webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/**
 * Server api configuration
 */



var api = {};

/* harmony default export */ __webpack_exports__["a"] = (api);
api.timeout = { timeout: 20000
  // api.serverURL = (location.hostname === 'clearassured.co.uk') ? 'https://api.clearassured.co.uk' : 'http://dev.api.clearassured.co.uk'
};if (location.hostname === 'clearassured.co.uk') {
  api.serverURL = 'https://api.clearassured.co.uk';
  api.billingServerURL = 'https://billing.clearassured.co.uk';
} else if (location.hostname === 'dev.clearassured.co.uk') {
  api.serverURL = 'http://dev.api.clearassured.co.uk';
  api.billingServerURL = 'https://billingdev.clearassured.co.uk';
} else if (location.hostname === 'stage.clearassured.co.uk') {
  api.serverURL = 'https://api.stage.clearassured.co.uk';
  api.billingServerURL = 'https://billingdev.clearassured.co.uk';
} else if (location.hostname === 'live.clearassured.co.uk') {
  api.serverURL = 'https://api.live.clearassured.co.uk';
}
if (location.hostname === 'tcc-front.local') {
  api.serverURL = 'http://tcc-back.local';
}
if (location.hostname === 'tccfront.local') {
  api.serverURL = 'http://tccback.local';
}
if (location.hostname === 'localhost') {
  api.serverURL = 'http://localhost:8000';
  api.billingServerURL = 'http://localhost:4201';
}
if (location.hostname === '10.0.2.2') {
  api.serverURL = 'http://10.0.2.2:8000';
}

// api.serverURL = 'https://api.stage.clearassured.co.uk'
// api.billingServerURL = 'https://billingdev.clearassured.co.uk'

api.staticServerURL = api.serverURL;

api.token = localStorage.getItem('token');
api.headersAuthSettings = { headers: localStorage.getItem('token') ? { 'Authorization': 'Bearer ' + localStorage.getItem('token') } : '' };

api.serverContenImages = api.serverURL + '/uploads/images/content/';
api.serverUserImages = api.serverURL + '/uploads/images/users/';

api.URLS = {
  points: api.serverURL + '/api/v1/point',
  pointsAll: api.serverURL + '/api/v1/points',
  search: api.serverURL + '/api/v1/search?_format=json',
  login: api.serverURL + '/oauth/v2/token',
  userRoles: '/api/v1/getUserRoles/',
  register: api.serverURL + '/api/v1/register',
  registerCompany: api.serverURL + '/api/v1/register-company',
  forgotPassword: api.serverURL + '/resetting/send-email',
  content: api.serverURL + '/api/v1/content',
  contentNew: api.serverURL + '/api/v1/content-front',
  contentTypes: '/api/v1/contentTypes',
  contentChapters: '/api/v1/chapters',
  contentChaptersList: api.serverURL + '/api/v1/chapters',
  contentType: api.serverURL + '/api/v1/contentType/',
  contentSearch: api.serverURL + '/api/v1/content-search',
  companiesS: api.serverURL + '/api/v1/company',
  companies: '/api/v1/company',
  companyList: api.serverURL + '/api/v1/company',
  tags: '/api/v1/tags',
  tagsSimple: '/api/v1/tags-simple',
  tags1: api.serverURL + '/api/v1/tags',
  tag: api.serverURL + '/api/v1/tag',
  categories: '/api/v1/categories',
  categories1: api.serverURL + '/api/v1/categories',
  chapters: api.serverURL + '/api/v1/chapters',
  category: api.serverURL + '/api/v1/category',
  chapter: api.serverURL + '/api/v1/chapter',
  actionsURLS: {
    actions: '/api/v1/get-actions',
    permissions: '/api/v1/permissions',
    disallowed: api.serverURL + '/api/v1/disallowed'
  },
  roles: '/api/v1/roles',
  user: api.serverURL + '/api/v1/user',
  users: api.serverURL + '/api/v1/users',
  usersSearch: api.serverURL + '/api/v1/user-search',
  languages: '/api/v1/language',
  enabled: api.serverURL + '/api/v1/enabled',
  createAdmin: api.serverURL + '/api/v1/register-admin/',
  changeStatus: api.serverURL + '/api/v1/change-status',
  changeDoneStatus: api.serverURL + '/api/v1/change-done-status',
  deleteStatus: api.serverURL + '/api/v1/delete-done-status-message',
  getDoneStatus: api.serverURL + '/api/v1/contentstatuses',
  profile: api.serverURL + '/api/v1/profile',
  profileEnd: '/api/v1/profile',
  userLastLogin: api.serverURL + '/api/v1/user-last-login/',
  articleLog: api.serverURL + '/api/v1/get-log-data/',
  resetPassword: api.serverURL + '/resetting/reset/',
  invalidToken: api.serverURL + '/token/',
  page: api.serverURL + '/api/v1/page-list',
  password: api.serverURL + '/api/v1/password-change',
  companyCreate: api.serverURL + '/api/v1/company-create',
  companyPoints: api.serverURL + '/api/v1/companypoints',
  industry: api.serverURL + '/api/v1/industry',
  industries: '/api/v1/industries',
  industryList: api.serverURL + '/api/v1/industries',
  sponsors: api.serverURL + '/api/v1/sponsorsbyindustry',
  sponsorsByLanding: api.serverURL + '/api/v1/sponsorsbyindustrylanding',
  contentByCompany: api.serverURL + '/api/v1/contentbycompany',
  staticpage: api.serverURL + '/api/v1/staticpage',
  staticpagechanges: api.serverURL + '/api/v1/staticpagechanges',
  brochureRequest: api.serverURL + '/api/v1/request-brochure',
  contactSubmit: api.serverURL + '/api/v1/contact',
  searchSave: api.serverURL + '/api/v1/searchsave',
  dashboardCounters: api.serverURL + '/api/v1/dashboardcounters',
  topZeroSearch: api.serverURL + '/api/v1/topzerosearch',
  topSearch: api.serverURL + '/api/v1/topsearch',
  logs: api.serverURL + '/api/v1/logs',
  consent: api.serverURL + '/api/v1/consentlogs',
  consentDownload: api.serverURL + '/api/v1/consentlogs-download',
  filterLogs: api.serverURL + '/api/v1/filter/logs',
  consentLogs: api.serverURL + '/api/v1/filter/consentlogs',
  filterLogCompanies: api.serverURL + '/api/v1/filter/companies',
  filterLogUsers: api.serverURL + '/api/v1/filter/users',
  filterMailTypes: api.serverURL + '/api/v1/filter/mails',
  userNotifications: api.serverURL + '/api/v1/user/notifications',
  userNotificationsRead: api.serverURL + '/api/v1/user/readnotifications',
  inviteUsers: api.serverURL + '/api/v1/invite-users',
  activateUser: api.serverURL + '/api/v1/activate/user/',
  activatePassword: api.serverURL + '/api/v1/activate/password/',
  seenConsent: api.serverURL + '/api/v1/consent/seen',
  updateConsent: api.serverURL + '/api/v1/consent/update',
  companyPublic: api.serverURL + '/api/v1/companypublic',
  userStatuses: api.serverURL + '/api/v1/userstatuses',
  emailLogs: api.serverURL + '/api/v1/emaillogs',
  emailSingle: api.serverURL + '/api/v1/emaillog',
  mailTypes: api.serverURL + '/api/v1/filter/mailstypes',
  mailStatuses: api.serverURL + '/api/v1/filter/mailstatuses',
  checkSubscribe: api.serverURL + '/api/v1/issubscribe',
  subscribe: api.serverURL + '/api/v1/subscribe',
  subscription: api.serverURL + '/api/v1/subscription',
  subscribeConfirm: api.serverURL + '/api/v1/subscribeconfirm',
  unSubscribe: api.serverURL + '/api/v1/un-subscribe',
  uploadFile: api.serverURL + '/api/v1/upload-file',
  tawkHash: api.serverURL + '/api/v1/tawk/hash',
  emailTemplate: api.serverURL + '/api/v1/email-template',
  emailPreferences: api.serverURL + '/api/v1/email-preferences',
  disabledEmails: api.serverURL + '/api/v1/disabled-emails',
  promotions: api.serverURL + '/api/v1/promotions',
  defaultRegistrationRoles: '/api/v1/default-registration-roles',
  testEmail: api.serverURL + '/api/v1/test-email-template',
  redirect: api.serverURL + '/api/v1/redirect',
  task: api.serverURL + '/api/v1/task',
  taskNoBase: '/api/v1/task',
  adminUsers: '/api/v1/admin-users',
  file: '/api/v1/admin-users',
  topicSuggest: api.serverURL + '/api/v1/suggest-topic',
  contentLatest: api.serverURL + '/api/v1/content-latest',
  companySizes: '/api/v1/company/sizes',
  companyLocations: '/api/v1/company/locations',
  companyOrganizationTypes: '/api/v1/company/organization-types',
  activateCompany: api.serverURL + '/api/v1/activate/company/',
  resetCompanyActivationToken: api.serverURL + '/api/v1/reset-company-activation-token',
  completeCompanyProfile: api.serverURL + '/api/v1/complete-company-profile',
  plans: api.serverURL + '/api/v1/plans',
  voucherCheck: api.serverURL + '/api/v1/voucher/check',
  callbackRequest: api.serverURL + '/api/v1/callback-request',
  variation: api.serverURL + '/api/v1/variation',
  companyInvoice: api.serverURL + '/api/v1/company/invoice',
  companyQuote: api.serverURL + '/api/v1/company-quote',
  companyCanBeDisconnectedFromBilling: api.serverURL + '/api/v1/company/can-disconnect-from-billing',
  companyDisconnectedFromBilling: api.serverURL + '/api/v1/company/disconnect-from-billing',
  getCompanyActiveInvoice: api.serverURL + '/api/v1/company/invoice/unpaid'
};
api.requestToServer = function (urlEnd, type) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : api.headersAuthSettings;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http[type](api.serverURL + urlEnd, data, headers, api.timeout);
  }
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http[type](api.serverURL + urlEnd, headers, api.timeout);
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(1002),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5999138b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(1053),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2xlYXJBc3N1cmVkX2xvZ28iIGRhdGEtbmFtZT0iQ2xlYXJBc3N1cmVkIGxvZ28iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE4NS4zNDIiIGhlaWdodD0iMjMuOTk5IiB2aWV3Qm94PSIwIDAgMTg1LjM0MiAyMy45OTkiPgogIDxnIGlkPSJhc3N1cmVkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3Mi44MjYpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzQwIiBkYXRhLW5hbWU9IlBhdGggNDAiIGQ9Ik02MDAuODA4LDY1NS44NjhhNi42MDgsNi42MDgsMCwwLDAsMi4wODksMS40LDcuMTM3LDcuMTM3LDAsMCwwLDIuODIuNTIzLDUuOTM3LDUuOTM3LDAsMCwwLDIuNjA5LS41MDgsMS42NjYsMS42NjYsMCwwLDAsMS4wNDctMS41ODcsMS45MzMsMS45MzMsMCwwLDAtLjIyOC0uOTYyLDEuOTg0LDEuOTg0LDAsMCwwLS43NjYtLjcxNCw2LjU4LDYuNTgsMCwwLDAtMS40MjgtLjU3OGMtLjU5NC0uMTc1LTEuMzI4LS4zNjctMi4yMDktLjU3NmExMy4yMTcsMTMuMjE3LDAsMCwxLTEuODY2LS41NTksNi4xNjIsNi4xNjIsMCwwLDEtMS42NTMtLjkyNSw0LjYxNSw0LjYxNSwwLDAsMS0xLjE4NC0xLjQsNC4wMTksNC4wMTksMCwwLDEtLjQ1Mi0xLjk3MywzLjkxNywzLjkxNywwLDAsMSwuNTQtMi4wNzcsNC44MTQsNC44MTQsMCwwLDEsMS40NDMtMS41MDgsNi45NTYsNi45NTYsMCwwLDEsMi4wMzgtLjkyMSw4LjU5LDguNTksMCwwLDEsMi4zNTEtLjMxNywxMC4zLDEwLjMsMCwwLDEsMy41MzMuNTQsOC4xOTQsOC4xOTQsMCwwLDEsMi41OTMsMS41MTlsLTEuNzA2LDIuMTY2YTYuMTcsNi4xNywwLDAsMC0xLjgyNS0xLjExOCw2LjY4NCw2LjY4NCwwLDAsMC0yLjU1Ny0uNDUyLDUuMDQzLDUuMDQzLDAsMCwwLTIuNC40OSwxLjY4MSwxLjY4MSwwLDAsMC0uOTA1LDEuNjA3LDEuNjU2LDEuNjU2LDAsMCwwLDEuMiwxLjU1MSwxOS44MDksMTkuODA5LDAsMCwwLDMuMTUzLjk2MiwxOS4yMzYsMTkuMjM2LDAsMCwxLDIuMTQzLjY0Nyw2LjU4Niw2LjU4NiwwLDAsMSwxLjczOS45NDIsNC4yNTMsNC4yNTMsMCwwLDEsMS4xODUsMS40MTMsNC4zNjksNC4zNjksMCwwLDEsLjQzMywyLjAyNSw0LjA3NCw0LjA3NCwwLDAsMS0uNTU1LDIuMTQ2LDQuODY4LDQuODY4LDAsMCwxLTEuNSwxLjU1NSw2LjksNi45LDAsMCwxLTIuMTU5Ljk0MywxMC4wMzcsMTAuMDM3LDAsMCwxLTIuNTM5LjMxN3EtNC42LDAtNi44OTMtMi40NzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTgxLjEyNSAtNjM2LjQ0MSkiIGZpbGw9IiMwMGJiZDEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogICAgPHBhdGggaWQ9IlBhdGhfNDEiIGRhdGEtbmFtZT0iUGF0aCA0MSIgZD0iTTcxMS4wNjIsNjU1Ljk2NWMtLjExNS4xNC0uMzA4LjQ0LS41NzUuNzNhNS4yMDcsNS4yMDcsMCwwLDEtMS4wNjIuOSw3LjY1OSw3LjY1OSwwLDAsMS0xLjU0OS43NTMsNi4xMzgsNi4xMzgsMCwwLDEtMi4wNzMuMzI2LDYuODc2LDYuODc2LDAsMCwxLTIuODU3LS41ODgsNi43NzEsNi43NzEsMCwwLDEtMi4zLTEuNjc1LDcuNiw3LjYsMCwwLDEtMS41MTYtMi42MzQsMTAuNTE4LDEwLjUxOCwwLDAsMS0uNTM5LTMuNDczLDkuMDIsOS4wMiwwLDAsMSwuOC0zLjk2NCw4LjMxMyw4LjMxMywwLDAsMSwyLjAzNy0yLjcyMiw4LjA4OCw4LjA4OCwwLDAsMSwyLjY4LTEuNTU1LDguNTQ4LDguNTQ4LDAsMCwxLDIuNzM1LS40ODksNi4xNjgsNi4xNjgsMCwwLDEsMi41NDcuNDJjLjY1MS4yNzgsMS4zMy40OTEsMS4zMy42Mjh2LTcuOTM1aDMuMnYyMS44NDZhMy45MzUsMy45MzUsMCwwLDAsLjMwOSwxLjMxOWgtMy4wNjRsLS4xMDYtMS44ODlabS0uMzM1LTEwLjQxYzAtLjE4Ni0uNDk0LS40MzctMS4xMjItLjc1MWE1LjcyNSw1LjcyNSwwLDAsMC0yLjU5NS0uNDcxLDUuMDI3LDUuMDI3LDAsMCwwLTIuMDYzLjQxNyw0LjkyOCw0LjkyOCwwLDAsMC0xLjY1LDEuMTksNS4zNjgsNS4zNjgsMCwwLDAtMS4xLDEuODg1LDcuMzcxLDcuMzcxLDAsMCwwLS40LDIuNTEyLDguMzM5LDguMzM5LDAsMCwwLC4yNzksMi4xODIsNS4yNzEsNS4yNzEsMCwwLDAsLjg1NSwxLjgsMy45ODksMy45ODksMCwwLDAsMS40NjQsMS4yLDQuNjc4LDQuNjc4LDAsMCwwLDIuMTA1LjQzOCw0LjUwNSw0LjUwNSwwLDAsMCwyLjA5LS40NTMsMy41MjQsMy41MjQsMCwwLDAsMi4wNDMtMi42MzcsNC42MTEsNC42MTEsMCwwLDAsLjA5My0xLjUxOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MDEuNzA5IC02MzQuNjg2KSIgZmlsbD0iIzAwYmJkMSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgICA8cGF0aCBpZD0iUGF0aF80MiIgZGF0YS1uYW1lPSJQYXRoIDQyIiBkPSJNNjg4LjYyMSw2NTAuMDMzYy0uMDk0LDAtLjUzNi0yLjEzLTEuMzI1LTMuMDE1YTQuMiw0LjIsMCwwLDAtMy4zNDItMS4yMjgsNS4wMTQsNS4wMTQsMCwwLDAtMiwuNDMzLDQuODc0LDQuODc0LDAsMCwwLTEuNTE2LDEuMDM4LDMuODE5LDMuODE5LDAsMCwwLS45NzQsMS4yNjQsMTEuMiwxMS4yLDAsMCwwLS4zODMsMS41MDhabTIuODIsNy41NTRhMTAuNTE2LDEwLjUxNiwwLDAsMS0uODM4LjgsNi45MTUsNi45MTUsMCwwLDEtMS40NDUuOTQyLDExLjEzNSwxMS4xMzUsMCwwLDEtMi4wODcuNzg2LDEwLjI2NiwxMC4yNjYsMCwwLDEtMi43MzUuMzMzLDkuMTg4LDkuMTg4LDAsMCwxLTMuNDQ2LS42MjgsNy42NDksNy42NDksMCwwLDEtMi42OC0xLjc4LDcuOTgyLDcuOTgyLDAsMCwxLTEuNzI0LTIuNzU5LDEwLDEwLDAsMCwxLS42MDktMy41NjIsOS4yNiw5LjI2LDAsMCwxLC41OTItMy4zMzMsNy44OTQsNy44OTQsMCwwLDEsNy40ODYtNS4xNTIsNy40ODMsNy40ODMsMCwwLDEsMy41ODUuOCw3LjE1Nyw3LjE1NywwLDAsMSwyLjQ1NSwyLjEzMiw4LjI4Miw4LjI4MiwwLDAsMSwxLjQxMSwyLjg3LDE1LjI4MiwxNS4yODIsMCwwLDEsLjQ1MSwzLjM5Mkg2NzkuMDhhNS40NjIsNS40NjIsMCwwLDAsLjQ3LDIuMTYsNS4zNjksNS4zNjksMCwwLDAsMS4xNjgsMS42NTQsNS43MDgsNS43MDgsMCwwLDAsMS42NjYsMS4wODksNS4xNDgsNS4xNDgsMCwwLDAsMS45ODQuNCw3LjE4OCw3LjE4OCwwLDAsMCwzLjM3OS0uNjg4LDYuOTYsNi45NiwwLDAsMCwxLjkxNS0xLjM1NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01OTcuMDIgLTYzNi40NSkiIGZpbGw9IiMwMGJiZDEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogICAgPHBhdGggaWQ9IlBhdGhfNDMiIGRhdGEtbmFtZT0iUGF0aCA0MyIgZD0iTTY2Mi41NDgsNjQ3LjF2LTEuNzY0YzAtLjUuMTkzLS44MzQuMTcxLTEuNjMzaDIuOTk0bC4xLDIuNjU5YTguNTI3LDguNTI3LDAsMCwxLC43My0uOTA1LDUuMzkxLDUuMzkxLDAsMCwxLDEuMS0uOTE1LDYuOTc0LDYuOTc0LDAsMCwxLDEuNS0uNzE0LDYuMDE2LDYuMDE2LDAsMCwxLDEuOTY3LS4yOTMsNS44NDksNS44NDksMCwwLDEsLjk1Ny4wNzEsNC4zLDQuMywwLDAsMSwuODE5LjIxbC0uNywyLjkzNmE0Ljc3MSw0Ljc3MSwwLDAsMC00Ljk0MiwxLjIwNSw1LjM2NSw1LjM2NSwwLDAsMC0xLjA2NiwxLjU4Nyw1LjE4MSw1LjE4MSwwLDAsMC0uNDM2LDEuOTE5djguMjE1aC0zLjE5NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01OTQuMjY4IC02MzYuNTE0KSIgZmlsbD0iIzAwYmJkMSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgICA8cGF0aCBpZD0iUGF0aF80NCIgZGF0YS1uYW1lPSJQYXRoIDQ0IiBkPSJNNjM5LjM5NCw2NDMuNzVoMy4ydjkuNjE2YTQuODY3LDQuODY3LDAsMCwwLDEuMDI0LDMuMzMzLDMuNTk0LDMuNTk0LDAsMCwwLDIuNzU5LDEuMDI4LDQuMjA3LDQuMjA3LDAsMCwwLDIuMjY3LS41NTUsNC41ODIsNC41ODIsMCwwLDAsMS40NTctMS40NDcsNi4yODksNi4yODksMCwwLDAsLjkxOC0yLjAyNSwxMS45ODQsMTEuOTg0LDAsMCwwLC4zNjEtMi4zMjR2LTcuNjE4aDMuMTk1djE0LjY1N2E2LjQwOSw2LjQwOSwwLDAsMS0uMjg1LDEuMzE5aC0yLjk5NWwtLjEwNi0yLjI0YTExLjYyOSwxMS42MjksMCwwLDEtLjc2NiwxLDUuMjUxLDUuMjUxLDAsMCwxLTEuMTExLjkzMiw3LjA4OCw3LjA4OCwwLDAsMS0xLjUzNC43LDYuNDE5LDYuNDE5LDAsMCwxLTEuOTg0LjI5MSw1LjkzMiw1LjkzMiwwLDAsMS00Ljc4My0xLjgyNSw3LjcwNyw3LjcwNywwLDAsMS0xLjYxMy01LjAwN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODkuNDg2IC02MzYuNTU3KSIgZmlsbD0iIzAwYmJkMSIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgICA8cGF0aCBpZD0iUGF0aF80NSIgZGF0YS1uYW1lPSJQYXRoIDQ1IiBkPSJNNjIwLjcyNiw2NTUuODY4YTYuNjEzLDYuNjEzLDAsMCwwLDIuMDg4LDEuNCw3LjE0MSw3LjE0MSwwLDAsMCwyLjgyMS41MjMsNS45NDIsNS45NDIsMCwwLDAsMi42MTEtLjUwOCwxLjY2NiwxLjY2NiwwLDAsMCwxLjA0Ny0xLjU4NywxLjkyNywxLjkyNywwLDAsMC0uMjI5LS45NjIsMi4wMTEsMi4wMTEsMCwwLDAtLjc2NS0uNzE0LDYuNTc4LDYuNTc4LDAsMCwwLTEuNDI4LS41NzhxLS44ODctLjI2My0yLjIxMS0uNTc2YTEzLjI1MSwxMy4yNTEsMCwwLDEtMS44NjMtLjU1OSw2LjEyMiw2LjEyMiwwLDAsMS0xLjY1Mi0uOTI1LDQuNTMyLDQuNTMyLDAsMCwxLTEuMTgzLTEuNCwzLjk5MywzLjk5MywwLDAsMS0uNDUzLTEuOTczLDMuOTM1LDMuOTM1LDAsMCwxLC41NC0yLjA3Nyw0LjgxNSw0LjgxNSwwLDAsMSwxLjQ0MS0xLjUwOCw3LDcsMCwwLDEsMi4wMzctLjkyMSw4LjYzNCw4LjYzNCwwLDAsMSwyLjM1My0uMzE3LDEwLjMsMTAuMywwLDAsMSwzLjUzMy41NCw4LjE2LDguMTYsMCwwLDEsMi41OTQsMS41MTlsLTEuNywyLjE2NmE2LjI1OSw2LjI1OSwwLDAsMC0xLjgyNS0xLjExOCw2LjcxNSw2LjcxNSwwLDAsMC0yLjU2Mi0uNDUyLDUuMDM5LDUuMDM5LDAsMCwwLTIuNC40OSwxLjY3OCwxLjY3OCwwLDAsMC0uOTA2LDEuNjA3LDEuNjU3LDEuNjU3LDAsMCwwLDEuMiwxLjU1MSwxOS42NzIsMTkuNjcyLDAsMCwwLDMuMTUxLjk2MiwxOS4xODksMTkuMTg5LDAsMCwxLDIuMTQzLjY0Nyw2LjU4MSw2LjU4MSwwLDAsMSwxLjc0MS45NDIsNC4yMyw0LjIzLDAsMCwxLDEuMTg0LDEuNDEzLDQuMzQxLDQuMzQxLDAsMCwxLC40MzYsMi4wMjUsNC4wNjYsNC4wNjYsMCwwLDEtLjU1NSwyLjE0Niw0Ljg0OCw0Ljg0OCwwLDAsMS0xLjUsMS41NTUsNi45LDYuOSwwLDAsMS0yLjE1OS45NDMsMTAuMDM4LDEwLjAzOCwwLDAsMS0yLjUzOS4zMTdxLTQuNTk1LDAtNi44OTMtMi40NzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg1LjIzOSAtNjM2LjQ0MSkiIGZpbGw9IiMwMGJiZDEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogICAgPHBhdGggaWQ9IlBhdGhfNDYiIGRhdGEtbmFtZT0iUGF0aCA0NiIgZD0iTTU4OC44NjYsNjQ3LjY0OWMwLS43MjMtMS44MjktMS41NDctMy45MTktMS41MjRhNS4wMDYsNS4wMDYsMCwwLDAtNC44NywzLjQ5Miw3LjQ0OCw3LjQ0OCwwLDAsMC0uMzg3LDIuNTEyLDguMzcsOC4zNywwLDAsMCwuMjg0LDIuMTgyLDQuNTIzLDQuNTIzLDAsMCwwLDguNjc4LjM1MSw0Ljg3Nyw0Ljg3NywwLDAsMCwuMjE0LTEuNTE5Wm0uMSwxMC4xMDhhNi42MDYsNi42MDYsMCwwLDEtNS4yNTUsMi42MzQsNi44OSw2Ljg5LDAsMCwxLTYuNjY2LTQuODY0LDEwLjQxNywxMC40MTcsMCwwLDEtLjUzOS0zLjQ1M2MwLTQuNzksMy4zMTktOC43MTksOC4yLTguNzE5YTYuMTc3LDYuMTc3LDAsMCwxLDQuMTY1LDEuMzYxVjY0My42N2gzLjJ2MTQuNjU3YTEwLjMsMTAuMywwLDAsMCwuMDcsMS4zMTloLTMuMDYyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU3Ni41MDEgLTYzNi40NzQpIiBmaWxsPSIjMDBiYmQxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8L2c+CiAgPGcgaWQ9ImNsZWFyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuMDA0KSI+CiAgICA8cGF0aCBpZD0iUGF0aF8zNiIgZGF0YS1uYW1lPSJQYXRoIDM2IiBkPSJNNTQ4LjU3NSw2NDcuNjQ5YzAtLjcyMy0xLjg3OC0xLjU0Ny0zLjk2OC0xLjUyNGE1LjAzLDUuMDMsMCwwLDAtNC44OSwzLjQ5MSw3LjM1LDcuMzUsMCwwLDAtLjQsMi41MTIsOC4zLDguMywwLDAsMCwuMjc5LDIuMTgyLDQuNTQ4LDQuNTQ4LDAsMCwwLDguNzE5LjM1MSw0LjkyMSw0LjkyMSwwLDAsMCwuMjYyLTEuNTE5di01LjQ5NFptMCwxMC4xMDhhNi42MTMsNi42MTMsMCwwLDEtNS4yNTksMi42MzQsNi44ODgsNi44ODgsMCwwLDEtNi42NjYtNC44NjQsMTAuNCwxMC40LDAsMCwxLS41NC0zLjQ1M2MwLTQuNzksMy4zNjktOC43MTksOC4yNTMtOC43MTlhNi4zMjMsNi4zMjMsMCwwLDEsNC4yMTIsMS4zNjFWNjQzLjY3aDMuMnYxNC42NTdjMCwuNTI0LS4wNDcsMS4zMTktLjAyNSwxLjMxOWgtMy4wNjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDk1LjMzNSAtNjM2LjQ3OSkiIGZpbGw9IiMyMzFmMjAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogICAgPHBhdGggaWQ9IlBhdGhfMzciIGRhdGEtbmFtZT0iUGF0aCAzNyIgZD0iTTU1OS44MTIsNjQ3LjF2LTEuNzY0YzAtLjUtLjItLjgzNC0uMjIzLTEuNjMzaDNsLjEsMi42NTlhOC43MTcsOC43MTcsMCwwLDEsLjczMy0uOTA1LDUuMzM4LDUuMzM4LDAsMCwxLDEuMS0uOTE1LDYuODkzLDYuODkzLDAsMCwxLDEuNS0uNzE0LDYsNiwwLDAsMSwxLjk2Ni0uMjkzLDUuODczLDUuODczLDAsMCwxLC45NTkuMDcxLDQuMjY1LDQuMjY1LDAsMCwxLC44MTYuMjFsLS43LDIuOTM2YTQuNzc0LDQuNzc0LDAsMCwwLTQuOTQ0LDEuMjA1LDQuODQ0LDQuODQ0LDAsMCwwLS44NjYsMS41ODcsNSw1LDAsMCwwLS4yNDQsMS45MTl2OC4yMTVoLTMuMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MDAuMTgzIC02MzYuNTE4KSIgZmlsbD0iIzIzMWYyMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8zOCIgZGF0YS1uYW1lPSJQYXRoIDM4IiBkPSJNNTI1Ljk1NCw2NTAuMDMzYy0uMDkxLDAtLjUzMi0yLjEzLTEuMzIyLTMuMDE1YTQuMiw0LjIsMCwwLDAtMy4zNC0xLjIyOCw1LjAxOSw1LjAxOSwwLDAsMC0yLjAwNS40MzMsNC43ODQsNC43ODQsMCwwLDAtMS41MTMsMS4wMzgsMy44MzUsMy44MzUsMCwwLDAtLjk3NSwxLjI2NCwxMC44NDgsMTAuODQ4LDAsMCwwLS4zODIsMS41MDhabTIuODE5LDcuNTU0YTkuOTMxLDkuOTMxLDAsMCwxLS44MzMuOCw2Ljk1Miw2Ljk1MiwwLDAsMS0xLjQ0Ny45NDIsMTEuMDEyLDExLjAxMiwwLDAsMS0yLjA4Ny43ODYsMTAuMjQ1LDEwLjI0NSwwLDAsMS0yLjczMy4zMzIsOS4xOTEsOS4xOTEsMCwwLDEtMy40NDctLjYyOCw3LjYzMSw3LjYzMSwwLDAsMS0yLjY4MS0xLjc4LDgsOCwwLDAsMS0xLjcyMi0yLjc1OSw5LjkxNSw5LjkxNSwwLDAsMS0uNjEyLTMuNTYyLDkuMjYxLDkuMjYxLDAsMCwxLC41OTMtMy4zMzMsNy44OSw3Ljg5LDAsMCwxLDcuNDg4LTUuMTUyLDcuNDkxLDcuNDkxLDAsMCwxLDMuNTgzLjgsNy4xNjYsNy4xNjYsMCwwLDEsMi40NTUsMi4xMzIsOC4zLDguMywwLDAsMSwxLjQxMiwyLjg3LDE1LjM3NywxNS4zNzcsMCwwLDEsLjQ1MiwzLjM5Mkg1MTYuNDE5YTUuMzI0LDUuMzI0LDAsMCwwLDEuNjMzLDMuODE0LDUuNzU1LDUuNzU1LDAsMCwwLDEuNjc0LDEuMDg5LDUuMTQ2LDUuMTQ2LDAsMCwwLDEuOTg0LjQsNy4xNzIsNy4xNzIsMCwwLDAsMy4zNzUtLjY4OEE2Ljg5LDYuODksMCwwLDAsNTI3LDY1NS43WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5MC42MDcgLTYzNi40NTQpIiBmaWxsPSIjMjMxZjIwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE2IiB3aWR0aD0iMy4xOTYiIGhlaWdodD0iMjMuMTY0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNy4yOTQpIiBmaWxsPSIjMjMxZjIwIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8zOSIgZGF0YS1uYW1lPSJQYXRoIDM5IiBkPSJNNDk5LjU1OCw2NTcuNzE2YTguMTgsOC4xOCwwLDAsMS0yLjY2MiwxLjk3Myw4LjQ4OSw4LjQ4OSwwLDAsMS0zLjY3Ni43NTEsOS4yMyw5LjIzLDAsMCwxLTMuNTMzLS42NDgsNy41MjUsNy41MjUsMCwwLDEtNC4zNjktNC41LDkuODc2LDkuODc2LDAsMCwxLS41OTItMy40NzQsOC45MDYsOC45MDYsMCwwLDEsLjYyNy0zLjM1MSw4LjI1OCw4LjI1OCwwLDAsMSw0LjQzNy00LjU5Myw5LjE0Niw5LjE0NiwwLDAsMSw3LjA1Mi4wNTIsOC4xMzIsOC4xMzIsMCwwLDEsMi42OCwxLjk5MWwtMi4wNTIsMS45OWE1LjMxMiw1LjMxMiwwLDAsMC0xLjc3NS0xLjQyOCw1LjQ4Niw1LjQ4NiwwLDAsMC0yLjQ3NC0uNTI0LDUuMTg2LDUuMTg2LDAsMCwwLTIuMjQ2LjQ3Niw0Ljc4LDQuNzgsMCwwLDAtMS42NjYsMS4yOTIsNS45MzIsNS45MzIsMCwwLDAtMS4wNDMsMS44ODUsNi43MTcsNi43MTcsMCwwLDAtLjM2NywyLjIxOCw2LjYzNCw2LjYzNCwwLDAsMCwuMzY3LDIuMTgzLDUuOTE4LDUuOTE4LDAsMCwwLDEuMDQzLDEuODg1LDQuOTM2LDQuOTM2LDAsMCwwLDMuOTE1LDEuOCw1Ljg2NSw1Ljg2NSwwLDAsMCwyLjU2LS41NCw1LjMsNS4zLDAsMCwwLDEuODY1LTEuNDQ3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ4NC43MjUgLTYzNi40NDYpIiBmaWxsPSIjMjMxZjIwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(788)
  __webpack_require__(787)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(1058),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d455b562",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(936),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06aa37ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(752)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(1032),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(759)
  __webpack_require__(758)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(1037),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-85022b8e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

module.exports = {
	props: {
		/**
   * Toggles the adding of a 'loading' class to the main
   * .v-select wrapper. Useful to control UI state when
   * results are being processed through AJAX.
   */
		loading: {
			type: Boolean,
			default: false
		},

		/**
   * Accept a callback function that will be
   * run when the search text changes.
   *
   * loading() accepts a boolean value, and can
   * be used to toggle a loading class from
   * the onSearch callback.
   *
   * @param {search}  String          Current search text
   * @param {loading} Function(bool)  Toggle loading class
   */
		onSearch: {
			type: Function,
			default: function _default(search, loading) {}
		}
	},

	data: function data() {
		return {
			mutableLoading: false
		};
	},


	watch: {
		/**
   * If a callback & search text has been provided,
   * invoke the onSearch callback.
   */
		search: function search() {
			if (this.search.length > 0) {
				this.onSearch(this.search, this.toggleLoading);
				this.$emit('search', this.search, this.toggleLoading);
			}
		},

		/**
  * Sync the loading prop with the internal
  * mutable loading value.
   * @param val
   */
		loading: function loading(val) {
			this.mutableLoading = val;
		}
	},

	methods: {
		/**
   * Toggle this.loading. Optionally pass a boolean
   * value. If no value is provided, this.loading
   * will be set to the opposite of it's current value.
   * @param toggle Boolean
   * @returns {*}
   */
		toggleLoading: function toggleLoading() {
			var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (toggle == null) {
				return this.mutableLoading = !this.mutableLoading;
			}
			return this.mutableLoading = toggle;
		}
	}
};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// flow

module.exports = {
  watch: {
    typeAheadPointer: function typeAheadPointer() {
      this.maybeAdjustScroll();
    }
  },

  methods: {
    /**
     * Adjust the scroll position of the dropdown list
     * if the current pointer is outside of the
     * overflow bounds.
     * @returns {*}
     */
    maybeAdjustScroll: function maybeAdjustScroll() {
      var pixelsToPointerTop = this.pixelsToPointerTop();
      var pixelsToPointerBottom = this.pixelsToPointerBottom();

      if (pixelsToPointerTop <= this.viewport().top) {
        return this.scrollTo(pixelsToPointerTop);
      } else if (pixelsToPointerBottom >= this.viewport().bottom) {
        return this.scrollTo(this.viewport().top + this.pointerHeight());
      }
    },


    /**
     * The distance in pixels from the top of the dropdown
     * list to the top of the current pointer element.
     * @returns {number}
     */
    pixelsToPointerTop: function pixelsToPointerTop() {
      var pixelsToPointerTop = 0;
      if (this.$refs.dropdownMenu) {
        for (var i = 0; i < this.typeAheadPointer; i++) {
          pixelsToPointerTop += this.$refs.dropdownMenu.children[i].offsetHeight;
        }
      }
      return pixelsToPointerTop;
    },


    /**
     * The distance in pixels from the top of the dropdown
     * list to the bottom of the current pointer element.
     * @returns {*}
     */
    pixelsToPointerBottom: function pixelsToPointerBottom() {
      return this.pixelsToPointerTop() + this.pointerHeight();
    },


    /**
     * The offsetHeight of the current pointer element.
     * @returns {number}
     */
    pointerHeight: function pointerHeight() {
      var element = this.$refs.dropdownMenu ? this.$refs.dropdownMenu.children[this.typeAheadPointer] : false;
      return element ? element.offsetHeight : 0;
    },


    /**
     * The currently viewable portion of the dropdownMenu.
     * @returns {{top: (string|*|number), bottom: *}}
     */
    viewport: function viewport() {
      return {
        top: this.$refs.dropdownMenu ? this.$refs.dropdownMenu.scrollTop : 0,
        bottom: this.$refs.dropdownMenu ? this.$refs.dropdownMenu.offsetHeight + this.$refs.dropdownMenu.scrollTop : 0
      };
    },


    /**
     * Scroll the dropdownMenu to a given position.
     * @param position
     * @returns {*}
     */
    scrollTo: function scrollTo(position) {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.scrollTop = position : null;
    }
  }
};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = {
  data: function data() {
    return {
      typeAheadPointer: -1
    };
  },


  watch: {
    filteredOptions: function filteredOptions() {
      this.typeAheadPointer = 0;
    }
  },

  methods: {
    /**
     * Move the typeAheadPointer visually up the list by
     * subtracting the current index by one.
     * @return {void}
     */
    typeAheadUp: function typeAheadUp() {
      if (this.typeAheadPointer > 0) {
        this.typeAheadPointer--;
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll();
        }
      }
    },


    /**
     * Move the typeAheadPointer visually down the list by
     * adding the current index by one.
     * @return {void}
     */
    typeAheadDown: function typeAheadDown() {
      if (this.typeAheadPointer < this.filteredOptions.length - 1) {
        this.typeAheadPointer++;
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll();
        }
      }
    },


    /**
     * Select the option at the current typeAheadPointer position.
     * Optionally clear the search input on selection.
     * @return {void}
     */
    typeAheadSelect: function typeAheadSelect() {
      if (this.filteredOptions[this.typeAheadPointer]) {
        this.select(this.filteredOptions[this.typeAheadPointer]);
      } else if (this.taggable && this.search.length) {
        this.select(this.search);
      }

      if (this.clearSearchOnSelect) {
        this.search = "";
      }
    }
  }
};

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(717)
  __webpack_require__(718)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(1006),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c5faa3f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41190443",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
  __webpack_require__(689)
  __webpack_require__(690)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(989),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(1062),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5def156",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_AutocompleteInput__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_AutocompleteInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_AutocompleteInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Popup__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_Popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_datepicker__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_editor__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_AppSpiner_vue__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_AppSpiner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_common_AppSpiner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_timeago__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_timeago___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_timeago__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_zydialog__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_zydialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_zydialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_eventsource_polyfill__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_eventsource_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_eventsource_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vueditor__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vueditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vueditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vueditor_dist_style_vueditor_min_css__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vueditor_dist_style_vueditor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vueditor_dist_style_vueditor_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_wysiwyg__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_wysiwyg_dist_vueWysiwyg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_v_click_outside__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_v_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_v_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_tabs_Tabs__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_tabs_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_common_tabs_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_tabs_Tab__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_tabs_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_common_tabs_Tab__);
// The Vue build version to load with the `import` commandnpm install



// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















// import VueAnalytics from 'vue-analytics'














// import VuePapaParse from 'vue-papa-parse'

__WEBPACK_IMPORTED_MODULE_0_es6_promise___default.a.polyfill();

var config = {
  toolbar: ['element', 'bold', 'italic', 'underline', 'strikeThrough', 'foreColor', 'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'divider', 'insertOrderedList', 'insertUnorderedList', 'divider', 'indent', 'outdent', 'divider', 'link', 'unLink', 'picture', 'table', 'mixins', 'divider', 'sourceCode', 'removeFormat', 'undo', 'redo']
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vueditor___default.a, config);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue2_editor__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_zydialog___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$eventHub = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_wysiwyg___default.a, {
  maxHeight: '400px'
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('autocomplete-input', __WEBPACK_IMPORTED_MODULE_8__components_common_AutocompleteInput___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_10_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('popup', __WEBPACK_IMPORTED_MODULE_9__components_common_Popup___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('datepicker', __WEBPACK_IMPORTED_MODULE_13_vuejs_datepicker___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('app-spiner', __WEBPACK_IMPORTED_MODULE_15__components_common_AppSpiner_vue___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('tabs', __WEBPACK_IMPORTED_MODULE_24__components_common_tabs_Tabs___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('tab', __WEBPACK_IMPORTED_MODULE_25__components_common_tabs_Tab___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["default"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_v_click_outside___default.a);

// Vue.use(VueEditor)

// Vue.use(VuePapaParse)

// let analyticsOptions = {
//   id: location.hostname === 'clearassured.co.uk' ? 'UA-109158598-1' : 'UA-159201103-1',
//   router
// }
//
// let userData = localStorage.getItem('userData')
//
// if (userData) {
//   userData = JSON.parse(userData)
//   analyticsOptions['fields'] = {
//     userId: userData.id,
//     dimension1: 'SOME_INDUSTRY_NAME',
//     contentGroup1: 'SOME_INDUSTRY_NAME'
//   }
//   // Vue.$ga.set('dimension1', 'SOME_INDUSTRY_NAME')
// }
//
// console.log(analyticsOptions)
//
// Vue.use(VueAnalytics, analyticsOptions)
//
// Vue.$ga.event('Search', 'filter', 'see all results')

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_timeago___default.a, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
  locales: {
    // you will need json-loader in webpack 1
    'en-US': __webpack_require__(1069)
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('firstLetter', function (value) {
  return value ? value.charAt(0) + '.' : '';
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('maxCharacters', function (s, n) {
  if (!s) {
    return s;
  }
  if (n === 0) {
    return s;
  }
  var totalCount = 0;
  var content = '';
  var regex = /<\s*(\w+\b)(?:(?!<\s*\/\s*\1\b)[\s\S])*<\s*\/\s*\1\s*>|\S+/g;
  var splitSTR = s.match(regex);
  splitSTR.forEach(function (item) {
    var newRegex = /<(?:[^>=]|='[^']*'|="[^"]*"|=[^'"][^\s>]*)*>/g;
    var cleanItem = item.replace(newRegex, '');
    if (totalCount <= n) {
      totalCount += cleanItem.length;
      content += ' ' + item;
    }
  });
  return content;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('striphtml', function (value) {
  var div = document.createElement('div');
  div.innerHTML = value;
  var text = div.textContent || div.innerText || '';
  return text;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('nl2br', function (value) {
  return (value || '').replace(/(?:\r\n|\r|\n)/g, '<br />');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.interceptors.push(function (request, next) {
  var impersonated = localStorage.getItem('impersonated');
  if (impersonated) {
    request.params['_switch_user'] = impersonated;
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.interceptors.push(function (request, next) {
  next(function (response) {
    if (response.status === 301) {
      if (response.body && response.body.url) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push(response.body.url);
      }
    }
  });
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      formErrors: this.$validator.errors.items,
      formServerMessages: {
        success: [],
        errors: []
      }
    };
  },

  computed: {
    formJson: function formJson() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formInfo);
    },
    serverSuccessMessages: function serverSuccessMessages() {
      return this.formServerMessages.success;
    },
    serverErrors: function serverErrors() {
      return this.formServerMessages.errors;
    }
  },
  methods: {
    resetForm: function resetForm() {
      var func = this.formInfo.function;
      if (func.length) {
        func = null;
      }
      this.$refs.form.reset();
    },
    clearServerMessages: function clearServerMessages() {
      this.formServerMessages.success = [];
      this.formServerMessages.errors = [];
    },
    checkErrorsOnSubmit: function checkErrorsOnSubmit() {
      this.$validator.validateAll();
    },
    submitSuccess: function submitSuccess(res) {
      this.formServerMessages.success = res;
    },
    submitErrors: function submitErrors(err) {
      if (Array.isArray(err)) {
        this.formServerMessages.errors = err;
      } else {
        this.formServerMessages.errors.push(JSON.parse(err).error_description);
      }
    },
    submit: function submit() {
      this.clearServerMessages();
      this.checkErrorsOnSubmit();
      if (this.formErrors.length === 0) {
        this.sendFormRequest();
      }
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Login__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_subscriptions_RegisterCompany__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_subscriptions_RegisterCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_subscriptions_RegisterCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_ForgotPassword__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_main_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_ActivateAccount__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_ActivateAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_ActivateAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_GiveConsent__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_GiveConsent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_main_GiveConsent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_InvalidToken__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_InvalidToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_main_InvalidToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_main_ExpiredAccountToken__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_main_ExpiredAccountToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_main_ExpiredAccountToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Admin_Admin__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Admin_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_Admin_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_Admin_AdminDashboard__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_Admin_AdminDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_Admin_AdminDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Profile__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_Admin_SecurityConfiguration__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_Admin_SecurityConfiguration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_Admin_SecurityConfiguration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Admin_Management__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Admin_Management___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_Admin_Management__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_ResetPassword_Resetting__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_ResetPassword_Resetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pages_ResetPassword_Resetting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_ResetPassword_Reset__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_ResetPassword_Reset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pages_ResetPassword_Reset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_ArticlesList__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_ArticlesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_pages_ArticlesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_Article__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_pages_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_CategoriesList__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_CategoriesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_pages_CategoriesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pages_ChaptersList__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pages_ChaptersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_pages_ChaptersList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_pages_TagsList__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_pages_TagsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_pages_TagsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_UsersList__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_UsersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_pages_UsersList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_AddArticle__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_AddArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_pages_AddArticle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_EditArticle__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_EditArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_pages_EditArticle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_ExpiredToken__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_ExpiredToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_pages_ExpiredToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_User__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_pages_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_newCmsStyle_page_ArticlesList__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_newCmsStyle_page_ArticlesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_newCmsStyle_page_ArticlesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_pages_AddUser__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_pages_AddUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_pages_AddUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_pages_EditUser__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_pages_EditUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_pages_EditUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pages_Company__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pages_Company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_pages_Company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_pages_AccountSettings__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_pages_AccountSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_pages_AccountSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_pages_AddCompany__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_pages_AddCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_pages_AddCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_pages_EditCompany__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_pages_EditCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_pages_EditCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_pages_CompanyList__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_pages_CompanyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_pages_CompanyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_pages_Industry__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_pages_Industry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_pages_Industry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_pages_AddIndustry__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_pages_AddIndustry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_pages_AddIndustry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_pages_EditIndustry__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_pages_EditIndustry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_pages_EditIndustry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_pages_IndustryList__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_pages_IndustryList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_pages_IndustryList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_admin_todo_Todo__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_admin_todo_Todo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_admin_todo_Todo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_admin_todo_TodoList__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_admin_todo_TodoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_admin_todo_TodoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_admin_todo_AddTodo__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_admin_todo_AddTodo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_admin_todo_AddTodo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_admin_todo_EditTodo__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_admin_todo_EditTodo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_admin_todo_EditTodo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_pages_Error__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_pages_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_pages_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_main_Home__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_main_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_main_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_main_Index__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_main_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_main_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_main_Search__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_main_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_main_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_main_TermsAndConditions__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_main_TermsAndConditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_main_TermsAndConditions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_main_PrivacyPolicy__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_main_PrivacyPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_main_PrivacyPolicy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_main_AccessibilitySection__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_main_AccessibilitySection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_main_AccessibilitySection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_main_Cookies__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_main_Cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_main_Cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_main_SearchResults__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_main_SearchResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_main_SearchResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_admin_staticpage_homepage__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_admin_staticpage_homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_admin_staticpage_homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_admin_staticpage_staticpage__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_admin_staticpage_staticpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_admin_staticpage_staticpage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_main_Edit__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_main_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_main_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_main_EditLandingPages__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_main_EditLandingPages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_main_EditLandingPages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_pages_DownloadBrochure__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_pages_DownloadBrochure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_pages_DownloadBrochure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_pages_Contact__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_pages_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_pages_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_pages_About__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_pages_ClearKit__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_pages_ClearKit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_pages_ClearKit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_pages_Logs__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_pages_Logs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_pages_Logs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_pages_ConsentLogs__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_pages_ConsentLogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_pages_ConsentLogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_pages_EmailLogs__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_pages_EmailLogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_pages_EmailLogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_pages_EmailSingle__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_pages_EmailSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_pages_EmailSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_pages_Notifications__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_pages_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_pages_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_pages_Badge__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_pages_Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_pages_Badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_pages_ConfirmSubscription__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_pages_ConfirmSubscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_pages_ConfirmSubscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_pages_CompanyLanding__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_pages_CompanyLanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_pages_CompanyLanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_pages_EditIndustryEmails__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_pages_EditIndustryEmails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_pages_EditIndustryEmails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_pages_EditDefaultEmails__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_pages_EditDefaultEmails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_pages_EditDefaultEmails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_pages_EditIndustryStyling__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_pages_EditIndustryStyling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_pages_EditIndustryStyling__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_pages_EmailPreferences__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_pages_EmailPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_pages_EmailPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_pages_DashboardPromotions__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_pages_DashboardPromotions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_pages_DashboardPromotions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_pages_NoPermissions__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_pages_NoPermissions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_pages_NoPermissions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_pages_CompanyRegistrationLanding__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_pages_CompanyRegistrationLanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_pages_CompanyRegistrationLanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_pages_Redirects__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_pages_Redirects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_pages_Redirects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_pages_Tasks__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_pages_Tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_pages_Tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_pages_Task__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_pages_Task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_pages_Task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_pages_KnowledgeBase__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_pages_KnowledgeBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_pages_KnowledgeBase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_pages_Admin_NextGenDashboard__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_pages_Admin_NextGenDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_pages_Admin_NextGenDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_pages_NextGenArticle__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_pages_NextGenArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_pages_NextGenArticle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_pages_CompanyProfile__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_pages_CompanyProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_pages_CompanyProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_subscriptions_ActivateCompany__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_subscriptions_ActivateCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_subscriptions_ActivateCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_subscriptions_CompleteProfile__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_subscriptions_CompleteProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_subscriptions_CompleteProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_subscriptions_CallbackRequest__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_subscriptions_CallbackRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_subscriptions_CallbackRequest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_subscriptions_NeedHelpRequest__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_subscriptions_NeedHelpRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_subscriptions_NeedHelpRequest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_pages_BillingProfile__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_pages_BillingProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_pages_BillingProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_tour_wizard_TourWizardWrapper__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_tour_wizard_TourWizardWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_tour_wizard_TourWizardWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_subscriptions_AccountSuspended__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_subscriptions_AccountSuspended___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_subscriptions_AccountSuspended__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_main_TermsOfService__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_main_TermsOfService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_main_TermsOfService__);


























// new CMS

// add user

// edit user

// company routes





// industry routes




// Todo part




// General part

// users frontend



// import ContentList from '@/components/pages/ContentList'
// import AskExperts from '@/components/main/AskExperts'







// import AskPage from '@/components/admin/staticpage/ask'






// logs




// notifications

// badge

// subscriptions


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_43__components_main_Home___default.a,
    children: [{
      path: '',
      name: 'home',
      component: __WEBPACK_IMPORTED_MODULE_44__components_main_Index___default.a,
      meta: {
        dashboardRedirect: true
      }
    }, {
      path: 'search',
      name: 'search',
      component: __WEBPACK_IMPORTED_MODULE_45__components_main_Search___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/things-to-do',
      name: 'ttd-category',
      props: true,
      redirect: {
        name: 'tasks'
      }
    }, {
      path: '/content/:id',
      name: 'content',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_79__components_pages_NextGenArticle___default.a,
      meta: { requiresAuth: true }
    },
    // {
    //   path: '/ask-experts',
    //   name: 'AskExperts',
    //   component: AskExperts,
    //   meta: { requiresAuth: true }
    // },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: __WEBPACK_IMPORTED_MODULE_46__components_main_TermsAndConditions___default.a
    }, {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: __WEBPACK_IMPORTED_MODULE_88__components_main_TermsOfService___default.a
    }, {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: __WEBPACK_IMPORTED_MODULE_47__components_main_PrivacyPolicy___default.a
    }, {
      path: '/accessibility-section',
      name: 'accessibility-section',
      component: __WEBPACK_IMPORTED_MODULE_48__components_main_AccessibilitySection___default.a
    },
    // {
    //   path: '/cookies',
    //   name: 'cookies',
    //   component: Cookies
    // },
    {
      path: '/give-consent',
      name: 'give-consent',
      component: __WEBPACK_IMPORTED_MODULE_6__components_main_GiveConsent___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/profile',
      name: 'profile',
      component: __WEBPACK_IMPORTED_MODULE_11__components_pages_Profile___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/profile/email-preferences',
      name: 'email-preferences',
      component: __WEBPACK_IMPORTED_MODULE_70__components_pages_EmailPreferences___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/search-results',
      name: 'SearchResults',
      component: __WEBPACK_IMPORTED_MODULE_50__components_main_SearchResults___default.a,
      meta: { requiresAuth: true }
    }, {
      path: '/forgot-password',
      name: 'forgot-password',
      component: __WEBPACK_IMPORTED_MODULE_4__components_main_ForgotPassword___default.a,
      meta: { isUnauthorized: true }
    }, {
      path: '/no-permissions',
      name: 'no-permissions',
      component: __WEBPACK_IMPORTED_MODULE_72__components_pages_NoPermissions___default.a
    }, {
      path: '/activate-account/:token',
      name: 'activate-account',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_5__components_main_ActivateAccount___default.a
    }, {
      path: '/expired-token',
      name: 'expired-token',
      component: __WEBPACK_IMPORTED_MODULE_24__components_pages_ExpiredToken___default.a,
      meta: { isUnauthorized: true }
    }, {
      path: '/invalid-token',
      name: 'invalid-token',
      component: __WEBPACK_IMPORTED_MODULE_7__components_main_InvalidToken___default.a,
      meta: { isUnauthorized: true }
    }, {
      path: '/expired-activation-token',
      name: 'expired-activation-token',
      component: __WEBPACK_IMPORTED_MODULE_8__components_main_ExpiredAccountToken___default.a,
      meta: { isUnauthorized: true }
    }, {
      path: '/resetting',
      name: 'resetting',
      component: __WEBPACK_IMPORTED_MODULE_14__components_pages_ResetPassword_Resetting___default.a,
      children: [{
        path: 'reset/:token',
        name: 'reset',
        props: true,
        component: __WEBPACK_IMPORTED_MODULE_15__components_pages_ResetPassword_Reset___default.a
      }]
    }, {
      path: '/landing-page',
      component: __WEBPACK_IMPORTED_MODULE_53__components_main_Edit___default.a,
      children: [{
        path: '',
        name: 'edit-pages-list',
        component: __WEBPACK_IMPORTED_MODULE_54__components_main_EditLandingPages___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'login/edit',
        name: 'edit-login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Login___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'download-brochure/edit',
        name: 'edit-download-brochure',
        component: __WEBPACK_IMPORTED_MODULE_55__components_pages_DownloadBrochure___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'contact/edit',
        name: 'edit-contact',
        component: __WEBPACK_IMPORTED_MODULE_56__components_pages_Contact___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'homepage/edit',
        name: 'edit-homepage',
        component: __WEBPACK_IMPORTED_MODULE_44__components_main_Index___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'about/edit',
        name: 'edit-about',
        component: __WEBPACK_IMPORTED_MODULE_57__components_pages_About___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'clear-kit/edit',
        name: 'edit-clear-kit',
        component: __WEBPACK_IMPORTED_MODULE_58__components_pages_ClearKit___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      },
      // {
      //   path: 'ask-experts/edit',
      //   name: 'edit-ask-expert',
      //   component: AskExperts,
      //   meta: {
      //     requiresAuth: true,
      //     requiresAuthGM: true
      //   }
      // },
      {
        path: 'terms-and-conditions/edit',
        name: 'edit-terms-and-conditions',
        component: __WEBPACK_IMPORTED_MODULE_46__components_main_TermsAndConditions___default.a
      }, {
        path: 'terms-of-service/edit',
        name: 'edit-terms-of-service',
        component: __WEBPACK_IMPORTED_MODULE_88__components_main_TermsOfService___default.a
      }, {
        path: 'privacy-policy/edit',
        name: 'edit-privacy-policy',
        component: __WEBPACK_IMPORTED_MODULE_47__components_main_PrivacyPolicy___default.a
      }, {
        path: 'accessibility-section/edit',
        name: 'edit-accessibility-section',
        component: __WEBPACK_IMPORTED_MODULE_48__components_main_AccessibilitySection___default.a
      }, {
        path: 'cookies/edit',
        name: 'edit-cookies',
        component: __WEBPACK_IMPORTED_MODULE_49__components_main_Cookies___default.a
      }, {
        path: 'give-consent/edit',
        name: 'edit-give-consent',
        component: __WEBPACK_IMPORTED_MODULE_6__components_main_GiveConsent___default.a
      }, {
        path: 'confirm-subscription/edit',
        name: 'edit-confirm-subscription',
        component: __WEBPACK_IMPORTED_MODULE_65__components_pages_ConfirmSubscription___default.a
      }, {
        path: 'register/edit',
        name: 'edit-register',
        component: __WEBPACK_IMPORTED_MODULE_3__components_subscriptions_RegisterCompany___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'callback-request/edit',
        name: 'edit-callback-request',
        component: __WEBPACK_IMPORTED_MODULE_83__components_subscriptions_CallbackRequest___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }, {
        path: 'need-help/edit',
        name: 'edit-need-help',
        component: __WEBPACK_IMPORTED_MODULE_84__components_subscriptions_NeedHelpRequest___default.a,
        meta: {
          requiresAuth: true,
          requiresAuthGM: true
        }
      }]
    }, {
      path: '/login',
      name: 'login',
      component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Login___default.a,
      meta: {
        isUnauthorized: true,
        maybeLanding: true
      }
    },
    // {
    //   path: '/download-brochure',
    //   name: 'download-brochure',
    //   component: DownloadBrochure
    // },
    {
      path: '/contact',
      name: 'contact',
      component: __WEBPACK_IMPORTED_MODULE_56__components_pages_Contact___default.a
    }, {
      path: '/about',
      name: 'about',
      component: __WEBPACK_IMPORTED_MODULE_57__components_pages_About___default.a
    },
    // {
    //   path: '/clear-kit',
    //   name: 'clear-kit',
    //   component: ClearKit
    // },
    {
      path: '/confirm-subscription/:id',
      name: 'confirm-subscription',
      component: __WEBPACK_IMPORTED_MODULE_65__components_pages_ConfirmSubscription___default.a
    }, {
      path: '/landing/:id',
      name: 'company-landing',
      component: __WEBPACK_IMPORTED_MODULE_66__components_pages_CompanyLanding___default.a
    }, {
      path: '/landing/:industry/:company/register',
      name: 'company-registration-landing',
      component: __WEBPACK_IMPORTED_MODULE_73__components_pages_CompanyRegistrationLanding___default.a
    }, {
      path: '/landing/:id/edit',
      name: 'edit-company-landing',
      component: __WEBPACK_IMPORTED_MODULE_66__components_pages_CompanyLanding___default.a,
      meta: {
        requiresAuth: true,
        requiresAuthGM: true
      }
    }, {
      path: '/landing/:industry/register/edit',
      name: 'edit-company-registration-landing',
      component: __WEBPACK_IMPORTED_MODULE_73__components_pages_CompanyRegistrationLanding___default.a,
      meta: {
        requiresAuth: true,
        requiresAuthGM: true
      }
    }, {
      path: '/register',
      name: 'register',
      component: __WEBPACK_IMPORTED_MODULE_3__components_subscriptions_RegisterCompany___default.a,
      meta: {
        isUnauthorized: true
      }
    }, {
      path: '/activate-company/:token',
      name: 'activate-company',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_81__components_subscriptions_ActivateCompany___default.a,
      meta: {
        isUnauthorized: true
      }
    }, {
      path: '/callback-request',
      name: 'callback-request',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_83__components_subscriptions_CallbackRequest___default.a
    }, {
      path: '/need-help',
      name: 'need-help',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_84__components_subscriptions_NeedHelpRequest___default.a,
      meta: {
        isUnauthorized: true
      }
    }, {
      path: '/account-suspended',
      name: 'account-suspended',
      component: __WEBPACK_IMPORTED_MODULE_87__components_subscriptions_AccountSuspended___default.a,
      meta: {
        requiresAuth: true
      }
    }]
  }, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_Admin_Admin___default.a,
    meta: {
      requiresAuth: true,
      requiresAuthGM: true
    },
    children: [{
      path: '',
      name: 'admin',
      meta: {
        requiresAuthGM: true
      },
      component: __WEBPACK_IMPORTED_MODULE_10__components_pages_Admin_AdminDashboard___default.a
    }, {
      path: 'logs',
      name: 'logs',
      component: __WEBPACK_IMPORTED_MODULE_59__components_pages_Logs___default.a
    }, {
      path: 'consent-logs',
      name: 'consent-logs',
      component: __WEBPACK_IMPORTED_MODULE_60__components_pages_ConsentLogs___default.a
    }, {
      path: 'email-logs',
      name: 'email-logs',
      component: __WEBPACK_IMPORTED_MODULE_61__components_pages_EmailLogs___default.a
    }, {
      path: 'email/:id',
      name: 'email-view',
      component: __WEBPACK_IMPORTED_MODULE_62__components_pages_EmailSingle___default.a
    }, {
      path: 'notifications',
      name: 'notifications',
      component: __WEBPACK_IMPORTED_MODULE_63__components_pages_Notifications___default.a
    }, {
      path: 'management',
      name: 'management',
      component: __WEBPACK_IMPORTED_MODULE_13__components_pages_Admin_Management___default.a
    }, {
      path: 'security-configuration',
      name: 'security-configuration',
      component: __WEBPACK_IMPORTED_MODULE_12__components_pages_Admin_SecurityConfiguration___default.a
    }, {
      path: 'articles-list',
      name: 'articles-list',
      component: __WEBPACK_IMPORTED_MODULE_16__components_pages_ArticlesList___default.a
    }, {
      path: 'article',
      name: 'article',
      component: __WEBPACK_IMPORTED_MODULE_17__components_pages_Article___default.a,
      children: [{
        path: 'add',
        name: 'add-article',
        component: __WEBPACK_IMPORTED_MODULE_22__components_pages_AddArticle___default.a
      }, {
        path: 'edit/:id',
        name: 'edit-article',
        component: __WEBPACK_IMPORTED_MODULE_23__components_pages_EditArticle___default.a
      }]
    }, {
      path: 'todo',
      name: 'todo',
      component: __WEBPACK_IMPORTED_MODULE_38__components_admin_todo_Todo___default.a,
      children: [{
        path: 'add',
        name: 'add-todo',
        component: __WEBPACK_IMPORTED_MODULE_40__components_admin_todo_AddTodo___default.a
      }, {
        path: 'edit/:id',
        name: 'edit-todo',
        component: __WEBPACK_IMPORTED_MODULE_41__components_admin_todo_EditTodo___default.a
      }]
    }, {
      path: 'todo-list',
      name: 'todo-list',
      component: __WEBPACK_IMPORTED_MODULE_39__components_admin_todo_TodoList___default.a
    }, {
      path: 'categories',
      name: 'categories',
      component: __WEBPACK_IMPORTED_MODULE_18__components_pages_CategoriesList___default.a
    }, {
      path: 'chapters',
      name: 'chapters',
      component: __WEBPACK_IMPORTED_MODULE_19__components_pages_ChaptersList___default.a
    }, {
      path: 'dashboard-promotions',
      name: 'dashboard-promotions',
      component: __WEBPACK_IMPORTED_MODULE_71__components_pages_DashboardPromotions___default.a
    }, {
      path: 'tags',
      name: 'tags',
      component: __WEBPACK_IMPORTED_MODULE_20__components_pages_TagsList___default.a
    }, {
      path: 'users',
      name: 'users',
      component: __WEBPACK_IMPORTED_MODULE_21__components_pages_UsersList___default.a
    }, {
      path: 'user',
      name: 'user',
      component: __WEBPACK_IMPORTED_MODULE_25__components_pages_User___default.a,
      children: [{
        path: 'invite',
        name: 'add-user',
        component: __WEBPACK_IMPORTED_MODULE_27__components_pages_AddUser___default.a
      }, {
        path: 'edit/:id',
        name: 'edit-user',
        component: __WEBPACK_IMPORTED_MODULE_28__components_pages_EditUser___default.a
      }]
    }, {
      path: 'companies',
      name: 'companies',
      component: __WEBPACK_IMPORTED_MODULE_33__components_pages_CompanyList___default.a
    }, {
      path: 'company',
      name: 'company',
      component: __WEBPACK_IMPORTED_MODULE_29__components_pages_Company___default.a,
      children: [{
        path: 'create',
        name: 'add-company',
        component: __WEBPACK_IMPORTED_MODULE_31__components_pages_AddCompany___default.a
      }, {
        path: 'edit/:id',
        name: 'edit-company',
        component: __WEBPACK_IMPORTED_MODULE_32__components_pages_EditCompany___default.a
      }]
    }, {
      path: 'industries',
      name: 'industries',
      component: __WEBPACK_IMPORTED_MODULE_37__components_pages_IndustryList___default.a
    }, {
      path: 'industry',
      name: 'industry',
      component: __WEBPACK_IMPORTED_MODULE_34__components_pages_Industry___default.a,
      children: [{
        path: 'create',
        name: 'add-industry',
        component: __WEBPACK_IMPORTED_MODULE_35__components_pages_AddIndustry___default.a
      }, {
        path: 'edit/:id',
        name: 'edit-industry',
        component: __WEBPACK_IMPORTED_MODULE_36__components_pages_EditIndustry___default.a
      }, {
        path: 'edit/:id/industry-emails',
        name: 'edit-industry-emails',
        component: __WEBPACK_IMPORTED_MODULE_67__components_pages_EditIndustryEmails___default.a
      }, {
        path: 'edit/:id/industry-styling',
        name: 'edit-industry-styling',
        component: __WEBPACK_IMPORTED_MODULE_69__components_pages_EditIndustryStyling___default.a
      }]
    }, {
      path: 'new-articles-list',
      name: 'new-articles-list',
      component: __WEBPACK_IMPORTED_MODULE_26__components_newCmsStyle_page_ArticlesList___default.a
    }, {
      path: 'homepage',
      name: 'homepage',
      component: __WEBPACK_IMPORTED_MODULE_51__components_admin_staticpage_homepage___default.a
    }, {
      path: 'page/:id?',
      name: 'page',
      component: __WEBPACK_IMPORTED_MODULE_52__components_admin_staticpage_staticpage___default.a
    }, {
      path: 'default-email-templates',
      name: 'default-email-templates',
      component: __WEBPACK_IMPORTED_MODULE_68__components_pages_EditDefaultEmails___default.a
    }, {
      path: 'redirects',
      name: 'redirects',
      component: __WEBPACK_IMPORTED_MODULE_74__components_pages_Redirects___default.a
    }, {
      path: 'tasks/:companyId',
      name: 'company-tasks',
      component: __WEBPACK_IMPORTED_MODULE_75__components_pages_Tasks___default.a
    }, {
      path: 'tasks/:companyId/browse/:id',
      name: 'company-task',
      component: __WEBPACK_IMPORTED_MODULE_76__components_pages_Task___default.a
      // {
      //   path: 'ask/:id?',
      //   name: 'ask',
      //   component: AskPage
      // }
    }]
  }, {
    path: '/dashboard',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_Admin_Admin___default.a,
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '',
      name: 'user-app',
      component: __WEBPACK_IMPORTED_MODULE_78__components_pages_Admin_NextGenDashboard___default.a,
      meta: {
        requiresAuthCARU: true
      }
    }, {
      path: 'users',
      name: 'ca-users',
      component: __WEBPACK_IMPORTED_MODULE_21__components_pages_UsersList___default.a,
      meta: {
        requiresAuthCATALA: true
      }
    }, {
      path: 'user',
      name: 'ca-user',
      component: __WEBPACK_IMPORTED_MODULE_25__components_pages_User___default.a,
      meta: {
        requiresAuthCATALA: true
      },
      children: [{
        path: 'invite',
        name: 'ca-add-user',
        component: __WEBPACK_IMPORTED_MODULE_27__components_pages_AddUser___default.a
      }, {
        path: 'edit/:id',
        name: 'ca-edit-user',
        component: __WEBPACK_IMPORTED_MODULE_28__components_pages_EditUser___default.a
      }]
    }, {
      path: 'notifications',
      name: 'dashboard-notifications',
      component: __WEBPACK_IMPORTED_MODULE_63__components_pages_Notifications___default.a
    }, {
      path: 'tasks',
      name: 'tasks',
      component: __WEBPACK_IMPORTED_MODULE_75__components_pages_Tasks___default.a,
      meta: {
        requiresAuth: true,
        requiresAuthCARU: true
      }
    }, {
      path: 'tasks/browse/:id',
      name: 'task',
      component: __WEBPACK_IMPORTED_MODULE_76__components_pages_Task___default.a,
      meta: {
        requiresAuth: true,
        requiresAuthCARU: true
      }
    }, {
      path: 'knowledge-base',
      name: 'knowledge-base',
      component: __WEBPACK_IMPORTED_MODULE_77__components_pages_KnowledgeBase___default.a
    }, {
      path: 'complete-profile',
      name: 'complete-profile',
      component: __WEBPACK_IMPORTED_MODULE_82__components_subscriptions_CompleteProfile___default.a
    }, {
      path: 'renew-subscription',
      name: 'renew-subscription',
      component: __WEBPACK_IMPORTED_MODULE_82__components_subscriptions_CompleteProfile___default.a,
      meta: {
        renewSubscription: true
      }
    }, {
      path: 'company-profile',
      name: 'company-profile',
      component: __WEBPACK_IMPORTED_MODULE_80__components_pages_CompanyProfile___default.a,
      meta: {
        requiresAuthCARU: true
      }
    }, {
      path: 'account-settings',
      name: 'account-settings',
      component: __WEBPACK_IMPORTED_MODULE_30__components_pages_AccountSettings___default.a
    }, {
      path: 'billing-profile',
      name: 'billing-profile',
      component: __WEBPACK_IMPORTED_MODULE_85__components_pages_BillingProfile___default.a,
      meta: {
        requiresAuthCATALA: true
      }
    }]
  }, {
    path: '/tour-wizard/:id',
    name: 'tour-wizard',
    component: __WEBPACK_IMPORTED_MODULE_86__components_tour_wizard_TourWizardWrapper___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/error',
    name: 'error',
    component: __WEBPACK_IMPORTED_MODULE_42__components_pages_Error___default.a
  }, {
    path: '/badge',
    name: 'badge',
    component: __WEBPACK_IMPORTED_MODULE_64__components_pages_Badge___default.a
  }, { path: '*', redirect: '/error' }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // savedPosition is only available for popstate navigations.
    if (savedPosition) return savedPosition;

    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    if (to.params.savePosition) return {};

    // scroll to anchor by returning the selector
    if (to.hash) {
      var position = { selector: to.hash

        // specify offset of the element
        // if (to.hash === '#anchor2') {
        //   position.offset = { y: 100 }
        // }
      };return position;
    }

    // scroll to top by default
    return { x: 0, y: 0 };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

router.beforeEach(function (to, from, next) {
  if (!to.hash) {
    setTimeout(function () {
      var element = document.getElementsByTagName('HEADER');
      if (element.length) {
        element[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  }
  if (!localStorage.getItem('cookieFixed')) {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('userIndustryName');
    localStorage.removeItem('userCompanyName');
  }
  if (to.name !== 'content' && window.ga) {
    window.ga('set', 'contentGroup2', null);
  }
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!localStorage.getItem('token')) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  }if (to.matched.some(function (record) {
    return record.meta.isUnauthorized;
  })) {
    if (localStorage.getItem('token')) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  }if (to.matched.some(function (record) {
    return record.meta.requiresAuthGM;
  })) {
    var userData = JSON.parse(localStorage.getItem('userData'));
    if (userData && userData.userRole !== 'gm') {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }if (to.matched.some(function (record) {
    return record.meta.requiresAuthCATALA;
  })) {
    var _userData = JSON.parse(localStorage.getItem('userData'));
    if (_userData && _userData.userRole !== 'ca' && _userData.userRole !== 'ta' && _userData.userRole !== 'la') {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }if (to.matched.some(function (record) {
    return record.meta.requiresAuthCARU;
  })) {
    var _userData2 = JSON.parse(localStorage.getItem('userData'));
    if (_userData2 && _userData2.userRole !== 'ca' && _userData2.userRole !== 'cu') {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }if (to.matched.some(function (record) {
    return record.meta.requiresAuthCA;
  })) {
    var _userData3 = JSON.parse(localStorage.getItem('userData'));
    if (_userData3 && _userData3.userRole !== 'ca') {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }if (to.matched.some(function (record) {
    return record.meta.dashboardRedirect;
  })) {
    var _userData4 = JSON.parse(localStorage.getItem('userData'));
    if (_userData4 !== null) {
      if (_userData4.userRole === 'gm') {
        next({
          name: 'admin'
        });
      } else if (_userData4.userRole === 'ca' || _userData4.userRole === 'cu') {
        next({
          name: 'user-app'
        });
      } else {
        next({
          name: 'knowledge-base'
        });
      }
    }
  } else {
    next();
  }
  if (to.matched.some(function (record) {
    return record.meta.maybeLanding;
  })) {
    var landing = localStorage.getItem('landing');
    if (landing !== null) {
      next({
        name: 'company-landing',
        params: { id: landing }
      });
    }
  } else {
    next();
  }if (localStorage.getItem('consentSeen') && localStorage.getItem('consentSeen') < 1 || localStorage.getItem('userData') && localStorage.getItem('token') && !localStorage.getItem('consentSeen')) {
    next({
      path: '/give-consent'
    });
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redirect", function() { return redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLogout", function() { return authLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContentById", function() { return getContentById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserRoles", function() { return getUserRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFontSizeActive", function() { return setFontSizeActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setColorPaletteActive", function() { return setColorPaletteActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTypes", function() { return getTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getChapters", function() { return getChapters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskChapters", function() { return getTaskChapters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskStatuses", function() { return getTaskStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskMandatory", function() { return getTaskMandatory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskAssignee", function() { return getTaskAssignee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAdminUsers", function() { return getAdminUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTags", function() { return getTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActions", function() { return getActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRoles", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCategories", function() { return getCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanies", function() { return getCompanies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIndustries", function() { return getIndustries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultRegistrationRoles", function() { return getDefaultRegistrationRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSponsors", function() { return getSponsors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLngs", function() { return getLngs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanySizes", function() { return getCompanySizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyLocations", function() { return getCompanyLocations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyOrganizationTypes", function() { return getCompanyOrganizationTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDataPreviewArticle", function() { return setDataPreviewArticle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initConfAction", function() { return initConfAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearConfAction", function() { return clearConfAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInformationMsg", function() { return setInformationMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeInformationMsg", function() { return closeInformationMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStyleForMsg", function() { return setStyleForMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resizeText", function() { return resizeText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeVisibilityThem", function() { return changeVisibilityThem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeConsent", function() { return changeConsent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);


var _this = this;


// import router from '@/router'

var isLoggedIn = localStorage.getItem('token');
var redirect = function redirect() {
  // router.push('/');
  // document.location.reload()
  document.location.href = '/';
};

// auth
var authLogout = function authLogout(_ref, payload) {
  var commit = _ref.commit;

  localStorage.removeItem('token');
  localStorage.removeItem('userData');
  localStorage.removeItem('consentSeen');
  localStorage.removeItem('consentHead');
  localStorage.removeItem('impersonated');
  localStorage.removeItem('userIndustryName');
  localStorage.removeItem('userCompanyName');
  commit('authLogout');
  commit('changeImpersonate', false);
  redirect();
};

var getContentById = function getContentById(_ref2, payload, id) {
  var commit = _ref2.commit;

  if (isLoggedIn) {
    var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content + '/' + _this.id;
    var type = 'get';
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload, id).then(function (res) {
      _this.contentItem = res.body;
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getUserRoles = function getUserRoles(_ref3, payload) {
  var commit = _ref3.commit;

  var token = localStorage.getItem('token');
  var userData = JSON.parse(localStorage.getItem('userData'));
  if (token && userData) {
    var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.userRoles + token;
    var type = 'get';
    var headers = { headers: { 'Authorization': 'Bearer ' + token } };
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, headers).then(function (res) {
      var userRole = res.body;
      if (userRole === 'ca' && localStorage.getItem('consentHead') === 'true') {
        userRole = 'sh';
      }
      userData.userRole = userRole;
      localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
      commit('authLoginSetUserRole', userRole);
      commit('authLoginSetCompany', userData.company);
    }).catch(function (err) {
      return console.log(err);
    });
  }
};

var getUser = function getUser(_ref4) {
  var commit = _ref4.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.profileEnd, 'put', __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].timeout, {}).then(function (res) {
    commit('setProfile', res.body);
  }).catch(function (err) {
    return console.log(err);
  });
};

var setFontSizeActive = function setFontSizeActive(_ref5) {
  var commit = _ref5.commit;

  var fontSizeActive = localStorage.getItem('selectedFont') ? +localStorage.getItem('selectedFont') : 0;
  var fontSizeButtons = document.getElementsByClassName('text-resize-controls__button');
  var activeFontSizeTrigger = document.getElementById('accessibilityFontSize_' + fontSizeActive);
  for (var i = 0; i < fontSizeButtons.length; i++) {
    fontSizeButtons[i].classList.remove('active');
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-size-0', 'accessibility-size-1', 'accessibility-size-2');
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-size-' + fontSizeActive);
  if (activeFontSizeTrigger) {
    activeFontSizeTrigger.classList.add('active');
  }
  commit('resizeText', fontSizeActive);
};

var setColorPaletteActive = function setColorPaletteActive() {
  var colorPaletteActive = localStorage.getItem('selectedHightCont') ? +localStorage.getItem('selectedHightCont') : 0;
  var colorPaletteButtons = document.getElementsByClassName('color-change-controls__button');
  var activeColorTrigger = document.getElementById('accessibilityColorPalette_' + colorPaletteActive);
  for (var i = 0; i < colorPaletteButtons.length; i++) {
    colorPaletteButtons[i].classList.remove('active');
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-color-0', 'accessibility-color-1', 'accessibility-color-2');
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-color-' + colorPaletteActive);
  if (activeColorTrigger) {
    activeColorTrigger.classList.add('active');
  }
};

var getTypes = function getTypes(_ref6, payload) {
  var commit = _ref6.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.contentTypes;
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setTypes', res.body.items);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getChapters = function getChapters(_ref7, payload) {
  var commit = _ref7.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.contentChapters;
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setChapters', res.body);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getTaskChapters = function getTaskChapters(_ref8, companyId, payload) {
  var commit = _ref8.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.taskNoBase + '/chapters';
  if (companyId) {
    urlEnd += '?company=' + companyId;
  }
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setTaskChapters', res.body);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getTaskStatuses = function getTaskStatuses(_ref9, companyId, payload) {
  var commit = _ref9.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.taskNoBase + '/statuses';
  if (companyId) {
    urlEnd += '?company=' + companyId;
  }
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setTaskStatuses', res.body);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getTaskMandatory = function getTaskMandatory(_ref10, data, payload) {
  var commit = _ref10.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.taskNoBase + '/mandatory';
  if (data.company) {
    urlEnd += '?company=' + data.company;
    if (data.board) {
      urlEnd += '&board=' + data.board;
    }
  } else {
    if (data.board) {
      urlEnd += '?board=' + data.board;
    }
  }
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setTaskMandatory', res.body);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getTaskAssignee = function getTaskAssignee(_ref11, companyId, payload) {
  var commit = _ref11.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.taskNoBase + '/assignee';
  if (companyId) {
    urlEnd += '?company=' + companyId;
  }
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setTaskAssignee', res.body);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getAdminUsers = function getAdminUsers(_ref12, payload) {
  var commit = _ref12.commit;

  var urlEnd = '' + __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.adminUsers;
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setAdminUsers', res.body);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getTags = function getTags(_ref13, payload) {
  var commit = _ref13.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.tagsSimple;
  var type = 'get';
  if (isLoggedIn) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
      commit('setTags', res.body.items);
    }).catch(function (err) {
      return console.error(err);
    });
  }
};

var getActions = function getActions(_ref14, payload) {
  var commit = _ref14.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.actionsURLS.actions;
  var type = 'get';
  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
    console.log('getActions', res);
    commit('setActions', res.body);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getRoles = function getRoles(_ref15, payload) {
  var commit = _ref15.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.roles;
  var type = 'get';
  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
    return commit('setRoles', res.body);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getCategories = function getCategories(_ref16, payload) {
  var commit = _ref16.commit;

  var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.categories;
  var type = 'get';
  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, payload).then(function (res) {
    var result = [];
    var categories = res.body.items.filter(function (item) {
      return !item.parent;
    });
    categories.forEach(function (item) {
      result.push(item);
      if (item.children.length) {
        item.children.forEach(function (child) {
          var curChild = child;
          curChild.isChild = true;
          curChild.parent = {
            label: item.title,
            value: item.id
          };
          result.push(curChild);
        });
      }
    });
    commit('setCategories', result);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getCompanies = function getCompanies(_ref17, payload) {
  var commit = _ref17.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companies, 'get').then(function (res) {
    var companies = res.body.data.items;
    var parents = [];
    companies.sort(function (a, b) {
      return a.name > b.name;
    }).forEach(function (company) {
      if (company.parent === null) {
        var children = companies.filter(function (item) {
          return item.parent !== null && item.parent.id === company.id;
        });
        parents.push(company);
        children.forEach(function (child) {
          parents.push(child);
        });
      }
    });
    commit('setCompanies', parents);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getIndustries = function getIndustries(_ref18, payload) {
  var commit = _ref18.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.industries, 'get').then(function (res) {
    var industries = res.body.items;
    var parents = [];
    industries.sort(function (a, b) {
      return a.name > b.name;
    }).forEach(function (industry) {
      if (industry.parent === null) {
        var children = industries.filter(function (item) {
          return item.parent !== null && item.parent.id === industry.id;
        });
        parents.push(industry);
        children.forEach(function (child) {
          parents.push(child);
        });
      }
    });
    commit('setIndustries', parents);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getDefaultRegistrationRoles = function getDefaultRegistrationRoles(_ref19, payload) {
  var commit = _ref19.commit;

  var token = localStorage.getItem('token');
  var userData = JSON.parse(localStorage.getItem('userData'));
  if (token && userData) {
    var urlEnd = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.defaultRegistrationRoles;
    var type = 'get';
    var headers = { headers: { 'Authorization': 'Bearer ' + token } };
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(urlEnd, type, headers).then(function (res) {
      commit('setDefaultRegistrationRoles', res.body);
    }).catch(function (err) {
      return console.log('error', err);
    });
  }
};

var getSponsors = function getSponsors(_ref20, payload) {
  var commit = _ref20.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.sponsors + '/' + payload, 'get').then(function (res) {
    return commit('setSponsors', res.body);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getLngs = function getLngs(_ref21, payload) {
  var commit = _ref21.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.languages, 'get').then(function (res) {
    return commit('setLanguages', res.body.items);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getCompanySizes = function getCompanySizes(_ref22, payload) {
  var commit = _ref22.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companySizes, 'get').then(function (res) {
    return commit('setCompanySizes', res.body);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getCompanyLocations = function getCompanyLocations(_ref23, payload) {
  var commit = _ref23.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyLocations, 'get').then(function (res) {
    return commit('setCompanyLocations', res.body);
  }).catch(function (err) {
    return console.log(err);
  });
};

var getCompanyOrganizationTypes = function getCompanyOrganizationTypes(_ref24) {
  var commit = _ref24.commit;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].requestToServer(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyOrganizationTypes, 'get').then(function (res) {
    return commit('setCompanyOrganizationTypes', res.body);
  }).catch(function (err) {
    return console.log(err);
  });
};

var setDataPreviewArticle = function setDataPreviewArticle(_ref25, payload) {
  var commit = _ref25.commit;

  commit('setDataPreviewArticle', payload);
};

var initConfAction = function initConfAction(_ref26, payload) {
  var commit = _ref26.commit;

  commit('initConfAction', payload);
};

var clearConfAction = function clearConfAction(_ref27, payload) {
  var commit = _ref27.commit;

  commit('clearConfAction', payload);
};

// Information block action
var setInformationMsg = function setInformationMsg(_ref28, payload) {
  var commit = _ref28.commit;

  commit('setInformationMsg', payload);
};

// Information block close action
var closeInformationMsg = function closeInformationMsg(_ref29, payload) {
  var commit = _ref29.commit;

  commit('setInformationMsg', {
    isShown: false,
    title: '',
    text: '',
    className: ''
  });
};

var setStyleForMsg = function setStyleForMsg(_ref30, payload) {
  var commit = _ref30.commit;

  commit('setStyleForMsg', payload);
};

var resizeText = function resizeText(_ref31, payload) {
  var commit = _ref31.commit;

  commit('resizeText', payload);
};

var changeVisibilityThem = function changeVisibilityThem(_ref32, payload) {
  var commit = _ref32.commit;

  commit('changeVisibilityThem', payload);
};

var changeConsent = function changeConsent(_ref33, payload) {
  var commit = _ref33.commit;

  commit('consentRequired', payload);
};
// export const initConfAction = ({ commit }, payload) => {
//   commit('initConfAction', payload)
// }
//
// export const clearConfAction = ({ commit }, payload) => {
//   commit('clearConfAction', payload)
// }
//
// export const removeUserById = ({ commit }, payload) => {
//   const urlEnd = api.URLS.userRoles
//   const type = 'get'
//   api.requestToServer(urlEnd, type, payload)
//     .then((res) => {
//       let userRole = res.body[0]
//       localStorage.setItem('userRole', userRole)
//       commit('authLoginSetUserRole', userRole)
//     })
//     .catch((err) => console.log(err))
// }
//
// export const confCurAction = ({ commit, state }, payload) => {
//   switch (state.confData.actionName) {
//     case 'removeUserById':
//       removeUserById({ commit }, payload)
//       break
//   }
//   clearConfAction({commit})
// }

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "content", function() { return content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "types", function() { return types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tags", function() { return tags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "roles", function() { return roles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContentTypes", function() { return getContentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContentTypeTitles", function() { return getContentTypeTitles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContentTypeIdByTitle", function() { return getContentTypeIdByTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContentTypeForSelect", function() { return getContentTypeForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContentChapterForSelect", function() { return getContentChapterForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTagTitles", function() { return getTagTitles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTagIdByNames", function() { return getTagIdByNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTagsForSelect", function() { return getTagsForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNonEmptyTagsForSelect", function() { return getNonEmptyTagsForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIsLoggedIn", function() { return getIsLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFirstName", function() { return getFirstName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLastName", function() { return getLastName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserId", function() { return getUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserRole", function() { return getUserRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserCompany", function() { return getUserCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccessToken", function() { return getAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTest", function() { return getTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAdmin", function() { return isAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRegularUser", function() { return isRegularUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLightUser", function() { return isLightUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyName", function() { return companyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCategoriesTitle", function() { return getCategoriesTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCategoriesForSelect", function() { return getCategoriesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNonEmptyCategoriesForSelect", function() { return getNonEmptyCategoriesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parentCategoriesForSelect", function() { return parentCategoriesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompaniesForSelect", function() { return getCompaniesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIndustriesForSelect", function() { return getIndustriesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultRegistrationRolesForSelect", function() { return getDefaultRegistrationRolesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSponsorList", function() { return getSponsorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRolesForSelect", function() { return getRolesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLanguagesForSelect", function() { return getLanguagesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArticlePreview", function() { return getArticlePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConfData", function() { return getConfData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInformationMsg", function() { return getInformationMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedFontSize", function() { return getSelectedFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedFont", function() { return getSelectedFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedHightCont", function() { return selectedHightCont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bgColorSpOp", function() { return bgColorSpOp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whiteYelWhite", function() { return whiteYelWhite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blackYelBlack", function() { return blackYelBlack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BlueYelBlue", function() { return BlueYelBlue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConsentRequired", function() { return getConsentRequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImpersonatingUser", function() { return getImpersonatingUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tasksPriorities", function() { return tasksPriorities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskMessageAllowedFileFormats", function() { return taskMessageAllowedFileFormats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chapters", function() { return chapters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskChapters", function() { return taskChapters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskStatuses", function() { return taskStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskMandatory", function() { return taskMandatory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskStatusesForSelect", function() { return taskStatusesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskMandatoryForSelect", function() { return taskMandatoryForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskAssigneeForSelect", function() { return taskAssigneeForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultAssigneeForSelect", function() { return defaultAssigneeForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adminUsersForSelect", function() { return adminUsersForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskAssignee", function() { return taskAssignee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backlogTasks", function() { return backlogTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusTasks", function() { return focusTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "articleCategories", function() { return articleCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "articleTopics", function() { return articleTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companySizes", function() { return companySizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyLocations", function() { return companyLocations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyOrganizationTypes", function() { return companyOrganizationTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profile", function() { return profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userFunctionalAreas", function() { return userFunctionalAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userIndustrySectors", function() { return userIndustrySectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countries", function() { return countries; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var content = function content(state) {
  return state.content;
};
var types = function types(state) {
  return state.types;
};
var tags = function tags(state) {
  return state.tags;
};
var actions = function actions(state) {
  return state.actions;
};
var roles = function roles(state) {
  return state.roles;
};
// types
var getContentTypes = function getContentTypes(state) {
  var defaultValue = false;
  return state.types.map(function (type) {
    if (!defaultValue) {
      return;
    }
    return {
      'label': type.type,
      'value': type.id
    };
  });
};
var getContentTypeTitles = function getContentTypeTitles(state) {
  return state.types.map(function (item) {
    return item.type;
  });
};
var getContentTypeIdByTitle = function getContentTypeIdByTitle(state) {
  return function (type) {
    return state.types.find(function (item) {
      return item.type === type;
    }).id;
  };
};
var getContentTypeForSelect = function getContentTypeForSelect(state) {
  return state.types.map(function (item) {
    //  if (item.is_active) {
    return {
      label: item.type,
      value: item.id
      //  }
    };
  });
};
var getContentChapterForSelect = function getContentChapterForSelect(state) {
  return state.chapters.map(function (item) {
    //  if (item.is_active) {
    return {
      label: item.name,
      value: item.id
      //  }
    };
  });
};

// tags
var getTagTitles = function getTagTitles(state) {
  return state.tags.map(function (item) {
    return {
      'label': item.name,
      'value': item.id
    };
  });
};
var getTagIdByNames = function getTagIdByNames(state) {
  return function (names) {
    return state.tags.filter(function (item) {
      return names.indexOf(item.name) !== -1;
    }).map(function (item) {
      return item.id;
    });
  };
};
var getTagsForSelect = function getTagsForSelect(state) {
  return state.tags.map(function (item) {
    //  if (item.is_active) {
    return {
      label: item.name,
      value: item.id
      //  }
    };
  });
};
var getNonEmptyTagsForSelect = function getNonEmptyTagsForSelect(state) {
  return state.tags.filter(function (item) {
    return parseInt(item.contentsCount) > 0;
  }).map(function (item) {
    return {
      label: item.name,
      value: item.id
    };
  });
};

// auth
var getIsLoggedIn = function getIsLoggedIn(state) {
  return state.auth.isLoggedIn;
};
var getFirstName = function getFirstName(state) {
  return state.auth.userData ? state.auth.userData.firstName : '';
};
var getLastName = function getLastName(state) {
  return state.auth.userData ? state.auth.userData.lastName : '';
};
var getUserId = function getUserId(state) {
  return state.auth.userData ? state.auth.userData.id : '';
};
var getUserRole = function getUserRole(state) {
  return state.auth.userData ? state.auth.userData.userRole : null;
};
var getUserCompany = function getUserCompany(state) {
  return state.auth.userData ? state.auth.userData.company : null;
};
var getAccessToken = function getAccessToken(state) {
  return state.auth.accessToken;
};
var getTest = function getTest(state) {
  return state.auth;
};
var isAdmin = function isAdmin(state) {
  return state.auth.userData ? state.auth.userData.userRole === 'gm' : false;
};
var isRegularUser = function isRegularUser(state) {
  return state.auth.userData ? ['ca', 'cu'].indexOf(state.auth.userData.userRole) > -1 : false;
};
var isLightUser = function isLightUser(state) {
  return state.auth.userData ? ['la', 'lu', 'ta', 'tu'].indexOf(state.auth.userData.userRole) > -1 : false;
};
var companyName = function companyName(state) {
  return state.auth.companyName;
};

// categories
var getCategoriesTitle = function getCategoriesTitle(state) {
  return state.categories.map(function (item) {
    return item.title;
  });
};
var getCategoriesForSelect = function getCategoriesForSelect(state) {
  return state.categories.map(function (item) {
    //  if (item.is_active) {
    return {
      label: item.title,
      value: item.id,
      level: item.parent ? 2 : 1
      //  }
    };
  });
};
var getNonEmptyCategoriesForSelect = function getNonEmptyCategoriesForSelect(state) {
  return state.categories.filter(function (item) {
    return item.contents && item.contents.length;
  }).map(function (item) {
    return {
      label: item.title,
      value: item.id,
      level: item.parent ? 2 : 1
    };
  });
};
var parentCategoriesForSelect = function parentCategoriesForSelect(state) {
  return state.categories.filter(function (item) {
    return !item.parent;
  }).map(function (item) {
    return {
      label: item.title,
      value: item.id
    };
  });
};
// companies
var getCompaniesForSelect = function getCompaniesForSelect(state) {
  return state.companies.map(function (item) {
    return {
      label: item.parent ? ' - ' + item.name : item.name,
      value: item.id,
      parent: item.parent ? 1 : 0,
      usersLimit: item.employee_limit ? item.employee_limit : 0
    };
  });
};
// industries
var getIndustriesForSelect = function getIndustriesForSelect(state) {
  return state.industries.map(function (item) {
    return {
      label: item.parent ? ' - ' + item.name : item.name,
      value: item.id,
      parent: item.parent ? 1 : 0
    };
  });
};
// industries
var getDefaultRegistrationRolesForSelect = function getDefaultRegistrationRolesForSelect(state) {
  return state.defaultRegistrationRoles.map(function (item) {
    return {
      label: item.name,
      value: item.id
    };
  });
};
// get sponsor list
var getSponsorList = function getSponsorList(state) {
  return state.sponsors.map(function (item) {
    return {
      id: item.id,
      alt: item.alt ? item.alt : '',
      url: item.url ? item.url : '',
      logo: item.logo ? item.logo : '',
      order: item.order ? item.order : '',
      isLogoFileUploaded: true
    };
  });
};
// roles
var getRolesForSelect = function getRolesForSelect(state) {
  return state.roles.map(function (item) {
    //  if (item.is_active) {
    return {
      label: item.name,
      slug: item.slug,
      value: item.id
      //  }
    };
  });
};
// languages
var getLanguagesForSelect = function getLanguagesForSelect(state) {
  return state.languages.map(function (item) {
    //  if (item.is_active) {
    return {
      label: item.name,
      value: item.id
      //  }
    };
  });
};
var getArticlePreview = function getArticlePreview(state) {
  return state.articlePreview;
};

var getConfData = function getConfData(state) {
  return state.confData;
};

var getInformationMsg = function getInformationMsg(state) {
  return state.informationMsg;
};

// Special opportunities
var getSelectedFontSize = function getSelectedFontSize(state) {
  return state.specialOps.fontOpt[state.specialOps.selectedFont];
};
var getSelectedFont = function getSelectedFont(state) {
  return state.specialOps.selectedFont;
};

var selectedHightCont = function selectedHightCont(state) {
  return state.specialOps.selectedHightCont;
};
var bgColorSpOp = function bgColorSpOp(state) {
  return state.specialOps.backgroundColor[state.specialOps.selectedHightCont];
};
var color = function color(state) {
  return state.specialOps.color[state.specialOps.selectedHightCont];
};
var whiteYelWhite = function whiteYelWhite(state) {
  var color = void 0;
  switch (state.specialOps.selectedHightCont) {
    case 0:
      color = '#fff';
      break;
    case 1:
      color = '#FFFA1A';
      break;
    case 2:
      color = '#fff';
      break;
  }
  return {
    color: color
  };
};
var blackYelBlack = function blackYelBlack(state) {
  var color = void 0;
  switch (state.specialOps.selectedHightCont) {
    case 0:
      color = '#000';
      break;
    case 1:
      color = '#FFFA1A';
      break;
    case 2:
      color = '#000';
      break;
  }
  return {
    color: color
  };
};
var BlueYelBlue = function BlueYelBlue(state) {
  var color = void 0;
  switch (state.specialOps.selectedHightCont) {
    case 0:
      color = '#257281';
      break;
    case 1:
      color = '#FFFA1A';
      break;
    case 2:
      color = '#257281';
      break;
  }
  return {
    color: color
  };
};

var getConsentRequired = function getConsentRequired(state) {
  return state.consentRequired;
};

var getImpersonatingUser = function getImpersonatingUser(state) {
  return state.impersonatingUser;
};

var tasksPriorities = function tasksPriorities(state) {
  return state.tasks.priorities;
};

var taskMessageAllowedFileFormats = function taskMessageAllowedFileFormats(state) {
  return state.tasks.message.allowedFileFormats;
};

var chapters = function chapters(state) {
  return state.chapters;
};

var taskChapters = function taskChapters(state) {
  return state.taskChapters;
};

var taskStatuses = function taskStatuses(state) {
  return state.taskStatuses;
};

var taskMandatory = function taskMandatory(state) {
  return state.taskMandatory;
};

var taskStatusesForSelect = function taskStatusesForSelect(state) {
  return state.taskStatuses.map(function (item) {
    return {
      label: item.name,
      value: item.id
    };
  });
};

var taskMandatoryForSelect = function taskMandatoryForSelect(state) {
  return state.taskMandatory.map(function (item) {
    return {
      label: item.name,
      value: item.id
    };
  });
};

var taskAssigneeForSelect = function taskAssigneeForSelect(state) {
  return [{
    label: 'Unassigned',
    value: null
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.taskAssignee));
};

var defaultAssigneeForSelect = function defaultAssigneeForSelect(state) {
  return state.taskAssignee;
};

var adminUsersForSelect = function adminUsersForSelect(state) {
  return state.adminUsers;
};

var taskAssignee = function taskAssignee(state) {
  return state.taskAssignee.filter(function (item) {
    return item.count > 0;
  });
};

var backlogTasks = function backlogTasks(state) {
  return state.tasks.backlogTasks;
};

var focusTasks = function focusTasks(state) {
  return state.tasks.focusTasks;
};

var articleCategories = function articleCategories(state) {
  return state.categories.filter(function (item) {
    return item.contents && item.contents.length;
  }).map(function (item) {
    return {
      id: item.id,
      title: item.title,
      description: item.description,
      icon: item.icon
    };
  });
};

var articleTopics = function articleTopics(state) {
  return state.tags.filter(function (item) {
    return parseInt(item.contentsCount) > 0;
  }).map(function (item) {
    return {
      id: item.id,
      title: item.name,
      description: item.description,
      icon: item.icon
    };
  });
};

var companySizes = function companySizes(state) {
  return state.companySizes.map(function (item) {
    return {
      value: item.id,
      label: item.name,
      min: item.min,
      max: item.max
    };
  });
};

var companyLocations = function companyLocations(state) {
  return state.companyLocations.map(function (item) {
    return {
      value: item.id,
      label: item.name
    };
  });
};

var companyOrganizationTypes = function companyOrganizationTypes(state) {
  return state.companyOrganizationTypes.sort(function (a, b) {
    return a.label.localeCompare(b.label);
  });
};

var profile = function profile(state) {
  return state.profile;
};

var userFunctionalAreas = function userFunctionalAreas(state) {
  return state.userFunctionalAreas.sort(function (a, b) {
    return a.label.localeCompare(b.label);
  });
};

var userIndustrySectors = function userIndustrySectors(state) {
  return state.userIndustrySectors.sort(function (a, b) {
    return a.label.localeCompare(b.label);
  });
};

var countries = function countries(state) {
  return state.countries;
};

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(245);
/**
 * App state storage
 */







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);
var state = {
  auth: {
    isLoggedIn: !!localStorage.getItem('token'),
    accessToken: localStorage.getItem('token'),
    userData: JSON.parse(localStorage.getItem('userData')),
    userRole: null,
    company: null,
    pending: null,
    companyName: localStorage.getItem('userCompanyName') || null
  },
  content: [],
  companies: [],
  industries: [],
  defaultRegistrationRoles: [],
  sponsors: [],
  types: [],
  chapters: [],
  taskChapters: [],
  taskStatuses: [],
  taskMandatory: [],
  taskAssignee: [],
  adminUsers: [],
  tags: [],
  actions: [],
  roles: [],
  categories: [],
  languages: [],
  confData: {
    id: null,
    actionId: null,
    actionName: null,
    showPopup: false,
    userStatus: null,
    actionConfirmed: false,
    customCancelButtonText: null,
    customConfirmButtonText: null,
    includeForm: false,
    feedbackText: null
  },
  informationMsg: {
    isShown: false,
    title: null,
    text: null,
    className: { 'success': false, 'error': false, 'warning': false },
    style: {}
  },
  search: {
    searchString: null,
    contentTypes: [],
    topics: []
  },
  specialOps: {
    selectedFont: localStorage.getItem('selectedFont') ? +localStorage.getItem('selectedFont') : 0,
    fontOpt: {
      0: '16px',
      1: '19.2px',
      2: '22.4px'
    },
    selectedHightCont: localStorage.getItem('selectedHightCont') ? +localStorage.getItem('selectedHightCont') : 0,
    backgroundColor: {
      0: '#fff',
      1: '#000',
      2: '#fafac8'
    },
    color: {
      0: '#000',
      1: '#FFFA1A',
      2: '#000'
    }
  },
  consentRequired: localStorage.getItem('consentHead') ? localStorage.getItem('consentHead') : false,
  impersonatingUser: localStorage.getItem('impersonated') ? localStorage.getItem('impersonated') : false,
  tasks: {
    priorities: [{
      label: 'Low',
      value: 0
    }, {
      label: 'Medium',
      value: 1
    }, {
      label: 'High',
      value: 2
    }],
    message: {
      allowedFileFormats: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv', 'pdf', 'txt', 'zip', 'odt', 'ods', 'odg', 'odp', 'gif', 'jpg', 'jpeg', 'png']
    },
    backlogTasks: [],
    focusTasks: []
  },
  companySizes: [],
  companyLocations: [],
  companyOrganizationTypes: [],
  profile: null,
  userFunctionalAreas: [{
    label: 'Strategy',
    value: 'Strategy'
  }, {
    label: 'Marketing',
    value: 'Marketing'
  }, {
    label: 'Finance',
    value: 'Finance'
  }, {
    label: 'Human Resources',
    value: 'Human Resources'
  }, {
    label: 'Technology and equipment',
    value: 'Technology and equipment'
  }, {
    label: 'Operations',
    value: 'Operations'
  }, {
    label: 'Legal',
    value: 'Legal'
  }, {
    label: 'ED&I',
    value: 'ED&I'
  }],
  userIndustrySectors: [{
    label: 'Agriculture, Forestry and Fishing',
    value: 'Agriculture, Forestry and Fishing'
  }, {
    label: 'Manufacturing',
    value: 'Manufacturing'
  }, {
    label: 'Electricity, gas, steam and air conditioning supply',
    value: 'Electricity, gas, steam and air conditioning supply'
  }, {
    label: 'Construction',
    value: 'Construction'
  }, {
    label: 'Wholesale and retail trade',
    value: 'Wholesale and retail trade'
  }, {
    label: 'Transportation and storage',
    value: 'Transportation and storage'
  }, {
    label: 'Accommodation and food service activities',
    value: 'Accommodation and food service activities'
  }, {
    label: 'Information and communication',
    value: 'Information and communication'
  }, {
    label: 'Financial and insurance activities',
    value: 'Financial and insurance activities'
  }, {
    label: 'Real estate activities',
    value: 'Real estate activities'
  }, {
    label: 'Professional, scientific and technical activities',
    value: 'Professional, scientific and technical activities'
  }, {
    label: 'Administrative and support service activities',
    value: 'Administrative and support service activities'
  }, {
    label: 'Education',
    value: 'Education'
  }, {
    label: 'Human health and social work activities',
    value: 'Human health and social work activities'
  }, {
    label: 'Arts, entertainment and recreation',
    value: 'Arts, entertainment and recreation'
  }, {
    label: 'Other service activities',
    value: 'Other service activities'
  }],
  countries: [{
    label: 'Afghanistan',
    value: 'AF'
  }, {
    label: 'Åland Islands',
    value: 'AX'
  }, {
    label: 'Albania',
    value: 'AL'
  }, {
    label: 'Algeria',
    value: 'DZ'
  }, {
    label: 'American Samoa',
    value: 'AS'
  }, {
    label: 'AndorrA',
    value: 'AD'
  }, {
    label: 'Angola',
    value: 'AO'
  }, {
    label: 'Anguilla',
    value: 'AI'
  }, {
    label: 'Antarctica',
    value: 'AQ'
  }, {
    label: 'Antigua and Barbuda',
    value: 'AG'
  }, {
    label: 'Argentina',
    value: 'AR'
  }, {
    label: 'Armenia',
    value: 'AM'
  }, {
    label: 'Aruba',
    value: 'AW'
  }, {
    label: 'Australia',
    value: 'AU'
  }, {
    label: 'Austria',
    value: 'AT'
  }, {
    label: 'Azerbaijan',
    value: 'AZ'
  }, {
    label: 'Bahamas',
    value: 'BS'
  }, {
    label: 'Bahrain',
    value: 'BH'
  }, {
    label: 'Bangladesh',
    value: 'BD'
  }, {
    label: 'Barbados',
    value: 'BB'
  }, {
    label: 'Belarus',
    value: 'BY'
  }, {
    label: 'Belgium',
    value: 'BE'
  }, {
    label: 'Belize',
    value: 'BZ'
  }, {
    label: 'Benin',
    value: 'BJ'
  }, {
    label: 'Bermuda',
    value: 'BM'
  }, {
    label: 'Bhutan',
    value: 'BT'
  }, {
    label: 'Bolivia',
    value: 'BO'
  }, {
    label: 'Bosnia and Herzegovina',
    value: 'BA'
  }, {
    label: 'Botswana',
    value: 'BW'
  }, {
    label: 'Bouvet Island',
    value: 'BV'
  }, {
    label: 'Brazil',
    value: 'BR'
  }, {
    label: 'British Indian Ocean Territory',
    value: 'IO'
  }, {
    label: 'Brunei Darussalam',
    value: 'BN'
  }, {
    label: 'Bulgaria',
    value: 'BG'
  }, {
    label: 'Burkina Faso',
    value: 'BF'
  }, {
    label: 'Burundi',
    value: 'BI'
  }, {
    label: 'Cambodia',
    value: 'KH'
  }, {
    label: 'Cameroon',
    value: 'CM'
  }, {
    label: 'Canada',
    value: 'CA'
  }, {
    label: 'Cape Verde',
    value: 'CV'
  }, {
    label: 'Cayman Islands',
    value: 'KY'
  }, {
    label: 'Central African Republic',
    value: 'CF'
  }, {
    label: 'Chad',
    value: 'TD'
  }, {
    label: 'Chile',
    value: 'CL'
  }, {
    label: 'China',
    value: 'CN'
  }, {
    label: 'Christmas Island',
    value: 'CX'
  }, {
    label: 'Cocos (Keeling) Islands',
    value: 'CC'
  }, {
    label: 'Colombia',
    value: 'CO'
  }, {
    label: 'Comoros',
    value: 'KM'
  }, {
    label: 'Congo',
    value: 'CG'
  }, {
    label: 'Congo, The Democratic Republic of the',
    value: 'CD'
  }, {
    label: 'Cook Islands',
    value: 'CK'
  }, {
    label: 'Costa Rica',
    value: 'CR'
  }, {
    label: 'Cote D\'Ivoire',
    value: 'CI'
  }, {
    label: 'Croatia',
    value: 'HR'
  }, {
    label: 'Cuba',
    value: 'CU'
  }, {
    label: 'Cyprus',
    value: 'CY'
  }, {
    label: 'Czech Republic',
    value: 'CZ'
  }, {
    label: 'Denmark',
    value: 'DK'
  }, {
    label: 'Djibouti',
    value: 'DJ'
  }, {
    label: 'Dominica',
    value: 'DM'
  }, {
    label: 'Dominican Republic',
    value: 'DO'
  }, {
    label: 'Ecuador',
    value: 'EC'
  }, {
    label: 'Egypt',
    value: 'EG'
  }, {
    label: 'El Salvador',
    value: 'SV'
  }, {
    label: 'Equatorial Guinea',
    value: 'GQ'
  }, {
    label: 'Eritrea',
    value: 'ER'
  }, {
    label: 'Estonia',
    value: 'EE'
  }, {
    label: 'Ethiopia',
    value: 'ET'
  }, {
    label: 'Falkland Islands (Malvinas)',
    value: 'FK'
  }, {
    label: 'Faroe Islands',
    value: 'FO'
  }, {
    label: 'Fiji',
    value: 'FJ'
  }, {
    label: 'Finland',
    value: 'FI'
  }, {
    label: 'France',
    value: 'FR'
  }, {
    label: 'French Guiana',
    value: 'GF'
  }, {
    label: 'French Polynesia',
    value: 'PF'
  }, {
    label: 'French Southern Territories',
    value: 'TF'
  }, {
    label: 'Gabon',
    value: 'GA'
  }, {
    label: 'Gambia',
    value: 'GM'
  }, {
    label: 'Georgia',
    value: 'GE'
  }, {
    label: 'Germany',
    value: 'DE'
  }, {
    label: 'Ghana',
    value: 'GH'
  }, {
    label: 'Gibraltar',
    value: 'GI'
  }, {
    label: 'Greece',
    value: 'GR'
  }, {
    label: 'Greenland',
    value: 'GL'
  }, {
    label: 'Grenada',
    value: 'GD'
  }, {
    label: 'Guadeloupe',
    value: 'GP'
  }, {
    label: 'Guam',
    value: 'GU'
  }, {
    label: 'Guatemala',
    value: 'GT'
  }, {
    label: 'Guernsey',
    value: 'GG'
  }, {
    label: 'Guinea',
    value: 'GN'
  }, {
    label: 'Guinea-Bissau',
    value: 'GW'
  }, {
    label: 'Guyana',
    value: 'GY'
  }, {
    label: 'Haiti',
    value: 'HT'
  }, {
    label: 'Heard Island and Mcdonald Islands',
    value: 'HM'
  }, {
    label: 'Holy See (Vatican City State)',
    value: 'VA'
  }, {
    label: 'Honduras',
    value: 'HN'
  }, {
    label: 'Hong Kong',
    value: 'HK'
  }, {
    label: 'Hungary',
    value: 'HU'
  }, {
    label: 'Iceland',
    value: 'IS'
  }, {
    label: 'India',
    value: 'IN'
  }, {
    label: 'Indonesia',
    value: 'ID'
  }, {
    label: 'Iran, Islamic Republic Of',
    value: 'IR'
  }, {
    label: 'Iraq',
    value: 'IQ'
  }, {
    label: 'Ireland',
    value: 'IE'
  }, {
    label: 'Isle of Man',
    value: 'IM'
  }, {
    label: 'Israel',
    value: 'IL'
  }, {
    label: 'Italy',
    value: 'IT'
  }, {
    label: 'Jamaica',
    value: 'JM'
  }, {
    label: 'Japan',
    value: 'JP'
  }, {
    label: 'Jersey',
    value: 'JE'
  }, {
    label: 'Jordan',
    value: 'JO'
  }, {
    label: 'Kazakhstan',
    value: 'KZ'
  }, {
    label: 'Kenya',
    value: 'KE'
  }, {
    label: 'Kiribati',
    value: 'KI'
  }, {
    label: 'Korea, Democratic People\'S Republic of',
    value: 'KP'
  }, {
    label: 'Korea, Republic of',
    value: 'KR'
  }, {
    label: 'Kuwait',
    value: 'KW'
  }, {
    label: 'Kyrgyzstan',
    value: 'KG'
  }, {
    label: 'Lao People\'S Democratic Republic',
    value: 'LA'
  }, {
    label: 'Latvia',
    value: 'LV'
  }, {
    label: 'Lebanon',
    value: 'LB'
  }, {
    label: 'Lesotho',
    value: 'LS'
  }, {
    label: 'Liberia',
    value: 'LR'
  }, {
    label: 'Libyan Arab Jamahiriya',
    value: 'LY'
  }, {
    label: 'Liechtenstein',
    value: 'LI'
  }, {
    label: 'Lithuania',
    value: 'LT'
  }, {
    label: 'Luxembourg',
    value: 'LU'
  }, {
    label: 'Macao',
    value: 'MO'
  }, {
    label: 'Macedonia, The Former Yugoslav Republic of',
    value: 'MK'
  }, {
    label: 'Madagascar',
    value: 'MG'
  }, {
    label: 'Malawi',
    value: 'MW'
  }, {
    label: 'Malaysia',
    value: 'MY'
  }, {
    label: 'Maldives',
    value: 'MV'
  }, {
    label: 'Mali',
    value: 'ML'
  }, {
    label: 'Malta',
    value: 'MT'
  }, {
    label: 'Marshall Islands',
    value: 'MH'
  }, {
    label: 'Martinique',
    value: 'MQ'
  }, {
    label: 'Mauritania',
    value: 'MR'
  }, {
    label: 'Mauritius',
    value: 'MU'
  }, {
    label: 'Mayotte',
    value: 'YT'
  }, {
    label: 'Mexico',
    value: 'MX'
  }, {
    label: 'Micronesia, Federated States of',
    value: 'FM'
  }, {
    label: 'Moldova, Republic of',
    value: 'MD'
  }, {
    label: 'Monaco',
    value: 'MC'
  }, {
    label: 'Mongolia',
    value: 'MN'
  }, {
    label: 'Montserrat',
    value: 'MS'
  }, {
    label: 'Morocco',
    value: 'MA'
  }, {
    label: 'Mozambique',
    value: 'MZ'
  }, {
    label: 'Myanmar',
    value: 'MM'
  }, {
    label: 'Namibia',
    value: 'NA'
  }, {
    label: 'Nauru',
    value: 'NR'
  }, {
    label: 'Nepal',
    value: 'NP'
  }, {
    label: 'Netherlands',
    value: 'NL'
  }, {
    label: 'Netherlands Antilles',
    value: 'AN'
  }, {
    label: 'New Caledonia',
    value: 'NC'
  }, {
    label: 'New Zealand',
    value: 'NZ'
  }, {
    label: 'Nicaragua',
    value: 'NI'
  }, {
    label: 'Niger',
    value: 'NE'
  }, {
    label: 'Nigeria',
    value: 'NG'
  }, {
    label: 'Niue',
    value: 'NU'
  }, {
    label: 'Norfolk Island',
    value: 'NF'
  }, {
    label: 'Northern Mariana Islands',
    value: 'MP'
  }, {
    label: 'Norway',
    value: 'NO'
  }, {
    label: 'Oman',
    value: 'OM'
  }, {
    label: 'Pakistan',
    value: 'PK'
  }, {
    label: 'Palau',
    value: 'PW'
  }, {
    label: 'Palestinian Territory, Occupied',
    value: 'PS'
  }, {
    label: 'Panama',
    value: 'PA'
  }, {
    label: 'Papua New Guinea',
    value: 'PG'
  }, {
    label: 'Paraguay',
    value: 'PY'
  }, {
    label: 'Peru',
    value: 'PE'
  }, {
    label: 'Philippines',
    value: 'PH'
  }, {
    label: 'Pitcairn',
    value: 'PN'
  }, {
    label: 'Poland',
    value: 'PL'
  }, {
    label: 'Portugal',
    value: 'PT'
  }, {
    label: 'Puerto Rico',
    value: 'PR'
  }, {
    label: 'Qatar',
    value: 'QA'
  }, {
    label: 'Reunion',
    value: 'RE'
  }, {
    label: 'Romania',
    value: 'RO'
  }, {
    label: 'Russian Federation',
    value: 'RU'
  }, {
    label: 'RWANDA',
    value: 'RW'
  }, {
    label: 'Saint Helena',
    value: 'SH'
  }, {
    label: 'Saint Kitts and Nevis',
    value: 'KN'
  }, {
    label: 'Saint Lucia',
    value: 'LC'
  }, {
    label: 'Saint Pierre and Miquelon',
    value: 'PM'
  }, {
    label: 'Saint Vincent and the Grenadines',
    value: 'VC'
  }, {
    label: 'Samoa',
    value: 'WS'
  }, {
    label: 'San Marino',
    value: 'SM'
  }, {
    label: 'Sao Tome and Principe',
    value: 'ST'
  }, {
    label: 'Saudi Arabia',
    value: 'SA'
  }, {
    label: 'Senegal',
    value: 'SN'
  }, {
    label: 'Serbia and Montenegro',
    value: 'CS'
  }, {
    label: 'Seychelles',
    value: 'SC'
  }, {
    label: 'Sierra Leone',
    value: 'SL'
  }, {
    label: 'Singapore',
    value: 'SG'
  }, {
    label: 'Slovakia',
    value: 'SK'
  }, {
    label: 'Slovenia',
    value: 'SI'
  }, {
    label: 'Solomon Islands',
    value: 'SB'
  }, {
    label: 'Somalia',
    value: 'SO'
  }, {
    label: 'South Africa',
    value: 'ZA'
  }, {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'GS'
  }, {
    label: 'Spain',
    value: 'ES'
  }, {
    label: 'Sri Lanka',
    value: 'LK'
  }, {
    label: 'Sudan',
    value: 'SD'
  }, {
    label: 'Surilabel',
    value: 'SR'
  }, {
    label: 'Svalbard and Jan Mayen',
    value: 'SJ'
  }, {
    label: 'Swaziland',
    value: 'SZ'
  }, {
    label: 'Sweden',
    value: 'SE'
  }, {
    label: 'Switzerland',
    value: 'CH'
  }, {
    label: 'Syrian Arab Republic',
    value: 'SY'
  }, {
    label: 'Taiwan, Province of China',
    value: 'TW'
  }, {
    label: 'Tajikistan',
    value: 'TJ'
  }, {
    label: 'Tanzania, United Republic of',
    value: 'TZ'
  }, {
    label: 'Thailand',
    value: 'TH'
  }, {
    label: 'Timor-Leste',
    value: 'TL'
  }, {
    label: 'Togo',
    value: 'TG'
  }, {
    label: 'Tokelau',
    value: 'TK'
  }, {
    label: 'Tonga',
    value: 'TO'
  }, {
    label: 'Trinidad and Tobago',
    value: 'TT'
  }, {
    label: 'Tunisia',
    value: 'TN'
  }, {
    label: 'Turkey',
    value: 'TR'
  }, {
    label: 'Turkmenistan',
    value: 'TM'
  }, {
    label: 'Turks and Caicos Islands',
    value: 'TC'
  }, {
    label: 'Tuvalu',
    value: 'TV'
  }, {
    label: 'Uganda',
    value: 'UG'
  }, {
    label: 'Ukraine',
    value: 'UA'
  }, {
    label: 'United Arab Emirates',
    value: 'AE'
  }, {
    label: 'United Kingdom',
    value: 'GB'
  }, {
    label: 'United States',
    value: 'US'
  }, {
    label: 'United States Minor Outlying Islands',
    value: 'UM'
  }, {
    label: 'Uruguay',
    value: 'UY'
  }, {
    label: 'Uzbekistan',
    value: 'UZ'
  }, {
    label: 'Vanuatu',
    value: 'VU'
  }, {
    label: 'Venezuela',
    value: 'VE'
  }, {
    label: 'Viet Nam',
    value: 'VN'
  }, {
    label: 'Virgin Islands, British',
    value: 'VG'
  }, {
    label: 'Virgin Islands, U.S.',
    value: 'VI'
  }, {
    label: 'Wallis and Futuna',
    value: 'WF'
  }, {
    label: 'Western Sahara',
    value: 'EH'
  }, {
    label: 'Yemen',
    value: 'YE'
  }, {
    label: 'Zambia',
    value: 'ZM'
  }, {
    label: 'Zimbabwe',
    value: 'ZW'
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__
}));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTypes", function() { return setTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setChapters", function() { return setChapters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskChapters", function() { return setTaskChapters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskStatuses", function() { return setTaskStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskMandatory", function() { return setTaskMandatory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskAssignee", function() { return setTaskAssignee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAdminUsers", function() { return setAdminUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTags", function() { return setTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCategories", function() { return setCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLogin", function() { return authLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLoginSuccess", function() { return authLoginSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLoginSetUsername", function() { return authLoginSetUsername; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLoginSetUserRole", function() { return authLoginSetUserRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProfile", function() { return setProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLoginSetCompany", function() { return authLoginSetCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLogout", function() { return authLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActions", function() { return setActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRoles", function() { return setRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCompanies", function() { return setCompanies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIndustries", function() { return setIndustries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultRegistrationRoles", function() { return setDefaultRegistrationRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSponsors", function() { return setSponsors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDataPreviewArticle", function() { return setDataPreviewArticle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLanguages", function() { return setLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCompanySizes", function() { return setCompanySizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCompanyLocations", function() { return setCompanyLocations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCompanyOrganizationTypes", function() { return setCompanyOrganizationTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initConfAction", function() { return initConfAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearConfAction", function() { return clearConfAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInformationMsg", function() { return setInformationMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStyleForMsg", function() { return setStyleForMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resizeText", function() { return resizeText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeVisibilityThem", function() { return changeVisibilityThem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeConsent", function() { return changeConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeImpersonate", function() { return changeImpersonate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeAuthUserData", function() { return changeAuthUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBacklogTasks", function() { return setBacklogTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFocusTasks", function() { return setFocusTasks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var setTypes = function setTypes(state, types) {
  state.types = types;
};
var setChapters = function setChapters(state, chapters) {
  state.chapters = chapters;
};
var setTaskChapters = function setTaskChapters(state, chapters) {
  state.taskChapters = chapters;
};
var setTaskStatuses = function setTaskStatuses(state, statuses) {
  state.taskStatuses = statuses;
};
var setTaskMandatory = function setTaskMandatory(state, mandatory) {
  state.taskMandatory = mandatory;
};
var setTaskAssignee = function setTaskAssignee(state, users) {
  state.taskAssignee = users;
};
var setAdminUsers = function setAdminUsers(state, users) {
  state.adminUsers = users;
};
var setTags = function setTags(state, tags) {
  state.tags = tags;
};
var setCategories = function setCategories(state, categories) {
  state.categories = categories;
};

// auth
var authLogin = function authLogin(state) {
  state.auth.pending = true;
};
var authLoginSuccess = function authLoginSuccess(state) {
  // state.auth.isLoggedIn = true
  // state.auth.pending = false
  if (window._paq) {
    window._paq.push(['trackEvent', 'Login', 1]);
  }
  // if (window.ga) {
  //   window.ga('send', {
  //     hitType: 'event',
  //     eventCategory: 'Login',
  //     eventValue: 1
  //   })
  // }
};
var authLoginSetUsername = function authLoginSetUsername(state, name) {
  state.auth.username = name;
};
var authLoginSetUserRole = function authLoginSetUserRole(state, userRole) {
  state.auth.userRole = userRole;
};
var setProfile = function setProfile(state, profile) {
  state.profile = profile;
};
var authLoginSetCompany = function authLoginSetCompany(state, company) {
  state.auth.company = company;
};
var authLogout = function authLogout(state) {
  state.auth.isLoggedIn = false;
  state.auth.username = null;
  state.auth.userRole = null;
  if (window._paq) {
    window._paq.push(['trackEvent', 'Logout', 1]);
  }
  // if (window.ga) {
  //   window.ga('send', {
  //     hitType: 'event',
  //     eventCategory: 'Logout',
  //     eventValue: 1
  //   })
  // }
};

var setActions = function setActions(state, actions) {
  state.actions = actions;
};
var setRoles = function setRoles(state, roles) {
  state.roles = roles;
};

// Companies
var setCompanies = function setCompanies(state, payload) {
  state.companies = payload;
};

// Industries
var setIndustries = function setIndustries(state, payload) {
  state.industries = payload;
};

// Default Registration Roles
var setDefaultRegistrationRoles = function setDefaultRegistrationRoles(state, payload) {
  state.defaultRegistrationRoles = payload;
};

// Sponsors
var setSponsors = function setSponsors(state, payload) {
  state.sponsors = payload;
};

//
var setDataPreviewArticle = function setDataPreviewArticle(state, payload) {
  state.articlePreview = payload;
};
// Lngs
var setLanguages = function setLanguages(state, payload) {
  state.languages = payload;
};
var setCompanySizes = function setCompanySizes(state, payload) {
  state.companySizes = payload;
};
var setCompanyLocations = function setCompanyLocations(state, payload) {
  state.companyLocations = payload;
};
var setCompanyOrganizationTypes = function setCompanyOrganizationTypes(state, payload) {
  state.companyOrganizationTypes = payload;
};
var initConfAction = function initConfAction(state, payload) {
  state.confData.id = payload.id;
  state.confData.actionId = payload.actionId;
  state.confData.actionName = payload.actionName;
  state.confData.showPopup = true;
  state.confData.userStatus = payload.userStatus;
  state.confData.actionConfirmed = payload.confirmActionHandler;
  state.confData.includeForm = payload.includeForm;
  state.confData.customCancelButtonText = payload.customCancelButtonText;
  state.confData.customConfirmButtonText = payload.customConfirmButtonText;
  state.confData.feedbackText = payload.feedbackText;
  state.confData.customText = payload.customText;
};

var clearConfAction = function clearConfAction(state, payload) {
  state.confData.id = null;
  state.confData.actionName = null;
  state.confData.showPopup = false;
  state.confData.actionId = null;
  state.confData.userStatus = null;
  state.confData.feedbackText = null;
  state.confData.customText = null;
  state.confData.includeForm = null;
  state.confData.customCancelButtonText = null;
  state.confData.customConfirmButtonText = null;
};

// Information block mutation
var setInformationMsg = function setInformationMsg(state, payload) {
  state.informationMsg.isShown = payload.isShown;
  state.informationMsg.title = payload.title;
  state.informationMsg.text = payload.text;
  for (var className in state.informationMsg.className) {
    state.informationMsg.className[className] = false;
  }
  if (payload.className) {
    state.informationMsg.className[payload.className] = true;
  }
  document.body.scrollTop = document.documentElement.scrollTop = 0;
  setTimeout(function () {
    state.informationMsg.isShown = false;
    state.informationMsg.title = '';
    state.informationMsg.text = '';
  }, 15000);
};

var setStyleForMsg = function setStyleForMsg(state, payload) {
  state.informationMsg.style = payload;
};

var resizeText = function resizeText(state, payload) {
  var fontSizeButtons = document.getElementsByClassName('text-resize-controls__button');
  var fontSizeTrigger = document.getElementById('accessibilityFontSize_' + payload);
  for (var i = 0; i < fontSizeButtons.length; i++) {
    fontSizeButtons[i].classList.remove('active');
  }
  switch (payload) {
    case 0:
      document.getElementsByTagName('HTML')[0].style.fontSize = '100%';
      break;
    case 1:
      document.getElementsByTagName('HTML')[0].style.fontSize = '110%';
      break;
    case 2:
      document.getElementsByTagName('HTML')[0].style.fontSize = '120%';
      break;
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-size-0', 'accessibility-size-1', 'accessibility-size-2');
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-size-' + payload);
  if (fontSizeTrigger) {
    fontSizeTrigger.classList.add('active');
  }
  state.specialOps.selectedFont = payload;
  localStorage.setItem('selectedFont', payload);
};

var changeVisibilityThem = function changeVisibilityThem(state, payload) {
  var colorPaletteButtons = document.getElementsByClassName('color-change-controls__button');
  for (var i = 0; i < colorPaletteButtons.length; i++) {
    colorPaletteButtons[i].classList.remove('active');
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-color-0', 'accessibility-color-1', 'accessibility-color-2');
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-color-' + payload);
  document.getElementById('accessibilityColorPalette_' + payload).classList.add('active');
  state.specialOps.selectedHightCont = payload;
  localStorage.setItem('selectedHightCont', payload);
};

var changeConsent = function changeConsent(state, payload) {
  state.consentRequired = payload;
  localStorage.setItem('consentHead', payload);
};

var changeImpersonate = function changeImpersonate(state, payload) {
  state.impersonatingUser = payload;
  if (!payload) {
    localStorage.removeItem('impersonated');
    location.href = '/admin';
    var app = document.getElementById('app');
    if (app) {
      app.removeAttribute('data-industry');
    }
  }
};

var changeAuthUserData = function changeAuthUserData(state, payload) {
  state.auth.userData = payload;
};

var setBacklogTasks = function setBacklogTasks(state, payload) {
  state.tasks.backlogTasks = [];
  for (var i = 0; i < payload.length; i++) {
    state.tasks.backlogTasks = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.tasks.backlogTasks), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(payload[i].tasks));
  }
};

var setFocusTasks = function setFocusTasks(state, payload) {
  state.tasks.focusTasks = [];
  for (var i = 0; i < payload.length; i++) {
    state.tasks.focusTasks = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.tasks.focusTasks), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(payload[i].tasks));
  }
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_AppHeader__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_ConfPopup__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_ConfPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_ConfPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_InfomMsg__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_InfomMsg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_InfomMsg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      industry: null,
      isLocalHost: false
    };
  },

  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_common_AppHeader___default.a,
    ConfPopup: __WEBPACK_IMPORTED_MODULE_1__components_common_ConfPopup___default.a,
    InformMsg: __WEBPACK_IMPORTED_MODULE_2__components_common_InfomMsg___default.a
  },
  mounted: function mounted() {
    this.industry = localStorage.getItem('userIndustry');
    this.isLocalHost = location.hostname === 'localhost';
    if (this.industry) {
      var userData = localStorage.getItem('userData');
      var app = document.getElementById('app');
      if (userData) {
        userData = JSON.parse(userData);
        if (userData['role'] !== 'gm' && app) {
          app.setAttribute('data-industry', this.industry);
        }
      } else {
        app.setAttribute('data-industry', this.industry);
      }
    }
  },
  beforeMount: function beforeMount() {
    var element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('type', 'text/css');
    element.setAttribute('href', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/assets/css/industries.css');
    document.getElementsByTagName('head')[0].appendChild(element);
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll___default.a, __WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer___default.a, __WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax___default.a],

  props: {
    /**
     * Contains the currently selected value. Very similar to a
     * `value` attribute on an <input>. You can listen for changes
     * using 'change' event using v-on
     * @type {Object||String||null}
     */
    value: {
      default: null
    },

    /**
     * An array of strings or objects to be used as dropdown choices.
     * If you are using an array of objects, vue-select will look for
     * a `label` key (ex. [{label: 'This is Foo', value: 'foo'}]). A
     * custom label key can be set with the `label` prop.
     * @type {Array}
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Disable the entire component.
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Can the user clear the selected property.
     * @type {Boolean}
     */
    clearable: {
      type: Boolean,
      default: true
    },

    /**
     * Sets the max-height property on the dropdown list.
     * @deprecated
     * @type {String}
     */
    maxHeight: {
      type: String,
      default: '400px'
    },

    /**
     * Enable/disable filtering the options.
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },

    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * Equivalent to the `placeholder` attribute on an `<input>`.
     * @type {String}
     */
    placeholder: {
      type: String,
      default: ''
    },

    /**
     * Sets a Vue transition property on the `.dropdown-menu`. vue-select
     * does not include CSS for transitions, you'll need to add them yourself.
     * @type {String}
     */
    transition: {
      type: String,
      default: 'fade'
    },

    /**
     * Enables/disables clearing the search text when an option is selected.
     * @type {Boolean}
     */
    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Close a dropdown when an option is chosen. Set to false to keep the dropdown
     * open (useful when combined with multi-select, for example)
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Tells vue-select what key to use when generating option
     * labels when each `option` is an object.
     * @type {String}
     */
    label: {
      type: String,
      default: 'label'
    },

    /**
     * Value of the 'autocomplete' field of the input
     * element.
     * @type {String}
     */
    autocomplete: {
      type: String,
      default: 'off'
    },

    /**
     * Tells vue-select what key to use when generating option
     * values when each `option` is an object.
     * @type {String}
     */
    index: {
      type: String,
      default: null
    },

    /**
     * Callback to generate the label text. If {option}
     * is an object, returns option[this.label] by default.
     *
     * Label text is used for filtering comparison and
     * displaying. If you only need to adjust the
     * display, you should use the `option` and
     * `selected-option` slots.
     *
     * @type {Function}
     * @param  {Object || String} option
     * @return {String}
     */
    getOptionLabel: {
      type: Function,
      default: function _default(option) {
        if (this.index) {
          option = this.findOptionByIndexValue(option);
        }

        if ((typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(option)) === 'object') {
          if (!option.hasOwnProperty(this.label)) {
            return console.warn('[vue-select warn]: Label key "option.' + this.label + '" does not' + (' exist in options object ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(option) + '.\n') + 'http://sagalbot.github.io/vue-select/#ex-labels');
          }
          return option[this.label];
        }
        return option;
      }
    },

    /**
     * An optional callback function that is called each time the selected
     * value(s) change. When integrating with Vuex, use this callback to trigger
     * an action, rather than using :value.sync to retreive the selected value.
     * @type {Function}
     * @param {Object || String} val
     */
    onChange: {
      type: Function,
      default: function _default(val) {
        this.$emit('change', val);
      }
    },

    onInput: {
      type: Function,
      default: function _default(val) {
        this.$emit('input', val);
      }
    },

    /**
     * Select the current value if selectOnTab is enabled
     */
    onTab: {
      type: Function,
      default: function _default() {
        if (this.selectOnTab) {
          this.typeAheadSelect();
        }
      }
    },

    /**
     * Enable/disable creating options from searchInput.
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },

    /**
     * Set the tabindex for the input field.
     * @type {Number}
     */
    tabindex: {
      type: Number,
      default: null
    },

    /**
     * When true, newly created tags will be added to
     * the options list.
     * @type {Boolean}
     */
    pushTags: {
      type: Boolean,
      default: false
    },

    /**
     * When true, existing options will be filtered
     * by the search text. Should not be used in conjunction
     * with taggable.
     * @type {Boolean}
     */
    filterable: {
      type: Boolean,
      default: true
    },

    /**
     * Callback to determine if the provided option should
     * match the current search text. Used to determine
     * if the option should be displayed.
     * @type   {Function}
     * @param  {Object || String} option
     * @param  {String} label
     * @param  {String} search
     * @return {Boolean}
     */
    filterBy: {
      type: Function,
      default: function _default(option, label, search) {
        return (label || '').toLowerCase().indexOf(search.toLowerCase()) > -1;
      }
    },

    /**
     * Callback to filter results when search text
     * is provided. Default implementation loops
     * each option, and returns the result of
     * this.filterBy.
     * @type   {Function}
     * @param  {Array} list of options
     * @param  {String} search text
     * @param  {Object} vSelect instance
     * @return {Boolean}
     */
    filter: {
      'type': Function,
      default: function _default(options, search) {
        var _this = this;

        return options.filter(function (option) {
          var label = _this.getOptionLabel(option);
          if (typeof label === 'number') {
            label = label.toString();
          }
          return _this.filterBy(option, label, search);
        });
      }
    },

    /**
     * User defined function for adding Options
     * @type {Function}
     */
    createOption: {
      type: Function,
      default: function _default(newOption) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(this.mutableOptions[0]) === 'object') {
          newOption = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, this.label, newOption);
        }
        this.$emit('option:created', newOption);
        return newOption;
      }
    },

    /**
     * When false, updating the options will not reset the select value
     * @type {Boolean}
     */
    resetOnOptionsChange: {
      type: Boolean,
      default: false
    },

    /**
     * Disable the dropdown entirely.
     * @type {Boolean}
     */
    noDrop: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the id of the input element.
     * @type {String}
     * @default {null}
     */
    inputId: {
      type: String
    },

    /**
     * Sets RTL support. Accepts 'ltr', 'rtl', 'auto'.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir
     * @type {String}
     * @default 'auto'
     */
    dir: {
      type: String,
      default: 'auto'
    },
    /**
     * When true, hitting the 'tab' key will select the current select value
     * @type {Boolean}
     */
    selectOnTab: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      search: '',
      open: false,
      mutableValue: null,
      mutableOptions: []
    };
  },


  watch: {
    /**
     * When the value prop changes, update
     * the internal mutableValue.
     * @param  {mixed} val
     * @return {void}
     */
    value: function value(val) {
      this.mutableValue = val;
    },


    /**
     * Maybe run the onChange callback.
     * @param  {string|object} val
     * @param  {string|object} old
     * @return {void}
     */
    mutableValue: function mutableValue(val, old) {
      if (this.multiple) {
        this.onChange ? this.onChange(val) : null;
      } else {
        this.onChange && val !== old ? this.onChange(val) : null;
      }
    },


    /**
     * When options change, update
     * the internal mutableOptions.
     * @param  {array} val
     * @return {void}
     */
    options: function options(val) {
      this.mutableOptions = val;
    },


    /**
     * Maybe reset the mutableValue
     * when mutableOptions change.
     * @return {[type]} [description]
     */
    mutableOptions: function mutableOptions() {
      if (!this.taggable && this.resetOnOptionsChange) {
        this.mutableValue = this.multiple ? [] : null;
      }
    },


    /**
     * Always reset the mutableValue when
     * the multiple prop changes.
     * @param  {Boolean} val
     * @return {void}
     */
    multiple: function multiple(val) {
      this.mutableValue = val ? [] : null;
    }
  },

  /**
   * Clone props into mutable values,
   * attach any event listeners.
   */
  created: function created() {
    this.mutableValue = this.value;
    this.mutableOptions = this.options.slice(0);
    this.mutableLoading = this.loading;

    this.$on('option:created', this.maybePushTag);
  },


  methods: {

    /**
     * Select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    select: function select(option) {
      if (this.taggable && !this.optionExists(option)) {
        option = this.createOption(option);
      }
      if (this.index) {
        if (!option.hasOwnProperty(this.index)) {
          return console.warn('[vue-select warn]: Index key "option.' + this.index + '" does not' + (' exist in options object ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(option) + '.'));
        }
        option = option[this.index];
      }
      if (!this.isOptionSelected(option)) {
        if (this.multiple && !this.mutableValue) {
          this.mutableValue = [option];
        } else if (this.multiple) {
          this.mutableValue = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.mutableValue), [option]);
        } else {
          this.mutableValue = option;
        }
      } else {
        if (this.multiple) {
          var index = this.mutableValue.indexOf(option);
          this.mutableValue.splice(index, 1);
        } else {
          this.mutableValue = null;
        }
      }

      this.onInput(this.mutableValue);

      this.onAfterSelect(option);
    },


    /**
     * De-select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    deselect: function deselect(option) {
      var _this2 = this;

      if (this.multiple) {
        var ref = -1;
        this.mutableValue.forEach(function (val) {
          if (val === option || _this2.index && val === option[_this2.index] || (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(val)) === 'object' && val[_this2.label] === option[_this2.label]) {
            ref = val;
          }
        });
        this.mutableValue = this.mutableValue.filter(function (entry) {
          return entry !== ref;
        });
      } else {
        this.mutableValue = null;
      }
      this.onInput(this.mutableValue);
    },


    /**
     * Clears the currently selected value(s)
     * @return {void}
     */
    clearSelection: function clearSelection() {
      this.mutableValue = this.multiple ? [] : null;
      this.onInput(this.mutableValue);
    },


    /**
     * Called from this.select after each selection.
     * @param  {Object|String} option
     * @return {void}
     */
    onAfterSelect: function onAfterSelect(option) {
      if (this.closeOnSelect) {
        this.open = !this.open;
        this.$refs.search.blur();
      }

      if (this.clearSearchOnSelect) {
        this.search = '';
      }
    },


    /**
     * Toggle the visibility of the dropdown menu.
     * @param  {Event} e
     * @return {void}
     */
    toggleDropdown: function toggleDropdown(e) {
      if (e.target === this.$refs.openIndicator || e.target === this.$refs.search || e.target === this.$refs.toggle || e.target.classList.contains('selected-tag') || e.target === this.$el) {
        if (this.open) {
          this.$refs.search.blur(); // dropdown will close on blur
        } else {
          if (!this.disabled) {
            this.open = true;
            this.$refs.search.focus();
          }
        }
      }
    },


    /**
     * Check if the given option is currently selected.
     * @param  {Object|String}  option
     * @return {Boolean}        True when selected | False otherwise
     */
    isOptionSelected: function isOptionSelected(option) {
      var _this3 = this;

      return this.valueAsArray.some(function (value) {
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value)) === 'object') {
          return _this3.optionObjectComparator(value, option);
        }
        return value === option || value === option[_this3.index];
      });
    },


    /**
     * Determine if two option objects are matching.
     *
     * @param value {Object}
     * @param option {Object}
     * @returns {boolean}
     */
    optionObjectComparator: function optionObjectComparator(value, option) {
      if (this.index && value === option[this.index]) {
        return true;
      } else if (value[this.label] === option[this.label] || value[this.label] === option) {
        return true;
      } else if (this.index && value[this.index] === option[this.index]) {
        return true;
      }
      return false;
    },


    /**
     * Finds an option from this.options
     * where option[this.index] matches
     * the passed in value.
     *
     * @param value {Object}
     * @returns {*}
     */
    findOptionByIndexValue: function findOptionByIndexValue(value) {
      var _this4 = this;

      this.options.forEach(function (_option) {
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_option[_this4.index]) === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(value)) {
          value = _option;
        }
      });
      return value;
    },


    /**
     * If there is any text in the search input, remove it.
     * Otherwise, blur the search input to close the dropdown.
     * @return {void}
     */
    onEscape: function onEscape() {
      if (!this.search.length) {
        this.$refs.search.blur();
      } else {
        this.search = '';
      }
    },


    /**
     * Close the dropdown on blur.
     * @emits  {search:blur}
     * @return {void}
     */
    onSearchBlur: function onSearchBlur() {
      if (this.mousedown && !this.searching) {
        this.mousedown = false;
      } else {
        if (this.clearSearchOnBlur) {
          this.search = '';
        }
        this.closeSearchOptions();
        return;
      }
      // Fixed bug where no-options message could not be closed
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },


    /**
     * 'Private' function to close the search options
     * @emits  {search:blur}
     * @returns {void}
     */
    closeSearchOptions: function closeSearchOptions() {
      this.open = false;
      this.$emit('search:blur');
    },


    /**
     * Open the dropdown on focus.
     * @emits  {search:focus}
     * @return {void}
     */
    onSearchFocus: function onSearchFocus() {
      this.open = true;
      this.$emit('search:focus');
    },


    /**
     * Delete the value on Delete keypress when there is no
     * text in the search input, & there's tags to delete
     * @return {this.value}
     */
    maybeDeleteValue: function maybeDeleteValue() {
      if (!this.$refs.search.value.length && this.mutableValue && this.clearable) {
        this.mutableValue = this.multiple ? this.mutableValue.slice(0, -1) : null;
      }
    },


    /**
     * Determine if an option exists
     * within this.mutableOptions array.
     *
     * @param  {Object || String} option
     * @return {boolean}
     */
    optionExists: function optionExists(option) {
      var _this5 = this;

      var exists = false;

      this.mutableOptions.forEach(function (opt) {
        if ((typeof opt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(opt)) === 'object' && opt[_this5.label] === option) {
          exists = true;
        } else if (opt === option) {
          exists = true;
        }
      });

      return exists;
    },


    /**
     * If push-tags is true, push the
     * given option to mutableOptions.
     *
     * @param  {Object || String} option
     * @return {void}
     */
    maybePushTag: function maybePushTag(option) {
      if (this.pushTags) {
        this.mutableOptions.push(option);
      }
    },


    /**
     * Event-Handler to help workaround IE11 (probably fixes 10 as well)
     * firing a `blur` event when clicking
     * the dropdown's scrollbar, causing it
     * to collapse abruptly.
     * @return {void}
     */
    onMousedown: function onMousedown() {
      this.mousedown = true;
    },
    onMouseup: function onMouseup() {
      this.mousedown = false;
    }
  },

  computed: {

    /**
     * Classes to be output on .dropdown
     * @return {Object}
     */
    dropdownClasses: function dropdownClasses() {
      return {
        open: this.dropdownOpen,
        single: !this.multiple,
        searching: this.searching,
        searchable: this.searchable,
        unsearchable: !this.searchable,
        loading: this.mutableLoading,
        selected: !this.isValueEmpty,
        rtl: this.dir === 'rtl', // This can be removed - styling is handled by `dir="rtl"` attribute
        disabled: this.disabled
      };
    },


    /**
     * If search text should clear on blur
     * @return {Boolean} True when single and clearSearchOnSelect
     */
    clearSearchOnBlur: function clearSearchOnBlur() {
      return this.clearSearchOnSelect && !this.multiple;
    },


    /**
     * Return the current state of the
     * search input
     * @return {Boolean} True if non empty value
     */
    searching: function searching() {
      return !!this.search;
    },


    /**
     * Return the current state of the
     * dropdown menu.
     * @return {Boolean} True if open
     */
    dropdownOpen: function dropdownOpen() {
      return this.noDrop ? false : this.open && !this.mutableLoading;
    },


    /**
     * Return the placeholder string if it's set
     * & there is no value selected.
     * @return {String} Placeholder text
     */
    searchPlaceholder: function searchPlaceholder() {
      if (this.isValueEmpty && this.placeholder) {
        return this.placeholder;
      }
    },


    /**
     * The currently displayed options, filtered
     * by the search elements value. If tagging
     * true, the search text will be prepended
     * if it doesn't already exist.
     *
     * @return {array}
     */
    filteredOptions: function filteredOptions() {
      if (!this.filterable && !this.taggable) {
        return this.mutableOptions.slice();
      }
      var options = this.search.length ? this.filter(this.mutableOptions, this.search, this) : this.mutableOptions;
      if (this.taggable && this.search.length && !this.optionExists(this.search)) {
        options.unshift(this.search);
      }
      return options;
    },


    /**
     * Check if there aren't any options selected.
     * @return {Boolean}
     */
    isValueEmpty: function isValueEmpty() {
      if (this.mutableValue) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(this.mutableValue) === 'object') {
          return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.mutableValue).length;
        }
        return !this.valueAsArray.length;
      }

      return true;
    },


    /**
     * Return the current value in array format.
     * @return {Array}
     */
    valueAsArray: function valueAsArray() {
      if (this.multiple && this.mutableValue) {
        return this.mutableValue;
      } else if (this.mutableValue) {
        return [].concat(this.mutableValue);
      }

      return [];
    },


    /**
     * Determines if the clear button should be displayed.
     * @return {Boolean}
     */
    showClearButton: function showClearButton() {
      return !this.multiple && this.clearable && !this.open && this.mutableValue != null;
    }
  }

});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_avatar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_avatar__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_admin_common_mixins_pointerScroll___default.a, __WEBPACK_IMPORTED_MODULE_6__components_admin_common_mixins_typeAheadPointer___default.a, __WEBPACK_IMPORTED_MODULE_7__components_admin_common_mixins_ajax___default.a],

  props: {
    /**
     * Contains the currently selected value. Very similar to a
     * `value` attribute on an <input>. You can listen for changes
     * using 'change' event using v-on
     * @type {Object||String||null}
     */
    value: {
      default: null
    },

    /**
     * An array of strings or objects to be used as dropdown choices.
     * If you are using an array of objects, vue-select will look for
     * a `label` key (ex. [{label: 'This is Foo', value: 'foo'}]). A
     * custom label key can be set with the `label` prop.
     * @type {Array}
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Disable the entire component.
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Can the user clear the selected property.
     * @type {Boolean}
     */
    clearable: {
      type: Boolean,
      default: true
    },

    /**
     * Sets the max-height property on the dropdown list.
     * @deprecated
     * @type {String}
     */
    maxHeight: {
      type: String,
      default: '400px'
    },

    /**
     * Enable/disable filtering the options.
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },

    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * Equivalent to the `placeholder` attribute on an `<input>`.
     * @type {String}
     */
    placeholder: {
      type: String,
      default: ''
    },

    /**
     * Sets a Vue transition property on the `.dropdown-menu`. vue-select
     * does not include CSS for transitions, you'll need to add them yourself.
     * @type {String}
     */
    transition: {
      type: String,
      default: 'fade'
    },

    /**
     * Enables/disables clearing the search text when an option is selected.
     * @type {Boolean}
     */
    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Close a dropdown when an option is chosen. Set to false to keep the dropdown
     * open (useful when combined with multi-select, for example)
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Tells vue-select what key to use when generating option
     * labels when each `option` is an object.
     * @type {String}
     */
    label: {
      type: String,
      default: 'label'
    },

    /**
     * Value of the 'autocomplete' field of the input
     * element.
     * @type {String}
     */
    autocomplete: {
      type: String,
      default: 'off'
    },

    /**
     * Tells vue-select what key to use when generating option
     * values when each `option` is an object.
     * @type {String}
     */
    index: {
      type: String,
      default: null
    },

    /**
     * Callback to generate the label text. If {option}
     * is an object, returns option[this.label] by default.
     *
     * Label text is used for filtering comparison and
     * displaying. If you only need to adjust the
     * display, you should use the `option` and
     * `selected-option` slots.
     *
     * @type {Function}
     * @param  {Object || String} option
     * @return {String}
     */
    getOptionLabel: {
      type: Function,
      default: function _default(option) {
        if (this.index) {
          option = this.findOptionByIndexValue(option);
        }

        if ((typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(option)) === 'object') {
          if (!option.hasOwnProperty(this.label)) {
            return console.warn('[vue-select warn]: Label key "option.' + this.label + '" does not' + (' exist in options object ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(option) + '.\n') + 'http://sagalbot.github.io/vue-select/#ex-labels');
          }
          return option[this.label];
        }
        return option;
      }
    },

    /**
     * An optional callback function that is called each time the selected
     * value(s) change. When integrating with Vuex, use this callback to trigger
     * an action, rather than using :value.sync to retreive the selected value.
     * @type {Function}
     * @param {Object || String} val
     */
    onChange: {
      type: Function,
      default: function _default(val) {
        this.$emit('change', val);
      }
    },

    onInput: {
      type: Function,
      default: function _default(val) {
        this.$emit('input', val);
      }
    },

    /**
     * Select the current value if selectOnTab is enabled
     */
    onTab: {
      type: Function,
      default: function _default() {
        if (this.selectOnTab) {
          this.typeAheadSelect();
        }
      }
    },

    /**
     * Enable/disable creating options from searchInput.
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },

    /**
     * Set the tabindex for the input field.
     * @type {Number}
     */
    tabindex: {
      type: Number,
      default: null
    },

    /**
     * When true, newly created tags will be added to
     * the options list.
     * @type {Boolean}
     */
    pushTags: {
      type: Boolean,
      default: false
    },

    /**
     * When true, existing options will be filtered
     * by the search text. Should not be used in conjunction
     * with taggable.
     * @type {Boolean}
     */
    filterable: {
      type: Boolean,
      default: true
    },

    /**
     * Callback to determine if the provided option should
     * match the current search text. Used to determine
     * if the option should be displayed.
     * @type   {Function}
     * @param  {Object || String} option
     * @param  {String} label
     * @param  {String} search
     * @return {Boolean}
     */
    filterBy: {
      type: Function,
      default: function _default(option, label, search) {
        return (label || '').toLowerCase().indexOf(search.toLowerCase()) > -1;
      }
    },

    /**
     * Callback to filter results when search text
     * is provided. Default implementation loops
     * each option, and returns the result of
     * this.filterBy.
     * @type   {Function}
     * @param  {Array} list of options
     * @param  {String} search text
     * @param  {Object} vSelect instance
     * @return {Boolean}
     */
    filter: {
      "type": Function,
      default: function _default(options, search) {
        var _this = this;

        return options.filter(function (option) {
          var label = _this.getOptionLabel(option);
          if (typeof label === 'number') {
            label = label.toString();
          }
          return _this.filterBy(option, label, search);
        });
      }
    },

    /**
     * User defined function for adding Options
     * @type {Function}
     */
    createOption: {
      type: Function,
      default: function _default(newOption) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(this.mutableOptions[0]) === 'object') {
          newOption = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, this.label, newOption);
        }
        this.$emit('option:created', newOption);
        return newOption;
      }
    },

    /**
     * When false, updating the options will not reset the select value
     * @type {Boolean}
     */
    resetOnOptionsChange: {
      type: Boolean,
      default: false
    },

    /**
     * Disable the dropdown entirely.
     * @type {Boolean}
     */
    noDrop: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the id of the input element.
     * @type {String}
     * @default {null}
     */
    inputId: {
      type: String
    },

    /**
     * Sets RTL support. Accepts 'ltr', 'rtl', 'auto'.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir
     * @type {String}
     * @default 'auto'
     */
    dir: {
      type: String,
      default: 'auto'
    },
    /**
     * When true, hitting the 'tab' key will select the current select value
     * @type {Boolean}
     */
    selectOnTab: {
      type: Boolean,
      default: false
    },
    customActive: {
      type: Boolean,
      default: true
    },
    customType: {
      type: String,
      default: null
    },
    imageBase: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      search: '',
      open: false,
      mutableValue: null,
      mutableOptions: []
    };
  },


  watch: {
    /**
     * When the value prop changes, update
     * the internal mutableValue.
     * @param  {mixed} val
     * @return {void}
     */
    value: function value(val) {
      this.mutableValue = val;
    },


    /**
     * Maybe run the onChange callback.
     * @param  {string|object} val
     * @param  {string|object} old
     * @return {void}
     */
    mutableValue: function mutableValue(val, old) {
      if (this.multiple) {
        this.onChange ? this.onChange(val) : null;
      } else {
        this.onChange && val !== old ? this.onChange(val) : null;
      }
    },


    /**
     * When options change, update
     * the internal mutableOptions.
     * @param  {array} val
     * @return {void}
     */
    options: function options(val) {
      this.mutableOptions = val;
    },


    /**
     * Maybe reset the mutableValue
     * when mutableOptions change.
     * @return {[type]} [description]
     */
    mutableOptions: function mutableOptions() {
      if (!this.taggable && this.resetOnOptionsChange) {
        this.mutableValue = this.multiple ? [] : null;
      }
    },


    /**
     * Always reset the mutableValue when
     * the multiple prop changes.
     * @param  {Boolean} val
     * @return {void}
     */
    multiple: function multiple(val) {
      this.mutableValue = val ? [] : null;
    }
  },

  /**
   * Clone props into mutable values,
   * attach any event listeners.
   */
  created: function created() {
    this.mutableValue = this.value;
    this.mutableOptions = this.options.slice(0);
    this.mutableLoading = this.loading;

    this.$on('option:created', this.maybePushTag);
  },


  methods: {

    /**
     * Select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    select: function select(option) {
      if (!this.isOptionSelected(option)) {
        if (this.taggable && !this.optionExists(option)) {
          option = this.createOption(option);
        }
        if (this.index) {
          if (!option.hasOwnProperty(this.index)) {
            return console.warn('[vue-select warn]: Index key "option.' + this.index + '" does not' + (' exist in options object ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(option) + '.'));
          }
          option = option[this.index];
        }
        if (this.multiple && !this.mutableValue) {
          this.mutableValue = [option];
        } else if (this.multiple) {
          this.mutableValue = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.mutableValue), [option]);
        } else {
          this.mutableValue = option;
        }
        this.onInput(this.mutableValue);
      }

      this.onAfterSelect(option);
    },


    /**
     * De-select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    deselect: function deselect(option) {
      var _this2 = this;

      if (this.multiple) {
        var ref = -1;
        this.mutableValue.forEach(function (val) {
          if (val === option || _this2.index && val === option[_this2.index] || (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(val)) === 'object' && val[_this2.label] === option[_this2.label]) {
            ref = val;
          }
        });
        this.mutableValue = this.mutableValue.filter(function (entry) {
          return entry !== ref;
        });
      } else {
        this.mutableValue = null;
      }
      this.onInput(this.mutableValue);
    },


    /**
     * Clears the currently selected value(s)
     * @return {void}
     */
    clearSelection: function clearSelection() {
      this.mutableValue = this.multiple ? [] : null;
      this.onInput(this.mutableValue);
    },


    /**
     * Called from this.select after each selection.
     * @param  {Object|String} option
     * @return {void}
     */
    onAfterSelect: function onAfterSelect(option) {
      if (this.closeOnSelect) {
        this.open = !this.open;
        this.$refs.search.blur();
      }

      if (this.clearSearchOnSelect) {
        this.search = '';
      }
    },


    /**
     * Toggle the visibility of the dropdown menu.
     * @param  {Event} e
     * @return {void}
     */
    toggleDropdown: function toggleDropdown(e) {
      if (e.target === this.$refs.openIndicator || e.target === this.$refs.search || e.target === this.$refs.toggle || e.target.classList.contains('selected-tag') || e.target === this.$el) {
        if (this.open) {
          this.$refs.search.blur(); // dropdown will close on blur
        } else {
          if (!this.disabled) {
            this.open = true;
            this.$refs.search.focus();
          }
        }
      }
    },


    /**
     * Check if the given option is currently selected.
     * @param  {Object|String}  option
     * @return {Boolean}        True when selected | False otherwise
     */
    isOptionSelected: function isOptionSelected(option) {
      var _this3 = this;

      return this.valueAsArray.some(function (value) {
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value)) === 'object') {
          return _this3.optionObjectComparator(value, option);
        }
        return value === option || value === option[_this3.index];
      });
    },


    /**
     * Determine if two option objects are matching.
     *
     * @param value {Object}
     * @param option {Object}
     * @returns {boolean}
     */
    optionObjectComparator: function optionObjectComparator(value, option) {
      if (this.index && value === option[this.index]) {
        return true;
      } else if (value[this.label] === option[this.label] || value[this.label] === option) {
        return true;
      } else if (this.index && value[this.index] === option[this.index]) {
        return true;
      }
      return false;
    },


    /**
     * Finds an option from this.options
     * where option[this.index] matches
     * the passed in value.
     *
     * @param value {Object}
     * @returns {*}
     */
    findOptionByIndexValue: function findOptionByIndexValue(value) {
      var _this4 = this;

      this.options.forEach(function (_option) {
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_option[_this4.index]) === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(value)) {
          value = _option;
        }
      });
      return value;
    },


    /**
     * If there is any text in the search input, remove it.
     * Otherwise, blur the search input to close the dropdown.
     * @return {void}
     */
    onEscape: function onEscape() {
      if (!this.search.length) {
        this.$refs.search.blur();
      } else {
        this.search = '';
      }
    },


    /**
     * Close the dropdown on blur.
     * @emits  {search:blur}
     * @return {void}
     */
    onSearchBlur: function onSearchBlur() {
      if (this.mousedown && !this.searching) {
        this.mousedown = false;
      } else {
        if (this.clearSearchOnBlur) {
          this.search = '';
        }
        this.closeSearchOptions();
        return;
      }
      // Fixed bug where no-options message could not be closed
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },


    /**
     * 'Private' function to close the search options
     * @emits  {search:blur}
     * @returns {void}
     */
    closeSearchOptions: function closeSearchOptions() {
      this.open = false;
      this.$emit('search:blur');
    },


    /**
     * Open the dropdown on focus.
     * @emits  {search:focus}
     * @return {void}
     */
    onSearchFocus: function onSearchFocus() {
      this.open = true;
      this.$emit('search:focus');
    },


    /**
     * Delete the value on Delete keypress when there is no
     * text in the search input, & there's tags to delete
     * @return {this.value}
     */
    maybeDeleteValue: function maybeDeleteValue() {
      if (!this.$refs.search.value.length && this.mutableValue && this.clearable) {
        this.mutableValue = this.multiple ? this.mutableValue.slice(0, -1) : null;
      }
    },


    /**
     * Determine if an option exists
     * within this.mutableOptions array.
     *
     * @param  {Object || String} option
     * @return {boolean}
     */
    optionExists: function optionExists(option) {
      var _this5 = this;

      var exists = false;

      this.mutableOptions.forEach(function (opt) {
        if ((typeof opt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(opt)) === 'object' && opt[_this5.label] === option) {
          exists = true;
        } else if (opt === option) {
          exists = true;
        }
      });

      return exists;
    },


    /**
     * If push-tags is true, push the
     * given option to mutableOptions.
     *
     * @param  {Object || String} option
     * @return {void}
     */
    maybePushTag: function maybePushTag(option) {
      if (this.pushTags) {
        this.mutableOptions.push(option);
      }
    },


    /**
     * Event-Handler to help workaround IE11 (probably fixes 10 as well)
     * firing a `blur` event when clicking
     * the dropdown's scrollbar, causing it
     * to collapse abruptly.
     * @return {void}
     */
    onMousedown: function onMousedown() {
      this.mousedown = true;
    },
    onMouseup: function onMouseup() {
      this.mousedown = false;
    }
  },

  computed: {

    /**
     * Classes to be output on .dropdown
     * @return {Object}
     */
    dropdownClasses: function dropdownClasses() {
      return {
        open: this.dropdownOpen,
        single: !this.multiple,
        searching: this.searching,
        searchable: this.searchable,
        unsearchable: !this.searchable,
        loading: this.mutableLoading,
        rtl: this.dir === 'rtl', // This can be removed - styling is handled by `dir="rtl"` attribute
        disabled: this.disabled
      };
    },


    /**
     * If search text should clear on blur
     * @return {Boolean} True when single and clearSearchOnSelect
     */
    clearSearchOnBlur: function clearSearchOnBlur() {
      return this.clearSearchOnSelect && !this.multiple;
    },


    /**
     * Return the current state of the
     * search input
     * @return {Boolean} True if non empty value
     */
    searching: function searching() {
      return !!this.search;
    },


    /**
     * Return the current state of the
     * dropdown menu.
     * @return {Boolean} True if open
     */
    dropdownOpen: function dropdownOpen() {
      return this.noDrop ? false : this.open && !this.mutableLoading;
    },


    /**
     * Return the placeholder string if it's set
     * & there is no value selected.
     * @return {String} Placeholder text
     */
    searchPlaceholder: function searchPlaceholder() {
      if (this.customActive) {
        return this.placeholder;
      }
      if (this.isValueEmpty && this.placeholder) {
        return this.placeholder;
      }
      // if (this.dropdownOpen && this.placeholder) {
      //   return this.placeholder;
      // }
    },


    /**
     * The currently displayed options, filtered
     * by the search elements value. If tagging
     * true, the search text will be prepended
     * if it doesn't already exist.
     *
     * @return {array}
     */
    filteredOptions: function filteredOptions() {
      if (!this.filterable && !this.taggable) {
        return this.mutableOptions.slice();
      }
      var options = this.search.length ? this.filter(this.mutableOptions, this.search, this) : this.mutableOptions;
      if (this.taggable && this.search.length && !this.optionExists(this.search)) {
        options.unshift(this.search);
      }
      return options;
    },


    /**
     * Check if there aren't any options selected.
     * @return {Boolean}
     */
    isValueEmpty: function isValueEmpty() {
      if (this.mutableValue) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(this.mutableValue) === 'object') {
          return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.mutableValue).length;
        }
        return !this.valueAsArray.length;
      }

      return true;
    },


    /**
     * Return the current value in array format.
     * @return {Array}
     */
    valueAsArray: function valueAsArray() {
      if (this.multiple && this.mutableValue) {
        return this.mutableValue;
      } else if (this.mutableValue) {
        return [].concat(this.mutableValue);
      }

      return [];
    },


    /**
     * Determines if the clear button should be displayed.
     * @return {Boolean}
     */
    showClearButton: function showClearButton() {
      return !this.multiple && this.clearable && !this.open && this.mutableValue != null;
    }
  },

  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_8_vue_avatar___default.a
  }

});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'status',
  props: ['status']
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_common_status__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_common_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_admin_common_status__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'statusbar',
  props: ['status', 'updatedAt'],
  components: {
    status: __WEBPACK_IMPORTED_MODULE_0__components_admin_common_status___default.a
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'homepage',
  computed: {},
  components: {}
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_common_statusbar__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_common_statusbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_admin_common_statusbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'staticpage',
  data: function data() {
    return {
      page: {
        title: '',
        content: {},
        status: 0
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      isNew: true,
      id: null,
      type: 'page',
      updatedAt: null
    };
  },

  methods: {
    submit: function submit() {
      return false;
    },
    preview: function preview() {
      if (this.errors.items.length > 0) return;
      this.page.status = 0;
      this.sendRequest(this.page).then(function (res) {
        window.open('https://google.com', '_blank');
      });
    },
    exit: function exit() {
      alert(321);
    },
    deletePage: function deletePage() {
      alert('Delete');
    },
    saveDraft: function saveDraft() {
      if (this.errors.items.length > 0) return;
      this.page.status = 0;
      this.sendRequest(this.page);
    },
    publish: function publish() {
      if (this.errors.items.length > 0) return;
      this.page.status = 1;
      this.sendRequest(this.page);
    },
    getUrl: function getUrl() {
      if (this.isNew) {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].URLS.page + '/' + this.type;
      }
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].URLS.page + '/' + this.type + '/' + this.id;
    },
    sendRequest: function sendRequest(payload) {
      if (this.isNew) {
        return this.$http.post(this.getUrl(), payload, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].headersAuthSettings);
      }
      return this.$http.post(this.getUrl(), payload, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].headersAuthSettings);
    },
    fetchPage: function fetchPage() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].URLS.page + '/' + this.id, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.page.title = res.body.title;
        _this.page.content.content = res.body.content.content;
        _this.updatedAt = new Date(res.body.updated_at);
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id !== 0 && typeof this.$route.params.id !== 'undefined') {
      this.isNew = false;
      this.id = this.$route.params.id;
      this.fetchPage();
    }
  },

  components: {
    statusbar: __WEBPACK_IMPORTED_MODULE_1__components_admin_common_statusbar___default.a
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sticky__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-todo',
  directives: {
    'sticky': __WEBPACK_IMPORTED_MODULE_2_vue_sticky___default.a
  },
  data: function data() {
    return {
      entity: {
        title: '',
        featuredImage: '',
        altImage: '',
        chapter: null,
        type: null,
        topic: null,
        company: null,
        industry: null,
        location: null,
        size: null,
        notCompany: null,
        notIndustry: null,
        notLocation: null,
        notSize: null,
        content: '',
        ttc: [],
        settings: {
          mandatory: false,
          assessed: false,
          recurrence: null,
          score: 0,
          onBoarding: false
        },
        resources: {
          video: [{
            videoUrl: '',
            videoTranscript: ''
          }],
          document: [{
            name: '',
            resource: null,
            extension: null,
            resourceUrl: '',
            resourceTranscript: ''
          }]
        },
        loading: false
      },
      featuredImage: null,
      articleType: {
        type: null,
        shown: false
      },
      tags: [],
      categories: [],
      thingsToConsiderOptions: [],
      isThumbnailFileUploaded: false,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      articlePreview: {
        isShown: false,
        mainImg: null,
        resources: []
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      isSpecific: null,
      isExcluded: null,
      articleEditBoxActive: true,
      articleRelatedBoxActive: true,
      articleAccessBoxActive: true,
      articleSettingsBoxActive: true,
      articleResourcesBoxActive: true,
      recurrences: [{
        label: 'Doesn’t repeat',
        value: null
      }, {
        label: 'Monthly',
        value: 30
      }, {
        label: 'Quarterly',
        value: 90
      }, {
        label: 'Bi-annually',
        value: 180
      }, {
        label: 'Yearly',
        value: 365
      }, {
        label: 'Custom',
        value: 0
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['types', 'getTagsForSelect', 'getCategoriesForSelect', 'getCompaniesForSelect', 'getContentTypeForSelect', 'getContentChapterForSelect', 'getIndustriesForSelect', 'isAdmin', 'companyLocations', 'companySizes']), {
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    },
    thingsToConsiderOptionsComputed: function thingsToConsiderOptionsComputed() {
      return this.thingsToConsiderOptions;
    }
  }),
  watch: {
    'entity.company': function entityCompany(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'company';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.industry': function entityIndustry(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'industry';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.notCompany': function entityNotCompany(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'company';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.notIndustry': function entityNotIndustry(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'industry';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.type': function entityType(value) {
      this.entity.resources = {
        video: [{
          videoUrl: '',
          videoTranscript: ''
        }],
        document: [{
          name: '',
          resource: null,
          extension: null,
          resourceUrl: '',
          resourceTranscript: ''
        }]
      };
      if (value) {
        this.articleType.shown = true;
        if (value.label === 'Video') {
          this.articleType.type = 'video';
        } else if (value.label === 'Template' || value.label === 'Document') {
          this.articleType.type = 'document';
        }
      } else {
        this.articleType.shown = false;
        this.articleType.type = null;
      }
    },
    'entity.settings.recurrence': function entitySettingsRecurrence(value) {
      if (value && value.label === 'Custom') {
        setTimeout(function () {
          var customInput = document.getElementById('repeats-custom');
          if (customInput) {
            customInput.focus();
            customInput.select();
          }
        }, 200);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['getTypes', 'getChapters', 'getCompanies', 'getCategories', 'getTags', 'setInformationMsg', 'getIndustries', 'getCompanyLocations', 'getCompanySizes']), {
    addVideoRow: function addVideoRow() {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.push({
          videoUrl: '',
          videoTranscript: ''
        });
      } else {
        this.entity.resources.document.push({
          name: '',
          resource: null,
          extension: null,
          resourceUrl: '',
          resourceTranscript: ''
        });
      }
    },
    removeElement: function removeElement(index) {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.splice(index, 1);
      } else {
        this.entity.resources.document.splice(index, 1);
      }
    },
    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    },
    removeResource: function removeResource(index) {
      this.entity.resources.document[index].resource = null;
      this.entity.resources.document[index].extension = null;
      this.entity.resources.document[index].name = '';
    },
    addFormElement: function addFormElement(type) {
      this.addElements[type] += 1;
    },
    onThumbnailFileChange: function onThumbnailFileChange(e) {
      var self = this;
      var input = document.getElementById('uploadThumbnail');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.isThumbnailFileUploaded = true;
        var reader = new FileReader();
        reader.onload = function (e) {
          self.entity.featuredImage = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    onResourceFileChange: function onResourceFileChange(value, i) {
      this.entity.loading = true;
      var self = this;
      var valueTrimmed = value.target.value.replace(/^.*\\/, '');
      var input = document.getElementById('uploadResource_' + i);
      var extension = value.target.value.split('.').pop().toLowerCase();
      var fileNameArray = valueTrimmed.split('.');
      if (this.entity.type.label === 'Template' && ['doc', 'docx', 'xls', 'xlsx', 'pdf'].indexOf(extension) === -1) {
        alert('Only .doc, .docx, .xls, .xlsx or .pdf file extension allowed to add on article template type!');
        this.entity.loading = false;
        return;
      }
      if (this.entity.type.label === 'Document' && extension !== 'pdf') {
        alert('Only .pdf file extension allowed to add on article document type!');
        this.entity.loading = false;
        return;
      }
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            name: fileNameArray[0],
            file: e.target.result,
            extension: extension,
            type: 'task'
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            if (Array.isArray(res.body)) {
              alert(res.body[0] + '. Please try again.');
              return;
            }
            self.entity.resources.document[i].name = valueTrimmed;
            self.entity.resources.document[i].extension = extension;
            self.entity.resources.document[i].resource = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            alert('Error on file upload. Please try again');
            console.log('err', err);
          });
        };
        reader.onloadend = function (evt) {
          self.entity.loading = false;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeThumbnail: function removeThumbnail() {
      var input = document.getElementById('uploadThumbnail');
      input.value = null;
      this.isThumbnailFileUploaded = false;
      this.entity.featuredImage = null;
    },
    publishArticle: function publishArticle(status, redirect) {
      var _this = this;

      this.$validator.validateAll();
      this.entity.loading = true;
      this.$nextTick(function () {
        if (_this.errors.items.length) {
          _this.entity.loading = false;
          return false;
        }
        if (_this.entity.loading === true) {
          _this.entity.loading = false;
          return false;
        }
      });
      var self = this;
      var editor = this.$refs.contentEditor;
      this.entity.content = editor.getContent();
      var formData = {
        title: this.entity.title,
        imageFile: this.entity.featuredImage || '',
        alt: this.entity.altImage,
        content: this.entity.content,
        contentType: this.entity.type.value,
        chapter: this.entity.chapter.value,
        status: status,
        isArticle: 0,
        children: this.entity.ttc,
        tags: this.entity.topic,
        companies: this.entity.company,
        industries: this.entity.industry,
        locations: this.entity.location,
        sizes: this.entity.size,
        notCompanies: this.entity.notCompany,
        notIndustries: this.entity.notIndustry,
        notLocations: this.entity.notLocation,
        notSizes: this.entity.notSize,
        mandatory: this.entity.settings.mandatory,
        onBoarding: this.entity.settings.onBoarding,
        assessed: this.entity.settings.assessed,
        recurrence: this.entity.settings.recurrence && this.entity.settings.recurrence.value !== null ? this.entity.settings.recurrence.value : 0,
        score: this.entity.settings.score || 1
      };
      if (this.articleType.type === 'video') {
        formData.typeValues = [];
        this.entity.resources.video.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.videoUrl,
            textarea: row.videoTranscript
          });
        });
      }
      if (this.articleType.type === 'document') {
        formData.typeValues = [];
        this.entity.resources.document.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.resourceUrl,
            name: row.name,
            textarea: row.resourceTranscript,
            extension: row.extension,
            file: row.resource
          });
        });
      }
      var newWindow = void 0;
      if (redirect) {
        newWindow = window.open('', '_blank');
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content, formData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.infMsgTitle = 'A new task called ' + res.body.title + ' was successfully created.';
        self.infMsgDescription = '';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        if (redirect) {
          var routeName = _this.isAdmin ? 'company-task' : 'task';
          var routeParams = {
            id: res.body.id
          };
          if (_this.isAdmin) {
            routeParams['companyId'] = 2;
          }
          var props = _this.$router.resolve({
            name: routeName,
            params: routeParams
          });
          newWindow.location = props.href;
        }
        self.switchEditPage(res.body.id);
      }).catch(function (err) {
        self.serverValidation.errors = err;
        self.infMsgTitle = 'Error. We were not able to create this task because ';
        self.infMsgTitle += err.body.message.toLowerCase();
        self.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        self.infMsgClass = 'error';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
      });
    },
    switchEditPage: function switchEditPage(id) {
      var props = this.$router.resolve({
        name: 'edit-todo',
        params: { id: id }
      });
      location.href = props.href;
    },
    goToAllArticles: function goToAllArticles() {
      var props = this.$router.resolve({
        name: 'todo-list'
      });
      this.$router.push(props.href);
    },
    getOptionsThingsToConsider: function getOptionsThingsToConsider(search, loading) {
      var _this2 = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=true';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var items = res.body.data.items ? res.body.data.items : [];
        _this2.thingsToConsiderOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    handleScroll: function handleScroll(event) {
      var headerPlaceholder = document.getElementById('headerPlaceholder');
      var header = document.querySelector('.article__header');
      if (!headerPlaceholder || !header) {
        return;
      }
      var rect = headerPlaceholder.getBoundingClientRect();
      var sticky = rect.top;
      if (sticky <= 0) {
        header.classList.add('sticky');
        headerPlaceholder.style.height = header.offsetHeight + 'px';
      } else {
        header.classList.remove('sticky');
        headerPlaceholder.style.height = '';
      }
    }
  }),
  created: function created() {
    document.title = 'Create new task | Clear Assured';
    window.addEventListener('scroll', this.handleScroll);
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  components: {},
  mounted: function mounted() {
    this.getTypes();
    this.getChapters();
    this.getTags();
    this.getCategories();
    this.getCompanies();
    this.getIndustries();
    this.getCompanyLocations();
    this.getCompanySizes();
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sticky__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-todo',
  directives: {
    'sticky': __WEBPACK_IMPORTED_MODULE_2_vue_sticky___default.a
  },
  data: function data() {
    return {
      entity: {
        title: '',
        type: null,
        featuredImage: '',
        altImage: '',
        topic: null,
        chapter: null,
        company: null,
        location: null,
        size: null,
        industry: null,
        notCompany: null,
        notIndustry: null,
        notLocation: null,
        notSize: null,
        content: '',
        ttc: [],
        status: null,
        lastTimeEditedDate: null,
        lastTimeEditedBy: null,
        settings: {
          mandatory: false,
          assessed: false,
          recurrence: null,
          score: 0,
          onBoarding: false
        },
        loading: false,
        resources: {
          video: [{
            videoUrl: '',
            videoTranscript: ''
          }],
          document: [{
            name: '',
            resource: null,
            extension: null,
            resourceUrl: '',
            resourceTranscript: ''
          }]
        }
      },
      featuredImage: null,
      articleType: {
        type: null,
        shown: false
      },
      confOpened: null,
      initialData: {},
      contentLoaded: false,
      articleLog: [],
      tags: [],
      categories: [],
      thingsToConsiderOptions: [],
      isThumbnailFileUploaded: false,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      articlePreview: {
        isShown: false,
        mainImg: null,
        resources: []
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      isSpecific: null,
      isExcluded: null,
      articleEditBoxActive: true,
      articleRelatedBoxActive: true,
      articleAccessBoxActive: true,
      articleSettingsBoxActive: true,
      articleResourcesBoxActive: true,
      articleChangelogBoxActive: true,
      recurrences: [{
        label: 'Doesn’t repeat',
        value: null
      }, {
        label: 'Monthly',
        value: 30
      }, {
        label: 'Quarterly',
        value: 90
      }, {
        label: 'Bi-annually',
        value: 180
      }, {
        label: 'Yearly',
        value: 365
      }, {
        label: 'Custom',
        value: 0
      }],
      recurrenceCustomCanFocus: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getContentChapterForSelect', 'getTagsForSelect', 'getCategoriesForSelect', 'getCompaniesForSelect', 'getIndustriesForSelect', 'getConfData', 'getContentTypeForSelect', 'isAdmin', 'companyLocations', 'companySizes']), {
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    },
    thingsToConsiderOptionsComputed: function thingsToConsiderOptionsComputed() {
      return this.thingsToConsiderOptions;
    }
  }),
  created: function created() {
    this.articleId = this.$route.params.id;
    document.onclick = this.documentClick;
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  watch: {
    'entity.company': function entityCompany(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'company';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.industry': function entityIndustry(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'industry';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.notCompany': function entityNotCompany(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'company';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.notIndustry': function entityNotIndustry(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'industry';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.type': function entityType(value) {
      if (value) {
        this.articleType.shown = true;
        if (value.label === 'Video') {
          this.articleType.type = 'video';
        } else if (value.label === 'Template' || value.label === 'Document') {
          this.articleType.type = 'document';
        }
      } else {
        this.articleType.shown = false;
        this.articleType.type = null;
      }
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteArticleConfirmed();
        if (this.confOpened === 'archive') this.archiveArticleConfirmed();
        this.clearConfAction();
      }
    },
    'entity.settings.recurrence': function entitySettingsRecurrence(value) {
      if (value && value.label === 'Custom' && this.recurrenceCustomCanFocus) {
        setTimeout(function () {
          var customInput = document.getElementById('repeats-custom');
          if (customInput) {
            customInput.focus();
            customInput.select();
          }
        }, 200);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'getChapters', 'getTypes', 'getCompanies', 'getCategories', 'getTags', 'setInformationMsg', 'getIndustries', 'initConfAction', 'authLogout', 'getCompanyLocations', 'getCompanySizes']), {
    addVideoRow: function addVideoRow() {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.push({
          videoUrl: '',
          videoTranscript: ''
        });
      } else {
        this.entity.resources.document.push({
          name: '',
          resource: null,
          extension: null,
          resourceUrl: '',
          resourceTranscript: ''
        });
      }
    },
    removeElement: function removeElement(index) {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.splice(index, 1);
      } else {
        this.entity.resources.document.splice(index, 1);
      }
    },
    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    },
    removeResource: function removeResource(index) {
      this.entity.resources.document[index].resource = null;
      this.entity.resources.document[index].name = '';
      this.entity.resources.document[index].extension = '';
    },
    addFormElement: function addFormElement(type) {
      this.addElements[type] += 1;
    },
    onThumbnailFileChange: function onThumbnailFileChange(e) {
      var self = this;
      var input = document.getElementById('uploadThumbnail');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.isThumbnailFileUploaded = true;
        var reader = new FileReader();
        reader.onload = function (e) {
          self.entity.featuredImage = e.target.result;
          self.featuredImage = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    onResourceFileChange: function onResourceFileChange(value, i) {
      var self = this;
      var valueTrimmed = value.target.value.replace(/^.*\\/, '');
      var extension = value.target.value.split('.').pop().toLowerCase();
      var fileNameArray = valueTrimmed.split('.');
      if (this.entity.type.label === 'Template' && ['doc', 'docx', 'xls', 'xlsx', 'pdf'].indexOf(extension) === -1) {
        alert('Only .doc, .docx, .xls, .xlsx or .pdf file extension allowed to add on article template type!');
        return;
      }
      if (this.entity.type.label === 'Document' && extension !== 'pdf') {
        alert('Only .pdf file extension allowed to add on article document type!');
        return;
      }
      var input = document.getElementById('uploadResource_' + i);
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            name: fileNameArray[0],
            file: e.target.result,
            extension: extension,
            type: 'task'
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            if (Array.isArray(res.body)) {
              alert(res.body[0] + '. Please try again.');
              return;
            }
            self.entity.resources.document[i].name = valueTrimmed;
            self.entity.resources.document[i].extension = extension;
            self.entity.resources.document[i].resource = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            alert('Error on file upload. Please try again');
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeThumbnail: function removeThumbnail() {
      var input = document.getElementById('uploadThumbnail');
      input.value = null;
      this.isThumbnailFileUploaded = false;
      this.entity.featuredImage = null;
    },
    archiveArticle: function archiveArticle() {
      this.confOpened = 'archive';
      this.initConfAction({
        actionName: 'changeArticleStatus',
        userStatus: this.entity.status
      });
    },
    archiveArticleConfirmed: function archiveArticleConfirmed() {
      var _this = this;

      var self = this;
      var articleData = {
        id: this.articleId,
        status: this.entity.status === 1 ? 0 : 1
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content, articleData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        var actionText = res.body.status ? 'Unarchived' : 'Archived';
        _this.infMsgTitle = _this.initialData.title + ' task was successfully ' + actionText + '.';
        if (res.body.status) {
          _this.infMsgDescription = 'All active users belonging to ' + _this.initialData.title + ' will now be able to login.';
        } else {
          _this.infMsgDescription = 'All users belonging to ' + _this.initialData.title + ' will no longer be able to login. However, the company will still appear in the list of companies and all company data will be kept in the database.';
        }
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        self.getArticleData();
      }).catch(function (err) {
        _this.disableAPI = false;
        self.serverValidation.errors = err;
        self.infMsgTitle = 'Error. We can\'t archive this task because ';
        self.infMsgTitle += err.body.message.toLowerCase();
        self.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        self.infMsgClass = 'error';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
      });
      this.getConfData.actionConfirmed = false;
    },
    deleteArticle: function deleteArticle() {
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeArticleById'
      });
    },
    deleteArticleConfirmed: function deleteArticleConfirmed() {
      var _this2 = this;

      if (this.disableAPI) return;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content + '/' + this.articleId, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = _this2.initialData.title + ' article was successfully deleted.';
        _this2.infMsgDescription = 'All users and stored information belonging to ' + _this2.initialData.title + ' were also deleted.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.goToAllArticles();
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We can\'t archive this Resource because ';
        _this2.infMsgTitle += err.body.error.message.toLowerCase();
        _this2.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
      });
      this.getConfData.actionConfirmed = false;
    },
    getArticleData: function getArticleData() {
      var _this3 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content + '/' + this.articleId, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.entity.title = res.body.title;
        _this3.initialData.title = res.body.title;
        if (res.body.image_path) {
          _this3.featuredImage = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverURL + res.body.image_path;
          _this3.isThumbnailFileUploaded = true;
        }
        if (res.body.image_name) {
          _this3.entity.featuredImage = res.body.image_name;
        }
        var editor = _this3.$refs.contentEditor;
        _this3.entity.content = res.body.content ? res.body.content : '';
        editor.setContent(res.body.content);
        _this3.entity.altImage = res.body.alt ? res.body.alt : '';
        _this3.entity.status = res.body.status;
        _this3.entity.lastTimeEditedDate = res.body.updated_at ? res.body.updated_at : null;
        _this3.entity.lastTimeEditedBy = res.body.updated_by ? res.body.updated_by : null;
        _this3.entity.settings.mandatory = res.body.mandatory ? 'true' : 'false';
        _this3.entity.settings.onBoarding = res.body.on_boarding ? 'true' : 'false';
        _this3.entity.settings.assessed = res.body.assessed ? 'true' : 'false';
        _this3.entity.settings.score = res.body.score || 1;
        if (res.body.content_type !== null) {
          _this3.entity.type = null;
          _this3.entity.type = {
            id: res.body.content_type.id,
            label: res.body.content_type.type,
            value: res.body.content_type.id
          };
        }
        if (res.body.chapter !== null) {
          _this3.entity.chapter = null;
          _this3.entity.chapter = {
            id: res.body.chapter.id,
            label: res.body.chapter.name,
            value: res.body.chapter.id
          };
        }
        if (res.body.companies && res.body.companies.length) {
          _this3.entity.company = [];
          res.body.companies.forEach(function (row) {
            _this3.entity.company.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.locations && res.body.locations.length) {
          _this3.entity.location = [];
          res.body.locations.forEach(function (row) {
            _this3.entity.location.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.sizes && res.body.sizes.length) {
          _this3.entity.size = [];
          res.body.sizes.forEach(function (row) {
            _this3.entity.size.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_companies && res.body.not_companies.length) {
          _this3.entity.notCompany = [];
          res.body.not_companies.forEach(function (row) {
            _this3.entity.notCompany.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.tags && res.body.tags.length) {
          _this3.entity.topic = [];
          res.body.tags.forEach(function (row) {
            _this3.entity.topic.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.industries && res.body.industries.length) {
          _this3.entity.industry = [];
          res.body.industries.forEach(function (row) {
            _this3.entity.industry.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_industries && res.body.not_industries.length) {
          _this3.entity.notIndustry = [];
          res.body.not_industries.forEach(function (row) {
            _this3.entity.notIndustry.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_locations && res.body.not_locations.length) {
          _this3.entity.notLocation = [];
          res.body.not_locations.forEach(function (row) {
            _this3.entity.notLocation.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_sizes && res.body.not_sizes.length) {
          _this3.entity.notSize = [];
          res.body.not_sizes.forEach(function (row) {
            _this3.entity.notSize.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.children && res.body.children.length) {
          _this3.entity.ttc = [];
          res.body.children.forEach(function (row) {
            if (row) {
              _this3.entity.ttc.push({
                id: row.id,
                label: row.title,
                value: row.id
              });
            }
          });
        }
        if (res.body.resources && res.body.resources !== null) {
          var resources = JSON.parse(res.body.resources);
          if (res.body.content_type.type === 'Video') {
            _this3.entity.resources.video = [];
            resources.forEach(function (row) {
              _this3.entity.resources.video.push({
                videoUrl: row.link,
                videoTranscript: row.textarea
              });
            });
          } else {
            _this3.entity.resources.document = [];
            resources.forEach(function (row) {
              _this3.entity.resources.document.push({
                name: row.name,
                resource: row.file,
                resourceUrl: row.link,
                resourceTranscript: row.textarea
              });
            });
          }
        }
        var recurrence = void 0;
        if (res.body.recurrence) {
          recurrence = _this3.recurrences.find(function (item) {
            return item.value === res.body.recurrence;
          });
          if (!recurrence) {
            recurrence = _this3.recurrences.find(function (item) {
              return item.value === 0;
            });
            recurrence.value = parseInt(res.body.recurrence, 10);
          }
        } else {
          recurrence = _this3.recurrences.find(function (item) {
            return item.value === null;
          });
        }
        _this3.entity.settings.recurrence = recurrence;
        document.title = 'Edit "' + _this3.entity.title + '" task | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
        _this3.contentLoaded = true;
        var self = _this3;
        setTimeout(function () {
          self.recurrenceCustomCanFocus = true;
        }, 1000);
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this3.$router.resolve({
            name: 'error'
          });
          _this3.$router.push(props.href);
        }
        if (err.status === 401) {
          _this3.authLogout();
        }
      });
    },
    getArticleLogById: function getArticleLogById(id) {
      var _this4 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.articleLog + id, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.articleLog = res.body.items ? res.body.items : null;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    publishArticle: function publishArticle(status, redirect, same) {
      var _this5 = this;

      this.$validator.validateAll();
      this.entity.loading = true;
      this.$nextTick(function () {
        if (_this5.errors.items.length) {
          _this5.entity.loading = false;
          return false;
        }
        if (_this5.entity.loading === true) {
          _this5.entity.loading = false;
          return false;
        }
      });
      var self = this;
      var editor = this.$refs.contentEditor;
      this.entity.content = editor.getContent();
      var formData = {
        id: this.articleId,
        title: this.entity.title,
        imageFile: this.entity.featuredImage || '',
        alt: this.entity.altImage,
        contentType: this.entity.type.value,
        content: this.entity.content,
        status: status,
        isArticle: 0,
        children: this.entity.ttc,
        chapter: this.entity.chapter.value,
        tags: this.entity.topic,
        companies: this.entity.company,
        locations: this.entity.location,
        sizes: this.entity.size,
        industries: this.entity.industry,
        notCompanies: this.entity.notCompany,
        notIndustries: this.entity.notIndustry,
        notLocations: this.entity.notLocation,
        notSizes: this.entity.notSize,
        mandatory: this.entity.settings.mandatory === 'true',
        onBoarding: this.entity.settings.onBoarding === 'true',
        assessed: this.entity.settings.assessed === 'true',
        recurrence: this.entity.settings.recurrence && this.entity.settings.recurrence.value !== null ? this.entity.settings.recurrence.value : 0,
        score: this.entity.settings.score || 1
      };
      if (this.articleType.type === 'video') {
        formData.typeValues = [];
        this.entity.resources.video.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.videoUrl,
            textarea: row.videoTranscript
          });
        });
      }
      if (this.articleType.type === 'document') {
        formData.typeValues = [];
        this.entity.resources.document.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.resourceUrl,
            textarea: row.resourceTranscript,
            extension: row.extension,
            file: row.resource,
            name: row.name
          });
        });
      }
      var newWindow = void 0;
      if (redirect && !same) {
        newWindow = window.open('', '_blank');
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content, formData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.status === 0) {
          self.infMsgTitle = res.body.title + ' article has been saved as draft.';
        } else {
          self.infMsgTitle = res.body.title + ' article has been published.';
        }
        self.infMsgDescription = '';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        if (redirect) {
          if (same) {
            self.switchEditPage(res.body.id);
            self.getArticleData();
          } else {
            var routeName = _this5.isAdmin ? 'company-task' : 'task';
            var routeParams = {
              id: res.body.id
            };
            if (_this5.isAdmin) {
              routeParams['companyId'] = 2;
            }
            var props = _this5.$router.resolve({
              name: routeName,
              params: routeParams
            });
            newWindow.location = props.href;
          }
        } else {
          self.goToAllArticles();
        }
        _this5.entity.loading = false;
      }).catch(function (err) {
        self.serverValidation.errors = err;
        self.infMsgTitle = 'Error. We were not able to edit this task because';
        if (err.body.message) {
          self.infMsgTitle += ' ' + err.body.message.toLowerCase();
        }
        if (err.body.error.exception.length) {
          for (var error in err.body.error.exception) {
            self.infMsgTitle += ' ' + err.body.error.exception[error]['message'].toLowerCase();
          }
        }
        self.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        self.infMsgClass = 'error';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        _this5.entity.loading = false;
      });
    },
    getStatus: function getStatus(st) {
      switch (st) {
        case 0:
          return 'Draft';
        case 1:
          return 'Published';
        case 2:
          return 'Archived';
        default:
          return '';
      }
    },
    lastTimeEdited: function lastTimeEdited(date, user) {
      if (date === null) return;
      var string = 'Last edited ';
      var updatedAt = new Date(date);
      var now = new Date();
      var difference = Math.floor((+now - +updatedAt) / (1000 * 60 * 60));
      if (difference < 1) {
        string += 'less than 1 hour ago';
      } else if (difference >= 1 && difference < 24) {
        string += difference + ' hours ago';
      } else {
        string += this.convertDate(date, '.');
      }
      if (user !== null) {
        string += ' by ' + user.first_name + ' ' + user.last_name;
      }
      return string;
    },
    convertDate: function convertDate(payload, delimiter) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear;
    },
    goToAllArticles: function goToAllArticles() {
      var props = this.$router.resolve({
        name: 'todo-list'
      });
      this.$router.push(props.href);
    },
    switchEditPage: function switchEditPage(id) {
      var props = this.$router.resolve({
        name: 'edit-todo',
        params: { id: id }
      });
      this.$router.push(props.href);
    },
    getOptionsThingsToConsider: function getOptionsThingsToConsider(search, loading) {
      var _this6 = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=true';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var items = res.body.data.items ? res.body.data.items : [];
        _this6.thingsToConsiderOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    handleScroll: function handleScroll(event) {
      var headerPlaceholder = document.getElementById('headerPlaceholder');
      var header = document.querySelector('.article__header');
      if (!headerPlaceholder || !header) {
        return;
      }
      var rect = headerPlaceholder.getBoundingClientRect();
      var sticky = rect.top;
      if (sticky <= 0) {
        header.classList.add('sticky');
        headerPlaceholder.style.height = header.offsetHeight + 'px';
      } else {
        header.classList.remove('sticky');
        headerPlaceholder.style.height = '';
      }
    }
  }),
  components: {},
  mounted: function mounted() {
    this.getChapters();
    this.getTags();
    this.getCategories();
    this.getCompanies();
    this.getIndustries();
    this.getArticleData();
    this.getArticleLogById(this.articleId);
    this.getCompanyLocations();
    this.getCompanySizes();
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'todo',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'articles-list',
  data: function data() {
    return {
      ppt: 15,
      offset: 15,
      articles: [],
      selectedAction: null,
      contentAutoloadInfo: {
        numPages: 1,
        locked: false
      },
      search: '',
      searchByName: '',
      contentType: [],
      tags: [],
      categories: [],
      chapter: [],
      roles: [],
      companies: [],
      industries: [],
      lastEdited: [],
      status: [],
      onBoarding: [],
      datepicker: {
        isShown: false,
        from: null,
        to: null
      },
      statusbar: {
        published: 0,
        archived: 0,
        draft: 0,
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      articleOrderBy: {
        type: 'edited',
        order: false
      },
      editedArticles: [],
      articleTypeList: [],
      articleTagList: [],
      articleCategoryList: [],
      articleChapterList: [],
      // articleRoleList: [],
      articleCompanyList: [],
      articleIndustryList: [],
      articleStatusList: [],
      downloadInProcess: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])(['setInformationMsg']), {
    csvExport: function csvExport() {
      var _this = this;

      this.downloadInProcess = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.content + '/documents/export', __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.downloadInProcess = false;
        var hiddenElement = document.getElementById('dataDownload');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(res.body);
        hiddenElement.download = _this.getDocumentsDownloadName();
        hiddenElement.click();
      }).catch(function (err) {
        _this.downloadInProcess = false;
        console.log(err);
      });
    },
    tableExport: function tableExport(arrData) {
      var csvContent = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(arrData[0]).map(function (item) {
        return '"' + item + '"';
      }).join(',')].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(arrData.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(item).map(function (item) {
          return '"' + item + '"';
        }).join(',');
      }))).join('\n').replace(/(^\[)|(\]$)/gm, '');

      var csvData = new Blob([csvContent], {
        type: 'application/csv;charset=utf-8;'
      });

      var documentName = this.getTableDataDownloadName();

      if (window.navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, documentName);
      } else {
        var csvUrl = URL.createObjectURL(csvData);
        var link = document.getElementById('dataDownload');
        link.setAttribute('href', csvUrl);
        link.setAttribute('download', documentName);
        link.click();
      }
    },
    getDocumentsDownloadName: function getDocumentsDownloadName() {
      var date = new Date();
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      month = months[month - 1];
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + month + fullYear;
      var timeString = toDoubleDigit(hours) + 'h' + toDoubleDigit(minutes) + 'm';
      return 'ContentDocuments' + '-' + dateString + '-' + timeString + '.csv';
    },
    getTableDataDownloadName: function getTableDataDownloadName() {
      var date = new Date();
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      month = months[month - 1];
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + month + fullYear;
      var timeString = toDoubleDigit(hours) + 'h' + toDoubleDigit(minutes) + 'm';
      return 'TTDs' + '-' + dateString + '-' + timeString + '.csv';
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
    },
    changeOrderBy: function changeOrderBy(type, order) {
      this.articleOrderBy = {
        type: type,
        order: this.articleOrderBy !== null ? !this.articleOrderBy.order : order
      };
    },
    editArticle: function editArticle(id) {
      var props = this.$router.resolve({
        name: 'edit-todo',
        params: { id: id }
      });
      location.href = props.href;
    },
    searchByParams: function searchByParams(page, limit) {
      var _this2 = this;

      this.contentAutoloadInfo.curPage = page;
      var body = {
        isArticle: false
      };
      this.lastEdited.forEach(function (item) {
        if (item.from) {
          body.from = item.from;
        }
        if (item.to) {
          body.to = item.to;
        }
      });
      this.$eventHub.$emit('load-end');
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.contentSearch + '?page=' + page + '&limit=' + limit, body, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.data.items.length < true) {
          _this2.$eventHub.$emit('load-end');
          _this2.$eventHub.$emit('load-stop');
        } else {
          _this2.$eventHub.$emit('load-start');
        }
        _this2.contentAutoloadInfo.curPage = res.body.data.current_page_number;
        _this2.contentAutoloadInfo.numPages = Math.ceil(res.body.data.total_count / limit) !== 0 ? Math.ceil(res.body.data.total_count / limit) : 1;
        if (page === 1) {
          _this2.articles = res.body.data.items;
        } else {
          _this2.articles = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this2.articles), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(res.body.data.items));
        }
        var count = res.body.status;
        _this2.statusbar.published = count.Published.count;
        _this2.statusbar.draft = count.Draft.count;
        _this2.statusbar.archived = count.Archived.count;
      }).catch(function () {
        _this2.contentAutoloadInfo.locked = false;
      });
    },
    getStatus: function getStatus(st) {
      switch (st) {
        case 0:
          return 'Draft';
        case 1:
          return 'Published';
        case 2:
          return 'Archived';
        default:
          return '';
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      var _this3 = this;

      if (this.searchByName) {
        this.searchByName = '';
      }
      this.contentType.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.contentType.splice(i, 1);
          return;
        }
      });
      this.categories.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.categories.splice(i, 1);
          return;
        }
      });
      this.chapter.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.chapter.splice(i, 1);
          return;
        }
      });
      this.tags.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.tags.splice(i, 1);
          return;
        }
      });
      this.roles.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.roles.splice(i, 1);
          return;
        }
      });
      this.companies.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.companies.splice(i, 1);
          return;
        }
      });
      this.industries.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.industries.splice(i, 1);
          return;
        }
      });
      this.lastEdited.forEach(function (item, i) {
        if (item.id === null && item.label === filter.label) {
          _this3.lastEdited.splice(i, 1);
          return;
        }
      });
      this.status.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.status.splice(i, 1);
          return;
        }
      });
      this.onBoarding.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.onBoarding.splice(i, 1);
          return;
        }
      });
    },
    removeAllFilters: function removeAllFilters() {
      this.searchByName = '';
      this.contentType = [];
      this.categories = [];
      this.chapter = [];
      this.tags = [];
      this.roles = [];
      this.companies = [];
      this.industries = [];
      this.lastEdited = [];
      this.status = [];
      this.onBoarding = [];
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },

    // articleRoles (roles) {
    //   let string = ''
    //   roles.forEach(role => {
    //     string += role.name + '</br>'
    //   })
    //   return string
    // },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])([]), {
    csvData: function csvData() {
      var dataForExport = this.editedArticles;
      var self = this;
      return dataForExport.map(function (item) {
        var roles = '';
        var companies = '';
        var industries = '';
        for (var i = 0; i < item.roles.length; i++) {
          roles += item.roles[i].name;
          if (i < item.roles.length - 1) {
            roles += '\n';
          }
        }
        for (var _i = 0; _i < item.companies.length; _i++) {
          companies += item.companies[_i].name;
          if (_i < item.companies.length - 1) {
            companies += '\n';
          }
        }
        for (var _i2 = 0; _i2 < item.industries.length; _i2++) {
          industries += item.industries[_i2].name;
          if (_i2 < item.industries.length - 1) {
            industries += '\n';
          }
        }
        return {
          'Id': item.id,
          'Name': item.title,
          'Type': item.content_type.type,
          'Topics': item.tags.length ? item.tags[0].name : 'n/a',
          'Category': item.categories.length ? item.categories[0].title : 'n/a',
          'Access': roles,
          'Company specific': companies,
          'Industry specific': industries,
          'Last edited': self.convertDate(item.updated_at, '.'),
          'Onboarding': item.on_boarding ? 'Yes' : 'No',
          'Status': self.getStatus(item.status)
        };
      });
    },
    selectedFilters: function selectedFilters() {
      var searchByName = [];
      if (this.searchByName) {
        searchByName.push({
          id: null,
          type: 'name',
          label: this.searchByName
        });
      }
      return [].concat(searchByName, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.contentType), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.categories), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.chapter), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.tags), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.roles), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.companies), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.industries), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.lastEdited), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.onBoarding), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.status));
    },
    getContentTypeForSelect: function getContentTypeForSelect() {
      return this.articleTypeList;
    },
    getTagsForSelect: function getTagsForSelect() {
      return this.articleTagList;
    },
    getCategoriesForSelect: function getCategoriesForSelect() {
      return this.articleCategoryList;
    },
    getChaptersForSelect: function getChaptersForSelect() {
      return this.articleChapterList;
    },

    // getRolesForSelect () {
    //   return this.articleRoleList
    // },
    getCompaniesForSelect: function getCompaniesForSelect() {
      return this.articleCompanyList;
    },
    getIndustriesForSelect: function getIndustriesForSelect() {
      return this.articleIndustryList;
    },
    getStatusesForSelect: function getStatusesForSelect() {
      return this.articleStatusList;
    },
    filteredArticles: function filteredArticles() {
      var _this4 = this;

      var result = this.articles;
      result = this.articles.filter(function (article) {
        return (article.id + ' ' + article.title).toLowerCase().indexOf(_this4.searchByName.toLowerCase()) > -1;
      }).filter(function (article) {
        return _this4.contentType.length === 0 || article.content_type && _this4.contentType.find(function (type) {
          return type.value === article.content_type.id;
        });
      }).filter(function (article) {
        return _this4.companies.length === 0 || article.companies.length && _this4.companies.find(function (company) {
          return article.companies.find(function (articleCompany) {
            return articleCompany.id === company.value;
          });
        });
      }).filter(function (article) {
        return _this4.industries.length === 0 || article.industries.length && _this4.industries.find(function (industry) {
          return article.industries.find(function (articleIndustry) {
            return articleIndustry.id === industry.value;
          });
        });
      }).filter(function (article) {
        return _this4.categories.length === 0 || article.categories.length && _this4.categories.find(function (category) {
          return article.categories.find(function (articleCategory) {
            return articleCategory.id === category.value;
          });
        });
      }).filter(function (article) {
        return _this4.chapter.length === 0 || article.chapter && _this4.chapter.find(function (chapter) {
          return chapter.value === article.chapter.id;
        });
      }).filter(function (article) {
        return _this4.tags.length === 0 || article.tags.length && _this4.tags.find(function (tag) {
          return article.tags.find(function (articleTag) {
            return articleTag.id === tag.value;
          });
        });
      }).filter(function (article) {
        return _this4.roles.length === 0 || article.roles.length && _this4.roles.find(function (role) {
          return article.roles.find(function (articleRole) {
            return articleRole.id === role.value;
          });
        });
      }).filter(function (article) {
        return _this4.status.length === 0 || _this4.status.find(function (st) {
          return st.value === article.status;
        });
      }).filter(function (article) {
        return _this4.onBoarding.length === 0 || _this4.onBoarding.find(function (st) {
          return st.value === article.on_boarding;
        });
      });
      if (this.articleOrderBy !== null) {
        var ascDesc = this.articleOrderBy.order ? 1 : -1;
        return result.sort(function (a, b) {
          return ascDesc * (new Date(a.updated_at) - new Date(b.updated_at));
        });
      } else {
        return result;
      }
    }
  }),
  watch: {
    filteredArticles: function filteredArticles() {
      var _this5 = this;

      this.offset = this.ppt;
      var editedArticles = [];
      this.articleTypeList = [];
      this.articleTagList = [];
      this.articleCategoryList = [];
      this.articleChapterList = [];
      // this.articleRoleList = []
      this.articleCompanyList = [];
      this.articleIndustryList = [];
      this.articleStatusList = [];
      this.offset = this.ppt;
      this.filteredArticles.forEach(function (article) {
        if (article.content_type) {
          var _index = _this5.articleTypeList.findIndex(function (x) {
            return x.value === article.content_type.id;
          });
          if (_index === -1) {
            _this5.articleTypeList.push({
              label: article.content_type.type,
              value: article.content_type.id
            });
          }
        }
        if (article.tags.length) {
          article.tags.forEach(function (tag) {
            var index = _this5.articleTagList.findIndex(function (x) {
              return x.value === tag.id;
            });
            if (index === -1) {
              _this5.articleTagList.push({
                label: tag.name,
                value: tag.id
              });
            }
          });
        }
        if (article.categories.length) {
          article.categories.forEach(function (category) {
            var index = _this5.articleCategoryList.findIndex(function (x) {
              return x.value === category.id;
            });
            if (index === -1) {
              _this5.articleCategoryList.push({
                label: category.title,
                value: category.id
              });
            }
          });
        }
        if (article.chapter) {
          var _index2 = _this5.articleChapterList.findIndex(function (x) {
            return x.value === article.chapter.id;
          });
          if (_index2 === -1) {
            _this5.articleChapterList.push({
              label: article.chapter.name,
              value: article.chapter.id
            });
          }
        }
        // if (article.roles.length) {
        //   article.roles.forEach((role) => {
        //     let index = this.articleRoleList.findIndex(x => x.value === role.id)
        //     if (index === -1) {
        //       this.articleRoleList.push({
        //         label: role.name,
        //         value: role.id
        //       })
        //     }
        //   })
        // }
        if (article.companies.length) {
          article.companies.forEach(function (company) {
            var index = _this5.articleCompanyList.findIndex(function (x) {
              return x.value === company.id;
            });
            if (index === -1) {
              _this5.articleCompanyList.push({
                label: company.name,
                value: company.id
              });
            }
          });
        }
        if (article.industries.length) {
          article.industries.forEach(function (industry) {
            var index = _this5.articleIndustryList.findIndex(function (x) {
              return x.value === industry.id;
            });
            if (index === -1) {
              _this5.articleIndustryList.push({
                label: industry.name,
                value: industry.id
              });
            }
          });
        }
        var index = _this5.articleStatusList.findIndex(function (x) {
          return x.value === article.status;
        });
        if (index === -1) {
          _this5.articleStatusList.push({
            label: _this5.getStatus(article.status),
            value: article.status
          });
        }
        editedArticles.push(article);
      });
      this.editedArticles = editedArticles;
    }
  },
  mounted: function mounted() {
    this.searchByParams(1, 1000);
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  created: function created() {
    document.title = 'All Tasks | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },

  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default.a
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header',
  data: function data() {
    return {
      menuShown: null,
      accessibilityOpen: false,
      notifications: [],
      accessibilityLinks: false,
      unreadNotifications: null,
      sponsors: [],
      impersonate: [],
      hideConsent: false,
      activeSection: null,
      customLogo: false,
      industriesAlts: '',
      windowWidth: window.innerWidth,
      mobileMenuShown: false,
      confOpened: null,
      accountExpiring: false,
      accountExpiringDate: false,
      hasActiveSubscription: false,
      hideFeedbackButton: false,
      paid: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getFirstName', 'getLastName', 'getUserRole', 'getConsentRequired', 'getImpersonatingUser', 'isAdmin', 'isRegularUser', 'isLightUser', 'getUserRole', 'getConfData', 'profile']), {
    userDashboard: function userDashboard() {
      if (this.isAdmin) {
        return 'admin';
      } else if (this.isRegularUser) {
        return 'user-app';
      } else {
        return 'knowledge-base';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['authLogout', 'getUserRoles', 'resizeText', 'changeVisibilityThem', 'setFontSizeActive', 'setColorPaletteActive', 'initConfAction', 'clearConfAction']), {
    getFullServerPath: function getFullServerPath(fileName) {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverContenImages + fileName;
    },
    getIndustryLogo: function getIndustryLogo() {
      var _this = this;

      var industryId = localStorage.getItem('userIndustry');
      if (!industryId) {
        return;
      }
      var data = {
        id: industryId
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.industry + '/logo', data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.customLogo = res.body.logo;
      }).catch(function (err) {
        console.log(err);
      });
    },
    hideMenuIfOpen: function hideMenuIfOpen() {
      if (this.menuShown) {
        this.menuShown = null;
      }
      if (this.accessibilityOpen) {
        this.accessibilityOpen = false;
      }
      if (this.activeSection) {
        this.activeSection = '';
      }
      if (this.mobileMenuShown) {
        this.mobileMenuShown = false;
      }
    },
    openSubmenu: function openSubmenu(evt, menu) {
      if (menu === 'accessibility') {
        this.accessibilityOpen = !this.accessibilityOpen;
        this.menuShown = null;
        setTimeout(function () {
          var button = document.getElementById('reciteMe');
          if (button) {
            button.focus();
          }
        }, 100);
      } else if (menu === 'mobileMenu') {
        this.mobileMenuShown = !this.mobileMenuShown;
      } else {
        if (this.menuShown === menu) {
          this.menuShown = null;
          return;
        }
        this.menuShown = menu;
        this.activeSection = '';
        this.accessibilityOpen = false;
        var current = evt.target;
        var all = document.querySelectorAll('a');
        var currentIndex = void 0;
        for (var i = 0; i < all.length; i++) {
          if (current.isEqualNode(all[i])) {
            currentIndex = i;
          }
        }
        if (all[currentIndex + 1]) {
          setTimeout(function () {
            all[currentIndex + 1].focus();
          }, 100);
        }
      }
    },
    getNotifications: function getNotifications() {
      var _this2 = this;

      var body = {
        offset: 0,
        limit: 3
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.userNotifications, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.unreadNotifications = res.body.unread > 0 ? res.body.unread : null;
        var notifications = res.body.notifications;
        var temp = void 0;
        _this2.notifications = [];

        var _loop = function _loop(index) {
          var notification = notifications[index];
          var date = _this2.convertDate(notification.createdAt, '.');
          var group = _this2.notifications.find(function (item) {
            return item.date === date;
          });
          temp = {
            type: notification.type,
            id: notification.id,
            contentId: notification.contentId,
            companyId: notification.companyId,
            userFromId: notification.userFromId,
            message: notification.message,
            isRead: notification.isRead
          };
          if (group) {
            group.children.push(temp);
          } else {
            _this2.notifications.push({
              date: date,
              children: [{
                type: notification.type,
                id: notification.id,
                contentId: notification.contentId,
                companyId: notification.companyId,
                userFromId: notification.userFromId,
                isRead: notification.isRead,
                message: notification.message
              }]
            });
          }
        };

        for (var index in notifications) {
          _loop(index);
        }
      }).catch(function (err) {
        if (err.status === 401) {
          _this2.authLogout();
        }
      });
    },
    markNotificationsRead: function markNotificationsRead(ids) {
      var _this3 = this;

      this.unreadNotifications = null;
      var body = [];
      if (ids) {
        body = ids;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.userNotificationsRead, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.getNotifications();
      }).catch(function (err) {
        return console.log(err);
      });
    },
    readNotification: function readNotification(item) {
      this.markNotificationsRead([item.id]);
      // if (item.type === 1) {
      //   if (item.companyId && item.contentId) {
      //     let props = this.$router.resolve({
      //       name: 'edit-company',
      //       params: {
      //         id: item.companyId
      //       },
      //       query: {
      //         ttd: item.contentId
      //       }
      //     })
      //     this.$router.push(props.href)
      //   }
      // } else {
      //   if (item.userFromId) {
      //     let props = this.$router.resolve({
      //       name: 'edit-user',
      //       params: {
      //         id: item.userFromId
      //       }
      //     })
      //     this.$router.push(props.href)
      //   } else {
      //     let props = this.$router.resolve({
      //       name: 'consent-logs'
      //     })
      //     this.$router.push(props.href)
      //   }
      // }
    },
    updateNotifications: function updateNotifications() {
      var self = this;
      self.getNotifications();
      setInterval(function () {
        self.getNotifications();
      }, 60000);
    },
    updateConsent: function updateConsent() {
      var props = this.$router.resolve({
        name: 'give-consent'
      });
      this.$router.push(props.href);
    },
    discardConsent: function discardConsent() {
      var _this4 = this;

      var body = {
        consent: 2
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.updateConsent, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        _this4.$store.commit('changeConsent', 'false');
        var props = _this4.$router.resolve({
          name: 'profile'
        });
        location.href = props.href;
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    removeImpersonate: function removeImpersonate() {
      this.$store.commit('changeImpersonate', false);
    },
    convertDate: function convertDate(payload, delimiter) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear;
    },
    getTodayDate: function getTodayDate(text) {
      var date = new Date();
      var todayText = this.convertDate(date, '.');
      if (text === todayText) {
        return 'TODAY';
      } else {
        return text;
      }
    },
    getCustomUserName: function getCustomUserName() {
      var firstName = this.getFirstName;
      var lastName = this.getLastName;
      var fullName = '';
      if (firstName || lastName) {
        if (firstName) {
          fullName += firstName + ' ';
        }
        if (lastName) {
          fullName += lastName.charAt(0) + '.';
        }
        return fullName;
      } else {
        return 'My profile';
      }
    },
    skipTo: function skipTo(section) {
      var toThis = document.getElementsByClassName(section);
      if (toThis[0]) {
        setTimeout(function () {
          toThis[0].focus();
        }, 0);
      }
    },
    hasSection: function hasSection(section) {
      var toThis = document.getElementsByClassName(section);
      return !!toThis[0];
    },
    isPage: function isPage(pages) {
      var route = this.$route.name;
      var response = false;
      if (pages.indexOf(route) > -1) {
        response = true;
      }
      return response;
    },
    checkAccess: function checkAccess() {
      var _this5 = this;

      var userData = JSON.parse(localStorage.getItem('userData'));
      if (userData) {
        this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
          userData.id = res.body.id;
          userData.userRole = res.body.role.slug;
          userData.company = res.body.company ? res.body.company.id : null;
          // if (res.body.password_changed === 1 && this.$route.name !== 'profile' && this.$route.name !== 'give-consent') {
          //   let props = this.$router.resolve({
          //     name: 'profile'
          //   })
          //   this.$router.push(props.href)
          // }
          if (res.body.consent_status !== 1 && res.body.role.slug === 'ca') {
            userData.userRole = 'sh';
            _this5.$store.commit('authLoginSetUserRole', 'sh');
          }
          if (res.body.consent_status === 1 && res.body.role.slug === 'ca') {
            userData.userRole = 'ca';
            _this5.$store.commit('authLoginSetUserRole', 'ca');
          }
          // if ((res.body.consent_status === 1 && res.body.role.slug === 'ca' && this.getUserRole === 'sh') ||
          //   (res.body.consent_status === 0 && res.body.role.slug === 'ca' && this.getUserRole === 'ca')) {
          //   location.href = location.href
          // }
          if (userData.firstName !== res.body.first_name || userData.lastName !== res.body.last_name) {
            userData.firstName = res.body.first_name;
            userData.lastName = res.body.last_name;
            _this5.$store.commit('changeAuthUserData', userData);
            localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          }
          var userIndustry = res.body.company && res.body.company.industry ? res.body.company.industry.id : 1;
          localStorage.setItem('userIndustry', userIndustry);
          document.getElementById('app').setAttribute('data-industry', userIndustry);
          if (res.body.company) {
            localStorage.setItem('userCompanyName', res.body.company.name);
          }
          if (res.body.company && res.body.company.industry) {
            localStorage.setItem('userIndustryName', res.body.company.industry.name);
          }
          _this5.getSponsors();
          localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          _this5.$store.commit('changeAuthUserData', userData);
          if (userData.company) {
            _this5.$store.commit('authLoginSetCompany', userData.company);
          }
          _this5.impersonate = {
            'role': res.body.role.slug.toUpperCase(),
            'firstName': res.body.first_name,
            'lastName': res.body.last_name
          };
          var route = _this5.$route.name;
          if (route === 'user-app' && res.body.role.slug === 'gm') {
            var props = _this5.$router.resolve({
              name: 'admin'
            });
            _this5.$router.push(props.href);
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    getSponsors: function getSponsors() {
      var _this6 = this;

      var self = this;
      var industryId = localStorage.getItem('userIndustry') ? localStorage.getItem('userIndustry') : 1;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.sponsors + '/' + industryId, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.sponsors = res.body.sponsors;
        _this6.generateIndustriesAlts(self.sponsors);
        if (!self.sponsors.length) {
          _this6.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.sponsors + '/1', {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res2) {
            self.sponsors = res2.body.sponsors;
            _this6.generateIndustriesAlts(self.sponsors);
          }).catch(function (err) {
            console.log(err);
          });
        }
        localStorage.setItem('userIndustry', res.body.industry);
        document.getElementById('app').setAttribute('data-industry', res.body.industry);
      }).catch(function (err) {
        console.log(err);
      });
    },
    generateIndustriesAlts: function generateIndustriesAlts(sponsors) {
      var alts = [];
      for (var i = 0; i < sponsors.length; i++) {
        alts.push(sponsors[i].altImage);
      }
      this.industriesAlts = alts.join(', ');
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 940) {
        deviceName = 'desktop';
      } else if (width > 640) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    activePage: function activePage(path) {
      return location.pathname === path || location.pathname === path + '/';
    },
    activateFeedback: function activateFeedback() {
      this.confOpened = 'send-feedback';
      this.initConfAction({
        actionName: 'sendTasksFeedback',
        includeForm: true,
        customCancelButtonText: 'Cancel',
        customConfirmButtonText: 'Submit'
      });
    },
    submitFeedback: function submitFeedback() {
      var data = {
        text: this.getConfData.feedbackText,
        location: location.href,
        width: window.innerWidth,
        height: window.innerHeight
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.task + '/feedback', data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {}).catch(function () {});
    },
    setupExpiration: function setupExpiration() {
      if (!this.profile || !this.profile.company || !this.profile.company.subscription_end) {
        return;
      }
      if (this.profile.company.is_temporary || this.profile.company.is_demo) {
        this.accountExpiring = false;
        return;
      }
      var commitmentEnd = new Date(this.profile.company.commitment_end).setHours(0, 0);
      var subscriptionEnd = new Date(this.profile.company.subscription_end).setHours(0, 0);
      var diffTime = subscriptionEnd - new Date();
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays <= 30) {
        this.accountExpiring = diffDays;
        this.hasActiveSubscription = commitmentEnd && commitmentEnd > subscriptionEnd;
        this.accountExpiringDate = this.convertDate(this.profile.company.subscription_end, '.');
      }
    },
    maybeHideFeedbackButtonNeeded: function maybeHideFeedbackButtonNeeded() {
      this.hideFeedbackButton = this.$route.name === 'complete-profile' || this.$route.name === 'renew-subscription';
    }
  }),
  mounted: function mounted() {
    var self = this;
    this.getUserRoles();
    setTimeout(function () {
      self.checkAccess();
      self.updateNotifications();
      self.getIndustryLogo();
    }, 2000);
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.hideMenuIfOpen);
    if (this.$route.name === 'give-consent') {
      this.hideConsent = true;
    }
    this.paid = this.$route.query.paid || false;
    this.maybeHideFeedbackButtonNeeded();
  },
  beforeDestroy: function beforeDestroy() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideMenuIfOpen);
  },

  watch: {
    'activeSection': function activeSection(value) {
      if (value && value === 'notifications') {
        this.menuShown = null;
        this.accessibilityOpen = false;
      }
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'send-feedback') {
          this.submitFeedback();
          this.confOpened = null;
          this.clearConfAction();
        }
      }
    },
    'profile': function profile(value) {
      if (value) {
        this.setupExpiration();
      }
    },
    $route: function $route(from, to) {
      this.maybeHideFeedbackButtonNeeded();
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spin__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_in_view_dist_in_view_min__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_in_view_dist_in_view_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_in_view_dist_in_view_min__);
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-spiner',
  data: function data() {
    return {
      isActive: true,
      isStop: true
    };
  },

  methods: {
    insertSpiner: function insertSpiner() {
      var opts = {
        lines: 7,
        length: 20,
        width: 5,
        radius: 16,
        scale: 0.75,
        corners: 1,
        color: '#000',
        opacity: 0.25,
        rotate: 0,
        direction: 1,
        speed: 1,
        trail: 60,
        fps: 20,
        className: 'spinner',
        shadow: false,
        hwaccel: false
      };
      var target = document.getElementById('spiner');
      new __WEBPACK_IMPORTED_MODULE_0_spin___default.a(opts).spin(target);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.insertSpiner();
    this.$eventHub.$on('load-start', function () {
      _this.isActive = true;
    });
    this.$eventHub.$on('load-end', function () {
      _this.isActive = false;
    });
    this.$eventHub.$on('load-stop', function () {
      _this.isStop = false;
    });
    document.body.addEventListener('scroll', function () {
      if (__WEBPACK_IMPORTED_MODULE_1_in_view_dist_in_view_min___default.a.is(document.getElementById('spiner'))) {
        if (_this.isActive) {
          _this.$eventHub.$emit('in-view');
        }
      }
    });
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'autocomplete-input',
  data: function data() {
    return {
      searchQuery: '',
      isOpen: false,
      page: 1,
      limit: 6,
      moreResults: false,
      highlightedPosition: 0,
      server: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverURL,
      options: [],
      selectedType: 0,
      selectedTags: null,
      isTyping: false,
      query: {},
      lastSearch: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getAccessToken', 'types', 'getContentTypeForSelect', 'getContentTypeIdByTitle', 'tags', 'getTagTitles', 'getTagIdByNames', 'selectedHightCont', 'BlueYelBlue', 'isAdmin']), {
    optionsComputed: function optionsComputed() {
      var _this = this;

      var options = this.options.map(function (option) {
        var cutTitle = void 0;
        var title = option.title.split(' ');
        if (title.length > 8) {
          cutTitle = title.splice(0, 9).join(' ') + '...';
        } else {
          cutTitle = title.join(' ');
        }
        var itemType = option.content_type.type;
        var itemClass = void 0;
        switch (_this.selectedHightCont) {
          case 0:
            itemClass = itemType.toLowerCase().replace(/\s/g, '');
            break;
          case 1:
            itemClass = itemType.toLowerCase().replace(/\s/g, '');
            break;
          case 2:
            itemClass = itemType.toLowerCase().replace(/\s/g, '');
            break;
        }
        return {
          id: option.id,
          title: cutTitle,
          isArticle: option.is_article,
          itemClass: itemClass
        };
      });
      return options;
    },
    startsTyping: function startsTyping() {
      var filters = document.querySelectorAll('.ac-filters');
      if (this.moreResults !== true && filters.length) {
        filters[0].style.marginBottom = 0;
      }
    },
    tokenComputed: function tokenComputed() {
      return localStorage.getItem('token');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getTypes', 'getTags']), {
    onInput: function onInput(value) {
      this.open(value);
      if (value === '') {
        this.close();
        this.selectedType = 0;
      } else {
        if (this.getIsLoggedIn) {
          this.fetchContent();
        }
      }
    },
    clear: function clear() {
      this.searchQuery = '';
    },
    fetchContent: function fetchContent() {
      var _this2 = this;

      // variables
      var queryString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&page=' + this.page;
      var searchQuery = this.searchQuery;
      // END:variables
      if (searchQuery.length) {
        queryString += '&search=' + searchQuery;
        this.query['search'] = searchQuery;
      }
      if (this.selectedType > 0) {
        queryString += '&contentType[0]=' + this.selectedType;
        this.query['content-type'] = this.selectedType;
      }
      if (this.selectedTags) {
        queryString += '&tags[]=' + this.selectedTags;
      }
      this.$http.get('' + queryString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var resData = res.body.data;
        if (!resData.items) {
          _this2.lastSearch = _this2.searchQuery;
        }
        _this2.options = resData.items ? resData.items : [];
        _this2.moreResults = resData.page;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    select: function select(id, title, isArticle) {
      this.close();
      this.clear();
      //      this.$router.push({name: 'content', params: {id: id}})
      if (window._paq) {
        window._paq.push(['trackEvent', 'Search', 'clicked_result', title]);
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'clicked_result',
      //     eventLabel: title,
      //     eventValue: 1,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
      if (isArticle) {
        this.$router.push({ name: 'content', params: { id: id } });
      } else {
        if (this.isAdmin) {
          this.$router.push({
            name: 'company-task',
            params: {
              companyId: 2,
              id: id
            }
          });
        } else {
          this.$router.push({ name: 'task', params: { id: id } });
        }
      }
    },
    open: function open(value) {
      this.isOpen = !!value;
    },
    close: function close() {
      this.isOpen = false;
      this.page = 1;
    },
    selectType: function selectType(val) {
      var _this3 = this;

      if (val) {
        this.selectedType = val.value;
      } else {
        this.selectedType = 0;
      }
      if (window._paq) {
        var filterLabel = this.getContentTypeForSelect.find(function (item) {
          return item.value === _this3.selectedType;
        });
        window._paq.push(['trackEvent', 'Search', 'filter', filterLabel.label]);
      }
      // if (window.ga) {
      //   let filterLabel = this.getContentTypeForSelect.find((item) => item.value === this.selectedType)
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: filterLabel.label,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }

      this.fetchContent();
    },
    selectTags: function selectTags(val) {
      if (val) {
        this.selectedTags = val.value;
      } else {
        this.selectedTags = null;
      }
      this.fetchContent();
    },
    seeMore: function seeMore() {
      this.close();
      this.$router.push({ path: '/search-results', query: this.query });
      if (window._paq) {
        window._paq.push(['trackEvent', 'Search', 'filter', 'see all results']);
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: 'see all results',
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    },
    closeSearchList: function closeSearchList() {
      var searchFor = this.searchQuery;
      var isEmpty = this.options.length === 0;
      setTimeout(function () {
        if (this.isTyping) {
          this.searchStatisticSend(searchFor, isEmpty);
        }
      }, 500);
      this.isTyping = false;
      this.close();
      this.searchQuery = '';
      this.selectedType = 0;
    },
    keyDownPressed: function keyDownPressed(event) {
      var key = event.keyCode || event.charCode;
      if (key === 8 || key === 27 || key === 46) {
        if (this.isTyping && this.options.length === 0) {
          var searchFor = this.lastSearch;
          this.searchStatisticSend(searchFor, true);
        }
        this.isTyping = false;
      } else {
        this.isTyping = true;
      }
    },
    searchLeave: function searchLeave(event) {
      var searchFor = event.target.value;
      if (searchFor !== '') {
        if (this.isTyping) {
          if (this.options.length > 0) {
            this.searchStatisticSend(searchFor, false);
          } else {
            this.searchStatisticSend(searchFor, true);
          }
        }
      }
    },
    searchStatisticSend: function searchStatisticSend(search, empty) {
      var _this4 = this;

      if (this.disableAPI) return;
      var body = {
        request: search,
        isEmpty: empty
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.searchSave, body, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function () {
        _this4.disableAPI = false;
        if (window._paq) {
          window._paq.push(['setCustomDimension', 4, search]);
          window._paq.push(['setCustomUrl', '/search-query/' + search]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
          window._paq.push(['deleteCustomDimension', 4]);
          window._paq.push(['trackEvent', 'Search', 'wrote', search]);
        }
        // if (window.ga) {
        // window.ga('set', 'dimension4', search)
        // window.ga('send', 'pageview', {
        //   page: '/search-query/' + search,
        //   title: search
        // })
        // window.ga('set', 'dimension4', null)

        // window.ga('send', 'pageview', {
        //   eventCategory: 'Search',
        //   eventAction: 'wrote',
        //   eventLabel: search,
        //   eventValue: 1,
        //   page: '/search-query/' + search
        // })
        // }
      }).catch(function () {
        _this4.disableAPI = false;
      });
    },
    closeSearch: function closeSearch(e) {
      var _this5 = this;

      var search = this.$refs.search;
      var target = e.target;
      if (search && search !== target && !search.contains(target)) {
        this.$nextTick(function () {
          _this5.closeSearchList();
        });
      }
    }
  }),
  directives: {
    onClickaway: __WEBPACK_IMPORTED_MODULE_3_vue_clickaway__["directive"]
  },
  beforeDestroy: function beforeDestroy() {
    document.addEventListener('click', this.closeSearch);
  },
  created: function created() {
    this.$eventHub.$on('v-closeSearch', this.closeSearchList);
  },
  mounted: function mounted() {
    this.getTypes();
    this.getTags();
    document.addEventListener('click', this.closeSearch);
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'conf-popup',
  data: function data() {
    return {
      nonMenuNodes: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'confCurAction']), {
    getActionNotifyText: function getActionNotifyText(action, status) {
      var data = [];
      switch (action) {
        case 'removeProfile':
          data['title'] = 'Are you sure you want to delete your profile?';
          data['body'] = 'You will be removed from the system and your access to Clear Assured will be blocked. You can’t undo delete, you will not be able to access the system unless someone creates a new account for you.';
          break;

        case 'removeUserById':
          data['title'] = 'Are you sure you want to delete this user?';
          data['body'] = 'Deleted users are removed from the system and can’t be reinstated. A good alternative to delete is archiving a user.';
          break;

        case 'changeUserStatus':
          if (status === 0) {
            data['title'] = 'Are you sure you want to archive this user?';
            data['body'] = 'Archived users will still appear in your organization, but they will not be able to access the application. You can unarchive a user and re-enable their access at any time.';
          }

          if (status === 1) {
            data['title'] = 'Are you sure you want to re-enable this user?';
            data['body'] = 'This will grant the user access to the application. Viewing rights and privileges depend on their user type (role).';
          }
          break;

        case 'removeCompanyById':
          data['title'] = 'Are you sure you want to delete this company?';
          data['body'] = 'Please note this action will permanently delete the company and all the users associated with it. There will be no possibility to undo this action.';
          break;

        case 'removeIndustryById':
          data['title'] = 'Are you sure you want to delete this industry?';
          data['body'] = 'Please note this action will permanently delete the industry. There will be no possibility to undo this action.';
          break;

        case 'removeArticleById':
          data['title'] = 'Are you sure you want to delete this resource?';
          data['body'] = 'By doing this, the resource will be permanently removed from the server with no possibility to undo.';
          break;

        case 'removeCategoryById':
          data['title'] = 'Are you sure you want to delete this category?';
          data['body'] = 'Please note this action will permanently delete the resource. There will be no possibility to undo this action.';
          break;

        case 'removeChapterById':
          data['title'] = 'Are you sure you want to delete this chapter?';
          data['body'] = 'Please note this action will permanently delete the chapter. There will be no possibility to undo this action.';
          break;

        case 'removePromotionById':
          data['title'] = 'Are you sure you want to delete this promotion?';
          data['body'] = 'Please note this action will permanently delete the promotion. There will be no possibility to undo this action.';
          break;

        case 'removeTagById':
          data['title'] = 'Are you sure you want to delete this topic?';
          data['body'] = 'Please note this action will permanently delete the resource. There will be no possibility to undo this action.';
          break;

        case 'resetStyles':
          data['title'] = 'Are you sure you want to reset industry styles to default?';
          data['body'] = 'Please note this action will permanently remove industry colors and custom logo. There will be no possibility to undo this action.';
          break;

        case 'changeCompanyStatus':
          if (status === 0) {
            data['title'] = 'Are you sure you want to archive this company?';
            data['body'] = 'By doing this, you will keep the company in the database, but access will be blocked for all users associated with it.';
          }

          if (status === 1) {
            data['title'] = 'Are you sure you want to re-enable this company?';
            data['body'] = 'By doing this, all active users associated with it will be granted access to the application.';
          }

          break;

        case 'changeArticleStatus':
          if (status === 1) {
            data['title'] = 'Are you sure you want to archive this resource?';
            data['body'] = 'By doing this, the resource will no longer appear in searches nor will it be visible to non-admin users.';
          }

          if (status === 0) {
            data['title'] = 'Are you sure you want to restore this resource?';
            data['body'] = 'By doing this, the resource will start appearing in search results and it be visible to non-admin users.';
          }

          break;

        case 'changeCompanyUrl':
          data['title'] = 'Are you sure you want to change the company url?';
          data['body'] = 'You should avoid changing the company URL after users have been added to a company. When invited to join, users get a link to their company URL. If you change the URL, they will be redirected to the 404 error page.';
          break;

        case 'noAllowedEmailDomains':
          data['title'] = 'Email address confirmation';
          data['body'] = 'Your company has not defined which email domains it allows users from in Clear Assured. This means you can invite users with any email extension to work in the application. For security reasons we recommend you set up the approved domains in your Company setup.';
          break;

        case 'deleteStatusFile':
          data['title'] = 'Are you sure you want to delete this file?';
          data['body'] = 'The file will no longer be available for download and you will not be able to undo this action.';
          break;

        case 'deleteStatusMessage':
          data['title'] = 'Are you sure you want to cancel this comment?';
          data['body'] = 'It will continue to appear in the list, but it will be hidden and marked as cancelled. You will not be able to undo this action.';
          break;

        case 'deleteStatusFileMessage':
          data['title'] = 'Are you sure you want to cancel this comment and delete all the files attached to it?';
          data['body'] = 'The comment will continue to appear in the list, but it will be hidden and marked as cancelled. The file(s) will no longer be available for download.  You will not be able to undo this action.';
          break;

        case 'impersonateUserById':
          var userData = JSON.parse(localStorage.getItem('userData'));
          var user = '';
          if (userData) {
            user = userData['firstName'] + ' ' + userData['lastName'];
          }
          data['title'] = 'Are you sure you want to perform this action?';
          data['body'] = 'You are about to impersonate ' + this.getConfData.actionId + '. Please remember that your actions will produce results that will be associated with the impersonated user, yet the application logs will show your actions as being done while impersonated by ' + user + '.';
          break;

        case 'resetEmailTemplate':
          data['title'] = 'Are you sure you want to reset this email template to default?';
          data['body'] = 'You can always go back and customise it again, but all changes done prior to the reset will be lost.';
          break;

        case 'editLanding':
          data['title'] = 'Are you sure you want to edit this landing?';
          data['body'] = 'Please be aware that the changes made on this landing will be applied to all company landings from the current industry.';
          break;

        case 'removeRedirectById':
          data['title'] = 'Are you sure you want to delete this redirect?';
          data['body'] = 'Please note this action will permanently delete the redirect. There will be no possibility to undo this action.';
          break;

        case 'sendTasksFeedback':
          data['title'] = 'Send us your feedback';
          data['body'] = 'Please tell us what you think about Clear Assured: is everything working well, would you like to improve something, what do you like best about it and what don’t you like?';
          break;

        case 'resetTaskHistoryById':
          data['title'] = 'Are you sure you want to reset this company’s progress?';
          data['body'] = 'There is no ‘undo’ to this. Once you hit ‘Yes’ it will all be gone. \nPlease be aware that these actions are being logged!';
          break;

        case 'resetTaskMessagesById':
          data['title'] = 'Are you sure you want to reset this company’s tasks conversations?';
          data['body'] = 'There is no ‘undo’ to this. Once you hit ‘Yes’ it will all be gone. Please be aware that these actions are being logged!';
          break;

        case 'suggestTopic':
          data['title'] = 'Suggest a topic';
          data['body'] = 'Please tell us the name of the topic you\'re looking for, what resources should it include and why do you think it would be a good addition to Clear Assured.';
          break;

        case 'disconnectFromBilling':
          data['title'] = 'Are you sure you want to disconnect this company from billing?';
          data['body'] = 'This company has active billing subscriptions in Stripe. Please note this action will permanently delete them too.';
          break;

        case 'disconnectFromBillingError':
          data['title'] = 'Are you sure you want to disconnect this company from billing?';
          data['body'] = this.getConfData.customText || '';
          break;

        case 'disconnectCompanyFromBilling':
          data['title'] = 'Are you sure you want to cancel your subscription?';
          data['body'] = 'If you click yes, your subscription will be cancelled at the end of your commitment period and past that point all the users under this subscription will lose their access to Clear Assured.';
          break;

        default:
          data['title'] = 'Are you sure you want to perform this action?';
          data['body'] = '';
          break;
      }

      return data;
    },
    confirmAction: function confirmAction() {
      this.getConfData.actionConfirmed = true;
      // this.clearConfAction()
    },
    clearAction: function clearAction() {
      var _this = this;

      var h1 = document.getElementsByTagName('H1');
      if (h1.length) {
        h1[0].setAttribute('tabindex', '-1');
        h1[0].focus();
      }
      this.getConfData.showPopup = false;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.getConfData).forEach(function (key) {
        if (key !== 'isShown' && key !== 'style' && key !== 'id') {
          _this.getConfData[key] = null;
        }
      });
    }
  }),
  watch: {
    'getConfData.showPopup': function getConfDataShowPopup(value) {
      if (value === true) {
        setTimeout(function () {
          var alert = document.getElementById('alertPopup');
          if (alert) {
            alert.setAttribute('tabindex', '-1');
            alert.focus();
          }
        }, 500);
      }
      var self = this;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default.a) {
        var popupNodes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('#app, .w1, .wrap-admin, .confirmation-popup, .confirmation-popup-inner, ' + '.confirmation-popup-inner-caption, .confirmation-popup-inner-caption > span, .confirmation-popup-inner-body, ' + '.confirmation-popup-inner-body > span, .confirmation-popup-inner-controll-panel, ' + 'confirmation-popup-inner-controll-panel > button, .confirmation-popup-close'));
        if (value === true) {
          for (var i = 0; i < self.nonMenuNodes.length; i++) {
            var node = self.nonMenuNodes[i];
            if (!popupNodes.includes(node)) {
              node._prevTabindex = node.getAttribute('tabindex');
              node._prevAriaHidden = node.getAttribute('aria-hidden');
              node.setAttribute('tabindex', -1);
              node.setAttribute('aria-hidden', 'true');
              node.style.outline = 'none';
            }
          }
        } else {
          for (var _i = 0; _i < self.nonMenuNodes.length; _i++) {
            var _node = self.nonMenuNodes[_i];
            if (_node._prevTabindex) {
              _node.setAttribute('tabindex', _node._prevTabindex);
              _node._prevTabindex = null;
            } else {
              _node.removeAttribute('tabindex');
            }
            if (_node._prevAriaHidden) {
              _node.setAttribute('aria-hidden', _node._prevAriaHidden);
              _node._prevAriaHidden = null;
            } else {
              _node.removeAttribute('aria-hidden');
            }
            _node.style.outline = null;
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.nonMenuNodes = document.querySelectorAll('body *:not([tabindex="-1"]):not([aria-hidden="true"])' + ':not(.confirmation-popup):not(.confirmation-popup-inner):not(.confirmation-popup-inner-caption)' + ':not(.confirmation-popup-inner-body):not(.confirmation-popup-inner-controll-panel)' + ':not(.confirmation-popup-close)');
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    messages: {
      type: Object,
      default: {
        success: [],
        errors: []
      }
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inform-msg',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['getInformationMsg'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['closeInformationMsg'])),
  watch: {
    'getInformationMsg.isShown': function getInformationMsgIsShown(value) {
      if (value === true) {
        setTimeout(function () {
          var alert = document.getElementById('information-message');
          if (alert) {
            alert.setAttribute('tabindex', '-1');
            alert.focus();
          }
          var element = document.getElementsByTagName('HEADER');
          element[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 500);
      }
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      show: this.modal
    };
  },

  methods: {
    close: function close() {
      //      this.show = false
      this.$router.push('/');
    }
  },
  directives: {
    onClickaway: __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'promotions',
  data: function data() {
    return {
      canShowPromotions: true,
      activePromotions: [],
      promotions: []
    };
  },

  methods: {
    getActivePromotions: function getActivePromotions() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].URLS.promotions + '/active', __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body) {
          _this.activePromotions = res.body;
          _this.filterPromotions();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getImageFullPath: function getImageFullPath(image) {
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].serverURL + '/uploads/images/content/' + image;
    },
    hidePromotion: function hidePromotion(id) {
      localStorage.setItem('hidePromotion-' + id, 'true');
      this.filterPromotions();
    },
    filterPromotions: function filterPromotions() {
      this.promotions = this.activePromotions.filter(function (p) {
        var promotionHidden = localStorage.getItem('hidePromotion-' + p.id);
        return !promotionHidden;
      });
    }
  },
  mounted: function mounted() {
    this.getActivePromotions();
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab',
  props: {
    name: {
      required: true
    },
    alias: {
      required: true
    },
    selected: {
      default: false
    },
    hash: {
      default: true
    }
  },
  data: function data() {
    return {
      isActive: this.hash && this.$route.hash === this.href ? true : this.isActive,
      aliasSlug: this.alias.toLowerCase().replace(/ /g, '-')
    };
  },

  computed: {
    href: function href() {
      return '#' + this.aliasSlug;
    }
  },
  watch: {
    selected: function selected(value) {
      this.isActive = this.hash && this.$route.hash ? this.$route.hash === this.href : value;
    }
  },
  mounted: function mounted() {
    this.isActive = this.hash && this.$route.hash ? this.$route.hash === this.href : this.selected;
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tabs',
  model: {
    prop: 'tabSelected',
    event: 'tab-selected'
  },
  data: function data() {
    return {
      tabs: [],
      tabFocus: Number
    };
  },
  created: function created() {
    this.tabs = this.$children;
  },
  mounted: function mounted() {
    this.tabFocus = this.tabs.findIndex(function (item) {
      return item.isActive === true;
    });
  },

  methods: {
    selectTab: function selectTab(selectedTab, event) {
      if (!selectedTab.hash) {
        event.preventDefault();
      }
      this.tabs.forEach(function (tab) {
        tab.isActive = tab.name === selectedTab.name;
      });
      this.$emit('tab-selected', {
        id: selectedTab.aliasSlug
      });
    },
    focusTab: function focusTab(e) {
      if (e.keyCode === 39 || e.keyCode === 37) {
        var focusedTab = document.getElementById('tab-' + this.tabs[this.tabFocus].aliasSlug);
        focusedTab.setAttribute('tabindex', '-1');
        if (e.keyCode === 39) {
          this.tabFocus++;
          if (this.tabFocus >= this.tabs.length) {
            this.tabFocus = 0;
          }
        } else if (e.keyCode === 37) {
          this.tabFocus--;
          if (this.tabFocus < 0) {
            this.tabFocus = this.tabs.length - 1;
          }
        }
        focusedTab = document.getElementById('tab-' + this.tabs[this.tabFocus].aliasSlug);
        focusedTab.setAttribute('tabindex', '0');
        focusedTab.focus();
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.hash !== from.hash) {
        var activeTab = this.tabs.find(function (item) {
          return item.alias === to.hash.replace('#', '');
        });
        if (activeTab) {
          this.selectTab(activeTab);
        }
      }
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accessibility-section',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole'])),
  methods: {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.post);
      var pageData = {
        slug: 'accessibility-section',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'accessibility-section',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'accessibility'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/accessibility-section', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.post = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.post.title = _this3.metaData.title;
        _this3.post.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/accessibility-section', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    }
  },
  created: function created() {
    this.getLandingPage();
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'activate-account',
  props: ['token'],
  data: function data() {
    return {
      resetInProgress: false,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: ''
      },
      passwordType: 'password',
      retypePasswordType: 'password',
      passwordFocus: false,
      retypePasswordFocus: false,
      formInfo: {
        fos_user_resetting_form: {
          plainPassword: {
            first: '',
            second: ''
          }
        }
      },
      successfullyReset: false,
      isError: false,
      isToken: false,
      loginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        loginInProgress: false,
        isError: false,
        loginErrorMessage: '',
        passwordType: 'password'
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect']), {
    invalidToken: function invalidToken() {
      var _this = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.activateUser + this.$route.params.token).then(function (res) {
        _this.isToken = true;
        if (res.body.landing) {
          localStorage.setItem('landing', res.body.landing);
          _this.$router.push({ name: 'company-landing', params: { id: res.body.landing }, query: { activated: 'true' } });
        } else {
          _this.$router.push({ name: 'login', query: { activated: 'true' } });
        }
      }).catch(function () {
        _this.$router.push('/expired-activation-token');
      });
    },
    sendFormRequest: function sendFormRequest() {
      this.$router.push('/');
    },
    resetPassword: function resetPassword() {
      var _this2 = this;

      this.$validator.validateAll();
      if (this.errors.items.length) {
        this.isError = true;
        return;
      }
      this.resetInProgress = true;
      var token = this.$route.params.token;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.activatePassword + token, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formInfo), {}).then(function (res) {
        _this2.resetInProgress = false;
        _this2.loginForm.email = res.body;
        _this2.loginForm.password = _this2.formInfo.fos_user_resetting_form.plainPassword.second;
        _this2.authenticate();
      }).catch(function (err) {
        _this2.resetInProgress = false;
        _this2.formStatus.success = false;
        _this2.formStatus.title = err.body.error.exception[0].message;
        _this2.formStatus.body = '';
        _this2.formStatus.shown = true;
      });
    },
    showPassword: function showPassword(form) {
      if (form === 'password') {
        this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
      } else {
        this.retypePasswordType = this.retypePasswordType === 'password' ? 'text' : 'password';
      }
    },
    authenticate: function authenticate() {
      var _this3 = this;

      var auth = {
        grant_type: this.loginForm.grantType,
        client_id: this.loginForm.clientId,
        client_secret: this.loginForm.clientSecret,
        username: this.loginForm.email,
        password: this.loginForm.password
      };

      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.login, auth).then(function (res) {
        _this3.isError = false;
        localStorage.setItem('token', res.body.access_token);
        var headers = { headers: { 'Authorization': 'Bearer ' + res.body.access_token } };
        _this3.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, {}, headers).then(function (res) {
          _this3.$store.commit('authLoginSuccess');
          var userData = {
            'id': res.body.id ? res.body.id : '',
            'firstName': res.body.first_name ? res.body.first_name : '',
            'lastName': res.body.last_name ? res.body.last_name : '',
            'userRole': res.body.role.slug,
            'company': res.body.company ? res.body.company.id : null
          };
          if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
            localStorage.setItem('consentHead', 'true');
          }
          localStorage.setItem('consentSeen', res.body.consent_seen);
          localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          localStorage.setItem('cookieFixed', true);
          localStorage.setItem('userIndustry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          document.getElementById('app').setAttribute('data-industry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          if (res.body.company && res.body.company.industry && res.body.company.industry.landing) {
            localStorage.setItem('landing', res.body.company.industry.landing.slug);
          }
          if (res.body.company) {
            localStorage.setItem('userCompanyName', res.body.company.name);
          }
          if (res.body.company && res.body.company.industry) {
            localStorage.setItem('userIndustryName', res.body.company.industry.name);
          }
          _this3.$store.commit('authLoginSetUsername', userData.firstName);
          var props = _this3.$router.resolve({
            name: 'give-consent'
          });
          location.href = props.href;
        }).catch(function (err) {
          if (err.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('userData');
            localStorage.removeItem('consentSeen');
            localStorage.removeItem('consentHead');
            localStorage.removeItem('userIndustryName');
            localStorage.removeItem('userCompanyName');
            _this3.loginForm.loginInProgress = false;
            _this3.loginForm.isError = true;
            _this3.loginForm.loginErrorMessage = 'Your account is inactive. Please contact support.';
          }
        });
      }).catch(function (err) {
        _this3.loginForm.isError = true;
        _this3.loginForm.loginErrorMessage = 'Invalid credentials';
        _this3.loginForm.loginInProgress = false;
        console.log(err);
      });
    }
  }),
  created: function created() {
    document.title = 'Clear Assured – activate your account';
  },
  mounted: function mounted() {
    this.invalidToken();
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cookies',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole'])),
  methods: {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.post);
      var pageData = {
        slug: 'cookies',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'cookies',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'cookies'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/cookies', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.post = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.post.title = _this3.metaData.title;
        _this3.post.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/cookies', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    }
  },
  created: function created() {
    this.getLandingPage();
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit'
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin',
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['setFontSizeActive', 'setColorPaletteActive']), {
    goToPageEdit: function goToPageEdit(page) {
      var props = this.$router.resolve({
        name: page
      });
      this.$router.push(props.href);
    },
    importPage: function importPage(slug) {
      var page = void 0;
      var self = this;
      var input = document.getElementById('importLanding');
      input.addEventListener('change', function () {
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          reader.onload = function (e) {
            page = JSON.parse(e.target.result);
            self.savePage(slug, page);
          };
          reader.readAsText(input.files[0]);
        }
      }, false);
      input.click();
    },
    savePage: function savePage(slug, page) {
      var pageData = {
        title: page.title,
        description: page.description,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(page.body),
        slug: slug
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings);
    },
    exportPage: function exportPage(slug) {
      var body = {
        slug: slug
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/' + slug, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var pageData = {
          title: res.data.title,
          description: res.data.description,
          body: JSON.parse(res.data.body)
        };
        var date = new Date();
        var dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(pageData));
        var dlAnchorElem = document.getElementById('exportLanding');
        dlAnchorElem.setAttribute('href', dataStr);
        dlAnchorElem.setAttribute('download', slug + '_' + (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear() + '.json');
        dlAnchorElem.click();
        console.log(res);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    consentCheck: function consentCheck() {
      var _this = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.consent_status !== 1) {
          var props = _this.$router.resolve({
            name: 'give-consent'
          });
          _this.$router.push(props.href);
        }
      });
    }
  }),
  created: function created() {
    this.consentCheck();
    document.title = 'All landing pages | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'expired-account-token',
  data: function data() {
    return {
      resetInProgress: false,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: ''
      },
      emailFocus: false,
      formInfo: {
        email: ''
      },
      topLoginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        loginInProgress: false,
        isError: false,
        loginErrorMessage: '',
        passwordType: 'password'
      },
      ppp: 5,
      footerEdit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    authenticate: function authenticate(form) {
      var _this = this;

      this.topLoginForm.loginInProgress = true;
      var auth = {
        grant_type: this.topLoginForm.grantType,
        client_id: this.topLoginForm.clientId,
        client_secret: this.topLoginForm.clientSecret,
        username: this.topLoginForm.email,
        password: this.topLoginForm.password
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.login, auth).then(function (res) {
        var headers = { headers: { 'Authorization': 'Bearer ' + res.body.access_token } };
        document.cookie = 'Recite.Persist=; Max-Age=-99999999;';
        localStorage.setItem('token', res.body.access_token);
        _this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, {}, headers).then(function (res) {
          _this.$store.commit('authLoginSuccess');
          var userData = {
            'id': res.body.id ? res.body.id : '',
            'firstName': res.body.first_name ? res.body.first_name : '',
            'lastName': res.body.last_name ? res.body.last_name : '',
            'userRole': res.body.role.slug,
            'company': res.body.company ? res.body.company.id : null
          };
          if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
            localStorage.setItem('consentHead', 'true');
          }
          localStorage.setItem('consentSeen', res.body.consent_seen);
          localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          localStorage.setItem('cookieFixed', true);
          localStorage.setItem('userIndustry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          document.getElementById('app').setAttribute('data-industry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          if (res.body.company) {
            localStorage.setItem('userCompanyName', res.body.company.name);
          }
          if (res.body.company && res.body.company.industry) {
            localStorage.setItem('userIndustryName', res.body.company.industry.name);
          }
          _this.$store.commit('authLoginSetUsername', userData.firstName);
          _this.redirect();
        }).catch(function (err) {
          if (err.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('userData');
            localStorage.removeItem('consentSeen');
            localStorage.removeItem('consentHead');
            localStorage.removeItem('userIndustryName');
            localStorage.removeItem('userCompanyName');
            _this.topLoginForm.isError = true;
            _this.topLoginForm.loginInProgress = false;
            _this.topLoginForm.loginErrorMessage = 'Your account is inactive. Please contact support.';
          }
        });
      }).catch(function () {
        _this.topLoginForm.isError = true;
        _this.topLoginForm.loginInProgress = false;
        _this.topLoginForm.loginErrorMessage = 'Invalid credentials';
      });
    }
  }),
  created: function created() {
    document.title = 'Clear Assured – account token expired';
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgot-password',
  data: function data() {
    return {
      resetInProgress: false,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false,
        submitted: false
      },
      emailFocus: false,
      formInfo: {
        email: ''
      }
    };
  },

  methods: {
    sendFormRequest: function sendFormRequest() {
      var _this = this;

      var self = this;
      this.formStatus.submitting = true;
      this.formStatus.submitted = true;
      this.$validator.validateAll().then(function (valid) {
        if (!valid) {
          _this.formStatus.submitting = false;
          return;
        }
        _this.resetInProgress = true;
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.forgotPassword, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.formInfo)).then(function (res) {
          _this.formStatus.success = true;
          _this.formStatus.title = 'Reset link successfully sent.';
          _this.formStatus.body = 'If your email is in our database, you’ll receive an email shortly with instructions to reset your password.';
          _this.formStatus.shown = true;
          _this.formInfo.email = '';
          _this.resetInProgress = false;
          setTimeout(function () {
            self.errors.clear();
            self.formStatus.submitting = false;
          }, 100);
        }).catch(function (err) {
          _this.resetInProgress = false;
          _this.formStatus.success = false;
          _this.formStatus.title = err.body;
          _this.formStatus.body = '';
          _this.formStatus.shown = true;
          _this.formStatus.submitting = false;
        });
      });
    }
  },
  created: function created() {
    document.title = 'Clear Assured – forgot password';
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'give-consent',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      user: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['initConfAction', 'authLogout', 'clearConfAction']), {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.post);
      var pageData = {
        slug: 'give-consent',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'give-consent',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'give-consent'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/give-consent', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.post = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.post.title = _this3.metaData.title;
        _this3.post.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/give-consent', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    },
    consentSeen: function consentSeen() {
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.seenConsent, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        localStorage.setItem('consentSeen', '1');
      });
    },
    updateConsent: function updateConsent(consent) {
      var _this6 = this;

      var body = {
        consent: consent
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.updateConsent, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        if (consent === 1) {
          _this6.$store.commit('changeConsent', 'false');
        } else {
          _this6.$store.commit('changeConsent', 'true');
        }
        if (_this6.user.company && _this6.user.company.is_temporary) {
          var props = _this6.$router.resolve({
            name: 'complete-profile'
          });
          _this6.$router.push(props.href);
        } else {
          var _props = _this6.$router.resolve({
            name: 'profile',
            query: {
              consent: consent
            }
          });
          _this6.$router.push(_props.href);
        }
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    discardConsent: function discardConsent() {
      this.$store.commit('changeConsent', 'false');
      var props = this.$router.resolve({
        name: 'profile'
      });
      this.$router.push(props.href);
    },
    getProfileData: function getProfileData() {
      var _this7 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.user = res.body;
      });
    },
    deleteMyProfile: function deleteMyProfile() {
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeProfile'
      });
    },
    deleteMyProfileConfirmed: function deleteMyProfileConfirmed() {
      var _this8 = this;

      var id = this.user.id;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.user + '/' + id, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this8.authLogout();
      }).catch(function (err) {
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    }
  }),
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteMyProfileConfirmed();
        this.clearConfAction();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.getProfileData();
    this.consentSeen();
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_common_AuthorizationHeader__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_common_AuthorizationHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_common_AuthorizationHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_common_AppFooter__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_common_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_main_common_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_ConfPopup__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_ConfPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_ConfPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_InfomMsg__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_InfomMsg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_InfomMsg__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['getIsLoggedIn', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['setFontSizeActive', 'setColorPaletteActive']), {
    isLandingPage: function isLandingPage() {
      var route = this.$route.name;
      var response = false;
      var landings = ['about', 'edit-about', 'login', 'edit-login', 'home', 'edit-homepage', 'download-brochure', 'edit-download-brochure', 'contact', 'edit-contact', 'ask-experts', 'edit-ask-expert', 'terms-and-conditions', 'edit-terms-and-conditions', 'privacy-policy', 'edit-privacy-policy', 'accessibility-section', 'edit-accessibility-section', 'cookies', 'edit-cookies', 'company-landing'];
      if (landings.indexOf(route) > -1) {
        response = true;
      }
      return response;
    },
    isCompanyLandingPage: function isCompanyLandingPage() {
      var route = this.$route.name;
      var response = false;
      if (route === 'company-landing') {
        response = true;
      }
      return response;
    },
    checkUserCorrectlyLoggedOut: function checkUserCorrectlyLoggedOut() {
      var token = localStorage.getItem('token');
      var userData = localStorage.getItem('userData');
      if (!token && userData) {
        localStorage.removeItem('userData');
        var props = this.$router.resolve('/');
        this.$router.push(props.href);
      }
    }
  }),
  components: {
    AuthorizationHeader: __WEBPACK_IMPORTED_MODULE_2__components_main_common_AuthorizationHeader___default.a,
    AppHeader: __WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_4__components_main_common_AppFooter___default.a,
    ConfPopup: __WEBPACK_IMPORTED_MODULE_5__components_common_ConfPopup___default.a,
    InformMsg: __WEBPACK_IMPORTED_MODULE_6__components_common_InfomMsg___default.a
  },
  mounted: function mounted() {
    this.checkUserCorrectlyLoggedOut();
    this.setFontSizeActive();
    this.setColorPaletteActive();
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscriptions_plans_PlansList__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscriptions_plans_PlansList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__subscriptions_plans_PlansList__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'homepage',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      headerEdit: false,
      footerEdit: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      headerData: [{
        title: '',
        url: '',
        alt: ''
      }],
      footerData: {
        address: '',
        social: [{
          image: '',
          imageHigh: '',
          altImage: '',
          url: ''
        }],
        logos: [{
          image: '',
          imageHigh: '',
          altImage: '',
          url: ''
        }],
        menu: [{
          title: '',
          url: '',
          alt: ''
        }]
      },
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          subtitle: '',
          description: '',
          points: [{
            text: ''
          }],
          altImage: '',
          image: '',
          button: {
            text: '',
            url: ''
          },
          hideSection: false
        },
        clientSection: {
          title: '',
          description: '',
          logos: [{
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          }],
          hideSection: false
        },
        featuresSection: {
          title: '',
          items: [{
            title: '',
            description: '',
            text: '',
            image: '',
            altImage: '',
            expanded: false
          }],
          hideSection: false
        },
        howItWorksSection: {
          title: '',
          description: '',
          sections: [{
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }],
          hideSection: false
        },
        testimonialsSection: {
          title: '',
          testimonials: [{
            text: '',
            name: '',
            company: '',
            image: '',
            altImage: ''
          }],
          hideSection: false
        },
        contactCTA: {
          title: '',
          text: '',
          buttons: [{
            text: '',
            link: ''
          }],
          hideSection: false
        },
        subscribeSection: {
          title: '',
          description: '',
          formTitle: '',
          hideSection: false
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      slidesReady: false,
      slickOptions: {
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        speed: 300,
        adaptiveHeight: true,
        slidesToShow: 4,
        slidesToScroll: 4
      },
      howItWorksOptionsContent: {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        adaptiveHeight: true,
        draggable: true
      },
      testimonialsOptionsContent: {
        arrows: true,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        accessibility: true,
        draggable: true
      },
      activePopup: null,
      sliderModalShown: false,
      ppp: 5,
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['image', 'link'], [{ 'align': [] }], ['clean']],
      subscribeForm: {
        firstnameFocus: false,
        lastnameFocus: false,
        emailFocus: false,
        firstname: '',
        lastname: '',
        email: ''
      },
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    subscribeMe: function subscribeMe() {
      var _this = this;

      this.formStatus.submitting = true;
      this.$validator.validateAll(['First name', 'Last name', 'Email address']).then(function (result) {
        if (!result) {
          _this.formStatus.submitting = false;
          return;
        }
        var firstname = _this.subscribeForm.firstname;
        var lastname = _this.subscribeForm.lastname;
        var email = _this.subscribeForm.email;
        var body = {
          firstname: firstname,
          lastname: lastname
        };
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.subscribe + '/' + email, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
          _this.formStatus.submitting = false;
          _this.formStatus.shown = true;
          _this.formStatus.success = true;
          _this.formStatus.title = 'You have been successfully subscribed to the Clear Assured newsletter.';
          _this.formStatus.body = 'We will send you news about our latest resources made available on the web app and will keep you updated with our events and webinars. You can always unsubscribe from your email.';
          _this.subscribeForm.firstname = '';
          _this.subscribeForm.lastname = '';
          _this.subscribeForm.email = '';
          setTimeout(function () {
            _this.errors.clear();
          }, 100);
        }).catch(function (err) {
          _this.formStatus.submitting = false;
          _this.serverValidation.errors = err;
          _this.disableAPI = false;
          _this.formStatus.shown = true;
          _this.formStatus.success = false;
          _this.formStatus.title = err.body.message || 'Your subscribe request was not submitted.';
          _this.formStatus.body = 'It looks like there was an error. Please try again or give us a call and we\'ll have our support team help you.';
        });
      });
    },
    updateLandingPage: function updateLandingPage() {
      var _this2 = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: 'homepage',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.getLandingPage();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    updateHeader: function updateHeader() {
      var _this3 = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.headerData);
      var pageData = {
        title: 'Landing header',
        slug: 'landing-header',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    updateFooter: function updateFooter() {
      var _this4 = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.footerData);
      var pageData = {
        title: 'Footer',
        slug: 'footer',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this5 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'homepage',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this5.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this6 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/homepage', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this6.disableAPI = false;
        _this6.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this6.editHistory = true;
      }).catch(function (err) {
        _this6.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    getLandingPage: function getLandingPage(id) {
      var _this7 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.slidesReady = false;
      var body = {
        slug: 'homepage'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/homepage', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        pageData.featuresSection.items = pageData.featuresSection.items.map(function (i) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, i, {
            expanded: false
          });
        });
        _this7.content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this7.content, pageData);
        _this7.metaData.title = res.data.title;
        _this7.metaData.description = res.data.description;
        if (_this7.metaData.title && _this7.metaData.title !== '') {
          document.title = _this7.metaData.title + ' | Clear Assured';
        }
        _this7.addPageMeta('description', [{ name: 'content', value: _this7.metaData.description }]);
        _this7.content.title = _this7.metaData.title;
        _this7.content.description = _this7.metaData.description;
        _this7.slidesReady = true;
        _this7.$nextTick(function () {
          if (_this7.$refs.testimonialsSlick) {
            _this7.$refs.testimonialsSlick.reSlick();
          }
          if (_this7.$refs.howItWorksSlick) {
            _this7.$refs.howItWorksSlick.reSlick();
          }
        });
        if (id) {
          _this7.pageEditSwitch();
        } else {
          _this7.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this7.disableAPI = false;
        console.log('err', err);
      });
    },
    getHeaderData: function getHeaderData() {
      var _this8 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'landing-header'
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/landing-header', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this8.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this8.headerData = pageData;
      }).catch(function (err) {
        _this8.disableAPI = false;
        console.log('err', err);
      });
      this.$nextTick(function () {
        _this8.headerEdit = true;
      });
    },
    getFooterData: function getFooterData() {
      var _this9 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'footer'
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/footer', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this9.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        if (!pageData.logos) {
          pageData.logos = [{
            image: '',
            imageHigh: '',
            altImage: '',
            url: ''
          }];
        }
        _this9.footerData = pageData;
      }).catch(function (err) {
        _this9.disableAPI = false;
        console.log('err', err);
      });
      this.$nextTick(function () {
        _this9.footerEdit = true;
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this10 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this10.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    addSection: function addSection(section) {
      if (section === 'points') {
        this.content.heroSection.points.push({
          text: ''
        });
      }
      if (section === 'features') {
        this.content.featuresSection.items.push({
          title: '',
          description: '',
          text: '',
          image: '',
          altImage: '',
          expanded: false
        });
      }
      if (section === 'testimonials') {
        this.content.testimonialsSection.testimonials.push({
          text: '',
          name: '',
          company: '',
          image: '',
          altImage: ''
        });
      }
      if (section === 'contact-cta-button') {
        this.content.contactCTA.buttons.push({
          text: '',
          link: ''
        });
      }
      if (section === 'header-menu') {
        this.headerData.push({
          title: '',
          url: '',
          alt: ''
        });
      }
      if (section === 'footer-menu') {
        this.footerData.menu.push({
          title: '',
          url: '',
          alt: ''
        });
      }
      if (section === 'footer-social') {
        this.footerData.social.push({
          image: '',
          imageHigh: '',
          altImage: ''
        });
      }
      if (section === 'footer-logos') {
        this.footerData.logos.push({
          image: '',
          imageHigh: '',
          altImage: ''
        });
      }
      if (section === 'logos') {
        this.content.clientSection.logos.push({
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: '',
          url: ''
        });
      }
    },
    removeSection: function removeSection(section, index) {
      section.splice(index, 1);
    },
    expandSection: function expandSection(section, feature) {
      var scroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!feature.hasOwnProperty('expanded') || feature.expanded === undefined || feature.expanded === null) {
        feature.expanded = false;
      }
      feature.expanded = !feature.expanded;
      if (feature.expanded || scroll) {
        this.goToPageSection(section);
      }
    },
    goToPageSection: function goToPageSection(ref) {
      var _this11 = this;

      setTimeout(function () {
        var element = _this11.$refs[ref];
        if (element) {
          var here = element[0] ? element[0] : element;
          here.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 250);
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    getHighImage: function getHighImage(item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image;
    },
    getHighImageAlt: function getHighImageAlt(item) {
      return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage;
    },
    activatePopup: function activatePopup(item) {
      this.activePopup = item;
    },
    closePopup: function closePopup() {
      var _this12 = this;

      this.activePopup = null;
      this.sliderModalShown = false;
      this.slidesReady = true;
      this.headerEdit = false;
      this.footerEdit = false;
      this.pageMetaEdit = false;
      this.$nextTick(function () {
        if (_this12.$refs.testimonialsSlick) {
          _this12.$refs.testimonialsSlick.reSlick();
        }
        if (_this12.$refs.howItWorksSlick) {
          _this12.$refs.howItWorksSlick.reSlick();
        }
      });
    },
    closePopupOnOutsideClick: function closePopupOnOutsideClick(e) {
      var _this13 = this;

      var iconPopup = this.$refs.iconPopup;
      var sliderPopup = this.$refs.sliderPopup;
      var target = e.target;
      if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
        this.activePopup = null;
      }
      if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
        this.switchSliderModal();
        this.slidesReady = true;
        this.$nextTick(function () {
          if (_this13.$refs.testimonialsSlick) {
            _this13.$refs.testimonialsSlick.reSlick();
          }
          if (_this13.$refs.howItWorksSlick) {
            _this13.$refs.howItWorksSlick.reSlick();
          }
        });
      }
    },
    switchSliderModal: function switchSliderModal() {
      this.sliderModalShown = !this.sliderModalShown;
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 768) {
        deviceName = 'desktop';
      } else if (width > 600) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    editHeader: function editHeader() {
      this.getHeaderData();
    },
    discardHeaderEdit: function discardHeaderEdit() {
      this.closePopup();
    },
    editFooter: function editFooter() {
      this.getFooterData();
    },
    discardFooterEdit: function discardFooterEdit() {
      this.closePopup();
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image caption',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '"><i class="image-alt">' + alt + '</i>');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    },
    planSelected: function planSelected(event) {
      if (event.variation) {
        this.$router.push({
          name: 'register',
          query: {
            v: event.variation.id,
            s: event.variation.minSize,
            o: event.variation.orgType.name
          }
        });
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_4_vue_slick__["a" /* default */],
    PlansList: __WEBPACK_IMPORTED_MODULE_5__subscriptions_plans_PlansList___default.a
  },
  watch: {}
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invalid-token',
  data: function data() {
    return {
      resetInProgress: false,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: ''
      },
      emailFocus: false,
      formInfo: {
        email: ''
      }
    };
  },

  methods: {
    sendFormRequest: function sendFormRequest() {
      var _this = this;

      var self = this;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      this.resetInProgress = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.forgotPassword, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formInfo)).then(function (res) {
        _this.formStatus.success = true;
        _this.formStatus.title = 'Reset link successfully sent.';
        _this.formStatus.body = 'If your email is in our database, you’ll receive an email shortly with instructions to reset your password.';
        _this.formStatus.shown = true;
        _this.formInfo.email = '';
        setTimeout(function () {
          self.errors.clear();
        }, 100);
      }).catch(function (err) {
        _this.resetInProgress = false;
        _this.formStatus.success = false;
        _this.formStatus.title = err.body;
        _this.formStatus.body = '';
        _this.formStatus.shown = true;
      });
    }
  },
  created: function created() {
    document.title = 'Clear Assured – forgot password';
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy-policy',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole'])),
  methods: {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.post);
      var pageData = {
        slug: 'privacy-policy',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'privacy-policy',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'privacy-policy'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/privacy-policy', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.post = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.post.title = _this3.metaData.title;
        _this3.post.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/privacy-policy', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    }
  },
  created: function created() {
    this.getLandingPage();
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  computed: {},
  components: {}
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-results',
  data: function data() {
    return {
      ppt: 5,
      noMore: false,
      items: [],
      page: 1,
      moreResults: false,
      server: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverURL,
      selectedType: null,
      selectedTags: null,
      aldItems: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['selectedHightCont', 'getContentTypeForSelect', 'getTagTitles'])),
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.page = 1;
    this.name = to.params.name;
    next();
    this.fetchContent();
  },

  methods: {
    fetchContent: function fetchContent() {
      var _this = this;

      var queryString = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.search + '&page=' + this.page + '&size=' + this.ppt;
      if (this.$route.query.search) {
        queryString += '&search=' + this.$route.query.search;
      }
      if (this.selectedType) {
        queryString += '&contentType[0]=' + this.selectedType;
      }
      if (this.selectedTags) {
        queryString += '&tags[]=' + this.selectedTags;
      }
      this.$eventHub.$emit('load-end');
      this.$http.get('' + queryString, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var resData = res.body.data;
        if (res.body.data.success) {
          _this.$eventHub.$emit('load-end');
          _this.$eventHub.$emit('load-stop');
          _this.noMore = true;
        } else {
          _this.$eventHub.$emit('load-start');
          if (_this.page === 1) {
            _this.items = res.body.data.items;
          } else {
            _this.items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.items), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.body.data.items));
          }
          if (_this.items.length < _this.ppt) {
            _this.noMore = true;
          }
          _this.moreResults = resData.page;
        }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    selectType: function selectType(val) {
      var _this2 = this;

      if (val) {
        this.selectedType = val.value;
      } else {
        this.selectedType = null;
      }
      this.items = [];
      this.page = 1;
      this.noMore = false;
      if (window._paq) {
        var filterLabel = this.getContentTypeForSelect.find(function (item) {
          return item.value === _this2.selectedType;
        });
        window._paq.push(['trackEvent', 'Search', 'filter', filterLabel.label]);
      }
      // if (window.ga) {
      //   let filterLabel = this.getContentTypeForSelect.find((item) => item.value === this.selectedType)
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: filterLabel.label,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
      this.fetchContent();
    },
    selectTags: function selectTags(val) {
      if (val) {
        this.selectedTags = val.value;
      } else {
        this.selectedTags = null;
      }
      this.fetchContent();
    },
    nextPage: function nextPage() {
      this.page = this.page + 1;
      this.fetchContent();
    },
    itemClass: function itemClass(type) {
      return type.toLowerCase().replace(/\s/g, '');
    },
    loadMore: function loadMore() {
      this.nextPage();
      if (window._paq) {
        window._paq.push(['trackEvent', 'Search', 'filter', 'load more']);
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: 'load more',
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    }
  },
  mounted: function mounted() {
    this.page = 1;
    this.fetchContent();
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.query['content-type'] && to.query['content-type'] !== from.query['content-type']) {
        var selected = this.getContentTypeForSelect.find(function (item) {
          return item.value === to.query['content-type'];
        });
        this.selectedType = {
          value: selected.value,
          label: selected.label
        };
      }
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'terms-and-conditions',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole'])),
  methods: {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.post);
      var pageData = {
        slug: 'terms-and-conditions',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'terms-and-conditions',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'terms-and-conditions'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/terms-and-conditions', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.post = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.post.title = _this3.metaData.title;
        _this3.post.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/terms-and-conditions', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    }
  },
  created: function created() {
    this.getLandingPage();
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'terms-of-service',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole'])),
  methods: {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.post);
      var pageData = {
        slug: 'terms-of-service',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'terms-of-service',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'terms-of-service'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/terms-of-service', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.post = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.post.title = _this3.metaData.title;
        _this3.post.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/terms-of-service', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    }
  },
  created: function created() {
    this.getLandingPage();
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-header',
  data: function data() {
    return {
      sponsors: [],
      sponsorsLogo: null,
      footerData: [],
      isGoUpNeeded: false,
      company: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['bgColorSpOp', 'getIsLoggedIn', 'color', 'getUserRole', 'selectedHightCont'])),
  watch: {
    selectedHightCont: function selectedHightCont() {
      this.$forceUpdate();
    }
  },
  methods: {
    tawkTo: function tawkTo(user) {

      if (this.$route.name === 'complete-profile' || this.$route.name === 'renew-subscription') {
        return;
      }

      var body = {
        email: user.email
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.tawkHash, body, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {

        var hash = res.body.hash;

        var s1 = document.createElement('script');
        s1.async = true;
        s1.id = 'tawkScript';
        s1.src = 'https://embed.tawk.to/59b658fec28eca75e461f521/' + (localStorage.selectedHightCont == 1 ? '1btu6qlga' : 'default');
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');

        document.getElementsByTagName("head")[0].appendChild(s1);

        var s2 = document.createElement('script');

        s2.innerHTML = "var Tawk_API=Tawk_API||{};\n" + "var Tawk_LoadStart=new Date();\n" + "Tawk_API.onLoad = function(){\n" + "Tawk_API.setAttributes({\n" + " 'name' : '" + user.first_name + " " + user.last_name + (user.company ? ' (' + user.company.name + ')' : '') + "',\n" + " 'email': '" + user.email + "',\n" + " 'hash' : '" + hash + "'\n" + "}, function (error) {});\n" + "};";

        document.getElementsByTagName("head")[0].appendChild(s2);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getFooterData: function getFooterData() {
      var self = this;
      var body = {
        slug: 'footer'
      };
      var body2 = {};
      var industryId = localStorage.getItem('userIndustry') ? localStorage.getItem('userIndustry') : 1;
      if (this.company !== null) {
        body2.company_url = this.company;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.staticpage + '/footer', body, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (data) {
        var pageData = JSON.parse(data.data.body);
        pageData.address = pageData.address.replace(/\r\n|\r|\n/g, "<br />");
        self.footerData = pageData;
      });
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.sponsorsByLanding + '/' + industryId, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (data) {
        if (data.body.hasLanding === true && data.body.sponsors && data.body.logosLabel) {
          self.sponsors = data.body.sponsors;
          self.sponsorsLogo = data.body.logosLabel;
        } else {
          this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.sponsorsByLanding + '/1', {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (data2) {
            if (data2.body.hasLanding === true) {
              self.sponsors = data2.body.sponsors;
              self.sponsorsLogo = data2.body.logosLabel;
            }
          });
        }
      });
    },
    getUserData: function getUserData() {
      var _this = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.company && res.body.company.sees_chat) {
          _this.tawkTo(res.body);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    getHighImage: function getHighImage(item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image;
    },
    goUpAction: function goUpAction() {
      var element = document.getElementsByTagName('HEADER');
      var h1 = document.getElementsByTagName('H1');
      element[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      if (h1.length) {
        setTimeout(function () {
          h1[0].setAttribute('tabindex', '-1');
          h1[0].focus();
        }, 1000);
      }
    },
    goUpNeeded: function goUpNeeded() {
      var documentHeight = document.documentElement.scrollHeight;
      var windowHeight = window.innerHeight;
      if (documentHeight > windowHeight + 500) {
        this.isGoUpNeeded = true;
      } else {
        this.isGoUpNeeded = false;
      }
    },
    routeName: function routeName(link) {
      return (link || '/').replace(location.origin, '');
    }
  },
  components: {},
  mounted: function mounted() {
    this.getFooterData();
    if (this.getIsLoggedIn) {
      this.getUserData();
    }
  },
  created: function created() {
    if (this.$route.query.company) {
      this.company = this.$route.query.company;
    }
    document.addEventListener('scroll', this.goUpNeeded);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.goUpNeeded);
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'authorization-header',
  data: function data() {
    return {
      isShownCookiesNot: false,
      mobileMenuShown: false,
      windowWidth: window.innerWidth,
      headerData: [{
        title: '',
        url: '',
        alt: ''
      }],
      customLogo: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])([])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])([]), {
    getFullServerPath: function getFullServerPath(fileName) {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverContenImages + fileName;
    },
    getHeaderData: function getHeaderData() {
      var self = this;
      var body = {
        slug: 'landing-header'
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/landing-header', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings)]).then(function (data) {
        self.headerData = JSON.parse(data[0].data.body);
      });
    },
    getIndustryLogo: function getIndustryLogo() {
      var _this = this;

      var industryId = localStorage.getItem('userIndustry');
      if (!industryId) {
        return;
      }
      var data = {
        id: industryId
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.industry + '/logo', data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.customLogo = res.body.logo;
      }).catch(function (err) {
        console.log(err);
      });
    },
    setCookiesPermission: function setCookiesPermission() {
      this.setCookie('useCookies', true, { expires: new Date(2030, 0, 0) });
      this.isShownCookiesNot = false;
    },
    setCookie: function setCookie(name, value, options) {
      options = options || {};
      var expires = options.expires;
      if (typeof expires === 'number' && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }
      value = encodeURIComponent(value);
      var updatedCookie = name + '=' + value;
      for (var propName in options) {
        updatedCookie += ';' + propName;
        var propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += '=' + propValue;
        }
      }
      document.cookie = updatedCookie;
    },
    getCookie: function getCookie(name) {
      var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 1024) {
        deviceName = 'desktop';
      } else if (width > 600) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },

    skipToContent: function skipToContent(event) {
      event.preventDefault();
      var elm = document.getElementsByTagName('h1')[0];
      if (!elm) {
        return;
      }
      elm.setAttribute('tabindex', '-1');
      elm.focus();
      this.scrollTo(document.body, elm, elm.offsetTop - 20, 1500);
    },
    scrollTo: function scrollTo(element, target, to, duration) {
      if (duration <= 0) {
        return;
      }
      var difference = to - element.scrollTop;
      var perTick = difference / duration * 10;
      setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) {
          return;
        }
        this.scrollTo(element, to, duration - 10);
      }, 20);
      target.focus({ preventScroll: true });
    },
    routeName: function routeName(link) {
      return (link || '/').replace(location.origin, '');
    }
  }),
  created: function created() {
    this.isShownCookiesNot = !this.getCookie('useCookies');
  },
  beforeMount: function beforeMount() {
    this.getHeaderData();
    this.getIndustryLogo();
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },

  watch: {}
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //        data: {'name': 'Kol9I', 'name': 'Vas9I'}
    };
  },
  methods: {}
});

/***/ }),
/* 287 */
/***/ (function(module, exports) {

//
//
//
//

/***/ }),
/* 288 */
/***/ (function(module, exports) {

//
//
//
//

/***/ }),
/* 289 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 290 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_chevron_up__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_chevron_down__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'languageArticle',
  data: function data() {
    return {
      lngs: ['English (UK)', 'English (US)'],
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null
      }
    };
  }
});

/***/ }),
/* 292 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'searchInArticles',
  data: function data() {
    return {
      search: ''
    };
  }
});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 295 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 296 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 297 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_newCmsStyle_ComponentArticle_articlesId__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_newCmsStyle_ComponentArticle_articlesId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_newCmsStyle_ComponentArticle_articlesId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_newCmsStyle_ComponentArticle_searchInArticles__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_newCmsStyle_ComponentArticle_searchInArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_newCmsStyle_ComponentArticle_searchInArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_newCmsStyle_ComponentArticle_languageArticles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_newCmsStyle_ComponentArticle_languageArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_newCmsStyle_ComponentArticle_languageArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_newCmsStyle_ComponentArticle_typeArticles__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_newCmsStyle_ComponentArticle_typeArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_newCmsStyle_ComponentArticle_typeArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_newCmsStyle_ComponentArticle_topicsArticles__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_newCmsStyle_ComponentArticle_topicsArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_newCmsStyle_ComponentArticle_topicsArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_newCmsStyle_ComponentArticle_categoryArticles__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_newCmsStyle_ComponentArticle_categoryArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_newCmsStyle_ComponentArticle_categoryArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_newCmsStyle_ComponentArticle_accessArticles__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_newCmsStyle_ComponentArticle_accessArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_newCmsStyle_ComponentArticle_accessArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_newCmsStyle_ComponentArticle_companySpecificArticles__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_newCmsStyle_ComponentArticle_companySpecificArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_newCmsStyle_ComponentArticle_companySpecificArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_newCmsStyle_ComponentArticle_lastEditedArticles__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_newCmsStyle_ComponentArticle_lastEditedArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_newCmsStyle_ComponentArticle_lastEditedArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_newCmsStyle_ComponentArticle_uploaderEditorArticles__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_newCmsStyle_ComponentArticle_uploaderEditorArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_newCmsStyle_ComponentArticle_uploaderEditorArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_newCmsStyle_ComponentArticle_statusArticles__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_newCmsStyle_ComponentArticle_statusArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_newCmsStyle_ComponentArticle_statusArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_newCmsStyle_ComponentArticle_actionsArticles__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_newCmsStyle_ComponentArticle_actionsArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_newCmsStyle_ComponentArticle_actionsArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_plus__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_icons_search__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_awesome_icons_pencil__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_icons_folder__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons_times__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_chevron_up__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_awesome_icons_chevron_down__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_awesome_icons_rotate_right__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* -------------------------------------------------- */












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'articles-list',
  data: function data() {
    return {
      articles: [],
      getArticleListActions: ['Action 1', 'Action 2', 'Action 3'],
      selectedAction: null,
      lngs: ['English (UK)', 'English (US)'],
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      contentAutoloadInfo: {
        //        curPage: 1,
        numPages: 1,
        locked: false
      },
      search: '',
      languages: [],
      contentType: [],
      tags: [],
      categories: [],
      roles: [],
      companies: [],
      lastEdited: [],
      lastEditors: [],
      status: [],
      statusOptions: [],
      lastEditorsOptions: [],
      datepicker: {
        from: null,
        to: null
      },
      statusbar: {
        published: 0,
        archived: 0,
        draft: 0,
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vuex__["mapActions"])(['getTypes', 'getTags', 'getCategories', 'getCompanies', 'getRoles', 'getLngs']), {
    initAction: function initAction(name, payload) {
      var _this = this;

      this.confirmation.action = name;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        _this.confirmation[key] = payload[key];
      });
      this.confirmation.isShown = true;
    },
    clearAction: function clearAction() {
      var _this2 = this;

      this.confirmation.isShown = false;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.confirmation).forEach(function (key) {
        if (key !== 'isShown' && key !== 'style') {
          _this2.confirmation[key] = null;
        }
      });
    },
    confirmActionHandler: function confirmActionHandler() {
      var self = this;
      switch (this.confirmation.action) {
        case 'removeArticle':
          removeArticle(this.confirmation.articleId, this.confirmation.i);
          break;
        case 'changeStatusArticle':
          changeStatusArticle(this.confirmation.articleId, this.confirmation.status, this.confirmation.i);
          break;

      }
      function removeArticle(articleId, i) {
        self.clearAction();
        self.$http.delete(__WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].URLS.content + '/' + articleId, __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].headersAuthSettings).then(function (res) {
          self.clearAction();
          self.articles.splice(i, 1);
          alert('Article has been successfully removed');
        }).catch(function (err) {
          return console.log(err);
        });
      }
      function changeStatusArticle(articleId, status, i) {
        self.clearAction();
        var body = {
          status: status,
          isArticle: true
        };
        self.$http.post(__WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].URLS.changeStatus + '/' + articleId, body, __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].headersAuthSettings).then(function (res) {
          self.clearAction();
          var status = res.body.data.status;
          self.articles[i].status = status;
          // set article count
          var statuses = res.body.statuses;
          self.statusbar.published = statuses.Published.count;
          self.statusbar.draft = statuses.Draft.count;
          self.statusbar.archived = statuses.Archived.count;
          console.log(res);
        }).catch(function (err) {
          return console.log(err);
        });
      }
    },

    // TODO: Change scrool handler make cur page different for different search typeFdelete
    handleScroll: function handleScroll(event) {
      if (!this.articles.length) return;

      if (this.search) {
        this.page = 1;
        this.mainSearch(++this.contentAutoloadInfo.curPage, 20);
      } else {
        this.page = 1;
        this.searchByParams(++this.contentAutoloadInfo.curPage, 20);
      }
    },
    editArticle: function editArticle(id) {
      this.$router.push({ path: '/admin/article/edit/' + id });
    },
    mainSearch: function mainSearch(page, limit) {
      var _this3 = this;

      if (!this.search) {
        this.searchByParams(1, 20);
        return;
      }
      // filter by languages
      var subLanguages = '';
      this.languages.forEach(function (lng, i) {
        subLanguages += '&language[' + i + ']=' + lng.value;
      });
      var subTag = '';
      this.tags.forEach(function (tag, i) {
        subTag += '&tags[' + i + ']=' + tag.value;
      });
      var subCategories = '';
      this.categories.forEach(function (category, i) {
        subCategories += '&categories[' + i + ']=' + category.value;
      });
      // filter by contentType
      var subContentType = '';
      this.contentType.forEach(function (item, i) {
        subContentType += '&contentType[' + i + ']=' + item.value;
      });
      // filter by roles
      var subRole = '';
      this.roles.forEach(function (role, i) {
        subRole += '&roles[' + i + ']=' + role.value;
      });
      var subCompany = '';
      this.companies.forEach(function (company, i) {
        subCompany += '&companies[' + i + ']=' + company.value;
      });
      // filter by time
      var subLastEdited = '';
      this.lastEdited.forEach(function (item) {
        if (item.from) {
          subLastEdited += '&from=' + item.from;
        }
        if (item.to) {
          subLastEdited += '&to=' + item.to;
        }
      });
      // filter by lastEditors
      var subLastEditors = '';
      this.lastEditors.forEach(function (editor, i) {
        subLastEditors += '&authorId[' + i + ']=' + editor.value;
      });
      // status
      var subStatus = '';
      this.status.forEach(function (status, i) {
        subStatus += '&status[' + i + ']=' + status.value;
      });
      this.$eventHub.$emit('load-end');
      var urlString = __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].URLS.search + '&search=' + (this.search + subLanguages + subContentType + subTag + subCategories + subRole + subCompany + subLastEdited + subLastEditors + subStatus) + '&page=' + page + '&size=' + limit + '&isArticle=true';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.data.success) {
          _this3.$eventHub.$emit('load-end');
          _this3.$eventHub.$emit('load-stop');
        } else {
          _this3.$eventHub.$emit('load-start');
          //          this.contentAutoloadInfo.curPage = res.body.current_page_number
          if (page === 1) {
            _this3.articles = res.body.data.items ? res.body.data.items : [];
          } else {
            _this3.articles = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.articles), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.body.data.items));
          }
        }
      }).catch(function (err) {
        _this3.contentAutoloadInfo.locked = false;
        console.log(err);
      });
    },
    searchByParams: function searchByParams(page, limit) {
      var _this4 = this;

      this.contentAutoloadInfo.curPage = page;
      var body = {
        language: this.languages.map(function (item) {
          return item.value;
        }),
        contentType: this.contentType.map(function (item) {
          return item.value;
        }),
        tags: this.tags.map(function (item) {
          return item.value;
        }),
        categories: this.categories.map(function (item) {
          return item.value;
        }),
        roles: this.roles.map(function (item) {
          return item.value;
        }),
        companies: this.companies.map(function (item) {
          return item.value;
        }),
        isArticle: 1,
        authorId: this.lastEditors.map(function (item) {
          return item.value;
        }),
        status: this.status.map(function (item) {
          return item.value;
        })
      };
      this.lastEdited.forEach(function (item) {
        if (item.from) {
          body.from = item.from;
        }
        if (item.to) {
          body.to = item.to;
        }
      });
      this.$eventHub.$emit('load-end');
      this.$http.post(__WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].URLS.contentSearch + '?page=' + page + '&limit=' + limit, body, __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].headersAuthSettings).then(function (res) {
        // Set status options
        if (res.body.data.items.length < true) {
          _this4.$eventHub.$emit('load-end');
          _this4.$eventHub.$emit('load-stop');
        } else {
          _this4.$eventHub.$emit('load-start');
        }
        _this4.statusOptions = [];
        var statusOptions = res.body.status ? res.body.status : {};
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(statusOptions).forEach(function (key) {
          _this4.statusOptions.push({
            label: key,
            value: +statusOptions[key].id
          });
        });
        _this4.contentAutoloadInfo.curPage = res.body.data.current_page_number;
        _this4.contentAutoloadInfo.numPages = Math.ceil(res.body.data.total_count / limit) !== 0 ? Math.ceil(res.body.data.total_count / limit) : 1;
        if (page === 1) {
          _this4.articles = res.body.data.items;
        } else {
          _this4.articles = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this4.articles), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.body.data.items));
        }
        // set article count
        var count = res.body.status;
        _this4.statusbar.published = count.Published.count;
        _this4.statusbar.draft = count.Draft.count;
        _this4.statusbar.archived = count.Archived.count;
      }).catch(function () {
        _this4.contentAutoloadInfo.locked = false;
      });
    },
    getStatus: function getStatus(st) {
      switch (st) {
        case 0:
          return 'Draft';
        case 1:
          return 'Published';
        case 2:
          return 'Archived';
        default:
          return '';
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      var _this5 = this;

      console.log(filter);
      // Languages
      this.languages.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.languages.splice(i, 1);
          return;
        }
      });
      this.contentType.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.contentType.splice(i, 1);
          return;
        }
      });
      this.categories.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.categories.splice(i, 1);
          return;
        }
      });
      this.tags.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.tags.splice(i, 1);
          return;
        }
      });
      this.roles.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.roles.splice(i, 1);
          return;
        }
      });
      this.companies.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.companies.splice(i, 1);
          return;
        }
      });
      // Last edited
      this.lastEdited.forEach(function (item, i) {
        if (item.id === null && item.label === filter.label) {
          _this5.lastEdited.splice(i, 1);
          return;
        }
      });
      // Last editors
      this.lastEditors.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.lastEditors.splice(i, 1);
          return;
        }
      });
      // Status
      this.status.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this5.status.splice(i, 1);
          return;
        }
      });
    },
    removeAllFilters: function removeAllFilters() {
      this.languages = [];
      this.contentType = [];
      this.categories = [];
      this.tags = [];
      this.roles = [];
      this.companies = [];
      this.lastEdited = [];
      this.lastEditors = [];
      this.status = [];
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    changeDateFilter: function changeDateFilter() {
      //      this.datepicker.isShown = false
      this.showHideSubMenu(7);
      if (!this.datepicker.from && !this.datepicker.to) return;
      var label = (this.datepicker.from ? this.convertDate(this.datepicker.from, '.') : 'n/a') + ' - ' + (this.datepicker.to ? this.convertDate(this.datepicker.to, '.') : 'n/a');
      this.lastEdited = [{
        label: label,
        id: null,
        from: this.datepicker.from ? convertDate(this.datepicker.from, '-') : null,
        to: this.datepicker.to ? convertDate(this.datepicker.to, '-') : null
      }];
      function convertDate(payload, delimetr) {
        if (!payload) return;
        var date = new Date(payload);
        var fullYear = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        return fullYear + delimetr + toDoubleDigit(month) + delimetr + toDoubleDigit(day);
        function toDoubleDigit(num) {
          return num.toString().length < 2 ? '0' + num : num.toString();
        }
      }
    },
    getOptionsLastEditors: function getOptionsLastEditors(search, loading) {
      var _this6 = this;

      loading(true);
      var body = {
        name: search
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].URLS.usersSearch, body, __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        var users = res.body.items ? res.body.items : [];
        _this6.lastEditorsOptions = users.map(function (user) {
          return {
            value: user.id,
            label: user.username + ' ' + user.last_name
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    initSearch: function initSearch() {
      this.search ? this.mainSearch(1, 20) : this.searchByParams(1, 20);
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    articleRoles: function articleRoles(roles) {
      var string = '';
      roles.forEach(function (role) {
        string += role.name + '</br>';
      });
      return string;
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vuex__["mapGetters"])(['types', 'getCategoriesTitle', 'getTagTitles', 'getContentTypeForSelect', 'getTagsForSelect', 'getCategoriesForSelect', 'getRolesForSelect', 'getCompaniesForSelect', 'getLanguagesForSelect']), {
    selectedFilters: function selectedFilters() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.languages), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.contentType), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.categories), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.tags), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.roles), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.companies), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.lastEdited), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.lastEditors), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.status));
    }
  }),
  watch: {
    languages: function languages() {
      this.initSearch();
    },
    contentType: function contentType() {
      this.initSearch();
    },
    categories: function categories() {
      this.initSearch();
    },
    tags: function tags() {
      this.initSearch();
    },
    roles: function roles() {
      this.initSearch();
    },
    companies: function companies() {
      this.initSearch();
    },
    lastEdited: function lastEdited() {
      this.initSearch();
    },
    lastEditors: function lastEditors() {
      this.initSearch();
    },
    status: function status() {
      this.initSearch();
    },
    'confirmation.isShown': function confirmationIsShown(value) {
      if (value) {
        this.confirmation.style.top = window.pageYOffset - 100 + 'px';
      }
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_24__components_admin_common_Select___default.a,
    'articleId': __WEBPACK_IMPORTED_MODULE_3__components_newCmsStyle_ComponentArticle_articlesId___default.a,
    'searchInArticles': __WEBPACK_IMPORTED_MODULE_4__components_newCmsStyle_ComponentArticle_searchInArticles___default.a,
    'languageArticles': __WEBPACK_IMPORTED_MODULE_5__components_newCmsStyle_ComponentArticle_languageArticles___default.a,
    'typeArticles': __WEBPACK_IMPORTED_MODULE_6__components_newCmsStyle_ComponentArticle_typeArticles___default.a,
    'topicsArticle': __WEBPACK_IMPORTED_MODULE_7__components_newCmsStyle_ComponentArticle_topicsArticles___default.a,
    'categoryArticles': __WEBPACK_IMPORTED_MODULE_8__components_newCmsStyle_ComponentArticle_categoryArticles___default.a,
    'accessArticle': __WEBPACK_IMPORTED_MODULE_9__components_newCmsStyle_ComponentArticle_accessArticles___default.a,
    'companySpecificArticles': __WEBPACK_IMPORTED_MODULE_10__components_newCmsStyle_ComponentArticle_companySpecificArticles___default.a,
    'lastEditedArticles': __WEBPACK_IMPORTED_MODULE_11__components_newCmsStyle_ComponentArticle_lastEditedArticles___default.a,
    'uploaderEditorArticles': __WEBPACK_IMPORTED_MODULE_12__components_newCmsStyle_ComponentArticle_uploaderEditorArticles___default.a,
    'statusArticles': __WEBPACK_IMPORTED_MODULE_13__components_newCmsStyle_ComponentArticle_statusArticles___default.a,
    'actionsArticles': __WEBPACK_IMPORTED_MODULE_14__components_newCmsStyle_ComponentArticle_actionsArticles___default.a
  },
  mounted: function mounted() {
    var self = this;
    this.$eventHub.$on('in-view', function () {
      self.handleScroll();
    });
    this.getTypes();
    this.searchByParams(1, 20);
    this.getCategories();
    this.getCompanies();
    this.getRoles();
    this.getTags();
    this.getLngs();
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick__ = __webpack_require__(90);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about-page',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          image: '',
          altImage: '',
          button: {
            text: '',
            url: ''
          },
          hideSection: false
        },
        clientSection: {
          title: '',
          description: '',
          logos: [{
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          }],
          hideSection: false
        },
        howItWorksSection: {
          title: '',
          description: '',
          sections: [{
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }],
          hideSection: false
        },
        testimonialsSection: {
          title: '',
          testimonials: [{
            text: '',
            name: '',
            company: '',
            image: '',
            altImage: ''
          }],
          hideSection: false
        },
        contactCTA: {
          title: '',
          text: '',
          buttons: [{
            text: '',
            link: ''
          }],
          hideSection: false
        },
        subscribeSection: {
          title: '',
          description: '',
          formTitle: '',
          hideSection: false
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      slidesReady: false,
      howItWorksOptionsContent: {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        draggable: true
      },
      testimonialsOptionsContent: {
        arrows: true,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        accessibility: true,
        draggable: true
      },
      activePopup: null,
      sliderModalShown: false,
      subscribeForm: {
        firstnameFocus: false,
        lastnameFocus: false,
        emailFocus: false,
        firstname: '',
        lastname: '',
        email: ''
      },
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    subscribeMe: function subscribeMe() {
      var _this = this;

      this.formStatus.submitting = true;
      this.$validator.validateAll(['First name', 'Last name', 'Email address']).then(function (result) {
        if (!result) {
          _this.formStatus.submitting = false;
          return;
        }
        var firstname = _this.subscribeForm.firstname;
        var lastname = _this.subscribeForm.lastname;
        var email = _this.subscribeForm.email;
        var body = {
          firstname: firstname,
          lastname: lastname
        };
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.subscribe + '/' + email, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
          _this.formStatus.submitting = false;
          _this.formStatus.shown = true;
          _this.formStatus.success = true;
          _this.formStatus.title = 'You have been successfully subscribed to the Clear Assured newsletter.';
          _this.formStatus.body = 'We will send you news about our latest resources made available on the web app and will keep you updated with our events and webinars. You can always unsubscribe from your email.';
          _this.subscribeForm.firstname = '';
          _this.subscribeForm.lastname = '';
          _this.subscribeForm.email = '';
          setTimeout(function () {
            _this.errors.clear();
          }, 100);
        }).catch(function (err) {
          _this.formStatus.submitting = false;
          _this.serverValidation.errors = err;
          _this.disableAPI = false;
          _this.formStatus.shown = true;
          _this.formStatus.success = false;
          _this.formStatus.title = err.body.message || 'Your subscribe request was not submitted.';
          _this.formStatus.body = 'It looks like there was an error. Please try again or give us a call and we\'ll have our support team help you.';
        });
      });
    },
    updateLandingPage: function updateLandingPage() {
      var _this2 = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: 'about-us',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.getLandingPage();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this3 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'about-us',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this4 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.slidesReady = false;
      var body = {
        slug: 'about-us'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/about-us', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this4.content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.content, pageData);
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title + ' | Clear Assured';
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        _this4.slidesReady = true;
        _this4.$nextTick(function () {
          if (_this4.$refs.testimonialsSlick) {
            _this4.$refs.testimonialsSlick.reSlick();
          }
          if (_this4.$refs.howItWorksSlick) {
            _this4.$refs.howItWorksSlick.reSlick();
          }
        });
        if (id) {
          _this4.pageEditSwitch();
        } else {
          _this4.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this5 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/about-us', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this5.editHistory = true;
      }).catch(function (err) {
        _this5.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this6 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this6.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    addSection: function addSection(section) {
      if (section === 'testimonials') {
        this.content.testimonialsSection.testimonials.push({
          text: '',
          name: '',
          company: '',
          image: '',
          altImage: ''
        });
      }
      if (section === 'contact-cta-button') {
        this.content.contactCTA.buttons.push({
          text: '',
          link: ''
        });
      }
      if (section === 'features') {
        this.content.featuresSection.items.push({
          title: '',
          text: '',
          video: '',
          button: {
            text: '',
            url: ''
          },
          image: '',
          altImage: ''
        });
      }
      if (section === 'how-it-works') {
        this.content.howItWorksSection.sections.push({
          title: '',
          description: '',
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: ''
        });
        console.log(this.content.howItWorksSection.sections);
      }
      if (section === 'logos') {
        this.content.clientSection.logos.push({
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: '',
          url: ''
        });
      }
    },
    removeSection: function removeSection(section, index) {
      section.splice(index, 1);
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    getHighImage: function getHighImage(item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image;
    },
    getHighImageAlt: function getHighImageAlt(item) {
      return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage;
    },
    activatePopup: function activatePopup(item) {
      this.activePopup = item;
    },
    closePopup: function closePopup() {
      var _this7 = this;

      this.activePopup = null;
      this.sliderModalShown = false;
      this.slidesReady = true;
      this.pageMetaEdit = false;
      this.$nextTick(function () {
        if (_this7.$refs.testimonialsSlick) {
          _this7.$refs.testimonialsSlick.reSlick();
        }
        if (_this7.$refs.howItWorksSlick) {
          _this7.$refs.howItWorksSlick.reSlick();
        }
      });
    },
    closePopupOnOutsideClick: function closePopupOnOutsideClick(e) {
      var _this8 = this;

      var iconPopup = this.$refs.iconPopup;
      var sliderPopup = this.$refs.sliderPopup;
      var target = e.target;
      if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
        this.activePopup = null;
      }
      if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
        this.switchSliderModal();
        this.slidesReady = true;
        this.$nextTick(function () {
          if (_this8.$refs.testimonialsSlick) {
            _this8.$refs.testimonialsSlick.reSlick();
          }
          if (_this8.$refs.howItWorksSlick) {
            _this8.$refs.howItWorksSlick.reSlick();
          }
        });
      }
    },
    getVideoUrl: function getVideoUrl(url) {
      var link = url;
      if (url !== '') {
        var linkPart = url.split('/');
        if (linkPart) {
          if (linkPart[2].indexOf('youtu') !== -1) {
            link = linkPart[0] + '//www.youtube.com/embed/' + linkPart[linkPart.length - 1];
          }
          if (linkPart[2].indexOf('vimeo') !== -1) {
            link = linkPart[0] + '//player.vimeo.com/video/' + linkPart[linkPart.length - 1];
          }
          link += '?autoplay=0&loop=1';
        }
      }
      return link;
    },
    switchSliderModal: function switchSliderModal() {
      this.sliderModalShown = !this.sliderModalShown;
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 1024) {
        deviceName = 'desktop';
      } else if (width > 640) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    }
  }),
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_4_vue_slick__["a" /* default */]
  },
  watch: {}
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'account-settings',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditDetails: false,
      canEditOwner: false,
      canEditTasksSettings: false,
      confOpened: null,
      company: {
        details: {
          id: '',
          name: '',
          industrySector: '',
          marketplace: '',
          companySize: ''
        },
        ownerData: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        },
        tasksSettings: {
          contraption: '',
          defaultAssignee: false,
          accountManager: false
        }
      },
      initialData: {
        details: {
          id: '',
          name: '',
          industrySector: '',
          marketplace: '',
          companySize: ''
        },
        ownerData: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        },
        tasksSettings: {
          contraption: '',
          defaultAssignee: false,
          accountManager: false
        }
      },
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      canLeave: false,
      next: null,
      isChanged: false,
      companyId: null,
      activeSection: 'companyDetails'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getUserRole', 'getUserCompany', 'getConfData', 'userIndustrySectors', 'defaultAssigneeForSelect'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'initConfAction', 'authLogout', 'getCompanyOrganizationTypes', 'getTaskAssignee']), {
    openEditEmails: function openEditEmails() {
      this.canEditEmails = true;
    },
    openEditDetails: function openEditDetails() {
      this.canEditDetails = true;
    },
    openEditOwner: function openEditOwner() {
      this.canEditOwner = true;
    },
    openTasksSettings: function openTasksSettings() {
      this.canEditTasksSettings = true;
    },
    closeEditDetails: function closeEditDetails() {
      this.company.details = this.initialData.details;
      this.canEditDetails = false;
      this.errors.clear();
    },
    closeEditOwner: function closeEditOwner() {
      this.company.ownerData = this.initialData.ownerData;
      this.canEditOwner = false;
      this.errors.clear();
    },
    closeEditTasksSettings: function closeEditTasksSettings() {
      this.company.tasksSettings = this.initialData.tasksSettings;
      this.canEditTasksSettings = false;
      this.errors.clean();
    },
    closeMsg: function closeMsg() {
      this.errors.clear();
    },
    fieldChange: function fieldChange() {
      this.isChanged = true;
    },
    getCompanyData: function getCompanyData() {
      var _this = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, { id: this.companyId }, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var companyDetails = _this.company;
        // set received data
        companyDetails.details.id = res.body.id;
        // company details
        companyDetails.details.name = res.body.name;
        companyDetails.details.industrySector = res.body.industry_sector;
        companyDetails.details.marketplace = res.body.industry !== null && res.body.industry.id !== 1 ? res.body.industry.name : '';
        companyDetails.details.companySize = res.body.company_size !== null ? res.body.company_size.name : null;
        // company owner data
        companyDetails.ownerData.firstName = res.body.owner_first_name;
        companyDetails.ownerData.lastName = res.body.owner_last_name;
        companyDetails.ownerData.phoneNumber = res.body.owner_phone_number;
        companyDetails.ownerData.email = res.body.owner_email;
        // company task settings
        companyDetails.tasksSettings.contraption = res.body.contraption;
        companyDetails.tasksSettings.defaultAssignee = null;
        if (res.body.default_assignee !== null) {
          companyDetails.tasksSettings.defaultAssignee = {
            id: res.body.default_assignee.id,
            label: res.body.default_assignee.first_name + ' ' + res.body.default_assignee.last_name,
            value: res.body.default_assignee.id
          };
        }
        // set initial data
        _this.initialData = companyDetails;

        document.title = 'Account settings | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this.$router.resolve({
            name: 'error'
          });
          _this.$router.push(props.href);
        }
        if (err.status === 401) {
          _this.authLogout();
        }
      });
    },
    updateCompanyDetails: function updateCompanyDetails() {
      var _this2 = this;

      if (this.getUserRole !== 'ca') {
        return;
      }
      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var companyData = {
        id: this.company.details.id,
        companyName: this.company.details.name,
        industrySector: this.company.details.industrySector.label
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, companyData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = res.body.name + ' organisation details was successfully updated.';
        _this2.infMsgDescription = 'Please note all edits are being logged. ';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.getCompanyData();
        _this2.canEditDetails = !_this2.canEditDetails;
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We were not able to update this organisation because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this2.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.getCompanyData();
      });
    },
    updateCompanyOwner: function updateCompanyOwner() {
      var _this3 = this;

      if (this.getUserRole !== 'ca') {
        return;
      }
      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var owner = {
        id: this.company.details.id,
        ownerFirstName: this.company.ownerData.firstName,
        ownerLastName: this.company.ownerData.lastName,
        ownerPhoneNumber: this.company.ownerData.phoneNumber,
        ownerEmail: this.company.ownerData.email
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, owner, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = res.body.name + ' organisation owner details was successfully updated.';
        _this3.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.getCompanyData();
        _this3.canEditOwner = !_this3.canEditOwner;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
        _this3.infMsgTitle = 'Error. We were not able to update this company because ';
        for (var error in err.body.error.exception) {
          _this3.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this3.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this3.infMsgClass = 'error';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.getCompanyData();
      });
    },
    updateCompanyTasksSettings: function updateCompanyTasksSettings() {
      var _this4 = this;

      if (this.getUserRole !== 'ca') {
        return;
      }
      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var companyData = {
        id: this.company.details.id,
        contraption: this.company.tasksSettings.contraption,
        defaultAssignee: this.company.tasksSettings.defaultAssignee
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, companyData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = res.body.name + ' company tasks settings was successfully updated.';
        _this4.infMsgDescription = 'Please note all edits are being logged. ';
        _this4.infMsgClass = 'success';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.getCompanyData();
        _this4.canEditTasksSettings = !_this4.canEditTasksSettings;
      }).catch(function (err) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = 'Error. We were not able to update this company because ';
        for (var error in err.body.error.exception) {
          _this4.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this4.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this4.infMsgClass = 'error';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.getCompanyData();
      });
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(function () {
          element.focus();
        });
      }
    },
    posY: function posY(elm) {
      var test = elm;
      var top = 0;
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop;
        test = test.offsetParent;
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(elem) {
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        var section = sections[index];
        if (section && this.isScrolledIntoView(section)) {
          this.activeSection = index;
        }
      }
    }
  }),
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default.a
  },
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteCompanyConfirmed();
        if (this.confOpened === 'archive') this.archiveCompanyConfirmed();
        this.clearConfAction();
      }
    }
  },
  created: function created() {
    this.companyId = this.getUserCompany;
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.getCompanyData();
    this.getCompanyOrganizationTypes();
    this.getTaskAssignee();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-article',
  data: function data() {
    return {
      entity: {
        title: '',
        featuredImage: '',
        altImage: '',
        type: null,
        topic: null,
        category: null,
        company: null,
        industry: null,
        location: null,
        size: null,
        notCompany: null,
        notIndustry: null,
        notLocation: null,
        notSize: null,
        content: '',
        ttd: [],
        ttc: [],
        loading: false,
        resources: {
          video: [{
            videoUrl: '',
            videoTranscript: ''
          }],
          document: [{
            name: '',
            resource: null,
            extension: null,
            resourceUrl: '',
            resourceTranscript: ''
          }]
        }
      },
      featuredImage: null,
      articleType: {
        type: null,
        shown: false
      },
      tags: [],
      categories: [],
      thingsToConsiderOptions: [],
      thingsToDoOptions: [],
      isThumbnailFileUploaded: false,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      isSpecific: null,
      isExcluded: null,
      articleEditBoxActive: true,
      articleRelatedBoxActive: true,
      articleSettingsBoxActive: true,
      articleResourcesBoxActive: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['types', 'getTagsForSelect', 'getCategoriesForSelect', 'getCompaniesForSelect', 'getContentTypeForSelect', 'getIndustriesForSelect', 'companyLocations', 'companySizes']), {
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    },
    thingsToConsiderOptionsComputed: function thingsToConsiderOptionsComputed() {
      return this.thingsToConsiderOptions;
    }
  }),
  watch: {
    'entity.company': function entityCompany(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'company';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.industry': function entityIndustry(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'industry';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.notCompany': function entityNotCompany(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'company';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.notIndustry': function entityNotIndustry(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'industry';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.type': function entityType(value) {
      this.entity.resources = {
        video: [{
          videoUrl: '',
          videoTranscript: ''
        }],
        document: [{
          name: '',
          resource: null,
          extension: null,
          resourceUrl: '',
          resourceTranscript: ''
        }]
      };
      if (value) {
        this.articleType.shown = true;
        if (value.label === 'Video') {
          this.articleType.type = 'video';
        } else if (value.label === 'Template' || value.label === 'Document') {
          this.articleType.type = 'document';
        }
      } else {
        this.articleType.shown = false;
        this.articleType.type = null;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getTypes', 'getCompanies', 'getCategories', 'getTags', 'setInformationMsg', 'getIndustries', 'getCompanyLocations', 'getCompanySizes']), {
    addVideoRow: function addVideoRow() {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.push({
          videoUrl: '',
          videoTranscript: ''
        });
      } else {
        this.entity.resources.document.push({
          name: '',
          resource: null,
          extension: null,
          resourceUrl: '',
          resourceTranscript: ''
        });
      }
    },
    removeElement: function removeElement(index) {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.splice(index, 1);
      } else {
        this.entity.resources.document.splice(index, 1);
      }
    },
    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    },
    removeResource: function removeResource(index) {
      this.entity.resources.document[index].extension = null;
      this.entity.resources.document[index].resource = null;
      this.entity.resources.document[index].name = '';
    },
    addFormElement: function addFormElement(type) {
      this.addElements[type] += 1;
    },
    onThumbnailFileChange: function onThumbnailFileChange(e) {
      var self = this;
      var input = document.getElementById('uploadThumbnail');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.isThumbnailFileUploaded = true;
        var reader = new FileReader();
        reader.onload = function (e) {
          self.entity.featuredImage = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    onResourceFileChange: function onResourceFileChange(value, i) {
      var self = this;
      var valueTrimmed = value.target.value.replace(/^.*\\/, '');
      var input = document.getElementById('uploadResource_' + i);
      var extension = value.target.value.split('.').pop().toLowerCase();
      if (this.entity.type.label === 'Template' && ['doc', 'docx', 'xls', 'xlsx', 'pdf'].indexOf(extension) === -1) {
        alert('Only .doc, .docx, .xls, .xlsx or .pdf file extension allowed to add on article template type!');
        return;
      }
      if (this.entity.type.label === 'Document' && extension !== 'pdf') {
        alert('Only .pdf file extension allowed to add on article document type!');
        return;
      }
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          var fileNameArray = valueTrimmed.split('.');
          if (self.disableAPI) return;
          var pageData = {
            name: fileNameArray[0],
            file: e.target.result,
            extension: extension,
            type: 'article'
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            if (Array.isArray(res.body)) {
              alert(res.body[0] + '. Please try again.');
              return;
            }
            self.entity.resources.document[i].name = valueTrimmed;
            self.entity.resources.document[i].extension = extension;
            self.entity.resources.document[i].resource = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            alert('Error on file upload. Please try again');
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeThumbnail: function removeThumbnail() {
      var input = document.getElementById('uploadThumbnail');
      input.value = null;
      this.isThumbnailFileUploaded = false;
      this.entity.featuredImage = null;
    },
    publishArticle: function publishArticle(status, redirect) {
      var _this = this;

      this.$validator.validateAll();
      this.entity.loading = true;
      this.$nextTick(function () {
        if (_this.errors.items.length) {
          _this.entity.loading = false;
          return false;
        }
        if (_this.entity.loading === true) {
          _this.entity.loading = false;
          return false;
        }
      });
      var self = this;
      var editor = this.$refs.contentEditor;
      this.entity.content = editor.getContent();
      var formData = {
        title: this.entity.title,
        imageFile: this.entity.featuredImage || '',
        alt: this.entity.altImage,
        content: this.entity.content,
        contentType: this.entity.type.value,
        status: status,
        isArticle: 1,
        children: this.entity.ttc.concat(this.entity.ttd),
        categories: Array.isArray(this.entity.category) ? this.entity.category : [this.entity.category],
        tags: this.entity.topic,
        companies: this.entity.company,
        industries: this.entity.industry,
        locations: this.entity.location,
        sizes: this.entity.size,
        notCompanies: this.entity.notCompany,
        notIndustries: this.entity.notIndustry,
        notLocations: this.entity.notLocation,
        notSizes: this.entity.notSize
      };
      if (this.articleType.type === 'video') {
        formData.typeValues = [];
        this.entity.resources.video.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.videoUrl,
            textarea: row.videoTranscript
          });
        });
      }
      if (this.articleType.type === 'document') {
        formData.typeValues = [];
        this.entity.resources.document.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.resourceUrl,
            textarea: row.resourceTranscript,
            extension: row.extension,
            file: row.resource,
            name: row.name
          });
        });
      }
      var newWindow = void 0;
      if (redirect) {
        newWindow = window.open('', '_blank');
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content, formData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.infMsgTitle = 'A new Resource called ' + res.body.title + ' was successfully created.';
        self.infMsgDescription = '';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        if (redirect) {
          var props = _this.$router.resolve({
            name: 'content',
            params: { id: res.body.id }
          });
          newWindow.location = props.href;
          _this.entity.loading = false;
        }
        self.switchEditPage(res.body.id);
        // this.entity.loading = false
      }).catch(function (err) {
        self.serverValidation.errors = err;
        self.infMsgTitle = 'Error. We were not able to create this Resource because ';
        self.infMsgTitle += err.body.message.toLowerCase();
        self.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        self.infMsgClass = 'error';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
      });
    },
    switchEditPage: function switchEditPage(id) {
      var props = this.$router.resolve({
        name: 'edit-article',
        params: { id: id }
      });
      location.href = props.href;
    },
    goToAllArticles: function goToAllArticles() {
      var props = this.$router.resolve({
        name: 'articles-list'
      });
      this.$router.push(props.href);
    },
    getOptionsThingsToConsider: function getOptionsThingsToConsider(search, loading) {
      var _this2 = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=true';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        var items = res.body.data.items ? res.body.data.items : [];
        _this2.thingsToConsiderOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    getOptionsThingsToDo: function getOptionsThingsToDo(search, loading) {
      var _this3 = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=false';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        var items = res.body.data.items ? res.body.data.items : [];
        _this3.thingsToDoOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    handleScroll: function handleScroll(event) {
      var headerPlaceholder = document.getElementById('headerPlaceholder');
      var header = document.querySelector('.article__header');
      if (!headerPlaceholder || !header) {
        return;
      }
      var rect = headerPlaceholder.getBoundingClientRect();
      var sticky = rect.top;
      if (sticky <= 0) {
        header.classList.add('sticky');
        headerPlaceholder.style.height = header.offsetHeight + 'px';
      } else {
        header.classList.remove('sticky');
        headerPlaceholder.style.height = '';
      }
    }
  }),
  components: {},
  mounted: function mounted() {
    this.getTypes();
    this.getTags();
    this.getCategories();
    this.getCompanies();
    this.getIndustries();
    this.getCompanyLocations();
    this.getCompanySizes();
  },
  created: function created() {
    document.title = 'Create new Thing to Consider | Clear Assured';
    window.addEventListener('scroll', this.handleScroll);
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-company',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      company: null,
      lastEdited: null,
      newCompany: {
        name: '',
        parent: null,
        industry: null,
        subscriptionEnd: '',
        employeeLimit: '',
        enabled: null,
        url: null,
        language: 'English',
        contraption: '',
        seesChat: true,
        isDemo: false,
        allowRegistration: null,
        allowAllEmails: null,
        emailApproval: null,
        usersType: null,
        companySize: null,
        companyLocation: null,
        approvedEmails: [{
          email: ''
        }]
      },
      ownerData: {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      confirmation: {
        action: '',
        isShown: false,
        id: null,
        style: {
          top: '100px'
        }
      },
      datepicker: {
        subscription: null,
        shown: false,
        keepFocus: false
      },
      activeSection: 'companyDetails',
      emailControl: {
        input: '',
        isPaste: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIndustriesForSelect', 'getUserRole', 'getCompaniesForSelect', 'getDefaultRegistrationRolesForSelect', 'companySizes', 'companyLocations']), {
    getStatusesForSelect: function getStatusesForSelect() {
      return [{
        label: 'Active',
        value: '1'
      }, {
        label: 'Inactive',
        value: '0'
      }];
    },
    yesNoOptionsForSelect: function yesNoOptionsForSelect() {
      return [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
    },
    yesNoOptionsForSelectNew: function yesNoOptionsForSelectNew() {
      return [{
        label: this.newCompany.allowAllEmails && this.newCompany.allowAllEmails.value ? 'Yes' : 'Yes, all',
        value: true
      }, {
        label: this.newCompany.allowAllEmails && this.newCompany.allowAllEmails.value ? 'No' : 'Only accounts without an approved domain email',
        value: false
      }];
    },
    preparedCompanies: function preparedCompanies() {
      var companyList = [];
      for (var company in this.getCompaniesForSelect) {
        if (this.getCompaniesForSelect[company].parent !== 1) {
          companyList.push(this.getCompaniesForSelect[company]);
        }
      }
      return companyList;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getCompanies', 'getIndustries', 'setInformationMsg', 'getDefaultRegistrationRoles', 'getCompanySizes', 'getCompanyLocations']), {
    createNewCompany: function createNewCompany() {
      var _this = this;

      this.$validator.validateAll();
      var self = this;
      if (this.errors.items.length) return;
      var company = {
        companyName: this.newCompany.name,
        parent: this.newCompany.parent,
        industry: this.newCompany.industry,
        subscriptionEnd: this.newCompany.subscriptionEnd,
        employeeLimit: this.newCompany.employeeLimit,
        enabled: this.newCompany.enabled.value,
        ownerFirstName: this.ownerData.firstName,
        ownerLastName: this.ownerData.lastName,
        ownerPhoneNumber: this.ownerData.phoneNumber,
        ownerEmail: this.ownerData.email,
        emailEndings: this.newCompany.approvedEmails,
        url: this.newCompany.url,
        allowRegistration: this.newCompany.allowRegistration ? this.newCompany.allowRegistration.value === true : false,
        allowAllEmails: this.newCompany.allowAllEmails ? this.newCompany.allowAllEmails.value === false : true,
        emailApproval: this.newCompany.emailApproval ? this.newCompany.emailApproval.value === true : false,
        contraption: this.newCompany.contraption,
        seesChat: this.newCompany.seesChat,
        isDemo: this.newCompany.isDemo,
        usersType: this.newCompany.usersType ? this.newCompany.usersType.value : {},
        companySize: this.newCompany.companySize ? this.newCompany.companySize.value : {},
        companyLocation: this.newCompany.companyLocation ? this.newCompany.companyLocation.value : {}
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, company, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.infMsgTitle = 'A new company called ' + res.body.name + ' was successfully created.';
        _this.infMsgDescription = 'Please set the company focus point, start date and the progress before you start adding users.';
        _this.infMsgClass = 'success';
        _this.setInformationMsg({
          isShown: true,
          title: _this.infMsgTitle,
          text: _this.infMsgDescription,
          className: _this.infMsgClass
        });
        self.goToCompanyList();
      }).catch(function (err) {
        _this.serverValidation.errors = err.body;
        _this.infMsgTitle = 'Error. We were not able to create this company because ';
        for (var error in err.body.error.exception) {
          _this.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this.infMsgClass = 'error';
        _this.setInformationMsg({
          isShown: true,
          title: _this.infMsgTitle,
          text: _this.infMsgDescription,
          className: _this.infMsgClass
        });
      });
    },
    discardAllData: function discardAllData() {
      var self = this;
      this.newCompany.name = '';
      this.newCompany.parent = '';
      this.newCompany.industry = '';
      this.newCompany.subscriptionEnd = '';
      this.newCompany.employeeLimit = '';
      this.newCompany.enabled = '';
      this.ownerData.firstName = '';
      this.ownerData.lastName = '';
      this.ownerData.phoneNumber = '';
      this.ownerData.email = '';
      this.newCompany.emailEndings = [{
        email: ''
      }];
      this.newCompany.url = '';
      this.newCompany.allowRegistration = this.yesNoOptionsForSelect[0];
      this.newCompany.allowAllEmails = this.yesNoOptionsForSelect[0];
      this.newCompany.emailApproval = this.yesNoOptionsForSelect[0];
      this.newCompany.contraption = '';
      this.newCompany.seesChat = true;
      this.newCompany.isDemo = false;
      setTimeout(function () {
        self.errors.clear();
      }, 1);
    },
    createTags: function createTags(el, wait, blur) {
      var _this2 = this;

      var target = this.getTarget(el);
      // const newEmailsSet = {}
      this.emailControl['input'] = target.value;
      if (wait && !this.emailControl['isPaste']) {
        this.autoHeight(el);
        return;
      }
      if (blur) {
        this.emailControl['isPaste'] = false;
        if (this.emailControl['input'] === '') {
          return;
        }
      }
      var emails = this.emailControl['input'].split(/(?:,| |>|<|"|'|;)+/);

      var _loop = function _loop(index) {
        if (emails[index] !== '') {
          var exists = _this2.newCompany.approvedEmails.find(function (item) {
            return item.email === emails[index];
          });
          var empty = _this2.newCompany.approvedEmails.findIndex(function (item) {
            return item.email === '';
          });
          if (empty !== -1) {
            _this2.removeElement(empty);
          }
          if (!exists) {
            _this2.newCompany.approvedEmails.push({
              email: emails[index]
            });
          }
        }
      };

      for (var index in emails) {
        _loop(index);
      }
      this.emailControl['isPaste'] = false;
      this.emailControl['input'] = '';
      this.addEmailRow();
    },
    autoWidth: function autoWidth(el) {
      var target = this.getTarget(el);
      setTimeout(function () {
        if (target) {
          target.style.width = '10px';
          target.style.width = target.scrollWidth + 15 + 'px';
        }
      }, 0);
    },
    autoHeight: function autoHeight(el) {
      var target = this.getTarget(el);
      if (target) {
        setTimeout(function () {
          target.style.height = '40px;';
          target.style.height = target.scrollHeight + 4 + 'px';
        }, 0);
      }
    },
    getTarget: function getTarget(e) {
      var evn = e || window.event;
      return evn.srcElement || e.currentTarget;
    },

    closeMsg: function closeMsg() {
      this.errors.clear();
    },
    addEmailRow: function addEmailRow() {
      this.newCompany.approvedEmails.push({
        email: ''
      });
    },
    removeElement: function removeElement(index) {
      this.newCompany.approvedEmails.splice(index, 1);
    },
    dateSelected: function dateSelected(e) {
      this.newCompany.subscriptionEnd = this.convertDate(e, '/');
      this.datepicker.shown = false;
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    documentClick: function documentClick(e) {
      var self = this;
      if (self.datepicker.shown) {
        var datepicker = document.getElementById('date-selector');
        var target = e.target;
        if (!this.isDescendant(datepicker, target)) {
          self.datepicker.shown = false;
        }
      }
    },
    isDescendant: function isDescendant(parent, child) {
      var node = child.parentNode;
      while (node !== null) {
        if (node === parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    },
    goToCompanyList: function goToCompanyList() {
      var props = this.$router.resolve({
        name: 'companies'
      });
      this.$router.push(props.href);
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        var here = element[0] ? element[0] : element;
        here.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    posY: function posY(elm) {
      var test = elm[0] ? elm[0] : elm;
      var top = 0;
      if (test && test.tagName) {
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop;
          test = test.offsetParent;
        }
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elem = el[0] ? el[0] : el;
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        if (!index.match(/article/)) {
          var section = sections[index];
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index;
          }
        }
      }
    }
  }),
  watch: {
    'newCompany.allowAllEmails': function newCompanyAllowAllEmails(value) {
      if (value && value.value === false) {
        this.newCompany.emailApproval = this.yesNoOptionsForSelectNew[1];
      }
      if (value && value.value === true) {
        this.newCompany.emailApproval = this.yesNoOptionsForSelect[1];
      }
    },
    'getIndustriesForSelect': function getIndustriesForSelect(value) {
      if (value) {
        var defaultIndustry = value.find(function (i) {
          return i.value === 1;
        });
        if (defaultIndustry) {
          this.newCompany.industry = defaultIndustry;
        }
      }
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default.a
  },
  mounted: function mounted() {
    this.getCompanies();
    this.getIndustries();
    this.getDefaultRegistrationRoles();
    this.getCompanySizes();
    this.getCompanyLocations();
  },
  created: function created() {
    document.onclick = this.documentClick;
    window.addEventListener('scroll', this.handleScroll);
    document.title = 'Create company account | Clear Assured';
    this.newCompany.allowRegistration = this.yesNoOptionsForSelect[0];
    this.newCompany.allowAllEmails = this.yesNoOptionsForSelect[0];
    this.newCompany.emailApproval = this.yesNoOptionsForSelect[0];
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sortablejs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].directive('sortable', {
  inserted: function inserted(el, binding) {
    __WEBPACK_IMPORTED_MODULE_5_sortablejs__["default"].create(el, binding.value || {
      handle: '.sponsor-item-handle'
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-industry',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      industry: null,
      lastEdited: null,
      newIndustry: {
        name: '',
        parent: null,
        benchmarkPoliciesAndProcedures: '',
        benchmarkFindingTalent: '',
        benchmarkAccessingTalent: '',
        benchmarkRetainingTalent: '',
        chapterPoliciesAndProcedures: '',
        chapterFindingTalent: '',
        chapterAccessingTalent: '',
        chapterRetainingTalent: '',
        sponsors: [{
          id: null,
          logo: '',
          alt: '',
          url: '',
          order: 0,
          isLogoFileUploaded: false
        }]
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      confirmation: {
        action: '',
        isShown: false,
        id: null,
        style: {
          top: '100px'
        }
      },
      activeSection: 'industryDetails',
      thingsToConsiderOptions: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIndustriesForSelect']), {
    preparedIndustries: function preparedIndustries() {
      var industryList = [];
      for (var industry in this.getIndustriesForSelect) {
        if (this.getIndustriesForSelect[industry].parent !== 1) {
          industryList.push(this.getIndustriesForSelect[industry]);
        }
      }
      return industryList;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getIndustries', 'setInformationMsg']), {
    getOptionsThingsToConsider: function getOptionsThingsToConsider(search, loading) {
      var _this = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=true';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        var items = res.body.data.items ? res.body.data.items : [];
        _this.thingsToConsiderOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    createNewIndustry: function createNewIndustry() {
      var _this2 = this;

      this.$validator.validateAll();
      var self = this;
      if (this.errors.items.length) return;
      if (this.newIndustry.name === '') return;
      var sponsors = [];
      for (var sponsor in this.newIndustry.sponsors) {
        if (this.newIndustry.sponsors[sponsor].logo !== '') {
          sponsors.push({
            logo: this.newIndustry.sponsors[sponsor].logo,
            alt: this.newIndustry.sponsors[sponsor].alt,
            url: this.newIndustry.sponsors[sponsor].url,
            order: this.newIndustry.sponsors[sponsor].order
          });
        }
      }
      var industryData = {
        industryName: this.newIndustry.name,
        parent: this.newIndustry.parent,
        // benchmark
        benchmarkFindingTalent: this.newIndustry.benchmarkFindingTalent,
        benchmarkPoliciesAndProcedures: this.newIndustry.benchmarkPoliciesAndProcedures,
        benchmarkAccessingTalent: this.newIndustry.benchmarkAccessingTalent,
        benchmarkRetainingTalent: this.newIndustry.benchmarkRetainingTalent,
        chapterFindingTalent: this.newIndustry.chapterFindingTalent,
        chapterPoliciesAndProcedures: this.newIndustry.chapterPoliciesAndProcedures,
        chapterAccessingTalent: this.newIndustry.chapterAccessingTalent,
        chapterRetainingTalent: this.newIndustry.chapterRetainingTalent,
        // sponsors
        sponsors: sponsors
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.industry, industryData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.discardAllData();
        self.goToIndustryList();
        _this2.infMsgTitle = 'A new industry called ' + res.body.name + ' was successfully created.';
        _this2.infMsgDescription = 'Now you can assign companies and content to this industry.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
      }).catch(function (err) {
        _this2.serverValidation.errors = err.body;
        _this2.infMsgTitle = 'Error. We were not able to create this industry because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this2.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
      });
    },
    discardAllData: function discardAllData() {
      var self = this;
      this.newIndustry = {
        name: '',
        parent: null,
        benchmark: {
          policiesAndProcedures: '',
          findingTalent: '',
          accessingTalent: '',
          retainingTalent: ''
        },
        sponsors: [{
          id: null,
          logo: '',
          alt: '',
          url: '',
          order: 0,
          isLogoFileUploaded: false
        }]
      };
      setTimeout(function () {
        self.errors.clear();
      }, 1);
    },

    closeMsg: function closeMsg() {
      this.errors.clear();
    },
    addNewRow: function addNewRow(index) {
      if (this.newIndustry.sponsors.length - 1 === index) {
        this.newIndustry.sponsors.push({
          id: null,
          logo: '',
          alt: '',
          url: '',
          order: index + 1,
          isLogoFileUploaded: false
        });
      }
    },
    removeElement: function removeElement(index) {
      if (this.newIndustry.sponsors.length === 1) {
        this.newIndustry.sponsors = [{
          id: null,
          logo: '',
          alt: '',
          url: '',
          order: 0,
          isLogoFileUploaded: false
        }];
      } else {
        this.newIndustry.sponsors.splice(index, 1);
      }
    },
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: true,
        mimes: 'image/*'
      };
    },
    onThumbnailFileChange: function onThumbnailFileChange(e, index) {
      var self = this;
      var input = document.getElementById(e.target.id);
      var thisItem = input.closest('.sponsor-item');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        var reader = new FileReader();
        reader.onloadstart = function () {
          thisItem.classList.add('loading');
        };
        reader.onload = function (e) {
          self.newIndustry.sponsors[index].logo = e.target.result;
          self.newIndustry.sponsors[index].isLogoFileUploaded = true;
          if (self.newIndustry.sponsors.length - 1 === index) {
            self.newIndustry.sponsors.push({
              id: null,
              logo: '',
              alt: '',
              url: '',
              order: index + 1,
              isLogoFileUploaded: false
            });
          }
        };
        reader.readAsDataURL(input.files[0]);
        reader.onloadend = function () {
          if (this.readyState === 2) {
            thisItem.classList.remove('loading');
          }
        };
      }
    },
    removeLogo: function removeLogo(index) {
      this.newIndustry.sponsors[index].isLogoFileUploaded = false;
      this.newIndustry.sponsors[index].logo = '';
    },
    goToIndustryList: function goToIndustryList() {
      var props = this.$router.resolve({
        name: 'industries'
      });
      this.$router.push(props.href);
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        var here = element[0] ? element[0] : element;
        here.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    posY: function posY(elm) {
      var test = elm[0] ? elm[0] : elm;
      var top = 0;
      if (test && test.tagName) {
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop;
          test = test.offsetParent;
        }
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elem = el[0] ? el[0] : el;
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        if (!index.match(/article/)) {
          var section = sections[index];
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index;
          }
        }
      }
    }
  }),
  watch: {},
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default.a
  },
  beforeMount: function beforeMount() {
    this.getIndustries();
  },

  created: function created() {
    this.newIndustry.sponsors = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.orderBy(this.newIndustry.sponsors, 'order');
    window.addEventListener('scroll', this.handleScroll);
    document.title = 'Create a new industry account | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-user',
  data: function data() {
    return {
      userInvites: [],
      defaultRole: null,
      defaultCompany: null,
      email: {
        input: '',
        active: false,
        isPaste: false
      },
      step: 0,
      disableAPI: false,
      requestInProcess: false,
      response: {},
      status: {},
      user: null,
      confOpened: null,
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {}
      },
      inviteType: 1,
      currentStepImport: 0,
      fileName: '',
      usersImported: false,
      ignoreFirstRow: true,
      columns: [{
        label: 'Skip this column',
        value: 'skip'
      }, {
        label: 'Email address',
        value: 'email'
      }, {
        label: 'Role',
        value: 'role'
      }, {
        label: 'Company',
        value: 'company'
      }, {
        label: 'Job title',
        value: 'title'
      }, {
        label: 'Function',
        value: 'function'
      }, {
        label: 'First name',
        value: 'firstName'
      }, {
        label: 'Last name',
        value: 'lastName'
      }, {
        label: 'Phone',
        value: 'phone'
      }],
      csvData: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getCompaniesForSelect', 'getUserRole', 'getConfData', 'getRolesForSelect'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['getRoles', 'clearConfAction', 'initConfAction', 'getCompanies', 'setInformationMsg']), {
    roleChanged: function roleChanged(item) {
      if (item.role && item.role !== null && item.role.slug === 'gm') {
        item.company = null;
      }
    },
    changeIgnoreFirst: function changeIgnoreFirst() {
      this.ignoreFirstRow = !this.ignoreFirstRow;
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(function () {
          element.focus();
        }, 0);
      }
    },
    nextStep: function nextStep(type) {
      if (!this.userInvites.length && type === 1 || !this.usersImported && type === 2) {
        return;
      }
      var self = this;
      if (this.step === 0 && type === 2) {
        this.step += 1;
      }
      if (this.step === 0 && (type === 1 || type === 3)) {
        if (this.defaultCompany !== null) {
          for (var index in this.userInvites) {
            this.userInvites[index].company = this.defaultCompany;
          }
        }
        if (this.defaultRole !== null) {
          for (var _index in this.userInvites) {
            if (this.defaultRole.slug === 'gm') {
              this.userInvites[_index].company = null;
            }
            this.userInvites[_index].role = this.defaultRole;
          }
        }
        setTimeout(function () {
          self.autoHeight();
        }, 100);
        this.step += 1;
      } else if (this.step === 1 && (type === 1 || type === 3) || this.currentStepImport === 2 && type === 3) {
        if (this.user && this.user.email_endings === '' && this.getUserRole === 'ca') {
          this.sendInvitations('noDomains');
        } else {
          this.sendInvitationsConfirmed();
        }
      } else if (this.currentStepImport === 0 && type === 2) {
        this.currentStepImport += 1;
        this.goToPageSection('content');
      } else if (this.currentStepImport === 1 && type === 2) {
        var synchronised = this.csvData.some(function (item) {
          return item.column && item.column.value === 'email';
        });
        if (synchronised) {
          this.columns2rows();
          this.goToPageSection('content');
          setTimeout(function () {
            self.autoHeight();
          }, 100);
          return;
        } else {
          alert('Please sync columns');
          return;
        }
      }
    },
    columns2rows: function columns2rows() {
      var reorderedData = [];
      var emailColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'email';
      });
      var companyColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'company';
      });
      var roleColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'role';
      });
      var titleColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'title';
      });
      var functionColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'function';
      });
      var firstNameColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'firstName';
      });
      var lastNameColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'lastName';
      });
      var phoneColumn = this.csvData.find(function (item) {
        return item.column !== undefined && item.column.value === 'phone';
      });

      reorderedData.push(emailColumn);
      reorderedData.push(titleColumn);
      reorderedData.push(functionColumn);
      reorderedData.push(firstNameColumn);
      reorderedData.push(lastNameColumn);
      reorderedData.push(phoneColumn);

      if (roleColumn !== undefined) {
        reorderedData.push(roleColumn);
      } else {
        reorderedData.push({
          column: this.columns.find(function (item) {
            return item.value === 'role';
          }),
          columnIndex: 3,
          items: []
        });
      }

      if (this.getUserRole === 'gm') {
        if (companyColumn !== undefined) {
          reorderedData.push(companyColumn);
        } else {
          reorderedData.push({
            column: this.columns.find(function (item) {
              return item.value === 'company';
            }),
            columnIndex: 2,
            items: []
          });
        }
      }

      var w = reorderedData.length || 0;
      var h = reorderedData[0].items instanceof Array ? reorderedData[0].items.length : 0;

      if (h === 0 || w === 0) {
        return;
      }

      var i = void 0;
      var j = void 0;
      var t = [];

      for (i = 0; i < h; i++) {
        if (this.ignoreFirstRow && i === 0) {
          continue;
        }
        t[i] = {
          id: i,
          email: '',
          role: null,
          title: '',
          function: '',
          firstName: '',
          lastName: '',
          phone: '',
          company: null,
          isValid: false
        };
        for (j = 0; j < w; j++) {
          var column = reorderedData[j] && reorderedData[j].column ? reorderedData[j].column.value : null;
          if (column) {
            if (column === 'email') {
              t[i][column] = reorderedData[j].items[i];
              t[i].isValid = this.isValidEmail(reorderedData[j].items[i]);
            } else if (column === 'company') {
              t[i][column] = this.getCompaniesForSelect.find(function (item) {
                return item.label.toLowerCase().replaceAll(' ', '-') === reorderedData[j].items[i].toLowerCase().replaceAll(' ', '-');
              }) || null;
            } else if (column === 'role') {
              t[i][column] = this.getRolesForSelect.find(function (item) {
                return item.label.toLowerCase().replaceAll(' ', '-') === reorderedData[j].items[i].replace('\r', '').toLowerCase().replaceAll(' ', '-');
              }) || null;
            } else if (column === 'title' || column === 'function' || column === 'firstName' || column === 'lastName' || column === 'phone') {
              t[i][column] = reorderedData[j].items[i].replace('\r', '') || '';
            }
          }
        }
      }
      this.userInvites = t.filter(function (row) {
        return row;
      });
      this.currentStepImport += 1;
    },
    isValid: function isValid(column, item) {
      if (column && column.value === 'email') {
        return this.maybeIsEmailColumn(item);
      } else if (column && column.value === 'role') {
        if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object') {
          return !!item;
        }
      } else if (column && column.value === 'company') {
        if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object') {
          return !!item;
        }
      } else {
        return true;
      }
    },
    sendInvitations: function sendInvitations(conf) {
      var actionName = void 0;
      if (conf === 'noDomains') {
        actionName = 'noAllowedEmailDomains';
      }
      this.confOpened = 'invite';
      this.initConfAction({
        actionName: actionName
      });
    },
    sendInvitationsConfirmed: function sendInvitationsConfirmed() {
      var _this = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.requestInProcess = true;
      var hasErrors = false;
      var self = this;
      var body = [];
      for (var index in this.userInvites) {
        var user = this.userInvites[index];
        var role = user.role ? user.role.slug : null;
        var company = user.company;
        if (!user.isValid) {
          hasErrors = true;
          this.disableAPI = false;
          this.requestInProcess = false;
          return;
        }
        if (role === null) {
          hasErrors = true;
          this.disableAPI = false;
          this.requestInProcess = false;
          return;
        }
        if (this.getUserRole === 'gm' && role !== 'gm' && company === null) {
          hasErrors = true;
          this.disableAPI = false;
          this.requestInProcess = false;
          return;
        }
        var newUser = {
          id: user.id,
          email: user.email,
          role: user.role ? user.role.value : null,
          title: user.title,
          function: user.function,
          firstName: user.firstName,
          lastName: user.lastName,
          phone: user.phone,
          company: null
        };
        if (user.company) {
          newUser.company = user.company ? user.company.value : null;
        }
        body.push(newUser);
      }
      if (hasErrors) {
        this.disableAPI = false;
        this.requestInProcess = false;
        return;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.inviteUsers, body, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.requestInProcess = false;
        _this.response = res.body.users;
        _this.status = res.body.count;
        _this.step += 1;
        _this.currentStepImport += 1;
        setTimeout(function () {
          self.autoHeight();
        }, 100);
      }).catch(function (err) {
        _this.disableAPI = false;
        _this.requestInProcess = false;
        console.log(err);
      });
    },
    getProfileData: function getProfileData() {
      var _this2 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.user = res.body;
      });
    },
    changeInviteType: function changeInviteType(type) {
      this.inviteType = type;
    },
    convertFile: function convertFile(e) {
      var _this3 = this;

      var input = e.target;
      var reader = new FileReader();
      reader.onload = function () {
        _this3.fileName = input.files[0] ? input.files[0].name : '';
        var lines = reader.result.split('\n');

        var result = lines.map(function (line) {
          return line.split(',');
        });

        _this3.initCsvColumnSync(result);

        // let text = reader.result
        // this.$papa.parse(text, {
        //   complete: (results, file) => {
        //     this.initCsvColumnSync(results)
        //   }
        // })
      };
      reader.readAsText(input.files[0]);
    },
    initCsvColumnSync: function initCsvColumnSync(results) {
      var _this4 = this;

      var data = results;

      var columns = [];

      var cleanData = data.filter(function (row) {
        return row.some(function (item) {
          return item !== '';
        });
      });

      cleanData.forEach(function (row, i) {
        if (i === 0) {
          var firstRowHasEmail = row.some(function (item) {
            return _this4.maybeIsEmailColumn(item);
          });
          if (firstRowHasEmail) {
            _this4.ignoreFirstRow = false;
          }
        }
        row.forEach(function (item, index) {
          var thisColumn = columns.findIndex(function (find) {
            return find.columnIndex === index;
          });
          if (thisColumn > -1) {
            columns[thisColumn].items.push(item);
            columns[thisColumn].column = columns[thisColumn].column === undefined || columns[thisColumn].column.value === 'skip' ? _this4.identifyColumn(item) : columns[thisColumn].column;
            columns[thisColumn].synchronised = _this4.isColumnSynchronised(columns[thisColumn]);
          } else {
            columns.push({
              columnIndex: index,
              column: _this4.identifyColumn(item) || undefined,
              synchronised: false,
              items: [item]
            });
          }
        });
      });
      this.csvData = columns;
      this.usersImported = true;
    },
    identifyColumn: function identifyColumn(item) {
      if (this.maybeIsEmailColumn(item)) {
        return this.columns.find(function (column) {
          return column.value === 'email';
        });
      }
      var nonEmailColumns = this.columns.filter(function (column) {
        return column.value !== 'email';
      });
      var existingColumn = void 0;
      nonEmailColumns.forEach(function (column) {
        if (item.indexOf(column.label) > -1) {
          existingColumn = column;
        }
      });
      if (existingColumn !== undefined) {
        return existingColumn;
      }
      return this.columns.find(function (column) {
        return column.value === 'skip';
      });
    },
    isColumnSynchronised: function isColumnSynchronised(item) {
      if (item.synchronised) {
        return;
      }
      return item.column !== undefined;
    },
    synchroniseColumn: function synchroniseColumn(e, col) {
      col.column = e.option;
      col.synchronised = true;
    },
    maybeIsEmailColumn: function maybeIsEmailColumn(text) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(text);
    },
    createTags: function createTags(el, wait) {
      if (wait && !this.email.isPaste) {
        return;
      }
      var self = this;
      var emails = this.email.input.split(/[, ]+/);
      for (var index in emails) {
        if (emails[index] !== '') {
          var company = this.defaultCompany;
          this.userInvites.push({
            id: index,
            email: emails[index],
            role: this.defaultRole,
            title: null,
            function: null,
            firstName: null,
            lastName: null,
            phone: null,
            company: company,
            isValid: this.isValidEmail(emails[index]),
            code: 0
          });
        }
      }
      setTimeout(function () {
        self.email.isPaste = false;
        self.autoWidth(el);
        el.value = '';
        self.email.input = '';
        if (self.$refs.emailsAddWrapper) {
          self.$refs.emailsAddWrapper.scrollTop = self.$refs.emailsAddWrapper.scrollHeight;
        }
      }, 10);
    },
    changeEmail: function changeEmail(evt, index) {
      this.email.input = evt.target.innerText;
      this.userInvites.splice(index, 1);
      var el = this.$refs.inputEmails;
      setTimeout(function () {
        el.style = 'width: 10px';
        el.style = 'width:' + (el.scrollWidth + 10) + 'px';
      }, 10);
    },
    changeValid: function changeValid(item, value) {
      item.isValid = this.isValidEmail(value);
      item.email = value;
      this.autoHeight();
    },
    removeEmail: function removeEmail(index, pos) {
      this.userInvites.splice(index, pos);
      if (this.step === 1 && !this.userInvites.length) {
        this.step = 0;
      }
    },
    clearAllEmails: function clearAllEmails() {
      this.userInvites = [];
    },
    emailsKeyDown: function emailsKeyDown(evt) {
      console.log(evt.keyCode);
      if ([13, 27, 32, 188].indexOf(evt.keyCode) !== -1) {
        this.createTags(evt);
      }
      this.autoWidth(evt);
    },
    goToUsersList: function goToUsersList() {
      var usersPage = this.getUserRole === 'gm' ? 'users' : 'ca-users';
      var props = this.$router.resolve({
        name: usersPage
      });
      this.$router.push(props.href);
    },
    inviteNewUsers: function inviteNewUsers() {
      this.userInvites = [];
      this.defaultRole = null;
      this.defaultCompany = null;
      this.email = {
        input: '',
        active: false,
        isPaste: false
      };
      this.inviteType = 1;
      this.step = 0;
      this.currentStepImport = 0;
      this.response = {};
      this.status = {};
    },
    autoWidth: function autoWidth(el) {
      var target = this.getTarget(el);
      setTimeout(function () {
        if (target) {
          target.style.width = '10px';
          target.style.width = target.scrollWidth + 15 + 'px';
        }
      }, 0);
    },
    autoHeight: function autoHeight() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        if (item) {
          setTimeout(function () {
            item.style.height = '40px;';
            item.style.height = item.scrollHeight + 4 + 'px';
          }, 0);
        }
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    getTarget: function getTarget(e) {
      var evn = e || window.event;
      return evn.srcElement || e.currentTarget;
    },
    isValidEmail: function isValidEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    userHasError: function userHasError(type, item) {
      if (type === 'role') {
        return item.role === null;
      }
      if (type === 'company') {
        if (this.getUserRole === 'ca' || this.getUserRole === 'ta' || this.getUserRole === 'la') {
          return false;
        }
        return item.company === null && item.role !== null && item.role.slug !== 'gm' || item.company === null && item.role === null;
      }
    }
  }),
  created: function created() {
    document.title = 'Invite users | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted: function mounted() {
    this.getRoles();
    this.getCompanies();
    this.getProfileData();
  },

  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default.a
  },
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'invite') this.sendInvitationsConfirmed();
        this.clearConfAction();
      }
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_AppHeader__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_ConfPopup__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_ConfPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_ConfPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_InfomMsg__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_InfomMsg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_InfomMsg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_common_AppFooter__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_common_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_common_AppFooter__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['profile']), {
    isInvitePage: function isInvitePage() {
      var route = this.$route.name;
      return route === 'add-user' || route === 'ca-add-user';
    },
    isFullPage: function isFullPage() {
      var route = this.$route.name;
      return route === 'add-article' || route === 'edit-article' || route === 'add-todo' || route === 'edit-todo' || route === 'user-app' || route === 'company-tasks' || route === 'company-task' || route === 'tasks' || route === 'task' || route === 'knowledge-base' || route === 'complete-profile' || route === 'account-suspended' || route === 'renew-subscription';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['setFontSizeActive', 'setColorPaletteActive', 'getUser']), {
    redirectCheck: function redirectCheck() {
      if (!this.profile) {
        return;
      }
      var route = this.$route.name;
      var allowThis = ['admin', 'user-app', 'give-consent', 'notifications', 'logs'];
      if (this.profile.consent_status !== 1 && allowThis.indexOf(route) === -1) {
        var props = this.$router.resolve({
          name: 'give-consent'
        });
        this.$router.push(props.href);
      } else if (this.profile.company.suspended === true && route !== 'billing-profile' && route !== 'complete-profile' && route !== 'renew-subscription') {
        if (this.profile.company.subscription_end) {
          var _props = this.$router.resolve({
            name: 'account-suspended'
          });
          this.$router.push(_props.href);
        } else {
          var _props2 = this.$router.resolve({
            name: 'billing-profile'
          });
          this.$router.push(_props2.href);
        }
      } else if (this.profile.company.is_temporary && route !== 'complete-profile' && route !== 'renew-subscription') {
        var _props3 = this.$router.resolve({
          name: 'complete-profile'
        });
        this.$router.push(_props3.href);
      } else if (this.profile.password_changed === 1 && this.$route.name !== 'profile' && this.$route.name !== 'give-consent') {
        var _props4 = this.$router.resolve({
          name: 'profile'
        });
        this.$router.push(_props4.href);
      }
    }
  }),
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_2__components_common_AppHeader___default.a,
    ConfPopup: __WEBPACK_IMPORTED_MODULE_3__components_common_ConfPopup___default.a,
    InformMsg: __WEBPACK_IMPORTED_MODULE_4__components_common_InfomMsg___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_5__components_main_common_AppFooter___default.a
  },
  watch: {
    $route: function $route(to, from) {
      if (to !== from && this.getUserRole !== 'cu' && this.getUserRole !== 'sh') {
        this.redirectCheck();
      }
    },
    profile: function profile(user) {
      if (user) {
        this.redirectCheck();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if (this.userData.userRole !== 'gm' && this.$route.path === '/admin') {
      this.$router.push({
        path: '/dashboard'
      });
    }
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
  },
  created: function created() {
    this.getUser();
    if (this.getUserRole !== 'cu' && this.getUserRole !== 'sh') {
      this.redirectCheck();
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin-app',
  data: function data() {
    return {
      companies: null,
      users: null,
      topZeroSearch: null,
      topSearch: null,
      activeSection: 'dashboardCompanies'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['getUserRole'])),
  components: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])([]), {
    getCounters: function getCounters() {
      var _this = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.dashboardCounters, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.companies = res.body.companies;
        _this.users = res.body.users;
        _this.$nextTick(function () {
          _this.getTopSearch();
        });
      }).catch(function () {
        _this.disableAPI = false;
      });
    },
    getCompanyStatus: function getCompanyStatus(status) {
      var response = void 0;
      if (status === 'active') {
        response = 'Active companies';
      } else if (status === 'notactive') {
        response = 'Expired companies';
      } else {
        response = 'Archived companies';
      }
      return response;
    },
    getUserRoleName: function getUserRoleName(slug) {
      var response = void 0;
      if (slug === 'gm') {
        response = 'God mode users';
      } else if (slug === 'ca') {
        response = 'Company admin users';
      } else if (slug === 'sh') {
        response = 'Company stakeholders users';
      } else if (slug === 'ta') {
        response = 'Toolkit admin users';
      } else if (slug === 'tu') {
        response = 'Toolkit user users';
      } else if (slug === 'la') {
        response = 'Light admin users';
      } else if (slug === 'lu') {
        response = 'Light user users';
      } else {
        response = 'Regular users';
      }
      return response;
    },
    getTopZeroSearch: function getTopZeroSearch() {
      var _this2 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.topZeroSearch, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.topZeroSearch = res.body;
      }).catch(function () {
        _this2.disableAPI = false;
      });
    },
    getTopSearch: function getTopSearch() {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.topSearch, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.topSearch = res.body;
        _this3.$nextTick(function () {
          _this3.getTopZeroSearch();
        });
      }).catch(function () {
        _this3.disableAPI = false;
      });
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        element.focus();
      }
    },
    posY: function posY(elm) {
      var test = elm;
      var top = 0;
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop;
        test = test.offsetParent;
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(elem) {
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) - 10;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop <= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        var section = sections[index];
        if (section && this.isScrolledIntoView(section)) {
          this.activeSection = index;
        }
      }
    }
  }),
  watch: {},
  created: function created() {
    this.getCounters();
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    document.title = 'Admin dashboard | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  beforeMount: function beforeMount() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if (this.userData.userRole !== 'gm' && this.$route.path === '/admin') {
      this.$router.push({
        path: '/'
      });
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_forms__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_FormMessages__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_FormMessages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_FormMessages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin-management',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_forms__["a" /* default */]],
  data: function data() {
    return {
      functionOptions: ['One', 'Two'],
      formInfo: {
        username: '',
        email: '',
        plainPassword: {
          first: '',
          second: ''
        },
        function: '',
        lastName: '',
        jobTitle: ''
      },
      userRole: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['getRoles']), {
    sendFormRequest: function sendFormRequest() {
      var _this = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.createAdmin + this.userRole.value, this.formJson).then(function (res) {
        _this.submitSuccess(res.body);
      }).catch(function (err) {
        return _this.submitErrors(err.body);
      });
    }
  }),
  components: {
    FormMessages: __WEBPACK_IMPORTED_MODULE_3__components_common_FormMessages___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['getRolesForSelect'])),
  mounted: function mounted() {
    this.getRoles();
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Promotions__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Promotions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Promotions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuescroll__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuescroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuescroll__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'next-gen-dashboard',
  data: function data() {
    return {
      tasks: [],
      articles: [],
      scrollBarOptions: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: '#DCDCDC',
          opacity: '1',
          keepShow: true
        }
      },
      loadingTasks: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getUserCompany', 'taskChapters', 'taskStatuses', 'tasksPriorities', 'selectedHightCont', 'getUserId'])),
  components: {
    Promotions: __WEBPACK_IMPORTED_MODULE_3__components_common_Promotions___default.a,
    vuescroll: __WEBPACK_IMPORTED_MODULE_5_vuescroll___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getTaskChapters', 'getTaskStatuses']), {
    getTasks: function getTasks() {
      var _this = this;

      var filters = {
        assignee: [this.getUserId]
      };
      var actionURL = __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.task + '/all/backlog?filters=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filters));
      this.$http.get('' + actionURL, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        for (var board in res.body) {
          if (res.body.hasOwnProperty(board)) {
            if (res.body[board].slug === 'completed') {
              continue;
            }
            _this.tasks = _this.tasks.concat(res.body[board].tasks);
          }
        }
        _this.loadingTasks = false;
      }).catch(function (err) {
        _this.loadingTasks = false;
        console.log(err);
      });
    },
    getChapterById: function getChapterById(id) {
      return this.taskChapters.find(function (item) {
        return item.id === id;
      });
    },
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    getStatusById: function getStatusById(id) {
      var status = this.taskStatuses.find(function (item) {
        return item.id === id;
      });
      return status || false;
    },
    taskPriorityDelta: function taskPriorityDelta(value) {
      var priorityDelta = 0;
      if (value <= 33) {
        priorityDelta = 0;
      } else if (value > 33 && value <= 66) {
        priorityDelta = 1;
      } else if (value > 66 && value <= 100) {
        priorityDelta = 2;
      }
      return priorityDelta;
    },
    taskPriorityLabelByValue: function taskPriorityLabelByValue(value) {
      var priority = this.tasksPriorities.find(function (item) {
        return item.value === value;
      });
      return priority ? priority.label : '';
    },
    getArticles: function getArticles() {
      var _this2 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.contentLatest + '?page=1&limit=10', {}, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.articles = res.body.data.items || [];
      }).catch(function () {});
    },
    articleText: function articleText(text) {
      if (!text) {
        return '';
      }
      text = text.replace(/(<([^>]+)>)/gi, '');
      if (text.length > 174) {
        text = text.substring(0, 174) + '...';
      }
      return text;
    }
  }),
  created: function created() {
    document.title = 'Dashboard | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
    this.getTasks();
    this.getArticles();
    this.getTaskChapters(this.getUserCompany);
    this.getTaskStatuses(this.getUserCompany);
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'security-configuration',
  data: function data() {
    return {
      allowedItems: [],
      selectedInfo: {
        disallowed: {
          actionId: null,
          actionName: null,
          roleUser: null
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['actions', 'roles']), {
    selectedInfoJson: function selectedInfoJson() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedInfo);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['getActions', 'getRoles']), {
    checkIdLength: function checkIdLength(actionId, roleId) {
      return this.allowedItems.filter(function (item) {
        return item.actionId === actionId;
      }).filter(function (item) {
        return item.roleUser.id === roleId;
      }).length;
    },
    sendRequest: function sendRequest() {
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.actionsURLS.disallowed, this.selectedInfoJson, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        return console.log(res);
      }).catch(function (err) {
        return console.log(err);
      });
    },
    select: function select(actionId, actionName, role) {
      this.selectedInfo.disallowed.actionId = actionId;
      this.selectedInfo.disallowed.actionName = actionName;
      this.selectedInfo.disallowed.roleUser = role;
      this.sendRequest();
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.getActions();
    this.getRoles();
    this.$http.get('' + __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverURL + __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.actionsURLS.permissions, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
      console.log('permissions', res);
      _this.allowedItems = res.body;
    });
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'articles-list',
  data: function data() {
    return {
      ppt: 15,
      offset: 15,
      articles: [],
      selectedAction: null,
      contentAutoloadInfo: {
        numPages: 1,
        locked: false
      },
      search: '',
      searchByName: '',
      contentType: [],
      tags: [],
      categories: [],
      roles: [],
      companies: [],
      industries: [],
      lastEdited: [],
      status: [],
      datepicker: {
        isShown: false,
        from: null,
        to: null
      },
      statusbar: {
        published: 0,
        archived: 0,
        draft: 0,
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      articleOrderBy: {
        type: 'edited',
        order: false
      },
      editedArticles: [],
      articleTypeList: [],
      articleTagList: [],
      articleCategoryList: [],
      // articleRoleList: [],
      articleCompanyList: [],
      articleIndustryList: [],
      articleStatusList: [],
      downloadInProcess: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])(['setInformationMsg']), {
    csvExport: function csvExport() {
      var _this = this;

      this.downloadInProcess = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.content + '/documents/export', __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.downloadInProcess = false;
        var hiddenElement = document.getElementById('dataDownload');
        hiddenElement.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURI(res.body));
        hiddenElement.setAttribute('download', _this.getDocumentsDownloadName());
        hiddenElement.click();
      }).catch(function (err) {
        _this.downloadInProcess = false;
        console.log(err);
      });
    },
    tableExport: function tableExport(arrData) {
      var csvContent = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(arrData[0]).map(function (item) {
        return '"' + item + '"';
      }).join(',')].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(arrData.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(item).map(function (item) {
          return '"' + item + '"';
        }).join(',');
      }))).join('\n').replace(/(^\[)|(\]$)/gm, '');

      var csvData = new Blob([csvContent], {
        type: 'application/csv;charset=utf-8;'
      });

      var documentName = this.getTableDataDownloadName();

      if (window.navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, documentName);
      } else {
        var csvUrl = URL.createObjectURL(csvData);
        var link = document.getElementById('dataDownload');
        link.setAttribute('href', csvUrl);
        link.setAttribute('download', documentName);
        link.click();
      }
    },
    getDocumentsDownloadName: function getDocumentsDownloadName() {
      var date = new Date();
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      month = months[month - 1];
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + month + fullYear;
      var timeString = toDoubleDigit(hours) + 'h' + toDoubleDigit(minutes) + 'm';
      return 'ContentDocuments' + '-' + dateString + '-' + timeString + '.csv';
    },
    getTableDataDownloadName: function getTableDataDownloadName() {
      var date = new Date();
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      month = months[month - 1];
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + month + fullYear;
      var timeString = toDoubleDigit(hours) + 'h' + toDoubleDigit(minutes) + 'm';
      return 'Resources' + '-' + dateString + '-' + timeString + '.csv';
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
    },
    changeOrderBy: function changeOrderBy(type, order) {
      this.articleOrderBy = {
        type: type,
        order: this.articleOrderBy !== null ? !this.articleOrderBy.order : order
      };
    },
    editArticle: function editArticle(id) {
      var props = this.$router.resolve({
        name: 'edit-article',
        params: { id: id }
      });
      location.href = props.href;
    },
    searchByParams: function searchByParams(page, limit) {
      var _this2 = this;

      this.contentAutoloadInfo.curPage = page;
      var body = {
        isArticle: true
      };
      this.lastEdited.forEach(function (item) {
        if (item.from) {
          body.from = item.from;
        }
        if (item.to) {
          body.to = item.to;
        }
      });
      this.$eventHub.$emit('load-end');
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.contentSearch + '?page=' + page + '&limit=' + limit, body, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.data.items.length < true) {
          _this2.$eventHub.$emit('load-end');
          _this2.$eventHub.$emit('load-stop');
        } else {
          _this2.$eventHub.$emit('load-start');
        }
        _this2.contentAutoloadInfo.curPage = res.body.data.current_page_number;
        _this2.contentAutoloadInfo.numPages = Math.ceil(res.body.data.total_count / limit) !== 0 ? Math.ceil(res.body.data.total_count / limit) : 1;
        if (page === 1) {
          _this2.articles = res.body.data.items;
        } else {
          _this2.articles = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this2.articles), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(res.body.data.items));
        }
        var count = res.body.status;
        _this2.statusbar.published = count.Published.count;
        _this2.statusbar.draft = count.Draft.count;
        _this2.statusbar.archived = count.Archived.count;
      }).catch(function () {
        _this2.contentAutoloadInfo.locked = false;
      });
    },
    getStatus: function getStatus(st) {
      switch (st) {
        case 0:
          return 'Draft';
        case 1:
          return 'Published';
        case 2:
          return 'Archived';
        default:
          return '';
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      var _this3 = this;

      if (this.searchByName) {
        this.searchByName = '';
      }
      this.contentType.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.contentType.splice(i, 1);
          return;
        }
      });
      this.categories.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.categories.splice(i, 1);
          return;
        }
      });
      this.tags.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.tags.splice(i, 1);
          return;
        }
      });
      this.roles.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.roles.splice(i, 1);
          return;
        }
      });
      this.companies.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.companies.splice(i, 1);
          return;
        }
      });
      this.industries.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.industries.splice(i, 1);
          return;
        }
      });
      this.lastEdited.forEach(function (item, i) {
        if (item.id === null && item.label === filter.label) {
          _this3.lastEdited.splice(i, 1);
          return;
        }
      });
      this.status.forEach(function (item, i) {
        if (item.value === filter.value && item.label === filter.label) {
          _this3.status.splice(i, 1);
          return;
        }
      });
    },
    removeAllFilters: function removeAllFilters() {
      this.searchByName = '';
      this.contentType = [];
      this.categories = [];
      this.tags = [];
      this.roles = [];
      this.companies = [];
      this.industries = [];
      this.lastEdited = [];
      this.status = [];
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },

    // articleRoles (roles) {
    //   let string = ''
    //   roles.forEach(role => {
    //     string += role.name + '</br>'
    //   })
    //   return string
    // },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])([]), {
    csvData: function csvData() {
      var dataForExport = this.editedArticles;
      var self = this;
      return dataForExport.map(function (item) {
        var roles = '';
        var companies = '';
        var industries = '';
        for (var i = 0; i < item.roles.length; i++) {
          roles += item.roles[i].name;
          if (i < item.roles.length - 1) {
            roles += '\n';
          }
        }
        for (var _i = 0; _i < item.companies.length; _i++) {
          companies += item.companies[_i].name;
          if (_i < item.companies.length - 1) {
            companies += '\n';
          }
        }
        for (var _i2 = 0; _i2 < item.industries.length; _i2++) {
          industries += item.industries[_i2].name;
          if (_i2 < item.industries.length - 1) {
            industries += '\n';
          }
        }
        return {
          'Id': item.id,
          'Name': item.title,
          'Type': item.content_type.type,
          'Topics': item.tags.length ? item.tags[0].name : 'n/a',
          'Category': item.categories.length ? item.categories[0].title : 'n/a',
          'Access': roles,
          'Company specific': companies,
          'Industry specific': industries,
          'Last edited': self.convertDate(item.updated_at, '.'),
          'Status': self.getStatus(item.status)
        };
      });
    },
    selectedFilters: function selectedFilters() {
      var searchByName = [];
      if (this.searchByName) {
        searchByName.push({
          id: null,
          type: 'name',
          label: this.searchByName
        });
      }
      return [].concat(searchByName, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.contentType), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.categories), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.tags), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.roles), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.companies), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.industries), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.lastEdited), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.status));
    },
    getContentTypeForSelect: function getContentTypeForSelect() {
      return this.articleTypeList;
    },
    getTagsForSelect: function getTagsForSelect() {
      return this.articleTagList;
    },
    getCategoriesForSelect: function getCategoriesForSelect() {
      return this.articleCategoryList;
    },

    // getRolesForSelect () {
    //   return this.articleRoleList
    // },
    getCompaniesForSelect: function getCompaniesForSelect() {
      return this.articleCompanyList;
    },
    getIndustriesForSelect: function getIndustriesForSelect() {
      return this.articleIndustryList;
    },
    getStatusesForSelect: function getStatusesForSelect() {
      return this.articleStatusList;
    },
    filteredArticles: function filteredArticles() {
      var _this4 = this;

      var result = this.articles;
      result = this.articles.filter(function (article) {
        return (article.id + ' ' + article.title).toLowerCase().indexOf(_this4.searchByName.toLowerCase()) > -1;
      }).filter(function (article) {
        return _this4.contentType.length === 0 || article.content_type && _this4.contentType.find(function (type) {
          return type.value === article.content_type.id;
        });
      }).filter(function (article) {
        return _this4.companies.length === 0 || article.companies.length && _this4.companies.find(function (company) {
          return article.companies.find(function (articleCompany) {
            return articleCompany.id === company.value;
          });
        });
      }).filter(function (article) {
        return _this4.industries.length === 0 || article.industries.length && _this4.industries.find(function (industry) {
          return article.industries.find(function (articleIndustry) {
            return articleIndustry.id === industry.value;
          });
        });
      }).filter(function (article) {
        return _this4.categories.length === 0 || article.categories.length && _this4.categories.find(function (category) {
          return article.categories.find(function (articleCategory) {
            return articleCategory.id === category.value;
          });
        });
      }).filter(function (article) {
        return _this4.tags.length === 0 || article.tags.length && _this4.tags.find(function (tag) {
          return article.tags.find(function (articleTag) {
            return articleTag.id === tag.value;
          });
        });
      }).filter(function (article) {
        return _this4.roles.length === 0 || article.roles.length && _this4.roles.find(function (role) {
          return article.roles.find(function (articleRole) {
            return articleRole.id === role.value;
          });
        });
      }).filter(function (article) {
        return _this4.status.length === 0 || _this4.status.find(function (st) {
          return st.value === article.status;
        });
      });
      if (this.articleOrderBy !== null) {
        var ascDesc = this.articleOrderBy.order ? 1 : -1;
        return result.sort(function (a, b) {
          return ascDesc * (new Date(a.updated_at) - new Date(b.updated_at));
        });
      } else {
        return result;
      }
    }
  }),
  watch: {
    filteredArticles: function filteredArticles() {
      var _this5 = this;

      this.offset = this.ppt;
      var editedArticles = [];
      this.articleTypeList = [];
      this.articleTagList = [];
      this.articleCategoryList = [];
      // this.articleRoleList = []
      this.articleCompanyList = [];
      this.articleIndustryList = [];
      this.articleStatusList = [];
      this.offset = this.ppt;
      this.filteredArticles.forEach(function (article) {
        if (article.content_type) {
          var _index = _this5.articleTypeList.findIndex(function (x) {
            return x.value === article.content_type.id;
          });
          if (_index === -1) {
            _this5.articleTypeList.push({
              label: article.content_type.type,
              value: article.content_type.id
            });
          }
        }
        if (article.tags.length) {
          article.tags.forEach(function (tag) {
            var index = _this5.articleTagList.findIndex(function (x) {
              return x.value === tag.id;
            });
            if (index === -1) {
              _this5.articleTagList.push({
                label: tag.name,
                value: tag.id
              });
            }
          });
        }
        if (article.categories.length) {
          article.categories.forEach(function (category) {
            var index = _this5.articleCategoryList.findIndex(function (x) {
              return x.value === category.id;
            });
            if (index === -1) {
              _this5.articleCategoryList.push({
                label: category.title,
                value: category.id
              });
            }
          });
        }
        // if (article.roles.length) {
        //   article.roles.forEach((role) => {
        //     let index = this.articleRoleList.findIndex(x => x.value === role.id)
        //     if (index === -1) {
        //       this.articleRoleList.push({
        //         label: role.name,
        //         value: role.id
        //       })
        //     }
        //   })
        // }
        if (article.companies.length) {
          article.companies.forEach(function (company) {
            var index = _this5.articleCompanyList.findIndex(function (x) {
              return x.value === company.id;
            });
            if (index === -1) {
              _this5.articleCompanyList.push({
                label: company.name,
                value: company.id
              });
            }
          });
        }
        if (article.industries.length) {
          article.industries.forEach(function (industry) {
            var index = _this5.articleIndustryList.findIndex(function (x) {
              return x.value === industry.id;
            });
            if (index === -1) {
              _this5.articleIndustryList.push({
                label: industry.name,
                value: industry.id
              });
            }
          });
        }
        var index = _this5.articleStatusList.findIndex(function (x) {
          return x.value === article.status;
        });
        if (index === -1) {
          _this5.articleStatusList.push({
            label: _this5.getStatus(article.status),
            value: article.status
          });
        }
        editedArticles.push(article);
      });
      this.editedArticles = editedArticles;
    }
  },
  mounted: function mounted() {
    this.searchByParams(1, 1000);
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  created: function created() {
    document.title = 'All Resources | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },

  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default.a
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'badge',
  data: function data() {
    return {
      companyId: null,
      companyPoints: null,
      companyAverage: 0,
      badgeTheme: null,
      badgeReady: false
    };
  },

  methods: {
    getCompany: function getCompany() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].URLS.companyPublic + '/' + this.companyId, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.companyPoints = res.body;
        var total = 0;
        for (var index in _this.companyPoints) {
          var quarter = _this.companyPoints[index];
          _this.setCompanyProgress(quarter, index);
          total += quarter;
        }
        _this.companyAverage = total / 4;
        _this.badgeReady = true;
      });
    },
    getCompanyLevel: function getCompanyLevel(returnThis) {
      var score = this.companyAverage;
      var level = void 0;
      if (score >= 0) {
        level = {
          name: 'Foundation',
          color: '#97eedd'
        };
      }
      if (score > 19) {
        level = {
          name: 'Bronze',
          color: '#ffdbb4'
        };
      }
      if (score > 39) {
        level = {
          name: 'Silver',
          color: '#e8e8e8'
        };
      }
      if (score > 59) {
        level = {
          name: 'Gold',
          color: '#ffe993'
        };
      }
      if (score > 79) {
        level = {
          name: 'Platinum',
          color: '#7fdce8'
        };
      }
      return level[returnThis];
    },
    setCompanyProgress: function setCompanyProgress(value, index) {
      var RADIUS = 38;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      var progressValue = document.querySelector('.progress__value' + '-' + index);
      var progress = value / 100 / 4;
      progressValue.style.display = 'block';
      progressValue.style.strokeDasharray = CIRCUMFERENCE;
      progressValue.style.strokeDashoffset = CIRCUMFERENCE * (1 - progress);
    },
    getUrlParameter: function getUrlParameter(name) {
      name = name.replace(/[/]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('hide-cookie-accept');
  },
  created: function created() {
    this.companyId = this.getUrlParameter('company');
    this.badgeTheme = this.getUrlParameter('theme');
    this.getCompany();
    document.body.classList.add('hide-cookie-accept');
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'billing-profile',
  props: {
    embeddedCompanyId: {
      type: Number,
      required: false
    },
    embedded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditBillingContact: false,
      canEditBillingDetails: false,
      canEditPayment: false,
      company: {
        billingContactData: {
          firstName: '',
          lastName: '',
          phone: '',
          email: ''
        },
        billingDetailsData: {
          organisationName: '',
          type: '',
          vat: '',
          county: '',
          street: '',
          postalCode: '',
          city: '',
          country: '',
          disconnectedFromBilling: null
        }
      },
      initialData: {
        billingContactData: {
          firstName: '',
          lastName: '',
          phone: '',
          email: ''
        },
        billingDetailsData: {
          organisationName: '',
          organisationType: '',
          organisationVat: '',
          addressCounty: '',
          addressStreet: '',
          addressPostalCode: '',
          addressCity: '',
          addressCountry: '',
          disconnectedFromBilling: null
        }
      },
      canLeave: false,
      isChanged: false,
      companyId: null,
      activeSection: 'subscriptionDetails',
      currentPlan: null,
      invoices: [],
      invoicesToBePaid: null,
      payment: {
        error: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['profile', 'getUserRole', 'getUserCompany', 'companyOrganizationTypes', 'companySizes', 'getConfData']), {
    vatDisplay: function vatDisplay() {
      return this.subscriptionDetails && this.subscriptionDetails.billingDetailsData && this.subscriptionDetails.billingDetailsData.addressCountry && this.subscriptionDetails.billingDetailsData.addressCountry.toLowerCase() === 'united kingdom';
    },
    planPrice: function planPrice() {
      // if (!this.currentPlan.price) {
      //   return ''
      // }
      // if (!this.vatDisplay) {
      //   return this.currentPlan.price
      // }
      // return parseFloat(this.currentPlan.price) + (parseFloat(this.currentPlan.price) * 0.2)
      return this.currentPlan.price || '';
    },
    currentPlanSubscriptionPaymentPeriod: function currentPlanSubscriptionPaymentPeriod() {
      if (!this.currentPlan) {
        return '';
      }
      var text = '';
      if (this.currentPlan.paymentPeriodUnit === 0) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          text = '1 month';
        } else {
          text = this.currentPlan.paymentPeriodValue + ' months';
        }
      } else if (this.currentPlan.paymentPeriodUnit === 1) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          text = '1 year';
        } else {
          text = this.currentPlan.paymentPeriodValue + ' years';
        }
      }
      return text;
    },
    currentPlanSize: function currentPlanSize() {
      var _this = this;

      if (!this.currentPlan) {
        return '';
      }
      var size = this.companySizes.find(function (s) {
        return s.min === _this.currentPlan.minSize;
      });
      if (!size) {
        return '';
      }
      return size.label;
    },
    currentPlanPaymentPeriod: function currentPlanPaymentPeriod() {
      if (!this.currentPlan) {
        return '';
      }
      if (this.currentPlan.paymentPeriodUnit === 0) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          return 'Monthly';
        } else {
          return 'Every ' + this.currentPlan.paymentPeriodValue + ' months';
        }
      } else if (this.currentPlan.paymentPeriodUnit === 1) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          return 'Yearly';
        } else {
          return 'Every ' + this.currentPlan.paymentPeriodValue + ' years';
        }
      }
    },
    currentPlanCommitment: function currentPlanCommitment() {
      if (!this.currentPlan) {
        return '';
      }
      var text = void 0;
      if (this.currentPlan.commitment === 1) {
        text = '1 Year';
      } else if (this.currentPlan.commitment === 3) {
        text = '3 Years';
      } else {
        text = 'No commitment';
      }
      return text;
    },
    nextPaymentDate: function nextPaymentDate() {
      if (this.profile && this.profile.company.suspended && !this.profile.company.subscription_end) {
        return 'n/a';
      }
      if (!this.currentPlan || !this.currentPlan.expiryOn) {
        return 'n/a';
      }
      var expiryOn = new Date(this.currentPlan.expiryOn);
      if (isNaN(expiryOn) || isNaN(Date.parse(expiryOn))) {
        return 'n/a';
      }
      var dd = String(expiryOn.getDate()).padStart(2, '0');
      var mm = String(expiryOn.getMonth() + 1).padStart(2, '0');
      var yyyy = expiryOn.getFullYear();
      return dd + '.' + mm + '.' + yyyy;
    },
    commitmentExpiryDate: function commitmentExpiryDate() {
      if (this.profile && this.profile.company.suspended && !this.profile.company.subscription_end) {
        return 'n/a';
      }
      if (!this.currentPlan || !this.currentPlan.commitmentExpiryOn) {
        return 'n/a';
      }
      var commitmentExpiryOn = new Date(this.currentPlan.commitmentExpiryOn);
      if (isNaN(commitmentExpiryOn) || isNaN(Date.parse(commitmentExpiryOn))) {
        return 'n/a';
      }
      var dd = String(commitmentExpiryOn.getDate()).padStart(2, '0');
      var mm = String(commitmentExpiryOn.getMonth() + 1).padStart(2, '0');
      var yyyy = commitmentExpiryOn.getFullYear();
      return dd + '.' + mm + '.' + yyyy;
    },
    stripeBillingUrl: function stripeBillingUrl() {
      if (!this.invoicesToBePaid || Array.isArray(this.invoicesToBePaid) && this.invoicesToBePaid.length === 0) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].billingServerURL + '/stripe-payment/' + this.companyId + '?check=0dce2bbbc190a8efb559d6dc892f677c&renew=true&invoice=' + this.invoicesToBePaid[0];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'authLogout', 'getCompanyOrganizationTypes', 'getCompanySizes', 'initConfAction']), {
    getCompanyVariation: function getCompanyVariation() {
      var _this2 = this;

      if (!this.companyId) {
        return;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.variation + '/company/' + this.companyId, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (!res.body.hasOwnProperty('success')) {
          _this2.currentPlan = res.body;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    openEditBillingContact: function openEditBillingContact() {
      this.canEditBillingContact = true;
    },
    openEditBillingDetails: function openEditBillingDetails() {
      this.canEditBillingDetails = true;
    },
    openEditPayment: function openEditPayment() {
      this.canEditPayment = true;
    },
    closeEditBillingContact: function closeEditBillingContact() {
      this.company.billingContactData = this.initialData.billingContactData;
      this.canEditBillingContact = false;
      this.errors.clear();
    },
    closeEditBillingDetails: function closeEditBillingDetails() {
      this.company.billingDetailsData = this.initialData.billingDetailsData;
      this.canEditBillingDetails = false;
      this.errors.clear();
    },
    closeEditPayment: function closeEditPayment() {
      this.canEditPayment = false;
      this.payment.error = null;
    },
    closeMsg: function closeMsg() {
      if (this.errors) {
        this.errors.clear();
      }
    },
    fieldChange: function fieldChange() {
      this.isChanged = true;
    },
    getCompanyData: function getCompanyData() {
      var _this3 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, { id: this.companyId }, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var subscriptionDetails = _this3.company;
        // company billing contact
        subscriptionDetails.billingContactData.firstName = res.body.billing_first_name;
        subscriptionDetails.billingContactData.lastName = res.body.billing_last_name;
        subscriptionDetails.billingContactData.phone = res.body.billing_phone;
        subscriptionDetails.billingContactData.email = res.body.billing_email;
        // company billing details
        subscriptionDetails.billingDetailsData.organisationName = res.body.billing_company_name;
        subscriptionDetails.billingDetailsData.organisationType = res.body.billing_company_type;
        subscriptionDetails.billingDetailsData.organisationVat = res.body.billing_company_vat;
        subscriptionDetails.billingDetailsData.addressCounty = res.body.billing_address_county;
        subscriptionDetails.billingDetailsData.addressStreet = res.body.billing_address_street;
        subscriptionDetails.billingDetailsData.addressPostalCode = res.body.billing_address_postal_code;
        subscriptionDetails.billingDetailsData.addressCity = res.body.billing_address_city;
        subscriptionDetails.billingDetailsData.addressCountry = res.body.billing_address_country;
        subscriptionDetails.billingDetailsData.disconnectedFromBilling = res.body.disconnected_from_billing;
        _this3.subscriptionDetails = subscriptionDetails;
        // set initial data
        _this3.initialData = subscriptionDetails;

        document.title = 'Billing details | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this3.$router.resolve({
            name: 'error'
          });
          _this3.$router.push(props.href);
        }
        if (err.status === 401) {
          _this3.authLogout();
        }
      });
    },
    updateCompanyBillingContactData: function updateCompanyBillingContactData() {
      var _this4 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var billing = {
        id: this.companyId,
        billingFirstName: this.company.billingContactData.firstName,
        billingLastName: this.company.billingContactData.lastName,
        billingPhoneNumber: this.company.billingContactData.phone,
        billingEmail: this.company.billingContactData.email
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, billing, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = res.body.name + ' organisation billing contact was successfully updated.';
        _this4.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this4.infMsgClass = 'success';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.getCompanyData();
        _this4.canEditBillingContact = !_this4.canEditBillingContact;
      }).catch(function (err) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = 'Error. We were not able to update this company billing contact because ';
        for (var error in err.body.error.exception) {
          _this4.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this4.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this4.infMsgClass = 'error';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.getCompanyData();
      });
    },
    updateCompanyBillingDetailsData: function updateCompanyBillingDetailsData() {
      var _this5 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var billing = {
        id: this.companyId,
        billingCompanyName: this.company.billingDetailsData.organisationName,
        billingCompanyType: this.company.billingDetailsData.organisationType,
        billingCompanyVat: this.company.billingDetailsData.organisationVat,
        billingAddressCounty: this.company.billingDetailsData.addressCounty,
        billingAddressStreet: this.company.billingDetailsData.addressStreet,
        billingAddressPostalCode: this.company.billingDetailsData.addressPostalCode,
        billingAddressCity: this.company.billingDetailsData.addressCity,
        billingAddressCountry: this.company.billingDetailsData.addressCountry
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, billing, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = res.body.name + ' organisation billing details was successfully updated.';
        _this5.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this5.infMsgClass = 'success';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getCompanyData();
        _this5.canEditBillingDetails = !_this5.canEditBillingDetails;
      }).catch(function (err) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = 'Error. We were not able to update this company billing details because ';
        for (var error in err.body.error.exception) {
          _this5.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this5.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this5.infMsgClass = 'error';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getCompanyData();
      });
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(function () {
          element.focus();
        });
      }
    },
    posY: function posY(elm) {
      var test = elm;
      var top = 0;
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop;
        test = test.offsetParent;
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(elem) {
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        var section = sections[index];
        if (section && this.isScrolledIntoView(section)) {
          this.activeSection = index;
        }
      }
    },
    convertDate: function convertDate(payload, separator) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + separator + toDoubleDigit(month) + separator + fullYear;
    },
    getInvoices: function getInvoices() {
      var _this6 = this;

      var url = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyInvoice + '/list';
      if (this.embedded) {
        url += '?companyId=' + this.companyId;
      }
      this.$http.get(url, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this6.invoices = res.body.items || [];
        _this6.invoices = _this6.invoices.filter(function (invoice) {
          return invoice.columns.status !== 'Authorised';
        });
        // this.invoices = this.invoices.map(i => {
        //   if (i.columns.status !== 'Paid' && i.columns.dueDate) {
        //     const dueDate = new Date(i.columns.dueDate.text)
        //     if (dueDate < new Date()) {
        //       i.columns.expired = true
        //     }
        //     i.columns.status = `Due on ${this.convertDate(i.columns.dueDate.text, '.')}`
        //   }
        //   return i
        // })
      }).catch(function (err) {
        console.log(err);
      });
    },
    downloadInvoice: function downloadInvoice(invoiceId) {
      var url = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyInvoice + '/download/' + invoiceId;
      if (this.embedded) {
        url += '?companyId=' + this.companyId;
      }
      this.$http.get(url, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.file && res.body.file.data) {
          var a = document.createElement('a');
          a.href = 'data:application/pdf;base64,' + res.body.file.data;
          a.download = res.body.file.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    initCancelSubscription: function initCancelSubscription() {
      this.confOpened = 'disconnectFromBilling';
      this.initConfAction({
        actionName: 'disconnectCompanyFromBilling'
      });
    },
    cancelSubscription: function cancelSubscription() {
      var _this7 = this;

      var id = this.companyId;
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyDisconnectedFromBilling + '/' + id, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.company.billingDetailsData.disconnectedFromBilling = true;
        _this7.disableAPI = false;
        _this7.getCompanyData();
      }).catch(function (err) {
        _this7.disableAPI = false;
        if (err.body.message) {
          _this7.infMsgTitle = 'Error. We were not able to cancel subscription because: ' + err.body.message;
        } else {
          _this7.infMsgTitle = 'Error. We were not able to cancel subscription because: ';
          for (var error in err.body.error.exception) {
            _this7.infMsgTitle += err.body.error.exception[error].message + ' ';
          }
        }
        _this7.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this7.infMsgClass = 'error';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
      });
      this.getConfData.actionConfirmed = false;
    },
    getCompanyActiveInvoice: function getCompanyActiveInvoice() {
      var _this8 = this;

      this.disableAPI = true;
      this.$http.get('' + __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.getCompanyActiveInvoice, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this8.disableAPI = false;
        if (res.body && Array.isArray(res.body) && res.body.length > 0) {
          _this8.invoicesToBePaid = res.body;
        }
      }).catch(function () {
        _this8.disableAPI = false;
      });
      this.getConfData.actionConfirmed = false;
    },
    paymentIframeActioned: function paymentIframeActioned() {
      this.$validator.validateAll(['Terms of service']).then(function (success) {
        if (!success) {
          // const termsOfService = document.getElementById('complete-profile-terms-of-service')
          // if (termsOfService) {
          //   termsOfService.scrollIntoView({
          //     behavior: 'auto',
          //     block: 'center',
          //     inline: 'center'
          //   })
          // }
        }
      });
    }
  }),
  components: {},
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'disconnectFromBilling') this.cancelSubscription();
        this.clearConfAction();
      }
    }
  },
  created: function created() {
    var _this9 = this;

    this.companyId = !this.embedded ? this.getUserCompany : this.embeddedCompanyId;
    this.getCompanyVariation();
    this.getCompanyData();
    this.getCompanyOrganizationTypes();
    this.getCompanySizes();
    this.getInvoices();
    this.getCompanyActiveInvoice();
    var myEventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var myEventListener = window[myEventMethod];
    var myEventMessage = myEventMethod === 'attachEvent' ? 'onmessage' : 'message';
    myEventListener(myEventMessage, function (e) {
      var iframe = document.getElementById('stripePaymentIframe');
      if (!iframe) {
        return;
      }
      var isError = /^payment_process_error::/.test(e.data);
      if (e.data === 'payment_process_started') {
        iframe.classList.add('payment_process_started');
        document.body.style.overflow = 'hidden';
      } else if (e.data === 'payment_process_succeeded' || isError) {
        iframe.classList.remove('payment_process_started');
        document.body.style.overflow = '';
        if (isError) {
          _this9.payment.error = e.data.replace('payment_process_error::', '');
        } else {
          _this9.setInformationMsg({
            isShown: true,
            title: 'Subscription successfully paid',
            text: 'Subscription successfully paid text',
            className: 'success'
          });
          _this9.closeEditPayment();
          _this9.invoicesToBePaid = null;
          _this9.getCompanyActiveInvoice();
          _this9.getCompanyVariation();
        }
      }
    }, false);
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_plus__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_search__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_pencil__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_folder__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_times__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_chevron_up__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_chevron_down__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'categories-list',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      categories: [],
      updatedCategories: [],
      contentAutoloadInfo: {
        curPage: 1,
        numPages: 1,
        locked: false
      },
      newCategory: {
        title: '',
        isActive: 1,
        description: '',
        parent: '',
        icon: ''
      },
      disableAPI: false,
      searchString: '',
      parent: null,
      statusbar: {
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["mapActions"])(['getCategories', 'setInformationMsg', 'clearConfAction', 'initConfAction']), {
    displayAddForm: function displayAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    closeAddForm: function closeAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    search: function search() {
      if (!this.filter.search) {
        this.contentInfo.typeAutoLoad = 'allContent';
        this.fetchAllContentByScroll(1, 200);
        return;
      }
      this.contentInfo.typeAutoLoad = 'searchContent';
      this.fetchSearchContent();
    },
    fetchSearchContent: function fetchSearchContent() {
      var _this = this;

      if (!this.filter.search) return;
      var queryString = '' + __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.search;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (item) {
        var value = _this.filter[item];
        if (value && typeof value === 'string') {
          queryString += '&search=' + value;
        }
        if (value !== null && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && value.length) {
          var subString = '';
          value.forEach(function (it) {
            subString += '&' + item + '=' + it.value;
          });
          queryString += subString;
        }
      });
      if (this.contentType.length) queryString += '&contentType=' + this.contentType[0].value;
      this.$http.get('' + queryString, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var resData = res.body.data.items;
        if (!resData) {
          _this.articles = [];
          return;
        }
        _this.articles = resData;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    removeCategory: function removeCategory(id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeCategoryById'
      });
    },
    removeCategoryConfirmed: function removeCategoryConfirmed(id) {
      var self = this;
      var thisCategory = this.updatedCategories.find(function (category) {
        return category.id === id;
      });
      this.getCategories();
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.category + '/' + id, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.infMsgTitle = thisCategory.title + ' category was successfully deleted.';
        self.infMsgDescription = 'Please note all actions are being logged.';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        for (var i = 0; i < self.categories.length; i++) {
          if (self.categories[i].id === id) {
            self.categories.splice(i, 1);
            break;
          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    handleScroll: function handleScroll(event) {
      var scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
      var fullScrolledValue = window.pageYOffset + window.innerHeight;

      if (fullScrolledValue > scrollHeight - 200) {
        this.fetchAllContentByScroll(++this.contentAutoloadInfo.curPage, 200);
      }
    },
    fetchAllContentByScroll: function fetchAllContentByScroll(page, limit) {
      var _this2 = this;

      if (this.contentAutoloadInfo.locked || this.contentAutoloadInfo.curPage > this.contentAutoloadInfo.numPages) return;
      this.contentAutoloadInfo.locked = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.categories1 + '?limit=' + limit + '&page=' + page, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.contentAutoloadInfo.curPage = res.body.current_page_number;
        _this2.contentAutoloadInfo.numPages = Math.ceil(res.body.total_count / limit);
        _this2.categories = _this2.expendCategories(res.body.items.filter(function (item) {
          return !item.parent;
        }));
        _this2.contentAutoloadInfo.locked = false;
      }).catch(function (err) {
        _this2.contentAutoloadInfo.locked = false;
        console.log(err);
      });
    },
    expendCategories: function expendCategories(categories) {
      var result = [];
      categories.forEach(function (item) {
        result.push(item);
        if (item.children.length) {
          item.children.forEach(function (child) {
            var curChild = child;
            curChild.isChild = true;
            curChild.parent = {
              label: item.title,
              value: item.id
            };
            result.push(curChild);
          });
        }
      });
      return result;
    },
    createCategory: function createCategory() {
      var _this3 = this;

      if (this.disableAPI) return;
      if (!this.newCategory.title) return;
      var formData = new FormData();
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.newCategory).forEach(function (fieldName) {
        if (typeof _this3.newCategory[fieldName] === 'string' || typeof _this3.newCategory[fieldName] === 'number') {
          formData.append('category[' + fieldName + ']', _this3.newCategory[fieldName]);
        }
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_this3.newCategory[fieldName]) === 'object' && fieldName !== 'parent') {
          _this3.newCategory[fieldName].forEach(function (item, i) {
            formData.append('category[' + fieldName + '][' + i + ']', item.value);
          });
        }
      });
      if (this.newCategory.parent) {
        formData.append('category[parent]', this.newCategory.parent.value);
      }
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.category, formData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = _this3.newCategory.title + ' category was successfully added.';
        _this3.infMsgDescription = 'Please note all actions are being logged.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.newCategory.title = '';
        _this3.newCategory.parent = null;
        _this3.newCategory.description = '';
        _this3.newCategory.icon = '';
        _this3.addFormDisplay = false;
        _this3.fetchAllContentByScroll(1, 200);
        _this3.getCategories;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log(err);
      });
    },
    showEditionForm: function showEditionForm(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedCategories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var category = _step.value;

          if (category.type === 'edit') category.type = null;
          if (category.id === id && category.type === null) {
            category.type = 'edit';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    editCategory: function editCategory(id) {
      var _this4 = this;

      if (this.disableAPI) return;
      var category = this.updatedCategories.find(function (category) {
        return category.id === id && category.type === 'edit';
      });
      var formData = {
        category: {
          title: category.title,
          description: category.description,
          icon: category.icon,
          isActive: 1
        }
      };
      if (category.parent && category.parent !== null) {
        formData.category.parent = category.parent.value;
      }
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.category + '/' + id, formData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.discardСhanges(id);
        _this4.fetchAllContentByScroll(1, 200);
        var infMsg = 'Category has been successfully updated';
        _this4.setInformationMsg({ text: infMsg, className: 'success' });
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log(err);
      });
    },
    discardСhanges: function discardHanges(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedCategories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var category = _step2.value;

          if (category.id === id && category.type === 'edit') {
            category.type = null;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      this.parent = null;
    },
    removeAllFilters: function removeAllFilters() {
      this.parent = null;
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["mapGetters"])(['getCategoriesTitle', 'getCategoriesForSelect', 'parentCategoriesForSelect', 'getTagsForSelect', 'getConfData']), {
    filteredCategories: function filteredCategories() {
      var _this5 = this;

      return this.categories.filter(function (category) {
        return category.title.toLowerCase().indexOf(_this5.searchString.toLowerCase()) > -1;
      }).filter(function (category) {
        return _this5.parent === null || category.parent && category.parent.value === _this5.parent.value;
      });
    }
  }),
  watch: {
    filteredCategories: function filteredCategories() {
      var updatedCategories = [];
      this.filteredCategories.forEach(function (category, i, arr) {
        category.type = 'show';
        updatedCategories.push(category);
        updatedCategories.push({
          type: null,
          id: category.id,
          title: category.title,
          parent: category.parent ? { label: category.parent.label, value: category.parent.value } : null,
          description: category.description,
          icon: category.icon
        });
      });
      this.updatedCategories = updatedCategories;
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      var actionName = this.getConfData.actionName;
      if (value) {
        switch (actionName) {
          case 'removeCategoryById':
            this.removeCategoryConfirmed(this.getConfData.actionId);
            this.clearConfAction();
            break;
        }
      }
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select___default.a
  },
  mounted: function mounted() {
    this.fetchAllContentByScroll(1, 200);
    this.getCategories();
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  created: function created() {
    document.title = 'Categories in "Topics" | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_plus__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_search__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_pencil__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_folder__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_times__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_chevron_up__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_chevron_down__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapters-list',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      chapters: [],
      updatedChapters: [],
      contentAutoloadInfo: {
        curPage: 1,
        numPages: 1,
        locked: false
      },
      newChapter: {
        name: '',
        slug: '',
        isActive: 1,
        description: '',
        image: null,
        imageGray: null,
        imageHigh: null,
        color: null
      },
      disableAPI: false,
      searchString: '',
      parent: null,
      statusbar: {
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false,
      isThumbnailFileUploadedBlue: false,
      isThumbnailFileUploadedGray: false,
      isThumbnailFileUploadedHigh: false,
      isEditFileUploadedBlue: false,
      isEditFileUploadedGray: false,
      isEditFileUploadedHigh: false,
      editorToolbar: [[{ 'header': [1, 2, 3, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["mapActions"])(['getCategories', 'setInformationMsg', 'clearConfAction', 'initConfAction']), {
    displayAddForm: function displayAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    closeAddForm: function closeAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    search: function search() {
      if (!this.filter.search) {
        this.contentInfo.typeAutoLoad = 'allContent';
        this.fetchAllContentByScroll(1, 200);
        return;
      }
      this.contentInfo.typeAutoLoad = 'searchContent';
      this.fetchSearchContent();
    },
    fetchSearchContent: function fetchSearchContent() {
      var _this = this;

      if (!this.filter.search) return;
      var queryString = '' + __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.search;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (item) {
        var value = _this.filter[item];
        if (value && typeof value === 'string') {
          queryString += '&search=' + value;
        }
        if (value !== null && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && value.length) {
          var subString = '';
          value.forEach(function (it) {
            subString += '&' + item + '=' + it.value;
          });
          queryString += subString;
        }
      });
      if (this.contentType.length) queryString += '&contentType=' + this.contentType[0].value;
      this.$http.get('' + queryString, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var resData = res.body.data.items;
        if (!resData) {
          _this.articles = [];
          return;
        }
        _this.articles = resData;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    removeCategory: function removeCategory(id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeChapterById'
      });
    },
    removeChapterConfirmed: function removeChapterConfirmed(id) {
      var self = this;
      var thisCategory = this.updatedChapters.find(function (chapter) {
        return chapter.id === id;
      });
      this.getCategories();
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.chapter + '/' + id, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.infMsgTitle = thisCategory.name + ' chapter was successfully deleted.';
        self.infMsgDescription = 'Please note all actions are being logged.';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        for (var i = 0; i < self.chapters.length; i++) {
          if (self.chapters[i].id === id) {
            self.chapters.splice(i, 1);
            break;
          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    handleScroll: function handleScroll(event) {
      var scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
      var fullScrolledValue = window.pageYOffset + window.innerHeight;

      if (fullScrolledValue > scrollHeight - 200) {
        this.fetchAllContentByScroll(++this.contentAutoloadInfo.curPage, 200);
      }
    },
    fetchAllContentByScroll: function fetchAllContentByScroll(page, limit) {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.chapters + '?limit=' + limit + '&page=' + page, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body) {
          _this2.chapters = res.body;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    createCategory: function createCategory() {
      var _this3 = this;

      if (this.disableAPI) return;
      if (!this.newChapter.name) return;
      var formData = new FormData();
      formData.append('chapter[name]', this.newChapter.name);
      formData.append('chapter[slug]', this.newChapter.slug);
      formData.append('chapter[description]', this.newChapter.description);
      formData.append('chapter[image]', this.newChapter.image);
      formData.append('chapter[imageGray]', this.newChapter.imageGray);
      formData.append('chapter[imageHigh]', this.newChapter.imageHigh);
      formData.append('chapter[color]', this.newChapter.color);
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.chapter, formData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = _this3.newChapter.name + ' chapter was successfully added.';
        _this3.infMsgDescription = 'Please note all actions are being logged.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.newChapter.name = '';
        _this3.newChapter.slug = '';
        _this3.newChapter.description = '';
        _this3.newChapter.image = null;
        _this3.newChapter.imageGray = null;
        _this3.newChapter.imageHigh = null;
        _this3.newChapter.color = null;
        _this3.addFormDisplay = false;
        _this3.isThumbnailFileUploadedBlue = false;
        _this3.isThumbnailFileUploadedGray = false;
        _this3.isThumbnailFileUploadedHIgh = false;
        _this3.fetchAllContentByScroll(1, 200);
        _this3.getCategories;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log(err);
      });
    },
    showEditionForm: function showEditionForm(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedChapters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var chapter = _step.value;

          if (chapter.type === 'edit') chapter.type = null;
          if (chapter.id === id && chapter.type === null) {
            chapter.type = 'edit';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    editCategory: function editCategory(id) {
      var _this4 = this;

      if (this.disableAPI) return;
      var chapter = this.updatedChapters.find(function (chapter) {
        return chapter.id === id && chapter.type === 'edit';
      });
      var formData = {
        chapter: {
          name: chapter.name,
          slug: chapter.slug,
          description: chapter.description,
          image: chapter.image,
          imageGray: chapter.imageGray,
          imageHigh: chapter.imageHigh,
          color: chapter.color
        }
      };
      if (chapter.parent && chapter.parent !== null) {
        formData.chapter.parent = chapter.parent.value;
      }
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.chapter + '/' + id, formData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        console.log('updateCategory', res);
        _this4.discardСhanges(id);
        _this4.fetchAllContentByScroll(1, 200);
        var infMsg = 'Category has been successfully updated';
        _this4.setInformationMsg({ text: infMsg, className: 'success' });
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log(err);
      });
    },
    discardСhanges: function discardHanges(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedChapters), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var chapter = _step2.value;

          if (chapter.id === id && chapter.type === 'edit') {
            chapter.type = null;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      this.parent = null;
    },
    removeAllFilters: function removeAllFilters() {
      this.parent = null;
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    onThumbnailFileChange: function onThumbnailFileChange(e, id, type) {
      var self = this;
      var input = document.getElementById('uploadThumbnail_' + type + '_' + id);
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        if (id === 0) {
          reader.onload = function (e) {
            if (type === 'blue') {
              self.isThumbnailFileUploadedBlue = true;
              self.newChapter.image = e.target.result;
            }
            if (type === 'gray') {
              self.isThumbnailFileUploadedGray = true;
              self.newChapter.imageGray = e.target.result;
            }
            if (type === 'high') {
              self.isThumbnailFileUploadedHigh = true;
              self.newChapter.imageHigh = e.target.result;
            }
          };
        } else {
          var chapter = this.updatedChapters.find(function (chapter) {
            return chapter.id === id && chapter.type === 'edit';
          });
          reader.onload = function (e) {
            if (type === 'blue') {
              self.isEditFileUploadedBlue = true;
              chapter.image = e.target.result;
            }
            if (type === 'gray') {
              self.isEditFileUploadedGray = true;
              chapter.imageGray = e.target.result;
            }
            if (type === 'high') {
              self.isEditFileUploadedHigh = true;
              chapter.imageHigh = e.target.result;
            }
          };
        }
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeThumbnail: function removeThumbnail(id, type) {
      var input = document.getElementById('uploadThumbnail_' + type + '_' + id);
      input.value = null;
      if (id === 0) {
        if (type === 'blue') {
          this.isThumbnailFileUploadedBlue = false;
          this.newChapter.image = null;
        }
        if (type === 'gray') {
          this.isThumbnailFileUploadedGray = false;
          this.newChapter.imageGray = null;
        }
        if (type === 'high') {
          this.isThumbnailFileUploadedHigh = false;
          this.newChapter.imageHigh = null;
        }
      } else {
        var chapter = this.updatedChapters.find(function (chapter) {
          return chapter.id === id && chapter.type === 'edit';
        });
        if (type === 'blue') {
          this.isEditFileUploadedBlue = false;
          chapter.image = null;
        }
        if (type === 'gray') {
          this.isEditFileUploadedGray = false;
          chapter.imageGray = null;
        }
        if (type === 'high') {
          this.isEditFileUploadedHigh = false;
          chapter.imageHigh = null;
        }
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["mapGetters"])(['getCategoriesTitle', 'getCategoriesForSelect', 'parentCategoriesForSelect', 'getTagsForSelect', 'getConfData']), {
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    },
    filteredCategories: function filteredCategories() {
      var _this5 = this;

      return this.chapters.filter(function (chapter) {
        return chapter.name.toLowerCase().indexOf(_this5.searchString.toLowerCase()) > -1;
      }).filter(function (chapter) {
        return _this5.parent === null || chapter.parent && chapter.parent.value === _this5.parent.value;
      });
    }
  }),
  watch: {
    filteredCategories: function filteredCategories() {
      var updatedChapters = [];
      this.filteredCategories.forEach(function (chapter, i, arr) {
        chapter.type = 'show';
        updatedChapters.push(chapter);
        updatedChapters.push({
          type: null,
          id: chapter.id,
          name: chapter.name,
          slug: chapter.slug,
          description: chapter.description,
          image: chapter.image,
          imageGray: chapter.image_gray,
          imageHigh: chapter.image_high,
          color: chapter.color
        });
      });
      this.updatedChapters = updatedChapters;
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      var actionName = this.getConfData.actionName;
      if (value) {
        switch (actionName) {
          case 'removeChapterById':
            this.removeChapterConfirmed(this.getConfData.actionId);
            this.clearConfAction();
            break;
        }
      }
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_12__components_admin_common_Select___default.a
  },
  mounted: function mounted() {
    this.fetchAllContentByScroll(1, 200);
    this.getCategories();
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  created: function created() {
    document.title = 'Task categories | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick__ = __webpack_require__(90);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clearkit-page',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          button: {
            text: '',
            url: ''
          },
          hideSection: false
        },
        aboutSection: [{
          title: '',
          text: '',
          button: {
            text: '',
            url: ''
          },
          hideSection: false
        }, {
          title: '',
          text: '',
          button: {
            text: '',
            url: ''
          }
        }],
        clientSection: {
          title: '',
          description: '',
          logos: [{
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          }],
          hideSection: false
        },
        howItWorksSection: {
          title: '',
          sections: [{
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }, {
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          }],
          hideSection: false
        },
        subscribeSection: {
          title: '',
          description: '',
          hideSection: false
        },
        featuresSection: {
          items: [{
            title: '',
            description: '',
            button: {
              text: '',
              url: ''
            },
            video: '',
            image: '',
            altImage: ''
          }],
          hideSection: false
        },
        footerCTASection: {
          title: '',
          description: '',
          button: {
            text: '',
            url: ''
          },
          hideSection: false
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      slidesReady: false,
      slickOptions: {
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 7,
        responsive: [{
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }]
      },
      slickOptionsContent: {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      activePopup: null,
      sliderModalShown: false,
      subscribeForm: {
        isError: false,
        firstnameFocus: false,
        lastnameFocus: false,
        emailFocus: false,
        firstname: '',
        lastname: '',
        email: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: 'clear-kit',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'clear-kit',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.slidesReady = false;
      var body = {
        slug: 'clear-kit'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/clear-kit', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.content = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.content.title = _this3.metaData.title;
        _this3.content.description = _this3.metaData.description;
        _this3.slidesReady = true;
        _this3.$nextTick(function () {
          _this3.$refs.slick.reSlick();
        });
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/clear-kit', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    addSection: function addSection(section) {
      if (section === 'features') {
        this.content.featuresSection.items.push({
          title: '',
          text: '',
          video: '',
          button: {
            text: '',
            url: ''
          },
          image: '',
          altImage: ''
        });
      }
      if (section === 'logos') {
        this.content.clientSection.logos.push({
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: '',
          url: ''
        });
      }
    },
    removeSection: function removeSection(section, index) {
      section.splice(index, 1);
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    getHighImage: function getHighImage(item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image;
    },
    getHighImageAlt: function getHighImageAlt(item) {
      return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage;
    },
    activatePopup: function activatePopup(item) {
      this.activePopup = item;
    },
    closePopup: function closePopup() {
      var _this6 = this;

      this.activePopup = null;
      this.sliderModalShown = false;
      this.slidesReady = true;
      this.pageMetaEdit = false;
      this.$nextTick(function () {
        _this6.$refs.slick.reSlick();
      });
    },
    closePopupOnOutsideClick: function closePopupOnOutsideClick(e) {
      var _this7 = this;

      var iconPopup = this.$refs.iconPopup;
      var sliderPopup = this.$refs.sliderPopup;
      var target = e.target;
      if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
        this.activePopup = null;
      }
      if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
        this.switchSliderModal();
        this.slidesReady = true;
        this.$nextTick(function () {
          _this7.$refs.slick.reSlick();
        });
      }
    },
    getVideoUrl: function getVideoUrl(url) {
      var link = url;
      if (url !== '') {
        var linkPart = url.split('/');
        if (linkPart) {
          if (linkPart[2].indexOf('youtu') !== -1) {
            link = linkPart[0] + '//www.youtube.com/embed/' + linkPart[linkPart.length - 1];
          }
          if (linkPart[2].indexOf('vimeo') !== -1) {
            link = linkPart[0] + '//player.vimeo.com/video/' + linkPart[linkPart.length - 1];
          }
          link += '?autoplay=0&loop=1';
        }
      }
      return link;
    },
    switchSliderModal: function switchSliderModal() {
      this.sliderModalShown = !this.sliderModalShown;
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 1024) {
        deviceName = 'desktop';
      } else if (width > 640) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    subscribeMe: function subscribeMe() {
      var _this8 = this;

      var firstname = this.subscribeForm.firstname;
      var lastname = this.subscribeForm.lastname;
      var email = this.subscribeForm.email;
      var body = {
        firstname: firstname,
        lastname: lastname
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.subscribe + '/' + email, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this8.subscribeForm.firstname = '';
        _this8.subscribeForm.lastname = '';
        _this8.subscribeForm.email = '';
        _this8.subscribeForm.isError = false;
      }).catch(function (err) {
        _this8.subscribeForm.isError = true;
        console.log('err', err);
      });
    }
  }),
  created: function created() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_4_vue_slick__["a" /* default */]
  },
  watch: {}
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick__ = __webpack_require__(90);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company-landing',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      logoEdit: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      landing: {
        logo: null
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        },
        clientSection: {
          title: '',
          description: '',
          button: {
            text: '',
            url: ''
          },
          logos: [{
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          }],
          hideSection: false
        },
        featuresSection: {
          title: '',
          items: [{
            title: '',
            excerpt: '',
            text: '',
            date: null,
            image: '',
            altImage: '',
            expanded: false
          }],
          hideSection: false
        },
        footerData: {
          logosLabel: '',
          logos: [{
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          }]
        }
      },
      initialContent: {
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: ''
        },
        clientSection: {
          title: '',
          description: '',
          button: {
            text: '',
            url: ''
          },
          logos: []
        },
        featuresSection: {
          title: '',
          items: []
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      slidesReady: false,
      slickOptions: {
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4
      },
      slickOptionsContent: {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      activePopup: null,
      sliderModalShown: false,
      topLoginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        loginInProgress: false,
        isError: false,
        loginErrorMessage: '',
        passwordType: 'password'
      },
      ppp: 5,
      footerEdit: false,
      activatePage: false,
      confOpened: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'initConfAction', 'redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    closeCustomMsg: function closeCustomMsg() {
      this.activatePage = false;
      var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      delete query.activated;
      this.$router.replace({ query: query });
    },
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.logoEdit = false;
      this.footerEdit = false;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: this.$route.params['id'],
        body: body,
        landing: true,
        logo: this.landing.logo
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage(null, true);
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: this.$route.params['id'],
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this3 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpagechanges + '/' + this.$route.params['id'] + '?type=1', __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this3.editHistory = true;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    expandSection: function expandSection(section, feature) {
      feature.expanded = !feature.expanded;
      this.goToPageSection(section);
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        var here = element[0] ? element[0] : element;
        here.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    getLandingPage: function getLandingPage(id, refresh) {
      var _this4 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      this.slidesReady = false;
      var body = {
        slug: this.$route.params['id'],
        type: 1
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage + '/' + this.$route.params['id'], body, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        if (pageData.footerData) {
          _this4.content.footerData = pageData.footerData;
        }
        if (pageData.heroSection) {
          _this4.content.heroSection = pageData.heroSection;
        }
        if (pageData.featuresSection) {
          _this4.content.featuresSection = pageData.featuresSection;
        }
        if (pageData.clientSection) {
          _this4.content.clientSection = pageData.clientSection;
        }
        if (res.data.logo) {
          _this4.landing.logo = res.data.logo;
        }
        // if (!this.content.heroSection) {
        //   this.content.heroSection = {
        //     title: '',
        //     description: '',
        //     altImage: '',
        //     image: '',
        //     hideSection: false
        //   }
        // }
        // if (!this.content.featuresSection) {
        //   this.content.featuresSection = {
        //     title: '',
        //     items: [
        //       {
        //         title: '',
        //         excerpt: '',
        //         text: '',
        //         image: '',
        //         altImage: ''
        //       }
        //     ],
        //     hideSection: false
        //   }
        // }
        // if (!this.content.clientSection) {
        //   this.content.clientSection = {
        //     title: '',
        //     description: '',
        //     button: {
        //       text: '',
        //       url: ''
        //     },
        //     logos: [
        //       {
        //         image: '',
        //         altImage: '',
        //         imageHigh: '',
        //         altImageHigh: '',
        //         url: ''
        //       }
        //     ],
        //     hideSection: false
        //   }
        // }
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title;
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        // Set initial data
        _this4.initialContent = pageData;
        _this4.slidesReady = true;
        _this4.$nextTick(function () {
          if (_this4.$refs.slick) {
            _this4.$refs.slick.reSlick();
          }
        });
        if (id) {
          _this4.pageEditSwitch();
        } else {
          if (refresh) {
            _this4.pageEditMode = false;
          }
        }
        if (_this4.$route.name === 'edit-company-landing') {
          _this4.$nextTick(function () {
            _this4.autoSizeOnInit();
          });
        }
        if (_this4.landing.logo) {
          var logoNode = document.getElementById('landingHeaderLogo');
          if (logoNode) {
            logoNode.src = _this4.getImageFullPath(_this4.landing.logo);
          }
        }
        // if (this.content.footerData.logosLabel !== '') {
        //   let footerLogosHead = document.getElementsByClassName('footer-section-head')
        //   if (footerLogosHead && footerLogosHead[0]) {
        //     footerLogosHead[0].innerHTML = this.content.footerData.logosLabel
        //   }
        // }
        // if (this.content.footerData.logos && this.content.footerData.logos[0].img !== '') {
        //   let self = this
        //   setTimeout(function () {
        //     let footerLogos = document.getElementsByClassName('industry-logos')
        //     if (footerLogos && footerLogos[0]) {
        //       footerLogos[0].innerHTML = ''
        //       for (let logo of self.content.footerData.logos) {
        //         console.log(logo)
        //         let logoLink = document.createElement('a')
        //         logoLink.setAttribute('href', logo.url)
        //         logoLink.classList.add('industry-logos__item')
        //         let logoImage = document.createElement('img')
        //         logoImage.setAttribute('src', self.getImageFullPath(self.getHighImage(logo)))
        //         logoLink.appendChild(logoImage)
        //         footerLogos[0].appendChild(logoLink)
        //       }
        //     }
        //   }, 1000)
        // }
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage(null, true);
    },
    pageEditSwitch: function pageEditSwitch() {
      this.confOpened = 'edit';
      this.initConfAction({
        actionName: 'editLanding'
      });
    },
    pageEditSwitchConfirmed: function pageEditSwitchConfirmed() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
      this.getConfData.actionConfirmed = false;
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    addSection: function addSection(section) {
      if (section === 'features') {
        this.content.featuresSection.items.push({
          title: '',
          excerpt: '',
          text: '',
          date: new Date(),
          image: '',
          altImage: '',
          expanded: false
        });
      }
      if (section === 'logos') {
        this.content.clientSection.logos.push({
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: '',
          url: ''
        });
      }
      if (section === 'footer-logos') {
        this.content.footerData.logos.push({
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: '',
          url: ''
        });
      }
    },
    removeSection: function removeSection(section, index) {
      section.splice(index, 1);
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload && payload !== '') {
        return true;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    getCurrentDate: function getCurrentDate(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var dd = date.getDate();
      var mm = date.getMonth();
      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }

      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      return dd + ' ' + monthNames[mm] + ' ' + yyyy;
    },
    getHighImage: function getHighImage(item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image;
    },
    getHighImageAlt: function getHighImageAlt(item) {
      return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage;
    },
    activatePopup: function activatePopup(item) {
      this.activePopup = item;
    },
    closePopup: function closePopup() {
      var _this6 = this;

      this.activePopup = null;
      this.sliderModalShown = false;
      this.slidesReady = true;
      this.pageMetaEdit = false;
      this.logoEdit = false;
      this.footerEdit = false;
      this.$nextTick(function () {
        if (_this6.$refs.slick) {
          _this6.$refs.slick.reSlick();
        }
      });
    },
    closePopupOnOutsideClick: function closePopupOnOutsideClick(e) {
      var _this7 = this;

      var iconPopup = this.$refs.iconPopup;
      var sliderPopup = this.$refs.sliderPopup;
      var target = e.target;
      if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
        this.activePopup = null;
      }
      if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
        this.switchSliderModal();
        this.slidesReady = true;
        this.$nextTick(function () {
          if (_this7.$refs.slick) {
            _this7.$refs.slick.reSlick();
          }
        });
      }
    },
    switchSliderModal: function switchSliderModal() {
      this.sliderModalShown = !this.sliderModalShown;
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 1024) {
        deviceName = 'desktop';
      } else if (width > 640) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    editPageLogo: function editPageLogo() {
      this.logoEdit = true;
    },
    authenticate: function authenticate(form) {
      var _this8 = this;

      this.topLoginForm.loginInProgress = true;
      var auth = {
        grant_type: this.topLoginForm.grantType,
        client_id: this.topLoginForm.clientId,
        client_secret: this.topLoginForm.clientSecret,
        username: this.topLoginForm.email,
        password: this.topLoginForm.password
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.login, auth).then(function (res) {
        var headers = { headers: { 'Authorization': 'Bearer ' + res.body.access_token } };
        document.cookie = 'Recite.Persist=; Max-Age=-99999999;';
        localStorage.setItem('token', res.body.access_token);
        _this8.$http.put(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.profile, {}, headers).then(function (res) {
          _this8.$store.commit('authLoginSuccess');
          var userData = {
            'id': res.body.id ? res.body.id : '',
            'firstName': res.body.first_name ? res.body.first_name : '',
            'lastName': res.body.last_name ? res.body.last_name : '',
            'userRole': res.body.role.slug,
            'company': res.body.company ? res.body.company.id : null
          };
          if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
            localStorage.setItem('consentHead', 'true');
          }
          localStorage.setItem('consentSeen', res.body.consent_seen);
          localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          localStorage.setItem('cookieFixed', true);
          localStorage.setItem('userIndustry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          document.getElementById('app').setAttribute('data-industry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          if (res.body.company) {
            localStorage.setItem('userCompanyName', res.body.company.name);
          }
          if (res.body.company && res.body.company.industry) {
            localStorage.setItem('userIndustryName', res.body.company.industry.name);
          }
          _this8.$store.commit('authLoginSetUsername', userData.firstName);
          _this8.redirect();
        }).catch(function (err) {
          if (err.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('userData');
            localStorage.removeItem('consentSeen');
            localStorage.removeItem('consentHead');
            localStorage.removeItem('userIndustryName');
            localStorage.removeItem('userCompanyName');
            _this8.topLoginForm.isError = true;
            _this8.topLoginForm.loginInProgress = false;
            _this8.topLoginForm.loginErrorMessage = 'Your account is inactive. Please contact support.';
          }
        });
      }).catch(function () {
        _this8.topLoginForm.isError = true;
        _this8.topLoginForm.loginInProgress = false;
        _this8.topLoginForm.loginErrorMessage = 'Invalid credentials';
      });
    }
  }),
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
    if (this.$route.name === 'edit-company-landing') {
      this.pageEditMode = true;
      this.landingPanel = true;
    }
    this.activatePage = this.$route.query.activated;
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_5_vue_slick__["a" /* default */]
  },
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'edit') this.pageEditSwitchConfirmed();
        this.clearConfAction();
      }
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_plus__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_check_circle__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_ban__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company-list',
  data: function data() {
    return {
      ppt: 15,
      offset: 15,
      companies: [],
      editedCompanies: [],
      selectedAction: null,
      search: '',
      table: '',
      head: '',
      searchByName: '',
      hoverSearchElements: [],
      companyParent: null,
      role: null,
      lastEdited: null,
      companyStatus: null,
      companyIndustry: null,
      userType: null,
      companyIndustryList: [],
      companyTitleList: [],
      parentCompanyList: [],
      companyStatusList: [],
      companyType: null,
      companyOrderBy: {
        type: '',
        order: false
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      confirmation: {
        action: '',
        isShown: false,
        id: null,
        style: {
          top: '100px'
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      datepicker: {
        isShown: false,
        from: null,
        to: null
      },
      statusbar: {
        data: [],
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      windowWidth: window.innerWidth
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])([
  // 'getRoles',
  // 'getCompanies',
  'setInformationMsg', 'getDefaultRegistrationRoles']), {
    fetchAllContentByScroll: function fetchAllContentByScroll(page, limit) {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyList + '?limit=' + limit + '&page=' + page, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var companies = res.body.data.items;
        var parents = [];
        companies.sort(function (a, b) {
          return a.name > b.name;
        }).forEach(function (company) {
          if (company.parent === null) {
            var children = companies.filter(function (item) {
              return item.parent !== null && item.parent.id === company.id;
            });
            parents.push(company);
            children.forEach(function (child) {
              parents.push(child);
            });
          }
        });
        _this.companies = parents;
        _this.statusbar.data = res.body.count ? res.body.count : [];
        var query = _this.$route.query;
        if (query && query.status) {
          if (query.status === 'active') {
            _this.companyStatus = {
              value: 2,
              label: 'Active'
            };
          } else if (query.status === 'notactive') {
            _this.companyStatus = {
              value: 1,
              label: 'Inactive'
            };
          } else if (query.status === 'disabled') {
            _this.companyStatus = {
              value: 0,
              label: 'Archived'
            };
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    addSearchHoverElement: function addSearchHoverElement(type) {
      this.hoverSearchElements = type;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    removeSearchHoverElements: function removeSearchHoverElements() {
      this.hoverSearchElements = '';
    },
    isExist: function isExist(element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true;
      }
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistSearchInOptions: function isExistSearchInOptions(type) {
      var hoverElement = this.hoverSearchElements ? this.hoverSearchElements : '';
      if (hoverElement === type) {
        return true;
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      if (this.searchByName) {
        this.searchByName = '';
      }
      if (this.companyStatus && this.companyStatus.label === filter.label && this.companyStatus.value === filter.value) {
        this.companyStatus = null;
      }
      if (this.companyParent && this.companyParent.label === filter.label && this.companyParent.value === filter.value) {
        this.companyParent = null;
      }
      if (this.companyIndustry && this.companyIndustry.label === filter.label && this.companyIndustry.value === filter.value) {
        this.companyIndustry = null;
      }
      if (this.userType && this.userType.label === filter.label && this.userType.value === filter.value) {
        this.userType = null;
      }
    },
    removeAllFilters: function removeAllFilters() {
      this.searchByName = '';
      this.companyStatus = null;
      this.companyParent = null;
      this.companyIndustry = null;
      this.userType = null;
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    lastActiveTime: function lastActiveTime(timestamp) {
      if (!timestamp) return '';
      var string = '';
      var dateFrom = new Date(timestamp);
      var now = new Date();
      if (isNaN(dateFrom.getTime())) {
        return 'n/a';
      }
      var difference = Math.floor((+now - +dateFrom) / (1000 * 60 * 60));
      if (difference < 1) {
        string += 'less than 1 hour ago';
      } else if (difference >= 1 && difference < 24) {
        string += difference + ' hours ago';
      } else {
        string += this.convertDate(timestamp, '.');
      }
      return string;
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      if (isNaN(date.getTime())) {
        return 'n/a';
      }
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    changeOrderBy: function changeOrderBy(type, order) {
      this.companyOrderBy = {
        type: type,
        order: this.companyOrderBy !== null ? !this.companyOrderBy.order : order
      };
    },
    goToCompanyEdit: function goToCompanyEdit(id) {
      var props = this.$router.resolve({
        name: 'edit-company',
        params: { id: id }
      });
      location.href = props.href;
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width >= 940) {
        deviceName = 'desktop';
      } else if (width >= 480) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    getTabletFiltersAppliedText: function getTabletFiltersAppliedText() {
      var filterAppliedText = 'Apply Filters';
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.companies.length + ' results';
      }
      return filterAppliedText;
    },
    getCompanyStatus: function getCompanyStatus(company) {
      console.log(company.is_temporary);
      if (company.enabled) {
        if (company.is_temporary || company.suspended) {
          return {
            label: 'Pending payment',
            value: 3
          };
        } else {
          if (company.subscription_end) {
            var today = new Date();
            var endDay = new Date(company.subscription_end);
            if (endDay < today) {
              return {
                label: 'Expired',
                value: 1
              };
            } else {
              return {
                label: 'Active',
                value: 2
              };
            }
          } else {
            return {
              label: 'Active',
              value: 2
            };
          }
        }
      } else {
        return {
          label: 'Archived',
          value: 0
        };
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapGetters"])(['getUserRole', 'getDefaultRegistrationRolesForSelect']), {
    getStatusesForSelect: function getStatusesForSelect() {
      return this.companyStatusList;
    },
    getCompaniesForSelect: function getCompaniesForSelect() {
      return this.parentCompanyList;
    },
    getIndustriesForSelect: function getIndustriesForSelect() {
      return this.companyIndustryList;
    },
    filteredCompanies: function filteredCompanies() {
      var _this2 = this;

      var result = this.companies;
      result = this.companies.filter(function (company) {
        return (company.id + ' ' + company.name).toLowerCase().indexOf(_this2.searchByName.toLowerCase()) > -1;
      }).filter(function (company) {
        return _this2.companyParent === null || company.parent && company.parent.id === _this2.companyParent.value;
      }).filter(function (company) {
        return _this2.companyIndustry === null || company.industry && company.industry.id === _this2.companyIndustry.value;
      }).filter(function (company) {
        return _this2.userType === null || company.userType && company.userType.id === _this2.userType.value;
      }).filter(function (company) {
        return _this2.companyStatus === null || _this2.getCompanyStatus(company).value === _this2.companyStatus.value;
      });
      if (this.companyOrderBy !== null && this.companyOrderBy.type !== '') {
        var ascDesc = this.companyOrderBy.order ? 1 : -1;
        if (this.companyOrderBy.type === 'expire') {
          return result.sort(function (a, b) {
            var firstDate = a.subscription_end !== undefined ? new Date(a.subscription_end) : '';
            var secondDate = b.subscription_end !== undefined ? new Date(b.subscription_end) : '';
            return ascDesc * (firstDate - secondDate);
          });
        } else if (this.companyOrderBy.type === 'users') {
          return result.sort(function (a, b) {
            return ascDesc * (a.users.length - b.users.length);
          });
        } else {
          return result.sort(function (a, b) {
            var firstDate = void 0;
            var secondDate = void 0;
            if (a.created) {
              firstDate = a.created !== undefined && a.created !== 'Invalid Date' ? new Date(a.created) : '';
            } else {
              firstDate = a.start_date !== undefined && a.start_date !== 'Invalid Date' ? new Date(a.start_date) : '';
            }
            if (b.created) {
              secondDate = b.created !== undefined && b.created !== 'Invalid Date' ? new Date(b.created) : '';
            } else {
              secondDate = b.start_date !== undefined && b.start_date !== 'Invalid Date' ? new Date(b.start_date) : '';
            }
            return ascDesc * (firstDate - secondDate);
          });
        }
      } else {
        return result;
      }
    },
    companiesSum: function companiesSum() {
      var count = 0;
      for (var counter in this.statusbar.data) {
        count = count + +this.statusbar.data[counter];
      }
      return count;
    },
    selectedFilters: function selectedFilters() {
      var filters = [];
      if (this.searchByName) {
        filters.push({
          id: null,
          type: 'name',
          label: this.searchByName
        });
      }
      if (this.companyParent) {
        filters.push(this.companyParent);
      }
      if (this.companyIndustry) {
        filters.push(this.companyIndustry);
      }
      if (this.userType) {
        filters.push(this.userType);
      }
      if (this.companyStatus) {
        filters.push(this.companyStatus);
      }
      return filters;
    }
  }),
  watch: {
    filteredCompanies: function filteredCompanies() {
      var _this3 = this;

      var editedCompanies = [];
      this.offset = this.ppt;
      this.companyTitleList = [];
      this.parentCompanyList = [];
      this.companyIndustryList = [];
      this.companyStatusList = [];
      this.filteredCompanies.forEach(function (company) {
        company.type = 'show';
        if (company.parent) {
          var _index = _this3.parentCompanyList.findIndex(function (x) {
            return x.label === company.parent.name;
          });
          if (_index === -1) {
            _this3.parentCompanyList.push({
              id: company.parent.id,
              label: company.parent.name,
              value: company.parent.id
            });
          }
        }
        if (company.industry) {
          var _index2 = _this3.companyIndustryList.findIndex(function (x) {
            return x.label === company.industry.name;
          });
          if (_index2 === -1) {
            _this3.companyIndustryList.push({
              id: company.industry.id,
              label: company.industry.name,
              value: company.industry.id
            });
          }
        }
        var status = _this3.getCompanyStatus(company);
        var index = _this3.companyStatusList.findIndex(function (x) {
          return x.value === status.value;
        });
        if (index === -1) {
          _this3.companyStatusList.push({
            label: status.label,
            value: status.value
          });
        }
        editedCompanies.push(company);
      });
      this.editedCompanies = editedCompanies;
    },
    'confirmation.isShown': function confirmationIsShown(value) {
      if (value) {
        this.confirmation.style.top = window.pageYOffset - 100 + 'px';
      }
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select___default.a
  },
  created: function created() {
    document.title = 'All Companies | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted: function mounted() {
    this.fetchAllContentByScroll(1, 2000);
    this.getDefaultRegistrationRoles();
    // this.getCompanies()
    // this.getRoles()
    document.addEventListener('click', this.hideSubMenuTableHead);
    window.addEventListener('resize', this.handleWindowResize);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html_to_image__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html_to_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html_to_image__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company-profile',
  data: function data() {
    return {
      user: null,
      chapters: null,
      quarters: null,
      chartData: null,
      hasPoints: false,
      company: {
        focusArea: {
          id: null,
          image: '',
          name: ''
        },
        level: {
          id: null,
          name: '',
          score: 0
        }
      },
      badgeCopy: false,
      iframeTheme: {
        label: 'Light',
        value: 'light'
      },
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['getUserRole', 'selectedHightCont']), {
    iframeThemes: function iframeThemes() {
      return [{
        label: 'Light',
        value: 'light'
      }, {
        label: 'Dark',
        value: 'dark'
      }];
    }
  }),
  components: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])([]), {
    getUserInfoById: function getUserInfoById() {
      var _this = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.user = res.body;
        var quarters = res.body.company.points.sort(function (a, b) {
          return -1 * (parseInt(a.year + '' + a.quarter) - parseInt(b.year + '' + b.quarter));
        });
        if (quarters.length) {
          _this.hasPoints = true;
        }
        _this.quarters = quarters;
        _this.getChaptersList();
        _this.$nextTick(function () {
          _this.setProgress(quarters);
        });
      }).catch(function (err) {
        return console.error(err);
      });
    },
    setProgress: function setProgress(quarters) {
      var focusArea = this.user.company.company_focus_area;
      var score = 0;
      if (focusArea !== null) {
        this.company.focusArea.id = focusArea.id;
        if (this.selectedHightCont === 1) {
          this.company.focusArea.image = focusArea.image_high;
        } else {
          this.company.focusArea.image = focusArea.image;
        }
        if (focusArea.slug === 'policies') {
          if (quarters[0]) {
            score = quarters[0].policies_score;
          }
          this.setCompanyProgress(score, '.progress__value');
          this.setFocusAreaLevel(score);
          this.company.focusArea.name = 'Policies and procedures';
        } else if (focusArea.slug === 'finding') {
          if (quarters[0]) {
            score = quarters[0].finding_score;
          }
          this.setCompanyProgress(score, '.progress__value');
          this.setFocusAreaLevel(score);
          this.company.focusArea.name = 'Finding talent';
        } else if (focusArea.slug === 'assessing') {
          if (quarters[0]) {
            score = quarters[0].assessing_score;
          }
          this.setCompanyProgress(score, '.progress__value');
          this.setFocusAreaLevel(score);
          this.company.focusArea.name = 'Assessing talent';
        } else if (focusArea.slug === 'retaining') {
          if (quarters[0]) {
            score = quarters[0].retaining_score;
          }
          this.setCompanyProgress(score, '.progress__value');
          this.setFocusAreaLevel(score);
          this.company.focusArea.name = 'Retaining talent';
        }
      }
      this.company.level.score = score;
    },
    setFocusAreaLevel: function setFocusAreaLevel(score) {
      if (score > 79) {
        this.company.level.id = 5;
        this.company.level.name = 'Platinum';
        return;
      }
      if (score > 59) {
        this.company.level.id = 4;
        this.company.level.name = 'Gold';
        return;
      }
      if (score > 39) {
        this.company.level.id = 3;
        this.company.level.name = 'Silver';
        return;
      }
      if (score > 19) {
        this.company.level.id = 2;
        this.company.level.name = 'Bronze';
        return;
      }
      if (score >= 0) {
        this.company.level.id = 1;
        this.company.level.name = 'Foundation';
        return;
      }
    },
    getFocusAreaLevel: function getFocusAreaLevel(score) {
      if (score > 79) {
        return {
          id: 5,
          name: 'Platinum'
        };
      }
      if (score > 59) {
        return {
          id: 4,
          name: 'Gold'
        };
      }
      if (score > 39) {
        return {
          id: 3,
          name: 'Silver'
        };
      }
      if (score > 19) {
        return {
          id: 2,
          name: 'Bronze'
        };
      }
      if (score >= 0) {
        return {
          id: 1,
          name: 'Foundation'
        };
      }
    },
    setCompanyProgress: function setCompanyProgress(value, selector) {
      var RADIUS = 44;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      var progressValue = document.querySelector(selector);
      var progress = value / 100;
      if (progressValue) {
        progressValue.style.display = 'block';
        progressValue.style.strokeDasharray = CIRCUMFERENCE;
        progressValue.style.strokeDashoffset = CIRCUMFERENCE * (1 - progress);
      }
    },
    convertDate: function convertDate(payload, delimiter, monthName) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (monthName) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        month = months[month - 1];
      }
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear;
    },
    getCurrentDate: function getCurrentDate() {
      var date = new Date();
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var fullYear = date.getFullYear();
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var m = months[month - 1];
      return m + ' ' + day + ', ' + fullYear;
    },
    getChaptersList: function getChaptersList() {
      var _this2 = this;

      var self = this;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.contentChaptersList, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var chapters = res.body;
        var order = ['policies', 'finding', 'assessing', 'retaining'];
        chapters.sort(function (x, y) {
          var xkey = order.indexOf(x.slug);
          var ykey = order.indexOf(y.slug);
          return xkey - ykey;
        });
        var focusArea = _this2.user.company.company_focus_area;
        var quarters = _this2.user.company.points.sort(function (a, b) {
          return -1 * (parseInt(a.year + '' + a.quarter) - parseInt(b.year + '' + b.quarter));
        });
        var lastQuarter = quarters.length ? quarters[0] : null;
        var newChapters = [];
        var chartData = [];
        var quarterData = {};
        var customChapters = {};
        var addThis = void 0;
        chapters.forEach(function (chapter) {
          var scores = {};
          var score = [];
          var i = 1;
          customChapters = chapter;
          self.reverseItems(quarters).forEach(function (quarter) {
            if (!quarterData[quarter.id]) {
              quarterData[quarter.id] = [];
            }
            if (chapter.slug === 'policies') {
              var bottom = void 0;
              var quarterScore = quarter.policies_score ? quarter.policies_score : 0;
              var benchmarkScore = self.user.company.industry && self.user.company.industry.benchmark_policies_and_procedures ? self.user.company.industry.benchmark_policies_and_procedures : null;
              var countInRange = quarterData[quarter.id].filter(function (x) {
                return x > quarterScore - 2 && x < quarterScore + 2;
              }).length;
              var countChapterInRange = quarterData[quarter.id].filter(function (x) {
                return x <= quarterScore - 10;
              }).length;
              if (quarterScore <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (quarterScore + countChapterInRange * 20) - addThis;
              quarterData[quarter.id].push(quarterScore);
              bottom = quarterScore + countInRange * 0.95;
              score.push({
                score: quarterScore,
                left: i * 140,
                top: 100 - bottom,
                benchmark: benchmarkScore
              });
            } else if (chapter.slug === 'finding') {
              var _bottom = void 0;
              var _quarterScore = quarter.finding_score ? quarter.finding_score : 0;
              var _benchmarkScore = self.user.company.industry && self.user.company.industry.benchmark_finding_talent ? self.user.company.industry.benchmark_finding_talent : null;
              var _countInRange = quarterData[quarter.id].filter(function (x) {
                return x > _quarterScore - 2 && x < _quarterScore + 2;
              }).length;
              var _countChapterInRange = quarterData[quarter.id].filter(function (x) {
                return x <= _quarterScore - 10;
              }).length;
              if (_quarterScore <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (_quarterScore + _countChapterInRange * 20) - addThis;
              quarterData[quarter.id].push(_quarterScore);
              _bottom = _quarterScore + _countInRange * 0.95;
              score.push({
                score: _quarterScore,
                left: i * 140,
                top: 100 - _bottom,
                benchmark: _benchmarkScore
              });
            } else if (chapter.slug === 'assessing') {
              var _bottom2 = void 0;
              var _quarterScore2 = quarter.assessing_score ? quarter.assessing_score : 0;
              var _benchmarkScore2 = self.user.company.industry && self.user.company.industry.benchmark_accessing_talent ? self.user.company.industry.benchmark_accessing_talent : null;
              var _countInRange2 = quarterData[quarter.id].filter(function (x) {
                return x > _quarterScore2 - 2 && x < _quarterScore2 + 2;
              }).length;
              var _countChapterInRange2 = quarterData[quarter.id].filter(function (x) {
                return x <= _quarterScore2 - 10;
              }).length;
              if (_quarterScore2 <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (_quarterScore2 + _countChapterInRange2 * 20) - addThis;
              quarterData[quarter.id].push(_quarterScore2);
              _bottom2 = _quarterScore2 + _countInRange2 * 0.95;
              score.push({
                score: _quarterScore2,
                left: i * 140,
                top: 100 - _bottom2,
                benchmark: _benchmarkScore2
              });
            } else if (chapter.slug === 'retaining') {
              var _bottom3 = void 0;
              var _quarterScore3 = quarter.retaining_score ? quarter.retaining_score : 0;
              var _benchmarkScore3 = self.user.company.industry && self.user.company.industry.benchmark_retaining_talent ? self.user.company.industry.benchmark_retaining_talent : null;
              var _countInRange3 = quarterData[quarter.id].filter(function (x) {
                return x > _quarterScore3 - 2 && x < _quarterScore3 + 2;
              }).length;
              var _countChapterInRange3 = quarterData[quarter.id].filter(function (x) {
                return x <= _quarterScore3 - 10;
              }).length;
              if (_quarterScore3 <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (_quarterScore3 + _countChapterInRange3 * 20) - addThis;
              quarterData[quarter.id].push(_quarterScore3);
              _bottom3 = _quarterScore3 + _countInRange3 * 0.95;
              score.push({
                score: _quarterScore3,
                left: i * 140,
                top: 100 - _bottom3,
                benchmark: _benchmarkScore3
              });
            }
            i += 1;
          });
          chartData[chapter.id] = {
            chapter: chapter,
            isFocus: focusArea ? focusArea.id === chapter.id : false,
            scores: score
          };
          if (chapter.slug === 'policies') {
            var _score = lastQuarter ? lastQuarter.policies_score : 0;
            scores = {
              score: _score,
              level: self.getFocusAreaLevel(_score)
            };
          } else if (chapter.slug === 'finding') {
            var _score2 = lastQuarter ? lastQuarter.finding_score : 0;
            scores = {
              score: _score2,
              level: self.getFocusAreaLevel(_score2)
            };
          } else if (chapter.slug === 'assessing') {
            var _score3 = lastQuarter ? lastQuarter.assessing_score : 0;
            scores = {
              score: _score3,
              level: self.getFocusAreaLevel(_score3)
            };
          } else if (chapter.slug === 'retaining') {
            var _score4 = lastQuarter ? lastQuarter.retaining_score : 0;
            scores = {
              score: _score4,
              level: self.getFocusAreaLevel(_score4)
            };
          }
          newChapters.push({
            chapter: chapter,
            isFocus: focusArea ? focusArea.id === chapter.id : false,
            scores: scores,
            isReady: true,
            keyShown: false
          });
          self.chartData = chartData;
        });
        _this2.chapters = newChapters;
        Array.isArray(_this2.chapters);
        _this2.dataLoaded = true;
        self.$nextTick(function () {
          if (_this2.getUserRole !== 'ta' && _this2.getUserRole !== 'tu') {
            self.connectPoints();
            self.setChaptersProgress();
          }
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    htmlToCanvas: function htmlToCanvas() {
      __WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.querySelector('.content-chart-wrapper')).then(function (canvas) {
        var link = document.createElement('a');
        link.download = 'metoda1.png';
        link.href = canvas.toDataURL();
        link.click();
      });
    },
    htmlToCanvas2: function htmlToCanvas2() {
      var _this3 = this;

      this.loading = true;
      var chartWidth = this.getChartWidthInteger(this.chartData, true);
      var minWidth = chartWidth + 120 > 1020 ? chartWidth + 120 : 1020;
      document.querySelector('.content-chart-body').style.overflow = 'visible';
      document.querySelector('.progress-section > div').style.paddingTop = '35px';
      document.querySelector('.progress-section .content-section-title').classList.add('hide-before-element');
      __WEBPACK_IMPORTED_MODULE_5_html_to_image___default.a.toPng(document.querySelector('.progress-section > div'), {
        quality: 1,
        width: minWidth,
        backgroundColor: '#ffffff'
      }).then(function (dataUrl) {
        _this3.loading = false;
        document.querySelector('.content-chart-body').style.overflow = '';
        document.querySelector('.progress-section > div').style.paddingTop = '';
        document.querySelector('.progress-section .content-section-title').classList.remove('hide-before-element');
        var link = document.createElement('a');
        link.download = 'progress-chart.png';
        link.href = dataUrl;
        link.click();
      }).catch(function () {
        _this3.loading = false;
        document.querySelector('.content-chart-body').style.overflow = '';
        document.querySelector('.progress-section > div').style.paddingTop = '';
        document.querySelector('.progress-section .content-section-title').classList.remove('hide-before-element');
      });
    },
    setChaptersProgress: function setChaptersProgress() {
      var self = this;
      self.chapters.forEach(function (chapter) {
        if (chapter.isReady) {
          var score = chapter.scores.score;
          var selector = '.progress__value-' + chapter.chapter.id;
          self.setCompanyProgress(score, selector);
        }
      });
    },
    reverseItems: function reverseItems(items) {
      if (items) {
        return items.slice().reverse();
      }
    },
    connectPoints: function connectPoints() {
      var chapters = document.querySelectorAll('.content-chart-points');
      for (var i = 0; i < chapters.length; i++) {
        var children = chapters[i].querySelectorAll('.content-chart-point');
        for (var n = 0; n < children.length; n++) {
          var isLast = false;
          var fromPoint = children[n];
          var toPoint = children[n + 1];
          if (!toPoint) {
            toPoint = document.getElementById(fromPoint.getAttribute('data-chapter'));
            isLast = true;
          }
          if (fromPoint !== undefined && toPoint !== undefined) {
            (function () {
              var el1 = fromPoint;
              var el2 = toPoint;
              var x1 = void 0;
              var x2 = void 0;
              var y1 = void 0;
              var y2 = void 0;
              var color = fromPoint.getAttribute('data-color');

              if (isLast) {
                x1 = el1.offsetLeft + 15;
                y1 = el1.offsetTop + el1.offsetHeight / 2 - 6;
                x2 = el2.offsetLeft + 15;
                y2 = el2.offsetTop + el1.offsetHeight / 2 + 5;
              } else {
                x1 = el1.offsetLeft + el1.offsetWidth - 2;
                y1 = el1.offsetTop + el1.offsetHeight - 11;
                x2 = el2.offsetLeft + el2.offsetWidth;
                y2 = el2.offsetTop;
              }

              var length = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
              var cx = (x1 + x2) / 2 - length / 2 - 5;
              var cy = (y1 + y2) / 2 - 3 / 2 + 5;
              var angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI);
              var line = document.createElement('div');
              line.style['-webkit-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-moz-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-ms-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-o-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-transform'] = 'rotate(' + angle + 'deg)';
              line.style.width = length + 'px';

              if (isLast) {
                line.style.backgroundColor = 'transparent';
                line.style.borderTop = '3px dashed ' + color;
              } else {
                line.style.backgroundColor = color;
              }

              line.style.position = 'absolute';
              line.style.left = cx + 'px';
              line.style.top = cy + 'px';
              line.style.height = 3 + 'px';
              try {
                document.body.onload = setTimeout(function () {
                  var chartData = document.querySelector('.content-chart-data');
                  if (chartData) {
                    chartData.appendChild(line);
                  }
                }, 500);
              } catch (err) {}
              isLast = false;
            })();
          }
        }
      }
      document.querySelector('.content-chart-body').scrollLeft = document.querySelector('.content-chart-body').scrollWidth;
    },
    addChapterHover: function addChapterHover(chapter, hoverActive) {
      for (var index in this.chartData) {
        if (this.chartData[index].hover && chapter.chapter.id !== this.chartData[index].chapter.id) {
          this.chartData[index].hover.show = false;
        }
        if (chapter.chapter.id === this.chartData[index].chapter.id) {
          var editedChapter = this.chartData[index];
          var scores = this.chartData[index].scores;
          var top = void 0;
          var create = this.chartData[index].hover ? !this.chartData[index].hover.show : true;
          if (hoverActive === 'benchmark') {
            top = scores[scores.length - 1].benchmark;
          } else {
            top = scores[scores.length - 1].score;
          }
          editedChapter.hover = {
            type: hoverActive,
            show: create,
            top: top
          };
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.chartData, index, editedChapter);
        }
      }
    },
    getChartWidth: function getChartWidth(chartData, full) {
      if (chartData !== null) {
        var rightMargin = 0;
        if (full) {
          rightMargin = 350;
        }
        return chartData.filter(function (item) {
          return item !== null;
        })[0].scores.length * 140 + rightMargin + 'px';
      }
    },
    getChartWidthInteger: function getChartWidthInteger(chartData, full) {
      if (chartData !== null) {
        var rightMargin = 0;
        if (full) {
          rightMargin = 350;
        }
        return chartData.filter(function (item) {
          return item !== null;
        })[0].scores.length * 140 + rightMargin;
      }
    },
    getChapterTopPosition: function getChapterTopPosition(chapter) {
      return chapter.top + '%';
    },
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    getChapterCustomName: function getChapterCustomName(chapter) {
      var name = null;
      if (chapter.slug === 'finding') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_finding_talent) {
          name = this.user.company.industry.chapter_finding_talent.title;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_finding_talent) {
          name = this.user.company.industry.parent.chapter_finding_talent.title;
        }
      } else if (chapter.slug === 'policies') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_policies_and_procedures) {
          name = this.user.company.industry.chapter_policies_and_procedures.title;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_policies_and_procedures) {
          name = this.user.company.industry.parent.chapter_policies_and_procedures.title;
        }
      } else if (chapter.slug === 'assessing') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_accessing_talent) {
          name = this.user.company.industry.chapter_accessing_talent.title;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_accessing_talent) {
          name = this.user.company.industry.parent.chapter_accessing_talent.title;
        }
      } else if (chapter.slug === 'retaining') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_retaining_talent) {
          name = this.user.company.industry.chapter_retaining_talent.title;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_retaining_talent) {
          name = this.user.company.industry.parent.chapter_retaining_talent.title;
        }
      }

      if (!name) {
        return chapter.name;
      } else {
        return name;
      }
    },
    getContentPageProps: function getContentPageProps(chapter) {
      var id = void 0;
      if (chapter.slug === 'finding') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_finding_talent) {
          id = this.user.company.industry.chapter_finding_talent.id;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_finding_talent) {
          id = this.user.company.industry.parent.chapter_finding_talent.id;
        } else {
          id = 131;
        }
      } else if (chapter.slug === 'policies') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_policies_and_procedures) {
          id = this.user.company.industry.chapter_policies_and_procedures.id;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_policies_and_procedures) {
          id = this.user.company.industry.parent.chapter_policies_and_procedures.id;
        } else {
          id = 132;
        }
      } else if (chapter.slug === 'assessing') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_accessing_talent) {
          id = this.user.company.industry.chapter_accessing_talent.id;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_accessing_talent) {
          id = this.user.company.industry.parent.chapter_accessing_talent.id;
        } else {
          id = 130;
        }
      } else if (chapter.slug === 'retaining') {
        if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.chapter_retaining_talent) {
          id = this.user.company.industry.chapter_retaining_talent.id;
        } else if (this.user && this.user.company && this.user.company.industry && this.user.company.industry.parent && this.user.company.industry.parent.chapter_retaining_talent) {
          id = this.user.company.industry.parent.chapter_retaining_talent.id;
        } else {
          id = 133;
        }
      }
      return {
        name: 'content',
        params: { id: id }
      };
    },
    hasBenchmark: function hasBenchmark(chapter) {
      if (chapter.scores.length) {
        if (chapter.scores[chapter.scores.length - 1].benchmark !== null) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getChapterIndex: function getChapterIndex(c) {
      var scores = [];
      var chartData = this.chartData;
      var index = 0;
      if (c.scores.length) {
        for (var _index in chartData) {
          var chapter = chartData[_index];
          scores.push(chapter.scores[chapter.scores.length - 1].top);
        }
        var orderedScores = scores.sort(function (a, b) {
          return a - b;
        });
        index = orderedScores.indexOf(c.scores[c.scores.length - 1].top);
      }
      return index;
    },
    getBadgeLink: function getBadgeLink() {
      var props = this.$router.resolve({
        name: 'badge'
      });
      return props.href;
    },
    getIframeCode: function getIframeCode() {
      var url = location.origin + this.getBadgeLink() + '?company=' + this.user.company.hash + '&theme=' + this.iframeTheme.value;
      return '<iframe title="' + (this.user && this.user.company ? this.user.company.name + ' badge' : 'Company badge') + '" width="210" height="85" src="' + url + '" style="border: none;"></iframe>';
    },
    copyIframe: function copyIframe() {
      document.getElementById('iframeCode').select();
      document.execCommand('copy');
    },
    reloadIframe: function reloadIframe() {
      var iframe = document.getElementById('previewIframe');
      iframe.src = iframe.src;
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload && payload !== '') {
        return true;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    }
  }),
  watch: {
    'badgeCopy': function badgeCopy(value) {
      if (value) {
        setTimeout(function () {
          document.getElementById('confirmation-popup-title').setAttribute('tabindex', '-1');
          document.getElementById('confirmation-popup-title').focus();
        }, 100);
      }
    },
    selectedHightCont: function selectedHightCont() {
      var iframe = document.getElementById('contentCompanyBadge').firstChild;
      iframe.src = iframe.src;
    },
    'iframeTheme': function iframeTheme() {
      this.reloadIframe();
    }
  },
  mounted: function mounted() {
    this.getUserInfoById();
  },
  created: function created() {
    document.title = 'Organisation profile | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick__ = __webpack_require__(90);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company-registration-landing',
  data: function data() {
    return {
      industryLanding: null,
      pageEditMode: false,
      landingPanel: false,
      logoEdit: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      landing: {
        logo: null
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        },
        stepSection: {
          description: '',
          steps: [{
            id: 1,
            text: '',
            altImage: '',
            image: '',
            altImageHigh: '',
            imageHigh: ''
          }, {
            id: 2,
            text: '',
            altImage: '',
            image: '',
            altImageHigh: '',
            imageHigh: ''
          }, {
            id: 3,
            text: '',
            altImage: '',
            image: '',
            altImageHigh: '',
            imageHigh: ''
          }],
          hideSection: false
        },
        clientSection: {
          title: '',
          description: '',
          button: {
            text: '',
            url: ''
          },
          logos: [{
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          }],
          hideSection: false
        },
        featuresSection: {
          title: '',
          items: [{
            title: '',
            excerpt: '',
            text: '',
            date: null,
            image: '',
            altImage: '',
            expanded: false
          }],
          hideSection: false
        },
        footerData: {
          logosLabel: '',
          logos: [{
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          }],
          hideSection: false
        }
      },
      initialContent: {
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: ''
        },
        clientSection: {
          title: '',
          description: '',
          button: {
            text: '',
            url: ''
          },
          logos: []
        },
        featuresSection: {
          title: '',
          items: []
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      slidesReady: false,
      slickOptions: {
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4
      },
      slickOptionsContent: {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      activePopup: null,
      stepImageChange: false,
      stepActive: 1,
      xDown: null,
      yDown: null,
      sliderModalShown: false,
      registrationForm: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        function: '',
        title: '',
        registrationInProgress: false,
        registrationErrors: null,
        registrationFormSubmitted: false,
        registrationFormResponseCode: 1
      },
      ppp: 5,
      footerEdit: false,
      focus: null,
      companyUrl: null,
      confOpened: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'initConfAction', 'redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    decodeHtml: function decodeHtml(value) {
      var txt = document.createElement('textarea');
      txt.innerHTML = value;
      return txt.value;
    },
    handleTouchStart: function handleTouchStart(evt) {
      this.xDown = evt.touches[0].clientX;
      this.yDown = evt.touches[0].clientY;
    },
    handleTouchMove: function handleTouchMove(evt) {
      if (!this.xDown || !this.yDown) {
        return;
      }
      if (!this.getDeviceType('mobile')) {
        return;
      }
      var target = evt.target;
      var steps = this.$refs.steps;
      if (steps && steps !== target && steps.contains(target)) {
        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;
        var xDiff = this.xDown - xUp;
        var yDiff = this.yDown - yUp;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          if (xDiff > 0) {
            if (this.stepActive === 1) {
              this.stepActive = 3;
            } else {
              this.stepActive -= 1;
            }
          } else {
            if (this.stepActive === 3) {
              this.stepActive = 1;
            } else {
              this.stepActive += 1;
            }
          }
        }
        this.xDown = null;
        this.yDown = null;
      }
    },
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.logoEdit = false;
      this.footerEdit = false;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: this.industryLanding,
        body: body,
        registrationLanding: true,
        logo: this.landing.logo
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.landingPanel = false;
        _this.getLandingPage(null, true);
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: this.industryLanding,
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this3 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/' + this.industryLanding + '?type=2', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id,
            value: res.body[index].id
          });
        }
        _this3.editHistory = true;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    expandSection: function expandSection(section, feature) {
      feature.expanded = !feature.expanded;
      this.goToPageSection(section);
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        var here = element[0] ? element[0] : element;
        here.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    getLandingPage: function getLandingPage(id, refresh) {
      var _this4 = this;

      this.slidesReady = false;
      var body = {
        slug: this.industryLanding,
        type: 2
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/' + this.industryLanding, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        if (pageData.footerData) {
          _this4.content.footerData = pageData.footerData;
        }
        if (pageData.heroSection) {
          _this4.content.heroSection = pageData.heroSection;
        }
        if (pageData.stepSection) {
          _this4.content.stepSection = pageData.stepSection;
        }
        if (pageData.featuresSection) {
          _this4.content.featuresSection = pageData.featuresSection;
        }
        if (pageData.clientSection) {
          _this4.content.clientSection = pageData.clientSection;
        }
        if (res.data.logo) {
          _this4.landing.logo = res.data.logo;
        }
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title;
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        // Set initial data
        _this4.initialContent = pageData;
        _this4.slidesReady = true;
        _this4.$nextTick(function () {
          if (_this4.$refs.slick) {
            _this4.$refs.slick.reSlick();
          }
        });
        if (id) {
          _this4.pageEditSwitch();
        } else {
          if (refresh) {
            _this4.pageEditMode = false;
          }
        }
        if (_this4.$route.name === 'edit-company-registration-landing') {
          _this4.$nextTick(function () {
            _this4.autoSizeOnInit();
          });
        }
        if (_this4.landing.logo) {
          var logoNode = document.getElementById('landingHeaderLogo');
          if (logoNode) {
            logoNode.src = _this4.getImageFullPath(_this4.landing.logo);
          }
        }
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    changeEmail: function changeEmail() {
      this.registrationForm.registrationFormSubmitted = false;
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage(null, true);
    },
    pageEditSwitch: function pageEditSwitch() {
      this.confOpened = 'edit';
      this.initConfAction({
        actionName: 'editLanding'
      });
    },
    pageEditSwitchConfirmed: function pageEditSwitchConfirmed() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
      this.getConfData.actionConfirmed = false;
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    addSection: function addSection(section) {
      if (section === 'features') {
        this.content.featuresSection.items.push({
          title: '',
          excerpt: '',
          text: '',
          date: new Date(),
          image: '',
          altImage: '',
          expanded: false
        });
      }
      if (section === 'logos') {
        this.content.clientSection.logos.push({
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: '',
          url: ''
        });
      }
      if (section === 'footer-logos') {
        this.content.footerData.logos.push({
          image: '',
          altImage: '',
          imageHigh: '',
          altImageHigh: '',
          url: ''
        });
      }
    },
    removeSection: function removeSection(section, index) {
      section.splice(index, 1);
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload && payload !== '') {
        return true;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    getCurrentDate: function getCurrentDate(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var dd = date.getDate();
      var mm = date.getMonth();
      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }

      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      return dd + ' ' + monthNames[mm] + ' ' + yyyy;
    },
    getHighImage: function getHighImage(item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image;
    },
    getHighImageAlt: function getHighImageAlt(item) {
      return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage;
    },
    activatePopup: function activatePopup(item) {
      this.activePopup = item;
    },
    closePopup: function closePopup() {
      var _this6 = this;

      this.activePopup = null;
      this.sliderModalShown = false;
      this.slidesReady = true;
      this.pageMetaEdit = false;
      this.logoEdit = false;
      this.footerEdit = false;
      this.$nextTick(function () {
        _this6.$refs.slick.reSlick();
      });
    },
    closePopupOnOutsideClick: function closePopupOnOutsideClick(e) {
      var _this7 = this;

      var iconPopup = this.$refs.iconPopup;
      var sliderPopup = this.$refs.sliderPopup;
      var target = e.target;
      if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
        this.activePopup = null;
      }
      if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
        this.switchSliderModal();
        this.slidesReady = true;
        this.$nextTick(function () {
          _this7.$refs.slick.reSlick();
        });
      }
    },
    switchSliderModal: function switchSliderModal() {
      this.sliderModalShown = !this.sliderModalShown;
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 1024) {
        deviceName = 'desktop';
      } else if (width > 640) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    editPageLogo: function editPageLogo() {
      this.logoEdit = true;
    },
    submitForm: function submitForm(confirmEmailNotFound) {
      var _this8 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      this.registrationForm.registrationInProgress = true;
      var formData = {
        firstName: this.registrationForm.firstName,
        lastName: this.registrationForm.lastName,
        email: this.registrationForm.email,
        phone: this.registrationForm.phone,
        function: this.registrationForm.function,
        title: this.registrationForm.title,
        companyUrl: this.companyUrl
      };
      if (confirmEmailNotFound) {
        formData['confirmEmail'] = true;
      }
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.register, formData).then(function (res) {
        _this8.disableAPI = false;
        _this8.registrationForm.registrationFormSubmitted = true;
        _this8.registrationForm.registrationInProgress = false;
        _this8.registrationForm.registrationErrors = null;
        _this8.registrationForm.registrationFormResponseCode = res.body.code;
      }).catch(function (err) {
        _this8.disableAPI = false;
        _this8.registrationForm.registrationFormSubmitted = false;
        _this8.registrationForm.registrationInProgress = false;
        _this8.registrationForm.registrationErrors = [];
        _this8.registrationForm.registrationFormResponseCode = err.body.code;
        if (_this8.registrationForm.registrationFormResponseCode) {
          _this8.registrationForm.registrationErrors = [err.body.message];
        } else {
          for (var i = 0; i < err.body.length; i++) {
            _this8.registrationForm.registrationErrors.push(err.body[i]);
          }
        }
      });
    },
    checkCompany: function checkCompany() {
      var _this9 = this;

      var formData = {
        companyUrl: this.companyUrl
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.companiesS + '/check-company-url', formData).then(function () {}).catch(function (err) {
        if (err.status === 404) {
          var props = _this9.$router.resolve({
            name: 'error'
          });
          _this9.$router.push(props.href);
        }
      });
    }
  }),
  mounted: function mounted() {
    this.industryLanding = this.$route.params['industry'];
    this.companyUrl = this.$route.params['company'];
    if (this.$route.name !== 'edit-company-registration-landing' && this.companyUrl !== 'default') {
      this.checkCompany();
    }
    this.getLandingPage();
    this.setFontSizeActive();
    this.setColorPaletteActive();
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
    if (this.$route.name === 'edit-company-registration-landing') {
      this.pageEditMode = true;
      this.landingPanel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.closePopupOnOutsideClick);
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_4_vue_slick__["a" /* default */]
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.params.industry !== from.params.industry || to.params.company !== from.params.company) {
        this.industryLanding = to.params.industry;
        this.companyUrl = to.params.company;
        if (this.$route.name !== 'edit-company-registration-landing' && this.companyUrl !== 'default') {
          this.checkCompany();
        }
        this.getLandingPage();
      }
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'edit') this.pageEditSwitchConfirmed();
        this.clearConfAction();
      }
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm-subscription',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      user: null,
      subscriptionId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['initConfAction', 'authLogout', 'clearConfAction']), {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.post);
      var pageData = {
        slug: 'confirm-subscription',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage();
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'confirm-subscription',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'confirm-subscription'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/confirm-subscription', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.post = pageData;
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.post.title = _this3.metaData.title;
        _this3.post.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          _this3.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/confirm-subscription', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    confirmSubscription: function confirmSubscription() {
      var subscriptionId = this.subscriptionId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.subscribeConfirm + '/' + subscriptionId, [], __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    getSubscription: function getSubscription(id) {
      var _this5 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.subscription + '/' + id, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).catch(function () {
        var props = _this5.$router.resolve({
          name: 'error'
        });
        _this5.$router.push(props.href);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this6 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this6.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },

    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    }
  }),
  created: function created() {
    this.subscriptionId = this.$route.params.id;
    if (this.getUserRole !== 'gm') {
      this.getSubscription(this.subscriptionId);
    }
    if (this.subscriptionId) {
      this.confirmSubscription();
    }
  },
  beforeMount: function beforeMount() {
    this.getLandingPage();
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company-list',
  data: function data() {
    return {
      ppt: 15,
      offset: 0,
      limit: 15,
      order: 'desc',
      logsCount: 0,
      search: '',
      table: '',
      head: '',
      logs: [],
      hoverSearchElements: [],
      logUsers: null,
      logEmails: null,
      logCompanies: null,
      logActions: null,
      usersFilter: [],
      emailsFilter: [],
      companiesFilter: [],
      actionsFilter: [],
      logsUser: null,
      logsEmail: null,
      logsCompany: null,
      logsAction: null,
      logOrderBy: {
        order: false
      },
      companyFilterLocked: false,
      userFilterLocked: false,
      emailFilterLocked: false,
      serverValidation: {
        errors: []
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      statusbar: {
        filter: {
          isHover: false
        }
      },
      windowWidth: window.innerWidth,
      downloadInProcess: false
    };
  },

  methods: {
    fetchAllContentByScroll: function fetchAllContentByScroll(reInit) {
      var _this = this;

      var user = '';
      if (this.logsUser) {
        user = this.logsUser.id;
      } else if (this.logsEmail) {
        user = this.logsEmail.id;
      }
      var body = {
        offset: this.offset,
        limit: this.limit,
        order: this.order,
        companyId: this.logsCompany ? this.logsCompany.id : '',
        userId: user,
        action: this.logsAction ? this.logsAction.id : ''
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.consent, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.logsCount = res.body.count;
        if (reInit) {
          _this.logs = [];
        }
        _this.logs = _this.logs.concat(res.body.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getAllFilters: function getAllFilters() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.consentLogs, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings), this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.filterLogCompanies, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings), this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.filterLogUsers, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings)]).then(function (data) {
        self.logActions = data[0].body;
        self.logCompanies = data[1].body;
        self.logUsers = data[2].body;
      });
    },
    downloadConsentLogs: function downloadConsentLogs() {
      var _this2 = this;

      this.downloadInProcess = true;
      var user = '';
      if (this.logsUser) {
        user = this.logsUser.id;
      } else if (this.logsEmail) {
        user = this.logsEmail.id;
      }
      var body = {
        offset: this.offset,
        limit: this.limit,
        order: this.order,
        companyId: this.logsCompany ? this.logsCompany.id : '',
        userId: user,
        action: this.logsAction ? this.logsAction.id : ''
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.consentDownload, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.downloadInProcess = false;
        var hiddenElement = document.getElementById('consentDownload');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(res.body);
        hiddenElement.download = _this2.getConsentDownloadName();
        hiddenElement.click();
      }).catch(function (err) {
        _this2.downloadInProcess = false;
        console.log(err);
      });
    },
    updateUsersFilter: function updateUsersFilter() {
      var _this3 = this;

      var body = {
        companyId: this.logsCompany ? this.logsCompany.id : ''
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.filterLogUsers, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.logUsers = res.body;
      }).catch(function (err) {
        console.log(err);
      });
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true;
      }
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistSearchInOptions: function isExistSearchInOptions(type) {
      var hoverElement = this.hoverSearchElements ? this.hoverSearchElements : '';
      if (hoverElement === type) {
        return true;
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      if (this.logsUser && this.logsUser.label === filter.label && this.logsUser.value === filter.value) {
        this.logsUser = null;
      }
      if (this.logsEmail && this.logsEmail.label === filter.label && this.logsEmail.value === filter.value) {
        this.logsEmail = null;
      }
      if (this.logsCompany && this.logsCompany.label === filter.label && this.logsCompany.value === filter.value) {
        this.logsCompany = null;
      }
      if (this.logsAction && this.logsAction.label === filter.label && this.logsAction.value === filter.value) {
        this.logsAction = null;
      }
    },
    removeAllFilters: function removeAllFilters() {
      this.logsUser = null;
      this.logsEmail = null;
      this.logsCompany = null;
      this.logsAction = null;
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    convertDate: function convertDate(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '.' + toDoubleDigit(month) + '.' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    getConsentDownloadName: function getConsentDownloadName() {
      var date = new Date();
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      month = months[month - 1];
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + month + fullYear;
      var timeString = toDoubleDigit(hours) + 'h' + toDoubleDigit(minutes) + 'm';
      return 'ConsentLog' + '-' + dateString + '-' + timeString;
    },
    changeOrderBy: function changeOrderBy(order) {
      this.logOrderBy = {
        order: this.logOrderBy !== null ? !this.logOrderBy.order : order
      };
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
      this.fetchAllContentByScroll();
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width >= 940) {
        deviceName = 'desktop';
      } else if (width >= 480) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    getTabletFiltersAppliedText: function getTabletFiltersAppliedText() {
      var filterAppliedText = 'Apply Filters';
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.logs.length + ' results';
      }
      return filterAppliedText;
    },
    getUser: function getUser(log) {
      var user = this.logUsers.find(function (user) {
        return user.id === log.userId;
      });
      if (!user) {
        return 'n/a';
      }
      var fullName = '';
      if (user && user.firstName) {
        fullName += user.firstName + ' ';
      }
      if (user && user.lastName) {
        fullName += user.lastName;
      }
      if (user.status === 3) {
        return (fullName !== '' ? fullName : 'User') + ' [DELETED]';
      }
      return fullName !== '' ? fullName : 'n/a';
    },
    getEmail: function getEmail(log) {
      var user = this.logUsers.find(function (user) {
        return user.id === log.userId;
      });
      if (!user) {
        return 'n/a';
      }
      return user.email ? user.email : 'n/a';
    },
    getActionName: function getActionName(log) {
      return this.logActions[log.message];
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['getUserRole']), {
    selectedFilters: function selectedFilters() {
      var filters = [];
      if (this.logsUser) {
        filters.push(this.logsUser);
      }
      if (this.logsEmail) {
        filters.push(this.logsEmail);
      }
      if (this.logsCompany) {
        filters.push(this.logsCompany);
      }
      if (this.logsAction) {
        filters.push(this.logsAction);
      }
      return filters;
    },
    getUsersForSelect: function getUsersForSelect() {
      return this.usersFilter;
    },
    getEmailsForSelect: function getEmailsForSelect() {
      return this.emailsFilter;
    },
    getCompaniesForSelect: function getCompaniesForSelect() {
      return this.companiesFilter;
    },
    getActionsForSelect: function getActionsForSelect() {
      return this.actionsFilter;
    }
  }),
  watch: {
    'logUsers': function logUsers(value) {
      var _this4 = this;

      this.usersFilter = [];
      this.emailsFilter = [];
      value.forEach(function (user) {
        var fullName = '';
        if (user.firstName) {
          fullName += user.firstName += ' ';
        }
        if (user.lastName) {
          fullName += user.lastName;
        }
        if (fullName !== '') {
          _this4.usersFilter.push({
            id: user.id,
            label: fullName
          });
        }
        if (user.status === '3') {
          _this4.emailsFilter.push({
            id: user.id,
            label: user.email + ' [DELETED]'
          });
        } else {
          _this4.emailsFilter.push({
            id: user.id,
            label: user.email
          });
        }
      });
    },
    'logCompanies': function logCompanies(value) {
      var _this5 = this;

      this.companiesFilter = [];
      value.forEach(function (company) {
        _this5.companiesFilter.push({
          id: company.id,
          label: company.name
        });
      });
    },
    'logActions': function logActions(value) {
      this.actionsFilter = [];
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        this.actionsFilter.push({
          id: key,
          label: value[key]
        });
      }
    },
    'logOrderBy.order': function logOrderByOrder(value) {
      this.order = value ? 'asc' : 'desc';
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsUser': function logsUser(value) {
      if (value) {
        this.companyFilterLocked = true;
        this.emailFilterLocked = true;
      } else {
        this.companyFilterLocked = false;
        this.emailFilterLocked = false;
      }
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsEmail': function logsEmail(value) {
      if (value) {
        this.userFilterLocked = true;
      } else {
        this.userFilterLocked = false;
      }
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsCompany': function logsCompany() {
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.updateUsersFilter();
      this.fetchAllContentByScroll(true);
    },
    'logsAction': function logsAction() {
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.getAllFilters();
      this.fetchAllContentByScroll(true);
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default.a
  },
  created: function created() {
    document.title = 'Consent logs | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted: function mounted() {
    this.getAllFilters();
    this.fetchAllContentByScroll();
    document.addEventListener('click', this.hideSubMenuTableHead);
    window.addEventListener('resize', this.handleWindowResize);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      },
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        },
        contactsSection: {
          address: '',
          addressInfo: '',
          email: '',
          phone: ''
        },
        formSection: {
          title: ''
        }
      },
      formData: {
        name: {
          text: '',
          focus: false
        },
        surname: {
          text: '',
          focus: false
        },
        jobTitle: {
          text: '',
          focus: false
        },
        email: {
          text: '',
          focus: false
        },
        phone: {
          text: '',
          focus: false
        },
        company: {
          text: '',
          focus: false
        },
        industry: {
          text: '',
          focus: false
        },
        employees: {
          text: '',
          focus: false
        },
        message: {
          text: '',
          focus: false
        },
        subscribe: false
      },
      contactRequest: {
        shown: false,
        success: true,
        message: '',
        email: ''
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    submitContactForm: function submitContactForm() {
      var _this = this;

      if (this.disableAPI) return;
      this.formStatus.submitting = true;
      this.$validator.validateAll(['First name', 'Last name', 'Job title', 'Telephone', 'Your message', 'Email address', 'Company name', 'Industry', 'Approximate number of employees']).then(function (valid) {
        if (!valid) {
          _this.formStatus.submitting = false;
          setTimeout(function () {
            _this.scrollToTheMessage();
          }, 100);
          return;
        }
        var body = {
          name: _this.formData.name.text,
          surname: _this.formData.surname.text,
          jobTitle: _this.formData.jobTitle.text,
          email: _this.formData.email.text,
          phone: _this.formData.phone.text,
          company: _this.formData.company.text,
          industry: _this.formData.industry.text,
          employees: _this.formData.employees.text,
          message: _this.formData.message.text,
          subscribe: _this.formData.subscribe
        };
        _this.disableAPI = true;
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.contactSubmit, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
          _this.disableAPI = false;
          _this.formStatus.shown = true;
          _this.formStatus.success = true;
          _this.formStatus.title = 'You have successfully submitted your message.';
          _this.formStatus.body = 'Thank you for getting in touch. We usually reply to the contact form message in maximum 24 hours from when it was submitted to us. If your inquiry is urgent, please give us a call.';
          _this.formData.name.text = '';
          _this.formData.surname.text = '';
          _this.formData.jobTitle.text = '';
          _this.formData.email.text = '';
          _this.formData.phone.text = '';
          _this.formData.company.text = '';
          _this.formData.industry.text = '';
          _this.formData.employees.text = '';
          _this.formData.message.text = '';
          _this.formData.subscribe = false;
          setTimeout(function () {
            _this.scrollToTheMessage();
            _this.errors.clear();
          }, 100);
          _this.formStatus.submitting = false;
        }).catch(function (err) {
          _this.formStatus.submitting = false;
          _this.serverValidation.errors = err;
          _this.disableAPI = false;
          _this.formStatus.shown = true;
          _this.formStatus.success = false;
          _this.formStatus.title = err.body.message || 'Your message was not submitted.';
          _this.formStatus.body = 'It looks like there was an error and your message could not be sent. Please try again or give us a call and we\'ll have our support team help you.';
          setTimeout(function () {
            _this.scrollToTheMessage();
          }, 100);
        });
      });
    },
    scrollToTheMessage: function scrollToTheMessage() {
      var elem = document.querySelector('.tcc-form-message');
      if (elem) {
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    updateLandingPage: function updateLandingPage() {
      var _this2 = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: 'contact-page',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.getLandingPage();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this3 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'contact-page',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this4 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'contact-page'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/contact-page', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this4.content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.content, pageData);
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title + ' | Clear Assured';
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        if (id) {
          _this4.pageEditSwitch();
        } else {
          _this4.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this5 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/contact-page', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this5.editHistory = true;
      }).catch(function (err) {
        _this5.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this6 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this6.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 940) {
        deviceName = 'desktop';
      } else if (width > 640) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      return payload.indexOf('data:') !== -1;
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    goToSection: function goToSection(id) {
      var element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    heroImageHeightFix: function heroImageHeightFix() {
      var imageContainer = document.querySelector('.hero-section .right-content');
      var image = document.querySelector('.hero-section .hero-image');
      var header = document.querySelector('header');
      var maxHeight = window.innerHeight;
      if (header) {
        maxHeight -= header.offsetHeight;
      }
      if (imageContainer && image && (image.clientHeight < maxHeight || imageContainer.clientHeight < maxHeight)) {
        imageContainer.style.height = maxHeight + 'px';
        image.style.maxHeight = maxHeight + 'px';
      }
    }
  }),
  created: function created() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    this.heroImageHeightFix();
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('resize', this.heroImageHeightFix);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('resize', this.heroImageHeightFix);
  },

  watch: {}
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard-promotions',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      promotions: [],
      updatedPromotions: [],
      newPromotion: {
        title: '',
        text: '',
        image: null,
        imageAlt: null,
        active: true,
        link: null,
        button: null,
        roles: null,
        companies: null,
        industries: null,
        targetUsers: null,
        targetDate: null
      },
      datepicker: {
        targetDate: null,
        startDate: null,
        shown: false,
        startShown: false,
        keepFocus: false
      },
      editDatepicker: {
        targetDate: null,
        startDate: null,
        shown: false,
        startShown: false,
        keepFocus: false
      },
      disableAPI: false,
      searchString: '',
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false,
      isFileUploaded: false,
      isEditFileUploaded: false,
      editorToolbar: [[{ 'header': [1, 2, 3, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['setInformationMsg', 'clearConfAction', 'initConfAction', 'getRoles', 'getCompanies', 'getIndustries']), {
    displayAddForm: function displayAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    closeAddForm: function closeAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    removePromotion: function removePromotion(id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removePromotionById'
      });
    },
    removePromotionConfirmed: function removePromotionConfirmed(id) {
      var self = this;
      var thisPromotion = this.updatedPromotions.find(function (promotion) {
        return promotion.id === id;
      });
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.promotions + '/' + id, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.infMsgTitle = thisPromotion.title + ' promotion was successfully deleted.';
        self.infMsgDescription = 'Please note all actions are being logged.';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        for (var i = 0; i < self.promotions.length; i++) {
          if (self.promotions[i].id === id) {
            self.promotions.splice(i, 1);
            break;
          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    fetchAllContentByScroll: function fetchAllContentByScroll() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.promotions, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body) {
          _this.promotions = res.body;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    createPromotion: function createPromotion() {
      var _this2 = this;

      if (this.disableAPI) return;
      if (!this.newPromotion.title) return;
      var formData = {
        title: this.newPromotion.title,
        text: this.newPromotion.text,
        image: this.newPromotion.image,
        imageAlt: this.newPromotion.imageAlt,
        link: this.newPromotion.link,
        button: this.newPromotion.button,
        roles: this.newPromotion.roles,
        companies: this.newPromotion.companies,
        industries: this.newPromotion.industries,
        active: this.newPromotion.active,
        targetUsers: this.newPromotion.targetUsers ? this.newPromotion.targetUsers.value : null,
        targetDate: this.newPromotion.targetDate
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.promotions, formData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = _this2.newPromotion.title + ' promotion was successfully added.';
        _this2.infMsgDescription = 'Please note all actions are being logged.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.newPromotion.title = '';
        _this2.newPromotion.text = '';
        _this2.newPromotion.image = null;
        _this2.newPromotion.imageAlt = null;
        _this2.newPromotion.link = '';
        _this2.newPromotion.button = '';
        _this2.newPromotion.roles = null;
        _this2.newPromotion.companies = null;
        _this2.newPromotion.industries = null;
        _this2.newPromotion.active = true;
        _this2.newPromotion.targetUsers = null;
        _this2.newPromotion.targetDate = '';
        _this2.addFormDisplay = false;
        _this2.isFileUploaded = false;
        _this2.fetchAllContentByScroll();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log(err);
      });
    },
    switchEditMode: function switchEditMode(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedPromotions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var promotion = _step.value;

          if (promotion.type === 'edit') promotion.type = null;
          if (promotion.id === id && promotion.type === null) {
            promotion.type = 'edit';
            var date = promotion.targetDate ? promotion.targetDate.split('/') : null;
            if (date) {
              var formattedDate = new Date(parseInt(date[2]), parseInt(date[1]) - 1, parseInt(date[0]));
              this.editDatepicker.targetDate = promotion.targetDate ? formattedDate : new Date();
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    editPromotion: function editPromotion(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      var promotion = this.updatedPromotions.find(function (promotion) {
        return promotion.id === id && promotion.type === 'edit';
      });
      var formData = {
        id: id,
        title: promotion.title,
        text: promotion.text,
        image: promotion.image,
        imageAlt: promotion.imageAlt,
        link: promotion.link,
        button: promotion.button,
        roles: promotion.roles,
        companies: promotion.companies,
        industries: promotion.industries,
        active: promotion.active,
        targetUsers: promotion.targetUsers ? promotion.targetUsers.value : null,
        targetDate: promotion.targetDate
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.promotions, formData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.discardChanges(id);
        _this3.fetchAllContentByScroll();
        _this3.infMsgTitle = promotion.title + ' promotion was successfully updated.';
        _this3.infMsgDescription = 'Please note all actions are being logged.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log(err);
      });
    },
    discardChanges: function discardChanges(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedPromotions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var promotion = _step2.value;

          if (promotion.id === id && promotion.type === 'edit') {
            promotion.type = null;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    onThumbnailFileChange: function onThumbnailFileChange(e, id) {
      var self = this;
      var input = document.getElementById('promotionImage-' + id);
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        if (id === 0) {
          reader.onload = function (e) {
            self.isFileUploaded = true;
            self.newPromotion.image = e.target.result;
          };
        } else {
          var promotion = this.updatedPromotions.find(function (promotion) {
            return promotion.id === id && promotion.type === 'edit';
          });
          reader.onload = function (e) {
            self.isEditFileUploaded = true;
            promotion.image = e.target.result;
          };
        }
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeThumbnail: function removeThumbnail(id) {
      var input = document.getElementById('promotionImage-' + id);
      input.value = null;
      if (id === 0) {
        this.isFileUploaded = false;
        this.newPromotion.image = null;
      } else {
        var promotion = this.updatedPromotions.find(function (promotion) {
          return promotion.id === id && promotion.type === 'edit';
        });
        this.isEditFileUploaded = false;
        promotion.image = null;
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload && payload !== '') {
        return true;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    dateSelected: function dateSelected(e) {
      this.newPromotion.targetDate = this.convertDate(e, '/');
      this.datepicker.shown = false;
    },
    dateSelectedEdit: function dateSelectedEdit(e, promotion) {
      promotion.targetDate = this.convertDate(e, '/');
      this.editDatepicker.shown = false;
    },
    convertDate: function convertDate(payload, delimiter) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }

      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear;
    },
    isDescendant: function isDescendant(parent, child) {
      var node = child.parentNode;
      while (node !== null) {
        if (node === parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    },
    documentClick: function documentClick(e) {
      var self = this;
      if (self.datepicker.shown) {
        var datepicker = document.getElementById('date-selector');
        var target = e.target;
        if (!this.isDescendant(datepicker, target)) {
          self.datepicker.shown = false;
          self.editDatepicker.shown = false;
        }
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getConfData', 'getRolesForSelect', 'getCompaniesForSelect', 'getIndustriesForSelect']), {
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    },
    filteredPromotions: function filteredPromotions() {
      var _this4 = this;

      return this.promotions.filter(function (promotion) {
        return promotion.title.toLowerCase().indexOf(_this4.searchString.toLowerCase()) > -1;
      });
    },
    targetUsers: function targetUsers() {
      return [{
        label: 'Created before',
        value: 1
      }, {
        label: 'Created after',
        value: 2
      }];
    }
  }),
  watch: {
    filteredPromotions: function filteredPromotions() {
      var _this5 = this;

      var updatedPromotions = [];
      this.filteredPromotions.forEach(function (promotion, i, arr) {
        promotion.type = 'show';
        updatedPromotions.push(promotion);
        var editPromotion = {
          type: null,
          id: promotion.id,
          title: promotion.title,
          text: promotion.text,
          image: promotion.image,
          imageAlt: promotion.image_alt,
          active: promotion.active,
          button: promotion.button,
          link: promotion.link,
          targetDate: _this5.convertDate(promotion.target_date, '/')
        };
        if (promotion.roles && promotion.roles.length) {
          editPromotion.roles = [];
          promotion.roles.forEach(function (row) {
            editPromotion.roles.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (promotion.companies && promotion.companies.length) {
          editPromotion.companies = [];
          promotion.companies.forEach(function (row) {
            editPromotion.companies.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (promotion.industries && promotion.industries.length) {
          editPromotion.industries = [];
          promotion.industries.forEach(function (row) {
            editPromotion.industries.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (promotion.target_users) {
          editPromotion.targetUsers = _this5.targetUsers.find(function (t) {
            return t.value === promotion.target_users;
          });
        }
        updatedPromotions.push(editPromotion);
      });
      this.updatedPromotions = updatedPromotions;
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      var actionName = this.getConfData.actionName;
      if (value) {
        switch (actionName) {
          case 'removePromotionById':
            this.removePromotionConfirmed(this.getConfData.actionId);
            this.clearConfAction();
            break;
        }
      }
    },
    addFormDisplay: function addFormDisplay(value) {
      if (value) {
        this.newPromotion.targetDate = this.convertDate(new Date(), '/');
        this.datepicker.targetDate = new Date();
      }
    }
  },
  components: {},
  mounted: function mounted() {
    this.fetchAllContentByScroll();
    this.getRoles();
    this.getCompanies();
    this.getIndustries();
    document.addEventListener('click', this.hideSubMenuTableHead);
    document.addEventListener('click', this.documentClick);
  },
  created: function created() {
    document.title = 'Dashboard promotions | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.hideSubMenuTableHead);
    document.removeEventListener('click', this.documentClick);
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'download-brochure',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: ''
        },
        contentSection: {
          title: '',
          summary: [{
            text: ''
          }]
        }
      },
      initialContent: {
        heroSection: {
          title: '',
          description: ''
        },
        contentSection: {
          title: '',
          summary: [{
            text: ''
          }]
        }
      },
      brochureRequest: {
        shown: false,
        success: true,
        subscribe: false,
        message: '',
        email: ''
      },
      windowWidth: window.innerWidth
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    requestBrochure: function requestBrochure() {
      var _this = this;

      if (this.disableAPI) return;
      var body = {
        email: this.brochureRequest.email,
        subscribe: this.brochureRequest.subscribe
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.brochureRequest, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.brochureRequest.shown = true;
        _this.brochureRequest.success = true;
        _this.brochureRequest.subscribe = false;
        _this.brochureRequest.message = 'Please check your email. We sent you a download link.';
        _this.brochureRequest.email = '';
      }).catch(function (err) {
        _this.disableAPI = false;
        _this.brochureRequest.shown = true;
        _this.brochureRequest.success = false;
        _this.brochureRequest.message = 'Server error';
        console.log('err', err);
      });
    },
    updateLandingPage: function updateLandingPage() {
      var _this2 = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: 'download-brochure-page',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.getLandingPage();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this3 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'download-brochure-page',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id) {
      var _this4 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'download-brochure-page'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/download-brochure-page', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this4.content = pageData;
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title + ' | Clear Assured';
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        if (id) {
          _this4.pageEditSwitch();
        } else {
          _this4.pageEditMode = false;
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this5 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/download-brochure-page', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this5.editHistory = true;
      }).catch(function (err) {
        _this5.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage();
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this6 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this6.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },
    addSection: function addSection(section) {
      section.push({
        text: ''
      });
    },
    removeSection: function removeSection(section, index) {
      section.splice(index, 1);
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width > 940) {
        deviceName = 'desktop';
      } else if (width > 640) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    }
  }),
  created: function created() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },

  watch: {}
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-article',
  data: function data() {
    return {
      entity: {
        title: '',
        type: null,
        featuredImage: '',
        altImage: '',
        topic: null,
        category: null,
        company: null,
        industry: null,
        location: null,
        size: null,
        noCompany: null,
        notIndustry: null,
        notLocation: null,
        notSize: null,
        content: '',
        ttd: [],
        ttc: [],
        status: null,
        lastTimeEditedDate: null,
        lastTimeEditedBy: null,
        loading: true,
        resources: {
          video: [{
            videoUrl: '',
            videoTranscript: ''
          }],
          document: [{
            name: '',
            extension: '',
            resource: null,
            resourceUrl: '',
            resourceTranscript: ''
          }]
        }
      },
      featuredImage: null,
      articleType: {
        type: null,
        shown: false
      },
      confOpened: null,
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {}
      },
      initialData: {},
      contentLoaded: false,
      articleLog: [],
      tags: [],
      categories: [],
      roles: [],
      thingsToConsiderOptions: [],
      thingsToDoOptions: [],
      isThumbnailFileUploaded: false,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      isSpecific: null,
      isExcluded: null,
      articleEditBoxActive: true,
      articleRelatedBoxActive: true,
      articleSettingsBoxActive: true,
      articleResourcesBoxActive: true,
      articleChangelogBoxActive: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getTagsForSelect', 'getCategoriesForSelect', 'getCompaniesForSelect', 'getLanguagesForSelect', 'getIndustriesForSelect', 'getConfData', 'companyLocations', 'companySizes']), {
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    },
    thingsToConsiderOptionsComputed: function thingsToConsiderOptionsComputed() {
      return this.thingsToConsiderOptions;
    }
  }),
  created: function created() {
    this.articleId = this.$route.params.id;
    document.onclick = this.documentClick;
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  watch: {
    'entity.company': function entityCompany(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'company';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.industry': function entityIndustry(value) {
      if (value.length > 0) {
        if (this.isSpecific === null) {
          this.isSpecific = 'industry';
        }
      } else {
        this.isSpecific = null;
      }
    },
    'entity.notCompany': function entityNotCompany(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'company';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.notIndustry': function entityNotIndustry(value) {
      if (value.length > 0) {
        if (this.isExcluded === null) {
          this.isExcluded = 'industry';
          this.isSpecific = null;
        }
      } else {
        this.isExcluded = null;
      }
    },
    'entity.type': function entityType(value) {
      if (value) {
        this.articleType.shown = true;
        if (value.label === 'Video') {
          this.articleType.type = 'video';
        } else if (value.label === 'Template' || value.label === 'Document') {
          this.articleType.type = 'document';
        }
      } else {
        this.articleType.shown = false;
        this.articleType.type = null;
      }
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteArticleConfirmed();
        if (this.confOpened === 'archive') this.archiveArticleConfirmed();
        this.clearConfAction();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'getTypes', 'getCompanies', 'getCategories', 'getTags', 'setInformationMsg', 'getIndustries', 'initConfAction', 'authLogout', 'getCompanyLocations', 'getCompanySizes']), {
    addVideoRow: function addVideoRow() {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.push({
          videoUrl: '',
          videoTranscript: ''
        });
      } else {
        this.entity.resources.document.push({
          name: '',
          resource: null,
          extension: null,
          resourceUrl: '',
          resourceTranscript: ''
        });
      }
    },
    removeElement: function removeElement(index) {
      if (this.articleType.type === 'video') {
        this.entity.resources.video.splice(index, 1);
      } else {
        this.entity.resources.document.splice(index, 1);
      }
    },
    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var $this = this;
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        }).then(function (alt) {
          if (alt) {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">');
          } else {
            Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">');
          }
        });
      };
    },
    removeResource: function removeResource(index) {
      this.entity.resources.document[index].resource = null;
      this.entity.resources.document[index].extension = null;
      this.entity.resources.document[index].name = '';
    },
    addFormElement: function addFormElement(type) {
      this.addElements[type] += 1;
    },
    onThumbnailFileChange: function onThumbnailFileChange(e) {
      var self = this;
      var input = document.getElementById('uploadThumbnail');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.isThumbnailFileUploaded = true;
        var reader = new FileReader();
        reader.onload = function (e) {
          self.entity.featuredImage = e.target.result;
          self.featuredImage = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    onResourceFileChange: function onResourceFileChange(value, i) {
      var self = this;
      var valueTrimmed = value.target.value.replace(/^.*\\/, '');
      var extension = value.target.value.split('.').pop().toLowerCase();
      var fileNameArray = valueTrimmed.split('.');
      if (this.entity.type.label === 'Template' && ['doc', 'docx', 'xls', 'xlsx', 'pdf'].indexOf(extension) === -1) {
        alert('Only .doc, .docx, .xls, .xlsx or .pdf file extension allowed to add on article template type!');
        return;
      }
      if (this.entity.type.label === 'Document' && extension !== 'pdf') {
        alert('Only .pdf file extension allowed to add on article document type!');
        return;
      }
      var input = document.getElementById('uploadResource_' + i);
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            name: fileNameArray[0],
            file: e.target.result,
            extension: extension,
            type: 'article'
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            if (Array.isArray(res.body)) {
              alert(res.body[0] + '. Please try again.');
              return;
            }
            self.entity.resources.document[i].name = valueTrimmed;
            self.entity.resources.document[i].extension = extension;
            self.entity.resources.document[i].resource = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            alert('Error on file upload. Please try again');
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload) {
        return false;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    removeThumbnail: function removeThumbnail() {
      var input = document.getElementById('uploadThumbnail');
      input.value = null;
      this.isThumbnailFileUploaded = false;
      this.entity.featuredImage = null;
    },
    archiveArticle: function archiveArticle() {
      this.confOpened = 'archive';
      this.initConfAction({
        actionName: 'changeArticleStatus',
        userStatus: this.entity.status
      });
    },
    archiveArticleConfirmed: function archiveArticleConfirmed() {
      var _this = this;

      var self = this;
      var articleData = {
        id: this.articleId,
        status: this.entity.status === 1 ? 0 : 1
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content, articleData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        var actionText = res.body.status ? 'Unarchived' : 'Archived';
        _this.infMsgTitle = _this.initialData.title + ' Resource was successfully ' + actionText + '.';
        if (res.body.status) {
          _this.infMsgDescription = 'All active users belonging to ' + _this.initialData.title + ' will now be able to login.';
        } else {
          _this.infMsgDescription = 'All users belonging to ' + _this.initialData.title + ' will no longer be able to login. However, the company will still appear in the list of companies and all company data will be kept in the database.';
        }
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        self.getArticleData();
      }).catch(function (err) {
        _this.disableAPI = false;
        self.serverValidation.errors = err;
        self.infMsgTitle = 'Error. We can\'t archive this Resource because ';
        self.infMsgTitle += err.body.message.toLowerCase();
        self.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        self.infMsgClass = 'error';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
      });
      this.getConfData.actionConfirmed = false;
    },
    deleteArticle: function deleteArticle() {
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeArticleById'
      });
    },
    deleteArticleConfirmed: function deleteArticleConfirmed() {
      var _this2 = this;

      if (this.disableAPI) return;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content + '/' + this.articleId, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = _this2.initialData.title + ' article was successfully deleted.';
        _this2.infMsgDescription = 'All users and stored information belonging to ' + _this2.initialData.title + ' were also deleted.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.goToAllArticles();
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We can\'t delete this Resource because ';
        _this2.infMsgTitle += err.body.error.message.toLowerCase();
        _this2.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
      });
      this.getConfData.actionConfirmed = false;
    },
    getArticleData: function getArticleData() {
      var _this3 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content + '/' + this.articleId, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var editor = _this3.$refs.contentEditor;
        editor.setContent(res.body.content);
        _this3.entity.loading = false;
        _this3.entity.title = res.body.title;
        _this3.initialData.title = res.body.title;
        if (res.body.image_path) {
          _this3.featuredImage = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverURL + res.body.image_path;
          _this3.isThumbnailFileUploaded = true;
        }
        if (res.body.image_name) {
          _this3.entity.featuredImage = res.body.image_name;
        }
        _this3.entity.content = res.body.content ? res.body.content : '';
        _this3.entity.altImage = res.body.alt ? res.body.alt : '';
        _this3.entity.status = res.body.status;
        _this3.entity.lastTimeEditedDate = res.body.updated_at ? res.body.updated_at : null;
        _this3.entity.lastTimeEditedBy = res.body.updated_by ? res.body.updated_by : null;
        if (res.body.content_type !== null) {
          _this3.entity.type = null;
          _this3.entity.type = {
            id: res.body.content_type.id,
            label: res.body.content_type.type,
            value: res.body.content_type.id
          };
        }
        if (res.body.companies && res.body.companies.length) {
          _this3.entity.company = [];
          res.body.companies.forEach(function (row) {
            _this3.entity.company.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_companies && res.body.not_companies.length) {
          _this3.entity.notCompany = [];
          res.body.not_companies.forEach(function (row) {
            _this3.entity.notCompany.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.categories && res.body.categories.length) {
          _this3.entity.category = [];
          _this3.entity.category.push({
            id: res.body.categories[0].id,
            label: res.body.categories[0].title,
            value: res.body.categories[0].id
          });
        }
        if (res.body.tags && res.body.tags.length) {
          _this3.entity.topic = [];
          res.body.tags.forEach(function (row) {
            _this3.entity.topic.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.industries && res.body.industries.length) {
          _this3.entity.industry = [];
          res.body.industries.forEach(function (row) {
            _this3.entity.industry.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.locations && res.body.locations.length) {
          _this3.entity.location = [];
          res.body.locations.forEach(function (row) {
            _this3.entity.location.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.sizes && res.body.sizes.length) {
          _this3.entity.size = [];
          res.body.sizes.forEach(function (row) {
            _this3.entity.size.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_industries && res.body.not_industries.length) {
          _this3.entity.notIndustry = [];
          res.body.not_industries.forEach(function (row) {
            _this3.entity.notIndustry.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_locations && res.body.not_locations.length) {
          _this3.entity.notLocation = [];
          res.body.not_locations.forEach(function (row) {
            _this3.entity.notLocation.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.not_sizes && res.body.not_sizes.length) {
          _this3.entity.notSize = [];
          res.body.not_sizes.forEach(function (row) {
            _this3.entity.notSize.push({
              id: row.id,
              label: row.name,
              value: row.id
            });
          });
        }
        if (res.body.children && res.body.children.length) {
          _this3.entity.ttd = [];
          _this3.entity.ttc = [];
          res.body.children.forEach(function (row) {
            if (row) {
              if (row.is_article) {
                _this3.entity.ttc.push({
                  id: row.id,
                  label: row.title,
                  value: row.id
                });
              } else {
                _this3.entity.ttd.push({
                  id: row.id,
                  label: row.title,
                  value: row.id
                });
              }
            }
          });
        }
        if (res.body.resources && res.body.resources !== null) {
          var resources = JSON.parse(res.body.resources);
          if (res.body.content_type.type === 'Video') {
            _this3.entity.resources.video = [];
            resources.forEach(function (row) {
              _this3.entity.resources.video.push({
                videoUrl: row.link,
                videoTranscript: row.textarea
              });
            });
          } else {
            _this3.entity.resources.document = [];
            resources.forEach(function (row) {
              _this3.entity.resources.document.push({
                name: row.name,
                resource: row.file,
                resourceUrl: row.link,
                resourceTranscript: row.textarea
              });
            });
          }
        }
        document.title = 'Edit "' + _this3.entity.title + '" Thing to Consider | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this3.$router.resolve({
            name: 'error'
          });
          _this3.$router.push(props.href);
        }
        if (err.status === 401) {
          _this3.authLogout();
        }
      });
    },
    getArticleLogById: function getArticleLogById(id) {
      var _this4 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.articleLog + id, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.articleLog = res.body.items ? res.body.items : null;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    publishArticle: function publishArticle(status, redirect, same) {
      var _this5 = this;

      this.$validator.validateAll();
      this.entity.loading = true;
      this.$nextTick(function () {
        if (_this5.errors.items.length) {
          _this5.entity.loading = false;
          return false;
        }
        if (_this5.entity.loading === true) {
          _this5.entity.loading = false;
          return false;
        }
      });
      var self = this;
      var editor = this.$refs.contentEditor;
      this.entity.content = editor.getContent();
      var formData = {
        id: this.articleId,
        title: this.entity.title,
        imageFile: this.entity.featuredImage || '',
        alt: this.entity.altImage,
        content: this.entity.content,
        status: status,
        isArticle: 1,
        children: this.entity.ttc.concat(this.entity.ttd),
        categories: Array.isArray(this.entity.category) ? this.entity.category : [this.entity.category],
        tags: this.entity.topic,
        companies: this.entity.company,
        industries: this.entity.industry,
        locations: this.entity.location,
        sizes: this.entity.size,
        notCompanies: this.entity.notCompany,
        notIndustries: this.entity.notIndustry,
        notLocations: this.entity.notLocation,
        notSizes: this.entity.notSize
      };
      if (this.articleType.type === 'video') {
        formData.typeValues = [];
        this.entity.resources.video.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.videoUrl,
            textarea: row.videoTranscript
          });
        });
      }
      if (this.articleType.type === 'document') {
        formData.typeValues = [];
        this.entity.resources.document.forEach(function (row, i) {
          formData.typeValues.push({
            link: row.resourceUrl,
            textarea: row.resourceTranscript,
            extention: row.extension,
            file: row.resource,
            name: row.name
          });
        });
      }
      var newWindow = void 0;
      if (redirect && !same) {
        newWindow = window.open('', '_blank');
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.content, formData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.status === 0) {
          self.infMsgTitle = res.body.title + ' article has been saved as draft.';
        } else {
          self.infMsgTitle = res.body.title + ' article has been published.';
        }
        self.infMsgDescription = '';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        if (redirect) {
          if (same) {
            self.switchEditPage(res.body.id);
            self.getArticleData();
          } else {
            var props = _this5.$router.resolve({
              name: 'content',
              params: { id: res.body.id }
            });
            newWindow.location = props.href;
          }
        } else {
          self.goToAllArticles();
        }
        _this5.entity.loading = false;
      }).catch(function (err) {
        self.serverValidation.errors = err;
        self.infMsgTitle = 'Error. We were not able to edit this resource because';
        if (err.body.message) {
          self.infMsgTitle += ' ' + err.body.message.toLowerCase();
        }
        if (err.body.error.exception.length) {
          for (var error in err.body.error.exception) {
            self.infMsgTitle += ' ' + err.body.error.exception[error]['message'].toLowerCase();
          }
        }
        self.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        self.infMsgClass = 'error';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        _this5.entity.loading = false;
      });
    },
    getStatus: function getStatus(st) {
      switch (st) {
        case 0:
          return 'Draft';
        case 1:
          return 'Published';
        case 2:
          return 'Archived';
        default:
          return '';
      }
    },
    lastTimeEdited: function lastTimeEdited(date, user) {
      if (date === null) return;
      var string = 'Last edited ';
      var updatedAt = new Date(date);
      var now = new Date();
      var difference = Math.floor((+now - +updatedAt) / (1000 * 60 * 60));
      if (difference < 1) {
        string += 'less than 1 hour ago';
      } else if (difference >= 1 && difference < 24) {
        string += difference + ' hours ago';
      } else {
        string += this.convertDate(date, '.');
      }
      if (user !== null) {
        string += ' by ' + user.first_name + ' ' + user.last_name;
      }
      return string;
    },
    convertDate: function convertDate(payload, delimiter) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear;
    },
    goToAllArticles: function goToAllArticles() {
      var props = this.$router.resolve({
        name: 'articles-list'
      });
      this.$router.push(props.href);
    },
    switchEditPage: function switchEditPage(id) {
      var props = this.$router.resolve({
        name: 'edit-article',
        params: { id: id }
      });
      this.$router.push(props.href);
    },
    getOptionsThingsToConsider: function getOptionsThingsToConsider(search, loading) {
      var _this6 = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=true';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        var items = res.body.data.items ? res.body.data.items : [];
        _this6.thingsToConsiderOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    getOptionsThingsToDo: function getOptionsThingsToDo(search, loading) {
      var _this7 = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=false';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        var items = res.body.data.items ? res.body.data.items : [];
        _this7.thingsToDoOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },
    handleScroll: function handleScroll(event) {
      var headerPlaceholder = document.getElementById('headerPlaceholder');
      var header = document.querySelector('.article__header');
      if (!headerPlaceholder || !header) {
        return;
      }
      var rect = headerPlaceholder.getBoundingClientRect();
      var sticky = rect.top;
      if (sticky <= 0) {
        header.classList.add('sticky');
        headerPlaceholder.style.height = header.offsetHeight + 'px';
      } else {
        header.classList.remove('sticky');
        headerPlaceholder.style.height = '';
      }
    }
  }),
  components: {},
  mounted: function mounted() {
    this.getTags();
    this.getCategories();
    this.getCompanies();
    this.getIndustries();
    this.getArticleData();
    this.getArticleLogById(this.articleId);
    this.getCompanyLocations();
    this.getCompanySizes();
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BillingProfile__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BillingProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BillingProfile__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-company',
  data: function data() {
    return {
      disableAPI: false,
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditDetails: false,
      canEditTasksSettings: false,
      canEditCompanyRegistration: false,
      canEditOwner: false,
      canEditProgressChapters: false,
      confOpened: null,
      statusPayload: null,
      company: {
        details: {
          id: '',
          name: '',
          parent: '',
          industry: null,
          subscriptionEnd: null,
          enabled: {
            label: '',
            value: ''
          },
          url: null,
          // can_export_tasks: false,
          seesChat: true,
          isDemo: false,
          disconnectedFromBilling: true,
          allowRegistration: null,
          allowAllEmails: null,
          emailApproval: null,
          usersType: null,
          companySize: null,
          companyLocation: null
        },
        tasksSettings: {
          contraption: '',
          defaultAssignee: false,
          accountManager: false
        },
        approvedEmails: [{
          email: ''
        }],
        ownerData: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        },
        progressDetails: {},
        progressChapters: {}
      },
      initialData: {
        details: {
          id: '',
          name: '',
          parent: '',
          industry: null,
          subscriptionEnd: null,
          enabled: {
            label: '',
            value: ''
          },
          url: 'clearassured.CompanyName.com',
          // can_export_tasks: false,
          seesChat: true,
          isDemo: false,
          disconnectedFromBilling: true,
          allowRegistration: false,
          allowAllEmails: false,
          emailApproval: false,
          usersType: null,
          companySize: null,
          companyLocation: null
        },
        tasksSettings: {
          contraption: '',
          defaultAssignee: false,
          accountManager: false
        },
        approvedEmails: [{
          email: ''
        }],
        ownerData: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        },
        progressDetails: {},
        progressChapters: {}
      },
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      canLeave: false,
      next: null,
      isChanged: false,
      isStakeholder: false,
      tabActive: 'profile',
      changeUrl: false,
      companyId: null,
      datepicker: {
        subscription: null,
        startDate: null,
        shown: false,
        startShown: false,
        keepFocus: false
      },
      dataFound: true,
      editedChapters: [],
      chapterOrderBy: {
        order: false
      },
      quarters: {},
      chapters: [],
      articles: [],
      user: {},
      dataLoading: false,
      dataLoaded: false,
      activeSection: 'companyDetails',
      hasPoints: false,
      chartData: null,
      badgeCopy: false,
      iframeTheme: {
        label: 'Light',
        value: 'light'
      },
      industry: null,
      emailControl: {
        input: '',
        isPaste: false
      },
      disconnectedFromBillingCheckConfirmed: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['selectedHightCont', 'getCompaniesForSelect', 'getIndustriesForSelect', 'getUserRole', 'getContentChapterForSelect', 'getConfData', 'defaultAssigneeForSelect', 'adminUsersForSelect', 'companySizes', 'companyLocations', 'getDefaultRegistrationRolesForSelect']), {
    getStatusesForSelect: function getStatusesForSelect() {
      return [{
        label: 'Active',
        value: 2
      }, {
        label: 'Inactive',
        value: 1
      }, {
        label: 'Archived',
        value: 0
      }];
    },
    yesNoOptionsForSelect: function yesNoOptionsForSelect() {
      return [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
    },
    yesNoOptionsForSelectNew: function yesNoOptionsForSelectNew() {
      return [{
        label: this.company.details.allowAllEmails && this.company.details.allowAllEmails.value ? 'Yes' : 'Yes, all',
        value: true
      }, {
        label: this.company.details.allowAllEmails && this.company.details.allowAllEmails.value ? 'No' : 'Only accounts without an approved domain email',
        value: false
      }];
    },
    preparedCompanies: function preparedCompanies() {
      var companyList = [];
      for (var company in this.getCompaniesForSelect) {
        if (this.getCompaniesForSelect[company].value !== this.companyId * 1 && this.getCompaniesForSelect[company].parent !== 1) {
          companyList.push(this.getCompaniesForSelect[company]);
        }
      }
      return companyList;
    },
    getQuarters: function getQuarters() {
      var self = this;
      var todayDate = new Date();
      var todayYear = todayDate.getFullYear();
      var todayMonth = todayDate.getMonth();
      var startDate = this.datepicker.startDate ? new Date(this.datepicker.startDate) : new Date();
      var startYear = startDate.getFullYear();
      var startMonth = startDate.getMonth();
      var quarterNames = ['Q1', 'Q2', 'Q3', 'Q4'];
      var quarters = [];

      var _loop = function _loop(y) {
        // let dataForThisQuarter = this.quarters.find(item => item.quarter === res.body.enabled)
        var lastYearQuarters = void 0;
        if (y > startYear) {
          lastYearQuarters = quarterNames.slice(0, 4);
        } else {
          lastYearQuarters = quarterNames.slice(parseInt(startMonth / 3), 4);
        }
        lastYearQuarters.forEach(function (index, data) {
          var dataForThisQuarter = self.quarters[y.toString() + index.slice(1, 2)];
          if (dataForThisQuarter) {
            quarters.push({
              quarter: index.slice(1, 2),
              year: y,
              policies: dataForThisQuarter.score.policies,
              finding: dataForThisQuarter.score.finding,
              assessing: dataForThisQuarter.score.assessing,
              retaining: dataForThisQuarter.score.retaining
            });
          } else {
            quarters.push({
              quarter: index.slice(1, 2),
              year: y,
              policies: 0,
              finding: 0,
              assessing: 0,
              retaining: 0
            });
          }
        });
      };

      for (var y = startYear; y < todayYear; y++) {
        _loop(y);
      }
      var startIndex = startYear === todayYear ? Math.ceil((startMonth + 1) / 3) - 1 : 0;
      var thisYearQuarters = quarterNames.slice(startIndex, parseInt(todayMonth / 3 + 1));
      thisYearQuarters.forEach(function (index, data) {
        var dataForThisQuarter = self.quarters[todayYear.toString() + index.slice(1, 2)];
        if (dataForThisQuarter) {
          quarters.push({
            quarter: index.slice(1, 2),
            year: todayYear,
            policies: dataForThisQuarter.score.policies,
            finding: dataForThisQuarter.score.finding,
            assessing: dataForThisQuarter.score.assessing,
            retaining: dataForThisQuarter.score.retaining
          });
        } else {
          quarters.push({
            quarter: index.slice(1, 2),
            year: todayYear,
            policies: 0,
            finding: 0,
            assessing: 0,
            retaining: 0
          });
        }
      });
      return quarters;
    },
    filteredChapters: function filteredChapters() {
      var result = this.getQuarters;
      var ascDesc = this.chapterOrderBy.order ? 1 : -1;
      return result.sort(function (a, b) {
        return ascDesc * (parseInt(a.year + '' + a.quarter) - parseInt(b.year + '' + b.quarter));
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'getCompanies', 'getIndustries', 'setInformationMsg', 'getChapters', 'initConfAction', 'getTaskAssignee', 'getAdminUsers', 'getCompanySizes', 'getCompanyLocations', 'getDefaultRegistrationRoles']), {
    openEditCompanyRegistration: function openEditCompanyRegistration() {
      this.canEditCompanyRegistration = true;
    },
    openEditDetails: function openEditDetails() {
      this.canEditDetails = true;
    },
    openTasksSettings: function openTasksSettings() {
      this.canEditTasksSettings = true;
    },
    openEditOwner: function openEditOwner() {
      this.canEditOwner = true;
    },
    openProgressChapters: function openProgressChapters() {
      this.canEditProgressChapters = true;
    },
    closeEditCompanyRegistration: function closeEditCompanyRegistration() {
      this.company.approvedEmails = this.initialData.approvedEmails;
      this.canEditCompanyRegistration = false;
      this.errors.clean();
    },
    closeEditDetails: function closeEditDetails() {
      this.company.details = this.initialData.details;
      this.canEditDetails = false;
      this.errors.clean();
    },
    closeEditTasksSettings: function closeEditTasksSettings() {
      this.company.tasksSettings = this.initialData.tasksSettings;
      this.canEditTasksSettings = false;
      this.errors.clean();
    },
    closeEditOwner: function closeEditOwner() {
      this.company.ownerData = this.initialData.ownerData;
      this.canEditOwner = false;
      this.errors.clean();
    },
    closeEditProgressChapters: function closeEditProgressChapters() {
      this.company.progressChapters = this.initialData.progressChapters;
      this.canEditProgressChapters = false;
    },
    closeMsg: function closeMsg() {
      this.errors.clear();
    },
    deleteProfile: function deleteProfile() {
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeCompanyById'
      });
    },
    resetTaskHistory: function resetTaskHistory() {
      this.confOpened = 'reset';
      this.initConfAction({
        actionName: 'resetTaskHistoryById'
      });
    },
    deleteCompanyConfirmed: function deleteCompanyConfirmed() {
      var _this = this;

      var id = this.companyId;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyList + '/' + id, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.infMsgTitle = _this.initialData.details.name + ' company was successfully deleted.';
        _this.infMsgDescription = 'All users and stored information belonging to ' + _this.initialData.details.name + ' were also deleted.';
        _this.infMsgClass = 'success';
        _this.setInformationMsg({
          isShown: true,
          title: _this.infMsgTitle,
          text: _this.infMsgDescription,
          className: _this.infMsgClass
        });
        _this.goToCompanyList();
      }).catch(function (err) {
        _this.disableAPI = false;
        _this.infMsgTitle = 'Error. We can\'t delete this company because ';
        for (var error in err.body.error.exception) {
          _this.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this.getUserRole === 'gm') {
          _this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this.infMsgClass = 'error';
        _this.setInformationMsg({
          isShown: true,
          title: _this.infMsgTitle,
          text: _this.infMsgDescription,
          className: _this.infMsgClass
        });
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    },
    resetTaskHistoryConfirmed: function resetTaskHistoryConfirmed() {
      var _this2 = this;

      var id = this.companyId;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.task + '/reset/' + id, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.infMsgTitle = _this2.initialData.details.name + ' company task history was successfully reset.';
        _this2.infMsgDescription = 'All tasks and tasks history belonging to ' + _this2.initialData.details.name + ' were also reset.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We can\'t reset tasks for this company because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this2.getUserRole === 'gm') {
          _this2.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this2.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    },
    archiveProfile: function archiveProfile() {
      this.confOpened = 'archive';
      this.initConfAction({
        actionName: 'changeCompanyStatus',
        userStatus: this.company.details.enabled.value ? 0 : 1
      });
    },
    archiveCompanyConfirmed: function archiveCompanyConfirmed() {
      var _this3 = this;

      var companyData = {
        id: this.companyId,
        enabled: !this.company.details.enabled.value
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, companyData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var actionText = res.body.enabled ? 'Unarchived' : 'Archived';
        _this3.disableAPI = false;
        _this3.infMsgTitle = res.body.name + ' company  profile was successfully ' + actionText + '.';
        if (res.body.enabled) {
          _this3.infMsgDescription = 'All active users belonging to ' + res.body.name + ' will now be able to login.';
        } else {
          _this3.infMsgDescription = 'All users belonging to ' + res.body.name + ' will no longer be able to login. However, the company will still appear in the list of companies and all company data will be kept in the database.';
        }
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.getCompanyData();
      }).catch(function (err) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = 'Error. We can\'t archive this company because ';
        for (var error in err.body.error.exception) {
          _this3.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this3.getUserRole === 'gm') {
          _this3.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this3.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this3.infMsgClass = 'error';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        console.log('err', err);
        _this3.getCompanyData();
      });
      this.getConfData.actionConfirmed = false;
    },
    changeUrlConfirmed: function changeUrlConfirmed() {
      this.changeUrl = true;
    },
    fieldChange: function fieldChange() {
      this.isChanged = true;
    },
    getCompanyData: function getCompanyData() {
      var _this4 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, { id: this.companyId }, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var companyDetails = _this4.company;
        // set received data
        companyDetails.details.id = res.body.id;
        // organisation details
        companyDetails.details.name = res.body.name;
        companyDetails.details.subscriptionEnd = _this4.convertDate(res.body.subscription_end, '/');
        companyDetails.details.enabled = _this4.getStatusesForSelect.find(function (item) {
          return item.value === _this4.getCompanyStatus(res.body).value;
        });
        companyDetails.details.url = res.body.url;
        // companyDetails.details.can_export_tasks = res.body.can_export_tasks
        companyDetails.details.seesChat = res.body.sees_chat;
        companyDetails.details.isDemo = res.body.is_demo;
        companyDetails.details.disconnectedFromBilling = res.body.disconnected_from_billing === 2 || res.body.disconnected_from_billing === 3;
        companyDetails.tasksSettings.contraption = res.body.contraption;
        companyDetails.tasksSettings.defaultAssignee = null;
        if (res.body.default_assignee !== null) {
          companyDetails.tasksSettings.defaultAssignee = {
            id: res.body.default_assignee.id,
            label: res.body.default_assignee.first_name + ' ' + res.body.default_assignee.last_name,
            value: res.body.default_assignee.id
          };
        }
        companyDetails.tasksSettings.accountManager = null;
        if (res.body.account_manager !== null) {
          companyDetails.tasksSettings.accountManager = {
            id: res.body.account_manager.id,
            label: res.body.account_manager.first_name + ' ' + res.body.account_manager.last_name,
            value: res.body.account_manager.id
          };
        }
        companyDetails.hash = res.body.hash;
        // company email endings
        companyDetails.approvedEmails = res.body.email_endings !== null ? JSON.parse(res.body.email_endings) : companyDetails.approvedEmails;
        // company owner data
        companyDetails.ownerData.firstName = res.body.owner_first_name;
        companyDetails.ownerData.lastName = res.body.owner_last_name;
        companyDetails.ownerData.phoneNumber = res.body.owner_phone_number;
        companyDetails.ownerData.email = res.body.owner_email;
        companyDetails.progressDetails.startDate = res.body.created ? _this4.convertDate(res.body.created, '/') : _this4.convertDate(res.body.start_date, '/');
        companyDetails.points = res.body.points;
        companyDetails.details.parent = null;
        if (res.body.parent !== null) {
          companyDetails.details.parent = {
            id: res.body.parent.id,
            label: res.body.parent.name,
            value: res.body.parent.id
          };
        }
        companyDetails.details.usersType = null;
        if (res.body.users_type !== null) {
          companyDetails.details.usersType = {
            label: res.body.users_type.name,
            value: res.body.users_type.id,
            id: res.body.users_type.id
          };
        }
        companyDetails.details.companySize = null;
        if (res.body.company_size !== null) {
          companyDetails.details.companySize = {
            label: res.body.company_size.name,
            value: res.body.company_size.id,
            id: res.body.company_size.id
          };
        }
        companyDetails.details.companyLocation = null;
        if (res.body.company_location !== null) {
          companyDetails.details.companyLocation = {
            label: res.body.company_location.name,
            value: res.body.company_location.id,
            id: res.body.company_location.id
          };
        }
        companyDetails.details.industry = null;
        if (res.body.industry !== null) {
          _this4.industry = res.body.industry;
          companyDetails.details.industry = {
            id: res.body.industry.id,
            label: res.body.industry.name,
            value: res.body.industry.id
          };
          if (res.body.industry.landing) {
            companyDetails.details.industry.landing = {
              slug: res.body.industry.landing.slug
            };
          }
        }
        companyDetails.details.allowRegistration = null;
        if (res.body.allow_registration !== null) {
          companyDetails.details.allowRegistration = _this4.yesNoOptionsForSelect.find(function (item) {
            return item.value === res.body.allow_registration;
          });
        }
        companyDetails.details.allowAllEmails = null;
        if (res.body.allow_all_emails !== null) {
          companyDetails.details.allowAllEmails = _this4.yesNoOptionsForSelect.find(function (item) {
            return item.value === !res.body.allow_all_emails;
          });
        }
        companyDetails.details.emailApproval = null;
        if (res.body.email_approval !== null) {
          companyDetails.details.emailApproval = _this4.yesNoOptionsForSelectNew.find(function (item) {
            return item.value === res.body.email_approval;
          });
        }
        // set datepicker
        _this4.datepicker.subscription = res.body.subscription_end;
        _this4.datepicker.startDate = res.body.created ? res.body.created : res.body.start_date;
        // set initial data
        _this4.initialData = companyDetails;
        document.title = res.body.name + '\'s details | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.body.error.code === 404) {
          var props = _this4.$router.resolve({
            name: 'error'
          });
          location.href = props.href;
        }
        if (err.status === 401) {
          _this4.authLogout();
        }
      });
    },
    getCompanyPoints: function getCompanyPoints() {
      var _this5 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyPoints + '/' + this.companyId, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.quarters = res.body;
        if (_this5.quarters) {
          _this5.hasPoints = true;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateCompanyDetails: function updateCompanyDetails() {
      var _this6 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var companyData = {
        id: this.company.details.id,
        companyName: this.company.details.name,
        subscriptionEnd: this.company.details.subscriptionEnd,
        enabled: this.company.details.enabled,
        seesChat: this.company.details.seesChat,
        isDemo: this.company.details.isDemo,
        disconnectedFromBilling: this.company.details.disconnectedFromBilling ? 3 : 0
      };
      if (this.company.details.parent !== null) {
        companyData.parent = this.company.details.parent;
      } else {
        companyData.parent = {};
      }
      if (this.company.details.industry !== null) {
        companyData.industry = this.company.details.industry;
      } else {
        companyData.industry = {};
      }
      if (this.company.details.usersType !== null) {
        companyData.usersType = this.company.details.usersType;
      } else {
        companyData.usersType = {};
      }
      if (this.company.details.companySize !== null) {
        companyData.companySize = this.company.details.companySize;
      } else {
        companyData.companySize = {};
      }
      if (this.company.details.companyLocation !== null) {
        companyData.companyLocation = this.company.details.companyLocation;
      } else {
        companyData.companyLocation = {};
      }
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, companyData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this6.disableAPI = false;
        _this6.infMsgTitle = res.body.name + ' organisation details was successfully updated.';
        _this6.infMsgDescription = 'Please note all edits are being logged. ';
        _this6.infMsgClass = 'success';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.getCompanyData();
        _this6.canEditDetails = !_this6.canEditDetails;
      }).catch(function (err) {
        _this6.disableAPI = false;
        console.log('err', err);
        _this6.infMsgTitle = 'Error. We were not able to update this company because ';
        for (var error in err.body.error.exception) {
          _this6.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this6.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this6.infMsgClass = 'error';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.getCompanyData();
      });
    },
    updateCompanyTasksSettings: function updateCompanyTasksSettings() {
      var _this7 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var companyData = {
        id: this.company.details.id,
        contraption: this.company.tasksSettings.contraption,
        defaultAssignee: this.company.tasksSettings.defaultAssignee || false,
        accountManager: this.company.tasksSettings.accountManager || false
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, companyData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.disableAPI = false;
        _this7.infMsgTitle = res.body.name + ' company tasks settings was successfully updated.';
        _this7.infMsgDescription = 'Please note all edits are being logged. ';
        _this7.infMsgClass = 'success';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
        _this7.getCompanyData();
        _this7.canEditTasksSettings = !_this7.canEditTasksSettings;
      }).catch(function (err) {
        _this7.disableAPI = false;
        _this7.infMsgTitle = 'Error. We were not able to update this company because ';
        for (var error in err.body.error.exception) {
          _this7.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this7.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this7.infMsgClass = 'error';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
        _this7.getCompanyData();
      });
    },
    updateCompanyRegistration: function updateCompanyRegistration() {
      var _this8 = this;

      this.$validator.validateAll();
      if (this.errors.items.length) return;
      if (this.disableAPI) return;
      var registrationData = {
        id: this.company.details.id,
        emailEndings: this.company.approvedEmails,
        url: this.company.details.url,
        allowRegistration: this.company.details.allowRegistration ? this.company.details.allowRegistration.value === true : false,
        allowAllEmails: this.company.details.allowAllEmails ? this.company.details.allowAllEmails.value === false : true,
        emailApproval: this.company.details.emailApproval ? this.company.details.emailApproval.value === true : false
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, registrationData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this8.disableAPI = false;
        _this8.infMsgTitle = res.body.name + ' user registration settings was successfully updated.';
        _this8.infMsgDescription = 'Please note all edits are being logged.';
        _this8.infMsgClass = 'success';
        _this8.setInformationMsg({
          isShown: true,
          title: _this8.infMsgTitle,
          text: _this8.infMsgDescription,
          className: _this8.infMsgClass
        });
        _this8.canEditCompanyRegistration = false;
        _this8.getCompanyData();
      }).catch(function (err) {
        _this8.getCompanyData();
        _this8.disableAPI = false;
        _this8.infMsgTitle = 'Error. We were not able to update this company because ';
        for (var error in err.body.error.exception) {
          _this8.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this8.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this8.infMsgClass = 'error';
        _this8.setInformationMsg({
          isShown: true,
          title: _this8.infMsgTitle,
          text: _this8.infMsgDescription,
          className: _this8.infMsgClass
        });
        _this8.canEditCompanyRegistration = false;
      });
      this.messageDisplay = true;
    },
    updateCompanyOwner: function updateCompanyOwner() {
      var _this9 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var owner = {
        id: this.company.details.id,
        ownerFirstName: this.company.ownerData.firstName,
        ownerLastName: this.company.ownerData.lastName,
        ownerPhoneNumber: this.company.ownerData.phoneNumber,
        ownerEmail: this.company.ownerData.email
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, owner, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this9.disableAPI = false;
        _this9.infMsgTitle = res.body.name + ' company owner details was successfully updated.';
        _this9.infMsgDescription = 'Please note all edits are being logged.';
        _this9.infMsgClass = 'success';
        _this9.setInformationMsg({
          isShown: true,
          title: _this9.infMsgTitle,
          text: _this9.infMsgDescription,
          className: _this9.infMsgClass
        });
        _this9.getCompanyData();
        _this9.canEditOwner = !_this9.canEditOwner;
      }).catch(function (err) {
        _this9.disableAPI = false;
        console.log('err', err);
        _this9.infMsgTitle = 'Error. We were not able to update this company because ';
        for (var error in err.body.error.exception) {
          _this9.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this9.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this9.infMsgClass = 'error';
        _this9.setInformationMsg({
          isShown: true,
          title: _this9.infMsgTitle,
          text: _this9.infMsgDescription,
          className: _this9.infMsgClass
        });
        _this9.getCompanyData();
      });
    },
    updateProgressChapters: function updateProgressChapters() {
      var _this10 = this;

      if (this.disableAPI) return;
      var chaptersData = {
        id: this.companyId,
        quarter: this.editedChapters
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCreate, chaptersData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this10.disableAPI = false;
        _this10.infMsgTitle = res.body.name + ' company progress on task categories was successfully updated.';
        _this10.infMsgDescription = 'Please note all edits are being logged.';
        _this10.infMsgClass = 'success';
        _this10.setInformationMsg({
          isShown: true,
          title: _this10.infMsgTitle,
          text: _this10.infMsgDescription,
          className: _this10.infMsgClass
        });
        _this10.getCompanyPoints();
        _this10.canEditProgressChapters = !_this10.canEditProgressChapters;
      }).catch(function (err) {
        _this10.disableAPI = false;
        _this10.infMsgTitle = 'Error. We were not able to update this company because ';
        for (var error in err.body.error.exception) {
          _this10.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this10.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this10.infMsgClass = 'error';
        _this10.setInformationMsg({
          isShown: true,
          title: _this10.infMsgTitle,
          text: _this10.infMsgDescription,
          className: _this10.infMsgClass
        });
        _this10.getCompanyPoints();
      });
    },
    createTags: function createTags(el, wait, blur) {
      var _this11 = this;

      var target = this.getTarget(el);
      // const newEmailsSet = {}
      this.emailControl['input'] = target.value;
      if (wait && !this.emailControl['isPaste']) {
        this.autoHeight(el);
        return;
      }
      if (blur) {
        this.emailControl['isPaste'] = false;
        if (this.emailControl['input'] === '') {
          return;
        }
      }
      var emails = this.emailControl['input'].split(/[, ]+/);

      var _loop2 = function _loop2(index) {
        if (emails[index] !== '') {
          var exists = _this11.company.approvedEmails.find(function (item) {
            return item.email === emails[index];
          });
          var empty = _this11.company.approvedEmails.findIndex(function (item) {
            return item.email === '';
          });
          if (empty !== -1) {
            _this11.removeElement(empty);
          }
          if (!exists) {
            _this11.company.approvedEmails.push({
              email: emails[index]
            });
          }
        }
      };

      for (var index in emails) {
        _loop2(index);
      }
      this.emailControl['isPaste'] = false;
      this.emailControl['input'] = '';
      this.addEmailRow();
    },
    autoWidth: function autoWidth(el) {
      var target = this.getTarget(el);
      setTimeout(function () {
        if (target) {
          target.style.width = '10px';
          target.style.width = target.scrollWidth + 15 + 'px';
        }
      }, 0);
    },
    autoHeight: function autoHeight(el) {
      var target = this.getTarget(el);
      if (target) {
        setTimeout(function () {
          target.style.height = '40px;';
          target.style.height = target.scrollHeight + 4 + 'px';
        }, 0);
      }
    },
    getTarget: function getTarget(e) {
      var evn = e || window.event;
      return evn.srcElement || e.currentTarget;
    },
    goToCompanyList: function goToCompanyList() {
      var props = this.$router.resolve({
        name: 'companies'
      });
      this.$router.push(props.href);
    },
    changeTabActive: function changeTabActive(tab) {
      this.tabActive = tab;
      if (tab === 'profile') {
        this.activeSection = 'companyDetails';
      }
      if (tab === 'progress') {
        this.activeSection = 'companyChart';
      }
    },

    addEmailRow: function addEmailRow() {
      this.company.approvedEmails.push({
        email: ''
      });
    },
    removeElement: function removeElement(index) {
      this.company.approvedEmails.splice(index, 1);
    },
    dateSelected: function dateSelected(e, model) {
      if (model === 'startDate') {
        this.company.progressDetails.startDate = this.convertDate(e, '/');
        this.datepicker.startShown = false;
      } else {
        this.company.details.subscriptionEnd = this.convertDate(e, '/');
        this.datepicker.shown = false;
      }
    },
    convertDate: function convertDate(payload, delimiter, monthName) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (monthName) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        month = months[month - 1];
      }

      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }

      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear;
    },
    documentClick: function documentClick(e) {
      var self = this;
      if (self.datepicker.shown) {
        var datepicker = document.getElementById('date-selector');
        var target = e.target;
        if (!this.isDescendant(datepicker, target)) {
          self.datepicker.shown = false;
        }
      }
    },
    isDescendant: function isDescendant(parent, child) {
      var node = child.parentNode;
      while (node !== null) {
        if (node === parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    },
    changeOrder: function changeOrder() {
      this.chapterOrderBy = {
        order: this.chapterOrderBy !== null ? !this.chapterOrderBy.order : true
      };
    },
    getChaptersList: function getChaptersList() {
      var _this12 = this;

      var self = this;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.contentChaptersList, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var chapters = res.body;
        var order = ['policies', 'finding', 'assessing', 'retaining'];
        chapters.sort(function (x, y) {
          var xkey = order.indexOf(x.slug);
          var ykey = order.indexOf(y.slug);
          return xkey - ykey;
        });
        var quarters = _this12.company.points.sort(function (a, b) {
          return -1 * (parseInt(a.year + '' + a.quarter) - parseInt(b.year + '' + b.quarter));
        });
        var lastQuarter = quarters.length ? quarters[0] : null;
        var newChapters = [];
        var chartData = [];
        var quarterData = {};
        var customChapters = {};
        var addThis = void 0;
        var articleIds = [];
        chapters.forEach(function (chapter) {
          var articlesForThisChapter = _this12.articles.filter(function (article) {
            return article.chapter && article.chapter === chapter.id;
          });
          for (var article in articlesForThisChapter) {
            articlesForThisChapter[article].ttdStatus = 0;
            articlesForThisChapter[article].status = null;
            articlesForThisChapter[article].loading = false;
            articlesForThisChapter[article].resources = [];
            articlesForThisChapter[article].done_status = [];
            articleIds.push(articlesForThisChapter[article].id);
          }
          var scores = {};
          var score = [];
          var i = 1;
          customChapters = chapter;
          self.reverseItems(quarters).forEach(function (quarter) {
            if (!quarterData[quarter.id]) {
              quarterData[quarter.id] = [];
            }
            if (chapter.slug === 'policies') {
              var bottom = void 0;
              var quarterScore = quarter.policies_score ? quarter.policies_score : 0;
              var benchmarkScore = self.company.details.industry && self.company.details.industry.benchmark_policies_and_procedures ? self.company.details.industry.benchmark_policies_and_procedures : null;
              var countInRange = quarterData[quarter.id].filter(function (x) {
                return x > quarterScore - 2 && x < quarterScore + 2;
              }).length;
              var countChapterInRange = quarterData[quarter.id].filter(function (x) {
                return x <= quarterScore - 10;
              }).length;
              if (quarterScore <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (quarterScore + countChapterInRange * 20) - addThis;
              quarterData[quarter.id].push(quarterScore);
              bottom = quarterScore + countInRange * 0.95;
              score.push({
                score: quarterScore,
                left: i * 140,
                top: 100 - bottom,
                benchmark: benchmarkScore
              });
            } else if (chapter.slug === 'finding') {
              var _bottom = void 0;
              var _quarterScore = quarter.finding_score ? quarter.finding_score : 0;
              var _benchmarkScore = self.company.details.industry && self.company.details.industry.benchmark_finding_talent ? self.company.details.industry.benchmark_finding_talent : null;
              var _countInRange = quarterData[quarter.id].filter(function (x) {
                return x > _quarterScore - 2 && x < _quarterScore + 2;
              }).length;
              var _countChapterInRange = quarterData[quarter.id].filter(function (x) {
                return x <= _quarterScore - 10;
              }).length;
              if (_quarterScore <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (_quarterScore + _countChapterInRange * 20) - addThis;
              quarterData[quarter.id].push(_quarterScore);
              _bottom = _quarterScore + _countInRange * 0.95;
              score.push({
                score: _quarterScore,
                left: i * 140,
                top: 100 - _bottom,
                benchmark: _benchmarkScore
              });
            } else if (chapter.slug === 'assessing') {
              var _bottom2 = void 0;
              var _quarterScore2 = quarter.assessing_score ? quarter.assessing_score : 0;
              var _benchmarkScore2 = self.company.details.industry && self.company.details.industry.benchmark_accessing_talent ? self.company.details.industry.benchmark_accessing_talent : null;
              var _countInRange2 = quarterData[quarter.id].filter(function (x) {
                return x > _quarterScore2 - 2 && x < _quarterScore2 + 2;
              }).length;
              var _countChapterInRange2 = quarterData[quarter.id].filter(function (x) {
                return x <= _quarterScore2 - 10;
              }).length;
              if (_quarterScore2 <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (_quarterScore2 + _countChapterInRange2 * 20) - addThis;
              quarterData[quarter.id].push(_quarterScore2);
              _bottom2 = _quarterScore2 + _countInRange2 * 0.95;
              score.push({
                score: _quarterScore2,
                left: i * 140,
                top: 100 - _bottom2,
                benchmark: _benchmarkScore2
              });
            } else if (chapter.slug === 'retaining') {
              var _bottom3 = void 0;
              var _quarterScore3 = quarter.retaining_score ? quarter.retaining_score : 0;
              var _benchmarkScore3 = self.company.details.industry && self.company.details.industry.benchmark_retaining_talent ? self.company.details.industry.benchmark_retaining_talent : null;
              var _countInRange3 = quarterData[quarter.id].filter(function (x) {
                return x > _quarterScore3 - 2 && x < _quarterScore3 + 2;
              }).length;
              var _countChapterInRange3 = quarterData[quarter.id].filter(function (x) {
                return x <= _quarterScore3 - 10;
              }).length;
              if (_quarterScore3 <= 5) {
                addThis = 5;
              }
              customChapters.top = 100 - (_quarterScore3 + _countChapterInRange3 * 20) - addThis;
              quarterData[quarter.id].push(_quarterScore3);
              _bottom3 = _quarterScore3 + _countInRange3 * 0.95;
              score.push({
                score: _quarterScore3,
                left: i * 140,
                top: 100 - _bottom3,
                benchmark: _benchmarkScore3
              });
            }
            i += 1;
          });
          chartData[chapter.id] = {
            chapter: chapter,
            scores: score
          };
          if (chapter.slug === 'policies') {
            var _score = lastQuarter ? lastQuarter.policies_score : 0;
            scores = {
              score: _score,
              level: self.getFocusAreaLevel(_score)
            };
          } else if (chapter.slug === 'finding') {
            var _score2 = lastQuarter ? lastQuarter.finding_score : 0;
            scores = {
              score: _score2,
              level: self.getFocusAreaLevel(_score2)
            };
          } else if (chapter.slug === 'assessing') {
            var _score3 = lastQuarter ? lastQuarter.assessing_score : 0;
            scores = {
              score: _score3,
              level: self.getFocusAreaLevel(_score3)
            };
          } else if (chapter.slug === 'retaining') {
            var _score4 = lastQuarter ? lastQuarter.retaining_score : 0;
            scores = {
              score: _score4,
              level: self.getFocusAreaLevel(_score4)
            };
          }
          newChapters.push({
            chapter: chapter,
            articles: articlesForThisChapter,
            scores: scores,
            isReady: true,
            keyShown: false
          });
          self.chartData = chartData;
        });
        _this12.chapters = newChapters;
        Array.isArray(_this12.chapters);
        _this12.getDoneStatuses(articleIds);
        self.$nextTick(function () {
          _this12.dataLoaded = true;
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    chapterKeyOpenClose: function chapterKeyOpenClose(key) {
      var chapter = this.chapters.find(function (item) {
        return item.chapter && item.chapter.id === key * 1;
      });
      chapter.keyShown = !chapter.keyShown;
    },
    openTTD: function openTTD(chapterId, articleId) {
      var actioned = false;
      var chapter = this.chapters.find(function (item) {
        return item.chapter && item.chapter.id === chapterId;
      });
      for (var article in chapter.articles) {
        if (chapter.articles[article].id === articleId && actioned === false) {
          (function () {
            var newArticle = chapter.articles[article];
            newArticle.open = !newArticle.open;
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(chapter.articles, article, newArticle);
            actioned = true;
            setTimeout(function () {
              var element = document.getElementById('article-messages-' + newArticle.id);
              if (element !== null && newArticle.open) {
                element.scrollTop = element.scrollHeight;
              }
            }, 10);
          })();
        }
      }
    },
    checkStatus: function checkStatus(id) {
      var self = this;
      var response = 0;
      var article = this.articles.find(function (article) {
        return article.id === id;
      });
      if (article.done_status !== null && article.done_status.length > 0) {
        var statuses = [];
        article.done_status.forEach(function (status) {
          if (status.company_id === self.companyId * 1) {
            statuses.push(status);
          }
        });
        if (statuses.length) {
          response = statuses[0].status;
        }
      }
      return response;
    },
    getDoneStatuses: function getDoneStatuses(items) {
      var self = this;
      items.forEach(function (item) {
        var body = {
          companyId: self.companyId,
          id: item
        };
        self.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.getDoneStatus, body, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
          var article = self.articles.find(function (article) {
            return article.id === item * 1;
          });
          if (article.chapter) {
            var chapter = self.chapters.find(function (chapter) {
              return chapter.chapter.id === article.chapter;
            });
            var index = chapter.articles.findIndex(function (x) {
              return x.id === item * 1;
            });
            if (res.body.length) {
              var newArticle = article;
              newArticle.done_status = res.body;
              newArticle.ttdStatus = self.checkStatus(article.id);
              newArticle.loading = false;
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(chapter.articles, index, newArticle);
              setTimeout(function () {
                var element = document.getElementById('article-messages-' + article.id);
                if (element !== null) {
                  element.scrollTop = element.scrollHeight;
                }
              }, 10);
            }
          }
        }).catch(function (err) {
          return console.log(err);
        });
      });
      self.dataLoading = false;
    },
    getFocusAreaLevel: function getFocusAreaLevel(score) {
      if (score > 79) {
        return {
          id: 5,
          name: 'Platinum'
        };
      }
      if (score > 59) {
        return {
          id: 4,
          name: 'Gold'
        };
      }
      if (score > 39) {
        return {
          id: 3,
          name: 'Silver'
        };
      }
      if (score > 19) {
        return {
          id: 2,
          name: 'Bronze'
        };
      }
      if (score >= 0) {
        return {
          id: 1,
          name: 'Foundation'
        };
      }
    },
    convertTime: function convertTime(payload, delimiter) {
      if (!payload) return;
      var date = new Date(payload);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;

      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }

      return toDoubleDigit(newHours) + delimiter + toDoubleDigit(minutes) + ' ' + ampm;
    },
    reverseItems: function reverseItems(items) {
      if (items) {
        return items.slice().reverse();
      }
    },
    parseJSON: function parseJSON(value) {
      return JSON.parse(value);
    },
    getFullServerPath: function getFullServerPath(fileName) {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverContenImages + fileName;
    },
    getProfileData: function getProfileData() {
      var _this13 = this;

      var self = this;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.user = res.body;
        _this13.getChaptersList();
      }).catch(function (err) {
        console.log(err);
      });
    },
    viewArticle: function viewArticle(id) {
      var props = this.$router.resolve({
        name: 'content',
        params: { id: id }
      });
      this.$router.push(props.href);
    },
    getCompanyStatus: function getCompanyStatus(company) {
      var today = new Date();
      var endDay = new Date(company.subscription_end);
      if (company.enabled) {
        if (endDay < today) {
          return {
            label: 'Inactive',
            value: 1
          };
        } else {
          return {
            label: 'Active',
            value: 2
          };
        }
      } else {
        return {
          label: 'Archived',
          value: 0
        };
      }
    },
    currentYPosition: function currentYPosition() {
      if (self.pageYOffset) {
        return self.pageYOffset;
      }
      if (document.documentElement && document.documentElement.scrollTop) {
        return document.documentElement.scrollTop;
      }
      if (document.body.scrollTop) {
        return document.body.scrollTop;
      }
      return 0;
    },
    elmYPosition: function elmYPosition(eID) {
      var elm = document.getElementById(eID);
      var y = elm.offsetTop;
      var node = elm;
      while (node.offsetParent && node.offsetParent !== document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
      }
      return y;
    },
    smoothScroll: function smoothScroll(eID) {
      var startY = this.currentYPosition();
      var stopY = this.elmYPosition(eID);
      var distance = stopY > startY ? stopY - startY : startY - stopY;
      if (distance < 100) {
        scrollTo(0, stopY);
        return;
      }
      var speed = Math.round(distance / 100);
      if (speed >= 20) {
        speed = 20;
      }
      var step = Math.round(distance / 25);
      var leapY = stopY > startY ? startY + step : startY - step;
      var timer = 0;
      if (stopY > startY) {
        for (var i = startY; i < stopY; i += step) {
          setTimeout(function () {
            window.scrollTo(0, leapY);
          }, timer * speed);
          leapY += step;
          if (leapY > stopY) {
            leapY = stopY;
            timer++;
          }
        }
        return;
      }
      for (var n = startY; n > stopY; n -= step) {
        setTimeout(function () {
          window.scrollTo(0, leapY);
        }, timer * speed);
        leapY -= step;
        if (leapY < stopY) {
          leapY = stopY;
          timer++;
        }
      }
    },
    getChapterCustomName: function getChapterCustomName(chapter) {
      var name = null;
      if (chapter.slug === 'finding') {
        if (this.industry && this.industry.chapter_finding_talent) {
          name = this.industry.chapter_finding_talent.title;
        } else if (this.industry && this.industry.parent && this.industry.parent.chapter_finding_talent) {
          name = this.industry.parent.chapter_finding_talent.title;
        }
      } else if (chapter.slug === 'policies') {
        if (this.industry && this.industry.chapter_policies_and_procedures) {
          name = this.industry.chapter_policies_and_procedures.title;
        } else if (this.industry && this.industry.parent && this.industry.parent.chapter_policies_and_procedures) {
          name = this.industry.parent.chapter_policies_and_procedures.title;
        }
      } else if (chapter.slug === 'assessing') {
        if (this.industry && this.industry.chapter_accessing_talent) {
          name = this.industry.chapter_accessing_talent.title;
        } else if (this.industry && this.industry.parent && this.industry.parent.chapter_accessing_talent) {
          name = this.industry.parent.chapter_accessing_talent.title;
        }
      } else if (chapter.slug === 'retaining') {
        if (this.industry && this.industry.chapter_retaining_talent) {
          name = this.industry.chapter_retaining_talent.title;
        } else if (this.industry && this.industry.parent && this.industry.parent.chapter_retaining_talent) {
          name = this.industry.parent.chapter_retaining_talent.title;
        }
      }

      if (!name) {
        return chapter.name;
      } else {
        return name;
      }
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        var here = element[0] ? element[0] : element;
        here.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(function () {
          here.focus();
        });
      }
    },
    posY: function posY(elm) {
      var test = elm[0] ? elm[0] : elm;
      var top = 0;
      if (test && test.tagName) {
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop;
          test = test.offsetParent;
        }
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elem = el[0] ? el[0] : el;
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        if (!index.match(/article/)) {
          var section = sections[index];
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index;
          }
        }
      }
    },

    // functional for chart
    getCurrentDate: function getCurrentDate() {
      var date = new Date();
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var fullYear = date.getFullYear();
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var m = months[month - 1];
      return m + ' ' + day + ', ' + fullYear;
    },
    getBadgeLink: function getBadgeLink() {
      var props = this.$router.resolve({
        name: 'badge'
      });
      return props.href;
    },
    getChartWidth: function getChartWidth(chartData, full) {
      if (chartData !== null) {
        var rightMargin = 0;
        if (full) {
          rightMargin = 350;
        }
        return chartData.filter(function (item) {
          return item !== null;
        })[0].scores.length * 140 + rightMargin + 'px';
      }
    },
    connectPoints: function connectPoints() {
      var chapters = document.querySelectorAll('.content-chart-points');
      for (var i = 0; i < chapters.length; i++) {
        var children = chapters[i].querySelectorAll('.content-chart-point');
        for (var n = 0; n < children.length; n++) {
          var isLast = false;
          var fromPoint = children[n];
          var toPoint = children[n + 1];
          if (!toPoint) {
            toPoint = document.getElementById(fromPoint.getAttribute('data-chapter'));
            isLast = true;
          }
          if (fromPoint !== undefined && toPoint !== undefined) {
            (function () {
              var el1 = fromPoint;
              var el2 = toPoint;
              var x1 = void 0;
              var x2 = void 0;
              var y1 = void 0;
              var y2 = void 0;
              var color = fromPoint.getAttribute('data-color');

              if (isLast) {
                x1 = el1.offsetLeft + 15;
                y1 = el1.offsetTop + el1.offsetHeight / 2 - 6;
                x2 = el2.offsetLeft + 15;
                y2 = el2.offsetTop + el1.offsetHeight / 2 + 5;
              } else {
                x1 = el1.offsetLeft + el1.offsetWidth - 2;
                y1 = el1.offsetTop + el1.offsetHeight - 11;
                x2 = el2.offsetLeft + el2.offsetWidth;
                y2 = el2.offsetTop;
              }

              var length = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
              var cx = (x1 + x2) / 2 - length / 2 - 5;
              var cy = (y1 + y2) / 2 - 3 / 2 + 5;
              var angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI);
              var line = document.createElement('div');
              line.style['-webkit-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-moz-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-ms-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-o-transform'] = 'rotate(' + angle + 'deg)';
              line.style['-transform'] = 'rotate(' + angle + 'deg)';
              line.style.width = length + 'px';

              if (isLast) {
                line.style.backgroundColor = 'transparent';
                line.style.borderTop = '3px dashed ' + color;
              } else {
                line.style.backgroundColor = color;
              }

              line.style.position = 'absolute';
              line.style.left = cx + 'px';
              line.style.top = cy + 'px';
              line.style.height = 3 + 'px';
              line.classList.add('chart-line');
              try {
                document.body.onload = setTimeout(function () {
                  if (document.querySelector('.content-chart-data')) {
                    document.querySelector('.content-chart-data').appendChild(line);
                  }
                }, 500);
              } catch (err) {}
              isLast = false;
            })();
          }
        }
      }
      document.querySelector('.content-chart-body').scrollLeft = document.querySelector('.content-chart-body').scrollWidth;
    },
    addChapterHover: function addChapterHover(chapter, hoverActive) {
      for (var index in this.chartData) {
        if (this.chartData[index].hover && chapter.chapter.id !== this.chartData[index].chapter.id) {
          this.chartData[index].hover.show = false;
        }
        if (chapter.chapter.id === this.chartData[index].chapter.id) {
          var editedChapter = this.chartData[index];
          var scores = this.chartData[index].scores;
          var top = void 0;
          var create = this.chartData[index].hover ? !this.chartData[index].hover.show : true;
          if (hoverActive === 'benchmark') {
            top = scores[scores.length - 1].benchmark;
          } else {
            top = scores[scores.length - 1].score;
          }
          editedChapter.hover = {
            type: hoverActive,
            show: create,
            top: top
          };
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.chartData, index, editedChapter);
        }
      }
    },
    getChapterIndex: function getChapterIndex(c) {
      var scores = [];
      var chartData = this.chartData;
      var index = 0;
      if (c.scores.length) {
        for (var _index in chartData) {
          var chapter = chartData[_index];
          scores.push(chapter.scores[chapter.scores.length - 1].top);
        }
        var orderedScores = scores.sort(function (a, b) {
          return a - b;
        });
        index = orderedScores.indexOf(c.scores[c.scores.length - 1].top);
      }
      return index;
    },
    hasBenchmark: function hasBenchmark(chapter) {
      if (chapter.scores.length) {
        if (chapter.scores[chapter.scores.length - 1].benchmark !== null) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getIframeCode: function getIframeCode() {
      var url = location.origin + this.getBadgeLink() + '?company=' + this.company.hash + '&theme=' + this.iframeTheme.value;
      return '<iframe width="210" height="85" src="' + url + '" style="border: none;"></iframe>';
    },
    copyIframe: function copyIframe() {
      document.getElementById('iframeCode').select();
      document.execCommand('copy');
    },
    reloadIframe: function reloadIframe() {
      var iframe = document.getElementById('previewIframe');
      iframe.src = iframe.src;
    },
    checkIfCompanyCanBeDisconnectedFromBilling: function checkIfCompanyCanBeDisconnectedFromBilling() {
      var _this14 = this;

      var id = this.companyId;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companyCanBeDisconnectedFromBilling + '/' + id, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.status === 403 || res.body.status === 409) {
          _this14.confOpened = 'disconnectFromBilling';
          if (res.body.status === 403) {
            _this14.initConfAction({
              actionName: 'disconnectFromBillingError',
              customText: res.body.message
            });
          } else {
            _this14.initConfAction({
              actionName: 'disconnectFromBilling'
            });
          }
        } else {
          _this14.disconnectedFromBillingCheckConfirmed = true;
          _this14.company.details.disconnectedFromBilling = true;
          _this14.$nextTick(function () {
            _this14.disconnectedFromBillingCheckConfirmed = false;
          });
        }
        _this14.disableAPI = false;
      }).catch(function () {
        _this14.disableAPI = false;
      });
      this.getConfData.actionConfirmed = false;
    },
    checkIfCompanyCanBeDisconnectedFromBillingConfirmed: function checkIfCompanyCanBeDisconnectedFromBillingConfirmed() {
      var _this15 = this;

      this.disconnectedFromBillingCheckConfirmed = true;
      this.company.details.disconnectedFromBilling = true;
      this.$nextTick(function () {
        _this15.disconnectedFromBillingCheckConfirmed = false;
      });
    }
  }),
  components: {
    BillingProfile: __WEBPACK_IMPORTED_MODULE_5__BillingProfile___default.a,
    AppSelect: __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default.a
  },
  watch: {
    filteredChapters: function filteredChapters() {
      var editedChapters = [];
      this.filteredChapters.forEach(function (chapter) {
        editedChapters.push({
          quarter: chapter.quarter,
          year: chapter.year,
          score: {
            policies: chapter.policies,
            finding: chapter.finding,
            assessing: chapter.assessing,
            retaining: chapter.retaining
          }
        });
      });
      this.editedChapters = editedChapters;
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteCompanyConfirmed();
        if (this.confOpened === 'reset') this.resetTaskHistoryConfirmed();
        if (this.confOpened === 'archive') this.archiveCompanyConfirmed();
        if (this.confOpened === 'changeUrl') this.changeUrlConfirmed();
        if (this.confOpened === 'disconnectFromBilling') this.checkIfCompanyCanBeDisconnectedFromBillingConfirmed();
        if (this.confOpened === 'deleteStatusFile' || this.confOpened === 'deleteStatusMessage' || this.confOpened === 'deleteStatusFileMessage') {
          this.deleteStatusConfirmed();
        }
        this.clearConfAction();
      }
    },

    // 'company.details.url' (value) {
    //   if (value && value !== this.initialData.details.url && this.changeUrl === false) {
    //     this.confOpened = 'changeUrl'
    //     this.initConfAction({
    //       actionName: 'changeCompanyUrl'
    //     })
    //   }
    // },
    'company.details.allowAllEmails': function companyDetailsAllowAllEmails(value) {
      var _this16 = this;

      this.company.details.emailApproval = this.yesNoOptionsForSelectNew.find(function (item) {
        return item.value === _this16.company.details.emailApproval.value;
      });
    },
    'company.details.disconnectedFromBilling': function companyDetailsDisconnectedFromBilling(newVal, oldVal) {
      var _this17 = this;

      if (newVal !== oldVal && newVal === true) {
        if (!this.disconnectedFromBillingCheckConfirmed) {
          this.checkIfCompanyCanBeDisconnectedFromBilling();
          this.$nextTick(function () {
            _this17.company.details.disconnectedFromBilling = false;
          });
        }
      }
    },

    tabActive: {
      handler: function handler(value) {
        if (value === 'progress') {
          var _self = this;
          setTimeout(function () {
            _self.connectPoints();
          }, 1000);
          document.title = this.company.details.name + '\'s progress | Clear Assured';
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname]);
            window._paq.push(['setDocumentTitle', document.title]);
            window._paq.push(['trackPageView']);
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }
        if (value === 'profile') {
          document.title = this.company.details.name + '\'s details | Clear Assured';
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname]);
            window._paq.push(['setDocumentTitle', document.title]);
            window._paq.push(['trackPageView']);
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }
      },
      deep: true
    },
    '$route': function $route(to, from) {
      if (to.params.id !== from.params.id) {
        location.reload();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getChapters();
    this.getTaskAssignee(this.companyId);
    this.getAdminUsers();
    // this.getCompanies()
    // this.getIndustries()
  },
  created: function created() {
    this.companyId = parseInt(this.$route.params.id);
    document.onclick = this.documentClick;
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.getCompanyData();
    this.getCompanyPoints();
    this.getCompanies();
    this.getIndustries();
    this.getProfileData();
    this.getCompanySizes();
    this.getCompanyLocations();
    this.getDefaultRegistrationRoles();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-default-emails',
  data: function data() {
    return {
      template: null,
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      confOpened: null,
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      customizedEmailTemplates: null,
      emailTemplates: null,
      emailTemplate: {
        id: null,
        description: '',
        variables: null,
        email: {
          template: '',
          subject: '',
          title: '',
          body: '',
          isDefault: 1
        }
      },
      testEmail: {
        email: 'tcc@eromagency.com'
      },
      canEditTemplate: false,
      disableAPI: false,
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      previewEmail: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getConfData']), {
    templateLabel: function templateLabel() {
      var _this = this;

      if (!this.emailTemplates) {
        return '';
      }
      var template = this.emailTemplates.find(function (item) {
        return item.value === _this.template;
      });
      return template ? template.label : '';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'initConfAction', 'authLogout']), {
    getEmailTemplates: function getEmailTemplates() {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.emailTemplate + '/list', __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.emailTemplates = res.body;
        if (!_this2.template) {
          var firstTemplate = res.body[0];
          _this2.$router.push({ query: { template: firstTemplate.value } });
        }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this2.$router.resolve({
            name: 'error'
          });
          _this2.$router.push(props.href);
        }
        if (err.status === 401) {
          _this2.authLogout();
        }
      });
    },
    getEmailTemplate: function getEmailTemplate() {
      var _this3 = this;

      if (!this.template) {
        return;
      }
      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.emailTemplate + '/' + this.template, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.emailTemplate.id = res.body.id || null;
        _this3.emailTemplate.variables = res.body.variables || null;
        _this3.emailTemplate.description = res.body.description || '';
        if (_this3.emailTemplate.email) {
          _this3.emailTemplate.email.template = res.body.email ? res.body.email.template : '';
          _this3.emailTemplate.email.subject = res.body.email ? res.body.email.subject : '';
          _this3.emailTemplate.email.title = res.body.email ? res.body.email.title : '';
          _this3.emailTemplate.email.body = res.body.email ? res.body.email.body : '';
          _this3.emailTemplate.email.isDefault = res.body.email ? res.body.email.isDefault : 1;
        }
        _this3.previewEmail = res.body.emailHtml ? res.body.emailHtml : '';
        _this3.buildEmailFrame(_this3.previewEmail);
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this3.$router.resolve({
            name: 'error'
          });
          _this3.$router.push(props.href);
        }
        if (err.status === 401) {
          _this3.authLogout();
        }
      });
    },

    openEditTemplate: function openEditTemplate() {
      this.canEditTemplate = true;
    },
    closeEditTemplate: function closeEditTemplate() {
      this.canEditTemplate = false;
    },
    updateEmailTemplate: function updateEmailTemplate() {
      var _this4 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var emailData = {
        template: this.template,
        subject: this.emailTemplate.email.subject,
        title: this.emailTemplate.email.title,
        body: this.emailTemplate.email.body,
        isDefault: 1
      };
      if (this.emailTemplate.id) {
        emailData['id'] = this.emailTemplate.id;
      }
      this.disableAPI = true;
      this.$http.post('' + __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.emailTemplate, emailData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = _this4.templateLabel + ' email was successfully updated.';
        _this4.infMsgDescription = 'Please note all edits are being logged.';
        _this4.infMsgClass = 'success';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.getEmailTemplate();
        _this4.canEditTemplate = !_this4.canEditTemplate;
      }).catch(function (err) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = 'Error. We were not able to update this email because ';
        for (var error in err.body.error.exception) {
          _this4.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this4.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this4.infMsgClass = 'error';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.getEmailTemplate();
      });
    },
    sendTestEmail: function sendTestEmail() {
      var _this5 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var emailData = {
        subject: this.templateLabel + ' test email',
        body: this.previewEmail,
        email: this.testEmail.email
      };
      this.disableAPI = true;
      this.$http.post('' + __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.testEmail, emailData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = _this5.templateLabel + ' email test successfully sent.';
        _this5.infMsgDescription = 'Please check your inbox.';
        _this5.infMsgClass = 'success';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
      }).catch(function (err) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = 'Error. We were not able to send test email because ';
        for (var error in err.body.error.exception) {
          _this5.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this5.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this5.infMsgClass = 'error';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
      });
    },
    buildEmailFrame: function buildEmailFrame(html) {
      var emailBody = document.getElementById('emailBody');
      var iframe = document.createElement('iframe');
      emailBody.innerHTML = '';
      emailBody.appendChild(iframe);
      iframe.onload = function resizeIframe() {
        this.style.height = this.contentWindow.document.documentElement.scrollHeight + 'px';
      };
      iframe.style.width = '100%';
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(html);
      iframe.contentWindow.document.close();
    }
  }),
  components: {},
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') {
          this.deleteIndustryConfirmed();
        }
        this.clearConfAction();
      }
    },
    '$route.query.template': function $routeQueryTemplate() {
      this.template = this.$route.query.template;
      this.canEditTemplate = false;
      this.getEmailTemplates();
      this.getEmailTemplate();
    }
  },
  beforeMount: function beforeMount() {},
  created: function created() {
    this.template = this.$route.query.template;
    document.title = 'Default email templates | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted: function mounted() {
    this.getEmailTemplates();
    this.getEmailTemplate();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sortablejs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_5_vue__["default"].directive('sortable', {
  inserted: function inserted(el, binding) {
    __WEBPACK_IMPORTED_MODULE_6_sortablejs__["default"].create(el, binding.value || {
      handle: '.sponsor-item-handle'
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-industry',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditDetails: false,
      canEditBenchmark: false,
      canEditChapters: false,
      canEditSponsors: false,
      confOpened: null,
      industry: {
        details: {
          id: '',
          name: '',
          parent: null,
          companies: [],
          slug: ''
        },
        benchmarkPoliciesAndProcedures: '',
        benchmarkFindingTalent: '',
        benchmarkAccessingTalent: '',
        benchmarkRetainingTalent: '',
        chapterPoliciesAndProcedures: '',
        chapterFindingTalent: '',
        chapterAccessingTalent: '',
        chapterRetainingTalent: '',
        sponsors: [{
          id: null,
          logo: '',
          alt: '',
          url: '',
          sort: 999999,
          isLogoFileUploaded: false
        }]
      },
      initialData: {
        details: {
          id: '',
          name: '',
          parent: '',
          companies: [],
          slug: ''
        },
        benchmarkPoliciesAndProcedures: '',
        benchmarkFindingTalent: '',
        benchmarkAccessingTalent: '',
        benchmarkRetainingTalent: '',
        chapterPoliciesAndProcedures: '',
        chapterFindingTalent: '',
        chapterAccessingTalent: '',
        chapterRetainingTalent: '',
        sponsors: this.getSponsorList
      },
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      canLeave: false,
      next: null,
      isChanged: false,
      industryId: null,
      activeSection: 'industryDetails',
      thingsToConsiderOptions: [],
      landing: null,
      registrationLanding: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['selectedHightCont', 'getIndustriesForSelect', 'getConfData']), {
    preparedIndustries: function preparedIndustries() {
      var industryList = [];
      for (var industry in this.getIndustriesForSelect) {
        if (this.getIndustriesForSelect[industry].value !== this.industryId * 1 && this.getIndustriesForSelect[industry].parent !== 1) {
          industryList.push(this.getIndustriesForSelect[industry]);
        }
      }
      return industryList;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'getIndustries', 'setSponsors', 'initConfAction', 'authLogout']), {
    getOptionsThingsToConsider: function getOptionsThingsToConsider(search, loading) {
      var _this = this;

      loading(true);
      var urlString = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.search + '&search=' + search + '&isArticle=true';
      this.$http.get(urlString, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        var items = res.body.data.items ? res.body.data.items : [];
        _this.thingsToConsiderOptions = items.map(function (item) {
          var industries = item.industries.map(function (item2) {
            return item2.name;
          });
          industries = industries.length ? ' (' + industries.join(', ') + ')' : '';
          return {
            value: item.id,
            label: item.title + industries
          };
        });
        loading(false);
      }).catch(function (err) {
        console.log(err);
        loading(false);
      });
    },

    openEditBenchmark: function openEditBenchmark() {
      this.canEditBenchmark = true;
    },
    openEditChapters: function openEditChapters() {
      this.canEditChapters = true;
    },
    openEditDetails: function openEditDetails() {
      this.canEditDetails = true;
    },
    openEditSponsors: function openEditSponsors() {
      this.canEditSponsors = true;
    },
    closeEditBenchmark: function closeEditBenchmark() {
      this.industry.benchmarkPoliciesAndProcedures = this.initialData.benchmarkPoliciesAndProcedures;
      this.industry.benchmarkFindingTalent = this.initialData.benchmarkFindingTalent;
      this.industry.benchmarkAccessingTalent = this.initialData.benchmarkAccessingTalent;
      this.industry.benchmarkRetainingTalent = this.initialData.benchmarkRetainingTalent;
      this.canEditBenchmark = false;
    },
    closeEditChapters: function closeEditChapters() {
      this.industry.chapterPoliciesAndProcedures = this.initialData.chapterPoliciesAndProcedures;
      this.industry.chapterFindingTalent = this.initialData.chapterFindingTalent;
      this.industry.chapterAccessingTalent = this.initialData.chapterAccessingTalent;
      this.industry.chapterRetainingTalent = this.initialData.chapterRetainingTalent;
      this.canEditChapters = false;
    },
    closeEditDetails: function closeEditDetails() {
      this.industry.details = this.initialData.details;
      this.canEditDetails = false;
    },
    closeEditSponsors: function closeEditSponsors() {
      this.industry.ownerData = this.initialData.ownerData;
      this.canEditSponsors = false;
    },
    closeMsg: function closeMsg() {
      this.errors.clear();
    },
    deleteIndustry: function deleteIndustry() {
      if (this.industry.details.companies && this.industry.details.companies.length) return;
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeIndustryById'
      });
    },
    deleteIndustryConfirmed: function deleteIndustryConfirmed() {
      var _this2 = this;

      var id = this.industryId;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry + '/' + id, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = _this2.initialData.details.name + ' industry was successfully deleted.';
        _this2.infMsgDescription = 'Please note all edits are being logged.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.goToIndustryList();
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We can\'t delete this industry because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this2.getUserRole === 'gm') {
          _this2.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this2.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    },
    fieldChange: function fieldChange() {
      this.isChanged = true;
    },
    getIndustryData: function getIndustryData() {
      var _this3 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, { id: this.industryId }, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var industry = _this3.industry;
        // set received data
        industry.details.id = res.body.id;
        industry.details.name = res.body.name;
        industry.details.slug = res.body.slug;
        industry.details.parent = null;
        if (res.body.parent !== null) {
          industry.details.parent = {
            id: res.body.parent.id,
            label: res.body.parent.name,
            value: res.body.parent.id
          };
        }
        industry.benchmarkPoliciesAndProcedures = res.body.benchmark_policies_and_procedures;
        industry.benchmarkFindingTalent = res.body.benchmark_finding_talent;
        industry.benchmarkAccessingTalent = res.body.benchmark_accessing_talent;
        industry.benchmarkRetainingTalent = res.body.benchmark_retaining_talent;
        industry.details.companies = res.body.companies;
        industry.chapterPoliciesAndProcedures = null;
        if (res.body.chapter_policies_and_procedures !== null) {
          industry.chapterPoliciesAndProcedures = {
            id: res.body.chapter_policies_and_procedures.id,
            label: res.body.chapter_policies_and_procedures.title,
            value: res.body.chapter_policies_and_procedures.id
          };
        }
        industry.chapterFindingTalent = null;
        if (res.body.chapter_finding_talent !== null) {
          industry.chapterFindingTalent = {
            id: res.body.chapter_finding_talent.id,
            label: res.body.chapter_finding_talent.title,
            value: res.body.chapter_finding_talent.id
          };
        }
        industry.chapterAccessingTalent = null;
        if (res.body.chapter_accessing_talent !== null) {
          industry.chapterAccessingTalent = {
            id: res.body.chapter_accessing_talent.id,
            label: res.body.chapter_accessing_talent.title,
            value: res.body.chapter_accessing_talent.id
          };
        }
        industry.chapterRetainingTalent = null;
        if (res.body.chapter_retaining_talent !== null) {
          industry.chapterRetainingTalent = {
            id: res.body.chapter_retaining_talent.id,
            label: res.body.chapter_retaining_talent.title,
            value: res.body.chapter_retaining_talent.id
          };
        }

        if (res.body.landing) {
          _this3.landing = res.body.landing.slug;
        }

        if (res.body.registration_landing) {
          _this3.registrationLanding = res.body.registration_landing.slug;
        }

        // set initial data
        _this3.initialData.details.id = industry.details.id;
        _this3.initialData.details.name = industry.details.name;
        _this3.initialData.details.parent = industry.details.parent;
        _this3.initialData.benchmarkPoliciesAndProcedures = industry.benchmarkPoliciesAndProcedures;
        _this3.initialData.benchmarkFindingTalent = industry.benchmarkFindingTalent;
        _this3.initialData.benchmarkAccessingTalent = industry.benchmarkAccessingTalent;
        _this3.initialData.benchmarkRetainingTalent = industry.benchmarkRetainingTalent;
        _this3.initialData.chapterPoliciesAndProcedures = industry.chapterPoliciesAndProcedures;
        _this3.initialData.chapterFindingTalent = industry.chapterFindingTalent;
        _this3.initialData.chapterAccessingTalent = industry.chapterAccessingTalent;
        _this3.initialData.chapterRetainingTalent = industry.chapterRetainingTalent;
        _this3.initialData.details.companies = industry.details.companies;
        document.title = industry.details.name + '\'s details | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this3.$router.resolve({
            name: 'error'
          });
          _this3.$router.push(props.href);
        }
        if (err.status === 401) {
          _this3.authLogout();
        }
      });
    },
    getSponsorsData: function getSponsorsData() {
      var _this4 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.sponsors + '/' + this.industryId, {}, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var sponsors = res.body.sponsors;
        var newSponsors = [];
        if (sponsors.length) {
          _this4.industry.sponsors = [];
          var lastIndex = 0;
          for (var sponsor in sponsors) {
            newSponsors.push({
              id: sponsors[sponsor].id,
              logo: sponsors[sponsor].logo,
              alt: sponsors[sponsor].alt,
              url: sponsors[sponsor].url,
              sort: sponsors[sponsor].sort,
              isLogoFileUploaded: true
            });
            lastIndex = lastIndex < sponsors[sponsor].sort ? sponsors[sponsor].sort : lastIndex;
          }
          newSponsors.push({
            id: null,
            logo: '',
            alt: '',
            url: '',
            sort: lastIndex + 1,
            isLogoFileUploaded: false
          });
          _this4.industry.sponsors = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(newSponsors, 'sort');
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateIndustryDetails: function updateIndustryDetails() {
      var _this5 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var industryData = {
        id: this.industry.details.id,
        industryName: this.industry.details.name
      };
      if (this.industry.details.parent !== null) {
        industryData.parent = this.industry.details.parent;
      } else {
        industryData.parent = {};
      }
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, industryData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = res.body.name + ' industry details was successfully updated.';
        _this5.infMsgDescription = 'Please note all edits are being logged.';
        _this5.infMsgClass = 'success';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getIndustryData();
        _this5.canEditDetails = !_this5.canEditDetails;
      }).catch(function (err) {
        _this5.disableAPI = false;
        console.log('err', err);
        _this5.infMsgTitle = 'Error. We were not able to update this industry because ';
        for (var error in err.body.error.exception) {
          _this5.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this5.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this5.infMsgClass = 'error';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getIndustryData();
      });
    },
    updateIndustryBenchmark: function updateIndustryBenchmark() {
      var _this6 = this;

      if (this.disableAPI) return;
      var benchmark = {
        id: this.industry.details.id,
        benchmarkFindingTalent: this.industry.benchmarkFindingTalent,
        benchmarkPoliciesAndProcedures: this.industry.benchmarkPoliciesAndProcedures,
        benchmarkAccessingTalent: this.industry.benchmarkAccessingTalent,
        benchmarkRetainingTalent: this.industry.benchmarkRetainingTalent
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, benchmark, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this6.disableAPI = false;
        _this6.infMsgTitle = res.body.name + ' industry benchmark was successfully updated.';
        _this6.infMsgDescription = 'Please note all edits are being logged.';
        _this6.infMsgClass = 'success';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.canEditBenchmark = false;
        _this6.getIndustryData();
      }).catch(function (err) {
        _this6.getIndustryData();
        _this6.disableAPI = false;
        _this6.infMsgTitle = 'Error. We were not able to update this industry because ';
        for (var error in err.body.error.exception) {
          _this6.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this6.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this6.infMsgClass = 'error';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.canEditBenchmark = false;
      });
      this.messageDisplay = true;
    },
    updateIndustryChapters: function updateIndustryChapters() {
      var _this7 = this;

      if (this.disableAPI) return;
      var chapter = {
        id: this.industry.details.id,
        chapterFindingTalent: this.industry.chapterFindingTalent || {},
        chapterPoliciesAndProcedures: this.industry.chapterPoliciesAndProcedures || {},
        chapterAccessingTalent: this.industry.chapterAccessingTalent || {},
        chapterRetainingTalent: this.industry.chapterRetainingTalent || {}
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, chapter, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.disableAPI = false;
        _this7.infMsgTitle = res.body.name + ' industry task categories was successfully updated.';
        _this7.infMsgDescription = 'Please note all edits are being logged.';
        _this7.infMsgClass = 'success';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
        _this7.canEditChapters = false;
        _this7.getIndustryData();
      }).catch(function (err) {
        _this7.getIndustryData();
        _this7.disableAPI = false;
        _this7.infMsgTitle = 'Error. We were not able to update this industry because ';
        for (var error in err.body.error.exception) {
          _this7.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this7.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this7.infMsgClass = 'error';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
        _this7.canEditChapters = false;
      });
      this.messageDisplay = true;
    },
    updateIndustrySponsors: function updateIndustrySponsors() {
      var _this8 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var sponsors = [];
      for (var sponsor in this.industry.sponsors) {
        if (this.industry.sponsors[sponsor].logo !== '') {
          sponsors.push({
            logo: this.industry.sponsors[sponsor].logo,
            alt: this.industry.sponsors[sponsor].alt,
            url: this.industry.sponsors[sponsor].url,
            order: this.industry.sponsors[sponsor].sort
          });
        }
      }
      var sponsorsData = {
        id: this.industry.details.id,
        sponsors: sponsors
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, sponsorsData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this8.disableAPI = false;
        _this8.infMsgTitle = res.body.name + ' industry sponsors list was successfully updated.';
        _this8.infMsgDescription = 'Please note all edits are being logged.';
        _this8.infMsgClass = 'success';
        _this8.setInformationMsg({
          isShown: true,
          title: _this8.infMsgTitle,
          text: _this8.infMsgDescription,
          className: _this8.infMsgClass
        });
        _this8.canEditSponsors = !_this8.canEditSponsors;
      }).catch(function (err) {
        _this8.disableAPI = false;
        _this8.infMsgTitle = 'Error. We were not able to update this industry because ';
        for (var error in err.body.error.exception) {
          _this8.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this8.infMsgDescription = 'Please note all edits are being logged.';
        _this8.infMsgClass = 'error';
        _this8.setInformationMsg({
          isShown: true,
          title: _this8.infMsgTitle,
          text: _this8.infMsgDescription,
          className: _this8.infMsgClass
        });
      });
    },

    createLanding: function createLanding() {
      var _this9 = this;

      if (this.disableAPI) return;

      var landingData = {
        title: this.industry.details.name,
        slug: this.industry.details.slug,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]),
        description: 'Landing page for industry ' + this.industry.details.name,
        landing: true,
        industry: this.industry.details.id
      };

      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.staticpage, landingData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this9.disableAPI = false;
        if (res.body.slug) {
          var props = _this9.$router.resolve({
            name: 'edit-company-landing',
            params: { id: res.body.slug }
          });
          _this9.$router.push(props.href);
        }
      }).catch(function (err) {
        _this9.disableAPI = false;
        _this9.infMsgTitle = 'Error. We were not able to create landing page for industry: "' + _this9.industry.details.name + '" because ';
        for (var error in err.body.error.exception) {
          _this9.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this9.infMsgDescription = '';
        _this9.infMsgClass = 'error';
        _this9.setInformationMsg({
          isShown: true,
          title: _this9.infMsgTitle,
          text: _this9.infMsgDescription,
          className: _this9.infMsgClass
        });
      });
    },
    createRegistrationLanding: function createRegistrationLanding() {
      var _this10 = this;

      if (this.disableAPI) return;

      var registrationLandingData = {
        title: this.industry.details.name,
        slug: this.industry.details.slug,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]),
        description: 'Registration landing page for industry ' + this.industry.details.name,
        registrationLanding: true,
        industry: this.industry.details.id
      };

      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.staticpage, registrationLandingData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this10.disableAPI = false;
        if (res.body.slug) {
          var props = _this10.$router.resolve({
            name: 'edit-company-registration-landing',
            params: { industry: res.body.slug }
          });
          _this10.$router.push(props.href);
        }
      }).catch(function (err) {
        _this10.disableAPI = false;
        _this10.infMsgTitle = 'Error. We were not able to create registration landing page for industry: "' + _this10.industry.details.name + '" because ';
        for (var error in err.body.error.exception) {
          _this10.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this10.infMsgDescription = '';
        _this10.infMsgClass = 'error';
        _this10.setInformationMsg({
          isShown: true,
          title: _this10.infMsgTitle,
          text: _this10.infMsgDescription,
          className: _this10.infMsgClass
        });
      });
    },
    goToIndustryList: function goToIndustryList() {
      var props = this.$router.resolve({
        name: 'industries'
      });
      this.$router.push(props.href);
    },

    addNewRow: function addNewRow(index) {
      if (this.industry.sponsors.length - 1 === index) {
        this.industry.sponsors.push({
          id: null,
          logo: '',
          alt: '',
          url: '',
          sort: index + 1,
          isLogoFileUploaded: false
        });
      }
    },
    removeElement: function removeElement(index) {
      if (this.industry.sponsors.length === 1) {
        this.industry.sponsors = [{
          id: null,
          logo: '',
          alt: '',
          url: '',
          sort: 0,
          isLogoFileUploaded: false
        }];
      } else {
        this.industry.sponsors.splice(index, 1);
      }
    },
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: true,
        mimes: 'image/*'
      };
    },
    onThumbnailFileChange: function onThumbnailFileChange(e, index) {
      var self = this;
      var input = document.getElementById(e.target.id);
      var thisItem = input.closest('.sponsor-item');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onloadstart = function () {
          thisItem.classList.add('loading');
        };
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            if (Array.isArray(res.body)) {
              alert(res.body[0] + '. Please try again.');
            }
            self.industry.sponsors[index].logo = res.body;
            self.industry.sponsors[index].isLogoFileUploaded = true;
            if (self.industry.sponsors.length - 1 === index) {
              self.industry.sponsors.push({
                id: null,
                logo: '',
                alt: '',
                url: '',
                sort: index + 1,
                isLogoFileUploaded: false
              });
            }
          }).catch(function (err) {
            self.disableAPI = false;
            alert('Error on file upload. Please try again');
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
        reader.onloadend = function () {
          if (this.readyState === 2) {
            thisItem.classList.remove('loading');
          }
        };
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload) {
        return false;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    removeLogo: function removeLogo(index) {
      this.industry.sponsors[index].isLogoFileUploaded = false;
      this.industry.sponsors[index].logo = '';
    },
    deleteMessage: function deleteMessage() {
      if (this.industry.details.id === 1) {
        return 'Default industry can\'t be deleted.';
      } else if (this.industry.details.companies && this.industry.details.companies.length) {
        return 'An industry can\'t be deleted if it has companies associated with it.';
      } else {
        return 'Delete industry.';
      }
    },

    onUpdate: function onUpdate(event) {
      this.industry.sponsors.splice(event.newIndex, 0, this.industry.sponsors.splice(event.oldIndex, 1)[0]);
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        var here = element[0] ? element[0] : element;
        here.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    posY: function posY(elm) {
      var test = elm[0] ? elm[0] : elm;
      var top = 0;
      if (test && test.tagName) {
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop;
          test = test.offsetParent;
        }
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elem = el[0] ? el[0] : el;
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        if (!index.match(/article/)) {
          var section = sections[index];
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index;
          }
        }
      }
    }
  }),
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default.a
  },
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteIndustryConfirmed();
        this.clearConfAction();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getIndustries();
  },
  created: function created() {
    this.industryId = this.$route.params.id;
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.getIndustryData();
    this.getSponsorsData();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-industry-emails',
  data: function data() {
    return {
      industryId: null,
      template: null,
      industry: {
        details: {
          id: '',
          name: '',
          parent: null,
          companies: [],
          slug: ''
        }
      },
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      confOpened: null,
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      emailTemplates: null,
      emailTemplate: {
        id: null,
        description: '',
        variables: null,
        email: {
          template: '',
          subject: '',
          title: '',
          body: '',
          isDefault: 0
        }
      },
      testEmail: {
        email: 'tcc@eromagency.com'
      },
      canEditTemplate: false,
      disableAPI: false,
      editorToolbar: [[{ 'header': [2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'strike', { 'color': [] }, { 'background': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], ['blockquote', 'code-block', 'image', 'link'], [{ 'font': [] }], [{ 'align': [] }], ['clean']],
      previewEmail: null,
      landing: null,
      registrationLanding: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getConfData']), {
    templateLabel: function templateLabel() {
      var _this = this;

      if (!this.emailTemplates) {
        return '';
      }
      var template = this.emailTemplates.find(function (item) {
        return item.value === _this.template;
      });
      return template ? template.label : '';
    },
    customizedEmails: function customizedEmails() {
      if (!this.emailTemplates) {
        return false;
      }
      return this.emailTemplates.filter(function (item) {
        return item.customized === true;
      });
    },
    defaultEmails: function defaultEmails() {
      if (!this.emailTemplates) {
        return false;
      }
      return this.emailTemplates.filter(function (item) {
        return item.customized === false;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'initConfAction', 'authLogout']), {
    createLanding: function createLanding() {
      var _this2 = this;

      if (this.disableAPI) return;

      var landingData = {
        title: this.industry.details.name,
        slug: this.industry.details.slug,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]),
        description: 'Landing page for industry ' + this.industry.details.name,
        landing: true,
        industry: this.industry.details.id
      };

      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.staticpage, landingData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        if (res.body.slug) {
          var props = _this2.$router.resolve({
            name: 'edit-company-landing',
            params: { id: res.body.slug }
          });
          _this2.$router.push(props.href);
        }
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We were not able to create landing page for industry: "' + _this2.industry.details.name + '" because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this2.infMsgDescription = '';
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
      });
    },
    createRegistrationLanding: function createRegistrationLanding() {
      var _this3 = this;

      if (this.disableAPI) return;

      var registrationLandingData = {
        title: this.industry.details.name,
        slug: this.industry.details.slug,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]),
        description: 'Registration landing page for industry ' + this.industry.details.name,
        registrationLanding: true,
        industry: this.industry.details.id
      };

      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.staticpage, registrationLandingData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        if (res.body.slug) {
          var props = _this3.$router.resolve({
            name: 'edit-company-registration-landing',
            params: { industry: res.body.slug }
          });
          _this3.$router.push(props.href);
        }
      }).catch(function (err) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = 'Error. We were not able to create registration landing page for industry: "' + _this3.industry.details.name + '" because ';
        for (var error in err.body.error.exception) {
          _this3.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this3.infMsgDescription = '';
        _this3.infMsgClass = 'error';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
      });
    },
    deleteIndustry: function deleteIndustry() {
      if (this.industry.details.companies && this.industry.details.companies.length) return;
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeIndustryById'
      });
    },
    deleteIndustryConfirmed: function deleteIndustryConfirmed() {
      var _this4 = this;

      var id = this.industryId;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry + '/' + id, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = _this4.initialData.details.name + ' industry was successfully deleted.';
        _this4.infMsgDescription = 'Please note all edits are being logged.';
        _this4.infMsgClass = 'success';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.goToIndustryList();
      }).catch(function (err) {
        _this4.disableAPI = false;
        _this4.infMsgTitle = 'Error. We can\'t delete this industry because ';
        for (var error in err.body.error.exception) {
          _this4.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this4.getUserRole === 'gm') {
          _this4.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this4.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this4.infMsgClass = 'error';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    },
    deleteMessage: function deleteMessage() {
      if (this.industry.details.id === 1) {
        return 'Default industry can\'t be deleted.';
      } else if (this.industry.details.companies && this.industry.details.companies.length) {
        return 'An industry can\'t be deleted if it has companies associated with it.';
      } else {
        return 'Delete industry.';
      }
    },
    getIndustryData: function getIndustryData() {
      var _this5 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, { id: this.industryId }, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var industry = _this5.industry;
        // set received data
        industry.details.id = res.body.id;
        industry.details.name = res.body.name;
        industry.details.slug = res.body.slug;
        industry.details.parent = null;
        if (res.body.parent !== null) {
          industry.details.parent = {
            id: res.body.parent.id,
            label: res.body.parent.name,
            value: res.body.parent.id
          };
        }

        if (res.body.landing) {
          _this5.landing = res.body.landing.slug;
        }

        if (res.body.registration_landing) {
          _this5.registrationLanding = res.body.registration_landing.slug;
        }

        document.title = industry.details.name + '\'s custom emails | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this5.$router.resolve({
            name: 'error'
          });
          _this5.$router.push(props.href);
        }
        if (err.status === 401) {
          _this5.authLogout();
        }
      });
    },
    getIndustryEmailTemplates: function getIndustryEmailTemplates() {
      var _this6 = this;

      if (!this.industryId) {
        return;
      }
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.emailTemplate + '/list?industry=' + this.industryId, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this6.emailTemplates = res.body;
        if (!_this6.template) {
          var firstTemplate = res.body[0];
          _this6.$router.push({ query: { template: firstTemplate.value } });
        }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this6.$router.resolve({
            name: 'error'
          });
          _this6.$router.push(props.href);
        }
        if (err.status === 401) {
          _this6.authLogout();
        }
      });
    },
    getEmailTemplate: function getEmailTemplate() {
      var _this7 = this;

      if (!this.template || !this.industryId) {
        return;
      }
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.emailTemplate + '/' + this.template + '?industry=' + this.industryId, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.emailTemplate.id = res.body.id || null;
        _this7.emailTemplate.variables = res.body.variables || null;
        _this7.emailTemplate.description = res.body.description || '';
        if (_this7.emailTemplate.email) {
          _this7.emailTemplate.email.template = res.body.email ? res.body.email.template : '';
          _this7.emailTemplate.email.subject = res.body.email ? res.body.email.subject : '';
          _this7.emailTemplate.email.title = res.body.email ? res.body.email.title : '';
          _this7.emailTemplate.email.body = res.body.email ? res.body.email.body : '';
          _this7.emailTemplate.email.isDefault = res.body.email ? res.body.email.isDefault : 0;
        }
        _this7.previewEmail = res.body.emailHtml ? res.body.emailHtml : '';
        _this7.buildEmailFrame(_this7.previewEmail);
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this7.$router.resolve({
            name: 'error'
          });
          _this7.$router.push(props.href);
        }
        if (err.status === 401) {
          _this7.authLogout();
        }
      });
    },

    openEditTemplate: function openEditTemplate() {
      this.canEditTemplate = true;
    },
    closeEditTemplate: function closeEditTemplate() {
      this.canEditTemplate = false;
    },
    updateEmailTemplate: function updateEmailTemplate() {
      var _this8 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var emailData = {
        industry: this.industryId,
        template: this.template,
        subject: this.emailTemplate.email.subject,
        title: this.emailTemplate.email.title,
        body: this.emailTemplate.email.body
      };
      this.disableAPI = true;
      this.$http.post('' + __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.emailTemplate, emailData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this8.disableAPI = false;
        _this8.infMsgTitle = _this8.templateLabel + ' email was successfully updated.';
        _this8.infMsgDescription = 'Please note all edits are being logged.';
        _this8.infMsgClass = 'success';
        _this8.setInformationMsg({
          isShown: true,
          title: _this8.infMsgTitle,
          text: _this8.infMsgDescription,
          className: _this8.infMsgClass
        });
        _this8.getEmailTemplate();
        _this8.getIndustryEmailTemplates();
        _this8.canEditTemplate = !_this8.canEditTemplate;
      }).catch(function (err) {
        _this8.disableAPI = false;
        _this8.infMsgTitle = 'Error. We were not able to update this email because ';
        for (var error in err.body.error.exception) {
          _this8.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this8.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this8.infMsgClass = 'error';
        _this8.setInformationMsg({
          isShown: true,
          title: _this8.infMsgTitle,
          text: _this8.infMsgDescription,
          className: _this8.infMsgClass
        });
        _this8.getEmailTemplate();
      });
    },
    sendTestEmail: function sendTestEmail() {
      var _this9 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var emailData = {
        subject: this.templateLabel + ' test email',
        body: this.previewEmail,
        email: this.testEmail.email
      };
      this.disableAPI = true;
      this.$http.post('' + __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.testEmail, emailData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this9.disableAPI = false;
        _this9.infMsgTitle = _this9.templateLabel + ' email test successfully sent.';
        _this9.infMsgDescription = 'Please check your inbox.';
        _this9.infMsgClass = 'success';
        _this9.setInformationMsg({
          isShown: true,
          title: _this9.infMsgTitle,
          text: _this9.infMsgDescription,
          className: _this9.infMsgClass
        });
      }).catch(function (err) {
        _this9.disableAPI = false;
        _this9.infMsgTitle = 'Error. We were not able to send test email because ';
        for (var error in err.body.error.exception) {
          _this9.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this9.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this9.infMsgClass = 'error';
        _this9.setInformationMsg({
          isShown: true,
          title: _this9.infMsgTitle,
          text: _this9.infMsgDescription,
          className: _this9.infMsgClass
        });
      });
    },
    resetEmailTemplate: function resetEmailTemplate() {
      this.confOpened = 'resetEmailTemplate';
      this.initConfAction({
        actionName: 'resetEmailTemplate'
      });
    },
    resetEmailTemplateConfirmed: function resetEmailTemplateConfirmed() {
      var _this10 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var emailData = {
        industry: this.industryId,
        template: this.template
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.emailTemplate + '/reset-default', emailData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this10.disableAPI = false;
        _this10.getIndustryEmailTemplates();
        _this10.infMsgTitle = _this10.templateLabel + ' email was successfully reset to default.';
        _this10.infMsgDescription = 'Please note all edits are being logged.';
        _this10.infMsgClass = 'success';
        _this10.setInformationMsg({
          isShown: true,
          title: _this10.infMsgTitle,
          text: _this10.infMsgDescription,
          className: _this10.infMsgClass
        });
        _this10.getEmailTemplate();
        _this10.canEditTemplate = !_this10.canEditTemplate;
      }).catch(function (err) {
        _this10.disableAPI = false;
        _this10.infMsgTitle = 'Error. We were not able to reset this email to default because ';
        for (var error in err.body.error.exception) {
          _this10.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this10.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this10.infMsgClass = 'error';
        _this10.setInformationMsg({
          isShown: true,
          title: _this10.infMsgTitle,
          text: _this10.infMsgDescription,
          className: _this10.infMsgClass
        });
        _this10.getEmailTemplate();
      });
    },
    buildEmailFrame: function buildEmailFrame(html) {
      var emailBody = document.getElementById('emailBody');
      var iframe = document.createElement('iframe');
      emailBody.innerHTML = '';
      emailBody.appendChild(iframe);
      iframe.onload = function resizeIframe() {
        this.style.height = this.contentWindow.document.documentElement.scrollHeight + 'px';
      };
      iframe.style.width = '100%';
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(html);
      iframe.contentWindow.document.close();
    }
  }),
  components: {},
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') {
          this.deleteIndustryConfirmed();
        }
        if (this.confOpened === 'resetEmailTemplate') {
          this.resetEmailTemplateConfirmed();
        }
        this.clearConfAction();
      }
    },
    '$route.params.id': function $routeParamsId() {
      this.industryId = this.$route.params.id;
    },
    '$route.query.template': function $routeQueryTemplate() {
      this.template = this.$route.query.template;
      this.canEditTemplate = false;
      this.getEmailTemplate();
    }
  },
  beforeMount: function beforeMount() {},
  created: function created() {
    this.industryId = this.$route.params.id;
    this.template = this.$route.query.template;
  },
  mounted: function mounted() {
    this.getIndustryData();
    this.getIndustryEmailTemplates();
    this.getEmailTemplate();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-industry-styling',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditColors: false,
      canEditLogo: false,
      confOpened: null,
      industry: {
        details: {
          id: '',
          name: '',
          mainColorOne: '#22b6cd',
          mainColorTwo: '#272727',
          customLogo: null,
          companies: [],
          slug: ''
        }
      },
      initialData: {
        details: {
          id: '',
          name: '',
          mainColorOne: '#22b6cd',
          mainColorTwo: '#272727',
          customLogo: null,
          companies: [],
          slug: null
        }
      },
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      canLeave: false,
      next: null,
      isChanged: false,
      industryId: null,
      activeSection: 'industryColors',
      mainColorOne: '#22b6cd',
      mainColorOnePickerActive: false,
      mainColorTwo: '#272727',
      mainColorTwoPickerActive: false,
      landing: null,
      registrationLanding: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['selectedHightCont', 'getConfData']), {
    resetNeeded: function resetNeeded() {
      return this.industry.details.mainColorOne !== null && this.industry.details.mainColorOne !== this.mainColorOne || this.industry.details.mainColorTwo !== null && this.industry.details.mainColorTwo !== this.mainColorTwo || this.industry.details.customLogo !== null;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'initConfAction', 'authLogout']), {
    createLanding: function createLanding() {
      var _this = this;

      if (this.disableAPI) return;

      var landingData = {
        title: this.industry.details.name,
        slug: this.industry.details.slug,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]),
        description: 'Landing page for industry ' + this.industry.details.name,
        landing: true,
        industry: this.industry.details.id
      };

      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.staticpage, landingData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        if (res.body.slug) {
          var props = _this.$router.resolve({
            name: 'edit-company-landing',
            params: { id: res.body.slug }
          });
          _this.$router.push(props.href);
        }
      }).catch(function (err) {
        _this.disableAPI = false;
        _this.infMsgTitle = 'Error. We were not able to create landing page for industry: "' + _this.industry.details.name + '" because ';
        for (var error in err.body.error.exception) {
          _this.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this.infMsgDescription = '';
        _this.infMsgClass = 'error';
        _this.setInformationMsg({
          isShown: true,
          title: _this.infMsgTitle,
          text: _this.infMsgDescription,
          className: _this.infMsgClass
        });
      });
    },
    createRegistrationLanding: function createRegistrationLanding() {
      var _this2 = this;

      if (this.disableAPI) return;

      var registrationLandingData = {
        title: this.industry.details.name,
        slug: this.industry.details.slug,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]),
        description: 'Registration landing page for industry ' + this.industry.details.name,
        registrationLanding: true,
        industry: this.industry.details.id
      };

      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.staticpage, registrationLandingData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        if (res.body.slug) {
          var props = _this2.$router.resolve({
            name: 'edit-company-registration-landing',
            params: { industry: res.body.slug }
          });
          _this2.$router.push(props.href);
        }
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We were not able to create registration landing page for industry: "' + _this2.industry.details.name + '" because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this2.infMsgDescription = '';
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
      });
    },
    openEditColors: function openEditColors() {
      this.canEditColors = true;
    },
    openEditLogo: function openEditLogo() {
      this.canEditLogo = true;
    },
    closeEditColors: function closeEditColors() {
      this.industry.details = this.initialData.details;
      this.canEditColors = false;
      this.mainColorOnePickerActive = false;
      this.mainColorTwoPickerActive = false;
    },
    closeEditLogo: function closeEditLogo() {
      this.industry.ownerData = this.initialData.ownerData;
      this.canEditLogo = false;
    },
    closeMsg: function closeMsg() {
      this.errors.clear();
    },
    deleteIndustry: function deleteIndustry() {
      if (this.industry.details.companies && this.industry.details.companies.length) return;
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeIndustryById'
      });
    },
    deleteIndustryConfirmed: function deleteIndustryConfirmed() {
      var _this3 = this;

      var id = this.industryId;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry + '/' + id, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = _this3.initialData.details.name + ' industry was successfully deleted.';
        _this3.infMsgDescription = 'Please note all edits are being logged.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.goToIndustryList();
      }).catch(function (err) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = 'Error. We can\'t delete this industry because ';
        for (var error in err.body.error.exception) {
          _this3.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this3.getUserRole === 'gm') {
          _this3.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this3.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this3.infMsgClass = 'error';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    },
    fieldChange: function fieldChange() {
      this.isChanged = true;
    },
    getIndustryData: function getIndustryData() {
      var _this4 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, { id: this.industryId }, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var industry = _this4.industry;
        // set received data
        industry.details.id = res.body.id;
        industry.details.name = res.body.name;
        industry.details.mainColorOne = res.body.main_color_one || _this4.mainColorOne;
        industry.details.mainColorTwo = res.body.main_color_two || _this4.mainColorTwo;
        industry.details.customLogo = res.body.custom_logo;
        industry.details.companies = res.body.companies;
        industry.details.slug = res.body.slug;

        if (res.body.landing) {
          _this4.landing = res.body.landing.slug;
        }

        if (res.body.registration_landing) {
          _this4.registrationLanding = res.body.registration_landing.slug;
        }

        // set initial data
        _this4.initialData.details.id = industry.details.id;
        _this4.initialData.details.name = industry.details.name;
        _this4.initialData.details.mainColorOne = industry.details.mainColorOne;
        _this4.initialData.details.mainColorTwo = industry.details.mainColorTwo;
        _this4.initialData.details.customLogo = industry.details.customLogo;
        _this4.initialData.details.companies = industry.details.companies;
        _this4.initialData.details.slug = industry.details.slug;

        document.title = industry.details.name + '\'s custom styling | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this4.$router.resolve({
            name: 'error'
          });
          _this4.$router.push(props.href);
        }
        if (err.status === 401) {
          _this4.authLogout();
        }
      });
    },
    updateIndustryColors: function updateIndustryColors() {
      var _this5 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var industryData = {
        id: this.industry.details.id,
        mainColorOne: this.industry.details.mainColorOne,
        mainColorTwo: this.industry.details.mainColorTwo
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, industryData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = res.body.name + ' industry custom styling was successfully updated.';
        _this5.infMsgDescription = 'Please note all edits are being logged.';
        _this5.infMsgClass = 'success';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getIndustryData();
        _this5.canEditColors = !_this5.canEditColors;
        _this5.mainColorOnePickerActive = false;
        _this5.mainColorTwoPickerActive = false;
      }).catch(function (err) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = 'Error. We were not able to update this industry custom styling because ';
        for (var error in err.body.error.exception) {
          _this5.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this5.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this5.infMsgClass = 'error';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getIndustryData();
      });
    },
    resetToDefault: function resetToDefault() {
      this.confOpened = 'resetStyles';
      this.initConfAction({
        actionName: 'resetStyles'
      });
    },
    resetToDefaultConfirmed: function resetToDefaultConfirmed() {
      var _this6 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry + '/reset-styles/' + this.industry.details.id, [], __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this6.disableAPI = false;
        _this6.infMsgTitle = _this6.industry.details.name + ' industry custom styling was successfully reset to default.';
        _this6.infMsgDescription = 'Please note all edits are being logged.';
        _this6.infMsgClass = 'success';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.getIndustryData();
      }).catch(function (err) {
        _this6.disableAPI = false;
        _this6.infMsgTitle = 'Error. We were not able to reset this industry custom styling to default because ';
        for (var error in err.body.error.exception) {
          _this6.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this6.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        _this6.infMsgClass = 'error';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.getIndustryData();
      });
    },
    updateIndustryLogo: function updateIndustryLogo() {
      var _this7 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var logoData = {
        id: this.industry.details.id,
        customLogo: this.industry.details.customLogo
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.industry, logoData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.disableAPI = false;
        _this7.infMsgTitle = res.body.name + ' industry custom logo was successfully updated.';
        _this7.infMsgDescription = 'Please note all edits are being logged.';
        _this7.infMsgClass = 'success';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
        _this7.canEditLogo = !_this7.canEditLogo;
      }).catch(function (err) {
        _this7.disableAPI = false;
        _this7.infMsgTitle = 'Error. We were not able to update this industry custom logo because ';
        for (var error in err.body.error.exception) {
          _this7.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this7.infMsgDescription = 'Please note all edits are being logged.';
        _this7.infMsgClass = 'error';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
      });
    },
    goToIndustryList: function goToIndustryList() {
      var props = this.$router.resolve({
        name: 'industries'
      });
      this.$router.push(props.href);
    },
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: true,
        mimes: 'image/*'
      };
    },
    onThumbnailFileChange: function onThumbnailFileChange(e) {
      var self = this;
      var input = document.getElementById(e.target.id);
      var thisItem = input.closest('.sponsor-item');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onloadstart = function () {
          thisItem.classList.add('loading');
        };
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            if (Array.isArray(res.body)) {
              alert(res.body[0] + '. Please try again.');
            }
            self.industry.details.customLogo = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            alert('Error on file upload. Please try again');
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
        reader.onloadend = function () {
          if (this.readyState === 2) {
            thisItem.classList.remove('loading');
          }
        };
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload) {
        return false;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    hideDatepicker: function hideDatepicker(event) {
      if (event.target.closest('.picker-container')) {
        return;
      }
      if (this.mainColorOnePickerActive) {
        this.mainColorOnePickerActive = false;
      }
      if (this.mainColorTwoPickerActive) {
        this.mainColorTwoPickerActive = false;
      }
    },
    removeLogo: function removeLogo() {
      this.industry.details.customLogo = null;
    },
    deleteMessage: function deleteMessage() {
      if (this.industry.details.id === 1) {
        return 'Default industry can\'t be deleted.';
      } else if (this.industry.details.companies && this.industry.details.companies.length) {
        return 'An industry can\'t be deleted if it has companies associated with it.';
      } else {
        return 'Delete industry.';
      }
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        var here = element[0] ? element[0] : element;
        here.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    posY: function posY(elm) {
      var test = elm[0] ? elm[0] : elm;
      var top = 0;
      if (test && test.tagName) {
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop;
          test = test.offsetParent;
        }
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elem = el[0] ? el[0] : el;
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        if (!index.match(/article/)) {
          var section = sections[index];
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index;
          }
        }
      }
    }
  }),
  components: {},
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteIndustryConfirmed();
        if (this.confOpened === 'resetStyles') this.resetToDefaultConfirmed();
        this.clearConfAction();
      }
    }
  },
  created: function created() {
    this.industryId = this.$route.params.id;
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.getIndustryData();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profile',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditDetails: false,
      canEditPassword: false,
      passwordError: false,
      confOpened: null,
      user: {
        personal: {
          id: '',
          first_name: '',
          last_name: '',
          email: '',
          company: null,
          role: null,
          job_title: null,
          enabled: null,
          status: null,
          current_password: '',
          plainPassword: {
            first: '',
            second: ''
          },
          image: ''
        }
      },
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      canLeave: false,
      next: null,
      initialData: {},
      isChanged: false,
      isStakeholder: false,
      consentStatus: 0,
      consentDate: null,
      activeSection: 'userDetails',
      isThumbnailFileUploaded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['selectedHightCont', 'getCompaniesForSelect', 'getRolesForSelect', 'BlueYelBlue', 'blackYelBlack', 'getUserRole', 'getConfData', 'isRegularUser']), {
    infoStyles: function infoStyles() {
      var updatedStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.BlueYelBlue, {});
      if (+this.selectedHightCont === 1) {
        updatedStyle.backgroundColor = '#000';
      }
      return updatedStyle;
    },
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['clearConfAction', 'getRoles', 'getCompanies', 'setInformationMsg', 'initConfAction', 'authLogout']), {
    openEditPassword: function openEditPassword() {
      this.canEditPassword = true;
    },
    openEditDetails: function openEditDetails() {
      this.canEditDetails = true;
    },
    closeEditPassword: function closeEditPassword() {
      this.user.personal.current_password = '';
      this.user.personal.plainPassword = {
        first: '',
        second: ''
      };
      this.canEditPassword = false;
    },
    closeEditDetails: function closeEditDetails() {
      this.user.personal = this.initialData;
      this.canEditDetails = false;
      this.errors.clean();
    },
    closeMsg: function closeMsg() {
      this.errors.clear();
    },
    deleteProfile: function deleteProfile() {
      this.confOpened = 'delete';
      this.initConfAction({
        actionName: 'removeUserById'
      });
    },
    deleteProfileConfirmed: function deleteProfileConfirmed() {
      var _this = this;

      var id = this.userId;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.user + '/' + id, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var userName = _this.user.personal.first_name + ' ' + _this.user.personal.last_name;
        if (userName === ' ') {
          userName = _this.user.personal.email;
        }
        _this.infMsgTitle = userName + '\'s profile was successfully deleted.';
        _this.infMsgDescription = 'All information related to this profile was removed from our database. We’ll only keep the information related to this profile into our system logs.';
        _this.infMsgClass = 'success';
        _this.setInformationMsg({
          isShown: true,
          title: _this.infMsgTitle,
          text: _this.infMsgDescription,
          className: _this.infMsgClass
        });
        _this.goToUserList(id);
      }).catch(function (err) {
        _this.disableAPI = false;
        _this.infMsgTitle = 'Error. We can\'t delete this user because ';
        for (var error in err.body.error.exception) {
          _this.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this.getUserRole === 'gm') {
          _this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this.infMsgClass = 'error';
        _this.setInformationMsg({
          isShown: true,
          title: _this.infMsgTitle,
          text: _this.infMsgDescription,
          className: _this.infMsgClass
        });
      });
      this.getConfData.actionConfirmed = false;
    },
    approveUser: function approveUser(approved) {
      var _this2 = this;

      var userData = {
        id: this.userId,
        approved: approved
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, userData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var actionText = approved ? 'approved' : 'rejected';
        _this2.disableAPI = false;
        _this2.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile was successfully ' + actionText;
        _this2.infMsgDescription = 'Please note all actions are being logged.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.getProfileData();
      }).catch(function (err) {
        _this2.disableAPI = false;
        var actionText = approved ? 'approve' : 'reject';
        _this2.infMsgTitle = 'Error. We can\'t ' + actionText + ' this user because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this2.getUserRole === 'gm') {
          _this2.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this2.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.getProfileData();
      });
    },
    impersonateUser: function impersonateUser() {
      this.confOpened = 'impersonate';
      this.initConfAction({
        actionName: 'impersonateUserById',
        actionId: this.user.personal.first_name + ' ' + this.user.personal.last_name !== ' ' ? this.user.personal.first_name + ' ' + this.user.personal.last_name : this.user.personal.email
      });
    },
    impersonateUserConfirmed: function impersonateUserConfirmed() {
      var userData = JSON.parse(localStorage.getItem('userData'));
      userData.id = this.user.personal.id;
      userData.userRole = this.user.personal.role.slug;
      userData.company = this.user.personal.company.id;
      userData.firstName = this.user.personal.first_name;
      userData.lastName = this.user.personal.last_name;
      localStorage.setItem('impersonated', this.user.personal.email);
      localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
      this.$store.commit('authLoginSetUserRole', this.user.personal.role.slug);
      this.$store.commit('changeImpersonate', this.user.personal.email);
      this.$store.commit('changeAuthUserData', userData);
      var props = this.$router.resolve({
        name: this.isRegularUser ? 'user-app' : 'knowledge-base'
      });
      location.href = props.href;
    },
    archiveProfile: function archiveProfile() {
      this.confOpened = 'archive';
      this.initConfAction({
        actionName: 'changeUserStatus',
        userStatus: this.user.personal.enabled ? 0 : 1
      });
    },
    archiveProfileConfirmed: function archiveProfileConfirmed() {
      var _this3 = this;

      var userData = {
        id: this.userId,
        enabled: !this.user.personal.enabled
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, userData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var actionText = res.body.enabled ? 'Unarchived' : 'Archived';
        _this3.disableAPI = false;
        _this3.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile was successfully ' + actionText;
        if (!res.body.enabled) {
          _this3.infMsgDescription = 'Archived users will still appear in your organization, but they will not be able to access the application. You can unarchive a user and re-enable their access at any time.';
        } else {
          _this3.infMsgDescription = 'This will grant the user access to the application. Viewing rights and privileges depend on their user type (role).';
        }
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.getProfileData();
      }).catch(function (err) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = 'Error. We can\'t archive this user because ';
        for (var error in err.body.error.exception) {
          _this3.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this3.getUserRole === 'gm') {
          _this3.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this3.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this3.infMsgClass = 'error';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.getProfileData();
      });
      this.getConfData.actionConfirmed = false;
    },
    fieldChange: function fieldChange() {
      this.isChanged = true;
    },
    getProfileData: function getProfileData() {
      var _this4 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, { id: this.userId }, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var personal = _this4.user.personal;
        // set page user data
        personal.id = res.body.id;
        personal.first_name = res.body.first_name;
        personal.last_name = res.body.last_name;
        personal.email = res.body.email;
        personal.phone = res.body.phone;
        personal.function = res.body.function;
        personal.job_title = res.body.job_title;
        personal.status = res.body.status;
        personal.enabled = res.body.enabled;
        if (res.body.image) {
          personal.image = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/users/' + res.body.image;
          _this4.isThumbnailFileUploaded = true;
        }
        if (res.body.company) {
          personal.company = {
            id: res.body.company.id,
            label: res.body.company.name,
            value: res.body.company.id
          };
        }
        personal.role = {
          id: res.body.role.id,
          label: res.body.role.name,
          value: res.body.role.id,
          slug: res.body.role.slug
        };
        personal.stakeholder_type = res.body.stakeholder_type;
        personal.plainPassword = {
          first: '',
          second: ''
          // set consent data
        };_this4.consentStatus = res.body.consent_status;
        _this4.consentDate = res.body.consent_updated;
        // set initial data
        _this4.initialData.id = personal.id;
        _this4.initialData.first_name = personal.first_name;
        _this4.initialData.last_name = personal.last_name;
        _this4.initialData.email = personal.email;
        _this4.initialData.phone = personal.phone;
        _this4.initialData.function = personal.function;
        _this4.initialData.job_title = personal.job_title;
        _this4.initialData.enabled = personal.enabled;
        _this4.initialData.status = personal.status;
        _this4.initialData.company = personal.company;
        _this4.initialData.role = personal.role;
        _this4.initialData.stakeholder_type = personal.stakeholder_type;
        _this4.initialData.image = personal.image;
        _this4.initialData.plainPassword = {
          first: '',
          second: ''
        };
        document.title = personal.first_name + ' ' + personal.last_name + '\'s profile details | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name === 'ca-edit-user' ? 'DASHBOARD_AREA' : 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this4.$router.resolve({
            name: 'error'
          });
          document.location = props.href;
        }
        if (err.status === 401) {
          _this4.authLogout();
        }
      });
    },
    updateProfileDetails: function updateProfileDetails() {
      var _this5 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var userData = {
        id: this.userId,
        firstName: this.user.personal.first_name,
        lastName: this.user.personal.last_name,
        email: this.user.personal.email,
        phone: this.user.personal.phone,
        function: this.user.personal.function,
        jobTitle: this.user.personal.job_title,
        company: this.user.personal.company,
        role: this.user.personal.role,
        stakeholderType: this.user.personal.stakeholder_type,
        image: this.user.personal.image
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, userData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile details was successfully updated.';
        _this5.infMsgDescription = 'When you update a user\'s profile, they are sent an email with the details of the change and who did it. Please note these actions are being logged.';
        _this5.infMsgClass = 'success';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getProfileData();
        _this5.canEditDetails = !_this5.canEditDetails;
      }).catch(function (err) {
        _this5.disableAPI = false;
        _this5.infMsgTitle = 'Error. We were not able to update this user because ';
        for (var error in err.body.error.exception) {
          _this5.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this5.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this5.infMsgClass = 'error';
        _this5.setInformationMsg({
          isShown: true,
          title: _this5.infMsgTitle,
          text: _this5.infMsgDescription,
          className: _this5.infMsgClass
        });
        _this5.getProfileData();
      });
    },
    updateProfilePassword: function updateProfilePassword() {
      var _this6 = this;

      if (this.disableAPI) return;
      this.$validator.validate('New password', this.user.personal.plainPassword.first);
      this.$validator.validate('Retype new password', this.user.personal.plainPassword.second);
      var firstPassword = this.user.personal.plainPassword.first;
      var secondPassword = this.user.personal.plainPassword.second;
      if (!firstPassword || !secondPassword) return;
      if (firstPassword !== secondPassword) {
        this.passwordError = true;
        this.infMsgTitle = 'Passwords doesn\'t match!';
        this.infMsgDescription = 'New password and Retype new password fields doesn\'t match. Please recheck!';
        this.infMsgClass = 'error';
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        });
        return;
      }
      var userData = {};
      userData = {
        id: this.userId,
        newPassword: firstPassword
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, userData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this6.disableAPI = false;
        _this6.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile password was successfully updated.';
        _this6.infMsgDescription = 'When you update a user\'s profile, they are sent an email with the details of the change and who did it. Please note these actions are being logged.';
        _this6.infMsgClass = 'success';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.passwordError = false;
        _this6.canEditPassword = false;
        _this6.getProfileData();
      }).catch(function (err) {
        _this6.getProfileData();
        _this6.disableAPI = false;
        _this6.infMsgTitle = 'Error. We were not able to update this user because ';
        for (var error in err.body.error.exception) {
          _this6.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this6.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this6.infMsgClass = 'error';
        _this6.setInformationMsg({
          isShown: true,
          title: _this6.infMsgTitle,
          text: _this6.infMsgDescription,
          className: _this6.infMsgClass
        });
        _this6.passwordError = false;
        _this6.canEditPassword = false;
      });
      this.messageDisplay = true;
    },
    goToUserList: function goToUserList(id) {
      var props = this.$router.resolve({
        name: 'users',
        params: { id: id }
      });
      this.$router.push(props.href);
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(function () {
          element.focus();
        });
      }
    },
    posY: function posY(elm) {
      var test = elm;
      var top = 0;
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop;
        test = test.offsetParent;
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(elem) {
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        var section = sections[index];
        if (section && this.isScrolledIntoView(section)) {
          this.activeSection = index;
        }
      }
    },
    onThumbnailFileChange: function onThumbnailFileChange(e) {
      var self = this;
      var input = document.getElementById('uploadThumbnail');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.isThumbnailFileUploaded = true;
        var reader = new FileReader();
        reader.onload = function (e) {
          self.user.personal.image = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeThumbnail: function removeThumbnail() {
      var input = document.getElementById('uploadThumbnail');
      input.value = null;
      this.isThumbnailFileUploaded = false;
      this.user.personal.image = null;
    }
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.user.personal.first_name !== this.initialData.first_name || this.user.personal.last_name !== this.initialData.last_name || this.user.personal.email !== this.initialData.email) {
      this.confirmation.isShown = true;
      this.next = next;
    } else {
      next();
    }
  },

  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default.a
  },
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'delete') this.deleteProfileConfirmed();
        if (this.confOpened === 'archive') this.archiveProfileConfirmed();
        if (this.confOpened === 'impersonate') this.impersonateUserConfirmed();
        this.clearConfAction();
      }
    },
    'user.personal.role': function userPersonalRole(value) {
      if (value && value.slug === 'sh') {
        this.isStakeholder = true;
      } else {
        this.isStakeholder = false;
      }
    }
  },
  created: function created() {
    this.userId = this.$route.params.id;
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeMount: function beforeMount() {
    this.getRoles();
    this.getCompanies();
  },
  mounted: function mounted() {
    this.getProfileData();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-logs',
  data: function data() {
    return {
      ppt: 15,
      offset: 0,
      limit: 15,
      order: 'desc',
      logsCount: 0,
      search: '',
      table: '',
      head: '',
      logs: [],
      hoverSearchElements: [],
      logUsers: null,
      logEmails: null,
      logTypes: [],
      logStatuses: [],
      usersFilter: [],
      emailsFilter: [],
      logsUser: null,
      logsEmail: null,
      logsType: null,
      logsStatus: null,
      logOrderBy: {
        order: false
      },
      userFilterLocked: false,
      emailFilterLocked: false,
      serverValidation: {
        errors: []
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      statusbar: {
        filter: {
          isHover: false
        }
      },
      windowWidth: window.innerWidth
    };
  },

  methods: {
    fetchAllContentByScroll: function fetchAllContentByScroll(reInit) {
      var _this = this;

      var user = '';
      if (this.logsUser) {
        user = this.logsUser.id;
      } else if (this.logsEmail) {
        user = this.logsEmail.id;
      }
      var body = {
        offset: this.offset,
        limit: this.limit,
        order: this.order,
        status: this.logsStatus ? this.logsStatus.value : '',
        userId: user,
        type: this.logsType ? this.logsType.value : ''
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.emailLogs, body, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.logsCount = res.body.count;
        if (reInit) {
          _this.logs = [];
        }
        _this.logs = _this.logs.concat(res.body.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getAllFilters: function getAllFilters() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.mailTypes, {}, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings), this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.mailStatuses, {}, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings), this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.filterLogUsers, {}, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings)]).then(function (data) {
        self.logTypes = data[0].body;
        self.logStatuses = data[1].body;
        self.logUsers = data[2].body;
      });
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true;
      }
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistSearchInOptions: function isExistSearchInOptions(type) {
      var hoverElement = this.hoverSearchElements ? this.hoverSearchElements : '';
      if (hoverElement === type) {
        return true;
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      if (this.logsUser && this.logsUser.label === filter.label && this.logsUser.value === filter.value) {
        this.logsUser = null;
      }
      if (this.logsEmail && this.logsEmail.label === filter.label && this.logsEmail.value === filter.value) {
        this.logsEmail = null;
      }
      if (this.logsStatus && this.logsStatus.label === filter.label && this.logsStatus.value === filter.value) {
        this.logsStatus = null;
      }
      if (this.logsType && this.logsType.label === filter.label && this.logsType.value === filter.value) {
        this.logsType = null;
      }
    },
    removeAllFilters: function removeAllFilters() {
      this.logsUser = null;
      this.logsEmail = null;
      this.logsStatus = null;
      this.logsType = null;
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    convertDate: function convertDate(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '.' + toDoubleDigit(month) + '.' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    changeOrderBy: function changeOrderBy(order) {
      this.logOrderBy = {
        order: this.logOrderBy !== null ? !this.logOrderBy.order : order
      };
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
      this.fetchAllContentByScroll();
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width >= 940) {
        deviceName = 'desktop';
      } else if (width >= 480) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    getTabletFiltersAppliedText: function getTabletFiltersAppliedText() {
      var filterAppliedText = 'Apply Filters';
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.logs.length + ' results';
      }
      return filterAppliedText;
    },
    getUser: function getUser(log) {
      var user = this.logUsers.find(function (user) {
        return user.id === log.userId;
      });
      if (!user) {
        return 'n/a';
      }
      var fullName = '';
      if (user && user.firstName) {
        fullName += user.firstName + ' ';
      }
      if (user && user.lastName) {
        fullName += user.lastName;
      }
      if (user.status === 3) {
        return (fullName !== '' ? fullName : 'User') + ' [DELETED]';
      }
      return fullName !== '' ? fullName : 'n/a';
    },
    getTypeName: function getTypeName(log) {
      var type = this.logTypes.find(function (type) {
        return type.value === log.type;
      });
      return type ? type.label : 'n/a';
    },
    getStatusName: function getStatusName(log) {
      var status = this.logStatuses.find(function (status) {
        return status.value === log.status;
      });
      return status ? status.label : 'n/a';
    },
    openEmail: function openEmail(log) {
      var props = this.$router.resolve({
        name: 'email-view',
        params: {
          id: log.id
        }
      });
      this.$router.push(props.href);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getUserRole']), {
    selectedFilters: function selectedFilters() {
      var filters = [];
      if (this.logsUser) {
        filters.push(this.logsUser);
      }
      if (this.logsEmail) {
        filters.push(this.logsEmail);
      }
      if (this.logsStatus) {
        filters.push(this.logsStatus);
      }
      if (this.logsType) {
        filters.push(this.logsType);
      }
      return filters;
    },
    getUsersForSelect: function getUsersForSelect() {
      return this.usersFilter;
    },
    getEmailsForSelect: function getEmailsForSelect() {
      return this.emailsFilter;
    },
    getStatusesForSelect: function getStatusesForSelect() {
      return this.logStatuses;
    },
    getTypesForSelect: function getTypesForSelect() {
      return this.logTypes;
    }
  }),
  watch: {
    'logUsers': function logUsers(value) {
      var _this2 = this;

      this.usersFilter = [];
      this.emailsFilter = [];
      value.forEach(function (user) {
        var fullName = '';
        if (user.firstName) {
          fullName += user.firstName += ' ';
        }
        if (user.lastName) {
          fullName += user.lastName;
        }
        if (fullName !== '') {
          _this2.usersFilter.push({
            id: user.id,
            label: fullName
          });
        }
        if (user.status === '3') {
          _this2.emailsFilter.push({
            id: user.id,
            label: user.email + ' [DELETED]'
          });
        } else {
          _this2.emailsFilter.push({
            id: user.id,
            label: user.email
          });
        }
      });
    },
    'logOrderBy.order': function logOrderByOrder(value) {
      this.order = value ? 'asc' : 'desc';
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsUser': function logsUser(value) {
      if (value) {
        this.emailFilterLocked = true;
      } else {
        this.emailFilterLocked = false;
      }
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsEmail': function logsEmail(value) {
      if (value) {
        this.userFilterLocked = true;
      } else {
        this.userFilterLocked = false;
      }
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsStatus': function logsStatus() {
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsType': function logsType() {
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.getAllFilters();
      this.fetchAllContentByScroll(true);
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default.a
  },
  created: function created() {
    document.title = 'Email logs | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted: function mounted() {
    this.getAllFilters();
    this.fetchAllContentByScroll();
    document.addEventListener('click', this.hideSubMenuTableHead);
    window.addEventListener('resize', this.handleWindowResize);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-preferences',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditRecommendedEmails: false,
      canEditOptionalEmails: false,
      activeSection: 'requiredEmails',
      emails: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['selectedHightCont', 'getUserRole', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'initConfAction', 'authLogout']), {
    openEditOptionalEmails: function openEditOptionalEmails() {
      this.canEditOptionalEmails = true;
    },
    openEditRecommendedEmails: function openEditRecommendedEmails() {
      this.canEditRecommendedEmails = true;
    },
    closeEditOptionalEmails: function closeEditOptionalEmails() {
      this.canEditOptionalEmails = false;
      this.messageDisplay = false;
      if (this.errors) {
        var self = this;
        setTimeout(function () {
          self.errors.clean();
        }, 100);
      }
    },
    closeEditRecommendedEmails: function closeEditRecommendedEmails() {
      this.canEditRecommendedEmails = false;
      this.messageDisplay = false;
      if (this.errors) {
        var self = this;
        setTimeout(function () {
          self.errors.clean();
        }, 100);
      }
    },
    getEmailPreferencesList: function getEmailPreferencesList() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.emailPreferences + '/list', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.emails = res.body;
      }).catch(function (err) {
        if (err.status === 401) {
          _this.authLogout();
        }
      });
    },
    allChildrenAreChecked: function allChildrenAreChecked(parent) {
      if ((typeof parent === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(parent)) !== 'object') {
        return false;
      }
      return !parent.some(function (item) {
        return item['checked'] === false;
      });
    },
    checkAllChildren: function checkAllChildren(event, parent) {
      if ((typeof parent === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(parent)) !== 'object') {
        return false;
      }
      var target = event.target;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parent), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          child['checked'] = target.checked;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    updateEmailPreferences: function updateEmailPreferences(type) {
      var _this2 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      if (!this.emails || this.emails && !this.emails.hasOwnProperty(type)) {
        return;
      }
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.disabledEmails, this.emails[type], __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Email preferences was successfully updated.';
        _this2.infMsgDescription = 'Please note these actions are being logged.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.canEditRecommendedEmails = !_this2.canEditRecommendedEmails;
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We were not able to update your email preferences ';
        for (var error in err.body.error.exception) {
          if (err.body.error.exception.hasOwnProperty(error)) {
            _this2.infMsgDescription += err.body.error.exception[error].message + ' ';
          }
        }
        _this2.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
      });
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(function () {
          element.focus();
        });
      }
    },
    posY: function posY(elm) {
      var test = elm;
      var top = 0;
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop;
        test = test.offsetParent;
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(elem) {
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        if (sections.hasOwnProperty(index)) {
          var section = sections[index];
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index;
          }
        }
      }
    }
  }),
  beforeMount: function beforeMount() {
    document.title = 'Email preferences | Clear Assured';
  },
  created: function created() {
    this.getEmailPreferencesList();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      email: {
        subject: '',
        text: '',
        mail_to: '',
        type: '',
        status: '',
        created: ''
      },
      emailBody: null,
      emailId: null,
      emailReady: false,
      mailTypes: [],
      mailStatuses: []
    };
  },
  created: function created() {
    this.emailId = this.$route.params.id;
    document.title = 'Clear Assured – View email ' + this.emailId;
  },

  methods: {
    fetchContent: function fetchContent() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.emailSingle + '/' + this.emailId, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.email = res.body;
        _this.email.type = _this.mailTypes.find(function (type) {
          return type.value === res.body.type;
        });
        _this.email.status = _this.mailStatuses.find(function (status) {
          return status.value === res.body.status;
        });
        _this.buildEmailFrame(_this.email.text);
        document.title = 'View email ' + _this.emailId + ' | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    getFilters: function getFilters() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.mailTypes, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings), this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.mailStatuses, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings)]).then(function (data) {
        self.mailTypes = data[0].body;
        self.mailStatuses = data[1].body;
      });
    },
    buildEmailFrame: function buildEmailFrame(html) {
      var iframe = document.createElement('iframe');
      document.getElementById('emailBody').appendChild(iframe);
      iframe.style.width = '100%';
      iframe.style.height = '700px';
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(html);
      iframe.contentWindow.document.close();
    },
    convertDate: function convertDate(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '.' + toDoubleDigit(month) + '.' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    }
  },
  mounted: function mounted() {
    this.getFilters();
    this.fetchContent();
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_common_AuthorizationHeader__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_common_AuthorizationHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_common_AuthorizationHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_common_AppFooter__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_common_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_common_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'error',
  data: function data() {
    return {
      msg: 'Sorry, The Page is not exists'
    };
  },

  components: {
    AuthorizationHeader: __WEBPACK_IMPORTED_MODULE_1__components_main_common_AuthorizationHeader___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_2__components_main_common_AppFooter___default.a,
    AppHeader: __WEBPACK_IMPORTED_MODULE_3__components_common_AppHeader___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['selectedHightCont', 'getIsLoggedIn', 'whiteYelWhite']), {
    wrapperStyle: function wrapperStyle() {
      var color = void 0;
      switch (this.selectedHightCont) {
        case 0:
          color = '#000';
          break;
        case 1:
          color = '#FFFA1A';
          break;
        case 2:
          color = '#000';
          break;
      }
      var style = {
        backgroundColor: this.bgColorSpOp,
        color: color
      };
      if (this.selectedHightCont === 1) {
        style.backgroundImage = 'none';
        style.backgroundColor = '#000';
      }
      return style;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['setFontSizeActive', 'setColorPaletteActive'])),
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'expired-token',
  data: function data() {
    return {
      resetInProgress: false,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: ''
      },
      emailFocus: false,
      formInfo: {
        email: ''
      }
    };
  },

  methods: {
    sendFormRequest: function sendFormRequest() {
      var _this = this;

      var self = this;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      this.resetInProgress = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.forgotPassword, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formInfo)).then(function (res) {
        _this.formStatus.success = true;
        _this.formStatus.title = 'Reset link successfully sent.';
        _this.formStatus.body = 'If your email is in our database, you’ll receive an email shortly with instructions to reset your password.';
        _this.formStatus.shown = true;
        _this.formInfo.email = '';
        setTimeout(function () {
          self.errors.clear();
        }, 100);
      }).catch(function (err) {
        _this.resetInProgress = false;
        _this.formStatus.success = false;
        _this.formStatus.title = err.body;
        _this.formStatus.body = '';
        _this.formStatus.shown = true;
      });
    }
  },
  created: function created() {
    document.title = 'Clear Assured – forgot password';
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'industry',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_plus__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_check_circle__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_ban__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'industry-list',
  data: function data() {
    return {
      ppt: 15,
      offset: 15,
      industries: [],
      filteredIndustryList: [],
      selectedAction: null,
      search: '',
      table: '',
      head: '',
      searchByName: '',
      searchByParent: '',
      hoverSearchElements: [],
      industry: null,
      parentIndustryList: [],
      industryOrderBy: {
        type: '',
        order: false
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      statusbar: {
        data: [],
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      windowWidth: window.innerWidth
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])(['getCompanies', 'getRoles', 'setInformationMsg']), {
    fetchAllContentByScroll: function fetchAllContentByScroll(page, limit) {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.industryList + '?limit=' + limit + '&page=' + page, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var industries = res.body.items;
        var parents = [];
        industries.sort(function (a, b) {
          return a.name > b.name;
        }).forEach(function (company) {
          if (company.parent === null) {
            var children = industries.filter(function (item) {
              return item.parent !== null && item.parent.id === company.id;
            });
            parents.push(company);
            children.forEach(function (child) {
              parents.push(child);
            });
          }
        });
        _this.industries = parents;
        _this.statusbar.data = res.body.count ? res.body.count : [];
      }).catch(function (err) {
        console.log(err);
      });
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    addSearchHoverElement: function addSearchHoverElement(type) {
      this.hoverSearchElements = type;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    removeSearchHoverElements: function removeSearchHoverElements() {
      this.hoverSearchElements = '';
    },
    isExist: function isExist(element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true;
      }
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistSearchInOptions: function isExistSearchInOptions(type) {
      var hoverElement = this.hoverSearchElements ? this.hoverSearchElements : '';
      if (hoverElement === type) {
        return true;
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      if (this.searchByName) {
        this.searchByName = '';
      }
      if (this.searchByParent) {
        this.searchByParent = '';
      }
      if (this.industryStatus && this.industryStatus.label === filter.label && this.industryStatus.value === filter.value) {
        this.industryStatus = null;
      }
    },
    removeAllFilters: function removeAllFilters() {
      this.searchByName = '';
      this.searchByParent = '';
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    changeOrderBy: function changeOrderBy(type, order) {
      this.industryOrderBy = {
        type: type,
        order: this.industryOrderBy !== null ? !this.industryOrderBy.order : order
      };
    },
    goToIndustryEdit: function goToIndustryEdit(id) {
      var props = this.$router.resolve({
        name: 'edit-industry',
        params: { id: id }
      });
      location.href = props.href;
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width >= 940) {
        deviceName = 'desktop';
      } else if (width >= 480) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    getTabletFiltersAppliedText: function getTabletFiltersAppliedText() {
      var filterAppliedText = 'Apply Filters';
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.industries.length + ' results';
      }
      return filterAppliedText;
    },

    randomNumber: function randomNumber() {
      return Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapGetters"])([]), {
    getCompaniesForSelect: function getCompaniesForSelect() {
      return this.parentIndustryList;
    },
    filteredCompanies: function filteredCompanies() {
      var _this2 = this;

      var result = this.industries;
      result = this.industries.filter(function (industry) {
        return (industry.id + ' ' + industry.name).toLowerCase().indexOf(_this2.searchByName.toLowerCase()) > -1;
      });
      if (this.industryOrderBy !== null && this.industryOrderBy.type !== '') {
        var ascDesc = this.industryOrderBy.order ? 1 : -1;
        if (this.industryOrderBy.type === 'companies') {
          result = result.sort(function (a, b) {
            return ascDesc * (a.companies.length - b.companies.length);
          });
        }
      }
      if (this.searchByParent) {
        result = result.filter(function (industry) {
          return industry.parent !== null && industry.parent.name.toLowerCase().indexOf(_this2.searchByParent.toLowerCase()) > -1;
        });
      }
      return result;
    },
    selectedFilters: function selectedFilters() {
      var filters = [];
      if (this.searchByName) {
        filters.push({
          id: null,
          type: 'name',
          label: this.searchByName
        });
      }
      if (this.searchByParent) {
        filters.push({
          id: null,
          type: 'parent',
          label: this.searchByParent
        });
      }
      return filters;
    }
  }),
  watch: {
    filteredCompanies: function filteredCompanies() {
      var filteredIndustryList = [];
      this.offset = this.ppt;
      this.parentIndustryList = [];
      this.filteredCompanies.forEach(function (industry) {
        industry.type = 'show';
        filteredIndustryList.push(industry);
      });
      this.filteredIndustryList = filteredIndustryList;
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_6__components_admin_common_Select___default.a
  },
  mounted: function mounted() {
    this.fetchAllContentByScroll(1, 500);
    // this.getCompanies()
    // this.getRoles()
    document.addEventListener('click', this.hideSubMenuTableHead);
    window.addEventListener('resize', this.handleWindowResize);
  },
  created: function created() {
    document.title = 'All industries | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_common_FiltersSelect__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_common_FiltersSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_common_FiltersSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Promotions__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Promotions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Promotions__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'knowledge-base',
  data: function data() {
    return {
      searchKey: null,
      searchCategories: [],
      searchTopics: [],
      searchTypes: [],
      confOpened: null,
      results: [],
      page: 1,
      limit: 10,
      moreResults: false,
      isTyping: false,
      lastSearch: '',
      loadingResources: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['articleCategories', 'articleTopics', 'getConfData', 'getNonEmptyTagsForSelect', 'getNonEmptyCategoriesForSelect', 'getContentTypeForSelect']), {
    searchFilters: function searchFilters() {
      return {
        categories: this.searchCategories,
        topics: this.searchTopics,
        types: this.searchTypes
      };
    },
    queryCategories: function queryCategories() {}
  }),
  components: {
    Promotions: __WEBPACK_IMPORTED_MODULE_4__components_common_Promotions___default.a,
    FiltersSelect: __WEBPACK_IMPORTED_MODULE_2__components_admin_common_FiltersSelect___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['getCategories', 'getTags', 'getTypes', 'initConfAction', 'clearConfAction']), {
    activateTopicSuggestion: function activateTopicSuggestion() {
      this.confOpened = 'topic-suggestion';
      this.initConfAction({
        actionName: 'suggestTopic',
        includeForm: true,
        customCancelButtonText: 'Cancel',
        customConfirmButtonText: 'Submit'
      });
    },
    suggestTopic: function suggestTopic() {
      var data = {
        text: this.getConfData.feedbackText
      };
      this.$http.put('' + __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.topicSuggest, data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {}).catch(function () {});
    },
    search: function search() {
      if (history.pushState) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set('search', this.searchKey);
        var url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.pushState({ path: url }, '', url);
      }
      this.fetchContent(true);
    },
    searchReset: function searchReset() {
      this.searchKey = null;
      if (history.pushState) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('search');
        var url = window.location.protocol + '//' + window.location.host + window.location.pathname;
        if (searchParams) {
          url += '?' + searchParams.toString();
        }
        window.history.pushState({ path: url }, '', url);
      }
    },
    resetAllFilters: function resetAllFilters() {
      this.searchCategories = [];
      this.searchTopics = [];
      this.searchTypes = [];
    },
    keyDownPressed: function keyDownPressed(event) {
      var key = event.keyCode || event.charCode;
      if (key === 8 || key === 27 || key === 46) {
        if (this.isTyping && this.results.length === 0) {
          var searchFor = this.lastSearch;
          this.searchStatisticSend(searchFor, true);
        }
        this.isTyping = false;
      } else {
        this.isTyping = true;
      }
    },
    searchLeave: function searchLeave(event) {
      var searchFor = event.target.value;
      if (searchFor !== '') {
        if (this.isTyping) {
          if (this.results.length > 0) {
            this.searchStatisticSend(searchFor, false);
          } else {
            this.searchStatisticSend(searchFor, true);
          }
        }
      }
    },
    searchStatisticSend: function searchStatisticSend(search, empty) {
      var _this = this;

      if (this.disableAPI) return;
      var body = {
        request: search,
        isEmpty: empty
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.searchSave, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        _this.disableAPI = false;
        if (window._paq) {
          window._paq.push(['setCustomDimension', 4, search]);
          window._paq.push(['setCustomUrl', '/search-query/' + search]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
          window._paq.push(['deleteCustomDimension', 4]);
          window._paq.push(['trackEvent', 'Search', 'wrote', search]);
        }
        // if (window.ga) {
        //   window.ga('set', 'dimension4', search)
        //   window.ga('send', 'pageview', {
        //     page: '/search-query/' + search,
        //     title: search
        //   })
        //   window.ga('set', 'dimension4', null)
        //
        //   window.ga('send', 'pageview', {
        //     eventCategory: 'Search',
        //     eventAction: 'wrote',
        //     eventLabel: search,
        //     eventValue: 1,
        //     page: '/search-query/' + search
        //   })
        // }
      }).catch(function () {
        _this.disableAPI = false;
      });
    },
    fetchContent: function fetchContent() {
      var _this2 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (reset) {
        this.page = 1;
        this.loadingResources = true;
      }
      var queryString = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.search + '&page=' + this.page + '&size=' + this.limit + '&isArticle=true';
      var searchQuery = this.searchKey;
      if (searchQuery && searchQuery.length) {
        queryString += '&search=' + searchQuery;
      }
      var categories = this.searchCategories.map(function (c) {
        return c.value;
      });
      var tags = this.searchTopics.map(function (t) {
        return t.value;
      });
      var types = this.searchTypes.map(function (t) {
        return t.value;
      });
      if (categories && categories.length > 0) {
        for (var i = 0; i < categories.length; i++) {
          queryString += '&categories[]=' + categories[i];
        }
      }
      if (tags && tags.length > 0) {
        for (var _i = 0; _i < tags.length; _i++) {
          queryString += '&tags[]=' + tags[_i];
        }
      }
      if (types && types.length > 0) {
        for (var _i2 = 0; _i2 < types.length; _i2++) {
          queryString += '&contentType[]=' + types[_i2];
        }
      }
      this.$http.get('' + queryString, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var resData = res.body.data;
        if (!resData.items) {
          _this2.lastSearch = _this2.searchQuery;
        }
        if (reset) {
          _this2.results = [];
        }
        _this2.results = _this2.results.concat(resData.items ? resData.items : []);
        _this2.moreResults = resData.page;
        _this2.loadingResources = false;
      }).catch(function (err) {
        console.error(err);
        _this2.loadingResources = false;
      });
    },
    loadMore: function loadMore() {
      this.page++;
      this.fetchContent();
    },
    getHighLightedResult: function getHighLightedResult(text) {
      if (!text) {
        return '';
      }
      text = text.replace(/(<([^>]+)>)/gi, '');
      if (text.length > 174) {
        text = text.substring(0, 174) + '...';
      }
      var re = new RegExp(this.searchKey, 'gi');
      if (this.searchKey && this.searchKey.length > 0) {
        return text.replace(re, '<mark>$&</mark>');
      } else {
        return text;
      }
    },
    activateFilter: function activateFilter(entity, searchContainer) {
      if (!this[searchContainer]) {
        this[searchContainer] = [];
      }
      this[searchContainer].push({
        label: entity.title,
        value: entity.id
      });
    }
  }),
  created: function created() {
    document.title = 'Inclusion hub | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
    if (this.$route.query && this.$route.query.search) {
      this.searchKey = decodeURI(this.$route.query.search);
      this.fetchContent();
    }
  },
  mounted: function mounted() {
    this.getCategories();
    this.getTags();
    this.getTypes();
  },

  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'topic-suggestion') {
          this.suggestTopic();
          this.confOpened = null;
          this.clearConfAction();
        }
      }
    },
    'searchFilters': function searchFilters(value) {
      if (value) {
        if (history.pushState) {
          var searchParams = new URLSearchParams(window.location.search);
          if (value.categories && value.categories.length) {
            var categories = value.categories.map(function (c) {
              return c.value;
            });
            searchParams.set('categories', categories.join(','));
          } else {
            searchParams.delete('categories');
          }
          if (value.topics && value.topics.length) {
            var topics = value.topics.map(function (c) {
              return c.value;
            });
            searchParams.set('topics', topics.join(','));
          } else {
            searchParams.delete('topics');
          }
          if (value.types && value.types.length) {
            var types = value.types.map(function (c) {
              return c.value;
            });
            searchParams.set('types', types.join(','));
          } else {
            searchParams.delete('types');
          }
          var url = window.location.protocol + '//' + window.location.host + window.location.pathname;
          if (searchParams) {
            url += '?' + searchParams.toString();
          }
          window.history.pushState({ path: url }, '', url);
        }
        this.fetchContent(true);
      }
    },
    'getNonEmptyCategoriesForSelect': function getNonEmptyCategoriesForSelect(value) {
      if (value) {
        if (this.$route.query && this.$route.query.categories) {
          var categoriesArr = this.$route.query.categories.toString().split(',');
          this.searchCategories = value.filter(function (_ref) {
            var value = _ref.value;
            return categoriesArr.includes(value.toString());
          });
        }
      }
    },
    'getNonEmptyTagsForSelect': function getNonEmptyTagsForSelect(value) {
      if (value) {
        if (this.$route.query && this.$route.query.topics) {
          var topicsArr = this.$route.query.topics.toString().split(',');
          this.searchTopics = value.filter(function (_ref2) {
            var value = _ref2.value;
            return topicsArr.includes(value.toString());
          });
        }
      }
    },
    'getContentTypeForSelect': function getContentTypeForSelect(value) {
      if (value) {
        if (this.$route.query && this.$route.query.types) {
          var typesArr = this.$route.query.types.toString().split(',');
          this.searchTypes = value.filter(function (_ref3) {
            var value = _ref3.value;
            return typesArr.includes(value.toString());
          });
        }
      }
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      loginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        isError: false,
        passwordType: 'password'
      },
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        },
        contactCTA: {
          title: '',
          text: '',
          buttons: [{
            text: '',
            link: ''
          }],
          hideSection: false
        }
      },
      activatePage: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['redirect']), {
    closeCustomMsg: function closeCustomMsg() {
      this.activatePage = false;
      var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      delete query.activated;
      this.$router.replace({ query: query });
    },
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content);
      var pageData = {
        slug: 'login-page',
        body: body
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.disableAPI = false;
        _this.getLandingPage(null, true);
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var metaTitle = this.metaData.title;
      var metaDescription = this.metaData.description;
      var pageData = {
        title: metaTitle,
        slug: 'login-page',
        description: metaDescription
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getLandingPage: function getLandingPage(id, refresh) {
      var _this3 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'login-page'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage + '/login-page', body, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        _this3.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this3.content, pageData);
        _this3.metaData.title = res.data.title;
        _this3.metaData.description = res.data.description;
        if (_this3.metaData.title && _this3.metaData.title !== '') {
          document.title = _this3.metaData.title + ' | Clear Assured';
        }
        _this3.addPageMeta('description', [{ name: 'content', value: _this3.metaData.description }]);
        _this3.content.title = _this3.metaData.title;
        _this3.content.description = _this3.metaData.description;
        if (id) {
          _this3.pageEditSwitch();
        } else {
          if (refresh) {
            _this3.pageEditMode = false;
          }
        }
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
        _this3.$nextTick(function () {
          _this3.heroImageHeightFix();
        });
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this4 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpagechanges + '/login-page', __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.pageVersions = [];
        for (var index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this4.editHistory = true;
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage(null, true);
    },
    pageEditSwitch: function pageEditSwitch() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    authenticate: function authenticate() {
      var _this6 = this;

      if (this.disableAPI) return;
      this.formStatus.submitting = true;
      this.$validator.validateAll(['Email address', 'Password']).then(function (valid) {
        if (!valid) {
          _this6.formStatus.submitting = false;
          _this6.heroImageHeightFix();
          return;
        }
        var auth = {
          grant_type: _this6.loginForm.grantType,
          client_id: _this6.loginForm.clientId,
          client_secret: _this6.loginForm.clientSecret,
          username: _this6.loginForm.email,
          password: _this6.loginForm.password
        };
        _this6.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.login, auth).then(function (res) {
          var headers = { headers: { 'Authorization': 'Bearer ' + res.body.access_token } };
          document.cookie = 'Recite.Persist=; Max-Age=-99999999;';
          localStorage.setItem('token', res.body.access_token);
          _this6.$http.put(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.profile, {}, headers).then(function (res) {
            _this6.$store.commit('authLoginSuccess');
            var userData = {
              'id': res.body.id ? res.body.id : '',
              'firstName': res.body.first_name ? res.body.first_name : '',
              'lastName': res.body.last_name ? res.body.last_name : '',
              'userRole': res.body.role.slug,
              'company': res.body.company ? res.body.company.id : null
            };
            if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
              localStorage.setItem('consentHead', 'true');
            }
            localStorage.setItem('consentSeen', res.body.consent_seen);
            localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
            localStorage.setItem('cookieFixed', true);
            localStorage.setItem('userIndustry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
            document.getElementById('app').setAttribute('data-industry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
            if (res.body.company) {
              localStorage.setItem('userCompanyName', res.body.company.name);
            }
            if (res.body.company && res.body.company.industry) {
              localStorage.setItem('userIndustryName', res.body.company.industry.name);
            }
            if (res.body.company && res.body.company.is_temporary) {
              var props = _this6.$router.resolve({
                name: 'complete-profile'
              });
              location.href = props.href;
            } else {
              _this6.redirect();
            }
            // this.$store.commit('authLoginSetUsername', userData.firstName)
          }).catch(function (err) {
            if (err.status === 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('userData');
              localStorage.removeItem('consentSeen');
              localStorage.removeItem('consentHead');
              localStorage.removeItem('userIndustryName');
              localStorage.removeItem('userCompanyName');
              _this6.loginForm.isError = true;
              _this6.formStatus.submitting = false;
              _this6.formStatus.shown = true;
              _this6.formStatus.success = false;
              _this6.formStatus.title = 'Your account is inactive. Please contact support.';
              _this6.formStatus.body = 'It looks like there was an error. Please try again or give us a call and we’ll have our support team help you.';
              _this6.heroImageHeightFix();
            }
          });
        }).catch(function () {
          _this6.loginForm.isError = true;
          _this6.formStatus.submitting = false;
          _this6.formStatus.shown = true;
          _this6.formStatus.success = false;
          _this6.formStatus.title = 'Invalid credentials';
          _this6.formStatus.body = 'It looks like there was an error. Please try again or give us a call and we\'ll have our support team help you.';
          _this6.heroImageHeightFix();
        });
      });
    },
    addSection: function addSection(section) {
      if (section === 'contact-cta-button') {
        this.content.contactCTA.buttons.push({
          text: '',
          link: ''
        });
      }
    },
    removeSection: function removeSection(section, index) {
      section.splice(index, 1);
    },
    showPassword: function showPassword() {
      this.loginForm.passwordType = this.loginForm.passwordType === 'password' ? 'text' : 'password';
    },
    decodeHtml: function decodeHtml(value) {
      var txt = document.createElement('textarea');
      txt.innerHTML = value;
      return txt.value;
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    encodeHtml: function encodeHtml(rawStr) {
      return rawStr.replace(/[\u00A0-\u9999<>]/gim, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
      });
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      if (userRole === 'gm') {
        return true;
      }
      return false;
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    getImageFullPath: function getImageFullPath(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload;
    },
    closePopup: function closePopup() {
      this.pageMetaEdit = false;
    },
    closePopupOnOutsideClick: function closePopupOnOutsideClick(e) {
      var pageMetaPopup = this.$refs.pageMetaPopup;
      var target = e.target;
      if (pageMetaPopup && pageMetaPopup !== target && !pageMetaPopup.contains(target)) {
        this.closePopup();
      }
    },
    heroImageHeightFix: function heroImageHeightFix() {
      var imageContainer = document.querySelector('.hero-section .right-content');
      var image = document.querySelector('.hero-section .hero-image');
      var header = document.querySelector('header');
      var maxHeight = window.innerHeight;
      if (header) {
        maxHeight -= header.offsetHeight;
      }
      if (imageContainer && image && (image.clientHeight < maxHeight || imageContainer.clientHeight < maxHeight)) {
        imageContainer.style.height = maxHeight + 'px';
        image.style.maxHeight = maxHeight + 'px';
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    document.addEventListener('click', this.closePopupOnOutsideClick);
    window.addEventListener('resize', this.heroImageHeightFix);
    this.activatePage = this.$route.query.activated;
    if (this.$route.name === 'edit-login') {
      this.pageEditMode = true;
      this.landingPanel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.addEventListener('click', this.closePopupOnOutsideClick);
    window.removeEventListener('resize', this.heroImageHeightFix);
  },

  watch: {}
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company-list',
  data: function data() {
    return {
      ppt: 15,
      offset: 0,
      limit: 15,
      order: 'desc',
      logsCount: 0,
      search: '',
      table: '',
      head: '',
      logs: [],
      hoverSearchElements: [],
      logUsers: null,
      logCompanies: null,
      logActions: null,
      usersFilter: [],
      emailsFilter: [],
      companiesFilter: [],
      actionsFilter: [],
      logsUser: null,
      logsEmail: null,
      logsCompany: null,
      logsAction: null,
      logOrderBy: {
        order: false
      },
      companyFilterLocked: false,
      userFilterLocked: false,
      emailFilterLocked: false,
      serverValidation: {
        errors: []
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      statusbar: {
        filter: {
          isHover: false
        }
      },
      windowWidth: window.innerWidth
    };
  },

  methods: {
    fetchAllContentByScroll: function fetchAllContentByScroll(reInit) {
      var _this = this;

      var user = '';
      if (this.logsUser) {
        user = this.logsUser.id;
      } else if (this.logsEmail) {
        user = this.logsEmail.id;
      }
      var body = {
        offset: this.offset,
        limit: this.limit,
        order: this.order,
        companyId: this.logsCompany ? this.logsCompany.id : '',
        userId: user,
        action: this.logsAction ? this.logsAction.id : ''
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.logs, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.logsCount = res.body.count;
        if (reInit) {
          _this.logs = [];
        }
        _this.logs = _this.logs.concat(res.body.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getAllFilters: function getAllFilters() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.filterLogs, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings), this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.filterLogCompanies, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings), this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.filterLogUsers, {}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings)]).then(function (data) {
        self.logActions = data[0].body;
        self.logCompanies = data[1].body;
        self.logUsers = data[2].body;
      });
    },
    updateUsersFilter: function updateUsersFilter() {
      var _this2 = this;

      var body = {
        companyId: this.logsCompany ? this.logsCompany.id : ''
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.filterLogUsers, body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.logUsers = res.body;
      }).catch(function (err) {
        console.log(err);
      });
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    isExist: function isExist(element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true;
      }
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = options.find(function (item) {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistSearchInOptions: function isExistSearchInOptions(type) {
      var hoverElement = this.hoverSearchElements ? this.hoverSearchElements : '';
      if (hoverElement === type) {
        return true;
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      if (this.logsUser && this.logsUser.label === filter.label && this.logsUser.value === filter.value) {
        this.logsUser = null;
      }
      if (this.logsEmail && this.logsEmail.label === filter.label && this.logsEmail.value === filter.value) {
        this.logsEmail = null;
      }
      if (this.logsCompany && this.logsCompany.label === filter.label && this.logsCompany.value === filter.value) {
        this.logsCompany = null;
      }
      if (this.logsAction && this.logsAction.label === filter.label && this.logsAction.value === filter.value) {
        this.logsAction = null;
      }
    },
    removeAllFilters: function removeAllFilters() {
      this.logsUser = null;
      this.logsEmail = null;
      this.logsCompany = null;
      this.logsAction = null;
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    convertDate: function convertDate(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '.' + toDoubleDigit(month) + '.' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    changeOrderBy: function changeOrderBy(order) {
      this.logOrderBy = {
        order: this.logOrderBy !== null ? !this.logOrderBy.order : order
      };
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
      this.fetchAllContentByScroll();
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width >= 940) {
        deviceName = 'desktop';
      } else if (width >= 480) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    getTabletFiltersAppliedText: function getTabletFiltersAppliedText() {
      var filterAppliedText = 'Apply Filters';
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.logs.length + ' results';
      }
      return filterAppliedText;
    },
    getUser: function getUser(log) {
      var user = this.logUsers.find(function (user) {
        return user.id === log.userId;
      });
      if (!user) {
        return 'n/a';
      }
      var fullName = '';
      if (user && user.firstName) {
        fullName += user.firstName + ' ';
      }
      if (user && user.lastName) {
        fullName += user.lastName;
      }
      if (user.status === 3) {
        return (fullName !== '' ? fullName : 'User') + ' [DELETED]';
      }
      return fullName !== '' ? fullName : 'n/a';
    },
    getEmail: function getEmail(log) {
      var user = this.logUsers.find(function (user) {
        return user.id === log.userId;
      });
      if (!user) {
        return 'n/a';
      }
      return user.email ? user.email : 'n/a';
    },
    getActionName: function getActionName(log) {
      return this.logActions[log.message];
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['getUserRole']), {
    selectedFilters: function selectedFilters() {
      var filters = [];
      if (this.logsUser) {
        filters.push(this.logsUser);
      }
      if (this.logsEmail) {
        filters.push(this.logsEmail);
      }
      if (this.logsCompany) {
        filters.push(this.logsCompany);
      }
      if (this.logsAction) {
        filters.push(this.logsAction);
      }
      return filters;
    },
    getUsersForSelect: function getUsersForSelect() {
      return this.usersFilter;
    },
    getEmailsForSelect: function getEmailsForSelect() {
      return this.emailsFilter;
    },
    getCompaniesForSelect: function getCompaniesForSelect() {
      return this.companiesFilter;
    },
    getActionsForSelect: function getActionsForSelect() {
      return this.actionsFilter;
    }
  }),
  watch: {
    'logUsers': function logUsers(value) {
      var _this3 = this;

      this.usersFilter = [];
      this.emailsFilter = [];
      value.forEach(function (user) {
        var fullName = '';
        if (user.firstName) {
          fullName += user.firstName += ' ';
        }
        if (user.lastName) {
          fullName += user.lastName;
        }
        if (fullName !== '') {
          _this3.usersFilter.push({
            id: user.id,
            label: fullName
          });
        }
        if (user.status === '3') {
          _this3.emailsFilter.push({
            id: user.id,
            label: user.email + ' [DELETED]'
          });
        } else {
          _this3.emailsFilter.push({
            id: user.id,
            label: user.email
          });
        }
      });
    },
    'logCompanies': function logCompanies(value) {
      var _this4 = this;

      this.companiesFilter = [];
      value.forEach(function (company) {
        _this4.companiesFilter.push({
          id: company.id,
          label: company.name
        });
      });
    },
    'logActions': function logActions(value) {
      this.actionsFilter = [];
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        this.actionsFilter.push({
          id: key,
          label: value[key]
        });
      }
    },
    'logOrderBy.order': function logOrderByOrder(value) {
      this.order = value ? 'asc' : 'desc';
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsUser': function logsUser(value) {
      if (value) {
        this.companyFilterLocked = true;
        this.emailFilterLocked = true;
      } else {
        this.companyFilterLocked = false;
        this.emailFilterLocked = false;
      }
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsEmail': function logsEmail(value) {
      if (value) {
        this.userFilterLocked = true;
      } else {
        this.userFilterLocked = false;
      }
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.fetchAllContentByScroll(true);
    },
    'logsCompany': function logsCompany() {
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.updateUsersFilter();
      this.fetchAllContentByScroll(true);
    },
    'logsAction': function logsAction() {
      this.offset = 0;
      this.hideSubMenuTableHead();
      this.getAllFilters();
      this.fetchAllContentByScroll(true);
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default.a
  },
  created: function created() {
    document.title = 'System logs | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  mounted: function mounted() {
    this.getAllFilters();
    this.fetchAllContentByScroll();
    document.addEventListener('click', this.hideSubMenuTableHead);
    window.addEventListener('resize', this.handleWindowResize);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_avatar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_avatar__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'next-gen-article',
  data: function data() {
    return {
      articleId: null,
      relatedArticles: [],
      relatedTasks: [],
      article: null,
      children: [],
      player: {
        shown: false,
        url: '',
        options: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['isAdmin', 'isRegularUser', 'isLightUser', 'getUserCompany', 'articleCategories', 'articleTopics', 'tasksPriorities']), {
    imageFullPath: function imageFullPath() {
      return this.article.image_name ? __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverContenImages + this.article.image_name : '';
    },
    imageBase: function imageBase() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverUserImages;
    }
  }),
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_4_vue_avatar___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getCategories', 'getTags']), {
    getArticleById: function getArticleById() {
      var _this = this;

      this.article = null;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.contentNew + '/' + this.articleId, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (!res.body.is_article) {
          _this.redirectTask();
          return;
        }
        _this.article = res.body;
        _this.getArticleRelatedById();
        _this.setupPageMeta();
        _this.maybeVideoTypeArticle();
        _this.setupExternalLinkClicks();
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this.$router.resolve({
            name: 'no-permissions'
          });
          _this.$router.push(props.href);
        }
        if (err.status === 401) {
          _this.authLogout();
        }
      });
    },
    getArticleRelatedById: function getArticleRelatedById() {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.contentNew + '/related/' + this.articleId, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.children = res.body;
        _this2.setupRelated();
      }).catch(function (err) {
        console.log(err);
      });
    },
    redirectTask: function redirectTask() {
      if (this.isAdmin) {
        this.$router.push({
          name: 'company-task',
          params: {
            companyId: 2,
            id: this.articleId
          }
        });
      } else {
        this.$router.push({ name: 'task', params: { id: this.articleId } });
      }
    },
    setupPageMeta: function setupPageMeta() {
      document.title = this.article.title + ' | Clear Assured';
      if (window._paq) {
        window._paq.push(['setCustomUrl', location.pathname]);
        window._paq.push(['setDocumentTitle', document.title]);
        window._paq.push(['trackPageView']);
      }
      // if (window.ga) {
      //   window.ga('set', 'contentGroup1', 'ARTICLE')
      //   window.ga('set', 'contentGroup2', this.article.content_type.type ? this.article.content_type.type.replace(/\s/g, '') : null)
      //   window.ga('send', 'pageview', {
      //     'page': location.pathname,
      //     'location': location.href,
      //     'title': document.title
      //   })
      // }
    },
    setupRelated: function setupRelated() {
      this.relatedArticles = this.children.filter(function (item) {
        return item.is_article;
      });
      if (this.isRegularUser) {
        var relatedTasks = this.children.filter(function (item) {
          return !item.is_article;
        });
        this.getTasks(relatedTasks);
      }
    },
    getTasks: function getTasks(relatedTasks) {
      var _this3 = this;

      if (!relatedTasks || !relatedTasks.length) {
        return;
      }
      var tasksIds = relatedTasks.map(function (t) {
        return t.id;
      });
      var data = {
        list: tasksIds
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.task + '/ids', data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.relatedTasks = res.body.tasks;
      }).catch(function (error) {
        console.log(error);
      });
    },
    maybeVideoTypeArticle: function maybeVideoTypeArticle() {
      if (this.article.content_type.type === 'Video' && this.article.resources !== null) {
        var resources = this.article.resources;
        var poster = this.article.image_name !== null;
        this.player.url = resources[0].link !== '' ? resources[0].link : null;
        if (!poster) {
          this.initPlayer(false);
        }
      } else {
        this.player = {
          shown: false,
          url: '',
          options: ''
        };
      }
    },
    initPlayer: function initPlayer(autoPlay) {
      var newVideoUrl = this.getVideoUrl(this.player.url);
      if (autoPlay) {
        newVideoUrl += '?autoplay=1&loop=1';
      }
      this.player.url = newVideoUrl;
      this.player.shown = true;
    },
    getVideoUrl: function getVideoUrl(url) {
      if (!url) {
        return;
      }
      var linkPart = url.split('/');
      var link = void 0;
      var id = void 0;
      if (linkPart[2].indexOf('youtu') !== -1) {
        id = this.youtubeParser(url);
        if (!id) {
          return;
        }
        link = linkPart[0] + '//www.youtube.com/embed/' + id;
      }
      if (linkPart[2].indexOf('vimeo') !== -1) {
        id = this.vimeoParser(url);
        if (!id) {
          return;
        }
        link = linkPart[0] + '//player.vimeo.com/video/' + id;
      }
      return link;
    },
    youtubeParser: function youtubeParser(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : false;
    },
    vimeoParser: function vimeoParser(url) {
      var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
      var match = url.match(regExp);
      return match[5] || false;
    },
    setupExternalLinkClicks: function setupExternalLinkClicks() {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('a')).forEach(function (a) {
          if (location.hostname !== a.hostname) {
            a.addEventListener('click', function () {
              if (window._paq) {
                window._paq.push(['trackEvent', 'ExternalUrl', 'Click', a.href]);
              }
              // if (window.ga) {
              //   window.ga('send', {
              //     hitType: 'event',
              //     eventCategory: 'ExternalUrl',
              //     eventAction: 'Click',
              //     eventLabel: a.href,
              //     eventValue: 1
              //   })
              // }
            });
          }
        });
      }, 1500);
    },
    playVideo: function playVideo() {
      this.initPlayer(true);
      if (window._paq) {
        window._paq.push(['trackEvent', 'VIDEO', 'Play', this.taskTitle]);
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'VIDEO',
      //     eventAction: 'Play',
      //     eventLabel: this.taskTitle,
      //     eventValue: 1,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    },
    downloadFile: function downloadFile(file) {
      this.gaDownloadEvent(file);
      var actionURL = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.content + '/download-file';
      if (this.getUserCompany) {
        actionURL += '?company=' + this.getUserCompany;
      }
      var fileName = file.name || file.file;
      var data = {
        type: 'content',
        content: this.articleId,
        file: file.file
      };
      var options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings, {
        responseType: 'blob'
      });
      this.$http.post(actionURL, data, options).then(function (res) {
        var data = new Blob([res['data']]);
        if (window.navigator.msSaveBlob) {
          navigator.msSaveBlob(data, fileName);
        } else {
          var dataUrl = URL.createObjectURL(data);
          var link = document.createElement('A');
          link.setAttribute('href', dataUrl);
          link.setAttribute('download', fileName);
          link.click();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    gaDownloadEvent: function gaDownloadEvent(file) {
      var name = file.name || file.file;
      if (window._paq) {
        window._paq.push(['trackEvent', 'FILE', 'Download', name]);
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'FILE',
      //     eventAction: 'Download',
      //     eventLabel: name,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    },
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    taskPriorityDelta: function taskPriorityDelta(value) {
      var priorityDelta = 0;
      if (value <= 33) {
        priorityDelta = 0;
      } else if (value > 33 && value <= 66) {
        priorityDelta = 1;
      } else if (value > 66 && value <= 100) {
        priorityDelta = 2;
      }
      return priorityDelta;
    },
    taskPriorityLabelByValue: function taskPriorityLabelByValue(value) {
      var priority = this.tasksPriorities.find(function (item) {
        return item.value === value;
      });
      return priority ? priority.label : '';
    }
  }),
  created: function created() {
    this.articleId = this.$route.params.id;
  },
  mounted: function mounted() {
    this.getArticleById();
    if (this.isLightUser || this.isAdmin) {
      this.getCategories();
      this.getTags();
    }
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.articleId = to.params.id;
        this.getArticleById();
      }
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'no-permissions',
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {
    document.title = 'No permissions | Clear Assured';
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'all-notifications',
  data: function data() {
    return {
      ppt: 10,
      offset: 0,
      limit: 10,
      notifications: [],
      allCount: 0,
      loadedCount: 0,
      allIds: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getUserRole'])),
  methods: {
    getNotifications: function getNotifications() {
      var _this = this;

      var body = {
        offset: this.offset,
        limit: this.limit
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.userNotifications, body, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.allCount = res.body.count;
        var notifications = res.body.notifications;
        var temp = void 0;

        var _loop = function _loop(index) {
          var notification = notifications[index];
          var date = _this.convertDate(notification.createdAt, '.');
          var time = _this.convertTime(notification.createdAt, ':');
          var group = _this.notifications.find(function (item) {
            return item.date === date;
          });
          var unread = false;
          _this.loadedCount += 1;
          if (unread === false && notification.isRead === 0) {
            unread = true;
          }
          _this.allIds.push(notification.id);
          temp = {
            type: notification.type,
            userFromId: notification.userFromId,
            id: notification.id,
            contentId: notification.contentId,
            companyId: notification.companyId,
            time: time,
            isRead: notification.isRead,
            message: notification.message
          };
          if (group) {
            group.children.push(temp);
          } else {
            _this.notifications.push({
              date: date,
              unread: unread,
              children: [{
                type: notification.type,
                userFromId: notification.userFromId,
                id: notification.id,
                contentId: notification.contentId,
                companyId: notification.companyId,
                isRead: notification.isRead,
                time: time,
                message: notification.message
              }]
            });
          }
        };

        for (var index in notifications) {
          _loop(index);
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    readNotification: function readNotification(item) {
      this.markNotificationsRead([item.id]);
      // if (item.type === 1) {
      //   if (item.companyId && item.contentId) {
      //     let props = this.$router.resolve({
      //       name: 'edit-company',
      //       params: {
      //         id: item.companyId
      //       },
      //       query: {
      //         ttd: item.contentId
      //       }
      //     })
      //     this.$router.push(props.href)
      //   }
      // } else if (item.type === 2 || item.type === 3) {
      //   if (item.userFromId) {
      //     let props = this.$router.resolve({
      //       name: 'edit-user',
      //       params: {
      //         id: item.userFromId
      //       }
      //     })
      //     this.$router.push(props.href)
      //   } else {
      //     let props = this.$router.resolve({
      //       name: 'consent-logs'
      //     })
      //     this.$router.push(props.href)
      //   }
      // } else if (item.type === 4 || item.type === 5) {
      //   let props = this.$router.resolve({
      //     name: 'content',
      //     params: {
      //       id: item.contentId
      //     }
      //   })
      //   this.$router.push(props.href)
      // }
    },
    markAllNotificationsAsRead: function markAllNotificationsAsRead() {
      this.markNotificationsRead([]);
    },
    markNotificationsRead: function markNotificationsRead(ids) {
      var _this2 = this;

      var body = [];
      if (ids) {
        body = ids;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.userNotificationsRead, body, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.notifications = [];
        _this2.offset = 0;
        _this2.limit = 10;
        _this2.getNotifications();
      }).catch(function (err) {
        return console.log(err);
      });
    },
    convertDate: function convertDate(payload, delimiter) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear;
    },
    convertTime: function convertTime(payload, delimiter) {
      if (!payload) return;
      var date = new Date(payload);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(newHours) + delimiter + toDoubleDigit(minutes) + ' ' + ampm;
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
      this.getNotifications();
    }
  },
  beforeMount: function beforeMount() {
    this.getNotifications();
  },
  created: function created() {
    document.title = 'Clear Assured – forgot password';
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profile',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditDetails: false,
      canEditPassword: false,
      passwordError: false,
      user: {
        personal: {
          id: '',
          name: '',
          first_name: '',
          last_name: '',
          email: '',
          company: null,
          role: null,
          phone: null,
          job_title: '',
          function: null,
          stakeholder_type: '',
          current_password: '',
          plainPassword: {
            first: '',
            second: ''
          },
          image: ''
        }
      },
      consentStatus: 0,
      consentDate: null,
      canLeave: false,
      next: null,
      initialData: {},
      isChanged: false,
      isStakeholder: false,
      activeSection: 'userDetails',
      needPasswordChange: false,
      isThumbnailFileUploaded: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['selectedHightCont', 'getCompaniesForSelect', 'getRolesForSelect', 'BlueYelBlue', 'blackYelBlack', 'getUserRole', 'getConfData']), {
    veeValidateFileUploadRules: function veeValidateFileUploadRules() {
      return {
        required: false,
        mimes: 'image/*'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'getRoles', 'getCompanies', 'setInformationMsg', 'initConfAction', 'authLogout', 'changeConsent']), {
    openEditPassword: function openEditPassword() {
      this.canEditPassword = true;
    },
    openEditDetails: function openEditDetails() {
      this.canEditDetails = true;
    },
    closeEditPassword: function closeEditPassword() {
      this.user.personal.current_password = '';
      this.user.personal.plainPassword = {
        first: '',
        second: ''
      };
      this.canEditPassword = false;
      this.messageDisplay = false;
    },
    closeEditDetails: function closeEditDetails() {
      this.user.personal = this.initialData;
      this.canEditDetails = false;
      if (this.errors) {
        var self = this;
        setTimeout(function () {
          self.errors.clean();
        }, 100);
      }
      this.messageDisplay = false;
    },
    closeMsg: function closeMsg() {
      this.errors.clear();
      this.messageDisplay = false;
    },
    deleteMyProfile: function deleteMyProfile() {
      this.initConfAction({
        actionName: 'removeProfile'
      });
    },
    deleteMyProfileConfirmed: function deleteMyProfileConfirmed() {
      var _this = this;

      var id = this.user.personal.id;
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.user + '/' + id, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        console.log(res);
        _this.authLogout();
      }).catch(function (err) {
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    },
    fieldChange: function fieldChange() {
      this.isChanged = true;
    },
    getProfileData: function getProfileData() {
      var _this2 = this;

      var dontResetInfoMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var route = this.$route.name;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.profile, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (res.body.consent_status === 1 && res.body.role.slug === 'ca') {
          _this2.$store.commit('authLoginSetUserRole', 'ca');
        }
        if (res.body.consent_status === 0 && res.body.role.slug === 'ca') {
          _this2.$store.commit('authLoginSetUserRole', 'sh');
        }
        if (res.body.password_changed && route !== 'give-consent' && dontResetInfoMsg === false) {
          _this2.needPasswordChange = true;
          _this2.openEditPassword();
          _this2.infMsgTitle = 'You must change your password';
          _this2.infMsgDescription = 'You just logged in with temporary credentials. It happens when you just activated your account or when your password was changed by an account administrator or by a Clear Assured support officer. You must set your own password before you can resume your session.';
          _this2.infMsgClass = 'warning';
          _this2.setInformationMsg({
            isShown: true,
            title: _this2.infMsgTitle,
            text: _this2.infMsgDescription,
            className: _this2.infMsgClass
          });
        }
        var personal = _this2.user.personal;
        // set page user data
        personal.id = res.body.id;
        personal.first_name = res.body.first_name;
        personal.last_name = res.body.last_name;
        personal.email = res.body.email;
        personal.phone = res.body.phone;
        personal.function = res.body.function;
        personal.job_title = res.body.job_title;
        if (res.body.image) {
          personal.image = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverURL + '/uploads/images/users/' + res.body.image;
          _this2.isThumbnailFileUploaded = true;
        }
        if (res.body.company) {
          personal.company = {
            id: res.body.company.id,
            label: res.body.company.name,
            value: res.body.company.id
          };
        }
        personal.role = {
          id: res.body.role.id,
          label: res.body.role.name,
          value: res.body.role.id,
          slug: res.body.role.slug
        };
        personal.stakeholder_type = res.body.stakeholder_type;
        personal.plainPassword = {
          first: '',
          second: ''
          // set consent data
        };_this2.consentStatus = res.body.consent_status;
        _this2.consentDate = res.body.consent_updated;
        // set initial data
        _this2.initialData.id = personal.id;
        _this2.initialData.first_name = personal.first_name;
        _this2.initialData.last_name = personal.last_name;
        _this2.initialData.email = personal.email;
        _this2.initialData.phone = personal.phone;
        _this2.initialData.function = personal.function;
        _this2.initialData.job_title = personal.job_title;
        _this2.initialData.company = personal.company ? personal.company : null;
        _this2.initialData.role = personal.role;
        _this2.initialData.stakeholder_type = personal.stakeholder_type;
        _this2.initialData.plainPassword = personal.plainPassword;
        _this2.initialData.image = personal.image;
        _this2.checkSubscribe(_this2.initialData.email);

        document.title = personal.first_name + ' ' + personal.last_name + '\'s profile details | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this2.$router.resolve({
            name: 'error'
          });
          _this2.$router.push(props.href);
        }
        if (err.status === 401) {
          _this2.authLogout();
        }
      });
    },
    updateProfileDetails: function updateProfileDetails() {
      var _this3 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll();
      if (this.errors.items.length) return;
      var userData = {
        firstName: this.user.personal.first_name,
        lastName: this.user.personal.last_name,
        email: this.user.personal.email,
        phone: this.user.personal.phone,
        image: this.user.personal.image
      };
      if (this.getUserRole === 'gm' || this.getUserRole === 'ca') {
        userData.function = this.user.personal.function;
        userData.jobTitle = this.user.personal.job_title;
        userData.company = this.user.personal.company;
        userData.role = this.user.personal.role;
        userData.stakeholderType = this.user.personal.stakeholder_type;
      }
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.profile, userData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = 'Your profile details was successfully updated.';
        _this3.infMsgDescription = 'Please note these actions are being logged.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.getProfileData();
        _this3.canEditDetails = !_this3.canEditDetails;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
        _this3.infMsgTitle = 'Error. We were not able to update your profile ';
        for (var error in err.body.error.exception) {
          _this3.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        _this3.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        _this3.infMsgClass = 'error';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.getProfileData();
      });
    },
    updateProfilePassword: function updateProfilePassword() {
      var _this4 = this;

      if (this.disableAPI) return;
      this.$validator.validateAll('password');
      var firstPassword = this.user.personal.plainPassword.first;
      var secondPassword = this.user.personal.plainPassword.second;
      if (firstPassword !== secondPassword) {
        this.passwordError = true;
        this.infMsgTitle = 'Passwords doesn\'t match!';
        this.infMsgDescription = 'New password and Retype new password fields doesn\'t match. Please recheck!';
        this.infMsgClass = 'error';
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        });
        return;
      }
      var userData = {
        currentPassword: this.user.personal.current_password,
        newPassword: firstPassword
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.profile, userData, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.needPasswordChange = false;
        var name = '';
        if (res.body.first_name) {
          name += res.body.first_name;
        }
        if (res.body.first_name && res.body.last_name) {
          name += ' ';
        }
        if (res.body.last_name) {
          name += res.body.last_name;
        }
        if (name === '') {
          name = res.body.email;
        }
        _this4.infMsgTitle = name + '\'s profile password was successfully updated.';
        _this4.infMsgDescription = 'Please note these actions are being logged.';
        _this4.infMsgClass = 'success';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.passwordError = false;
        _this4.canEditPassword = !_this4.canEditPassword;
        _this4.getProfileData(true);
        _this4.messageDisplay = true;
      }).catch(function (err) {
        var exceptions = err.body && err.body.error && err.body.error.exception ? err.body.error.exception.map(function (e) {
          return e.message;
        }) : ['Something went wrong and the server can\'t figure out what. Please send us a message using the \'Send us your feedback\' button to the left. We will investigate and get back to you shortly.'];
        _this4.getProfileData(true);
        _this4.disableAPI = false;
        _this4.infMsgTitle = 'Password was not changed!';
        _this4.infMsgDescription = exceptions.join('. ');
        // for (let error in err.body.error.exception) {
        //   this.infMsgDescription += err.body.error.exception[error].message + ' '
        // }
        _this4.infMsgClass = 'error';
        _this4.setInformationMsg({
          isShown: true,
          title: _this4.infMsgTitle,
          text: _this4.infMsgDescription,
          className: _this4.infMsgClass
        });
        _this4.passwordError = false;
        _this4.messageDisplay = true;
      });
    },
    updateConsent: function updateConsent(consent) {
      var _this5 = this;

      var body = {
        consent: consent
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.updateConsent, body, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function () {
        if (consent === 1) {
          _this5.$store.commit('changeConsent', 'false');
          if (!_this5.user.personal.first_name || !_this5.user.personal.last_name || _this5.user.personal.first_name === '' || _this5.user.personal.last_name === '') {
            _this5.openEditDetails();
            _this5.infMsgTitle = 'Please complete your profile';
            _this5.infMsgDescription = 'Thank you for activating your account. Please fill in your profile data before you resume your session.';
            _this5.infMsgClass = 'warning';
            _this5.setInformationMsg({
              isShown: true,
              title: _this5.infMsgTitle,
              text: _this5.infMsgDescription,
              className: _this5.infMsgClass
            });
          }
          _this5.setInformationMsg({
            isShown: false,
            title: '',
            text: '',
            className: ''
          });
        } else {
          _this5.$store.commit('changeConsent', 'true');
          _this5.infMsgTitle = 'Some features may be unavailable';
          _this5.infMsgDescription = 'You have not provided us with consent to access and process your data. You may still use the website, yet some of the features will be unavailable. You may change your mind and provide consent at any time and all the features associated with your role will become available.';
          _this5.infMsgClass = 'error';
          _this5.setInformationMsg({
            isShown: true,
            title: _this5.infMsgTitle,
            text: _this5.infMsgDescription,
            className: _this5.infMsgClass
          });
        }
        _this5.getProfileData();
      }).catch(function (err) {
        if (err.status === 401) {
          _this5.authLogout();
        }
      });
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    goToPageSection: function goToPageSection(ref) {
      var element = this.$refs[ref];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(function () {
          element.focus();
        });
      }
    },
    posY: function posY(elm) {
      var test = elm;
      var top = 0;
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop;
        test = test.offsetParent;
      }
      return top;
    },
    scrollY: function scrollY() {
      if (window.pageYOffset) {
        return window.pageYOffset;
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    },
    isScrolledIntoView: function isScrolledIntoView(elem) {
      var docViewTop = this.scrollY();
      var docViewBottom = docViewTop + window.outerHeight;
      var elemTop = this.posY(elem) + 300;
      var elemBottom = elemTop + elem.offsetHeight;
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    handleScroll: function handleScroll() {
      var sections = this.$refs;
      for (var index in sections) {
        var section = sections[index];
        if (section && this.isScrolledIntoView(section)) {
          this.activeSection = index;
        }
      }
    },
    onThumbnailFileChange: function onThumbnailFileChange(e) {
      var self = this;
      var input = document.getElementById('uploadThumbnail');
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.isThumbnailFileUploaded = true;
        var reader = new FileReader();
        reader.onload = function (e) {
          self.user.personal.image = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeThumbnail: function removeThumbnail() {
      var input = document.getElementById('uploadThumbnail');
      input.value = null;
      this.isThumbnailFileUploaded = false;
      this.user.personal.image = false;
    }
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.user.personal.first_name !== this.initialData.first_name || this.user.personal.last_name !== this.initialData.last_name || this.user.personal.email !== this.initialData.email) {
      if (this.confirmation) {
        this.confirmation.isShown = true;
      }
      this.next = next;
    } else {
      next();
    }
  },

  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default.a
  },
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        this.deleteMyProfileConfirmed();
        this.clearConfAction();
      }
    },
    'user.personal.role': function userPersonalRole(value) {
      if (value && value !== this.initialData.role && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!');
        this.user.personal.role = this.initialData.role;
      }
      if (value && value.slug === 'sh') {
        this.isStakeholder = true;
      } else {
        this.isStakeholder = false;
      }
    },
    'user.personal.job_title': function userPersonalJob_title(value) {
      if (value && value !== this.initialData.job_title && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!');
        this.user.personal.job_title = this.initialData.job_title;
      }
    },
    'user.personal.company': function userPersonalCompany(value) {
      if (value && value !== this.initialData.company && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!');
        this.user.personal.company = this.initialData.company;
      }
    },
    'user.personal.function': function userPersonalFunction(value) {
      if (value && value !== this.initialData.function && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!');
        this.user.personal.function = this.initialData.function;
      }
    },
    'user.personal.stakeholder_type': function userPersonalStakeholder_type(value) {
      if (value && value !== this.initialData.stakeholder_type && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!');
        this.user.personal.stakeholder_type = this.initialData.stakeholder_type;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getRoles();
    this.getCompanies();
    document.title = 'Clear Assured – Your profile details';
  },
  mounted: function mounted() {
    this.getProfileData();
  },
  created: function created() {
    var query = this.$route.query;
    if (query) {
      if (query.consent === '1') {
        this.openEditDetails();
        this.infMsgTitle = 'Please complete your profile';
        this.infMsgDescription = 'Thank you for activating your account. Please fill in your profile data before you resume your session.';
        this.infMsgClass = 'warning';
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        });
      }
      if (query.consent === '0') {
        this.openEditDetails();
        this.infMsgTitle = 'Some features may be unavailable';
        this.infMsgDescription = 'You have not provided us with consent to access and process your data. You may still use the website, yet some of the features will be unavailable. You may change your mind and provide consent at any time and all the features associated with your role will become available.';
        this.infMsgClass = 'error';
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        });
      }
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'redirects',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      redirects: [],
      updatedRedirects: [],
      newRedirect: {
        fromUrl: '',
        toUrl: ''
      },
      disableAPI: false,
      searchFrom: '',
      searchTo: '',
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['setInformationMsg', 'clearConfAction', 'initConfAction']), {
    displayAddForm: function displayAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    closeAddForm: function closeAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    removeRedirect: function removeRedirect(id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeRedirectById'
      });
    },
    removeRedirectConfirmed: function removeRedirectConfirmed(id) {
      var self = this;
      var thisRedirect = this.updatedRedirects.find(function (redirect) {
        return redirect.id === id;
      });
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.redirect + '/' + id, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.infMsgTitle = 'Redirect from "' + thisRedirect.fromUrl + '" to "' + thisRedirect.toUrl + '" was successfully deleted.';
        self.infMsgDescription = 'Please note all actions are being logged.';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        for (var i = 0; i < self.redirects.length; i++) {
          if (self.redirects[i].id === id) {
            self.redirects.splice(i, 1);
            break;
          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    fetchAllContentByScroll: function fetchAllContentByScroll() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.redirect + '/list', __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.redirects = [];
        if (res.body) {
          for (var i = 0; i < res.body.length; i++) {
            _this.redirects.push({
              id: res.body[i].id,
              fromUrl: res.body[i].from_url,
              toUrl: res.body[i].to_url
            });
          }
          console.log(_this.redirects);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    createRedirect: function createRedirect() {
      var _this2 = this;

      if (this.disableAPI) return;
      if (!this.newRedirect.fromUrl) return;
      if (!this.newRedirect.toUrl) return;
      var formData = {
        fromUrl: this.newRedirect.fromUrl,
        toUrl: this.newRedirect.toUrl
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.redirect, formData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Redirect from "' + res.body.from_url + '" to "' + res.body.to_url + '" was successfully created.';
        _this2.infMsgDescription = 'Please note all actions are being logged.';
        _this2.infMsgClass = 'success';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
        _this2.newRedirect.fromUrl = '';
        _this2.newRedirect.toUrl = '';
        _this2.addFormDisplay = false;
        _this2.fetchAllContentByScroll();
      }).catch(function (err) {
        _this2.disableAPI = false;
        _this2.infMsgTitle = 'Error. We can\'t create this redirect because ';
        for (var error in err.body.error.exception) {
          _this2.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this2.getUserRole === 'gm') {
          _this2.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this2.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this2.infMsgClass = 'error';
        _this2.setInformationMsg({
          isShown: true,
          title: _this2.infMsgTitle,
          text: _this2.infMsgDescription,
          className: _this2.infMsgClass
        });
      });
    },
    switchEditMode: function switchEditMode(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedRedirects), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var redirect = _step.value;

          if (redirect.type === 'edit') redirect.type = null;
          if (redirect.id === id && redirect.type === null) {
            redirect.type = 'edit';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    editRedirect: function editRedirect(id) {
      var _this3 = this;

      if (this.disableAPI) return;
      var redirect = this.updatedRedirects.find(function (redirect) {
        return redirect.id === id && redirect.type === 'edit';
      });
      var formData = {
        id: id,
        fromUrl: redirect.fromUrl,
        toUrl: redirect.toUrl
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.redirect, formData, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.discardChanges(id);
        _this3.fetchAllContentByScroll();
        _this3.infMsgTitle = 'Redirect from "' + res.body.from_url + '" to "' + res.body.to_url + '" was successfully updated.';
        _this3.infMsgDescription = 'Please note all actions are being logged.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
      }).catch(function (err) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = 'Error. We can\'t create this redirect because ';
        for (var error in err.body.error.exception) {
          _this3.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this3.getUserRole === 'gm') {
          _this3.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this3.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this3.infMsgClass = 'error';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
      });
    },
    discardChanges: function discardChanges(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedRedirects), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var redirect = _step2.value;

          if (redirect.id === id && redirect.type === 'edit') {
            redirect.type = null;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getConfData']), {
    filteredRedirects: function filteredRedirects() {
      var _this4 = this;

      console.log(this.redirects);
      return this.redirects.filter(function (redirect) {
        return redirect.fromUrl.toLowerCase().indexOf(_this4.searchFrom.toLowerCase()) > -1 && redirect.toUrl.toLowerCase().indexOf(_this4.searchTo.toLowerCase()) > -1;
      });
    }
  }),
  watch: {
    filteredRedirects: function filteredRedirects() {
      var updatedRedirects = [];
      this.filteredRedirects.forEach(function (redirect, i, arr) {
        redirect.type = 'show';
        updatedRedirects.push(redirect);
        updatedRedirects.push({
          type: null,
          id: redirect.id,
          fromUrl: redirect.fromUrl,
          toUrl: redirect.toUrl
        });
      });
      this.updatedRedirects = updatedRedirects;
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        this.removeRedirectConfirmed(this.getConfData.actionId);
        this.clearConfAction();
      }
    }
  },
  components: {},
  mounted: function mounted() {
    this.fetchAllContentByScroll();
    document.addEventListener('click', this.hideSubMenuTableHead);
  },
  created: function created() {
    document.title = 'Dashboard redirects | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reset',
  props: ['token'],
  data: function data() {
    return {
      resetInProgress: false,
      passwordType: 'password',
      retypePasswordType: 'password',
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      },
      passwordFocus: false,
      retypePasswordFocus: false,
      formInfo: {
        fos_user_resetting_form: {
          plainPassword: {
            first: '',
            second: ''
          }
        }
      },
      successfullyReset: false,
      isError: false,
      isToken: false,
      loginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        loginInProgress: false,
        isError: false,
        loginErrorMessage: '',
        passwordType: 'password'
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['redirect']), {
    invalidToken: function invalidToken() {
      var _this = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.invalidToken + this.$route.params.token).then(function (res) {
        _this.isToken = true;
      }).catch(function (err) {
        console.log(err);
        _this.$router.push('/expired-token');
      });
    },
    sendFormRequest: function sendFormRequest() {
      this.$router.push('/');
    },
    resetPassword: function resetPassword() {
      var _this2 = this;

      this.formStatus.submitting = true;
      this.$validator.validateAll().then(function (valid) {
        if (!valid) {
          _this2.isError = true;
          _this2.formStatus.submitting = false;
          return;
        }
        _this2.resetInProgress = true;
        var token = _this2.$route.params.token;
        _this2.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.resetPassword + token, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.formInfo), {}).then(function (res) {
          _this2.resetInProgress = false;
          _this2.formStatus.success = true;
          _this2.formStatus.title = 'Password was successfully updated.';
          _this2.formStatus.body = 'You can now login to your account using the new password.';
          _this2.formStatus.shown = true;
          _this2.formStatus.submitting = false;
        }).catch(function (err) {
          _this2.resetInProgress = false;
          _this2.formStatus.title = err.body.error.exception[0].message;
          _this2.formStatus.body = '';
          _this2.formStatus.shown = true;
          _this2.formStatus.submitting = false;
        });
      });
    },
    showPassword: function showPassword(form) {
      if (form === 'password') {
        this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
      } else {
        this.retypePasswordType = this.retypePasswordType === 'password' ? 'text' : 'password';
      }
    },
    authenticate: function authenticate() {
      var _this3 = this;

      var auth = {
        grant_type: this.loginForm.grantType,
        client_id: this.loginForm.clientId,
        client_secret: this.loginForm.clientSecret,
        username: this.loginForm.email,
        password: this.loginForm.password
      };

      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.login, auth).then(function (res) {
        _this3.isError = false;
        localStorage.setItem('token', res.body.access_token);
        var headers = { headers: { 'Authorization': 'Bearer ' + res.body.access_token } };
        _this3.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.profile, {}, headers).then(function (res) {
          _this3.$store.commit('authLoginSuccess');
          var userData = {
            'id': res.body.id ? res.body.id : '',
            'firstName': res.body.first_name ? res.body.first_name : '',
            'lastName': res.body.last_name ? res.body.last_name : '',
            'userRole': res.body.role.slug,
            'company': res.body.company ? res.body.company.id : null
          };
          if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
            localStorage.setItem('consentHead', 'true');
          }
          localStorage.setItem('consentSeen', res.body.consent_seen);
          localStorage.setItem('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          localStorage.setItem('cookieFixed', true);
          localStorage.setItem('userIndustry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          document.getElementById('app').setAttribute('data-industry', res.body.company && res.body.company.industry ? res.body.company.industry.id : 1);
          if (res.body.company) {
            localStorage.setItem('userCompanyName', res.body.company.name);
          }
          if (res.body.company && res.body.company.industry) {
            localStorage.setItem('userIndustryName', res.body.company.industry.name);
          }
          _this3.$store.commit('authLoginSetUsername', userData.firstName);
          _this3.redirect();
        }).catch(function (err) {
          if (err.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('userData');
            localStorage.removeItem('consentSeen');
            localStorage.removeItem('consentHead');
            localStorage.removeItem('userIndustryName');
            localStorage.removeItem('userCompanyName');
            _this3.loginForm.loginInProgress = false;
            _this3.loginForm.isError = true;
            _this3.loginForm.loginErrorMessage = 'Your account is inactive. Please contact support.';
          }
        });
      }).catch(function (err) {
        _this3.loginForm.isError = true;
        _this3.loginForm.loginErrorMessage = 'Invalid credentials';
        _this3.loginForm.loginInProgress = false;
        console.log(err);
      });
    }
  }),
  created: function created() {
    document.title = 'Clear Assured – reset your password';
  },
  mounted: function mounted() {
    this.invalidToken();
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resetting'
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tags-list',
  data: function data() {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      tags: [],
      updatedTags: [],
      contentAutoloadInfo: {
        curPage: 1,
        numPages: 1,
        locked: false
      },
      newTag: {
        name: '',
        isActive: 1,
        featured: 0,
        description: '',
        icon: ''
      },
      disableAPI: false,
      searchString: '',
      addFormDisplay: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])(['getTags', 'setInformationMsg', 'clearConfAction', 'initConfAction']), {
    displayAddForm: function displayAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    closeAddForm: function closeAddForm() {
      this.addFormDisplay = !this.addFormDisplay;
    },
    search: function search() {
      if (!this.filter.search) {
        this.contentInfo.typeAutoLoad = 'allContent';
        this.fetchAllContentByScroll(1, 20);
        return;
      }
      this.contentInfo.typeAutoLoad = 'searchContent';
      this.fetchSearchContent();
    },
    fetchSearchContent: function fetchSearchContent() {
      var _this = this;

      if (!this.filter.search) return;
      var queryString = '' + __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.search;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (item) {
        var value = _this.filter[item];
        if (value && typeof value === 'string') {
          queryString += '&search=' + value;
        }
        if (value !== null && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object' && value.length) {
          var subString = '';
          value.forEach(function (it) {
            subString += '&' + item + '=' + it.value;
          });
          queryString += subString;
        }
      });
      if (this.contentType.length) queryString += '&contentType=' + this.contentType[0].value;
      this.$http.get('' + queryString, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        var resData = res.body.data.items;
        if (!resData) {
          _this.articles = [];
          return;
        }
        _this.articles = resData;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    removeTag: function removeTag(id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeTagById'
      });
    },
    removeTagConfirmed: function removeTagConfirmed(id) {
      var self = this;
      var thisTag = this.updatedTags.find(function (tag) {
        return tag.id === id;
      });
      this.getTags();
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.tag + '/' + id, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        self.infMsgTitle = thisTag.name + ' topic was successfully deleted.';
        self.infMsgDescription = 'Please note all actions are being logged.';
        self.infMsgClass = 'success';
        self.setInformationMsg({
          isShown: true,
          title: self.infMsgTitle,
          text: self.infMsgDescription,
          className: self.infMsgClass
        });
        for (var i = 0; i < self.tags.length; i++) {
          if (self.tags[i].id === id) {
            self.tags.splice(i, 1);
            break;
          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    handleScroll: function handleScroll(event) {
      var scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
      var fullScrolledValue = window.pageYOffset + window.innerHeight;

      if (fullScrolledValue > scrollHeight - 200) {
        this.fetchAllContentByScroll(++this.contentAutoloadInfo.curPage, 20);
      }
    },
    fetchAllContentByScroll: function fetchAllContentByScroll(page, limit) {
      var _this2 = this;

      if (this.contentAutoloadInfo.locked || this.contentAutoloadInfo.curPage > this.contentAutoloadInfo.numPages) return;
      this.contentAutoloadInfo.locked = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.tags1 + '?limit=' + limit + '&page=' + page, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.contentAutoloadInfo.curPage = res.body.current_page_number;
        _this2.contentAutoloadInfo.numPages = Math.ceil(res.body.total_count / limit);
        _this2.tags = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this2.tags), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.body.items));
        _this2.contentAutoloadInfo.locked = false;
      }).catch(function (err) {
        _this2.contentAutoloadInfo.locked = false;
        console.log(err);
      });
    },
    createTag: function createTag() {
      var _this3 = this;

      if (this.disableAPI) return;
      if (!this.newTag.name) return;
      var formData = new FormData();
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.newTag).forEach(function (fieldName) {
        if (typeof _this3.newTag[fieldName] === 'string' || typeof _this3.newTag[fieldName] === 'number') {
          formData.append('tag[' + fieldName + ']', _this3.newTag[fieldName]);
        }
        if (typeof _this3.newTag[fieldName] === 'boolean') {
          formData.append('tag[' + fieldName + ']', _this3.newTag[fieldName] || '0');
        }
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this3.newTag[fieldName]) === 'object') {
          _this3.newTag[fieldName].forEach(function (item, i) {
            formData.append('tag[' + fieldName + '][' + i + ']', item.value);
          });
        }
      });
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.tag, formData, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.infMsgTitle = _this3.newTag.name + ' topic was successfully added.';
        _this3.infMsgDescription = 'Please note all actions are being logged.';
        _this3.infMsgClass = 'success';
        _this3.setInformationMsg({
          isShown: true,
          title: _this3.infMsgTitle,
          text: _this3.infMsgDescription,
          className: _this3.infMsgClass
        });
        _this3.tags.push(res.body);
        _this3.newTag.name = '';
        _this3.newTag.description = '';
        _this3.newTag.icon = '';
        _this3.newTag.featured = 0;
        _this3.addFormDisplay = false;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log(err);
      });
    },
    showEditionForm: function showEditionForm(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedTags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tag = _step.value;

          if (tag.type === 'edit') tag.type = null;
          if (tag.id === id && tag.type === null) {
            tag.type = 'edit';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    discardСhanges: function discardHanges(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.updatedTags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var tag = _step2.value;

          if (tag.id === id && tag.type === 'edit') {
            tag.type = null;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    editTag: function editTag(id) {
      var _this4 = this;

      if (this.disableAPI) return;
      var tag = this.updatedTags.find(function (tag) {
        return tag.id === id && tag.type === 'edit';
      });
      var formData = {
        tag: {
          name: tag.name,
          description: tag.description,
          icon: tag.icon,
          isActive: tag.isActive,
          featured: tag.featured || 0
        }
      };
      this.disableAPI = true;
      this.$http.put(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.tag + '/' + id, formData, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        _this4.discardСhanges(id);
        for (var i = 0; i < _this4.updatedTags.length; i++) {
          if (_this4.updatedTags[i].id === id && _this4.updatedTags[i].type === 'show') {
            var updatedData = res.body;
            updatedData.type = 'show';
            _this4.updatedTags[i] = updatedData;
            break;
          }
        }
        var infMsg = 'Topic has been successfully updated';
        _this4.setInformationMsg({ text: infMsg, className: 'success' });
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log(err);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])(['getConfData']), {
    filteredTags: function filteredTags() {
      var _this5 = this;

      return this.tags.filter(function (tag) {
        return tag.name.toLowerCase().indexOf(_this5.searchString.toLowerCase()) > -1;
      });
    }
  }),
  watch: {
    filteredTags: function filteredTags() {
      var updatedTags = [];
      this.filteredTags.forEach(function (tag, i, arr) {
        tag.type = 'show';
        updatedTags.push(tag);
        updatedTags.push({
          type: null,
          id: tag.id,
          name: tag.name,
          description: tag.description,
          icon: tag.icon,
          isActive: tag.isActive,
          featured: tag.featured
        });
      });
      this.updatedTags = updatedTags;
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      var actionName = this.getConfData.actionName;
      if (value) {
        switch (actionName) {
          case 'removeTagById':
            this.removeTagConfirmed(this.getConfData.actionId);
            this.clearConfAction();
            break;
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchAllContentByScroll(1, 20);
    this.getTags();
  },
  created: function created() {
    document.title = 'Topics list | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tasks_includes_TaskSingle__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tasks_includes_TaskSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tasks_includes_TaskSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task',
  data: function data() {
    return {
      companyId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])([])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])([])),
  components: {
    TaskSingle: __WEBPACK_IMPORTED_MODULE_1__tasks_includes_TaskSingle___default.a
  },
  created: function created() {
    this.companyId = parseInt(this.$route.params.companyId);
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.companyId !== from.params.companyId) {
        this.companyId = parseInt(to.params.companyId);
      }
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tasks_TasksList__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tasks_TasksList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tasks_TasksList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tasks',
  data: function data() {
    return {
      companyId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])([])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])([])),
  components: {
    TasksList: __WEBPACK_IMPORTED_MODULE_1__tasks_TasksList___default.a
  },
  created: function created() {
    document.title = 'Tasks | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
    this.companyId = parseInt(this.$route.params.companyId);
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.companyId !== from.params.companyId) {
        this.companyId = parseInt(to.params.companyId);
      }
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_common_Select__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users-list',
  data: function data() {
    return {
      ppt: 15,
      offset: 15,
      users: [],
      editedUsers: [],
      selectedAction: null,
      search: '',
      table: '',
      head: '',
      searchByName: '',
      searchEmail: '',
      hoverSearchElements: [],
      company: null,
      role: null,
      lastEdited: null,
      userStatus: [],
      userTitleList: [],
      userRoleList: [],
      userCompanyList: [],
      userStatusList: [],
      job_title: null,
      userType: null,
      userOrderBy: {
        type: 'login',
        order: false
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      confirmation: {
        action: '',
        isShown: false,
        id: null,
        style: {
          top: '100px'
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      datepicker: {
        isShown: false,
        from: null,
        to: null
      },
      statusbar: {
        data: [],
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      windowWidth: window.innerWidth,
      allUserStatuses: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])([
  // 'getRoles',
  // 'getCompanies',
  'setInformationMsg']), {
    fetchAllContentByScroll: function fetchAllContentByScroll(page, limit) {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.users + '?limit=' + limit + '&page=' + page, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.users = res.body.data.items;
        // for (let user in this.users) {
        //   this.checkSubscribe(this.users[user])
        // }
        _this.statusbar.data = res.body.count ? res.body.count : [];
        var query = _this.$route.query;
        if (query && query.role) {
          var role = _this.users.filter(function (x) {
            return x.role.slug === query.role;
          })[0].role;
          _this.role = {
            id: role.id,
            value: role.id,
            label: role.name
          };
        }
        _this.userStatus = [];
        if (query && query.status) {
          var userStatus = _this.allUserStatuses.find(function (item) {
            return item.label.toLowerCase() === query.status.toLowerCase();
          });
          _this.userStatus.push({
            value: userStatus.value,
            label: userStatus.label
          });
        } else {
          var preselectedStatuses = _this.allUserStatuses.filter(function (item) {
            return [0, 1, 7].indexOf(item.value) > -1;
          });
          for (var index in preselectedStatuses) {
            _this.userStatus.push({
              value: preselectedStatuses[index].value,
              label: preselectedStatuses[index].label
            });
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    discardСhanges: function discardHanges(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.editedUsers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var user = _step.value;

          if (user.id === id && user.type === 'edit') {
            user.type = null;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    addHoverElement: function addHoverElement(elements) {
      this.hoverElements = elements;
    },
    addSearchHoverElement: function addSearchHoverElement(type) {
      this.hoverSearchElements = type;
    },
    removeHoverElements: function removeHoverElements() {
      this.hoverElements = [];
    },
    removeSearchHoverElements: function removeSearchHoverElements() {
      this.hoverSearchElements = '';
    },
    isExist: function isExist(element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true;
      }
      var el = this.hoverElements.find(function (item) {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true;
        }
      });
      return !!el;
    },
    isExistInOptions: function isExistInOptions(options) {
      var hoverElement = this.hoverElements.length ? this.hoverElements[0] : {};
      var el = false;
      if (options) {
        el = options.find(function (item) {
          if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
            return true;
          }
        });
      }
      return !!el;
    },
    isExistSearchInOptions: function isExistSearchInOptions(type) {
      var hoverElement = this.hoverSearchElements ? this.hoverSearchElements : '';
      if (hoverElement === type) {
        return true;
      }
    },
    removeSelectedFilters: function removeSelectedFilters(filter) {
      if (this.searchByName) {
        this.searchByName = '';
      }
      if (this.searchEmail) {
        this.searchEmail = '';
      }
      if (this.role && this.role.label === filter.label && this.role.value === filter.value) {
        this.role = null;
      }
      if (this.company && this.company.label === filter.label && this.company.value === filter.value) {
        this.company = null;
      }
      if (this.lastEdited && this.lastEdited.label === filter.label && this.lastEdited.value === filter.value) {
        this.lastEdited = null;
      }
      if (this.userStatus.length && this.userStatus.find(function (item) {
        return item.label === filter.label && item.value === filter.value;
      })) {
        var index = this.userStatus.findIndex(function (item) {
          return item.label === filter.label && item.value === filter.value;
        });
        this.userStatus.splice(index, 1);
      }
      if (this.job_title && this.job_title.label === filter.label) {
        this.job_title = null;
      }
    },
    removeAllFilters: function removeAllFilters() {
      this.searchByName = '';
      this.searchEmail = '';
      this.role = null;
      this.company = null;
      this.job_title = null;
      this.lastEdited = null;
      this.userStatus = [];
    },
    showHideSubMenu: function showHideSubMenu(num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num;
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num;
      }
    },
    hideSubMenuTableHead: function hideSubMenuTableHead(e) {
      this.filerTableHead.selectedCeil = null;
    },
    lastActiveTime: function lastActiveTime(timestamp) {
      if (!timestamp) return '';
      var string = '';
      var loginAt = new Date(timestamp);
      var now = new Date();
      var difference = Math.floor((+now - +loginAt) / (1000 * 60 * 60));
      if (difference < 1) {
        string += 'less than 1 hour ago';
      } else if (difference >= 1 && difference < 24) {
        string += difference + ' hours ago';
      } else {
        string += this.convertDate(timestamp, '.');
      }
      return string;
    },
    convertDate: function convertDate(payload, delimetr) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear;
    },
    changeOrderBy: function changeOrderBy(type, order) {
      this.userOrderBy = {
        type: type,
        order: this.userOrderBy !== null ? !this.userOrderBy.order : order
      };
    },
    goToUserEdit: function goToUserEdit(id) {
      var props = this.$router.resolve({
        name: this.getUserRole === 'gm' ? 'edit-user' : 'ca-edit-user',
        params: { id: id }
      });
      this.$router.push(props.href);
    },
    loadMore: function loadMore() {
      this.offset = this.offset + this.ppt;
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    getDeviceType: function getDeviceType(check) {
      var width = this.windowWidth;
      var deviceName = '';
      if (width >= 940) {
        deviceName = 'desktop';
      } else if (width >= 480) {
        deviceName = 'tablet';
      } else {
        deviceName = 'mobile';
      }
      return check === deviceName;
    },
    getTabletFiltersAppliedText: function getTabletFiltersAppliedText() {
      var filterAppliedText = 'Apply Filters';
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.editedUsers.length + ' results';
      }
      return filterAppliedText;
    },
    getUserStatuses: function getUserStatuses() {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.userStatuses, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.allUserStatuses = res.body;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getUserStatus: function getUserStatus(user) {
      return this.allUserStatuses.find(function (item) {
        return item.value === user.status;
      });
    },
    csvExport: function csvExport(arrData) {
      var csvContent = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(arrData[0]).map(function (item) {
        return '"' + item + '"';
      }).join(',')].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(arrData.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(item).map(function (item) {
          return '"' + item + '"';
        }).join(',');
      }))).join('\n').replace(/(^\[)|(\]$)/gm, '');

      var csvData = new Blob([csvContent], {
        type: 'application/csv;charset=utf-8;'
      });

      if (window.navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, 'users-export.csv');
      } else {
        var csvUrl = URL.createObjectURL(csvData);
        var link = document.getElementById('csvDownload');
        link.setAttribute('href', csvUrl);
        link.setAttribute('download', 'users-export.csv');
        link.click();
      }
    },
    checkSubscribe: function checkSubscribe(user) {
      this.$http.get(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].URLS.checkSubscribe + '/' + user.email, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].headersAuthSettings).then(function (res) {
        user.subscribed = res.body;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])(['getUserRole']), {
    csvData: function csvData() {
      var dataForExport = this.filteredUsers;
      var self = this;
      var data = dataForExport.map(function (item) {
        var status = self.getUserStatus(item);
        var gdpr = item.consent_status === 1 ? 'Accepted' : 'Not accepted';
        var newItem = {
          'First name': item.first_name ? item.first_name : 'n/a',
          'Last name': item.last_name ? item.last_name : 'n/a',
          'Email': item.email,
          'Company': item.company ? item.company.name : 'n/a',
          'Role': item.role ? item.role.name : 'n/a',
          'GDPR': gdpr,
          'Status': status ? status.label : 'n/a'
        };
        return newItem;
      });

      return data;
    },
    getStatusesForSelect: function getStatusesForSelect() {
      return this.allUserStatuses;
    },
    getCompaniesForSelect: function getCompaniesForSelect() {
      return this.userCompanyList;
    },
    getRolesForSelect: function getRolesForSelect() {
      return this.userRoleList;
    },
    getTitlesForSelect: function getTitlesForSelect() {
      return this.userTitleList;
    },
    filteredUsers: function filteredUsers() {
      var _this3 = this;

      var result = this.users;
      result = this.users.filter(function (user) {
        return (user.id + ' ' + user.first_name + ' ' + user.last_name).toLowerCase().indexOf(_this3.searchByName.toLowerCase()) > -1;
      }).filter(function (user) {
        return (user.email ? user.email : '').toLowerCase().indexOf(_this3.searchEmail.toLowerCase()) > -1;
      }).filter(function (user) {
        return _this3.company === null || user.company && user.company.id === _this3.company.value;
      }).filter(function (user) {
        return _this3.role === null || user.role && user.role.id === _this3.role.value;
      }).filter(function (user) {
        return !_this3.userStatus.length || _this3.userStatus.find(function (item) {
          return item.value === user.status;
        });
      }).filter(function (user) {
        return _this3.job_title === null || user.job_title === _this3.job_title.label;
      });
      if (this.userOrderBy !== null) {
        var ascDesc = this.userOrderBy.order ? 1 : -1;
        if (this.userOrderBy.type === 'login') {
          return result.sort(function (a, b) {
            var firstDate = a.last_login !== undefined ? new Date(a.last_login) : '';
            var secondDate = b.last_login !== undefined ? new Date(b.last_login) : '';
            return ascDesc * (firstDate - secondDate);
          });
        } else {
          return result.sort(function (a, b) {
            var firstDate = a.created !== undefined ? new Date(a.created) : '';
            var secondDate = b.created !== undefined ? new Date(b.created) : '';
            return ascDesc * (firstDate - secondDate);
          });
        }
      } else {
        return result;
      }
    },
    usersSum: function usersSum() {
      var count = 0;
      if (this.getUserRole === 'gm') {
        this.statusbar.data.forEach(function (item) {
          count = count + +item.c;
        });
      } else {
        count = this.users.length;
      }
      return count;
    },
    selectedFilters: function selectedFilters() {
      var filters = [];
      if (this.searchByName) {
        filters.push({
          id: null,
          type: 'name',
          label: this.searchByName
        });
      }
      if (this.searchEmail) {
        filters.push({
          id: null,
          type: 'email',
          label: this.searchEmail
        });
      }
      if (this.company) {
        filters.push(this.company);
      }
      if (this.role) {
        filters.push(this.role);
      }
      if (this.job_title) {
        filters.push(this.job_title);
      }
      if (this.lastEdited) {
        filters.push(this.lastEdited);
      }
      if (this.userStatus) {
        for (var index in this.userStatus) {
          filters.push(this.userStatus[index]);
        }
      }
      return filters;
    }
  }),
  watch: {
    filteredUsers: function filteredUsers() {
      var _this4 = this;

      var editedUsers = [];
      this.offset = this.ppt;
      this.userTitleList = [];
      this.userRoleList = [];
      this.userCompanyList = [];
      this.userStatusList = [];
      this.filteredUsers.forEach(function (user) {
        user.type = 'show';
        if (user.company) {
          var index = _this4.userCompanyList.findIndex(function (x) {
            return x.label === user.company.name;
          });
          if (index === -1) {
            _this4.userCompanyList.push({
              id: user.company.id,
              label: user.company.name,
              value: user.company.id
            });
          }
        }
        if (user.role) {
          var _index = _this4.userRoleList.findIndex(function (x) {
            return x.label === user.role.name;
          });
          if (_index === -1) {
            _this4.userRoleList.push({
              id: user.role.id,
              label: user.role.name,
              value: user.role.id,
              slug: user.role.slug
            });
          }
        }
        if (user.job_title) {
          var _index2 = _this4.userTitleList.findIndex(function (x) {
            return x.label === user.job_title;
          });
          if (_index2 === -1) {
            _this4.userTitleList.push({
              label: user.job_title,
              value: user.job_title
            });
          }
        }
        editedUsers.push(user);
      });
      this.editedUsers = editedUsers;
    },
    'confirmation.isShown': function confirmationIsShown(value) {
      if (value) {
        this.confirmation.style.top = window.pageYOffset - 100 + 'px';
      }
    }
  },
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_7__components_admin_common_Select___default.a
  },
  created: function created() {
    document.title = 'All users | Clear Assured';
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name === 'ca-users' ? 'DASHBOARD_AREA' : 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  beforeMount: function beforeMount() {
    this.getUserStatuses();
  },
  mounted: function mounted() {
    this.fetchAllContentByScroll(1, 3000);
    // this.getRoles()
    // this.getCompanies()
    document.addEventListener('click', this.hideSubMenuTableHead);
    window.addEventListener('resize', this.handleWindowResize);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  destroyed: function destroyed() {
    document.addEventListener('click', this.hideSubMenuTableHead);
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'account-suspended',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['profile']), {
    expiryDate: function expiryDate() {
      if (!this.profile || !this.profile.company || !this.profile.company.subscription_end) {
        return '';
      }
      var expiryOn = new Date(this.profile.company.subscription_end);
      if (isNaN(this.profile.company.subscription_end) || isNaN(Date.parse(this.profile.company.subscription_end))) {
        return '';
      }
      var dd = String(expiryOn.getDate()).padStart(2, '0');
      var mm = String(expiryOn.getMonth() + 1).padStart(2, '0');
      var yyyy = expiryOn.getFullYear();
      return dd + '.' + mm + '.' + yyyy;
    },
    billingContact: function billingContact() {
      if (!this.profile || !this.profile.company) {
        return '';
      }
      return [this.profile.company.billing_first_name || '', this.profile.company.billing_last_name || ''].filter(function (n) {
        return n.trim() !== '';
      }).join(' ');
    },
    billingEmail: function billingEmail() {
      if (!this.profile || !this.profile.company) {
        return '';
      }
      return this.profile.company.billing_email;
    },
    billingPhone: function billingPhone() {
      if (!this.profile || !this.profile.company) {
        return '';
      }
      return this.profile.company.billing_phone;
    },
    canRenew: function canRenew() {
      if (!this.profile) {
        return false;
      }
      return this.profile.role.slug === 'ca';
    }
  }),
  data: function data() {
    return {};
  },

  watch: {
    profile: function profile(value) {
      if (value && value.company) {
        if (!value.company.suspended) {
          this.$router.push('/');
        }
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['getUser'])),
  created: function created() {
    document.title = 'Clear Assured – account suspended';
  },
  mounted: function mounted() {
    this.getUser();
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'activate-company',
  props: ['token'],
  data: function data() {
    return {
      resetInProgress: false,
      emailValidCode: 0, // 0 - needs validation, 1 - valid, 2 - validated, 3 - invalid token, 4 - invalid token and email, 5 - new activate link requested
      redirectCountDown: 10,
      resendActivationLinkForm: {
        email: '',
        emailFocus: false,
        requestInProgress: false
      }
    };
  },

  methods: {
    activateAccountByToken: function activateAccountByToken() {
      var _this = this;

      this.$http.post('' + __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].URLS.activateCompany + this.token).then(function (res) {
        _this.emailValidCode = res.body.code;
        if (_this.emailValidCode === 1 || _this.emailValidCode === 2) {
          _this.runCountDownRedirect();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    resendActivationToken: function resendActivationToken() {
      var _this2 = this;

      this.resendActivationLinkForm.requestInProgress = true;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this2.resendActivationLinkForm.requestInProgress = false;
          return;
        }
        var data = {
          email: _this2.resendActivationLinkForm.email
        };
        _this2.$http.post(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].URLS.resetCompanyActivationToken, data).then(function (res) {
          _this2.emailValidCode = res.body.code;
          _this2.resendActivationLinkForm.requestInProgress = false;
          window.scrollTo(0, 0);
        }).catch(function () {
          _this2.resendActivationLinkForm.requestInProgress = false;
          _this2.emailValidCode = 4;
        });
      });
    },
    runCountDownRedirect: function runCountDownRedirect() {
      var _this3 = this;

      var interval = setInterval(function () {
        _this3.redirectCountDown--;
        if (_this3.redirectCountDown === 0) {
          clearInterval(interval);
          _this3.$router.push({ name: 'login' });
        }
      }, 1000);
    }
  },
  created: function created() {
    document.title = 'Clear Assured – activate your company account';
  },
  mounted: function mounted() {
    this.activateAccountByToken();
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'callback-request',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      activePopup: null,
      registerForm: {
        name: '',
        surname: '',
        jobTitle: '',
        companyName: '',
        email: '',
        phone: '',
        message: '',
        terms: false,
        privacy: false,
        nameFocus: false,
        surnameFocus: false,
        jobTitleFocus: false,
        companyNameFocus: false,
        emailFocus: false,
        phoneFocus: false,
        messageFocus: false
      },
      confOpened: null,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'initConfAction', 'redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      var pageData = {
        slug: 'callback-request',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content)
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        _this.disableAPI = false;
        _this.getLandingPage(null, true);
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var pageData = {
        title: this.metaData.title,
        slug: 'callback-request',
        description: this.metaData.description
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this3 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/callback-request', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.pageVersions = [];
        for (var index in res.body) {
          if (!res.body.hasOwnProperty(index)) {
            return;
          }
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this3.editHistory = true;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    getLandingPage: function getLandingPage(id, refresh) {
      var _this4 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'callback-request'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/callback-request', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        if (pageData.footerData) {
          _this4.content.footerData = pageData.footerData;
        }
        if (pageData.heroSection) {
          _this4.content.heroSection = pageData.heroSection;
        }
        if (res.data.logo) {
          _this4.landing.logo = res.data.logo;
        }
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title;
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        _this4.content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.content, pageData);
        if (id) {
          _this4.pageEditSwitch();
        } else {
          if (refresh) {
            _this4.pageEditMode = false;
          }
        }
        if (_this4.$route.name === 'edit-callback-request') {
          _this4.$nextTick(function () {
            _this4.autoSizeOnInit();
          });
        }
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        if (!data.hasOwnProperty(index)) {
          return;
        }
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage(null, true);
    },
    pageEditSwitch: function pageEditSwitch() {
      this.confOpened = 'edit';
      this.initConfAction({
        actionName: 'editLanding'
      });
    },
    pageEditSwitchConfirmed: function pageEditSwitchConfirmed() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
      this.getConfData.actionConfirmed = false;
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload && payload !== '') {
        return true;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    closePopup: function closePopup() {
      var _this6 = this;

      this.activePopup = null;
      this.pageMetaEdit = false;
      this.$nextTick(function () {
        if (_this6.$refs.slick) {
          _this6.$refs.slick.reSlick();
        }
      });
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      return userRole === 'gm';
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    submitCallbackRequest: function submitCallbackRequest() {
      var _this7 = this;

      this.formStatus.submitting = true;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this7.formStatus.submitting = false;
          setTimeout(function () {
            _this7.scrollToTheMessage();
          }, 100);
          return;
        }
        var data = {
          name: _this7.registerForm.name,
          surname: _this7.registerForm.surname,
          jobTitle: _this7.registerForm.jobTitle,
          companyName: _this7.registerForm.companyName,
          email: _this7.registerForm.email,
          phone: _this7.registerForm.phone,
          message: _this7.registerForm.message,
          terms: _this7.registerForm.terms,
          privacy: _this7.registerForm.privacy,
          type: 1
        };
        _this7.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.callbackRequest, data).then(function () {
          _this7.formStatus.submitting = false;
          _this7.formStatus.shown = true;
          _this7.formStatus.success = true;
          _this7.formStatus.title = 'You have successfully submitted your callback request.';
          _this7.formStatus.body = 'Thank you for getting in touch. We usually reply to the callback request in maximum 24 hours from when it was submitted to us. If your inquiry is urgent, please give us a call.';
          _this7.registerForm.name = '';
          _this7.registerForm.surname = '';
          _this7.registerForm.jobTitle = '';
          _this7.registerForm.companyName = '';
          _this7.registerForm.email = '';
          _this7.registerForm.phone = '';
          _this7.registerForm.message = '';
          _this7.registerForm.terms = false;
          _this7.registerForm.privacy = false;
          setTimeout(function () {
            _this7.scrollToTheMessage();
            _this7.errors.clear();
          }, 100);
        }).catch(function (err) {
          _this7.formStatus.submitting = false;
          _this7.serverValidation.errors = err;
          _this7.disableAPI = false;
          _this7.formStatus.shown = true;
          _this7.formStatus.success = false;
          _this7.formStatus.title = err.body.message || 'Your callback request was not submitted.';
          _this7.formStatus.body = 'It looks like there was an error and your callback request could not be sent. Please try again or give us a call and we\'ll have our support team help you.';
          setTimeout(function () {
            _this7.scrollToTheMessage();
          }, 100);
        });
      });
    },
    scrollToTheMessage: function scrollToTheMessage() {
      var elem = document.querySelector('.tcc-form-message');
      if (elem) {
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    setupRightHeroStickyTopPosition: function setupRightHeroStickyTopPosition() {
      var header = document.querySelector('header.app-header .app-header-main');
      var stickyDiv = document.querySelector('.hero-section .right-content');
      if (header && stickyDiv) {
        var rect = header.getBoundingClientRect();
        stickyDiv.style.top = rect.height / 16 + 'rem';
      }
    },
    heroImageHeightFix: function heroImageHeightFix() {
      var imageContainer = document.querySelector('.hero-section .right-content');
      var image = document.querySelector('.hero-section .hero-image');
      var header = document.querySelector('header');
      var maxHeight = window.innerHeight;
      if (header) {
        maxHeight -= header.offsetHeight;
      }
      if (imageContainer && image) {
        imageContainer.style.height = maxHeight + 'px';
        image.style.maxHeight = maxHeight + 'px';
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    this.heroImageHeightFix();
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('resize', this.setupRightHeroStickyTopPosition);
    window.addEventListener('resize', this.heroImageHeightFix);
    window.addEventListener('scroll', this.setupRightHeroStickyTopPosition);
    if (this.$route.name === 'edit-register') {
      this.pageEditMode = true;
      this.landingPanel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('resize', this.setupRightHeroStickyTopPosition);
    window.removeEventListener('resize', this.heroImageHeightFix);
    window.removeEventListener('scroll', this.setupRightHeroStickyTopPosition);
  },

  components: {},
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'edit') this.pageEditSwitchConfirmed();
        this.clearConfAction();
      }
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plans_PlansList__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plans_PlansList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__plans_PlansList__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'complete-profile',
  data: function data() {
    return {
      formReady: false,
      currentStep: 0,
      currentRealStep: 0,
      submitting: false,
      steps: [{
        name: 'Finish your profile'
      }, {
        name: 'Organisation profile'
      }, {
        name: 'Billing details'
      }, {
        name: 'Plan summary'
      }, {
        name: 'Payment'
      }],
      profileData: {
        user: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          function: null,
          jobTitle: ''
        },
        organisation: {
          name: '',
          size: null,
          industrySector: null,
          marketplace: '',
          industry: null
        },
        billing: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          organisationName: '',
          organisationType: null,
          organisationVat: '',
          addressCountry: null,
          addressCity: '',
          addressCounty: '',
          addressPostalCode: '',
          addressStreet: ''
        },
        plan: {
          marketplace: true
        },
        payment: {
          method: 0,
          cardNumber: '',
          cardType: '',
          cardExpiryMonth: '',
          cardExpiryYear: '',
          cardCvc: '',
          termsOfService: false,
          termsOfServiceAccepted: null,
          paymentAreaActivated: false,
          error: false
        },
        quote: null
      },
      currentPlan: null,
      temporaryVariation: null,
      selectedVariation: null,
      registrationCompleted: false,
      planChanged: false,
      noPlans: false,
      manualNavigation: false,
      quoteDownloadActioned: false,
      quoteDownloading: false,
      renewSubscription: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['profile', 'companySizes', 'userFunctionalAreas', 'userIndustrySectors', 'companyOrganizationTypes', 'countries']), {
    stripeElements: {
      get: function get() {
        return this.$stripe.elements();
      },
      set: function set(payload) {
        return payload;
      }
    },
    paymentMethods: {
      get: function get() {
        return [{
          label: 'Pay by Card',
          value: 0
        }, {
          label: 'Pay by Bank Transfer',
          value: 1
        }];
      },
      set: function set(payload) {
        return payload;
      }
    },
    companyVariation: function companyVariation() {
      return this.temporaryVariation || this.selectedVariation;
    },
    currentPlanCommitment: function currentPlanCommitment() {
      if (!this.currentPlan) {
        return '';
      }
      var text = void 0;
      if (this.currentPlan.commitment === 1) {
        text = '1 Year';
      } else if (this.currentPlan.commitment === 3) {
        text = '3 Years';
      } else {
        text = 'No commitment';
      }
      return text;
    },
    commitmentExpiryDate: function commitmentExpiryDate() {
      if (!this.currentPlan) {
        return '';
      }
      var date = new Date();
      if (this.currentPlan.commitment === 1) {
        date = new Date(date.setFullYear(date.getFullYear() + 1));
      } else if (this.currentPlan.commitment === 3) {
        date = new Date(date.setFullYear(date.getFullYear() + 3));
      } else {
        return this.nextPaymentDate;
      }
      var dd = String(date.getDate() - 1).padStart(2, '0');
      var mm = String(date.getMonth() + 1).padStart(2, '0');
      var yyyy = date.getFullYear();
      return dd + '.' + mm + '.' + yyyy;
    },
    currentPlanPaymentPeriod: function currentPlanPaymentPeriod() {
      console.log(this.currentPlan);
      if (!this.currentPlan) {
        return '';
      }
      if (this.currentPlan.paymentPeriodUnit === 0) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          return 'Monthly';
        } else {
          return 'Every ' + this.currentPlan.paymentPeriodValue + ' months';
        }
      } else if (this.currentPlan.paymentPeriodUnit === 1) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          return 'Yearly';
        } else {
          return ' Every ' + this.currentPlan.paymentPeriodValue + ' years';
        }
      }
    },
    currentPlanSubscriptionPaymentPeriod: function currentPlanSubscriptionPaymentPeriod() {
      if (!this.currentPlan) {
        return '';
      }
      var text = '';
      if (this.currentPlan.paymentPeriodUnit === 0) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          text = '1 month';
        } else {
          text = this.currentPlan.paymentPeriodValue + ' months';
        }
      } else if (this.currentPlan.paymentPeriodUnit === 1) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          text = '1 year';
        } else {
          text = this.currentPlan.paymentPeriodValue + ' years';
        }
      }
      return text;
    },
    nextPaymentDate: function nextPaymentDate() {
      if (!this.currentPlan) {
        return '';
      }
      var nowDate = new Date();
      if (this.currentPlan.paymentPeriodUnit === 0) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          nowDate.setMonth(nowDate.getMonth() + 1);
        } else {
          nowDate.setMonth(nowDate.getMonth() + this.currentPlan.paymentPeriodValue);
        }
      } else if (this.currentPlan.paymentPeriodUnit === 1) {
        if (this.currentPlan.paymentPeriodValue === 1) {
          nowDate.setFullYear(nowDate.getFullYear() + 1);
        } else {
          nowDate.setFullYear(nowDate.getFullYear() + this.currentPlan.paymentPeriodValue);
        }
      }
      var dd = String(nowDate.getDate() - 1).padStart(2, '0');
      var mm = String(nowDate.getMonth() + 1).padStart(2, '0');
      var yyyy = nowDate.getFullYear();
      return dd + '-' + mm + '-' + yyyy;
    },
    currentPlanSize: function currentPlanSize() {
      var _this = this;

      if (!this.currentPlan) {
        return '';
      }
      var size = this.companySizes.find(function (s) {
        return s.min === _this.currentPlan.minSize;
      });
      return size ? size.label : '';
    },
    filteredCompanySizes: function filteredCompanySizes() {
      var _this2 = this;

      if (!this.companySizes) {
        return null;
      }
      if (!this.temporaryVariation) {
        return this.companySizes;
      }
      return this.companySizes.filter(function (c) {
        var sizes = c.label.match(/\d+/g);
        return sizes && sizes.length ? sizes[0] >= _this2.temporaryVariation.minSize : true;
      });
    },
    vatDisplay: function vatDisplay() {
      if (this.profileData.billing.addressCountry && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.profileData.billing.addressCountry) === 'object') {
        return this.profileData.billing.addressCountry.label.toLowerCase() === 'united kingdom';
      }
      return true;
    },
    planPrice: function planPrice() {
      // if (!this.currentPlan.price) {
      //   return ''
      // }
      // if (!this.vatDisplay) {
      //   return parseFloat(this.currentPlan.price).toFixed(2)
      // }
      // return parseFloat((parseFloat(this.currentPlan.price) + (parseFloat(this.currentPlan.price) * 0.2)).toString()).toFixed(2)
      return this.currentPlan.price || '';
    },
    stripeBillingUrl: function stripeBillingUrl() {
      var url = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].billingServerURL + '/stripe-payment/' + this.profile.company.id + '?check=0dce2bbbc190a8efb559d6dc892f677c';
      var voucher = sessionStorage.getItem('voucher');
      if (voucher) {
        url += '&voucher=' + voucher;
      }
      return url;
    },
    preSelectedSize: function preSelectedSize() {
      var _this3 = this;

      var size = this.companySizes.find(function (s) {
        return s.value === _this3.profile.company.company_size.id;
      });
      return size || null;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['getUser', 'getCompanySizes', 'getCompanyOrganizationTypes']), {
    synchroniseData: function synchroniseData() {
      var _this4 = this;

      if (!this.profile) {
        return;
      }

      // if (this.registrationCompleted && this.profile.company.activation_step <= 4) {
      //   let props = this.$router.resolve({
      //     name: 'company-profile'
      //   })
      //   this.$router.push(props.href)
      // }

      if (!this.manualNavigation) {
        this.currentStep = this.profile.company.activation_step !== null ? this.profile.company.activation_step : 0;
      }

      this.currentRealStep = this.profile.company.activation_step !== null ? this.profile.company.activation_step : 0;

      this.profileData.user.firstName = this.profile.first_name;
      this.profileData.user.lastName = this.profile.last_name;
      this.profileData.user.email = this.profile.email;
      this.profileData.user.phone = this.profile.phone || '';
      this.profileData.user.jobTitle = this.profile.job_title || '';

      this.profileData.organisation.name = this.profile.company.name;

      if (this.profile.company.company_size) {
        this.profileData.organisation.size = {
          label: this.profile.company.company_size.name,
          value: this.profile.company.company_size.id
        };
      }

      if (this.profile.company.industry_sector) {
        this.profileData.organisation.industrySector = {
          label: this.profile.company.industry_sector,
          value: this.profile.company.industry_sector
        };
      }

      if (this.profile.function) {
        this.profileData.user.function = {
          label: this.profile.function,
          value: this.profile.function
        };
      }

      this.profileData.organisation.marketplace = this.profile.company.marketplace;
      this.profileData.organisation.industry = this.profile.company.industry ? this.profile.company.industry.id : null;

      this.profileData.billing.firstName = this.profile.company.billing_first_name || this.profile.first_name;
      this.profileData.billing.lastName = this.profile.company.billing_last_name || this.profile.last_name;
      this.profileData.billing.email = this.profile.company.billing_email || this.profile.email;
      this.profileData.billing.phone = this.profile.company.billing_phone || this.profile.phone;

      this.profileData.billing.organisationName = this.profile.company.billing_company_name || this.profile.company.name;
      this.profileData.billing.organisationVat = this.profile.company.billing_company_vat || '';
      this.profileData.billing.addressCountry = this.profile.company.billing_address_country ? this.countries.find(function (c) {
        return c.label === _this4.profile.company.billing_address_country;
      }) : null;
      this.profileData.billing.addressCity = this.profile.company.billing_address_city || '';
      this.profileData.billing.addressCounty = this.profile.company.billing_address_county || '';
      this.profileData.billing.addressPostalCode = this.profile.company.billing_address_postal_code || '';
      this.profileData.billing.addressStreet = this.profile.company.billing_address_street || '';

      if (this.profile.company.billing_company_type) {
        this.profileData.billing.organisationType = {
          label: this.profile.company.billing_company_type,
          value: this.profile.company.billing_company_type
        };
      }

      if (this.profile.company.plan_voucher) {
        sessionStorage.setItem('voucher', this.profile.company.plan_voucher);
      }

      this.profileData.payment.method = this.profile.company.payment_method !== null ? this.profile.company.payment_method : 0;

      this.formReady = true;

      if (this.currentRealStep === 5 && !this.profile.company.is_temporary) {
        this.profileData.payment.method = this.profile.company.payment_method !== null ? this.profile.company.payment_method : 0;
        this.registrationCompleted = true;
        if (this.profileData.payment.method === 1) {
          this.getQuote();
        }
      }
    },
    getQuote: function getQuote() {
      var _this5 = this;

      this.quoteDownloading = true;
      this.$http.get('' + __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.companyQuote, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.profileData.quote = res.body.quote || null;
        _this5.quoteDownloading = false;
      }).catch(function (error) {
        _this5.quoteDownloading = false;
        console.log(error);
      });
    },
    downloadQuote: function downloadQuote() {
      this.quoteDownloadActioned = true;
      if (!this.profileData.quote || !this.profileData.quote.file) {
        this.quoteDownloadActioned = false;
        return;
      }
      var a = document.createElement('a');
      a.href = 'data:application/pdf;base64,' + this.profileData.quote.file.data;
      a.download = this.profileData.quote.file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.quoteDownloadActioned = false;
    },
    paymentIframeActioned: function paymentIframeActioned() {
      this.$validator.validateAll(['Terms of service']).then(function (success) {
        if (!success) {
          // const termsOfService = document.getElementById('complete-profile-terms-of-service')
          // if (termsOfService) {
          //   termsOfService.scrollIntoView({
          //     behavior: 'auto',
          //     block: 'center',
          //     inline: 'center'
          //   })
          // }
        }
      });
    },
    preSubmitData: function preSubmitData() {
      var _this6 = this;

      if (this.currentStep === 0) {
        this.$validator.validateAll(['First name', 'Last name', 'Email', 'Phone number', 'Functional area', 'Job title']).then(function (success) {
          if (!success) {
            return;
          }
          _this6.submitData();
        });
      } else if (this.currentStep === 1) {
        this.$validator.validateAll(['Organisation name', 'Organisation size', 'Industry sector', 'Clear Assured marketplace']).then(function (success) {
          if (!success) {
            return;
          }
          _this6.submitData();
        });
      } else if (this.currentStep === 2) {
        this.$validator.validateAll(['Billing first name', 'Billing last name', 'Billing email', 'Billing phone number', 'Billing organisation name', 'Billing organisation type', 'VAT', 'Country', 'City', 'County/State', 'Street address', 'Postcode']).then(function (success) {
          if (!success) {
            return;
          }
          _this6.submitData();
        });
      } else if (this.currentStep === 3) {
        this.submitData();
      } else if (this.currentStep === 4) {
        if (this.profileData.payment.method === 0) {
          this.$validator.validateAll(['Terms of service']).then(function (success) {
            if (!success) {
              _this6.profileData.payment.error = 'Invalid data';
              return;
            }
            _this6.submitData();
          });
        } else {
          this.submitData();
        }
      }
    },
    submitData: function submitData() {
      var _this7 = this;

      if (this.submitting) {
        return;
      }
      var data = {
        step: this.currentStep
      };
      var voucher = sessionStorage.getItem('voucher');
      if (this.currentStep === 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
          firstName: this.profileData.user.firstName,
          lastName: this.profileData.user.lastName,
          phone: this.profileData.user.phone,
          function: this.profileData.user.function.value,
          jobTitle: this.profileData.user.jobTitle
        });
      } else if (this.currentStep === 1) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
          organisationName: this.profileData.organisation.name,
          organisationSize: this.profileData.organisation.size.value,
          organisationIndustrySector: this.profileData.organisation.industrySector.value,
          marketplace: this.profileData.organisation.marketplace,
          industry: this.profileData.organisation.industry
        });
      } else if (this.currentStep === 2) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
          firstName: this.profileData.billing.firstName,
          lastName: this.profileData.billing.lastName,
          email: this.profileData.billing.email,
          phone: this.profileData.billing.phone,
          organisationName: this.profileData.billing.organisationName,
          organisationType: this.profileData.billing.organisationType.label,
          organisationVat: this.profileData.billing.organisationVat,
          addressCountry: this.profileData.billing.addressCountry ? this.profileData.billing.addressCountry.label : '',
          addressCity: this.profileData.billing.addressCity,
          addressCounty: this.profileData.billing.addressCounty,
          addressStreet: this.profileData.billing.addressStreet,
          addressPostalCode: this.profileData.billing.addressPostalCode,
          voucher: voucher
        });
      } else if (this.currentStep === 3) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
          variation: this.selectedVariation.id,
          voucher: voucher
        });
      } else if (this.currentStep === 4) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
          method: this.profileData.payment.method,
          termsOfService: this.profileData.payment.termsOfService
        });
      }
      this.submitting = true;
      this.$http.post('' + __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.completeCompanyProfile, data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (_this7.renewSubscription && _this7.currentStep === 4 && _this7.profileData.payment.method === 0) {
          var props = _this7.$router.resolve({
            name: 'billing-profile',
            query: {
              paid: true
            }
          });
          location.href = props.href;
          return;
        }
        _this7.getUser();
        // if (this.currentStep === 4) {
        //   this.registrationCompleted = true
        //   if (this.profileData.payment.method === 0) {
        //     this.registrationCompleted = true
        //   } else {
        //     let props = this.$router.resolve({
        //       name: 'company-profile'
        //     })
        //     this.$router.push(props.href)
        //   }
        // }
        _this7.scrollTop();
        if (_this7.manualNavigation) {
          _this7.currentStep += 1;
        }
        _this7.submitting = false;
      }).catch(function () {
        _this7.scrollTop();
        _this7.submitting = false;
      });
    },
    activatePaymentArea: function activatePaymentArea() {
      this.paymentIframeActioned();
      if (!this.profileData.payment.termsOfService) {
        return;
      }
      this.profileData.payment.paymentAreaActivated = true;
      if (this.profileData.payment.method === 0) {
        this.profileData.payment.termsOfServiceAccepted = new Date();
      } else {
        this.preSubmitData();
      }
    },
    convertDateTime: function convertDateTime(payload) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      var text = dateString;
      if (includeTime) {
        text += ' ' + timeString;
      }
      return text;
    },
    scrollTop: function scrollTop() {
      this.manualNavigation = true;
      setTimeout(function () {
        var element = document.querySelector('header');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    },
    previousStep: function previousStep() {
      this.manualNavigation = true;
      if (this.currentStep > 0) {
        this.currentStep--;
      }
      this.scrollTop();
    },
    activateStep: function activateStep(step) {
      this.manualNavigation = true;
      if (step === 3) {
        this.noPlans = false;
      }
      if (step > this.currentRealStep) {
        return;
      }
      this.currentStep = step;
    },
    planSelected: function planSelected(event) {
      this.selectedVariation = event.variation;
      if (this.selectedVariation) {
        this.preSubmitData();
      }
    },
    plansLoaded: function plansLoaded(event) {
      var _this8 = this;

      if (!event || !event.length) {
        this.noPlans = true;
        return;
      }
      this.noPlans = !event.some(function (p) {
        return p.variations.length > 0;
      });
      if (!this.temporaryVariation) {
        return;
      }
      this.planChanged = !event.some(function (p) {
        return p.variations.some(function (v) {
          return v.id === _this8.temporaryVariation.id;
        });
      });
    },
    getTemporaryVariation: function getTemporaryVariation() {
      var _this9 = this;

      if (!this.profile || !this.profile.company || !this.profile.company.plan_variation) {
        return;
      }
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.variation + '/temporary/' + this.profile.company.plan_variation, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this9.temporaryVariation = res.body.variation || null;
        if (_this9.temporaryVariation) {
          if (_this9.temporaryVariation.marketplace) {
            _this9.profileData.organisation.marketplace = _this9.temporaryVariation.marketplace.name;
            _this9.profileData.organisation.industry = _this9.temporaryVariation.marketplace.industry;
          } else {
            _this9.profileData.organisation.marketplace = '';
            _this9.profileData.organisation.industry = null;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCompanyVariation: function getCompanyVariation() {
      var _this10 = this;

      if (!this.profile || !this.profile.company || !this.profile.company.id) {
        return;
      }
      var data = {};
      var voucher = sessionStorage.getItem('voucher');
      if (voucher) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
          voucher: voucher
        });
      }
      this.currentPlan = null;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.variation + '/company/' + this.profile.company.id, data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        if (!res.body.hasOwnProperty('success')) {
          _this10.currentPlan = res.body;
          if (_this10.currentPlan.marketplace) {
            _this10.profileData.organisation.marketplace = _this10.currentPlan.marketplace.name;
            _this10.profileData.organisation.industry = _this10.currentPlan.marketplace.industry;
          } else {
            _this10.profileData.organisation.marketplace = '';
            _this10.profileData.organisation.industry = null;
          }
        }
      }).catch(function () {
        _this10.currentPlan = null;
      });
    },
    changeCompanyPaymentType: function changeCompanyPaymentType() {
      var data = {
        paymentType: this.profileData.payment.method
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.companiesS + '/change-company-payment-type', data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {}).catch(function () {});
    }
  }),
  watch: {
    profile: function profile() {
      this.synchroniseData();
      this.getCompanyVariation();
      this.getTemporaryVariation();
    },
    currentStep: function currentStep(value) {
      // this.noPlans = true
      if (value === 3) {
        this.noPlans = false;
        this.getTemporaryVariation();
      }
      if (value === 4) {
        this.getCompanyVariation();
      }
    },
    'profileData.payment.method': function profileDataPaymentMethod() {
      this.profileData.payment.termsOfService = false;
      this.profileData.payment.paymentAreaActivated = false;
      this.changeCompanyPaymentType();
    }
  },
  components: {
    PlansList: __WEBPACK_IMPORTED_MODULE_5__plans_PlansList___default.a
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {
    var _this11 = this;

    document.title = 'Clear Assured – complete your profile';
    this.renewSubscription = this.$route.meta.renewSubscription || false;
    var myEventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var myEventListener = window[myEventMethod];
    var myEventMessage = myEventMethod === 'attachEvent' ? 'onmessage' : 'message';
    myEventListener(myEventMessage, function (e) {
      var iframe = document.getElementById('stripePaymentIframe');
      if (!iframe) {
        return;
      }
      var isError = /^payment_process_error::/.test(e.data);
      if (e.data === 'payment_process_started') {
        iframe.classList.add('payment_process_started');
        document.body.style.overflow = 'hidden';
      } else if (e.data === 'payment_process_succeeded' || isError) {
        iframe.classList.remove('payment_process_started');
        document.body.style.overflow = '';
        if (isError) {
          _this11.profileData.payment.error = e.data.replace('payment_process_error::', '');
        } else {
          _this11.submitData();
        }
      }
    }, false);
  },
  mounted: function mounted() {
    this.synchroniseData();
    this.getCompanyVariation();
    this.getTemporaryVariation();
    this.getCompanySizes();
    this.getCompanyOrganizationTypes();
    if (!this.profileData.billing.addressCountry) {
      this.profileData.billing.addressCountry = this.countries.find(function (c) {
        return c.value === 'GB';
      });
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'need-help-request',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      activePopup: null,
      registerForm: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        privacy: false,
        nameFocus: false,
        surnameFocus: false,
        emailFocus: false,
        phoneFocus: false,
        subjectFocus: false,
        messageFocus: false
      },
      confOpened: null,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'initConfAction', 'redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      var pageData = {
        slug: 'need-help',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content)
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        _this.disableAPI = false;
        _this.getLandingPage(null, true);
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var pageData = {
        title: this.metaData.title,
        slug: 'need-help',
        description: this.metaData.description
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this3 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpagechanges + '/need-help', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.pageVersions = [];
        for (var index in res.body) {
          if (!res.body.hasOwnProperty(index)) {
            return;
          }
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this3.editHistory = true;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    getLandingPage: function getLandingPage(id, refresh) {
      var _this4 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'need-help'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.staticpage + '/need-help', body, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        if (pageData.footerData) {
          _this4.content.footerData = pageData.footerData;
        }
        if (pageData.heroSection) {
          _this4.content.heroSection = pageData.heroSection;
        }
        if (res.data.logo) {
          _this4.landing.logo = res.data.logo;
        }
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title;
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        _this4.content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.content, pageData);
        if (id) {
          _this4.pageEditSwitch();
        } else {
          if (refresh) {
            _this4.pageEditMode = false;
          }
        }
        if (_this4.$route.name === 'edit-need-help') {
          _this4.$nextTick(function () {
            _this4.autoSizeOnInit();
          });
        }
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        if (!data.hasOwnProperty(index)) {
          return;
        }
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage(null, true);
    },
    pageEditSwitch: function pageEditSwitch() {
      this.confOpened = 'edit';
      this.initConfAction({
        actionName: 'editLanding'
      });
    },
    pageEditSwitchConfirmed: function pageEditSwitchConfirmed() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
      this.getConfData.actionConfirmed = false;
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload && payload !== '') {
        return true;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    closePopup: function closePopup() {
      var _this6 = this;

      this.activePopup = null;
      this.pageMetaEdit = false;
      this.$nextTick(function () {
        if (_this6.$refs.slick) {
          _this6.$refs.slick.reSlick();
        }
      });
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      return userRole === 'gm';
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    submitCallbackRequest: function submitCallbackRequest() {
      var _this7 = this;

      this.formStatus.submitting = true;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          setTimeout(function () {
            _this7.scrollToTheMessage();
          }, 100);
          _this7.formStatus.submitting = false;
          return;
        }
        var data = {
          name: _this7.registerForm.name,
          surname: _this7.registerForm.surname,
          email: _this7.registerForm.email,
          phone: _this7.registerForm.phone,
          subject: _this7.registerForm.subject,
          message: _this7.registerForm.message,
          terms: true,
          privacy: _this7.registerForm.privacy,
          type: 2
        };
        _this7.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.callbackRequest, data).then(function () {
          _this7.formStatus.submitting = false;
          _this7.formStatus.shown = true;
          _this7.formStatus.success = true;
          _this7.formStatus.title = 'You have successfully submitted your need help request.';
          _this7.formStatus.body = 'Thank you for getting in touch. We usually reply to the need help request in maximum 24 hours from when it was submitted to us. If your inquiry is urgent, please give us a call.';
          _this7.registerForm.name = '';
          _this7.registerForm.surname = '';
          _this7.registerForm.email = '';
          _this7.registerForm.phone = '';
          _this7.registerForm.subject = '';
          _this7.registerForm.message = '';
          _this7.registerForm.privacy = false;
          setTimeout(function () {
            _this7.scrollToTheMessage();
            _this7.errors.clear();
          }, 100);
        }).catch(function (err) {
          _this7.formStatus.submitting = false;
          _this7.serverValidation.errors = err;
          _this7.disableAPI = false;
          _this7.formStatus.shown = true;
          _this7.formStatus.success = false;
          _this7.formStatus.title = err.body.message || 'Your need help request was not submitted.';
          _this7.formStatus.body = 'It looks like there was an error and your need help request could not be sent. Please try again or give us a call and we\'ll have our support team help you.';
          setTimeout(function () {
            _this7.scrollToTheMessage();
          }, 100);
        });
      });
    },
    scrollToTheMessage: function scrollToTheMessage() {
      var elem = document.querySelector('.tcc-form-message');
      if (elem) {
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    setupRightHeroStickyTopPosition: function setupRightHeroStickyTopPosition() {
      var header = document.querySelector('header.app-header .app-header-main');
      var stickyDiv = document.querySelector('.hero-section .right-content');
      if (header && stickyDiv) {
        var rect = header.getBoundingClientRect();
        stickyDiv.style.top = rect.height / 16 + 'rem';
      }
    },
    heroImageHeightFix: function heroImageHeightFix() {
      var imageContainer = document.querySelector('.hero-section .right-content');
      var image = document.querySelector('.hero-section .hero-image');
      var header = document.querySelector('header');
      var maxHeight = window.innerHeight;
      if (header) {
        maxHeight -= header.offsetHeight;
      }
      if (imageContainer && image) {
        imageContainer.style.height = maxHeight + 'px';
        image.style.maxHeight = maxHeight + 'px';
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    this.heroImageHeightFix();
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('resize', this.setupRightHeroStickyTopPosition);
    window.addEventListener('resize', this.heroImageHeightFix);
    window.addEventListener('scroll', this.setupRightHeroStickyTopPosition);
    if (this.$route.name === 'edit-register') {
      this.pageEditMode = true;
      this.landingPanel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('resize', this.setupRightHeroStickyTopPosition);
    window.removeEventListener('resize', this.heroImageHeightFix);
    window.removeEventListener('scroll', this.setupRightHeroStickyTopPosition);
  },

  components: {},
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'edit') this.pageEditSwitchConfirmed();
        this.clearConfAction();
      }
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register-company',
  data: function data() {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        }
      },
      initialContent: {
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: ''
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      activePopup: null,
      registerForm: {
        organizationName: '',
        name: '',
        surname: '',
        email: '',
        password: '',
        retypePassword: '',
        terms: false,
        privacy: false,
        // newsletterSubscribe: false,
        organizationNameFocus: false,
        nameFocus: false,
        surnameFocus: false,
        emailFocus: false,
        passwordFocus: false,
        retypePasswordFocus: false,
        isError: false,
        passwordType: 'password',
        retypePasswordType: 'password'
      },
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false,
        submitted: false
      },
      successfullyRegistered: false,
      confOpened: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getIsLoggedIn', 'getUserRole', 'selectedHightCont', 'getSelectedFontSize', 'getConfData'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['clearConfAction', 'initConfAction', 'redirect', 'getRoles', 'setFontSizeActive', 'setColorPaletteActive']), {
    updateLandingPage: function updateLandingPage() {
      var _this = this;

      if (this.disableAPI) return;
      var pageData = {
        slug: 'register',
        body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.content)
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function () {
        _this.disableAPI = false;
        _this.getLandingPage(null, true);
      }).catch(function (err) {
        _this.disableAPI = false;
        console.log('err', err);
      });
    },
    updateMeta: function updateMeta() {
      var _this2 = this;

      if (this.disableAPI) return;
      var pageData = {
        title: this.metaData.title,
        slug: 'register',
        description: this.metaData.description
      };
      this.disableAPI = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function () {
        _this2.disableAPI = false;
        document.location.reload();
      }).catch(function (err) {
        _this2.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersions: function getPageVersions() {
      var _this3 = this;

      var self = this;
      if (this.disableAPI) return;
      this.disableAPI = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpagechanges + '/register', __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.disableAPI = false;
        _this3.pageVersions = [];
        for (var index in res.body) {
          if (!res.body.hasOwnProperty(index)) {
            return;
          }
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          });
        }
        _this3.editHistory = true;
      }).catch(function (err) {
        _this3.disableAPI = false;
        console.log('err', err);
      });
    },
    getPageVersionsForSelect: function getPageVersionsForSelect() {
      return this.pageVersions;
    },
    changeLandingPage: function changeLandingPage(el) {
      this.getLandingPage(el.id);
    },
    convertDateTime: function convertDateTime(payload) {
      if (!payload) return;
      var date = new Date(payload);
      var fullYear = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var newHours = hours % 12 ? hours % 12 : 12;
      function toDoubleDigit(num) {
        return num.toString().length < 2 ? '0' + num : num.toString();
      }
      var dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear;
      var timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm;
      return dateString + ' ' + timeString;
    },
    getLandingPage: function getLandingPage(id, refresh) {
      var _this4 = this;

      if (this.disableAPI) return;
      this.disableAPI = true;
      var body = {
        slug: 'register'
      };
      if (id) {
        body.id = id;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.staticpage + '/register', body, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.disableAPI = false;
        var pageData = JSON.parse(res.data.body);
        if (pageData.footerData) {
          _this4.content.footerData = pageData.footerData;
        }
        if (pageData.heroSection) {
          _this4.content.heroSection = pageData.heroSection;
        }
        if (res.data.logo) {
          _this4.landing.logo = res.data.logo;
        }
        _this4.metaData.title = res.data.title;
        _this4.metaData.description = res.data.description;
        if (_this4.metaData.title && _this4.metaData.title !== '') {
          document.title = _this4.metaData.title;
        }
        _this4.addPageMeta('description', [{ name: 'content', value: _this4.metaData.description }]);
        _this4.content.title = _this4.metaData.title;
        _this4.content.description = _this4.metaData.description;
        _this4.initialContent = pageData;
        if (id) {
          _this4.pageEditSwitch();
        } else {
          if (refresh) {
            _this4.pageEditMode = false;
          }
        }
        if (_this4.$route.name === 'edit-register') {
          _this4.$nextTick(function () {
            _this4.autoSizeOnInit();
          });
        }
        _this4.$nextTick(function () {
          _this4.heroImageHeightFix();
        });
      }).catch(function (err) {
        _this4.disableAPI = false;
        console.log('err', err);
      });
    },
    activateEditHistory: function activateEditHistory() {
      this.getPageVersions();
    },
    addPageMeta: function addPageMeta(name, data) {
      var meta = document.createElement('meta');
      meta.name = name;
      for (var index in data) {
        if (!data.hasOwnProperty(index)) {
          return;
        }
        meta.setAttribute(data[index].name, data[index].value);
      }
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    discardChanges: function discardChanges() {
      this.getLandingPage(null, true);
    },
    pageEditSwitch: function pageEditSwitch() {
      this.confOpened = 'edit';
      this.initConfAction({
        actionName: 'editLanding'
      });
    },
    pageEditSwitchConfirmed: function pageEditSwitchConfirmed() {
      var _this5 = this;

      this.pageEditMode = true;
      this.$nextTick(function () {
        _this5.autoSizeOnInit();
      });
      this.getConfData.actionConfirmed = false;
    },
    discardPageEdit: function discardPageEdit() {
      this.discardChanges();
      if (this.editHistory) {
        this.editHistory = false;
      } else {
        this.landingPanel = false;
      }
    },
    onFileChange: function onFileChange(e, target, item) {
      var input = e.target;
      var self = this;
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileName = input.files[0].name;
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.disableAPI) return;
          var pageData = {
            file: e.target.result,
            extension: extension
          };
          self.disableAPI = true;
          self.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.uploadFile, pageData, __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].headersAuthSettings).then(function (res) {
            self.disableAPI = false;
            target[item] = res.body;
          }).catch(function (err) {
            self.disableAPI = false;
            console.log('err', err);
          });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getImagePath: function getImagePath() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].serverURL + '/uploads/images/content/';
    },
    isBase64: function isBase64(payload) {
      if (!payload && payload !== '') {
        return true;
      }
      return payload.indexOf('data:') !== -1;
    },
    getImage: function getImage(payload) {
      if (!payload) {
        return '';
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')';
    },
    closePopup: function closePopup() {
      var _this6 = this;

      this.activePopup = null;
      this.pageMetaEdit = false;
      this.$nextTick(function () {
        if (_this6.$refs.slick) {
          _this6.$refs.slick.reSlick();
        }
      });
    },
    autoSize: function autoSize(el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0';
        el.target.style = 'height:' + el.target.scrollHeight + 'px';
      }, 0);
    },
    autoSizeOnInit: function autoSizeOnInit() {
      var textAreas = document.getElementsByTagName('textarea');

      var _loop = function _loop(i) {
        var item = textAreas[i];
        setTimeout(function () {
          item.style = 'height:auto; padding:0';
          item.style = 'height:' + item.scrollHeight + 'px';
        }, 0);
      };

      for (var i = 0; i < textAreas.length; i++) {
        _loop(i);
      }
    },
    isGM: function isGM() {
      var isLogged = this.getIsLoggedIn;
      if (!isLogged) {
        return false;
      }
      var userRole = this.getUserRole;
      return userRole === 'gm';
    },
    handleWindowResize: function handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    register: function register() {
      var _this7 = this;

      this.formStatus.submitting = true;
      this.formStatus.submitted = true;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this7.formStatus.success = false;
          _this7.formStatus.title = 'Some fields are missing.';
          _this7.formStatus.body = 'Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.';
          _this7.formStatus.shown = true;
          _this7.formStatus.submitting = false;
          setTimeout(function () {
            _this7.scrollToTheMessage();
          }, 100);
          return;
        }
        var data = {
          organizationName: _this7.registerForm.organizationName,
          name: _this7.registerForm.name,
          surname: _this7.registerForm.surname,
          email: _this7.registerForm.email,
          password: _this7.registerForm.password,
          terms: _this7.registerForm.terms,
          privacy: _this7.registerForm.privacy
          // newsletterSubscribe: this.registerForm.newsletterSubscribe
        };
        if (_this7.$route.query.v) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
            variation: _this7.$route.query.v
          });
        }
        if (_this7.$route.query.hasOwnProperty('s')) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
            minSize: _this7.$route.query.s
          });
        }
        if (_this7.$route.query.hasOwnProperty('o')) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
            orgType: _this7.$route.query.o
          });
        }
        var voucher = sessionStorage.getItem('voucher');
        if (voucher) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
            voucher: voucher
          });
        }
        _this7.$http.post(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].URLS.registerCompany, data).then(function () {
          _this7.successfullyRegistered = true;
          window.scrollTo(0, 0);
        }).catch(function (error) {
          _this7.formStatus.success = false;
          _this7.formStatus.title = error.body.message || 'Internal server error. Please try again later.';
          _this7.formStatus.body = '';
          _this7.formStatus.shown = true;
          _this7.formStatus.submitting = false;
          if (error.body.code === 11) {
            _this7.formStatus.title = 'Some fields have errors';
            _this7.formStatus.body = 'Your password must contain at least 9 characters that include capital letters, lower case letters and numbers.';
            _this7.registerForm.password = '';
            _this7.registerForm.retypePassword = '';
          }
          setTimeout(function () {
            _this7.scrollToTheMessage();
          }, 100);
        });
      });
    },
    scrollToTheMessage: function scrollToTheMessage() {
      var elem = document.querySelector('.tcc-form-message');
      if (elem) {
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    showPassword: function showPassword(type) {
      if (!this.registerForm[type]) {
        return;
      }
      this.registerForm[type] = this.registerForm[type] === 'password' ? 'text' : 'password';
    },
    setupRightHeroStickyTopPosition: function setupRightHeroStickyTopPosition() {
      var header = document.querySelector('header.app-header .app-header-main');
      var stickyDiv = document.querySelector('.hero-section .right-content');
      if (header && stickyDiv) {
        var rect = header.getBoundingClientRect();
        stickyDiv.style.top = rect.height / 16 + 'rem';
      }
    },
    heroImageHeightFix: function heroImageHeightFix() {
      var imageContainer = document.querySelector('.hero-section .right-content');
      var image = document.querySelector('.hero-section .hero-image');
      var header = document.querySelector('header');
      var maxHeight = window.innerHeight;
      if (header) {
        maxHeight -= header.offsetHeight;
      }
      if (imageContainer && image) {
        imageContainer.style.height = maxHeight + 'px';
        image.style.maxHeight = maxHeight + 'px';
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.getLandingPage();
  },
  mounted: function mounted() {
    this.setFontSizeActive();
    this.setColorPaletteActive();
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('resize', this.setupRightHeroStickyTopPosition);
    window.addEventListener('resize', this.heroImageHeightFix);
    window.addEventListener('scroll', this.setupRightHeroStickyTopPosition);
    if (this.$route.name === 'edit-register') {
      this.pageEditMode = true;
      this.landingPanel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('resize', this.setupRightHeroStickyTopPosition);
    window.removeEventListener('resize', this.heroImageHeightFix);
    window.removeEventListener('scroll', this.setupRightHeroStickyTopPosition);
  },

  components: {},
  watch: {
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'edit') this.pageEditSwitchConfirmed();
        this.clearConfAction();
      }
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'plans-list',
  model: {
    prop: 'planSelected',
    event: 'plan-selected'
  },
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    currentPlan: {
      type: Object,
      required: false,
      default: null
    },
    currentVariation: {
      type: Object,
      required: false,
      default: null
    },
    vatDisplay: {
      type: Boolean,
      required: false,
      default: false
    },
    submitting: {
      type: Boolean,
      required: false,
      default: false
    },
    preSelectedSize: {
      type: Object,
      required: false,
      default: null
    },
    headingType: {
      type: String,
      required: false,
      default: 'h2'
    }
  },
  data: function data() {
    return {
      plans: [],
      selectedPlan: null,
      voucher: null,
      voucherSubmitted: false,
      invalidVoucher: false,
      hideVoucherSubmitForm: false,
      sizeSelectorActive: false,
      billingSelectorActive: false,
      commitmentSelectorActive: false,
      voucherAreaActive: false,
      voucherAreaTransitioning: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['companySizes']), {
    mutableCurrentPlan: {
      get: function get() {
        return this.currentPlan;
      },
      set: function set(value) {
        this.$emit('current-plan:change', value);
      }
    },
    heading: function heading() {
      return '<' + this.headingType + '>' + this.title + '</' + this.headingType + '>';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['getCompanySizes']), {
    findSelectedPlan: function findSelectedPlan() {
      var _this = this;

      var selectedPlan = null;
      if (!this.plans || !this.plans.length) {
        return selectedPlan;
      }
      if (this.mutableCurrentPlan) {
        selectedPlan = this.plans.find(function (plan) {
          return plan && plan.hasOwnProperty('variations') && plan.variations.length && plan.variations.some(function (v) {
            return parseInt(v.minSize, 10) === parseInt(_this.mutableCurrentPlan.minSize, 10) && parseInt(v.paymentPeriodUnit, 10) === parseInt(_this.mutableCurrentPlan.paymentPeriodUnit, 10) && parseInt(v.paymentPeriodValue, 10) === parseInt(_this.mutableCurrentPlan.paymentPeriodValue, 10) && parseInt(v.commitment, 10) === parseInt(_this.mutableCurrentPlan.commitment, 10) && (!_this.mutableCurrentPlan.marketplace && !v.marketplace || _this.mutableCurrentPlan.marketplace && v.marketplace && v.marketplace.id === _this.mutableCurrentPlan.marketplace.id);
          });
        });
      } else {
        // let lowerPrice
        // for (let i = 0; i < this.plans.length; i++) {
        //   if (!this.plans[i].hasOwnProperty('variations')) {
        //     continue
        //   }
        //   let lowerPriceVariation = this.plans[i]['variations'].reduce((prev, curr) => {
        //     let prevPrice = prev.price
        //     let currPrice = curr.price
        //     if (prev.paymentPeriodUnit === 0) {
        //       if (prev.paymentPeriodValue > 1) {
        //         prevPrice = parseFloat(prev.price) / parseFloat(prev.paymentPeriodValue)
        //       }
        //     } else if (prev.paymentPeriodUnit === 1) {
        //       if (prev.paymentPeriodValue > 1) {
        //         prevPrice = parseFloat(prev.price) / parseFloat(prev.paymentPeriodValue) / 12
        //       }
        //     }
        //     if (curr.paymentPeriodUnit === 0) {
        //       if (curr.paymentPeriodValue > 1) {
        //         currPrice = parseFloat(curr.price) / parseFloat(curr.paymentPeriodValue)
        //       }
        //     } else if (curr.paymentPeriodUnit === 1) {
        //       if (curr.paymentPeriodValue > 1) {
        //         currPrice = parseFloat(curr.price) / parseFloat(curr.paymentPeriodValue) / 12
        //       }
        //     }
        //     return prevPrice < currPrice ? prev.price : curr.price
        //   })
        //   if (!lowerPrice || (lowerPriceVariation && parseFloat(lowerPriceVariation) < lowerPrice)) {
        //     selectedPlan = this.plans[i]
        //   }
        //   lowerPrice = parseFloat(lowerPriceVariation)
        // }
      }
      this.selectedPlan = selectedPlan || this.plans[0];
    },
    planSelected: function planSelected(plan) {
      if (!this.selectedPlan) {
        return false;
      }
      return this.selectedPlan.type === plan.type && this.selectedPlan.marketplace === plan.marketplace;
    },
    planTemporaryPrice: function planTemporaryPrice(plan) {
      if (!plan.selectedVariation || plan.selectedVariation.minSize === null && (!plan.hasOwnProperty('temporarySelectedVariation') || plan.temporarySelectedVariation.minSize === null) || plan.selectedVariation.paymentPeriodUnit === null && (!plan.hasOwnProperty('temporarySelectedVariation') || plan.temporarySelectedVariation.paymentPeriodUnit === null) || plan.selectedVariation.paymentPeriodValue === null && (!plan.hasOwnProperty('temporarySelectedVariation') || plan.temporarySelectedVariation.paymentPeriodValue === null) || plan.selectedVariation.commitment === null && (!plan.hasOwnProperty('temporarySelectedVariation') || plan.temporarySelectedVariation.commitment === null)) {
        return true;
      }
      return false;
    },
    selectPlan: function selectPlan() {
      var variation = this.planVariation(this.selectedPlan);
      this.$emit('plan-selected', {
        variation: variation
      });
    },
    planVariation: function planVariation(plan) {
      if (!plan.variations || !Array.isArray(plan.variations) || !plan.selectedVariation) {
        return null;
      }
      return plan.variations.find(function (v) {
        return (v.minSize === plan.selectedVariation.minSize || plan.hasOwnProperty('temporarySelectedVariation') && plan.temporarySelectedVariation.minSize !== null && v.minSize === plan.temporarySelectedVariation.minSize) && (v.paymentPeriodUnit === plan.selectedVariation.paymentPeriodUnit || plan.hasOwnProperty('temporarySelectedVariation') && plan.temporarySelectedVariation.paymentPeriodUnit !== null && v.paymentPeriodUnit === plan.temporarySelectedVariation.paymentPeriodUnit) && (v.paymentPeriodValue === plan.selectedVariation.paymentPeriodValue || plan.hasOwnProperty('temporarySelectedVariation') && plan.temporarySelectedVariation.paymentPeriodValue !== null && v.paymentPeriodValue === plan.temporarySelectedVariation.paymentPeriodValue) && (v.commitment === plan.selectedVariation.commitment || plan.hasOwnProperty('temporarySelectedVariation') && plan.temporarySelectedVariation.commitment !== null && v.commitment === plan.temporarySelectedVariation.commitment);
      });
    },
    planLowerPriceVariation: function planLowerPriceVariation(plan) {
      if (!plan.variations || !Array.isArray(plan.variations) || !plan.lowerPriceVariation) {
        return null;
      }
      return plan.variations.find(function (v) {
        return v.minSize === plan.lowerPriceVariation.minSize && v.paymentPeriodUnit === plan.lowerPriceVariation.paymentPeriodUnit && v.paymentPeriodValue === plan.lowerPriceVariation.paymentPeriodValue && v.commitment === plan.lowerPriceVariation.commitment;
      });
    },
    planSizeOptions: function planSizeOptions(plan) {
      var _this2 = this;

      if (!plan.hasOwnProperty('variations') || !plan.variations.length) {
        return [];
      }
      var sizes = [];

      var _loop = function _loop(i) {
        var size = _this2.companySizes.find(function (cs) {
          return cs.min === plan.variations[i].minSize;
        });
        if (size && !sizes.find(function (s) {
          return s.value === size.value;
        })) {
          sizes.push(size);
        }
      };

      for (var i = 0; i < plan.variations.length; i++) {
        _loop(i);
      }
      return sizes.sort(function (a, b) {
        return a.value > b.value ? 1 : -1;
      });
    },
    selectedSizeOption: function selectedSizeOption(plan) {
      if (!plan.selectedVariation || plan.selectedVariation.minSize === null) {
        return null;
      }
      if (this.preSelectedSize) {
        return this.preSelectedSize;
      }
      var size = this.companySizes.find(function (cs) {
        return parseInt(cs.min) === parseInt(plan.selectedVariation.minSize);
      });
      return size || null;
    },
    planSizeChanged: function planSizeChanged(event, plan) {
      if (!event) {
        plan.selectedVariation.minSize = null;
        plan.selectedPlanSize = null;
        this.filterOptions(plan);
        return;
      }
      plan.selectedPlanSize = event;
      plan.selectedVariation.minSize = event.min;
      if (!plan.selectedVariation.selectedSavedVariation) {
        plan.selectedVariation.paymentPeriodUnit = null;
        plan.selectedVariation.paymentPeriodValue = null;
        plan.selectedVariation.commitment = null;
        plan.selectedPlanBilling = null;
        plan.selectedPlanCommitment = null;
      }
      this.filterOptions(plan);
    },
    planBillingOptions: function planBillingOptions(plan, filteredVariations) {
      if (!filteredVariations.length) {
        return [];
      }
      var billings = filteredVariations.map(function (v) {
        var label = void 0;
        var value = v.paymentPeriodValue + '-' + v.paymentPeriodUnit;
        if (v.paymentPeriodUnit === 0) {
          if (v.paymentPeriodValue === 1) {
            label = 'Billed monthly';
          } else {
            label = 'Billed every ' + v.paymentPeriodValue + ' months';
          }
        } else {
          if (v.paymentPeriodValue === 1) {
            label = 'Billed annually';
          } else {
            label = 'Billed every ' + v.paymentPeriodValue + ' years';
          }
        }
        return {
          label: label,
          value: value
        };
      });
      return billings.reduce(function (acc, o) {
        if (!acc.find(function (a) {
          return a.label === o.label;
        })) {
          acc.push(o);
        }
        return acc;
      }, []);
    },
    selectedBillingOption: function selectedBillingOption(plan) {
      if (!plan.selectedVariation || plan.selectedVariation.paymentPeriodUnit === null || plan.selectedVariation.paymentPeriodValue === null) {
        return null;
      }
      var label = void 0;
      var value = plan.selectedVariation.paymentPeriodValue + '-' + plan.selectedVariation.paymentPeriodUnit;
      if (plan.selectedVariation.paymentPeriodUnit === 0) {
        if (plan.selectedVariation.paymentPeriodValue === 1) {
          label = 'Billed monthly';
        } else {
          label = 'Billed every ' + plan.selectedVariation.paymentPeriodValue + ' months';
        }
      } else {
        if (plan.selectedVariation.paymentPeriodValue === 1) {
          label = 'Billed annually';
        } else {
          label = 'Billed every ' + plan.selectedVariation.paymentPeriodValue + ' years';
        }
      }
      return {
        label: label,
        value: value
      };
    },
    planBillingChanged: function planBillingChanged(event, plan) {
      if (!event) {
        plan.selectedVariation.paymentPeriodUnit = null;
        plan.selectedVariation.paymentPeriodValue = null;
        plan.selectedPlanBilling = null;
        this.filterOptions(plan);
        return;
      }
      var period = event.value.split('-');
      plan.selectedPlanBilling = event;
      plan.selectedVariation.paymentPeriodUnit = parseInt(period[1], 10);
      plan.selectedVariation.paymentPeriodValue = parseInt(period[0], 10);
      var strictFilteredOptions = this.strictFilteredOptions(plan);
      var selectedCommitmentOption = this.selectedCommitmentOption(plan);
      if (!plan.selectedVariation.selectedSavedVariation) {
        if (!plan.temporarySelectedVariation && selectedCommitmentOption && strictFilteredOptions.commitment.findIndex(function (o) {
          return o.label === selectedCommitmentOption.label && o.value === selectedCommitmentOption.value;
        }) === -1) {
          plan.selectedVariation.commitment = null;
          plan.selectedPlanCommitment = null;
        }
      }
      this.filterOptions(plan);
    },
    planCommitmentOptions: function planCommitmentOptions(plan, filteredVariations) {
      if (!filteredVariations.length) {
        return [];
      }
      var commitments = filteredVariations.map(function (c) {
        var label = void 0;
        if (c.commitment === 1) {
          label = '1 Year commitment';
        } else if (c.commitment === 3) {
          label = '3 Years commitment';
        } else {
          label = 'No commitment';
        }
        return {
          label: label,
          value: c.commitment
        };
      });
      return commitments.reduce(function (acc, o) {
        if (!acc.find(function (a) {
          return a.label === o.label;
        })) {
          acc.push(o);
        }
        return acc;
      }, []).sort(function (a, b) {
        return a.label === 'No commitment' ? -1 : a.label > b.label;
      });
    },
    selectedCommitmentOption: function selectedCommitmentOption(plan) {
      if (!plan.selectedVariation || plan.selectedVariation.commitment === null) {
        return null;
      }
      var label = void 0;
      if (plan.selectedVariation.commitment === 1) {
        label = '1 Year commitment';
      } else if (plan.selectedVariation.commitment === 3) {
        label = '3 Years commitment';
      } else {
        label = 'No commitment';
      }
      return {
        label: label,
        value: plan.selectedVariation.commitment
      };
    },
    planCommitmentChanged: function planCommitmentChanged(event, plan) {
      if (!event) {
        plan.selectedVariation.commitment = null;
        plan.selectedPlanCommitment = null;
        this.filterOptions(plan);
        return;
      }
      plan.selectedPlanCommitment = event;
      plan.selectedVariation.commitment = event.value;
      var strictFilteredOptions = this.strictFilteredOptions(plan);
      var selectedBillingOption = this.selectedBillingOption(plan);
      if (!plan.selectedVariation.selectedSavedVariation) {
        if (selectedBillingOption && strictFilteredOptions.billing.findIndex(function (o) {
          return o.label === selectedBillingOption.label && o.value === selectedBillingOption.value;
        }) === -1) {
          plan.selectedVariation.paymentPeriodUnit = null;
          plan.selectedVariation.paymentPeriodValue = null;
          plan.selectedPlanBilling = null;
        }
      }
      this.filterOptions(plan);
    },
    planPrice: function planPrice(plan) {
      var variation = this.planVariation(plan);
      if (!variation) {
        variation = this.planLowerPriceVariation(plan);
      }
      if (!variation) {
        return '';
      }
      if (variation.paymentPeriodUnit === 0) {
        if (variation.paymentPeriodValue === 1) {
          return parseFloat(variation.price);
        } else {
          return (parseFloat(variation.price) / variation.paymentPeriodValue).toFixed(2);
        }
      } else if (variation.paymentPeriodUnit === 1) {
        if (variation.paymentPeriodValue === 1) {
          return (parseFloat(variation.price) / 12).toFixed(2);
        } else {
          return (parseFloat(variation.price) / variation.paymentPeriodValue / 12).toFixed(2);
        }
      }
    },
    planDescription: function planDescription(plan) {
      var defaultText = '<ul><li><b>Knowledgeable enthusiasts, pragmatic expertise</b> – We understand the practical realities behind your inclusion journey and enable our clients to create policies and processes that reflect the specific needs of their workplace as well as changing cultures.</li><li><b>Focusing on D&amp;I since 2003</b> - the Clear Company has continuously enabled its clients to achieve powerful, constructive change across the employee lifecycle and beyond – influencing supply chains, inclusive customer solutions and investment in communities</li><li><b>Added Value</b> - The Clear Company provide resources and networking opportunities that focus on the latest developments in D&amp;I.&nbsp; They include regular blogs, downloadable mini guides, events and roundtables and a podcast series that provides bite-sized D&amp;I insights from business leaders<br></li></ul>';
      var variation = this.planVariation(plan);
      if (!variation) {
        return defaultText;
      }
      return variation.plan && variation.plan.description && variation.plan.description !== '' ? variation.plan.description : defaultText;
    },
    planPaymentPeriod: function planPaymentPeriod(plan) {
      var variation = this.planVariation(plan);
      if (!variation || variation.paymentPeriodUnit === null || variation.paymentPeriodValue === null) {
        return '';
      }
      var text = 'Billed';
      if (variation.paymentPeriodUnit === 0) {
        if (variation.paymentPeriodValue === 1) {
          text += ' monthly';
        } else {
          text += ' every ' + variation.paymentPeriodValue + ' months';
        }
      } else if (variation.paymentPeriodUnit === 1) {
        if (variation.paymentPeriodValue === 1) {
          text += ' yearly';
        } else {
          text += ' every ' + variation.paymentPeriodValue + ' years';
        }
      }
      if (variation.paymentPeriodUnit === 0) {
        if (variation.paymentPeriodValue === 1) {
          text += ' at <span>\xA3</span>' + parseFloat(variation.price) + (this.vatDisplay ? '<sup> + VAT</sup>' : '') + '/month';
        } else {
          text += ' at <span>\xA3</span>' + parseFloat(variation.price) + (this.vatDisplay ? '<sup> + VAT</sup>' : '') + '/' + variation.paymentPeriodValue + ' months';
        }
      } else if (variation.paymentPeriodUnit === 1) {
        if (variation.paymentPeriodValue === 1) {
          text += ' at <span>\xA3</span>' + parseFloat(variation.price) + (this.vatDisplay ? '<sup> + VAT</sup>' : '') + '/year';
        } else {
          text += ' at <span>\xA3</span>' + parseFloat(variation.price) + (this.vatDisplay ? '<sup> + VAT</sup>' : '') + '/' + variation.paymentPeriodValue + ' years';
        }
      }
      return text;
    },
    strictFilteredOptions: function strictFilteredOptions(plan) {
      var result = {
        size: [],
        billing: [],
        commitment: []
      };
      if (!plan.hasOwnProperty('variations') || !Array.isArray(plan.variations) || !plan.variations.length || !plan.selectedVariation) {
        return result;
      }

      var variations = plan.variations.filter(function (v) {
        return plan.selectedVariation.minSize === null || v.minSize === plan.selectedVariation.minSize;
      }).filter(function (v) {
        return plan.selectedVariation.paymentPeriodUnit === null && plan.selectedVariation.paymentPeriodValue === null || v.paymentPeriodUnit === plan.selectedVariation.paymentPeriodUnit && v.paymentPeriodValue === plan.selectedVariation.paymentPeriodValue;
      }).filter(function (v) {
        return plan.selectedVariation.commitment === null || v.commitment === plan.selectedVariation.commitment;
      });

      result.size = this.planSizeOptions(plan, variations);
      result.billing = this.planBillingOptions(plan, variations);
      result.commitment = this.planCommitmentOptions(plan, variations);

      return result;
    },
    filterOptions: function filterOptions(plan) {
      if (!plan.hasOwnProperty('variations') || !Array.isArray(plan.variations) || !plan.variations.length || !plan.selectedVariation) {
        return;
      }
      var variations = plan.variations.filter(function (v) {
        return plan.selectedVariation.minSize === null || v.minSize === plan.selectedVariation.minSize;
      });
      if (plan.selectedVariation.paymentPeriodUnit === null && (!plan.hasOwnProperty('temporarySelectedVariation') || !plan.temporarySelectedVariation.hasOwnProperty('paymentPeriodUnit') || plan.temporarySelectedVariation.paymentPeriodUnit === null) || plan.selectedVariation.paymentPeriodValue === null && (!plan.hasOwnProperty('temporarySelectedVariation') || !plan.temporarySelectedVariation.hasOwnProperty('paymentPeriodValue') || plan.temporarySelectedVariation.paymentPeriodValue === null) || plan.selectedVariation.commitment === null && (!plan.hasOwnProperty('temporarySelectedVariation') || !plan.temporarySelectedVariation.hasOwnProperty('commitment') || plan.temporarySelectedVariation.commitment === null)) {
        variations = variations.filter(function (v) {
          return plan.selectedVariation.paymentPeriodUnit === null && plan.selectedVariation.paymentPeriodValue === null || v.paymentPeriodUnit === plan.selectedVariation.paymentPeriodUnit && v.paymentPeriodValue === plan.selectedVariation.paymentPeriodValue;
        }).filter(function (v) {
          return plan.selectedVariation.commitment === null || v.commitment === plan.selectedVariation.commitment;
        });
      }

      if (!variations.length) {
        plan.variations = variations;
        // this.$nextTick(() => {
        //   let planIndex = this.plans.findIndex(p => p.id === plan.id)
        //   this.plans.splice(planIndex, 1)
        // })
        // this.$emit('plans-loaded', [])
        return;
      }

      // let sizes = this.planSizeOptions(plan, variations)
      var billings = this.planBillingOptions(plan, variations);
      var commitments = this.planCommitmentOptions(plan, variations);

      // this.$set(plan, 'sizeOptions', JSON.parse(JSON.stringify(sizes)))
      this.$set(plan, 'billingOptions', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(billings)));
      this.$set(plan, 'commitmentOptions', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(commitments)));
    },
    searchFocus: function searchFocus(plan, type) {
      if (!plan.hasOwnProperty('temporarySelectedVariation')) {
        this.$set(plan, 'temporarySelectedVariation', {});
      }
      switch (type) {
        case 'size':
          // plan.temporarySelectedVariation.minSize = plan.selectedVariation.minSize
          // plan.selectedVariation.minSize = null
          this.sizeSelectorActive = true;
          break;
        case 'billing':
          plan.temporarySelectedVariation.paymentPeriodUnit = plan.selectedVariation.paymentPeriodUnit;
          plan.temporarySelectedVariation.paymentPeriodValue = plan.selectedVariation.paymentPeriodValue;
          plan.selectedVariation.paymentPeriodUnit = null;
          plan.selectedVariation.paymentPeriodValue = null;
          this.billingSelectorActive = true;
          break;
        case 'commitment':
          plan.temporarySelectedVariation.commitment = plan.selectedVariation.commitment;
          plan.selectedVariation.commitment = null;
          this.commitmentSelectorActive = true;
          break;
      }
      this.filterOptions(plan);
    },
    searchBlur: function searchBlur(plan, type) {
      switch (type) {
        case 'size':
          // plan.selectedVariation.minSize = plan.temporarySelectedVariation.minSize
          this.sizeSelectorActive = false;
          break;
        case 'billing':
          plan.selectedVariation.paymentPeriodUnit = plan.temporarySelectedVariation.paymentPeriodUnit;
          plan.selectedVariation.paymentPeriodValue = plan.temporarySelectedVariation.paymentPeriodValue;
          this.billingSelectorActive = false;
          break;
        case 'commitment':
          plan.selectedVariation.commitment = plan.temporarySelectedVariation.commitment;
          this.commitmentSelectorActive = false;
          break;
      }
      // this.$set(plan, 'temporarySelectedVariation', {})
      delete plan.temporarySelectedVariation;
      this.$set(plan, 'selectedVariation', plan.selectedVariation);
    },
    updatePlansVariation: function updatePlansVariation() {
      var _this3 = this;

      if (!this.plans.length) {
        return;
      }

      var _loop2 = function _loop2(i) {
        if (!!_this3.voucher && !_this3.selectedPlan && _this3.plans[i].voucher && parseInt(_this3.plans[i].voucher.type, 10) === 3 && _this3.plans[i].marketplace && _this3.plans[i].marketplace.id === _this3.plans[i].voucher.marketplace) {
          _this3.selectedPlan = _this3.plans[i];
        }
        var variations = _this3.plans[i].variations;
        var sizes = _this3.planSizeOptions(_this3.plans[i], variations);
        _this3.plans[i].sizeOptions = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sizes));
        var variation = _this3.plans[i]['variations'].reduce(function (prev, curr) {
          var prevPrice = prev.price;
          var currPrice = curr.price;
          if (prev.paymentPeriodUnit === 0) {
            if (prev.paymentPeriodValue > 1) {
              prevPrice = parseFloat(prev.price) / parseFloat(prev.paymentPeriodValue);
            } else {
              prevPrice = parseFloat(prev.price);
            }
          } else if (prev.paymentPeriodUnit === 1) {
            if (prev.paymentPeriodValue > 1) {
              prevPrice = parseFloat(prev.price) / parseFloat(prev.paymentPeriodValue) / 12;
            } else {
              prevPrice = parseFloat(prev.price) / 12;
            }
          }
          if (curr.paymentPeriodUnit === 0) {
            if (curr.paymentPeriodValue > 1) {
              currPrice = parseFloat(curr.price) / parseFloat(curr.paymentPeriodValue);
            } else {
              currPrice = parseFloat(curr.price);
            }
          } else if (curr.paymentPeriodUnit === 1) {
            if (curr.paymentPeriodValue > 1) {
              currPrice = parseFloat(curr.price) / parseFloat(curr.paymentPeriodValue) / 12;
            } else {
              currPrice = parseFloat(curr.price) / 12;
            }
          }
          return prevPrice < currPrice ? prev : curr;
        });
        if (_this3.currentVariation) {
          var selectedVariation = _this3.plans[i]['variations'].find(function (v) {
            return v.id === _this3.currentVariation.id;
          });
          if (selectedVariation) {
            _this3.plans[i].selectedVariation = {
              minSize: selectedVariation.minSize,
              paymentPeriodUnit: selectedVariation.paymentPeriodUnit,
              paymentPeriodValue: selectedVariation.paymentPeriodValue,
              commitment: selectedVariation.commitment,
              selectedSavedVariation: true
            };
          }
        }
        if (!_this3.plans[i].selectedVariation) {
          _this3.plans[i].selectedVariation = {
            minSize: _this3.preSelectedSize ? _this3.preSelectedSize.min : null,
            paymentPeriodUnit: null,
            paymentPeriodValue: null,
            commitment: null
          };
        }
        _this3.plans[i].lowerPriceVariation = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(variation)) || null;
        if (!_this3.preSelectedSize && !!_this3.plans[i].lowerPriceVariation) {
          _this3.plans[i].selectedVariation.minSize = _this3.plans[i].lowerPriceVariation.minSize;
        }
        _this3.plans[i].selectedPlanSize = _this3.selectedSizeOption(_this3.plans[i]);
        _this3.plans[i].selectedPlanBilling = _this3.selectedBillingOption(_this3.plans[i]);
        _this3.plans[i].selectedPlanCommitment = _this3.selectedCommitmentOption(_this3.plans[i]);
        if (!_this3.plans[i].hasOwnProperty('variations') || !Array.isArray(_this3.plans[i].variations) || !_this3.plans[i].variations.length) {
          _this3.plans[i].sizeOptions = [];
          _this3.plans[i].billingOptions = [];
          _this3.plans[i].commitmentOptions = [];
        }
        if (!_this3.plans[i].selectedVariation) {
          var billings = _this3.planBillingOptions(_this3.plans[i], variations);
          _this3.plans[i].billingOptions = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(billings));
          var commitments = _this3.planCommitmentOptions(_this3.plans[i], variations);
          _this3.plans[i].commitmentOptions = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(commitments));
        }
        _this3.filterOptions(_this3.plans[i]);
        _this3.$nextTick(function () {
          delete _this3.plans[i].selectedVariation.selectedSavedVariation;
        });
      };

      for (var i = 0; i < this.plans.length; i++) {
        _loop2(i);
      }
    },
    getPlans: function getPlans() {
      var _this4 = this;

      var url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.plans;
      if (this.voucher) {
        url += '?voucher=' + this.voucher;
      }
      this.$http.get(url, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this4.plans = Array.isArray(res.body) ? res.body.sort(function (prev, next) {
          return prev.name.localeCompare(next.name);
        }) : [];
        _this4.findSelectedPlan();
        _this4.updatePlansVariation();
        _this4.$emit('plans-loaded', _this4.plans);
      }).catch(function (error) {
        console.log(error);
      });
    },
    submitVoucher: function submitVoucher() {
      var _this5 = this;

      var data = {
        voucher: this.voucher
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.voucherCheck, data, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this5.invalidVoucher = !res.body.valid;
        _this5.voucherSubmitted = true;
        if (_this5.invalidVoucher === false) {
          sessionStorage.setItem('voucher', _this5.voucher.toString());
          _this5.getPlans();
        } else {
          _this5.voucher = '';
        }
      }).catch(function () {
        _this5.invalidVoucher = true;
        _this5.voucher = '';
      });
    },
    submitAnotherVoucher: function submitAnotherVoucher() {
      this.hideVoucherSubmitForm = false;
    },
    deleteVoucher: function deleteVoucher() {
      sessionStorage.removeItem('voucher');
      this.hideVoucherSubmitForm = false;
      this.voucher = null;
      this.getPlans();
    },
    tabSelected: function tabSelected(event) {
      if (!this.plans || !this.plans.length) {
        return;
      }
      var plan = this.plans.find(function (p) {
        return p.name.toLowerCase().replace(/ /g, '-') === event.id;
      });
      if (plan) {
        this.selectedPlan = plan;
      }
    },
    activateVoucherArea: function activateVoucherArea() {
      var _this6 = this;

      if (this.voucherAreaActive && !this.voucherAreaTransitioning) {
        this.voucherAreaActive = false;
        this.voucherSubmitted = false;
        this.invalidVoucher = false;
      } else {
        this.voucherAreaTransitioning = true;
        setTimeout(function () {
          _this6.voucherAreaActive = true;
          _this6.voucherAreaTransitioning = false;
        }, 500);
      }
    }
  }),
  watch: {
    plans: function plans(value) {
      if (value) {
        if (!this.selectedPlan) {
          this.findSelectedPlan();
        }
      }
    },
    currentPlan: function currentPlan(value) {
      if (value) {
        if (!this.selectedPlan) {
          this.findSelectedPlan();
        }
      }
    },
    companySizes: function companySizes(value) {
      if (value) {
        this.getPlans();
      }
    }
  },
  created: function created() {
    this.voucher = sessionStorage.getItem('voucher');
    this.hideVoucherSubmitForm = !!this.voucher;
    this.getCompanySizes();
    // this.getPlans()
  },

  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_4__components_admin_common_Select___default.a
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__includes_FocusTasks__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__includes_FocusTasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__includes_FocusTasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_BacklogTasks__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_BacklogTasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__includes_BacklogTasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_TasksFilters__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_TasksFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__includes_TasksFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_TasksDeviceFilters__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_TasksDeviceFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__includes_TasksDeviceFilters__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tasks-list',
  props: {
    company: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      searchKey: null,
      activeTab: null,
      activeSearch: false,
      activeFilters: false,
      companies: [],
      windowWidth: window.innerWidth
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])(['isAdmin', 'isRegularUser']), {
    taskBoardList: function taskBoardList() {
      return [{
        label: 'Current focus',
        value: 'focus'
      }, {
        label: 'Backlog',
        value: 'backlog'
      }];
    },
    isDesktop: function isDesktop() {
      return this.windowWidth > 1090;
    },
    allActiveFiltersCount: function allActiveFiltersCount() {
      var filtersCounter = 0;
      if (!this.activeTab) {
        return filtersCounter;
      }
      if (this.activeTab.value === 'backlog') {
        if (this.$route.query.bc && decodeURIComponent(this.$route.query.bc) !== '') {
          filtersCounter += decodeURIComponent(this.$route.query.bc).split(',').length;
        }
        if (this.$route.query.ba && decodeURIComponent(this.$route.query.ba) !== '') {
          filtersCounter += decodeURIComponent(this.$route.query.ba).split(',').length;
        }
        if (this.$route.query.status && decodeURIComponent(this.$route.query.status) !== '') {
          filtersCounter += decodeURIComponent(this.$route.query.status).split(',').length;
        }
      } else {
        if (this.$route.query.fc && decodeURIComponent(this.$route.query.fc) !== '') {
          filtersCounter += decodeURIComponent(this.$route.query.fc).split(',').length;
        }
        if (this.$route.query.fa && decodeURIComponent(this.$route.query.fa) !== '') {
          filtersCounter += decodeURIComponent(this.$route.query.fa).split(',').length;
        }
      }
      if (this.$route.query.mandatory && decodeURIComponent(this.$route.query.mandatory) !== '') {
        filtersCounter += decodeURIComponent(this.$route.query.mandatory).split(',').length;
      }
      return filtersCounter;
    },
    currentCompany: function currentCompany() {
      var _this = this;

      return this.companies.find(function (item) {
        return item.value === _this.company;
      });
    },
    userDashboard: function userDashboard() {
      if (this.isAdmin) {
        return 'admin';
      } else if (this.isRegularUser) {
        return 'user-app';
      } else {
        return 'knowledge-base';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])(['getTaskChapters', 'getTaskStatuses', 'getTaskMandatory', 'getTaskAssignee']), {
    changeTaskBoard: function changeTaskBoard(event) {
      this.$router.replace({
        hash: event.value,
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query)
      });
    },
    setupInnerWidth: function setupInnerWidth() {
      this.windowWidth = window.innerWidth;
    },
    activateSearch: function activateSearch() {
      this.activeFilters = false;
      this.activeSearch = !this.activeSearch;
      this.maybeBodyScrollDisableNeeded();
    },
    activateFilters: function activateFilters() {
      this.activeSearch = false;
      this.activeFilters = !this.activeFilters;
      this.maybeBodyScrollDisableNeeded();
      if (this.activeFilters) {
        window.scrollTo(0, 0);
      }
    },
    maybeBodyScrollDisableNeeded: function maybeBodyScrollDisableNeeded() {
      if (this.activeSearch) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    setupTasksMinHeight: function setupTasksMinHeight() {
      var tasks = document.querySelector('.wrap-task');
      var footer = document.querySelector('.front-footer');
      if (tasks && footer) {
        tasks.style.minHeight = window.innerHeight - footer.offsetHeight + 'px';
      }
    },
    getAllCompaniesForSelect: function getAllCompaniesForSelect() {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companiesS + '/all/select', __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.companies = res.body;
      }).catch(function () {});
    },
    changeCompany: function changeCompany(event) {
      if (event.value === this.company) {
        return;
      }
      var props = this.$router.resolve({
        name: 'company-tasks',
        hash: this.activeTab ? '#' + this.activeTab.value : undefined,
        params: {
          companyId: event.value
        }
      });
      this.$router.push(props.href);
    }
  }),
  components: {
    TasksDeviceFilters: __WEBPACK_IMPORTED_MODULE_7__includes_TasksDeviceFilters___default.a,
    TasksFilters: __WEBPACK_IMPORTED_MODULE_4__includes_TasksFilters___default.a,
    BacklogTasks: __WEBPACK_IMPORTED_MODULE_3__includes_BacklogTasks___default.a,
    FocusTasks: __WEBPACK_IMPORTED_MODULE_2__includes_FocusTasks___default.a,
    AppSelect: __WEBPACK_IMPORTED_MODULE_5__components_admin_common_Select___default.a
  },
  beforeMount: function beforeMount() {
    this.getTaskChapters(this.company);
    this.getTaskStatuses(this.company);
    this.getTaskAssignee(this.company);
  },
  created: function created() {
    this.setupInnerWidth();
    this.setupTasksMinHeight();
    if (this.isAdmin) {
      this.getAllCompaniesForSelect();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.$route.hash) {
      this.activeTab = this.taskBoardList.find(function (item) {
        return item.value === _this3.$route.hash.replace('#', '');
      });
      this.getTaskMandatory({
        company: this.company,
        board: this.activeTab && this.activeTab.value === 'focus' ? 'current-focus' : null
      });
    } else {
      this.activeTab = this.taskBoardList[1];
      this.getTaskMandatory({
        company: this.company,
        board: null
      });
    }
    window.addEventListener('resize', this.setupInnerWidth);
    window.addEventListener('resize', this.setupTasksMinHeight);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.setupInnerWidth);
    window.removeEventListener('resize', this.setupTasksMinHeight);
  },

  watch: {
    '$route': function $route(to, from) {
      var _this4 = this;

      if (to.hash !== from.hash) {
        this.activeTab = this.taskBoardList.find(function (item) {
          return item.value === _this4.$route.hash.replace('#', '');
        }) || this.taskBoardList[1];
        this.getTaskMandatory({
          company: this.company,
          board: this.activeTab && this.activeTab.value === 'focus' ? 'current-focus' : null
        });
      }
    },
    company: function company(value) {
      if (value) {
        this.getTaskChapters(this.company);
        this.getTaskStatuses(this.company);
        this.getTaskMandatory({
          company: this.company,
          board: this.activeTab && this.activeTab.value === 'focus' ? 'current-focus' : null
        });
        this.getTaskAssignee(this.company);
      }
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_avatar__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'backlog-tasks',
  props: {
    company: Number
  },
  data: function data() {
    return {
      drag: false,
      completedTasksLimit: 3,
      backlogTasks: null
    };
  },

  methods: {
    handleChange: function handleChange(value, board) {
      if (value.hasOwnProperty('added')) {
        board.count++;
      }
      if (value.hasOwnProperty('removed')) {
        board.count--;
      }
      this.moveTask(board, value);
      // this.setChaptersProgress()
    },
    moveTask: function moveTask(board, value) {
      var backlogBoard = this.backlogTasks.find(function (item) {
        return item.id === board.id;
      });
      if (!backlogBoard) {
        return;
      }
      var data = {
        targetBoard: backlogBoard.id,
        indexes: this.generateNewTasksOrder(backlogBoard),
        filtered: this.hasActiveFilters
      };
      if (value.hasOwnProperty('added')) {
        data['action'] = 'added';
        data['taskId'] = value.added.element.id;
        data['newIndex'] = parseInt(value.added.newIndex);
      }
      if (value.hasOwnProperty('moved')) {
        data['action'] = 'moved';
        data['taskId'] = value.moved.element.id;
        data['newIndex'] = parseInt(value.moved.newIndex);
      }
      if (value.hasOwnProperty('removed')) {
        data['action'] = 'removed';
        data['newIndex'] = parseInt(value.removed.newIndex);
      }
      if (this.company) {
        data['company'] = this.company;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.task + '/move', data, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function () {}).catch(function (err) {
        console.log(err);
      });
    },
    generateNewTasksOrder: function generateNewTasksOrder(board) {
      var order = [];
      for (var i = 0; i < board.tasks.length; i++) {
        order.push(board.tasks[i]['id']);
      }
      return order;
    },
    goToTask: function goToTask(taskId) {
      var routeName = this.isAdmin ? 'company-task' : 'task';
      var routeParams = {
        id: taskId
      };
      if (this.company) {
        routeParams['companyId'] = this.company;
      }
      var props = this.$router.resolve({
        name: routeName,
        params: routeParams
      });
      this.$router.push(props.href);
    },
    activateBoard: function activateBoard(board) {
      board.active = !board.active;
    },
    getChapterById: function getChapterById(id) {
      return this.taskChapters.find(function (item) {
        return item.id === id;
      });
    },
    getStatusById: function getStatusById(id) {
      var status = this.taskStatuses.find(function (item) {
        return item.id === id;
      });
      return status || false;
    },
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    setChaptersProgress: function setChaptersProgress() {
      var self = this;
      setTimeout(function () {
        self.taskChapters.forEach(function (chapter) {
          var score = chapter.score;
          var selector = '.backlog-tasks .filters_progress_value-' + chapter.id;
          self.setCompanyProgress(score, selector);
        });
      }, 1000);
    },
    setCompanyProgress: function setCompanyProgress(value, selector) {
      var RADIUS = 44;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      var progressValue = document.querySelectorAll(selector);
      if (progressValue.length) {
        for (var i = 0; i < progressValue.length; i++) {
          var progress = value / 100;
          if (progressValue[i]) {
            progressValue[i].style.opacity = 1;
            progressValue[i].style.strokeDasharray = CIRCUMFERENCE;
            progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress);
          }
        }
      }
    },
    taskPriorityLabelByValue: function taskPriorityLabelByValue(value) {
      var priority = this.tasksPriorities.find(function (item) {
        return item.value === value;
      });
      return priority ? priority.label : '';
    },
    taskPriorityDelta: function taskPriorityDelta(value) {
      var priorityDelta = 0;
      if (value <= 33) {
        priorityDelta = 0;
      } else if (value > 33 && value <= 66) {
        priorityDelta = 1;
      } else if (value > 66 && value <= 100) {
        priorityDelta = 2;
      }
      return priorityDelta;
    },
    itemDragOver: function itemDragOver(event) {
      var board = event.target.closest('.backlog-tasks-row-body.no-items');
      if (board) {
        board.classList.add('drag-over');
      } else {
        var boards = document.querySelectorAll('.backlog-tasks-row-body.drag-over');
        for (var i = 0; i < boards.length; i++) {
          boards[i].classList.remove('drag-over');
        }
      }
    },
    getData: function getData() {
      var _this = this;

      var searchParams = this.searchParams;
      var actionURL = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.task + '/all/backlog';
      if (searchParams) {
        if (this.company) {
          actionURL += '?company=' + this.company + '&filters=' + searchParams;
        } else {
          actionURL += '?filters=' + searchParams;
        }
      } else if (this.company) {
        actionURL += '?company=' + this.company;
      }
      this.$http.get('' + actionURL, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.backlogTasks = res.body;
        _this.$store.commit('setBacklogTasks', res.body);
        // this.setChaptersProgress()
      }).catch(function (err) {
        console.log(err);
      });
    },
    taskAssigneeById: function taskAssigneeById(id) {
      var assignee = this.taskAssigneeForSelect.find(function (item) {
        return item.value === id;
      });
      if (assignee && assignee.value) {
        return assignee;
      }
      return null;
    },
    draggingItem: function draggingItem(state) {
      var header = document.querySelector('.app-header-main');
      if (state) {
        header.classList.add('absolute-positioned');
      } else {
        header.classList.remove('absolute-positioned');
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['getUserRole', 'tasksPriorities', 'taskStatuses', 'taskChapters', 'taskAssigneeForSelect', 'isAdmin']), {
    dragOptions: function dragOptions() {
      return {
        animation: 200,
        group: 'backlogTasks',
        disabled: false,
        delay: 200,
        delayOnTouchOnly: true,
        ghostClass: 'ghost'
      };
    },
    completedDragOptions: function completedDragOptions() {
      return {
        animation: 200,
        group: 'completedTasks',
        disabled: true,
        delay: 200,
        delayOnTouchOnly: true,
        ghostClass: 'ghost'
      };
    },
    hasActiveFilters: function hasActiveFilters() {
      var hasFilters = false;
      if (this.$route.query.bt || this.$route.query.bc || this.$route.query.ba || this.$route.query.status || this.$route.query.mandatory) {
        hasFilters = true;
      }
      return hasFilters;
    },
    searchParams: function searchParams() {
      var filters = {};
      var empty = true;
      if (this.$route.query.bt) {
        filters['text'] = decodeURIComponent(this.$route.query.bt);
        empty = false;
      }
      if (this.$route.query.bc) {
        filters['chapters'] = decodeURIComponent(this.$route.query.bc).split(',');
        empty = false;
      }
      if (this.$route.query.ba) {
        filters['assignee'] = decodeURIComponent(this.$route.query.ba).split(',');
        empty = false;
      }
      if (this.$route.query.status) {
        filters['status'] = decodeURIComponent(this.$route.query.status).split(',');
        empty = false;
      }
      if (this.$route.query.mandatory) {
        filters['mandatory'] = decodeURIComponent(this.$route.query.mandatory).split(',');
        empty = false;
      }
      if (empty) {
        return false;
      }
      return encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filters));
    },
    imageBase: function imageBase() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverUserImages;
    }
  }),
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    Avatar: __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default.a
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.params.companyId && from.params.companyId && to.params.companyId !== from.params.companyId || to.hash !== from.hash && to.hash === '#backlog') {
        this.getData();
      }
    },
    drag: function drag(value) {
      if (!value) {
        var boards = document.querySelectorAll('.backlog-tasks-row-body');
        for (var i = 0; i < boards.length; i++) {
          boards[i].classList.remove('drag-over');
        }
      }
    },
    taskChapters: function taskChapters(value) {
      if (value) {
        // this.setChaptersProgress()
      }
    },
    searchParams: function searchParams() {
      this.getData();
    }
  },
  created: function created() {
    this.getData();
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_avatar__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'focus-tasks',
  props: {
    company: Number
  },
  data: function data() {
    return {
      focusTasks: [],
      drag: false,
      allDragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        delay: 200,
        delayOnTouchOnly: true,
        ghostClass: 'ghost'
      },
      inReviewDragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        delay: 200,
        delayOnTouchOnly: true,
        ghostClass: 'ghost'
      },
      completedDragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        delay: 200,
        delayOnTouchOnly: true,
        ghostClass: 'ghost'
      },
      dragOverStatusId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['getUserRole', 'selectedHightCont', 'taskChapters', 'taskAssigneeForSelect', 'isAdmin']), {
    searchParams: function searchParams() {
      var filters = {};
      var empty = true;
      if (this.$route.query.ft) {
        filters['text'] = decodeURIComponent(this.$route.query.ft);
        empty = false;
      }
      if (this.$route.query.fc) {
        filters['chapters'] = decodeURIComponent(this.$route.query.fc).split(',');
        empty = false;
      }
      if (this.$route.query.fa) {
        filters['assignee'] = decodeURIComponent(this.$route.query.fa).split(',');
        empty = false;
      }
      if (this.$route.query.mandatory) {
        filters['mandatory'] = decodeURIComponent(this.$route.query.mandatory).split(',');
        empty = false;
      }
      if (empty) {
        return false;
      }
      return encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filters));
    },
    hasActiveFilters: function hasActiveFilters() {
      var hasFilters = false;
      if (this.$route.query.ft || this.$route.query.fc || this.$route.query.fa || this.$route.query.mandatory) {
        hasFilters = true;
      }
      return hasFilters;
    },
    imageBase: function imageBase() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverUserImages;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['getTaskStatuses']), {
    handleChange: function handleChange(value, status) {
      this.moveTask(status, value);
      if (value.hasOwnProperty('added')) {
        status.count++;
      }
      if (value.hasOwnProperty('removed')) {
        status.count--;
      }
      // this.setChaptersProgress(100)
    },
    moveTask: function moveTask(status, value) {
      var _this = this;

      var statusColumn = this.focusTasks.find(function (item) {
        return item.id === status.id;
      });
      if (!statusColumn) {
        return;
      }
      var data = {
        targetStatus: statusColumn.id,
        indexes: this.generateNewTasksOrder(statusColumn),
        filtered: this.hasActiveFilters
      };
      if (value.hasOwnProperty('added')) {
        data['action'] = 'added';
        data['taskId'] = value.added.element.id;
        data['newIndex'] = parseInt(value.added.newIndex);
      }
      if (value.hasOwnProperty('moved')) {
        data['action'] = 'moved';
        data['taskId'] = value.moved.element.id;
        data['newIndex'] = parseInt(value.moved.newIndex);
      }
      if (value.hasOwnProperty('removed')) {
        data['action'] = 'removed';
        data['newIndex'] = parseInt(value.removed.newIndex);
      }
      if (this.company) {
        data['company'] = this.company;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.task + '/move', data, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function () {
        if (value.hasOwnProperty('added')) {
          _this.getTaskStatuses(_this.company);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    generateNewTasksOrder: function generateNewTasksOrder(status) {
      var order = [];
      for (var i = 0; i < status.tasks.length; i++) {
        order.push(status.tasks[i]['id']);
      }
      return order;
    },
    goToTask: function goToTask(taskId) {
      var routeName = this.isAdmin ? 'company-task' : 'task';
      var routeParams = {
        id: taskId
      };
      if (this.company) {
        routeParams['companyId'] = this.company;
      }
      var props = this.$router.resolve({
        name: routeName,
        params: routeParams
      });
      this.$router.push(props.href);
    },
    getChapterById: function getChapterById(id) {
      return this.taskChapters.find(function (item) {
        return item.id === id;
      });
    },
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    setChaptersProgress: function setChaptersProgress(timeout) {
      timeout = timeout || 1000;
      var self = this;
      setTimeout(function () {
        self.taskChapters.forEach(function (chapter) {
          var score = chapter.score;
          var selector = '.focus-tasks .filters_progress_value-' + chapter.id;
          self.setCompanyProgress(score, selector);
        });
      }, timeout);
    },
    setCompanyProgress: function setCompanyProgress(value, selector) {
      var RADIUS = 44;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      var progressValue = document.querySelectorAll(selector);
      if (progressValue.length) {
        for (var i = 0; i < progressValue.length; i++) {
          var progress = value / 100;
          if (progressValue[i]) {
            progressValue[i].style.opacity = 1;
            progressValue[i].style.strokeDasharray = CIRCUMFERENCE;
            progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress);
          }
        }
      }
    },
    draggingItem: function draggingItem(task, state) {
      if (this.isAdmin) {
        return;
      }
      if (task.assessed) {
        this.inReviewDragOptions.disabled = state;
      } else {
        this.completedDragOptions.disabled = state;
      }
      var header = document.querySelector('.app-header-main');
      if (state) {
        header.classList.add('absolute-positioned');
      } else {
        header.classList.remove('absolute-positioned');
      }
    },
    dragOverHandle: function dragOverHandle(id) {
      setTimeout(function () {
        var element = document.getElementById('statusColumn-' + id);
        var container = document.querySelector('.focus-tasks-columns');

        var cLeft = container.scrollLeft;
        var cRight = cLeft + container.clientHeight;

        var eLeft = element.offsetLeft;
        var eRight = eLeft + element.clientHeight;

        if (eLeft < cLeft && eRight > cLeft) {
          container.scrollLeft -= cLeft - eLeft;
        } else if (eRight > cRight && eLeft < cRight) {
          container.scrollLeft += eRight - cRight;
        }
      }, 400);
      this.dragOverStatusId = id;
    },
    dragEnd: function dragEnd() {
      this.drag = false;
      this.dragOverStatusId = null;
    },
    dragOptions: function dragOptions(status) {
      if (status.slug === 'in-review') {
        return this.inReviewDragOptions;
      } else if (status.slug === 'completed') {
        return this.completedDragOptions;
      } else {
        return this.allDragOptions;
      }
    },
    statusIsDisabled: function statusIsDisabled(status) {
      if (this.isAdmin) {
        return;
      }
      if (status.slug === 'in-review') {
        return this.inReviewDragOptions.disabled;
      } else if (status.slug === 'completed') {
        return this.completedDragOptions.disabled;
      } else {
        return this.allDragOptions.disabled;
      }
    },
    getData: function getData() {
      var _this2 = this;

      var searchParams = this.searchParams;
      var actionURL = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.task + '/all/focus';
      if (searchParams) {
        if (this.company) {
          actionURL += '?company=' + this.company + '&filters=' + searchParams;
        } else {
          actionURL += '?filters=' + searchParams;
        }
      } else if (this.company) {
        actionURL += '?company=' + this.company;
      }
      this.$http.get('' + actionURL, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.focusTasks = res.body;
        _this2.$store.commit('setFocusTasks', res.body);
        // this.setChaptersProgress()
      }).catch(function (err) {
        console.log(err);
      });
    },
    taskAssigneeById: function taskAssigneeById(id) {
      var assignee = this.taskAssigneeForSelect.find(function (item) {
        return item.value === id;
      });
      if (assignee && assignee.value) {
        return assignee;
      }
      return null;
    },
    taskPriorityDelta: function taskPriorityDelta(value) {
      var priorityDelta = 0;
      if (value <= 33) {
        priorityDelta = 0;
      } else if (value > 33 && value <= 66) {
        priorityDelta = 1;
      } else if (value > 66 && value <= 100) {
        priorityDelta = 2;
      }
      return priorityDelta;
    }
  }),
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    Avatar: __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default.a
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.params.companyId && from.params.companyId && to.params.companyId !== from.params.companyId || to.hash !== from.hash && to.hash === '#focus') {
        this.getData();
      }
    },
    taskChapters: function taskChapters(value) {
      if (value) {
        // this.setChaptersProgress()
      }
    },
    searchParams: function searchParams() {
      this.getData();
    }
  },
  created: function created() {
    this.getData();
  },
  mounted: function mounted() {
    // this.setChaptersProgress()
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-actions',
  model: {
    prop: 'taskChanged',
    event: 'task-changed'
  },
  props: {
    company: Number,
    taskChanged: Boolean,
    taskId: {
      type: Number,
      required: true
    },
    assignee: {
      type: null,
      required: true
    },
    status: {
      type: Number,
      required: true
    },
    assessed: {
      type: Boolean,
      default: false,
      required: true
    },
    board: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    return {
      taskStatus: null,
      taskAssignee: null,
      taskBoard: null,
      disableAPI: false,
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      confOpened: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['isAdmin', 'taskStatuses', 'taskStatusesForSelect', 'taskAssigneeForSelect', 'getConfData']), {
    taskStatusesForSelectBasedOnTaskAssessment: function taskStatusesForSelectBasedOnTaskAssessment() {
      var statuses = [];
      for (var i = 0; i < this.taskStatusesForSelect.length; i++) {
        var item = this.taskStatusesForSelect[i];
        if (this.isAdmin) {
          if (item.value === 3) {
            continue;
          }
        } else {
          if (this.assessed && item.value === 3) {
            continue;
          }
          if (!this.assessed && item.value === 4) {
            continue;
          }
        }
        statuses.push(item);
      }
      return statuses;
    },
    imageBase: function imageBase() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].serverUserImages;
    },
    taskBoardsForSelect: function taskBoardsForSelect() {
      return [{
        label: 'Focus',
        value: 1
      }, {
        label: 'Backlog',
        value: 2
      }];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['clearConfAction', 'setInformationMsg', 'initConfAction']), {
    changeTaskStatus: function changeTaskStatus() {
      var _this = this;

      if (!this.taskStatus || this.taskStatus.value === this.status) {
        return;
      }
      var data = {
        taskId: this.taskId,
        status: this.taskStatus.value
      };
      if (this.company) {
        data['company'] = this.company;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.task + '/change/status', data, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function () {
        _this.$emit('task-changed', {
          status: _this.taskStatus.value
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    changeTaskAssignee: function changeTaskAssignee() {
      var _this2 = this;

      if (!this.taskAssignee || this.taskAssignee.value === this.assignee) {
        return;
      }
      var data = {
        taskId: this.taskId,
        assignee: this.taskAssignee.value
      };
      if (this.company) {
        data['company'] = this.company;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.task + '/change/assignee', data, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (response) {
        _this2.$emit('task-changed', {
          assignee: {
            name: response.body.name,
            fullName: response.body.fullName,
            image: response.body.image
          }
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    changeTaskBoard: function changeTaskBoard() {
      var _this3 = this;

      var board = this.taskBoardsForSelect.find(function (item) {
        return item.value === _this3.board;
      });
      if (!board) {
        return;
      }
      if (this.taskBoard.value === this.board) {
        return;
      }
      var data = {
        taskId: this.taskId,
        board: this.taskBoard.value
      };
      if (this.company) {
        data['company'] = this.company;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.task + '/change/board', data, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.$emit('task-changed', {
          board: res.body.boardName
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    setTaskStatus: function setTaskStatus() {
      var _this4 = this;

      var status = this.taskStatuses.find(function (item) {
        return item.id === _this4.status;
      });
      if (status) {
        this.taskStatus = {
          label: status.name,
          value: status.id
        };
      }
    },
    setTaskAssignee: function setTaskAssignee() {
      var _this5 = this;

      var assignee = this.taskAssigneeForSelect.find(function (item) {
        return item.value === _this5.assignee;
      });
      if (assignee) {
        this.taskAssignee = assignee;
      }
    },
    setTaskBoard: function setTaskBoard() {
      var _this6 = this;

      var board = this.taskBoardsForSelect.find(function (item) {
        return item.value === _this6.board;
      });
      if (board) {
        this.taskBoard = board;
      } else if (this.board === 3) {
        this.taskBoard = {
          label: 'Completed',
          value: 3
        };
      }
    },
    resetTaskMessages: function resetTaskMessages() {
      this.confOpened = 'reset-task-messages';
      this.initConfAction({
        actionName: 'resetTaskMessagesById'
      });
    },
    resetTaskMessagesConfirmed: function resetTaskMessagesConfirmed() {
      var _this7 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.task + '/reset-messages/' + this.company + '/' + this.taskId, {}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this7.infMsgTitle = 'Task history was successfully reset. Reloading...';
        _this7.infMsgDescription = '';
        _this7.infMsgClass = 'success';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
        setTimeout(function () {
          _this7.$router.go();
        }, 2000);
      }).catch(function (err) {
        console.log(err);
        _this7.disableAPI = false;
        _this7.infMsgTitle = 'Error. We can\'t reset task history because ';
        for (var error in err.body.error.exception) {
          _this7.infMsgTitle += err.body.error.exception[error].message + ' ';
        }
        if (_this7.isAdmin) {
          _this7.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.';
        } else {
          _this7.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.';
        }
        _this7.infMsgClass = 'error';
        _this7.setInformationMsg({
          isShown: true,
          title: _this7.infMsgTitle,
          text: _this7.infMsgDescription,
          className: _this7.infMsgClass
        });
        console.log(err);
      });
      this.getConfData.actionConfirmed = false;
    }
  }),
  components: {
    AppSelect: __WEBPACK_IMPORTED_MODULE_3__components_admin_common_Select___default.a
  },
  watch: {
    status: function status(value) {
      if (value) {
        this.setTaskStatus();
      }
    },
    board: function board(value) {
      if (value) {
        this.setTaskBoard();
      }
    },
    assignee: function assignee(value) {
      if (value) {
        this.setTaskAssignee();
      }
    },
    taskStatuses: function taskStatuses(value) {
      if (value) {
        this.setTaskStatus();
      }
    },
    taskAssigneeForSelect: function taskAssigneeForSelect(value) {
      if (value) {
        this.setTaskAssignee();
      }
    },
    'getConfData.actionConfirmed': function getConfDataActionConfirmed(value) {
      if (value) {
        if (this.confOpened === 'reset-task-messages') this.resetTaskMessagesConfirmed();
        this.clearConfAction();
      }
    }
  },
  created: function created() {
    this.setTaskStatus();
    this.setTaskAssignee();
    this.setTaskBoard();
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-content',
  props: {
    company: Number,
    taskId: {
      type: Number,
      required: true
    },
    taskImage: {
      required: true
    },
    taskTitle: {
      type: String,
      required: true
    },
    taskImageAlt: {
      required: true
    },
    taskContent: {
      required: true
    },
    taskResources: {
      type: Array,
      required: true
    },
    taskContentType: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      player: {
        shown: false,
        url: '',
        options: ''
      },
      related: []
    };
  },

  computed: {
    taskImageFullPath: function taskImageFullPath() {
      return this.taskImage ? __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverContenImages + this.taskImage : '';
    }
  },
  methods: {
    youtubeParser: function youtubeParser(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : false;
    },
    vimeoParser: function vimeoParser(url) {
      var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
      var match = url.match(regExp);
      return match[5] || false;
    },
    getVideoUrl: function getVideoUrl(url) {
      if (!url) {
        return;
      }
      var linkPart = url.split('/');
      var link = void 0;
      var id = void 0;
      if (linkPart[2].indexOf('youtu') !== -1) {
        id = this.youtubeParser(url);
        if (!id) {
          return;
        }
        link = linkPart[0] + '//www.youtube.com/embed/' + id;
      }
      if (linkPart[2].indexOf('vimeo') !== -1) {
        id = this.vimeoParser(url);
        if (!id) {
          return;
        }
        link = linkPart[0] + '//player.vimeo.com/video/' + id;
      }
      return link;
    },
    initPlayer: function initPlayer(autoPlay) {
      var newVideoUrl = this.getVideoUrl(this.player.url);
      if (autoPlay) {
        newVideoUrl += '?autoplay=1&loop=1';
      }
      this.player.url = newVideoUrl;
      this.player.shown = true;
    },
    initPlayerTemp: function initPlayerTemp() {
      if (this.taskContentType === 7 && this.taskResources !== null) {
        var resources = this.taskResources;
        var poster = this.taskImage !== null;
        this.player.url = resources[0].link !== '' ? resources[0].link : null;
        if (!poster) {
          this.initPlayer(false);
        }
      } else {
        this.player = {
          shown: false,
          url: '',
          options: ''
        };
      }
    },
    playVideo: function playVideo() {
      this.initPlayer(true);
      if (window._paq) {
        window._paq.push(['trackEvent', 'VIDEO', 'Play', this.taskTitle]);
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'VIDEO',
      //     eventAction: 'Play',
      //     eventLabel: this.taskTitle,
      //     eventValue: 1,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    },
    getTaskRelated: function getTaskRelated() {
      var _this = this;

      var actionURL = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.task + '/related/' + this.taskId;
      if (this.company) {
        actionURL += '?company=' + this.company;
      }
      this.$http.get(actionURL, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this.related = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.body.featured), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.body.regular));
      }).catch(function (err) {
        console.log(err);
      });
    },
    getFullServerPath: function getFullServerPath(fileName) {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverContenImages + fileName;
    },
    gaDownloadEvent: function gaDownloadEvent(file) {
      var name = file.name || file.file;
      if (window._paq) {
        window._paq.push(['trackEvent', 'FILE', 'Download', name]);
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'FILE',
      //     eventAction: 'Download',
      //     eventLabel: name,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    },
    downloadFile: function downloadFile(file) {
      this.gaDownloadEvent(file);
      var actionURL = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].URLS.content + '/download-file';
      if (this.company) {
        actionURL += '?company=' + this.company;
      }
      var fileName = file.name || file.file;
      var data = {
        type: 'content',
        content: this.taskId,
        file: file.file
      };
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].headersAuthSettings, {
        responseType: 'blob'
      });
      this.$http.post(actionURL, data, options).then(function (res) {
        var data = new Blob([res['data']]);
        if (window.navigator.msSaveBlob) {
          navigator.msSaveBlob(data, fileName);
        } else {
          var dataUrl = URL.createObjectURL(data);
          var link = document.createElement('A');
          link.setAttribute('href', dataUrl);
          link.setAttribute('download', fileName);
          link.click();
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  components: {},
  mounted: function mounted() {
    this.initPlayerTemp();
  },
  created: function created() {
    this.getTaskRelated();
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.id !== from.params.id || to.params.companyId && from.params.companyId && to.params.companyId !== from.params.companyId) {
        this.getTaskRelated();
      }
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuescroll__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuescroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuescroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_avatar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_avatar__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-history',
  props: {
    company: Number,
    taskId: {
      type: Number,
      required: true
    },
    newStatus: {
      type: Number
    },
    newAssignee: {
      type: Object
    },
    newBoard: {
      type: String
    },
    submitting: false
  },
  data: function data() {
    return {
      messageForm: {
        text: '',
        files: []
      },
      loadingMessages: false,
      deleteInProgress: null,
      scrollBarOptions: {
        scrollPanel: {
          scrollingX: false,
          initialScrollY: '100%'
        },
        bar: {
          background: '#22b6cd',
          opacity: '0.4'
        }
      },
      taskHistory: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['taskStatuses', 'taskMessageAllowedFileFormats', 'getFirstName', 'getLastName', 'getUserId', 'isAdmin']), {
    nowDateTimeString: function nowDateTimeString() {
      var currentDate = new Date();
      var date = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate();
      var month = currentDate.getMonth() < 9 ? '0' + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
      var year = currentDate.getFullYear();
      var hours = currentDate.getHours();
      var minutes = currentDate.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours || 12;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      return date + '-' + month + '-' + year + ', ' + hours + ':' + minutes + ' ' + ampm;
    },
    fileServerBase: function fileServerBase() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverContenImages;
    }
  }),
  methods: {
    processFiles: function processFiles(event) {
      var self = this;
      var files = event.target.files;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(files).map(function (key) {
        var file = files[key];
        var reader = new FileReader();
        var fileSize = (file.size / (1024 * 1024 * 25)).toFixed(2);
        if (fileSize > 1) {
          alert('Files attached shouldn\'t be larger than 25 MB.');
          return;
        }
        reader.onload = function (e) {
          var fileName = file.name;
          var valueTrimmed = fileName.replace(/\.[^/.]+$/, '');
          var extension = fileName.split('.').pop().toLowerCase();
          if (self.taskMessageAllowedFileFormats.indexOf(extension) === -1) {
            alert('Only accepted formats: ' + self.taskMessageAllowedFileFormats.join(', ') + '!');
            return;
          }
          self.messageForm.files.push({
            name: valueTrimmed,
            body: e.target.result,
            extension: extension
          });
        };
        reader.readAsDataURL(file);
      });
    },
    messageSubmit: function messageSubmit(event) {
      var _this = this;

      if (this.messageForm.text === '' && !this.messageForm.files.length) {
        return;
      }
      var createdMessageId = this.temporaryMessage();
      var createdMessage = this.taskHistory.find(function (item) {
        return item.id === createdMessageId;
      });
      var data = {
        taskId: this.taskId,
        text: this.messageForm.text,
        files: this.messageForm.files.length ? this.messageForm.files : null
      };
      if (this.company) {
        data['company'] = this.company;
      }
      this.submitting = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.task + '/message/submit', data, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function () {
        _this.messageFormReset(event.target);
        _this.getHistoryMessages();
        _this.scrollMessages();
        _this.refreshMessages();
        _this.submitting = false;
      }).catch(function () {
        createdMessage.notSent = true;
        _this.submitting = false;
      });
    },
    getHistoryMessages: function getHistoryMessages() {
      var _this2 = this;

      var actionURL = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.task + '/message/list/' + this.taskId;
      if (this.company) {
        actionURL += '?company=' + this.company;
      }
      this.$http.get(actionURL, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.taskHistory = res.body;
        _this2.scrollMessages();
      }).catch(function () {});
    },
    deleteMessage: function deleteMessage(message) {
      var _this3 = this;

      this.deleteInProgress = message.id;
      setTimeout(function () {
        message.deleted = true;
        message.deletedBy = _this3.getFirstName + ' ' + _this3.getLastName.charAt(0) + '.';
        message.deletedOn = _this3.nowDateTimeString;
        message.files = null;
      }, 400);
      this.$http.delete(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.task + '/message/' + message.id, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings).then(function (res) {
        setTimeout(function () {
          _this3.deleteInProgress = null;
        }, 400);
      }).catch(function (err) {
        console.log(err);
      });
    },
    retrySendMessage: function retrySendMessage(message) {
      message.notSent = false;
      this.updateTaskHistory();
    },
    loadOldMessages: function loadOldMessages() {
      var _this4 = this;

      if (this.loadingMessages) {
        return;
      }
      this.loadingMessages = true;
      setTimeout(function () {
        var _taskHistory;

        (_taskHistory = _this4.taskHistory).unshift.apply(_taskHistory, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this4.taskHistory));
        _this4.loadingMessages = false;
      }, 5000);
    },
    messageFormReset: function messageFormReset(form) {
      form.reset();
      this.messageForm.text = '';
      this.messageForm.files = [];
    },
    removeMessageFile: function removeMessageFile(index) {
      this.messageForm.files.splice(index, 1);
    },
    temporaryMessage: function temporaryMessage() {
      var id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999);
      var message = {
        id: id,
        userName: 'You',
        userId: this.getUserId,
        clearOfficer: this.isAdmin,
        clearBot: false,
        date: this.nowDateTimeString,
        type: 1,
        deleted: false,
        text: this.messageForm.text
      };
      if (this.messageForm.files && this.messageForm.files.length) {
        message.files = [];
        for (var i = 0; i < this.messageForm.files.length; i++) {
          message.files.push({
            name: this.messageForm.files[i]['name'],
            link: null
          });
        }
      }
      // this.taskHistory.push(message)
      return id;
    },
    temporaryStatus: function temporaryStatus(status) {
      var id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999);
      var message = {
        id: id,
        userName: 'You',
        userId: this.getUserId,
        clearOfficer: this.isAdmin,
        clearBot: false,
        date: this.nowDateTimeString,
        type: 2,
        status: status
      };
      this.taskHistory.push(message);
      return id;
    },
    temporaryAssignee: function temporaryAssignee(assignee) {
      var id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999);
      var message = {
        id: id,
        userName: 'You',
        userId: this.getUserId,
        clearOfficer: this.isAdmin,
        clearBot: false,
        date: this.nowDateTimeString,
        type: 3,
        assigneeFullName: assignee.fullName,
        assigneeName: assignee.name,
        assigneeImage: assignee.image ? __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverUserImages + assignee.image : null
      };
      this.taskHistory.push(message);
      return id;
    },
    temporaryBoard: function temporaryBoard(boardName) {
      var id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999);
      var message = {
        id: id,
        userName: 'You',
        userId: this.getUserId,
        clearOfficer: this.isAdmin,
        clearBot: false,
        date: this.nowDateTimeString,
        type: 4,
        board: boardName
      };
      this.taskHistory.push(message);
      return id;
    },
    scrollMessages: function scrollMessages() {
      var self = this;
      setTimeout(function () {
        self.$refs['historyMsg'].scrollTo({
          y: '100%'
        }, 0, 'easeInQuad');
      }, 200);
    },
    refreshMessages: function refreshMessages() {
      this.$refs['historyMsg'].refresh();
    },
    handleScroll: function handleScroll(vertical, horizontal, nativeEvent) {
      if (vertical.scrollTop <= 100) {
        // this.loadOldMessages()
      }
    },
    getStatusById: function getStatusById(id) {
      return this.taskStatuses.find(function (item) {
        return item.id === id;
      });
    },
    isMineMessage: function isMineMessage(message) {
      return this.isAdmin && (message.clearOfficer || message.clearBot) || !this.isAdmin && !message.clearOfficer && !message.clearBot;
    },
    updateTaskHistory: function updateTaskHistory() {
      this.taskHistory = [].concat(this.taskHistory);
    },
    downloadFile: function downloadFile(file, message) {
      var actionURL = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].URLS.content + '/download-file';
      if (this.company) {
        actionURL += '?company=' + this.company;
      }
      var data = {
        type: 'task-history',
        content: this.taskId,
        message: message,
        file: file.file
      };
      var options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].headersAuthSettings, {
        responseType: 'blob'
      });
      this.$http.post(actionURL, data, options).then(function (res) {
        var data = new Blob([res['data']]);
        if (window.navigator.msSaveBlob) {
          navigator.msSaveBlob(data, file.file);
        } else {
          var dataUrl = URL.createObjectURL(data);
          var link = document.createElement('A');
          link.setAttribute('href', dataUrl);
          link.setAttribute('download', file.file);
          link.click();
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  components: {
    vuescroll: __WEBPACK_IMPORTED_MODULE_5_vuescroll___default.a,
    Avatar: __WEBPACK_IMPORTED_MODULE_6_vue_avatar___default.a
  },
  mounted: function mounted() {},
  created: function created() {
    this.getHistoryMessages();
    // const messagesBody = document.querySelector('.task-history-body')
    // messagesBody.addEventListener('ps-scroll-up', function (event) {
    //   console.log(event)
    // })
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.id !== from.params.id || to.params.companyId && from.params.companyId && to.params.companyId !== from.params.companyId) {
        this.getHistoryMessages();
      }
    },
    newStatus: function newStatus(value) {
      this.temporaryStatus(value);
      this.scrollMessages();
    },
    newAssignee: function newAssignee(value) {
      this.temporaryAssignee(value);
      this.scrollMessages();
    },
    newBoard: function newBoard(value) {
      this.temporaryBoard(value);
      this.scrollMessages();
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskHistory__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TaskHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TaskContent__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TaskContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TaskContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TaskActions__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TaskActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TaskActions__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-single',
  props: {
    company: Number
  },
  data: function data() {
    return {
      taskId: null,
      task: null,
      newStatus: null,
      newAssignee: null,
      newBoard: null,
      previousRoute: null,
      activeContent: true,
      activeHistory: true,
      companies: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['getUserRole', 'tasksPriorities', 'taskStatuses', 'taskStatusesForSelect', 'taskChapters', 'isAdmin']), {
    currentCompany: function currentCompany() {
      var _this = this;

      return this.companies.find(function (item) {
        return item.value === _this.company;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getTaskChapters', 'getTaskStatuses', 'getTaskAssignee']), {
    getChapterById: function getChapterById(id) {
      return this.taskChapters.find(function (item) {
        return item.id === id;
      });
    },
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    setChaptersProgress: function setChaptersProgress() {
      var self = this;
      setTimeout(function () {
        self.taskChapters.forEach(function (chapter) {
          var score = chapter.score;
          var selector = '.task-single .filters_progress_value-' + chapter.id;
          self.setCompanyProgress(score, selector);
        });
      }, 1000);
    },
    setCompanyProgress: function setCompanyProgress(value, selector) {
      var RADIUS = 44;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      var progressValue = document.querySelectorAll(selector);
      if (progressValue.length) {
        for (var i = 0; i < progressValue.length; i++) {
          var progress = value / 100;
          if (progressValue[i]) {
            progressValue[i].style.opacity = 1;
            progressValue[i].style.strokeDasharray = CIRCUMFERENCE;
            progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress);
          }
        }
      }
    },
    taskPriorityLabelByValue: function taskPriorityLabelByValue(value) {
      var priority = this.tasksPriorities.find(function (item) {
        return item.value === value;
      });
      return priority ? priority.label : '';
    },
    taskPriorityDelta: function taskPriorityDelta(value) {
      var priorityDelta = 0;
      if (value <= 33) {
        priorityDelta = 0;
      } else if (value > 33 && value <= 66) {
        priorityDelta = 1;
      } else if (value > 66 && value <= 100) {
        priorityDelta = 2;
      }
      return priorityDelta;
    },
    getTaskById: function getTaskById() {
      var _this2 = this;

      var actionURL = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.task + '/browse/' + this.taskId;
      if (this.company) {
        actionURL += '?company=' + this.company;
      }
      this.$http.get(actionURL, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this2.task = res.body;
        document.title = _this2.task.title + ' | Clear Assured';
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname]);
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['trackPageView']);
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'TASK')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch(function (err) {
        if (err.status === 404) {
          var props = _this2.$router.resolve({
            name: 'no-permissions'
          });
          _this2.$router.push(props.href);
        }
      });
    },
    taskChanged: function taskChanged(event) {
      if (event.hasOwnProperty('status')) {
        this.newStatus = event.status;
      }
      if (event.hasOwnProperty('assignee')) {
        this.newAssignee = event.assignee;
      }
      if (event.hasOwnProperty('board')) {
        this.newBoard = event.board;
      }
      this.getTaskById();
    },
    isSectionCollapsed: function isSectionCollapsed(section) {
      return this[section] === false;
    },
    collapseSection: function collapseSection(section) {
      this[section] = !this[section];
    },
    changeCompany: function changeCompany(event) {
      if (event.value === this.company) {
        return;
      }
      var props = this.$router.resolve({
        name: 'company-task',
        params: {
          companyId: event.value,
          id: this.taskId
        }
      });
      // this.$router.push(props.href)
      location.href = props.href;
    },
    getAllCompaniesForSelect: function getAllCompaniesForSelect() {
      var _this3 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].URLS.companiesS + '/all/select', __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].headersAuthSettings).then(function (res) {
        _this3.companies = res.body;
      }).catch(function () {});
    }
  }),
  beforeMount: function beforeMount() {
    this.getTaskChapters(this.company);
    this.getTaskStatuses(this.company);
    this.getTaskAssignee(this.company);
  },
  created: function created() {
    this.taskId = parseInt(this.$route.params.id);
    this.getTaskById();
    if (this.isAdmin) {
      this.getAllCompaniesForSelect();
    }
  },

  components: {
    TaskActions: __WEBPACK_IMPORTED_MODULE_5__TaskActions___default.a,
    TaskContent: __WEBPACK_IMPORTED_MODULE_4__TaskContent___default.a,
    TaskHistory: __WEBPACK_IMPORTED_MODULE_3__TaskHistory___default.a
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.taskId = parseInt(to.params.id);
        this.getTaskById();
      }
      if (to.params.companyId !== from.params.companyId) {
        this.taskId = parseInt(to.params.id);
        this.getTaskById();
      }
    },
    taskChapters: function taskChapters(value) {
      if (value) {
        this.setChaptersProgress();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.prevRoute = from;
    });
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_avatar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_avatar__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tasks-device-filters',
  props: {
    company: Number,
    onlySearch: {
      type: Boolean,
      default: false
    },
    list: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['focus', 'backlog'].indexOf(value) !== -1;
      }
    }
  },
  data: function data() {
    return {
      titleSearchFilter: {
        focus: '',
        backlog: ''
      },
      titleSearchFilterFocused: false,
      chaptersFilter: {
        focus: [],
        backlog: []
      },
      assigneeFilter: {
        focus: [],
        backlog: []
      },
      statusFilter: [],
      mandatoryFilter: [],
      inputTimer: null,
      assignee: [],
      activeChapterFilter: {
        focus: false,
        backlog: false
      },
      activeAssigneeFilter: {
        focus: false,
        backlog: false
      },
      activeStatusFilter: {
        focus: false,
        backlog: false
      },
      activeMandatoryFilter: {
        focus: false,
        backlog: false
      }
    };
  },

  methods: {
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    setChaptersProgress: function setChaptersProgress() {
      var self = this;
      setTimeout(function () {
        self.taskChapters.forEach(function (chapter) {
          var score = chapter.score;
          var selector = '.tasks-device-filters-chapter-items .filters_progress_value-' + chapter.id;
          self.setCompanyProgress(score, selector);
        });
      }, 1000);
    },
    setCompanyProgress: function setCompanyProgress(value, selector) {
      var RADIUS = 44;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      var progressValue = document.querySelectorAll(selector);
      if (progressValue.length) {
        for (var i = 0; i < progressValue.length; i++) {
          var progress = value / 100;
          if (progressValue[i]) {
            progressValue[i].style.opacity = 1;
            progressValue[i].style.strokeDasharray = CIRCUMFERENCE;
            progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress);
          }
        }
      }
    },
    filterByChapter: function filterByChapter(chapter) {
      var chapterFilterExistsIndex = this.chaptersFilter[this.list].indexOf(chapter.id.toString());
      if (chapterFilterExistsIndex > -1) {
        this.chaptersFilter[this.list].splice(chapterFilterExistsIndex, 1);
      } else {
        this.chaptersFilter[this.list].push(chapter.id.toString());
      }
      if (this.chaptersFilter[this.list].length > 0) {
        if (this.list === 'focus') {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              fc: encodeURIComponent(this.chaptersFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        } else {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              bc: encodeURIComponent(this.chaptersFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        }
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        if (this.list === 'focus') {
          delete query.fc;
        } else {
          delete query.bc;
        }
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    filterByAssignee: function filterByAssignee(user) {
      if (user) {
        var userFilterExistsIndex = this.assigneeFilter[this.list].indexOf(user.value.toString());
        if (userFilterExistsIndex > -1) {
          this.assigneeFilter[this.list].splice(userFilterExistsIndex, 1);
        } else {
          this.assigneeFilter[this.list].push(user.value.toString());
        }
      } else {
        var _userFilterExistsIndex = this.assigneeFilter[this.list].indexOf('unassigned');
        if (_userFilterExistsIndex > -1) {
          this.assigneeFilter[this.list].splice(_userFilterExistsIndex, 1);
        } else {
          this.assigneeFilter[this.list].push('unassigned');
        }
      }
      if (this.assigneeFilter[this.list].length > 0) {
        if (this.list === 'focus') {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              fa: encodeURIComponent(this.assigneeFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        } else {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              ba: encodeURIComponent(this.assigneeFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        }
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        if (this.list === 'focus') {
          delete query.fa;
        } else {
          delete query.ba;
        }
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    filterByStatus: function filterByStatus(status) {
      var statusFilterExistsIndex = this.statusFilter.indexOf(status.id.toString());
      if (statusFilterExistsIndex > -1) {
        this.statusFilter.splice(statusFilterExistsIndex, 1);
      } else {
        this.statusFilter.push(status.id.toString());
      }
      if (this.statusFilter.length > 0) {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            status: encodeURIComponent(this.statusFilter.join(','))
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.status;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    filterByMandatory: function filterByMandatory(mandatory) {
      var mandatoryFilterExistsIndex = this.mandatoryFilter.indexOf(mandatory.id.toString());
      if (mandatoryFilterExistsIndex > -1) {
        this.mandatoryFilter.splice(mandatoryFilterExistsIndex, 1);
      } else {
        this.mandatoryFilter.push(mandatory.id.toString());
      }
      if (this.mandatoryFilter.length > 0) {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            mandatory: encodeURIComponent(this.mandatoryFilter.join(','))
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.mandatory;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    isFilterActive: function isFilterActive(type, id) {
      if (type === 'chapter') {
        return this.chaptersFilter[this.list].indexOf(id.toString()) > -1;
      } else if (type === 'assignee') {
        return this.assigneeFilter[this.list].indexOf(id.toString()) > -1;
      } else if (type === 'status') {
        return this.statusFilter.indexOf(id.toString()) > -1;
      } else if (type === 'mandatory') {
        return this.mandatoryFilter.indexOf(id.toString()) > -1;
      }
      return false;
    },
    filterApplied: function filterApplied(type) {
      if (type === 'chapter') {
        return this.chaptersFilter[this.list].length;
      } else if (type === 'assignee') {
        return this.assigneeFilter[this.list].length;
      } else if (type === 'status') {
        return this.statusFilter.length;
      } else if (type === 'mandatory') {
        return this.mandatoryFilter.length;
      }
      return false;
    },
    activeFiltersCount: function activeFiltersCount(type) {
      if (type === 'chapter') {
        return this.chaptersFilter[this.list].length;
      } else if (type === 'assignee') {
        return this.assigneeFilter[this.list].length;
      } else if (type === 'status') {
        return this.statusFilter.length;
      } else if (type === 'mandatory') {
        return this.mandatoryFilter.length;
      }
      return false;
    },
    clearFilter: function clearFilter(type) {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      if (type === 'title') {
        this.titleSearchFilter[this.list] = '';
        if (this.list === 'focus') {
          delete query.ft;
        } else {
          delete query.bt;
        }
      } else if (type === 'chapter') {
        this.chaptersFilter[this.list] = [];
        if (this.list === 'focus') {
          delete query.fc;
        } else {
          delete query.bc;
        }
      } else if (type === 'assignee') {
        this.assigneeFilter[this.list] = [];
        if (this.list === 'focus') {
          delete query.fa;
        } else {
          delete query.ba;
        }
      } else if (type === 'status') {
        this.statusFilter = [];
        delete query.status;
      } else if (type === 'mandatory') {
        this.mandatoryFilter = [];
        delete query.mandatory;
      }
      this.$router.replace({
        hash: this.$route.hash,
        query: query,
        params: { savePosition: true }
      });
    },
    clearFilterItem: function clearFilterItem(type, id) {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      if (type === 'chapter') {
        var itemIndex = this.chaptersFilter[this.list].indexOf(id.toString());
        if (itemIndex > -1) {
          this.chaptersFilter[this.list].splice(itemIndex, 1);
        }
        if (this.list === 'focus') {
          if (this.chaptersFilter[this.list].length) {
            query.fc = encodeURIComponent(this.chaptersFilter[this.list].join(','));
          } else {
            delete query.fc;
          }
        } else {
          if (this.chaptersFilter[this.list].length) {
            query.bc = encodeURIComponent(this.chaptersFilter[this.list].join(','));
          } else {
            delete query.bc;
          }
        }
      } else if (type === 'assignee') {
        var _itemIndex = this.assigneeFilter[this.list].indexOf(id.toString());
        if (_itemIndex > -1) {
          this.assigneeFilter[this.list].splice(_itemIndex, 1);
        }
        if (this.list === 'focus') {
          if (this.assigneeFilter[this.list].length) {
            query.fa = encodeURIComponent(this.assigneeFilter[this.list].join(','));
          } else {
            delete query.fa;
          }
        } else {
          if (this.assigneeFilter[this.list].length) {
            query.ba = encodeURIComponent(this.assigneeFilter[this.list].join(','));
          } else {
            delete query.ba;
          }
        }
      } else if (type === 'status') {
        var _itemIndex2 = this.statusFilter.indexOf(id.toString());
        if (_itemIndex2 > -1) {
          this.statusFilter.splice(_itemIndex2, 1);
        }
        if (this.statusFilter.length) {
          query.status = encodeURIComponent(this.statusFilter.join(','));
        } else {
          delete query.status;
        }
      } else if (type === 'mandatory') {
        var _itemIndex3 = this.mandatoryFilter.indexOf(id.toString());
        if (_itemIndex3 > -1) {
          this.mandatoryFilter.splice(_itemIndex3, 1);
        }
        if (this.mandatoryFilter.length) {
          query.mandatory = encodeURIComponent(this.mandatoryFilter.join(','));
        } else {
          delete query.mandatory;
        }
      }
      this.$router.replace({
        hash: this.$route.hash,
        query: query,
        params: { savePosition: true }
      });
    },
    titleSearchInput: function titleSearchInput(event) {
      if (this.inputTimer) {
        window.clearTimeout(this.inputTimer);
      }
      var self = this;
      this.inputTimer = window.setTimeout(function () {
        self.titleSearchFilter[self.list] = event.target.value;
      }, 400);
    },
    getChapterById: function getChapterById(id) {
      return this.taskChapters.find(function (item) {
        return item.id === id;
      });
    },
    taskAssigneeById: function taskAssigneeById(id) {
      var assignee = this.taskAssigneeForSelect.find(function (item) {
        return item.value === id;
      });
      if (assignee && assignee.value) {
        return assignee;
      }
      return null;
    },
    getStatusById: function getStatusById(id) {
      var status = this.taskStatuses.find(function (item) {
        return item.id === id;
      });
      return status || false;
    },
    getMandatoryById: function getMandatoryById(id) {
      var mandatory = this.taskMandatory.find(function (item) {
        return item.id === id;
      });
      return mandatory || false;
    },
    setupQueryParams: function setupQueryParams() {
      if (this.$route.query.ft && decodeURIComponent(this.$route.query.ft) !== '') {
        this.titleSearchFilter.focus = decodeURIComponent(this.$route.query.ft);
      }
      if (this.$route.query.bt && decodeURIComponent(this.$route.query.bt) !== '') {
        this.titleSearchFilter.backlog = decodeURIComponent(this.$route.query.bt);
      }
      if (this.$route.query.fc && decodeURIComponent(this.$route.query.fc) !== '') {
        this.chaptersFilter.focus = decodeURIComponent(this.$route.query.fc).split(',');
      }
      if (this.$route.query.bc && decodeURIComponent(this.$route.query.bc) !== '') {
        this.chaptersFilter.backlog = decodeURIComponent(this.$route.query.bc).split(',');
      }
      if (this.$route.query.fa && decodeURIComponent(this.$route.query.fa) !== '') {
        this.assigneeFilter.focus = decodeURIComponent(this.$route.query.fa).split(',');
      }
      if (this.$route.query.ba && decodeURIComponent(this.$route.query.ba) !== '') {
        this.assigneeFilter.backlog = decodeURIComponent(this.$route.query.ba).split(',');
      }
      if (this.$route.query.status && decodeURIComponent(this.$route.query.status) !== '') {
        this.statusFilter = decodeURIComponent(this.$route.query.status).split(',');
      }
      if (this.$route.query.mandatory && decodeURIComponent(this.$route.query.mandatory) !== '') {
        this.mandatoryFilter = decodeURIComponent(this.$route.query.mandatory).split(',');
      }
    },
    setupSearchResultsHeight: function setupSearchResultsHeight() {
      var height = document.getElementById('taskHeader').offsetHeight;
      var searchInput = document.querySelector('.tasks-device-filters-search');
      var headerButtons = document.querySelector('.tasks-list-header-buttons');
      if (searchInput) {
        height -= searchInput.offsetHeight;
      }
      if (headerButtons) {
        height -= headerButtons.offsetHeight;
      }
      var results = document.querySelector('.tasks-device-filters-search-results');
      if (results) {
        results.style.height = this.onlySearch ? height - 100 + 'px' : '';
      }
    },
    highlight: function highlight(words, query) {
      var regex = new RegExp(query, 'gi');
      return words.replace(regex, function (str) {
        return '<span class="highlight">' + str + '</span>';
      });
    },
    goToTask: function goToTask(taskId) {
      var routeName = this.isAdmin ? 'company-task' : 'task';
      var routeParams = {
        id: taskId
      };
      if (this.company) {
        routeParams['companyId'] = this.company;
      }
      var props = this.$router.resolve({
        name: routeName,
        params: routeParams
      });
      this.$router.push(props.href);
    },
    triggerFilter: function triggerFilter(filter) {
      switch (filter) {
        case 'chapter':
          this.activeChapterFilter[this.list] = !this.activeChapterFilter[this.list];
          break;
        case 'assignee':
          this.activeAssigneeFilter[this.list] = !this.activeAssigneeFilter[this.list];
          break;
        case 'status':
          this.activeStatusFilter[this.list] = !this.activeStatusFilter[this.list];
          break;
        case 'mandatory':
          this.activeMandatoryFilter[this.list] = !this.activeMandatoryFilter[this.list];
          break;
        default:
          break;
      }
    },
    clearAllFilters: function clearAllFilters() {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      this.titleSearchFilter[this.list] = '';
      this.chaptersFilter[this.list] = [];
      this.assigneeFilter[this.list] = [];
      this.statusFilter = [];
      if (this.list === 'focus') {
        delete query.ft;
        delete query.fc;
        delete query.fa;
      } else {
        delete query.bt;
        delete query.bc;
        delete query.ba;
      }
      delete query.status;
      delete query.mandatory;
      this.$router.replace({
        hash: this.$route.hash,
        query: query,
        params: { savePosition: true }
      });
      this.activeChapterFilter[this.list] = false;
      this.activeAssigneeFilter[this.list] = false;
      this.activeStatusFilter[this.list] = false;
      this.activeMandatoryFilter[this.list] = false;
    },
    taskPriorityDelta: function taskPriorityDelta(value) {
      var priorityDelta = 0;
      if (value <= 33) {
        priorityDelta = 0;
      } else if (value > 33 && value <= 66) {
        priorityDelta = 1;
      } else if (value > 66 && value <= 100) {
        priorityDelta = 2;
      }
      return priorityDelta;
    }
  },
  created: function created() {
    this.setupQueryParams();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getUserRole', 'selectedHightCont', 'taskStatuses', 'taskMandatory', 'taskChapters', 'taskAssignee', 'taskAssigneeForSelect', 'backlogTasks', 'focusTasks', 'isAdmin']), {
    anyFilters: function anyFilters() {
      return this.chaptersFilter[this.list].length || this.assigneeFilter[this.list].length || this.list === 'backlog' && this.statusFilter.length || this.mandatoryFilter.length || this.titleSearchFilter[this.list] !== '';
    },
    imageBase: function imageBase() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverUserImages;
    }
  }),
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_4_vue_avatar___default.a
  },
  mounted: function mounted() {
    this.setChaptersProgress();
    this.setupQueryParams();
    this.setupSearchResultsHeight();
    window.addEventListener('resize', this.setupSearchResultsHeight);
  },

  watch: {
    'titleSearchFilter.focus': function titleSearchFilterFocus(value) {
      if (value && value !== '') {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            ft: encodeURIComponent(value)
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.ft;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    'titleSearchFilter.backlog': function titleSearchFilterBacklog(value) {
      if (value && value !== '') {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            bt: encodeURIComponent(value)
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.bt;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    taskChapters: function taskChapters(value) {
      if (value) {
        this.setChaptersProgress();
      }
    },
    onlySearch: function onlySearch(value) {
      var self = this;
      setTimeout(function () {
        self.setupSearchResultsHeight();
      }, 200);
      if (!value) {
        this.clearFilter('title');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearFilter('title');
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.setupSearchResultsHeight);
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_avatar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_avatar__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tasks-filters',
  props: {
    company: Number,
    list: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['focus', 'backlog'].indexOf(value) !== -1;
      }
    }
  },
  data: function data() {
    return {
      titleSearchFilter: {
        focus: '',
        backlog: ''
      },
      titleSearchFilterFocused: false,
      chaptersFilter: {
        focus: [],
        backlog: []
      },
      assigneeFilter: {
        focus: [],
        backlog: []
      },
      statusFilter: [],
      mandatoryFilter: [],
      inputTimer: null,
      assignee: []
    };
  },

  methods: {
    getChapterBackground: function getChapterBackground(chapter) {
      if (this.selectedHightCont === 1) {
        return 'url(' + chapter.image_high + ')';
      } else {
        return 'url(' + chapter.image + ')';
      }
    },
    setChaptersProgress: function setChaptersProgress() {
      var self = this;
      setTimeout(function () {
        self.taskChapters.forEach(function (chapter) {
          var score = chapter.score;
          var selector = '.tasks-filters .filters_progress_value-' + chapter.id;
          self.setCompanyProgress(score, selector);
        });
      }, 1000);
    },
    setCompanyProgress: function setCompanyProgress(value, selector) {
      var RADIUS = 44;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
      var progressValue = document.querySelectorAll(selector);
      if (progressValue.length) {
        for (var i = 0; i < progressValue.length; i++) {
          var progress = value / 100;
          if (progressValue[i]) {
            progressValue[i].style.opacity = 1;
            progressValue[i].style.strokeDasharray = CIRCUMFERENCE;
            progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress);
          }
        }
      }
    },
    filterByChapter: function filterByChapter(chapter) {
      var chapterFilterExistsIndex = this.chaptersFilter[this.list].indexOf(chapter.id.toString());
      if (chapterFilterExistsIndex > -1) {
        this.chaptersFilter[this.list].splice(chapterFilterExistsIndex, 1);
      } else {
        this.chaptersFilter[this.list].push(chapter.id.toString());
      }
      if (this.chaptersFilter[this.list].length > 0) {
        if (this.list === 'focus') {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              fc: encodeURIComponent(this.chaptersFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        } else {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              bc: encodeURIComponent(this.chaptersFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        }
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        if (this.list === 'focus') {
          delete query.fc;
        } else {
          delete query.bc;
        }
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    filterByAssignee: function filterByAssignee(user) {
      if (user) {
        var userFilterExistsIndex = this.assigneeFilter[this.list].indexOf(user.value.toString());
        if (userFilterExistsIndex > -1) {
          this.assigneeFilter[this.list].splice(userFilterExistsIndex, 1);
        } else {
          this.assigneeFilter[this.list].push(user.value.toString());
        }
      } else {
        var _userFilterExistsIndex = this.assigneeFilter[this.list].indexOf('unassigned');
        if (_userFilterExistsIndex > -1) {
          this.assigneeFilter[this.list].splice(_userFilterExistsIndex, 1);
        } else {
          this.assigneeFilter[this.list].push('unassigned');
        }
      }
      if (this.assigneeFilter[this.list].length > 0) {
        if (this.list === 'focus') {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              fa: encodeURIComponent(this.assigneeFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        } else {
          this.$router.replace({
            hash: this.$route.hash,
            query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
              ba: encodeURIComponent(this.assigneeFilter[this.list].join(','))
            }),
            params: { savePosition: true }
          });
        }
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        if (this.list === 'focus') {
          delete query.fa;
        } else {
          delete query.ba;
        }
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    filterByStatus: function filterByStatus(status) {
      var statusFilterExistsIndex = this.statusFilter.indexOf(status.id.toString());
      if (statusFilterExistsIndex > -1) {
        this.statusFilter.splice(statusFilterExistsIndex, 1);
      } else {
        this.statusFilter.push(status.id.toString());
      }
      if (this.statusFilter.length > 0) {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            status: encodeURIComponent(this.statusFilter.join(','))
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.status;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    filterByMandatory: function filterByMandatory(mandatory) {
      var mandatoryFilterExistsIndex = this.mandatoryFilter.indexOf(mandatory.id.toString());
      if (mandatoryFilterExistsIndex > -1) {
        this.mandatoryFilter.splice(mandatoryFilterExistsIndex, 1);
      } else {
        this.mandatoryFilter.push(mandatory.id.toString());
      }
      if (this.mandatoryFilter.length > 0) {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            mandatory: encodeURIComponent(this.mandatoryFilter.join(','))
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.mandatory;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    isFilterActive: function isFilterActive(type, id) {
      if (type === 'chapter') {
        return this.chaptersFilter[this.list].indexOf(id.toString()) > -1;
      } else if (type === 'assignee') {
        return this.assigneeFilter[this.list].indexOf(id.toString()) > -1;
      } else if (type === 'status') {
        return this.statusFilter.indexOf(id.toString()) > -1;
      } else if (type === 'mandatory') {
        return this.mandatoryFilter.indexOf(id.toString()) > -1;
      }
      return false;
    },
    activeFiltersCount: function activeFiltersCount(type) {
      if (type === 'chapter') {
        return this.chaptersFilter[this.list].length;
      } else if (type === 'assignee') {
        return this.assigneeFilter[this.list].length;
      } else if (type === 'status') {
        return this.statusFilter.length;
      } else if (type === 'mandatory') {
        return this.mandatoryFilter.length;
      }
      return false;
    },
    clearFilter: function clearFilter(type) {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      if (type === 'chapter') {
        this.chaptersFilter[this.list] = [];
        if (this.list === 'focus') {
          delete query.fc;
        } else {
          delete query.bc;
        }
      } else if (type === 'assignee') {
        this.assigneeFilter[this.list] = [];
        if (this.list === 'focus') {
          delete query.fa;
        } else {
          delete query.ba;
        }
      } else if (type === 'status') {
        this.statusFilter = [];
        delete query.status;
      } else if (type === 'mandatory') {
        this.mandatoryFilter = [];
        delete query.mandatory;
      }
      this.$router.replace({
        hash: this.$route.hash,
        query: query,
        params: { savePosition: true }
      });
    },
    clearAllFilters: function clearAllFilters() {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      this.titleSearchFilter[this.list] = '';
      this.chaptersFilter[this.list] = [];
      this.assigneeFilter[this.list] = [];
      this.statusFilter = [];
      if (this.list === 'focus') {
        delete query.ft;
        delete query.fc;
        delete query.fa;
      } else {
        delete query.bt;
        delete query.bc;
        delete query.ba;
      }
      delete query.status;
      delete query.mandatory;
      this.$router.replace({
        hash: this.$route.hash,
        query: query,
        params: { savePosition: true }
      });
    },
    titleSearchInput: function titleSearchInput(event) {
      if (this.inputTimer) {
        window.clearTimeout(this.inputTimer);
      }
      var self = this;
      this.inputTimer = window.setTimeout(function () {
        self.titleSearchFilter[self.list] = event.target.value;
      }, 400);
    }
  },
  created: function created() {
    if (this.$route.query.ft && decodeURIComponent(this.$route.query.ft) !== '') {
      this.titleSearchFilter.focus = decodeURIComponent(this.$route.query.ft);
    }
    if (this.$route.query.bt && decodeURIComponent(this.$route.query.bt) !== '') {
      this.titleSearchFilter.backlog = decodeURIComponent(this.$route.query.bt);
    }
    if (this.$route.query.fc && decodeURIComponent(this.$route.query.fc) !== '') {
      this.chaptersFilter.focus = decodeURIComponent(this.$route.query.fc).split(',');
    }
    if (this.$route.query.bc && decodeURIComponent(this.$route.query.bc) !== '') {
      this.chaptersFilter.backlog = decodeURIComponent(this.$route.query.bc).split(',');
    }
    if (this.$route.query.fa && decodeURIComponent(this.$route.query.fa) !== '') {
      this.assigneeFilter.focus = decodeURIComponent(this.$route.query.fa).split(',');
    }
    if (this.$route.query.ba && decodeURIComponent(this.$route.query.ba) !== '') {
      this.assigneeFilter.backlog = decodeURIComponent(this.$route.query.ba).split(',');
    }
    if (this.$route.query.status && decodeURIComponent(this.$route.query.status) !== '') {
      this.statusFilter = decodeURIComponent(this.$route.query.status).split(',');
    }
    if (this.$route.query.mandatory && decodeURIComponent(this.$route.query.mandatory) !== '') {
      this.mandatoryFilter = decodeURIComponent(this.$route.query.mandatory).split(',');
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['getUserRole', 'selectedHightCont', 'taskStatuses', 'taskMandatory', 'taskChapters', 'taskAssignee']), {
    anyFilters: function anyFilters() {
      return this.chaptersFilter[this.list].length || this.assigneeFilter[this.list].length || this.list === 'backlog' && this.statusFilter.length || this.mandatoryFilter.length || this.titleSearchFilter[this.list] !== '';
    },
    imageBase: function imageBase() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].serverUserImages;
    }
  }),
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_4_vue_avatar___default.a
  },
  mounted: function mounted() {
    this.setChaptersProgress();
  },

  watch: {
    'titleSearchFilter.focus': function titleSearchFilterFocus(value) {
      if (value && value !== '') {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            ft: encodeURIComponent(value)
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.ft;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    'titleSearchFilter.backlog': function titleSearchFilterBacklog(value) {
      if (value && value !== '') {
        this.$router.replace({
          hash: this.$route.hash,
          query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            bt: encodeURIComponent(value)
          }),
          params: { savePosition: true }
        });
      } else {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
        delete query.bt;
        this.$router.replace({
          hash: this.$route.hash,
          query: query,
          params: { savePosition: true }
        });
      }
    },
    taskChapters: function taskChapters(value) {
      if (value) {
        this.setChaptersProgress();
      }
    },
    company: function company(value) {
      if (value) {
        this.setChaptersProgress();
      }
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tour-wizard',
  props: {
    tour: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      currentSlide: 1,
      sliderTotalWidth: 0,
      slideMaxWidth: 0,
      sliderLeftPosition: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])([]), {
    totalSlides: function totalSlides() {
      if (!this.tour.slides) {
        return 0;
      }
      return this.tour.slides.length;
    },
    canGoToTheNext: function canGoToTheNext() {
      return this.tour.slides && this.currentSlide < this.tour.slides.length;
    },
    canGoToThePrevious: function canGoToThePrevious() {
      return this.tour.slides && this.currentSlide > 1;
    },
    previousButtonText: function previousButtonText() {
      if (this.tour && this.tour.navigation && this.tour.navigation.previousBtnText) {
        return this.tour.navigation.previousBtnText;
      }
      return 'Previous step';
    },
    nextButtonText: function nextButtonText() {
      if (this.tour && this.tour.navigation && this.tour.navigation.nextBtnText) {
        return this.tour.navigation.nextBtnText;
      }
      return 'Next step';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])([]), {
    next: function next() {
      if (!this.canGoToTheNext) {
        return;
      }
      this.currentSlide += 1;
    },
    previous: function previous() {
      if (!this.canGoToThePrevious) {
        return;
      }
      this.currentSlide -= 1;
    },
    exit: function exit() {
      if (this.tour && this.tour.endpoint) {
        if (this.tour.endpoint.type === 'internal') {
          var props = this.$router.resolve(this.tour.endpoint.url);
          this.$router.push(props.href);
        } else {
          location.href = this.tour.endpoint.url;
        }
      } else {
        var _props = this.$router.resolve({
          name: 'user-app'
        });
        this.$router.push(_props.href);
      }
    },
    handleKeydown: function handleKeydown(e) {
      switch (e.keyCode) {
        case 37:
          this.previous();
          break;
        case 39:
          this.next();
          break;
        case 27:
          this.exit();
          break;
      }
    },
    touchStart: function touchStart(touchEvent) {
      var _this = this;

      if (touchEvent.changedTouches.length !== 1) {
        return;
      }
      var posXStart = touchEvent.changedTouches[0].clientX;
      var listener = function listener(touchEvent) {
        return _this.touchEnd(touchEvent, posXStart);
      };
      addEventListener('touchend', listener, { once: true });
      setTimeout(function () {
        removeEventListener('touchend', listener);
      }, 800);
    },
    touchEnd: function touchEnd(touchEvent, posXStart) {
      if (touchEvent.changedTouches.length !== 1) {
        return;
      }
      var diff = 200;
      var posXEnd = touchEvent.changedTouches[0].clientX;
      if (diff + posXStart < posXEnd) {
        this.previous();
      } else if (posXStart > posXEnd + diff) {
        this.next();
      }
    },
    calculateSliderTotalWidth: function calculateSliderTotalWidth() {
      this.sliderTotalWidth = document.body.clientWidth * this.totalSlides + 'px';
    },
    calculateSlideMaxWidth: function calculateSlideMaxWidth() {
      this.slideMaxWidth = document.body.clientWidth + 'px';
    },
    calculateSliderLeftPosition: function calculateSliderLeftPosition() {
      this.sliderLeftPosition = document.body.clientWidth * (this.currentSlide - 1) * -1 + 'px';
    },
    calculateSliderHeight: function calculateSliderHeight() {
      setTimeout(function () {
        var activeSlide = document.querySelector('.tour-wizard__slide.active');
        var slider = document.querySelector('.tour-wizard__slides');
        if (activeSlide && slider) {
          if (document.body.clientWidth > 1024) {
            slider.style.height = '';
          } else {
            slider.style.height = activeSlide.clientHeight + 'px';
          }
        }
      }, 100);
    }
  }),
  components: {},
  beforeMount: function beforeMount() {
    window.addEventListener('keydown', this.handleKeydown, null);
    window.addEventListener('resize', this.calculateSliderTotalWidth, null);
    window.addEventListener('resize', this.calculateSlideMaxWidth, null);
    window.addEventListener('resize', this.calculateSliderLeftPosition, null);
    window.addEventListener('resize', this.calculateSliderHeight, null);
  },
  created: function created() {
    this.calculateSliderTotalWidth();
    this.calculateSlideMaxWidth();
    this.calculateSliderLeftPosition();
    this.calculateSliderHeight();
    var app = document.getElementById('app');
    app.style.position = 'relative';
    app.style.zIndex = '9999999999';
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
    window.removeEventListener('resize', this.calculateSliderTotalWidth);
    window.removeEventListener('resize', this.calculateSlideMaxWidth);
    window.removeEventListener('resize', this.calculateSliderLeftPosition);
    window.removeEventListener('resize', this.calculateSliderHeight);
    var app = document.getElementById('app');
    app.style.position = '';
    app.style.zIndex = '';
  },
  beforeUpdate: function beforeUpdate() {
    this.calculateSliderTotalWidth();
    this.calculateSlideMaxWidth();
    this.calculateSliderLeftPosition();
    this.calculateSliderHeight();
  },

  watch: {
    'currentSlide': function currentSlide() {
      var _this2 = this;

      var activeSlide = document.querySelector('.tour-wizard__slide.active');
      if (activeSlide) {
        activeSlide.scrollTo(0, 0);
      }
      document.getElementById('app').scrollIntoView();
      this.$nextTick(function () {
        _this2.calculateSliderHeight();
        var video = document.querySelector('.tour-wizard__slide.active .tour-wizard__slide--media.type-video video');
        if (video) {
          video.currentTime = 0;
          video.play();
        }
      });
    },

    tour: {
      immediate: true,
      handler: function handler(value) {
        if (value) {
          document.title = value.name + ' | Clear Assured';
        }
      }
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TourWizard__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TourWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TourWizard__);

//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tour-wizard-wrapper',
  data: function data() {
    return {
      id: null,
      tours: [{
        id: 'manager-onboarding-tour',
        name: 'Onboarding Tour',
        endpoint: {
          type: 'internal',
          url: '/dashboard'
        },
        navigation: {
          previousBtnText: 'Previous step',
          nextBtnText: 'Next step'
        },
        slides: [{
          title: 'Let’s get you started',
          text: '<p>We’ll help you set the direction and we’ll be there to support you throughout your entire ED&I Journey.</p><p>Before we discuss your strategy, please take a moment to discover the tools and the resources that you can use.</p>',
          media: {
            type: 'image',
            alt: 'Graphic scheme illustrating the steps and workflow of the Clear Assured web application',
            resource: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Dashboard/Dashboard_1_Intro.jpg'
          }
        }, {
          title: 'Here’s your dashboard',
          text: '<p>It displays your assignments, newly added resources and a notification area with system updates.</p>',
          media: {
            type: 'video',
            title: 'Sections in Dashboard',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Dashboard/Dashboard_2_sections.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Let’s have a look at the tasks',
          text: '<p>These are all the actions you may need to complete as part of your ED&I journey, although not all of them are relevant to your organisation or your current strategy.</p>',
          media: {
            type: 'video',
            title: 'Tasks list',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Dashboard/Dashboard_3_Tasks.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Here\'s your backlog',
          text: '<p>Before starting to work on the tasks you will meet your account manager and together you will create an overall strategy and set up an action plan: set your direction, choose the first tasks to work on and bring them to the focus area.</p>',
          media: {
            type: 'video',
            title: 'Set the focus area',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TasksList/TasksList_1_Direction.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Manage your focus area',
          text: '<p>See what everyone is up to or focus on your own assignments. You can change a task\'s status by dragging it across columns or from the detailed view.</p><p>Remember to wait for your first strategy call before dragging tasks into your focus area. Your account manager will help you prioritize the most important tasks to start with.</p>',
          media: {
            type: 'video',
            title: 'Check out a task',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TasksList/TasksList_2_StartWorking.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Start working on your first task',
          text: '<p>Go through the task description and access the related resources to understand what needs to be done.</p>',
          media: {
            type: 'video',
            title: 'Task content',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TaskSingle/TaskSingle_1_ReadDetails.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Collaborate with your team',
          text: '<p>Take notes, log progress, assign it to a colleague or submit it for our review. Your progress will be stored in the task history.</p>',
          media: {
            type: 'video',
            title: 'Update task progress',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TaskSingle/TaskSingle_2_UpdateProgress.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Let’s have a look at the Inclusion Hub',
          text: '<p>The one-stop source of diversity and inclusion resources, accessible to anyone in your organisation. Use the Inclusion Hub to upskill your workforce on all things ED&I.</p>',
          media: {
            type: 'video',
            title: 'Inclusion hub',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TaskSingle/TaskSingle_3_MenuCat-InclusionHub.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Find the resources you need',
          text: '<p>Start typing to search. Filter by topic, category or resource type to narrow down the list of results.</p>',
          media: {
            type: 'video',
            title: 'Search the inclusion hub',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/InclusionHub/InclusionHub_1_Search.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Explore our resources',
          text: '<p>Take a deep dive into a topic or explore resources to get a feel for what you need.</p><p>Get in touch and share your ideas with us. We are always reviewing and updating our content.</p>',
          media: {
            type: 'video',
            title: 'Filter the inclusion hub by category or topic',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/InclusionHub/InclusionHub_2_Filter.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Let’s jump into an individual resource',
          text: '<p>Not what you need? Get in touch and let us know. We value your feedback.</p>',
          media: {
            type: 'video',
            title: 'Inclusion hub article',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/InclusionHub/InclusionHub_3_AccessAnArticle.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Individual resources simple and concise',
          text: '<p>The enclosed information will provide the answers and the related resources will provide the context.</p>',
          media: {
            type: 'video',
            title: 'Article content',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/ArticleSingle/Article_1_BrowseContent.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Ready to share these resources with your colleagues?',
          text: '<p>Let’s see how we can bring them onboard.</p>',
          media: {
            type: 'video',
            title: 'Company users list',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/ArticleSingle/Article_2_MenuCat-Users.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Let’s have a look at your team',
          text: '<p>Here are the users in your organisation. You can search by name and email address, filter by title, role or status and order by creation and last login date.</p>',
          media: {
            type: 'video',
            title: 'Browse users list',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Users/UsersList.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Bring in your team',
          text: '<p>Invite your team to progress your ED&I journey.</p><p>There are 2 types of users: company admins and regular users. Company admins will have the same privileges as you have. Regular users will not be allowed to manage users, change the company profile or access the billing settings. </p>',
          media: {
            type: 'video',
            title: 'Invite users',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Users/InviteUsers.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Manage team members',
          text: '<p>Find the relevant team member and click anywhere in the table row to access their profile.</p>',
          media: {
            type: 'video',
            title: 'User profile',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/UserProfile/UserProfile-1-SeeProfile.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Answer help calls',
          text: '<p>Your colleagues may need your help to manage their accounts. As an organisation administrator, you can manage their login credentials and their profile information.</p>',
          media: {
            type: 'video',
            title: 'Edit user’s details',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/UserProfile/UserProfile-2-EditUser.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'You are now ready to explore the Clear Assured and start planning your ED&I journey.',
          text: '<p>Thank you for taking the time to get familiar with the application.</p>',
          media: {
            type: 'image',
            alt: 'Random cheerful image (the one in the design)',
            resource: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TourCompleted/TourComplete.jpeg'
          }
        }]
      }, {
        id: 'regular-onboarding-tour',
        name: 'Onboarding Tour',
        endpoint: {
          type: 'internal',
          url: '/dashboard'
        },
        navigation: {
          previousBtnText: 'Previous step',
          nextBtnText: 'Next step'
        },
        slides: [{
          title: 'Let’s get you started',
          text: '<p>We’ll help you set the direction and we’ll be there to support you throughout your entire ED&I Journey.</p><p>Before we discuss your strategy, please take a moment to discover the tools and the resources that you can use.</p>',
          media: {
            type: 'image',
            alt: 'Graphic scheme illustrating the steps and workflow of the Clear Assured web application',
            resource: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Dashboard/Dashboard_1_Intro.jpg'
          }
        }, {
          title: 'Here’s your dashboard',
          text: '<p>It displays your assignments, newly added resources and a notification area with system updates.</p>',
          media: {
            type: 'video',
            title: 'Sections in Dashboard',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Dashboard/Dashboard_2_sections.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Let’s have a look at the tasks',
          text: '<p>These are all the actions you may need to complete as part of your ED&I journey, although not all of them are relevant to your organisation or your current strategy.</p>',
          media: {
            type: 'video',
            title: 'Tasks list',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/Dashboard/Dashboard_3_Tasks.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Here\'s your backlog',
          text: '<p>Before starting to work on the tasks you will meet your account manager and together you will create an overall strategy and set up an action plan: set your direction, choose the first tasks to work on and bring them to the focus area.</p>',
          media: {
            type: 'video',
            title: 'Set the focus area',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TasksList/TasksList_1_Direction.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Manage your focus area',
          text: '<p>See what everyone is up to or focus on your own assignments. You can change a task\'s status by dragging it across columns or from the detailed view.</p><p>Remember to wait for your first strategy call before dragging tasks into your focus area. Your account manager will help you prioritize the most important tasks to start with.</p>',
          media: {
            type: 'video',
            title: 'Check out a task',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TasksList/TasksList_2_StartWorking.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Start working on your first task',
          text: '<p>Go through the task description and access the related resources to understand what needs to be done.</p>',
          media: {
            type: 'video',
            title: 'Task content',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TaskSingle/TaskSingle_1_ReadDetails.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Collaborate with your team',
          text: '<p>Take notes, log progress, assign it to a colleague or submit it for our review. Your progress will be stored in the task history.</p>',
          media: {
            type: 'video',
            title: 'Update task progress',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TaskSingle/TaskSingle_2_UpdateProgress.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Let’s have a look at the Inclusion Hub',
          text: '<p>The one-stop source of diversity and inclusion resources, accessible to anyone in your organisation. Use the Inclusion Hub to upskill your workforce on all things ED&I.</p>',
          media: {
            type: 'video',
            title: 'Inclusion hub',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TaskSingle/TaskSingle_3_MenuCat-InclusionHub.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Find the resources you need',
          text: '<p>Start typing to search. Filter by topic, category or resource type to narrow down the list of results.</p>',
          media: {
            type: 'video',
            title: 'Search the inclusion hub',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/InclusionHub/InclusionHub_1_Search.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Explore our resources',
          text: '<p>Take a deep dive into a topic or explore resources to get a feel for what you need.</p><p>Get in touch and share your ideas with us. We are always reviewing and updating our content.</p>',
          media: {
            type: 'video',
            title: 'Filter the inclusion hub by category or topic',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/InclusionHub/InclusionHub_2_Filter.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Let’s jump into an individual resource',
          text: '<p>Not what you need? Get in touch and let us know. We value your feedback.</p>',
          media: {
            type: 'video',
            title: 'Inclusion hub article',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/InclusionHub/InclusionHub_3_AccessAnArticle.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'Individual resources simple and concise',
          text: '<p>The enclosed information will provide the answers and the related resources will provide the context.</p>',
          media: {
            type: 'video',
            title: 'Article content',
            sources: [{
              src: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/ArticleSingle/Article_1_BrowseContent.mp4',
              type: 'video/mp4'
            }]
          }
        }, {
          title: 'You are now ready to explore the Clear Assured and start planning your ED&I journey.',
          text: '<p>Thank you for taking the time to get familiar with the application.</p>',
          media: {
            type: 'image',
            alt: 'Random cheerful image (the one in the design)',
            resource: 'https://api.stage.clearassured.co.uk/uploads/tour-wizard/onboarding-tour/TourCompleted/TourComplete.jpeg'
          }
        }]
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])([]), {
    tour: function tour() {
      var _this = this;

      var tour = this.tours.find(function (t) {
        return t.id === _this.id;
      });
      if (!tour) {
        console.warn('Invalid tour id provided in the ClearAssured tour wizard.');
        return null;
      }
      return tour;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])([])),
  components: {
    TourWizard: __WEBPACK_IMPORTED_MODULE_2__TourWizard___default.a
  },
  beforeMount: function beforeMount() {},
  created: function created() {
    this.id = this.$route.params.id;
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  watch: {
    '$route.params.id': function $routeParamsId(value) {
      if (value) {
        this.id = this.$route.params.id;
      }
    }
  }
});

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ1RjREMTkzQzk0NzExRTdBMEIzQjRGMzhCRjY5OTQyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQ1RjREMTk0Qzk0NzExRTdBMEIzQjRGMzhCRjY5OTQyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDVGNEQxOTFDOTQ3MTFFN0EwQjNCNEYzOEJGNjk5NDIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDVGNEQxOTJDOTQ3MTFFN0EwQjNCNEYzOEJGNjk5NDIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6Dh/NRAAABVklEQVR42qyUMUsDQRCF5yRGjJUWculsRIvFVhcUsVQwpMgfSKfgT7FQUIuz004QC8VgYyM21toFleuihGBlYbG+1dlkHG5TOfBxtzs7b+fu3h4550iRAAsykLvfyHlsOf+nRgsYLjgE82AclPi6DE45b2Iidd51SQmPgRvwBdpuEHUtYjjRA2UlMgkuXHGYIJKIZ54SxbPgHhyDz4iIr0tIvET9ck9AFbRAB6xGhGyJiJpgjwZRBtvgDfRADSyCCSqOJnFLVnRxJXZ5B+tg38UjJ745Y4ERNzxa/IU+5GToJBWd3A0RWQMLYu1D6CRjY4XEKGiA3YjQnFi74uvD1zkosL9nRwmcq7yvs9InaYHIjBKZFrlU+iQ49pktLkUqQuBWHYW2dKw8O69sMDn/xCJbPK7yuv7Z+TnWIgy4BpfgCLwAb8gMdHnNJtgAj/2q//iffAswAHmIdZGJbwTOAAAAAElFTkSuQmCC"

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU2M0NCMEFBQzk0NzExRTc4ODg3QUNCNDk5QUEwODgwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU2M0NCMEFCQzk0NzExRTc4ODg3QUNCNDk5QUEwODgwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTYzQ0IwQThDOTQ3MTFFNzg4ODdBQ0I0OTlBQTA4ODAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTYzQ0IwQTlDOTQ3MTFFNzg4ODdBQ0I0OTlBQTA4ODAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5isJr+AAABFklEQVR42mI0Njb+z0A6EDxz5swHZAEWJDZIIgqILxAw5Bk2QWSDBIB4GxA3AHEX0Mbv2DSYmJhgNZ0JixjIoG9ADQVAzESsX/Ep7AdiPlyS6C5jYiAf2CC7mByDpID4ExBrAPFamGGMBKJfEIg5gVgdi1wWEIcC8RIgjmMhwgXeQDwbj3wMEH+nJIxg4A8QtxH0GnoKRoq1FKhLNYBqbrKQaj3QgFVAKhHK1QUZQm6sgQKYFRTIQEOuUJyOgIb8wJXXsAF2oFcYiTGYkEEvSMlrQdAiBBswgiZKdPwRXSHj////QTHBDGRHAPE8IGYjJvqx5n6g4r9AvBTI5IEm/X+kBj4TWkz8BuLpQCYXEFeRYhBAgAEAeh5Om/9P/goAAAAASUVORK5CYII="

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAMCAYAAACA0IaCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE4MTBGQzY5QzlFQjExRTc5OTUxQjBDNzIwMUIwM0U1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE4MTBGQzZBQzlFQjExRTc5OTUxQjBDNzIwMUIwM0U1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTgxMEZDNjdDOUVCMTFFNzk5NTFCMEM3MjAxQjAzRTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTgxMEZDNjhDOUVCMTFFNzk5NTFCMEM3MjAxQjAzRTUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5x/UuzAAACFElEQVR42mL8//cGAzq4cuWO+bbtR2LPnb9h9+jRC9Vfv35zsLGx/pCTk7htZKhxyMvTZrGOjspJdH2MyIY9ePBMo6t7wZRTp686g/hSUqL337z5IAU0jB1do5mp9t6y0oQcBQUpuAFMMMau3SfCY+Kqz37+/E1AVUXu0rw59dabNkxQ2r51irSGhsI5ZINkZMTvfvr8VRCkHqQPLgFy2e5dC0NNTU3+treVT/v6+QJvc1PJbJA4DIPkjY2N/8OwpaXFD5A6kHqQPpA8SB3LvftPtRoaZywICXGdVlYSn/vs+WuF7z9+ciO75N+//0zIfJC3P3z8LFxRnpjFxMz0F6RfSUnmKlNHx7zpKipyl4sLYwpBCvn5eN4dOHAmABT4IP6795/EFizYWIkS0IyM/0HqQGyQPpB+kDks6AHLzc35SVtL6XRaevNBUVHBZ2/ffhT/9+8fM7IaQwP1wyB16HqZKiqSMu/ceaTb27+kHyZYUBBdzMrK8uv16/dS6AaBxEHyMD5IH0g/yByMCPj98yorSOzk8TUuXl5uj5ADHsQHiYPkQerQIwAeYzt3LAi3trb8GhkZdP7UybVOMA2nT61z3LJ5dhyIhlkEkgepA6kH6YOZgTPRKipIX7e21t+mrCx7hZeX6wMo/d29+1jn6NGLXvcfPNXElmgZCWWnx49fqvz8+YuTnZ3tu6ys+B182QkgwABPUFsh1NN3kgAAAABJRU5ErkJggg=="

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjA3QjdDN0E5QzlFMzExRTdBNTc5QjhGNjQzMkY3OTRBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjA3QjdDN0FBQzlFMzExRTdBNTc5QjhGNjQzMkY3OTRBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDdCN0M3QTdDOUUzMTFFN0E1NzlCOEY2NDMyRjc5NEEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDdCN0M3QThDOUUzMTFFN0E1NzlCOEY2NDMyRjc5NEEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B5EGYAAABIElEQVR42mK8evXqAWlpac3y8nKjd+/ePWUgA7BoaWnZgxjKysomIENUVVUtXF1d0+Xk5HT/////78GDBxcPHTq06Pr164exGcDKysrBCFT4H8Tp7u4OBLpIIyoqqh2b4tOnT28Ago47d+6cBhnOzMzMamZmFhAREdHKgqwQZAguJ5uamgaA8Pfv3z99/vz5LT8/vzg7OzsX2Duk+p+Tk5MPhJHFmBioAEYNGcyGYKSTDx8+vNi7d+8cYHI/z8jIyKSkpGRsa2sbLSwsLIvLEJRkD0qNt27dOv7r16/vaPmD3dvbuxCEgSlVDCb+8OHDi4sXLy5FMQSUP/D6nYmJWUZGRouXl1cElFmfP39+i+Rk/+/fv7+PHj26PMyjGCDAAGj4fr6T+0JIAAAAAElFTkSuQmCC"

/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(987),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(1017),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(998),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54436761",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(734)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(1016),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a8817c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(946),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(639)
  __webpack_require__(638)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(945),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1270eecc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(1029),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78a5dda3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4aac4684",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(970),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(948),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1693a118",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(747)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(1028),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7815039e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(697)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(995),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5272a1fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(984),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47c9e76d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(973),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(1004),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59b92470",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(1036),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-84f48f90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(779)
  __webpack_require__(778)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(1051),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-beafd36e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(756)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(1035),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f67679e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(1026),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(750)
  __webpack_require__(749)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(1030),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a91c218",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(742)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(1020),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f14cdc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(719)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(1007),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d6fc6c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(785)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(1056),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ceaca750",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(940),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(777)
  __webpack_require__(776)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(1050),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bb8ef3be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-407ce77a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(954),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-221f3dae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(993),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-283d697d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(942),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f8b81e9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(733)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(1015),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69f42858",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(755)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(1034),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(947),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(726)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(1011),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(999),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(720)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(1008),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(1059),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(943),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(1054),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(1001),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(746)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(1027),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(1025),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(754)
  __webpack_require__(753)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(1033),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d3f3fed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06e839e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(1043),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9054e428",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(1047),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3a94a02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ef11a28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(760)
  __webpack_require__(761)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(1038),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(1022),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73d0d9b5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(1013),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
  __webpack_require__(698)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(996),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53e61a67",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(964),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fee1096",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(1005),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40c1976a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
  __webpack_require__(684)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b06bd03",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23508b2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(1040),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ad45258",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(634)
  __webpack_require__(633)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(939),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08ed4bce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(941),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(710)
  __webpack_require__(712)
  __webpack_require__(713)
  __webpack_require__(714)
  __webpack_require__(711)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(1003),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59a98d2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(988),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
  __webpack_require__(681)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-469dc3bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(705)
  __webpack_require__(706)
  __webpack_require__(707)
  __webpack_require__(704)
  __webpack_require__(703)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(1000),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5739ae31",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(1060),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eae28b46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(1024),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(661)
  __webpack_require__(662)
  __webpack_require__(660)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cebcd00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(780)
  __webpack_require__(781)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(1052),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c16d9e78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1700bc1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(938),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-071ea66c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(767)
  __webpack_require__(765)
  __webpack_require__(768)
  __webpack_require__(766)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(1042),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8fe80b1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(1061),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(1045),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(966),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(743)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(1021),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(772)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(1046),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(751)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(1031),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(956),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18c3c9e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(975),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e858e30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(944),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10f3bdb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(968),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(1057),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(728)
  __webpack_require__(727)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(1012),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-624687cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(732)
  __webpack_require__(730)
  __webpack_require__(731)
  __webpack_require__(729)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(1014),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-669ebdc9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(990),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(658)
  __webpack_require__(657)
  __webpack_require__(656)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-295c05a9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(1019),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f144563",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3639c3c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(967),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(784)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(1055),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cc013112",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(764)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(1041),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ee4f06c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(1010),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46831627",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(762)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(1039),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(991),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(1023),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(1049),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(794)
  __webpack_require__(793)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(1063),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f61690e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(670)
  __webpack_require__(669)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c1141c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(736)
  __webpack_require__(740)
  __webpack_require__(738)
  __webpack_require__(739)
  __webpack_require__(737)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(1018),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e88ecc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
  __webpack_require__(695)
  __webpack_require__(694)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(992),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f76db7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(721)
  __webpack_require__(725)
  __webpack_require__(723)
  __webpack_require__(724)
  __webpack_require__(722)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(1009),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-606315aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(644)
  __webpack_require__(648)
  __webpack_require__(646)
  __webpack_require__(647)
  __webpack_require__(645)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b07176c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-256de714",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(994),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-509aa33f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(980),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-422fc344",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b8ee6fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(770)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(1044),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-96289714",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(672)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(974),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3dce41de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(774)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(1048),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af565f4a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-302aa305",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(997),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5402093b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(972),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c700092",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(962),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getConfData.showPopup) ? _c('div', {
    staticClass: "confirmation-popup",
    attrs: {
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.clearAction($event)
      }
    }
  }, [_c('div', {
    staticClass: "confirmation-popup-inner",
    attrs: {
      "id": "alertPopup",
      "aria-labelledby": "confirmation-popup-title",
      "aria-modal": "true"
    }
  }, [_c('h2', {
    staticClass: "confirmation-popup-inner-caption",
    attrs: {
      "id": "confirmation-popup-title"
    }
  }, [_c('span', [_vm._v(_vm._s(this.getActionNotifyText(_vm.getConfData.actionName, _vm.getConfData.userStatus)['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-popup-inner-body"
  }, [_c('span', [_vm._v(_vm._s(this.getActionNotifyText(_vm.getConfData.actionName, _vm.getConfData.userStatus)['body']))]), _vm._v(" "), (_vm.getConfData.includeForm) ? _c('div', {
    staticClass: "confirmation-popup-inner-body__form"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getConfData.feedbackText),
      expression: "getConfData.feedbackText"
    }],
    staticClass: "form-control form-control__textarea",
    domProps: {
      "value": (_vm.getConfData.feedbackText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getConfData, "feedbackText", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-popup-inner-controll-panel"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearAction
    }
  }, [_vm._v(_vm._s(_vm.getConfData.customCancelButtonText || 'No, cancel'))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.confirmAction($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.getConfData.customConfirmButtonText || 'Yes, proceed'))])]), _vm._v(" "), _c('button', {
    staticClass: "confirmation-popup-close",
    attrs: {
      "aria-label": "Close dialog"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.clearAction($event)
      }
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article"
  }, [_c('div', {
    attrs: {
      "id": "headerPlaceholder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__header"
  }, [_c('div', {
    staticClass: "article__container article__header--container"
  }, [_c('router-link', {
    staticClass: "article__header--button",
    attrs: {
      "to": {
        name: 'articles-list'
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n        Back\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "article__header--actions"
  }, [_c('button', {
    staticClass: "blue-border-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(_vm.entity.status, true, false)
      }
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('button', {
    staticClass: "light-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(0)
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('button', {
    staticClass: "dark-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(1)
      }
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('button', {
    staticClass: "gray-border-btn",
    on: {
      "click": function($event) {
        return _vm.goToAllArticles()
      }
    }
  }, [_vm._v("Exit without saving")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__content"
  }, [_c('div', {
    staticClass: "article__container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article__content--editor"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleEditBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Edit article")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleEditBoxActive = !_vm.articleEditBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label"
  }, [_vm._v("Article content")]), _vm._v(" "), _c('Vueditor', {
    ref: "contentEditor",
    staticClass: "form-control__editor"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--fourth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "title",
      "data-vv-name": "Title",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "topic"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Topic')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getTagsForSelect,
      "data-vv-name": "Topic",
      "data-lpignore": "true",
      "name": "topic",
      "id": "topic"
    },
    model: {
      value: (_vm.entity.topic),
      callback: function($$v) {
        _vm.$set(_vm.entity, "topic", $$v)
      },
      expression: "entity.topic"
    }
  }), _vm._v(" "), (this.errors.has('Topic')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Topic')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Category')
    }],
    attrs: {
      "searchable": true,
      "multiple": false,
      "options": _vm.getCategoriesForSelect,
      "data-vv-name": "Category",
      "data-lpignore": "true",
      "name": "category",
      "id": "category"
    },
    model: {
      value: (_vm.entity.category),
      callback: function($$v) {
        _vm.$set(_vm.entity, "category", $$v)
      },
      expression: "entity.category"
    }
  }), _vm._v(" "), (this.errors.has('Category')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Category')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Type')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getContentTypeForSelect,
      "data-vv-name": "Type",
      "data-lpignore": "true",
      "name": "type",
      "id": "type"
    },
    model: {
      value: (_vm.entity.type),
      callback: function($$v) {
        _vm.$set(_vm.entity, "type", $$v)
      },
      expression: "entity.type"
    }
  }), _vm._v(" "), (this.errors.has('Type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Type')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-element article__featured-image"
  }, [_c('span', {
    staticClass: "article__form-label"
  }, [_vm._v("Featured image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded),
      expression: "!isThumbnailFileUploaded"
    }],
    staticClass: "article__form-label article__form-label--file-upload"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "24",
      "viewBox": "0 0 32 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M29,0a3,3,0,0,0,3-3V-21a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3V-3A3,3,0,0,0,3,0ZM7-20.5A3.5,3.5,0,0,1,10.5-17,3.5,3.5,0,0,1,7-13.5,3.5,3.5,0,0,1,3.5-17,3.5,3.5,0,0,1,7-20.5ZM4-4V-7l4.47-4.47a.75.75,0,0,1,1.061,0L13-8l8.47-8.47a.75.75,0,0,1,1.061,0L28-11v7Z",
      "transform": "translate(0 24)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.altImage),
      expression: "entity.altImage"
    }],
    staticClass: "form-control form-control__textarea has-no-label",
    class: {
      'is-blocked': !_vm.isThumbnailFileUploaded
    },
    attrs: {
      "disabled": !_vm.isThumbnailFileUploaded,
      "data-lpignore": "true",
      "id": "image",
      "placeholder": _vm.isThumbnailFileUploaded ? 'Type in Alt text for the image...' : '',
      "data-vv-name": "Image alt",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "altImage", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__container"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleSettingsBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Access Settings")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleSettingsBoxActive = !_vm.articleSettingsBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-specific"
    }
  }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Company specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getCompaniesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'industry') || _vm.isExcluded !== null,
      "data-vv-name": "Company specific",
      "data-lpignore": "true",
      "name": "company",
      "id": "company-specific"
    },
    model: {
      value: (_vm.entity.company),
      callback: function($$v) {
        _vm.$set(_vm.entity, "company", $$v)
      },
      expression: "entity.company"
    }
  }), _vm._v(" "), (this.errors.has('Company specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-specific"
    }
  }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Industry specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getIndustriesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'company') || _vm.isExcluded !== null,
      "data-vv-name": "Industry specific",
      "data-lpignore": "true",
      "name": "industry",
      "id": "industry-specific"
    },
    model: {
      value: (_vm.entity.industry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "industry", $$v)
      },
      expression: "entity.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-specific"
    }
  }, [_vm._v("Location specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Location specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Location specific",
      "data-lpignore": "true",
      "name": "location",
      "id": "location-specific"
    },
    model: {
      value: (_vm.entity.location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "location", $$v)
      },
      expression: "entity.location"
    }
  }), _vm._v(" "), (this.errors.has('Location specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Location specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-specific"
    }
  }, [_vm._v("Organisation size specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Size specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Size specific",
      "data-lpignore": "true",
      "name": "size",
      "id": "size-specific"
    },
    model: {
      value: (_vm.entity.size),
      callback: function($$v) {
        _vm.$set(_vm.entity, "size", $$v)
      },
      expression: "entity.size"
    }
  }), _vm._v(" "), (this.errors.has('Size specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Size specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-exclude"
    }
  }, [_vm._v("Exclude companies")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude companies')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'industry') || (_vm.isSpecific !== null && _vm.isSpecific !== 'industry'),
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Exclude companies",
      "data-lpignore": "true",
      "name": "notCompany",
      "id": "company-exclude"
    },
    model: {
      value: (_vm.entity.notCompany),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notCompany", $$v)
      },
      expression: "entity.notCompany"
    }
  }), _vm._v(" "), (this.errors.has('Exclude companies')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude companies')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-exclude"
    }
  }, [_vm._v("Exclude industries")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude industries')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'company') || _vm.isSpecific !== null,
      "options": _vm.getIndustriesForSelect,
      "data-vv-name": "Exclude industries",
      "data-lpignore": "true",
      "name": "notIndustry",
      "id": "industry-exclude"
    },
    model: {
      value: (_vm.entity.notIndustry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notIndustry", $$v)
      },
      expression: "entity.notIndustry"
    }
  }), _vm._v(" "), (this.errors.has('Exclude industries')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude industries')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-exclude"
    }
  }, [_vm._v("Exclude locations")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude locations')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Exclude locations",
      "data-lpignore": "true",
      "name": "notLocation",
      "id": "location-exclude"
    },
    model: {
      value: (_vm.entity.notLocation),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notLocation", $$v)
      },
      expression: "entity.notLocation"
    }
  }), _vm._v(" "), (this.errors.has('Exclude locations')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude locations')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-exclude"
    }
  }, [_vm._v("Exclude organisation sizes")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude organisation sizes')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Exclude organisation sizes",
      "data-lpignore": "true",
      "name": "notSize",
      "id": "size-exclude"
    },
    model: {
      value: (_vm.entity.notSize),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notSize", $$v)
      },
      expression: "entity.notSize"
    }
  }), _vm._v(" "), (this.errors.has('Exclude organisation sizes')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude organisation sizes')))]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleRelatedBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Related: resources and tasks")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleRelatedBoxActive = !_vm.articleRelatedBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-articles"
    }
  }, [_vm._v("Related Resources")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": true,
      "id": "related-articles",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttc),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttc", $$v)
      },
      expression: "entity.ttc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-tasks"
    }
  }, [_vm._v("Related Tasks")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToDo,
      "options": _vm.thingsToDoOptions,
      "multiple": true,
      "id": "related-tasks",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttd),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttd", $$v)
      },
      expression: "entity.ttd"
    }
  })], 1)])])])])]), _vm._v(" "), (_vm.articleType.type === 'video' || _vm.articleType.type === 'document') ? _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleResourcesBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Useful resources")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleResourcesBoxActive = !_vm.articleResourcesBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_vm._l((_vm.entity.resources.video), function(row, index) {
    return (_vm.articleType.type === 'video') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-url"
      }
    }, [_vm._v("Video URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoUrl),
        expression: "row.videoUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Video URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-url",
        "data-vv-name": "Video URL",
        "name": "video-url"
      },
      domProps: {
        "value": (row.videoUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Video URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Video URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-transcript"
      }
    }, [_vm._v("Transcript for video")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoTranscript),
        expression: "row.videoTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.videoTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoTranscript", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.video.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.entity.resources.document), function(row, index) {
    return (_vm.articleType.type === 'document') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('span', {
      staticClass: "article__form-label"
    }, [_vm._v("Upload resource")]), _vm._v(" "), _c('label', {
      staticClass: "form-label"
    }, [(row.resource === null) ? _c('span', {
      staticClass: "form-control form-control__input"
    }, [_vm._v("+Upload resource")]) : _vm._e(), _vm._v(" "), (row.resource !== null) ? _c('span', {
      staticClass: "form-control form-control__input",
      attrs: {
        "id": 'uploadedResource_' + index
      }
    }, [_vm._v(_vm._s(row.name))]) : _vm._e(), _vm._v(" "), _c('input', {
      staticClass: "form-control visually-hidden form-control--file input-file-resource",
      attrs: {
        "type": "file",
        "id": 'uploadResource_' + index,
        "placeholder": "Type in to add title..."
      },
      on: {
        "change": function($event) {
          return _vm.onResourceFileChange($event, index)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.document.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-url"
      }
    }, [_vm._v("Resource URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceUrl),
        expression: "row.resourceUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Resource URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-url",
        "data-vv-name": "Resource URL",
        "name": "resource-url"
      },
      domProps: {
        "value": (row.resourceUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Resource URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Resource URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-transcript"
      }
    }, [_vm._v("Transcript for resource")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceTranscript),
        expression: "row.resourceTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.resourceTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceTranscript", $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--full form-group__video-add-button",
    on: {
      "click": _vm.addVideoRow
    }
  }, [_c('div', {
    staticClass: "add-new-video"
  }, [_vm._v("Add new")])])], 2)])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article__content--title"
  }, [_c('h1', [_vm._v("Add article")])])
}]}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article"
  }, [_c('div', {
    attrs: {
      "id": "headerPlaceholder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__header"
  }, [_c('div', {
    staticClass: "article__container article__header--container"
  }, [_c('router-link', {
    staticClass: "article__header--button",
    attrs: {
      "to": {
        name: 'articles-list'
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n        Back\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "article__header--actions"
  }, [_c('button', {
    staticClass: "blue-border-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(_vm.entity.status, true, false)
      }
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('button', {
    staticClass: "light-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(0)
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('button', {
    staticClass: "dark-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(1)
      }
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('button', {
    staticClass: "gray-border-btn",
    on: {
      "click": function($event) {
        return _vm.goToAllArticles()
      }
    }
  }, [_vm._v("Exit without saving")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__content"
  }, [_c('div', {
    staticClass: "article__container"
  }, [_c('div', {
    staticClass: "article__content--title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.entity.title))]), _vm._v(" "), _c('div', {
    staticClass: "article__content--actions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.archiveArticle()
      }
    }
  }, [(_vm.entity.status === 1) ? [_c('svg', {
    staticClass: "archive-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "14",
      "viewBox": "0 0 16 14"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M14.5-11a1.447,1.447,0,0,1,1.063.438A1.447,1.447,0,0,1,16-9.5V-9H0v-2.5a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-13h5l2,2ZM0-.5V-8H16V-.5A1.447,1.447,0,0,1,15.563.563,1.447,1.447,0,0,1,14.5,1H1.5A1.447,1.447,0,0,1,.438.563,1.447,1.447,0,0,1,0-.5Z",
      "transform": "translate(0 13)"
    }
  })]), _vm._v("\n              Archive\n            ")] : [_c('svg', {
    staticClass: "restore-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15.76",
      "height": "15.75",
      "viewBox": "0 0 15.76 15.75"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M6.635-6.99a.375.375,0,0,0,.375-.375v-1.5a.375.375,0,0,0-.375-.375H3.564A5.49,5.49,0,0,1,8.01-11.5,5.5,5.5,0,0,1,13.51-6,5.5,5.5,0,0,1,8.01-.5,5.479,5.479,0,0,1,4.366-1.879a.374.374,0,0,0-.513.016L2.792-.8a.376.376,0,0,0,.015.544A7.721,7.721,0,0,0,8.01,1.75a7.75,7.75,0,0,0,7.75-7.733A7.732,7.732,0,0,0,8.068-13.75,7.73,7.73,0,0,0,2.25-11.184v-2.441A.375.375,0,0,0,1.875-14H.375A.375.375,0,0,0,0-13.625v6.26a.375.375,0,0,0,.375.375Z",
      "transform": "translate(0 14)"
    }
  })]), _vm._v("\n              Restore\n            ")]], 2), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.deleteArticle()
      }
    }
  }, [_c('svg', {
    staticClass: "delete-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "16",
      "viewBox": "0 0 14 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M1.656.594,1-10H13L12.344.594a1.574,1.574,0,0,1-.484,1A1.412,1.412,0,0,1,10.844,2H3.156a1.412,1.412,0,0,1-1.016-.406A1.574,1.574,0,0,1,1.656.594ZM13.5-13a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5H.5a.442.442,0,0,1-.5-.5v-1A.442.442,0,0,1,.5-13H4l.375-.719A.409.409,0,0,1,4.813-14H9.188a.409.409,0,0,1,.438.281L10-13Z",
      "transform": "translate(0 14)"
    }
  })]), _vm._v("\n            Delete")])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--statusbar"
  }, [_c('div', [_vm._v("Status")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getStatus(_vm.entity.status)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lastTimeEdited(_vm.entity.lastTimeEditedDate, _vm.entity.lastTimeEditedBy)))])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--editor"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleEditBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Edit article")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleEditBoxActive = !_vm.articleEditBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_c('div', {
    staticClass: "article__form-element",
    attrs: {
      "id": "contentEditor"
    }
  }, [_c('label', {
    staticClass: "article__form-label"
  }, [_vm._v("Article content")]), _vm._v(" "), _c('Vueditor', {
    ref: "contentEditor",
    staticClass: "form-control__editor"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--fourth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "title",
      "data-vv-name": "Title",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "topic"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Topic')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getTagsForSelect,
      "data-vv-name": "Topic",
      "data-lpignore": "true",
      "name": "topic",
      "id": "topic"
    },
    model: {
      value: (_vm.entity.topic),
      callback: function($$v) {
        _vm.$set(_vm.entity, "topic", $$v)
      },
      expression: "entity.topic"
    }
  }), _vm._v(" "), (this.errors.has('Topic')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Topic')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Category')
    }],
    attrs: {
      "searchable": true,
      "multiple": false,
      "options": _vm.getCategoriesForSelect,
      "data-vv-name": "Category",
      "data-lpignore": "true",
      "name": "category",
      "id": "category"
    },
    model: {
      value: (_vm.entity.category),
      callback: function($$v) {
        _vm.$set(_vm.entity, "category", $$v)
      },
      expression: "entity.category"
    }
  }), _vm._v(" "), (this.errors.has('Category')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Category')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select is-blocked",
    class: [{
      'has-error': _vm.errors.has('Type')
    }],
    attrs: {
      "searchable": false,
      "data-vv-name": "Type",
      "disabled": "disabled",
      "data-lpignore": "true",
      "name": "type",
      "id": "type"
    },
    model: {
      value: (_vm.entity.type),
      callback: function($$v) {
        _vm.$set(_vm.entity, "type", $$v)
      },
      expression: "entity.type"
    }
  }), _vm._v(" "), (this.errors.has('Type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Type')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-element article__featured-image"
  }, [_c('span', {
    staticClass: "article__form-label"
  }, [_vm._v("Featured image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded),
      expression: "!isThumbnailFileUploaded"
    }],
    staticClass: "article__form-label article__form-label--file-upload"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "24",
      "viewBox": "0 0 32 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M29,0a3,3,0,0,0,3-3V-21a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3V-3A3,3,0,0,0,3,0ZM7-20.5A3.5,3.5,0,0,1,10.5-17,3.5,3.5,0,0,1,7-13.5,3.5,3.5,0,0,1,3.5-17,3.5,3.5,0,0,1,7-20.5ZM4-4V-7l4.47-4.47a.75.75,0,0,1,1.061,0L13-8l8.47-8.47a.75.75,0,0,1,1.061,0L28-11v7Z",
      "transform": "translate(0 24)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.altImage),
      expression: "entity.altImage"
    }],
    staticClass: "form-control form-control__textarea has-no-label",
    class: {
      'is-blocked': !_vm.isThumbnailFileUploaded
    },
    attrs: {
      "disabled": !_vm.isThumbnailFileUploaded,
      "data-lpignore": "true",
      "id": "image",
      "placeholder": _vm.isThumbnailFileUploaded ? 'Type in Alt text for the image...' : '',
      "data-vv-name": "Image alt",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "altImage", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__container"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleSettingsBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Access Settings")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleSettingsBoxActive = !_vm.articleSettingsBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-specific"
    }
  }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Company specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getCompaniesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'industry') || _vm.isExcluded !== null,
      "data-vv-name": "Company specific",
      "data-lpignore": "true",
      "name": "company",
      "id": "company-specific"
    },
    model: {
      value: (_vm.entity.company),
      callback: function($$v) {
        _vm.$set(_vm.entity, "company", $$v)
      },
      expression: "entity.company"
    }
  }), _vm._v(" "), (this.errors.has('Company specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-specific"
    }
  }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Industry specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getIndustriesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'company') || _vm.isExcluded !== null,
      "data-vv-name": "Industry specific",
      "data-lpignore": "true",
      "name": "industry",
      "id": "industry-specific"
    },
    model: {
      value: (_vm.entity.industry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "industry", $$v)
      },
      expression: "entity.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-specific"
    }
  }, [_vm._v("Location specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Location specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Location specific",
      "data-lpignore": "true",
      "name": "location",
      "id": "location-specific"
    },
    model: {
      value: (_vm.entity.location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "location", $$v)
      },
      expression: "entity.location"
    }
  }), _vm._v(" "), (this.errors.has('Location specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Location specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-specific"
    }
  }, [_vm._v("Organisation size specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Organisation size specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Organisation size specific",
      "data-lpignore": "true",
      "name": "size",
      "id": "size-specific"
    },
    model: {
      value: (_vm.entity.size),
      callback: function($$v) {
        _vm.$set(_vm.entity, "size", $$v)
      },
      expression: "entity.size"
    }
  }), _vm._v(" "), (this.errors.has('Organisation size specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation size specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-exclude"
    }
  }, [_vm._v("Exclude companies")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude companies')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'industry') || (_vm.isSpecific !== null && _vm.isSpecific !== 'industry'),
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Exclude companies",
      "data-lpignore": "true",
      "name": "notCompany",
      "id": "company-exclude"
    },
    model: {
      value: (_vm.entity.notCompany),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notCompany", $$v)
      },
      expression: "entity.notCompany"
    }
  }), _vm._v(" "), (this.errors.has('Exclude companies')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude companies')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-exclude"
    }
  }, [_vm._v("Exclude industries")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude industries')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'company') || _vm.isSpecific !== null,
      "options": _vm.getIndustriesForSelect,
      "data-vv-name": "Exclude industries",
      "data-lpignore": "true",
      "name": "notIndustry",
      "id": "industry-exclude"
    },
    model: {
      value: (_vm.entity.notIndustry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notIndustry", $$v)
      },
      expression: "entity.notIndustry"
    }
  }), _vm._v(" "), (this.errors.has('Exclude industries')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude industries')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-exclude"
    }
  }, [_vm._v("Exclude locations")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude locations')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Exclude locations",
      "data-lpignore": "true",
      "name": "notLocation",
      "id": "location-exclude"
    },
    model: {
      value: (_vm.entity.notLocation),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notLocation", $$v)
      },
      expression: "entity.notLocation"
    }
  }), _vm._v(" "), (this.errors.has('Exclude locations')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude locations')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-exclude"
    }
  }, [_vm._v("Exclude organisation sizes")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude organisation sizes')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Exclude organisation sizes",
      "data-lpignore": "true",
      "name": "notSize",
      "id": "size-exclude"
    },
    model: {
      value: (_vm.entity.notSize),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notSize", $$v)
      },
      expression: "entity.notSize"
    }
  }), _vm._v(" "), (this.errors.has('Exclude organisation sizes')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude organisation sizes')))]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleRelatedBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Related: resources and tasks")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleRelatedBoxActive = !_vm.articleRelatedBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-articles"
    }
  }, [_vm._v("Related Resources")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": true,
      "id": "related-articles",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttc),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttc", $$v)
      },
      expression: "entity.ttc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-tasks"
    }
  }, [_vm._v("Related Tasks")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToDo,
      "options": _vm.thingsToDoOptions,
      "multiple": true,
      "id": "related-tasks",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttd),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttd", $$v)
      },
      expression: "entity.ttd"
    }
  })], 1)])])])])]), _vm._v(" "), (_vm.articleType.type === 'video' || _vm.articleType.type === 'document') ? _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleResourcesBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Useful resources")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleResourcesBoxActive = !_vm.articleResourcesBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_vm._l((_vm.entity.resources.video), function(row, index) {
    return (_vm.articleType.type === 'video') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-url"
      }
    }, [_vm._v("Video URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoUrl),
        expression: "row.videoUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Video URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-url",
        "data-vv-name": "Video URL",
        "name": "video-url"
      },
      domProps: {
        "value": (row.videoUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Video URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Video URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-transcript"
      }
    }, [_vm._v("Transcript for video")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoTranscript),
        expression: "row.videoTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.videoTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoTranscript", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.video.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.entity.resources.document), function(row, index) {
    return (_vm.articleType.type === 'document') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('span', {
      staticClass: "article__form-label"
    }, [_vm._v("Upload resource")]), _vm._v(" "), _c('label', {
      staticClass: "form-label"
    }, [(row.resource === null) ? _c('span', {
      staticClass: "form-control form-control__input"
    }, [_vm._v("+Upload resource")]) : _vm._e(), _vm._v(" "), (row.resource !== null) ? _c('span', {
      staticClass: "form-control form-control__input",
      attrs: {
        "id": 'uploadedResource_' + index
      }
    }, [_vm._v(_vm._s(row.name))]) : _vm._e(), _vm._v(" "), _c('input', {
      staticClass: "form-control visually-hidden form-control--file input-file-resource",
      attrs: {
        "type": "file",
        "id": 'uploadResource_' + index,
        "placeholder": "Type in to add title..."
      },
      on: {
        "change": function($event) {
          return _vm.onResourceFileChange($event, index)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.document.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-url"
      }
    }, [_vm._v("Resource URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceUrl),
        expression: "row.resourceUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Resource URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-url",
        "data-vv-name": "Resource URL",
        "name": "resource-url"
      },
      domProps: {
        "value": (row.resourceUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Resource URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Resource URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-transcript"
      }
    }, [_vm._v("Transcript for resource")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceTranscript),
        expression: "row.resourceTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.resourceTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceTranscript", $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--full form-group__video-add-button",
    on: {
      "click": _vm.addVideoRow
    }
  }, [_c('div', {
    staticClass: "add-new-video"
  }, [_vm._v("Add new")])])], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleChangelogBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Changelog")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleChangelogBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleChangelogBoxActive = !_vm.articleChangelogBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleChangelogBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('table', {
    staticClass: "changelog-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.articleLog.length) ? _vm._l((_vm.articleLog), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.created_at !== null ? _vm.convertDate(row.created_at, '.') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user !== null ? row.user.first_name + ' ' + row.user.last_name : '-'))])])
  }) : [_vm._m(1)]], 2)])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Action performed")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("User")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nothing to display here")])])
}]}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clear-kit"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-cta-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showHero"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "landing-page-lets-meet"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.heroSection.button.url,
      "title": _vm.content.heroSection.button.text
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.text),
      expression: "content.heroSection.button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.url),
      expression: "content.heroSection.button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.aboutSection[0].hideSection || _vm.content.aboutSection[0].hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.aboutSection[0].hideSection || content.aboutSection[0].hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper about-section landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].hideSection),
      expression: "content.aboutSection[0].hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.aboutSection[0].hideSection) ? _vm._i(_vm.content.aboutSection[0].hideSection, null) > -1 : (_vm.content.aboutSection[0].hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.aboutSection[0].hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.aboutSection[0], "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.aboutSection[0], "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.aboutSection[0], "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showSection"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[0].title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].title),
      expression: "content.aboutSection[0].title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0], "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[0].title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[0].text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].text),
      expression: "content.aboutSection[0].text"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].text)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0], "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[0].text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-action-wrapper"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.aboutSection[0].button.url,
      "title": _vm.content.aboutSection[0].button.text
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[0].button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].button.text),
      expression: "content.aboutSection[0].button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0].button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].button.url),
      expression: "content.aboutSection[0].button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0].button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[1].title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].title),
      expression: "content.aboutSection[1].title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1], "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[1].title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[1].text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].text),
      expression: "content.aboutSection[1].text"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].text)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1], "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[1].text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-action-wrapper"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.aboutSection[1].button.url,
      "title": _vm.content.aboutSection[1].button.text
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[1].button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].button.text),
      expression: "content.aboutSection[1].button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1].button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].button.url),
      expression: "content.aboutSection[1].button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1].button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClient"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showClient"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logos flex-section"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "slick",
    staticClass: "clients-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.howItWorksSection.hideSection || _vm.content.howItWorksSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper how-it-works-section landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.hideSection),
      expression: "content.howItWorksSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHIW"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.howItWorksSection.hideSection) ? _vm._i(_vm.content.howItWorksSection.hideSection, null) > -1 : (_vm.content.howItWorksSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.howItWorksSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.howItWorksSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showHIW"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.howItWorksSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.title),
      expression: "content.howItWorksSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.howItWorksSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "list flex-section"
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "content-slider"
  }, [_c('slick', {
    ref: "contentSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.slickOptionsContent
    }
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.subscribeSection.hideSection || _vm.content.subscribeSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.subscribeSection.hideSection || content.subscribeSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper subscribe-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.hideSection),
      expression: "content.subscribeSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showSubscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.subscribeSection.hideSection) ? _vm._i(_vm.content.subscribeSection.hideSection, null) > -1 : (_vm.content.subscribeSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.subscribeSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.subscribeSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showSubscribe"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.title),
      expression: "content.subscribeSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.description),
      expression: "content.subscribeSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('form', {
    staticClass: "subscribe-form center",
    attrs: {
      "name": "form",
      "method": "POST",
      "action": "https://forms.sign-up.to/15008/3116"
    }
  }, [_c('div', {
    staticClass: "subscribe-form-group",
    class: [{
      'active': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'has-error': _vm.subscribeForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "subscribe-form-firstname"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.firstname),
      expression: "subscribeForm.firstname"
    }],
    attrs: {
      "id": "subscribe-form-firstname",
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.subscribeForm.firstname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.firstnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.firstnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subscribe-form-group",
    class: [{
      'active': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'has-error': _vm.subscribeForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "subscribe-form-lastname"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.lastname),
      expression: "subscribeForm.lastname"
    }],
    attrs: {
      "id": "subscribe-form-lastname",
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.subscribeForm.lastname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.lastnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.lastnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subscribe-form-group",
    class: [{
      'active': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'has-error': _vm.subscribeForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "subscribe-form-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.email),
      expression: "subscribeForm.email"
    }],
    attrs: {
      "id": "subscribe-form-email",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.subscribeForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "subscribe-form-action",
    attrs: {
      "name": "subscribe",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.subscribeMe()
      }
    }
  }, [_vm._v("Subscribe")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.featuresSection.hideSection || _vm.content.featuresSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper features-section landing-page-wrapper__gray about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.hideSection),
      expression: "content.featuresSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFeatures"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.featuresSection.hideSection) ? _vm._i(_vm.content.featuresSection.hideSection, null) > -1 : (_vm.content.featuresSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.featuresSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.featuresSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showFeatures"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  }, [_vm._l((_vm.content.featuresSection.items), function(item, index) {
    return _c('div', {
      staticClass: "feature-item"
    }, [(!_vm.pageEditMode && !_vm.getDeviceType('desktop')) ? _c('div', {
      staticClass: "feature-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "feature-image",
      class: [{
        'iframe': item.video
      }],
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": !item.video || item.video === '' ? item.altImage : ''
      }
    }, [(!_vm.pageEditMode && item.video) ? _c('iframe', {
      attrs: {
        "id": "player",
        "frameborder": "0",
        "webkitAllowFullScreen": "",
        "mozallowfullscreen": "",
        "allowFullScreen": "",
        "height": "340",
        "width": "600",
        "src": _vm.getVideoUrl(item.video)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "landing-page-image-upload",
      attrs: {
        "for": 'feature-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'feature-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e(), _vm._v(" "), (!item.image || item.image === '') ? [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.video),
        expression: "item.video"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Video url"
      },
      domProps: {
        "value": (item.video)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "video", $event.target.value)
        }
      }
    }) : _vm._e()] : [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e()]], 2), _vm._v(" "), _c('div', {
      staticClass: "feature-content"
    }, [(!_vm.pageEditMode && _vm.getDeviceType('desktop')) ? _c('div', {
      staticClass: "feature-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-description",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.button.text !== '') ? _c('a', {
      staticClass: "feature-link",
      attrs: {
        "href": item.button.url,
        "title": item.button.text
      }
    }, [_vm._v(_vm._s(item.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "feature-description",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.button.text),
        expression: "item.button.text"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.button.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.button, "text", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.button.url),
        expression: "item.button.url"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button url",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.button.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.button, "url", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.featuresSection.items, index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('features')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.footerCTASection.hideSection || _vm.content.footerCTASection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.footerCTASection.hideSection || content.footerCTASection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper footer-cta-section landing-page-wrapper__blue about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.hideSection),
      expression: "content.footerCTASection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFooter"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.footerCTASection.hideSection) ? _vm._i(_vm.content.footerCTASection.hideSection, null) > -1 : (_vm.content.footerCTASection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.footerCTASection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.footerCTASection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.footerCTASection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.footerCTASection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showFooter"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footerCTASection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.title),
      expression: "content.footerCTASection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footerCTASection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.description),
      expression: "content.footerCTASection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "cta-content"
  }, [_c('div', {
    staticClass: "section-actions"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.footerCTASection.button.url,
      "title": _vm.content.footerCTASection.button.text
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.button.text),
      expression: "content.footerCTASection.button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.button.url),
      expression: "content.footerCTASection.button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      'landing-page': _vm.isLandingPage() === true
    }]
  }, [(!_vm.getIsLoggedIn || _vm.isCompanyLandingPage()) ? _c('Authorization-header') : _vm._e(), _vm._v(" "), (_vm.getIsLoggedIn && !_vm.isCompanyLandingPage()) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('conf-popup'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('inform-msg'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user-template"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "post-title color-1-100 background-1-10-after"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Last Edited")])])
}]}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.email !== '' || _vm.emailFocus,
      'has-error': this.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.email),
      expression: "formInfo.email"
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.formInfo.email)
    },
    on: {
      "focus": function($event) {
        _vm.emailFocus = true
      },
      "blur": function($event) {
        _vm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.resetInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendFormRequest()
      }
    }
  }, [_vm._v("Send me reset link")])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Expired token\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          Your password reset token is expired. Please enter your email address and "), _c('br'), _vm._v("\n          you will be sent a new one by email.\n        ")])
}]}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "add-article-wrapper form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('section', {
    staticClass: "add-article-section add-article-section--heading"
  }, [_c('div', {
    staticClass: "add-article-details"
  }, [_c('div', {
    staticClass: "form-elements"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('div', {
    staticClass: "wrap-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page.title),
      expression: "page.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "name": "title",
      "placeholder": "Type in to add title..."
    },
    domProps: {
      "value": (_vm.page.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.page, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('title')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('title')) + "\n                        ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "control-panel"
  }, [_c('div', {
    staticClass: "wrap-button"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deletePage()
      }
    }
  }, [_c('icon', {
    staticClass: "icon-btn-ctr",
    attrs: {
      "name": "remove"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Delete page")])], 1)])]), _vm._v(" "), _c('statusbar', {
    attrs: {
      "status": _vm.page.status,
      "updatedAt": _vm.updatedAt
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-article-body"
  }, [_c('div', {
    staticClass: "add-article-sections"
  }, [_c('section', {
    staticClass: "add-article-section"
  }, [_c('h2', {
    staticClass: "add-article-section__title"
  }, [_vm._v("Title and body")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "article-editor",
    attrs: {
      "editorToolbar": _vm.editorToolbar,
      "name": "content"
    },
    model: {
      value: (_vm.page.content.content),
      callback: function($$v) {
        _vm.$set(_vm.page.content, "content", $$v)
      },
      expression: "page.content.content"
    }
  }), _vm._v(" "), (_vm.errors.has('description')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('content')) + "\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-article-actions"
  }, [_c('button', {
    staticClass: "action-btn--back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/admin/articles-list')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "rotate-left"
    }
  }), _vm._v("\n                Back to list\n            ")], 1), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--preview icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "textInButton"
  }, [_vm._v("Preview page")])]), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--exit icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/admin/static-pages')
      }
    }
  }, [_vm._m(1), _vm._v("Exit without saving\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--draft icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDraft()
      }
    }
  }, [_vm._m(2), _vm._v("Save as draft\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--publish icon-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.publish()
      }
    }
  }, [_vm._m(3), _vm._v("Publish page\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "previe-icon",
    attrs: {
      "src": __webpack_require__(813)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "export-icon",
    attrs: {
      "src": __webpack_require__(812)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "saveAndDraft-icon",
    attrs: {
      "src": __webpack_require__(814)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "earth-icon",
    attrs: {
      "src": __webpack_require__(811)
    }
  })])
}]}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Actions")])
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "all-users-page test-class"
  }, [(_vm.downloadInProcess) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-text"
  }, [_vm._v("loading ...")])]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All Tasks")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), _c('router-link', {
    staticClass: "to-do active",
    attrs: {
      "to": {
        name: 'todo-list'
      }
    }
  }, [_vm._v("Tasks")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(+_vm.statusbar.published + +_vm.statusbar.archived + +_vm.statusbar.draft) + " resources")]), _vm._v(" "), _c('ul', {
    staticClass: "data-list-statuses data-list-statusbar__block"
  }, [_c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.published) + " published")]), _vm._v(" "), _c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.archived) + " archived")]), _vm._v(" "), _c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.draft) + " draft")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "data-list-add",
    attrs: {
      "to": {
        name: 'add-todo'
      },
      "tabindex": "-1"
    }
  }, [_vm._v("Add new Task")])], 1), _vm._v(" "), (this.editedArticles.length) ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.tableExport(_vm.csvData)
      }
    }
  }, [_vm._v("Export all Tasks")]) : _vm._e(), _vm._v(" "), (this.articles.length) ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.csvExport()
      }
    }
  }, [_vm._v("Export Task/Resource documents")]) : _vm._e(), _vm._v(" "), (_vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.editedArticles.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "articles-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 1
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByName),
      expression: "searchByName"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Search in TTDs..."
    },
    domProps: {
      "value": (_vm.searchByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "column-type-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getContentTypeForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getContentTypeForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'table-head-select',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getContentTypeForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.contentType),
      callback: function($$v) {
        _vm.contentType = $$v
      },
      expression: "contentType"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-topics-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getTagsForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getTagsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getTagsForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-categories-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 5,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getChaptersForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getChaptersForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getChaptersForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.chapter),
      callback: function($$v) {
        _vm.chapter = $$v
      },
      expression: "chapter"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-companies-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 7,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 6,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(6)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 6
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 6),
      expression: "filerTableHead.selectedCeil === 6"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-6",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getCompaniesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.companies),
      callback: function($$v) {
        _vm.companies = $$v
      },
      expression: "companies"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-industries-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 8,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 7,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getIndustriesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(7)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getIndustriesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 7
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 7),
      expression: "filerTableHead.selectedCeil === 7"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-7",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getIndustriesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.industries),
      callback: function($$v) {
        _vm.industries = $$v
      },
      expression: "industries"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('edited', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && this.articleOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && !this.articleOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 10,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 9,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    staticStyle: {
      "max-width": "120px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(9)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 9
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 9),
      expression: "filerTableHead.selectedCeil === 9"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-9",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }],
      "multiple": true
    },
    model: {
      value: (_vm.onBoarding),
      callback: function($$v) {
        _vm.onBoarding = $$v
      },
      expression: "onBoarding"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 11,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 10,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(10)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 10
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 10),
      expression: "filerTableHead.selectedCeil === 10"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-10",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getStatusesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedArticles), function(article, i) {
    return (i < _vm.offset) ? _c('tr', {
      on: {
        "click": function($event) {
          return _vm.editArticle(article.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-center cellpadding"
    }, [_c('label', {
      attrs: {
        "for": article.id
      }
    }, [_vm._v(_vm._s(article.id))])]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.content_type.type))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.tags.length ? article.tags[0].name : ''))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.chapter ? article.chapter.name : ''))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._l((article.companies), function(company) {
      return [_vm._v("\n                " + _vm._s(company.name) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._l((article.industries), function(industry) {
      return [_vm._v("\n                " + _vm._s(industry.name) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(_vm.convertDate(article.updated_at, '.')))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.on_boarding ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_c('span', {
      staticClass: "status",
      class: {
        'status--archived': article.status === 2, 'status--published': article.status === 1, 'status--draft': article.status === 0
      }
    }, [_vm._v(_vm._s(_vm.getStatus(article.status)))])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "fixed",
      "left": "-2000px",
      "bottom": "-2000px"
    },
    attrs: {
      "href": "#",
      "id": "dataDownload"
    }
  }, [_vm._v("download")]), _vm._v(" "), (this.offset <= this.editedArticles.length) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(8), _vm._v("Load more\n          ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Task category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text",
    staticStyle: {
      "max-width": "75px"
    }
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Company specific")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text",
    staticStyle: {
      "max-width": "75px"
    }
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Industry specific")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Last Edited")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Onboarding task")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-brochure-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "landing-page-wrapper download-brochure-hero",
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-hero"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-title"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "landing-page-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-description"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.description) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "landing-page-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-download-request"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brochureRequest.email),
      expression: "brochureRequest.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "email",
      "name": "Email",
      "placeholder": "Write your email address..."
    },
    domProps: {
      "value": (_vm.brochureRequest.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brochureRequest, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: [{
      'disabled': this.errors.has('Email')
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.requestBrochure()
      }
    }
  }, [_vm._v("Get brochure")])]), _vm._v(" "), _c('div', {
    staticClass: "download-subscribe"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brochureRequest.subscribe),
      expression: "brochureRequest.subscribe"
    }],
    attrs: {
      "type": "checkbox",
      "id": "subscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.brochureRequest.subscribe) ? _vm._i(_vm.brochureRequest.subscribe, null) > -1 : (_vm.brochureRequest.subscribe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.brochureRequest.subscribe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.brochureRequest, "subscribe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.brochureRequest, "subscribe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.brochureRequest, "subscribe", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "subscribe"
    }
  }, [_vm._v("Subscribe me to the newsletter")])]), _vm._v(" "), (_vm.brochureRequest.subscribe) ? _c('div', {
    staticClass: "download-subscribe-info"
  }, [_c('strong', [_vm._v("Privacy:")]), _vm._v(" Your details will be used to keep you informed about resources provided by The Clear Company.\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to find out more about the services we provide.\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.brochureRequest.shown) ? _c('div', {
    staticClass: "request-status",
    class: _vm.brochureRequest.success ? 'success' : 'error'
  }, [_vm._v("\n              " + _vm._s(_vm.brochureRequest.message) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-wrapper download-brochure-summary"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-summary"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-summary__title"
  }, [_vm._v("\n              " + _vm._s(_vm.content.contentSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contentSection.title),
      expression: "content.contentSection.title"
    }],
    staticClass: "landing-page-summary__title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contentSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contentSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contentSection.title))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "landing-page-summary__items"
  }, _vm._l((_vm.content.contentSection.summary), function(item, index) {
    return _c('li', {
      staticClass: "landing-page-summary__item"
    }, [(!_vm.pageEditMode) ? _c('span', {
      staticClass: "landing-page-summary__item"
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "landing-page-summary__item",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Summary item",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.contentSection.summary, index)
        }
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection(_vm.content.contentSection.summary)
      }
    }
  }, [_vm._v("+ Add item")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v(_vm._s(_vm.email.subject))]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users background-1-20 color-2-100",
    attrs: {
      "to": {
        name: 'email-logs'
      }
    }
  }, [_vm._v("\n        Back to email logs\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('p', [_c('strong', [_vm._v("Subject")]), _vm._v(": " + _vm._s(_vm.email.subject ? _vm.email.subject : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Status")]), _vm._v(": " + _vm._s(_vm.email.status ? _vm.email.status.label : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mail to")]), _vm._v(": " + _vm._s(_vm.email.mail_to ? _vm.email.mail_to : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Type")]), _vm._v(": " + _vm._s(_vm.email.type ? _vm.email.type.label : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Date and time")]), _vm._v(": " + _vm._s(_vm.email.created ? _vm.convertDate(_vm.email.created) : 'n/a'))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "emailBody"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage company-landing"
  }, [(_vm.disableAPI) ? _c('div', {
    staticClass: "loading-data-wrapper"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [(_vm.successfullyRegistered) ? [_vm._m(1), _vm._v(" "), _vm._m(2)] : [_c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-register"
  }, [_c('div', {
    staticClass: "hero-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('form', {
    staticClass: "tcc-form",
    on: {
      "submit": function($event) {
        return _vm.register()
      }
    }
  }, [_c('div', {
    staticClass: "hero-register-details"
  }, [_c('h2', [_vm._v("Your details")]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-organisation-name"
    }
  }, [_vm._v("Organisation name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.organizationName),
      expression: "registerForm.organizationName"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.organizationName !== '' || _vm.registerForm.organizationNameFocus,
      'active': _vm.registerForm.organizationName !== '' || _vm.registerForm.organizationNameFocus,
      'has-error': _vm.errors.has('Organisation name')
    }],
    attrs: {
      "id": "register-organisation-name",
      "data-lpignore": "true",
      "type": "text",
      "name": "Organisation name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.organizationName)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.organizationNameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.organizationNameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "organizationName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Organisation name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.name),
      expression: "registerForm.name"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'active': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'has-error': _vm.errors.has('First name')
    }],
    attrs: {
      "id": "register-name",
      "data-lpignore": "true",
      "type": "text",
      "name": "First name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.name)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.nameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.nameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.surname),
      expression: "registerForm.surname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'active': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'has-error': _vm.errors.has('Last name')
    }],
    attrs: {
      "id": "register-surname",
      "data-lpignore": "true",
      "type": "text",
      "name": "Last name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.surname)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.surnameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.surnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.email),
      expression: "registerForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'active': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'has-error': _vm.errors.has('Email address')
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email address",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "hero-register-password"
  }, [_c('h2', [_vm._v("Choose a password")]), _vm._v(" "), _c('p', [_vm._v("\n                        The password must contain at least 9 characters that include capital letters, lower case letters and numbers.\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-password"
    }
  }, [_vm._v("Password*")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('passwordType')
      }
    }
  }), _vm._v(" "), ((_vm.registerForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.password),
      expression: "registerForm.password"
    }],
    ref: "password",
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.password !== '' || _vm.registerForm.passwordFocus,
      'active': _vm.registerForm.password !== '' || _vm.registerForm.passwordFocus,
      'has-error': _vm.errors.has('Password')
    }],
    attrs: {
      "id": "register-password",
      "data-lpignore": "true",
      "name": "Password",
      "placeholder": "Type in here...",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.password) ? _vm._i(_vm.registerForm.password, null) > -1 : (_vm.registerForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.registerForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.registerForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.password),
      expression: "registerForm.password"
    }],
    ref: "password",
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.password !== '' || _vm.registerForm.passwordFocus,
      'active': _vm.registerForm.password !== '' || _vm.registerForm.passwordFocus,
      'has-error': _vm.errors.has('Password')
    }],
    attrs: {
      "id": "register-password",
      "data-lpignore": "true",
      "name": "Password",
      "placeholder": "Type in here...",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.registerForm.password, null)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.registerForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.password),
      expression: "registerForm.password"
    }],
    ref: "password",
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.password !== '' || _vm.registerForm.passwordFocus,
      'active': _vm.registerForm.password !== '' || _vm.registerForm.passwordFocus,
      'has-error': _vm.errors.has('Password')
    }],
    attrs: {
      "id": "register-password",
      "data-lpignore": "true",
      "name": "Password",
      "placeholder": "Type in here...",
      "type": _vm.registerForm.passwordType
    },
    domProps: {
      "value": (_vm.registerForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-retype-password"
    }
  }, [_vm._v("Repeat password*")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('retypePasswordType')
      }
    }
  }), _vm._v(" "), ((_vm.registerForm.retypePasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.retypePassword),
      expression: "registerForm.retypePassword"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.retypePassword !== '' || _vm.registerForm.retypePasswordFocus,
      'active': _vm.registerForm.retypePassword !== '' || _vm.registerForm.retypePasswordFocus,
      'has-error': _vm.errors.has('Repeat password')
    }],
    attrs: {
      "id": "register-retype-password",
      "data-lpignore": "true",
      "name": "Repeat password",
      "placeholder": "Type in here...",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.retypePassword) ? _vm._i(_vm.registerForm.retypePassword, null) > -1 : (_vm.registerForm.retypePassword)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.retypePasswordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.registerForm.retypePassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "retypePassword", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "retypePassword", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "retypePassword", $$c)
        }
      }
    }
  }) : ((_vm.registerForm.retypePasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.retypePassword),
      expression: "registerForm.retypePassword"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.retypePassword !== '' || _vm.registerForm.retypePasswordFocus,
      'active': _vm.registerForm.retypePassword !== '' || _vm.registerForm.retypePasswordFocus,
      'has-error': _vm.errors.has('Repeat password')
    }],
    attrs: {
      "id": "register-retype-password",
      "data-lpignore": "true",
      "name": "Repeat password",
      "placeholder": "Type in here...",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.registerForm.retypePassword, null)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.retypePasswordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.registerForm, "retypePassword", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.retypePassword),
      expression: "registerForm.retypePassword"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.retypePassword !== '' || _vm.registerForm.retypePasswordFocus,
      'active': _vm.registerForm.retypePassword !== '' || _vm.registerForm.retypePasswordFocus,
      'has-error': _vm.errors.has('Repeat password')
    }],
    attrs: {
      "id": "register-retype-password",
      "data-lpignore": "true",
      "name": "Repeat password",
      "placeholder": "Type in here...",
      "type": _vm.registerForm.retypePasswordType
    },
    domProps: {
      "value": (_vm.registerForm.retypePassword)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.retypePasswordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "retypePassword", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Repeat password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Repeat password')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "hero-register-terms"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.terms),
      expression: "registerForm.terms"
    }],
    staticClass: "tcc-form-element tcc-form-element__checkbox",
    class: [{
      'has-error': _vm.errors.has('Terms and Conditions')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "register-terms",
      "name": "Terms and Conditions"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.terms) ? _vm._i(_vm.registerForm.terms, null) > -1 : (_vm.registerForm.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registerForm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "terms", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "terms", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "terms", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "register-terms"
    }
  }, [_vm._v("Agree to the Clear Assured "), _c('router-link', {
    attrs: {
      "to": "/terms-of-service"
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v("*.")], 1), _vm._v(" "), (this.errors.has('Terms and Conditions')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Terms and Conditions')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.privacy),
      expression: "registerForm.privacy"
    }],
    staticClass: "tcc-form-element tcc-form-element__checkbox",
    class: [{
      'has-error': _vm.errors.has('Privacy policy')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "register-privacy",
      "name": "Privacy policy"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.privacy) ? _vm._i(_vm.registerForm.privacy, null) > -1 : (_vm.registerForm.privacy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registerForm.privacy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "privacy", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "privacy", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "privacy", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "register-privacy"
    }
  }, [_vm._v("Agree to the Clear Assured "), _c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v("*.")], 1), _vm._v(" "), (this.errors.has('Privacy policy')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Privacy policy')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action",
    class: [{
      'submitting': _vm.formStatus.submitting
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.register()
      }
    }
  }, [_vm._v("\n                        Create account\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                        Submitting\n                      ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                            " + _vm._s(_vm.formStatus.title) + "\n                          ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.formStatus.body) + "\n                          ")]) : _vm._e()] : (_vm.formStatus.submitted && this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                            Please fill in the required information\n                          ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk.")])] : _vm._e()]], 2)])])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-title"
  }, [_c('h1', {
    staticClass: "content color-2-100"
  }, [_vm._v("\n                  We're almost there.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-description"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v("\n                  Before we can move any further, we've sent you an email with a validation link. Please "), _c('strong', [_vm._v("follow the instructions from the email to validate your email address")]), _vm._v(" and move forward to the next step.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Fields marked with an asterisk ("), _c('span', [_vm._v("*")]), _vm._v(") are mandatory.")])
}]}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Search in resources..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        return _vm.mainSearch(1, 20)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  }, [_c('icon', {
    attrs: {
      "name": "search"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Status")])])
}]}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "post-title color-1-100 background-1-10-after"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.categories.length) + " subcategories\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new category")])]), _vm._v(" "), (_vm.parent) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.updatedCategories.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_c('button', {
    class: {
      'hover-filter-element': _vm.isExist(this.parent)
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeSelectedFilters,
      "mouseover": function($event) {
        return _vm.addHoverElement([{
          label: _vm.parent.label,
          value: _vm.parent.value
        }])
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.parent.label))])]), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])])]) : _vm._e(), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-name"
    }
  }, [_vm._v("Category Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory.title),
      expression: "newCategory.title"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-name"
    },
    domProps: {
      "value": (_vm.newCategory.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCategory, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-icon"
    }
  }, [_vm._v("Category Icon")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory.icon),
      expression: "newCategory.icon"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-icon"
    },
    domProps: {
      "value": (_vm.newCategory.icon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCategory, "icon", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "select-parent-category"
    }
  }, [_vm._v("Parent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "name": "Category",
      "options": _vm.parentCategoriesForSelect,
      "id": "select-parent-category"
    },
    model: {
      value: (_vm.newCategory.parent),
      callback: function($$v) {
        _vm.$set(_vm.newCategory, "parent", $$v)
      },
      expression: "newCategory.parent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory.description),
      expression: "newCategory.description"
    }],
    staticClass: "form-control form-control__textarea",
    staticStyle: {
      "height": "140px"
    },
    attrs: {
      "name": "category-desc",
      "id": "textarea-category-desc",
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.newCategory.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCategory, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCategory()
      }
    }
  }, [_vm._v("Create category")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Category name..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-body__head_parent-select table-head-ceil table-head-hover",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCategoriesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(1)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCategoriesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 1),
      expression: "filerTableHead.selectedCeil === 1"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-1",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "name": "Category",
      "data-vv-as": "\"Category\"",
      "options": _vm.getCategoriesForSelect,
      "placeholder": "Parent"
    },
    model: {
      value: (_vm.parent),
      callback: function($$v) {
        _vm.parent = $$v
      },
      expression: "parent"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-body__head_count-articles table-head-ceil"
  }, [_vm._v("\n            No of articles\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedCategories), function(category, i) {
    return _c('tr', [(category.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding"
    }, [_vm._v("\n            " + _vm._s(category.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(category.isChild ? '- ' + category.title : category.title) + "\n          ")]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(category.parent ? category.parent.label : '-') + "\n          ")]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(category.contents.length))]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showEditionForm(category.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeCategory(category.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (category.type === 'edit') ? _c('td', {
      staticClass: "edit-row",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', {
      staticClass: "wrap-title-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.title),
        expression: "category.title"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Title"
      },
      domProps: {
        "value": (category.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-parent-select"
    }, [_c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      attrs: {
        "name": "Category",
        "options": _vm.getCategoriesForSelect,
        "searchable": false,
        "placeholder": "Parent"
      },
      model: {
        value: (category.parent),
        callback: function($$v) {
          _vm.$set(category, "parent", $$v)
        },
        expression: "category.parent"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.icon),
        expression: "category.icon"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Icon"
      },
      domProps: {
        "value": (category.icon)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "icon", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.description),
        expression: "category.description"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "name": "desc-textarea",
        "cols": "10",
        "rows": "1",
        "placeholder": "Description"
      },
      domProps: {
        "value": (category.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.discardСhanges(category.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editCategory(category.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Categories in \"Topics\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-category-desc"
    }
  }, [_vm._v("Category description\n            "), _c('span', [_vm._v("(will not show up in articles)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Type")])])
}]}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [_c('span', [(_vm.canEditRecommendedEmails || _vm.canEditOptionalEmails) ? [_vm._v("\n              Edit email preferences\n            ")] : [_vm._v("\n              Email preferences\n            ")]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "profile profile-custom background-1-20 color-2-100",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('span', {
    staticClass: "profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 11.096 14.417"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 11.096 14.417",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_497_",
      "cx": "5.548",
      "cy": "3.75",
      "r": "3.75"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_496_",
      "d": "M1.002,14.417c-0.619,0-1.087-0.558-0.989-1.17c0.442-2.766,2.492-4.455,5.535-4.455\n                s5.093,1.69,5.535,4.455c0.098,0.611-0.37,1.17-0.989,1.17H1.002z"
    }
  })])]), _vm._v("\n          Go to my profile\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [(_vm.emails && _vm.emails['required']) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 data",
    class: [{
      'active  color-1-100': _vm.activeSection === 'requiredEmails'
    }]
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 19.99 21"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 19.99 21",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0\n                      c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226\n                      c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657\n                      c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878\n                      c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995\n                      c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "10",
      "cy": "9.995",
      "r": "3"
    }
  })])])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('requiredEmails')
      }
    }
  }, [_vm._v("Required emails")])]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['recommended']) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'recommendedEmails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('recommendedEmails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 18"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 18",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12\n                      c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8\n                      S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1\n                      C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"
    }
  })])]), _vm._v(" "), (_vm.canEditRecommendedEmails === false) ? [_vm._v("Recommended emails")] : [_vm._v("Edit recommended emails")]], 2)]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['optional']) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 password",
    class: [{
      'active  color-1-100': _vm.activeSection === 'optionalEmails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('optionalEmails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65\n                      L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"
    }
  })])]), _vm._v(" "), (_vm.canEditOptionalEmails === false) ? [_vm._v("Optional emails")] : [_vm._v("Edit optional emails")]], 2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [(_vm.emails && _vm.emails['required']) ? _c('div', {
    ref: "requiredEmails",
    staticClass: "content-section consent-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'requiredEmails'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Required emails")]), _vm._v(" "), _vm._l((_vm.emails['required']), function(category, index) {
    return [_c('div', {
      staticClass: "form-group__checkbox-block"
    }, [_c('div', {
      staticClass: "form-group form-group__checkbox"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      staticClass: "form-control form-control__checkbox border-2-100-after",
      class: [{
        'is-locked': true
      }],
      attrs: {
        "type": "checkbox",
        "disabled": true,
        "checked": "checked",
        "data-lpignore": "true",
        "id": 'required-email-' + index.toLowerCase().replace(' ', '-')
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63 background-1-20-before border-1-20-before border-2-70-after",
      attrs: {
        "for": 'required-email-' + index.toLowerCase().replace(' ', '-')
      }
    }, [_vm._v(_vm._s(index))])])]), _vm._v(" "), _vm._l((category), function(email) {
      return [_c('div', {
        staticClass: "form-group form-group__checkbox form-group__checkbox-inside"
      }, [_c('div', {
        staticClass: "form-element"
      }, [_c('input', {
        staticClass: "form-control form-control__checkbox border-2-100-after",
        class: [{
          'is-locked': true
        }],
        attrs: {
          "type": "checkbox",
          "disabled": true,
          "checked": "checked",
          "data-lpignore": "true",
          "id": 'required-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "form-label color-2-63 background-1-20-before border-1-20-before border-2-70-after",
        attrs: {
          "for": 'required-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }, [_vm._v("\n                          " + _vm._s(email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '')) + "\n                        ")])])])]
    })], 2)]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['recommended']) ? _c('div', {
    ref: "recommendedEmails",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'recommendedEmails' || _vm.canEditRecommendedEmails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditRecommendedEmails === false) ? [_vm._v("Recommended emails")] : [_vm._v("Edit recommended emails")]], 2), _vm._v(" "), (_vm.canEditRecommendedEmails === false) ? _c('button', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditRecommendedEmails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.emails['recommended']), function(category, index) {
    return [_c('div', {
      staticClass: "form-group__checkbox-block"
    }, [_c('div', {
      staticClass: "form-group form-group__checkbox"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      staticClass: "form-control form-control__checkbox border-2-100-after",
      class: [{
        'is-locked': !_vm.canEditRecommendedEmails
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.canEditRecommendedEmails,
        "data-lpignore": "true",
        "id": 'recommended-email-' + index.toLowerCase().replace(' ', '-')
      },
      domProps: {
        "checked": _vm.allChildrenAreChecked(category)
      },
      on: {
        "change": function($event) {
          return _vm.checkAllChildren($event, category)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      class: !_vm.canEditRecommendedEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
      attrs: {
        "for": 'recommended-email-' + index.toLowerCase().replace(' ', '-')
      }
    }, [_vm._v(_vm._s(index))])])]), _vm._v(" "), _vm._l((category), function(email) {
      return [_c('div', {
        staticClass: "form-group form-group__checkbox form-group__checkbox-inside"
      }, [_c('div', {
        staticClass: "form-element"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (email['checked']),
          expression: "email['checked']"
        }],
        staticClass: "form-control form-control__checkbox border-2-100-after",
        class: [{
          'is-locked': !_vm.canEditRecommendedEmails
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.canEditRecommendedEmails,
          "data-lpignore": "true",
          "id": 'recommended-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        },
        domProps: {
          "checked": Array.isArray(email['checked']) ? _vm._i(email['checked'], null) > -1 : (email['checked'])
        },
        on: {
          "change": function($event) {
            var $$a = email['checked'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(email, 'checked', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(email, 'checked', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(email, 'checked', $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "form-label color-2-63",
        class: !_vm.canEditRecommendedEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
        attrs: {
          "for": 'recommended-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }, [_vm._v("\n                          " + _vm._s(email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '')) + "\n                        ")])])])]
    })], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditRecommendedEmails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditRecommendedEmails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateEmailPreferences('recommended')
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['optional']) ? _c('div', {
    ref: "optionalEmails",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'optionalEmails' || _vm.canEditOptionalEmails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditOptionalEmails === false) ? [_vm._v("Optional emails")] : [_vm._v("Edit optional emails")]], 2), _vm._v(" "), (_vm.canEditOptionalEmails === false) ? _c('button', {
    staticClass: "edit-password edit-password-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditOptionalEmails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.emails['optional']), function(category, index) {
    return [_c('div', {
      staticClass: "form-group__checkbox-block"
    }, [_c('div', {
      staticClass: "form-group form-group__checkbox"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      staticClass: "form-control form-control__checkbox",
      class: [{
        'is-locked': !_vm.canEditOptionalEmails
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.canEditOptionalEmails,
        "data-lpignore": "true",
        "id": 'optional-email-' + index.toLowerCase().replace(' ', '-')
      },
      domProps: {
        "checked": _vm.allChildrenAreChecked(category)
      },
      on: {
        "change": function($event) {
          return _vm.checkAllChildren($event, category)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      class: !_vm.canEditOptionalEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
      attrs: {
        "for": 'optional-email-' + index.toLowerCase().replace(' ', '-')
      }
    }, [_vm._v(_vm._s(index))])])]), _vm._v(" "), _vm._l((category), function(email) {
      return [_c('div', {
        staticClass: "form-group form-group__checkbox form-group__checkbox-inside"
      }, [_c('div', {
        staticClass: "form-element"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (email['checked']),
          expression: "email['checked']"
        }],
        staticClass: "form-control form-control__checkbox",
        class: [{
          'is-locked': !_vm.canEditOptionalEmails
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.canEditOptionalEmails,
          "data-lpignore": "true",
          "id": 'optional-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        },
        domProps: {
          "checked": Array.isArray(email['checked']) ? _vm._i(email['checked'], null) > -1 : (email['checked'])
        },
        on: {
          "change": function($event) {
            var $$a = email['checked'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(email, 'checked', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(email, 'checked', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(email, 'checked', $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "form-label color-2-63",
        class: !_vm.canEditOptionalEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
        attrs: {
          "for": 'optional-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }, [_vm._v("\n                          " + _vm._s(email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '')) + "\n                        ")])])])]
    })], 2)]
  }), _vm._v(" "), (_vm.canEditOptionalEmails) ? _c('div', {
    staticClass: "update-data update-data__password"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditOptionalEmails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateEmailPreferences('optional')
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-list"
  }, [(_vm.isDesktop && _vm.isAdmin && _vm.currentCompany) ? _c('div', {
    staticClass: "tasks-list-admin-header"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit-company',
        params: {
          id: _vm.company
        }
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n      Back to \"" + _vm._s(_vm.currentCompany.label) + "\"\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-element tasks-list-admin-header-companies"
  }, [_c('label', {
    attrs: {
      "for": "companiesList"
    }
  }, [_vm._v("Change company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select tasks-list-header-boards-selector",
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "clearable": false,
      "value": this.currentCompany,
      "name": "companiesList",
      "id": "companiesList"
    },
    on: {
      "change": function($event) {
        return _vm.changeCompany($event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isDesktop) ? _c('div', {
    staticClass: "task-header tasks-list-header",
    class: {
      'search-opened': _vm.activeSearch, 'filters-opened': _vm.activeFilters
    },
    attrs: {
      "id": "taskHeader"
    }
  }, [_c('div', {
    staticClass: "tasks-list-header-buttons"
  }, [_c('div', [(_vm.isAdmin) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'edit-company',
        params: {
          id: _vm.company
        }
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })])]) : _c('router-link', {
    attrs: {
      "to": {
        name: _vm.userDashboard
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })])]), _vm._v(" "), _c('app-select', {
    staticClass: "tasks-list-header-boards-selector",
    attrs: {
      "options": _vm.taskBoardList,
      "searchable": false,
      "customActive": false,
      "clearable": false,
      "value": this.activeTab,
      "data-vv-name": "Task boards",
      "data-lpignore": "true",
      "name": "taskBoards",
      "id": "taskBoards"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskBoard($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "tasks-list-header-buttons-search-button",
    class: {
      active: _vm.activeSearch
    },
    on: {
      "click": function($event) {
        return _vm.activateSearch()
      }
    }
  }, [(_vm.activeSearch) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                  0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                  12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                  0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-search fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "search",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9\n                  0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4\n                  33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2\n                  128 128 0 70.7-57.2 128-128 128z"
    }
  })])]], 2), _vm._v(" "), _c('button', {
    staticClass: "tasks-list-header-buttons-filters-button",
    class: {
      active: _vm.activeFilters
    },
    on: {
      "click": function($event) {
        return _vm.activateFilters()
      }
    }
  }, [(_vm.activeFilters) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                  0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                  12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                  0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])] : [(_vm.allActiveFiltersCount) ? _c('span', {
    staticClass: "tasks-list-header-buttons-filters-button-count"
  }, [_vm._v(_vm._s(_vm.allActiveFiltersCount))]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-filter fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "filter",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17\n                  10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    }
  })])]], 2)])]), _vm._v(" "), (_vm.activeSearch || _vm.activeFilters) ? _c('div', {
    staticClass: "tasks-list-header-container"
  }, [_c('tasks-device-filters', {
    attrs: {
      "company": _vm.company,
      "only-search": _vm.activeSearch,
      "list": _vm.activeTab.value
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tabs', [_c('tab', {
    attrs: {
      "name": "Current focus",
      "alias": "focus"
    }
  }, [(_vm.isDesktop) ? _c('tasks-filters', {
    attrs: {
      "company": _vm.company,
      "list": "focus"
    }
  }) : _vm._e(), _vm._v(" "), _c('focus-tasks', {
    attrs: {
      "company": _vm.company
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Backlog",
      "alias": "backlog",
      "selected": true
    }
  }, [(_vm.isDesktop) ? _c('tasks-filters', {
    attrs: {
      "company": _vm.company,
      "list": "backlog"
    }
  }) : _vm._e(), _vm._v(" "), _c('backlog-tasks', {
    attrs: {
      "company": _vm.company
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results-page"
  }, [_c('div', {
    staticClass: "search-results-container"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("\n      Search results for \""), _c('i', [_vm._v(_vm._s(this.$route.query.search))]), _vm._v("\"\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-filter"
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Filter by Type",
      "value.sync": "selectedType",
      "on-change": _vm.selectType,
      "options": _vm.getContentTypeForSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-result"
  }, [_c('ul', {
    staticClass: "search-result-main"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "search-result-main-item",
      class: _vm.itemClass(item.content_type.type)
    }, [_c('router-link', {
      staticClass: "search-result-main-item-href",
      attrs: {
        "to": {
          name: 'content',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])], 1)
  }), 0)]), _vm._v(" "), (this.noMore === false) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(0), _vm._v("Load more\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article"
  }, [(_vm.article) ? _c('div', {
    staticClass: "next-gen-article__container"
  }, [_c('div', {
    staticClass: "next-gen-article__title"
  }, [(_vm.article.content_type.id === 7) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "21",
      "height": "21",
      "viewBox": "0 0 21 21"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M22.68,17.019l-7.452-4.53a1.018,1.018,0,0,0-1.511.889v8.807a1.02,1.02,0,0,0,1.511.889L22.68,18.8a1.019,1.019,0,0,0,0-1.779Zm5.6.762a10.5,10.5,0,0,0-10.5-10.5h0a10.5,10.5,0,0,0-10.5,10.5v0a10.5,10.5,0,0,0,10.5,10.5h0a10.5,10.5,0,0,0,10.5-10.5Zm-18.967,0a8.465,8.465,0,0,1,8.462-8.467h0a8.465,8.465,0,0,1,8.467,8.462v0a8.465,8.465,0,0,1-8.462,8.467h0a8.465,8.465,0,0,1-8.467-8.462Z",
      "transform": "translate(-7.281 -7.281)"
    }
  })])]) : (_vm.article.content_type.id === 8) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15.746",
      "height": "21.004",
      "viewBox": "0 0 15.746 21.004"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M24.417,11.02,20.972,7.579A1.97,1.97,0,0,0,19.582,7H11.219A1.975,1.975,0,0,0,9.25,8.974V26.032A1.969,1.969,0,0,0,11.219,28h11.81A1.97,1.97,0,0,0,25,26.032V12.414A1.982,1.982,0,0,0,24.417,11.02Zm-1.55,1.234h-3.12V9.134ZM11.219,26.032V8.974H17.78v4.264a.982.982,0,0,0,.98.984h4.269v11.81H11.219ZM21.483,20.14c-.511-.492-1.933-.363-2.645-.267a3.551,3.551,0,0,1-1.509-1.9,5.165,5.165,0,0,0,.222-2.3.914.914,0,0,0-1.75-.241,5.915,5.915,0,0,0,.289,2.751,33.027,33.027,0,0,1-1.451,3.051c-.816.422-1.927,1.074-2.091,1.894-.135.647,1.066,2.264,3.12-1.283a20.322,20.322,0,0,1,2.8-.825,5.45,5.45,0,0,0,2.288.7.947.947,0,0,0,.723-1.585h0Zm-8.128,3.19A4.918,4.918,0,0,1,14.6,21.9C13.822,23.136,13.354,23.358,13.354,23.33ZM16.7,15.515c.3,0,.275,1.317.073,1.673a3.433,3.433,0,0,1-.073-1.674Zm-1,5.6a16.12,16.12,0,0,0,1.012-2.242,4.513,4.513,0,0,0,1.235,1.456,13.949,13.949,0,0,0-2.248.786Zm5.4-.205s-.205.247-1.524-.315c1.433-.11,1.671.218,1.524.315Z",
      "transform": "translate(-9.25 -6.996)"
    }
  })])]) : (_vm.article.content_type.id === 9) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15.75",
      "height": "21",
      "viewBox": "0 0 15.75 21"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M21.063,17.172a.493.493,0,0,0-.495-.492H13.683a.494.494,0,0,0-.492.492V18.32a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492Zm-.5,2.953H13.683a.494.494,0,0,0-.492.492v1.148a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492V20.617A.494.494,0,0,0,20.567,20.125ZM25,12.41a1.959,1.959,0,0,0-.583-1.385L20.975,7.583A1.97,1.97,0,0,0,19.584,7H11.219A1.97,1.97,0,0,0,9.25,8.969V26.032A1.969,1.969,0,0,0,11.219,28H23.032A1.971,1.971,0,0,0,25,26.032ZM19.75,9.129l3.121,3.121H19.75Zm3.282,16.9H11.219V8.969h6.563v4.265a.982.982,0,0,0,.98.985h4.27Z",
      "transform": "translate(-9.25 -7)"
    }
  })])]) : (_vm.article.content_type.id === 10) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "23.627",
      "height": "21",
      "viewBox": "0 0 23.627 21"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M20219.232-8589a.984.984,0,0,1-.98-.984.985.985,0,0,1,.98-.985h2.955l.656-1.971h-7.873a1.969,1.969,0,0,1-1.971-1.966v-13.128a1.969,1.969,0,0,1,1.971-1.966h19.686a1.969,1.969,0,0,1,1.971,1.966v13.128a1.976,1.976,0,0,1-1.971,1.971h-7.877l.66,1.966h2.951a.982.982,0,0,1,.949.949.986.986,0,0,1-.949,1.021Zm-3.605-6.566H20234v-11.813h-18.375Zm3.209-2.479a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h7a.58.58,0,0,1,.58.584v1.163a.58.58,0,0,1-.58.584Zm0-4.667a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h10.5a.584.584,0,0,1,.584.584v1.163a.584.584,0,0,1-.584.584Z",
      "transform": "translate(-20213 8609.998)"
    }
  })])]) : (_vm.article.content_type.id === 11) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18.53",
      "height": "22.876",
      "viewBox": "0 0 18.53 22.876"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-8 -6.124)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M18.744,14.421H11.87a.493.493,0,0,0-.492.492v1.147a.493.493,0,0,0,.492.492h6.425a5.959,5.959,0,0,1,.886-.275.486.486,0,0,0,.056-.217l0-1.147a.493.493,0,0,0-.5-.492Z",
      "transform": "translate(0.517 1.307)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M11.378,17.866v1.147a.493.493,0,0,0,.492.492h3a6.083,6.083,0,0,1,1.4-2.13h-4.4A.493.493,0,0,0,11.378,17.866Z",
      "transform": "translate(0.526 1.772)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M9.967,25.007V8.078h6.554V12.31a.978.978,0,0,0,.979.977h4.264v4.19a6.065,6.065,0,0,1,1.966.552V11.491a1.937,1.937,0,0,0-.583-1.374L19.71,6.7a1.974,1.974,0,0,0-1.389-.579H9.967A1.961,1.961,0,0,0,8,8.078V25.007A1.961,1.961,0,0,0,9.967,26.96h6.152a5.993,5.993,0,0,1-.9-1.953Zm8.52-16.77,3.117,3.1H18.486Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M25.194,25.933l-1.815-1.815a.44.44,0,0,0-.31-.127h-.3a3.787,3.787,0,0,0-2.983-6.117h0A3.786,3.786,0,0,0,16,21.658v0a3.786,3.786,0,0,0,3.784,3.787h0a3.763,3.763,0,0,0,2.33-.8v.3a.44.44,0,0,0,.127.31l1.815,1.814a.437.437,0,0,0,.615,0l0,0,.515-.516A.441.441,0,0,0,25.194,25.933Zm-5.407-1.942a2.33,2.33,0,1,1,2.33-2.33A2.33,2.33,0,0,1,19.787,23.991Z",
      "transform": "translate(1.21 1.803)"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.article.title))])]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__sections"
  }, [_c('div', {
    staticClass: "next-gen-article__section next-gen-article__content",
    attrs: {
      "role": "main"
    }
  }, [((_vm.player.shown && _vm.player.url) || (_vm.imageFullPath !== '' && !_vm.player.shown)) ? _c('div', {
    staticClass: "task-content-media"
  }, [(_vm.player.shown && _vm.player.url) ? _c('div', {
    staticClass: "task-content-video"
  }, [_c('iframe', {
    attrs: {
      "id": "player",
      "frameborder": "0",
      "webkitAllowFullScreen": "",
      "mozallowfullscreen": "",
      "allowFullScreen": "",
      "height": "340",
      "width": "600",
      "src": _vm.player.url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imageFullPath !== '' && !_vm.player.shown) ? _c('div', {
    staticClass: "task-content-image",
    class: {
      'video-type': _vm.player.url
    },
    style: ({
      backgroundImage: 'url(' + _vm.imageFullPath + ')'
    }),
    attrs: {
      "title": _vm.article.alt
    }
  }, [(_vm.player.url) ? _c('div', {
    staticClass: "task-content-video-play",
    on: {
      "click": function($event) {
        return _vm.playVideo()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-play-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "play-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1\n                16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200\n                200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
    }
  })])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.article.content_type.id === 8 || _vm.article.content_type.id === 9) ? _c('div', {
    staticClass: "task-content-resources"
  }, [_c('div', {
    staticClass: "task-content-resources-items"
  }, _vm._l((_vm.article.resources), function(resource) {
    return (resource.file) ? _c('a', {
      attrs: {
        "href": "#",
        "role": "button",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadFile(resource)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-circle-down fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-circle-down",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288\n             302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4\n             9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(resource.name ? resource.name : resource.file))])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-content-text",
    domProps: {
      "innerHTML": _vm.article.content
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "task-content-meta"
  }, [(_vm.article.categories && _vm.article.categories.length) ? _c('div', [_c('i', {
    staticClass: "fas fa-binoculars"
  }), _vm._v(" "), _c('div', [_vm._l((_vm.article.categories), function(category, index) {
    return [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            categories: category.id
          }
        }
      }
    }, [_vm._v(_vm._s(category.title))])]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.article.tags && _vm.article.tags.length) ? _c('div', [_c('i', {
    staticClass: "fas fa-tag"
  }), _vm._v(" "), _c('div', [_vm._l((_vm.article.tags), function(tag, index) {
    return [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            topics: tag.id
          }
        }
      }
    }, [_vm._v(_vm._s(tag.name))])]
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.relatedArticles && _vm.relatedArticles.length) ? _c('div', {
    staticClass: "task-content-related"
  }, [_c('div', {
    staticClass: "task-content-related-header"
  }, [_vm._v("\n            Related resources\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "task-content-related-list"
  }, _vm._l((_vm.relatedArticles), function(item) {
    return _c('li', {
      staticClass: "task-content-related-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          'name': 'content',
          'params': {
            'id': item.id
          }
        }
      }
    }, [(item.content_type) ? _c('div', {
      staticClass: "task-content-related-icon"
    }, [(item.content_type.id === 7) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "play",
        "d": "M20.068,15.367l-6.188-3.762c-0.408-0.226-0.922-0.079-1.149,0.329\n                            c-0.069,0.125-0.106,0.266-0.106,0.409v7.313c0.001,0.467,0.381,0.845,0.849,0.843c0.142,0,0.282-0.037,0.406-0.105l6.188-3.55\n                            c0.408-0.228,0.554-0.743,0.326-1.151C20.317,15.556,20.205,15.443,20.068,15.367z M24.719,16c0.001-4.814-3.901-8.718-8.715-8.719\n                            c-0.001,0-0.003,0-0.004,0c-4.814-0.001-8.718,3.901-8.719,8.715c0,0.001,0,0.003,0,0.004c-0.001,4.814,3.901,8.718,8.715,8.719\n                            c0.001,0,0.003,0,0.004,0c4.814,0.001,8.718-3.901,8.719-8.715C24.719,16.003,24.719,16.001,24.719,16z M8.969,16\n                            c-0.001-3.882,3.145-7.03,7.027-7.031c0.001,0,0.003,0,0.004,0c3.882-0.001,7.03,3.145,7.031,7.027c0,0.001,0,0.003,0,0.004\n                            c0.001,3.882-3.145,7.03-7.027,7.031c-0.001,0-0.003,0-0.004,0c-3.882,0.001-7.03-3.145-7.031-7.027\n                            C8.969,16.003,8.969,16.001,8.969,16z"
      }
    })])])] : (item.content_type.id === 8) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-pdf",
        "d": "M22.254,10.446L19.3,7.496c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17\n                              c-0.934,0.003-1.69,0.762-1.688,1.696v14.625c0.001,0.932,0.756,1.687,1.688,1.687h10.125c0.931-0.001,1.686-0.756,1.687-1.687\n                              V11.641C22.749,11.193,22.57,10.763,22.254,10.446z M20.925,11.504H18.25V8.829L20.925,11.504z M10.938,23.317V8.692h5.625v3.656\n                              c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v10.125H10.938z M19.738,18.265\n                              c-0.438-0.422-1.657-0.311-2.268-0.229c-0.609-0.374-1.067-0.95-1.294-1.628c0.211-0.634,0.276-1.307,0.19-1.969\n                              c-0.054-0.43-0.446-0.734-0.876-0.68c-0.277,0.035-0.515,0.215-0.624,0.473c-0.105,0.795-0.02,1.603,0.248,2.359\n                              c-0.37,0.893-0.785,1.766-1.244,2.616c-0.7,0.362-1.652,0.921-1.793,1.624c-0.116,0.555,0.914,1.941,2.675-1.1\n                              c0.782-0.293,1.584-0.529,2.4-0.707c0.602,0.343,1.272,0.548,1.962,0.6c0.448,0.011,0.821-0.343,0.832-0.792\n                              c0.005-0.209-0.071-0.413-0.212-0.567H19.738z M12.769,21c0.273-0.476,0.636-0.893,1.069-1.23\n                              C13.17,20.834,12.769,21.024,12.769,21z M15.638,14.3c0.26,0,0.236,1.129,0.063,1.434c-0.139-0.466-0.161-0.959-0.063-1.435V14.3z\n                               M14.78,19.1c0.338-0.618,0.628-1.26,0.868-1.922c0.26,0.487,0.621,0.912,1.059,1.248C16.047,18.595,15.402,18.821,14.78,19.1\n                              L14.78,19.1z M19.407,18.924c0,0-0.176,0.212-1.307-0.27C19.329,18.56,19.533,18.841,19.407,18.924L19.407,18.924z"
      }
    })])])] : (item.content_type.id === 9) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-alt",
        "d": "M19.375,15.719c-0.001-0.234-0.19-0.423-0.424-0.422H18.95h-5.9\n                              c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9c0.233-0.001,0.421-0.189,0.422-0.422\n                              L19.375,15.719z M18.95,18.25h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9\n                              c0.233-0.001,0.421-0.189,0.422-0.422v-0.984C19.371,18.439,19.183,18.251,18.95,18.25z M22.75,11.637\n                              c-0.002-0.446-0.182-0.873-0.5-1.187L19.3,7.5c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17C10.006,7,9.25,7.756,9.25,8.688v14.625\n                              C9.251,24.245,10.006,25,10.938,25h10.125c0.931-0.001,1.686-0.756,1.687-1.687V11.637z M18.25,8.825l2.675,2.675H18.25V8.825z\n                               M21.063,23.313H10.938V8.688h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656V23.313z"
      }
    })])])] : (item.content_type.id === 10) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M24.438,7H7.563C6.631,7,5.875,7.756,5.875,8.688v11.25c0.001,0.932,0.756,1.687,1.688,1.687h6.75\n                              l-0.563,1.688h-2.531c-0.466,0-0.844,0.378-0.844,0.844S10.753,25,11.219,25h9.563c0.466-0.016,0.831-0.407,0.814-0.872\n                              c-0.015-0.443-0.371-0.799-0.814-0.814H18.25l-0.562-1.687h6.75c0.932-0.001,1.688-0.757,1.687-1.689V8.688\n                              C26.125,7.756,25.37,7.001,24.438,7z M23.875,19.375H8.125V9.25h15.75V19.375z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,13.25h9c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-9c-0.276,0-0.5,0.224-0.5,0.5v1\n                              C10.375,13.026,10.599,13.25,10.875,13.25z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,17.25h6c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276,0-0.5,0.224-0.5,0.5v1\n                              C10.375,17.025,10.599,17.25,10.875,17.25z"
      }
    })])])])] : (item.content_type.id === 11) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M17.7,14.421h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.514\n                              c0.245-0.097,0.498-0.177,0.76-0.236c0.028-0.057,0.048-0.118,0.048-0.186l0.003-0.984C18.124,14.609,17.935,14.42,17.7,14.421\n                              C17.701,14.421,17.7,14.421,17.7,14.421z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M11.378,17.796v0.984c0.001,0.233,0.189,0.421,0.422,0.422h2.571c0.272-0.693,0.68-1.316,1.203-1.828H11.8\n                              C11.567,17.375,11.379,17.563,11.378,17.796z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M9.688,22.437V7.812h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v3.62\n                              c0.599,0.067,1.166,0.225,1.687,0.477v-5.648c-0.002-0.446-0.182-0.873-0.5-1.187l-2.95-2.95c-0.315-0.318-0.744-0.498-1.192-0.5\n                              h-7.17C8.756,6.124,8,6.88,8,7.812v14.625c0.001,0.932,0.756,1.687,1.688,1.687h5.28c-0.356-0.503-0.615-1.074-0.776-1.687H9.688z\n                               M17,7.949l2.675,2.675H17V7.949z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M23.891,24.791l-1.558-1.558c-0.071-0.07-0.166-0.109-0.266-0.109h-0.254c0.447-0.571,0.689-1.275,0.688-2\n                              c0.001-1.794-1.454-3.249-3.248-3.25c-0.001,0-0.002,0-0.003,0c-1.794-0.001-3.249,1.454-3.25,3.248c0,0.001,0,0.001,0,0.002\n                              c-0.001,1.794,1.454,3.249,3.248,3.25c0.001,0,0.001,0,0.002,0c0.725,0.002,1.429-0.24,2-0.687v0.255\n                              c0,0.1,0.039,0.195,0.109,0.266l1.558,1.557c0.145,0.146,0.381,0.147,0.528,0.003c0.001-0.001,0.002-0.002,0.003-0.003\n                              l0.442-0.443C24.035,25.176,24.036,24.939,23.891,24.791z M19.25,23.124c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2\n                              S20.355,23.124,19.25,23.124z"
      }
    })])])])] : _vm._e()], 2) : _vm._e(), _vm._v("\n                " + _vm._s(item.title) + "\n              ")])], 1)
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__side",
    class: {
      'equal-sections': _vm.isRegularUser
    },
    attrs: {
      "role": "complementary"
    }
  }, [(_vm.isLightUser || _vm.isAdmin) ? [(_vm.articleCategories) ? _c('div', {
    staticClass: "next-gen-article__section next-gen-article__categories"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "next-gen-article__categories--items"
  }, _vm._l((_vm.articleCategories), function(category) {
    return _c('li', {
      key: category.id
    }, [_c('router-link', {
      staticClass: "next-gen-article__categories--item",
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            categories: category.id
          }
        }
      }
    }, [(category.icon) ? _c('div', {
      staticClass: "next-gen-article__categories--item__icon",
      domProps: {
        "innerHTML": _vm._s(category.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(category.title))])])], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.articleTopics) ? _c('div', {
    staticClass: "next-gen-article__section next-gen-article__topics"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__topics--items"
  }, _vm._l((_vm.articleTopics), function(topic) {
    return _c('router-link', {
      key: topic.id,
      staticClass: "next-gen-article__topics--item",
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            topics: topic.id
          }
        }
      }
    }, [(topic.icon) ? _c('div', {
      staticClass: "next-gen-article__topics--item__icon",
      domProps: {
        "innerHTML": _vm._s(topic.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(topic.title))])])
  }), 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isRegularUser) ? [(_vm.relatedTasks && _vm.relatedTasks.length) ? _c('div', {
    staticClass: "next-gen-article__section next-gen-article__tasks"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__tasks--items"
  }, _vm._l((_vm.relatedTasks), function(task) {
    return _c('router-link', {
      key: task.id,
      staticClass: "next-gen-article__tasks--item",
      attrs: {
        "to": {
          name: 'task',
          params: {
            id: task.id
          }
        },
        "aria-label": task.title
      }
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-data"
    }, [_c('span', {
      staticClass: "next-gen-article__tasks--item-key",
      class: {
        'line-through': task.status && task.status.id === 4
      }
    }, [_vm._v("\n                    " + _vm._s(task.key) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "next-gen-article__tasks--item-name"
    }, [_vm._v("\n                    " + _vm._s(task.title) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta"
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-chapter",
      class: {
        empty: !task.chapter
      }
    }, [(task.chapter) ? [_c('div', {
      staticClass: "next-gen-article__tasks--item-chapter-progress"
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-chapter-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(task.chapter)
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + task.chapter.id,
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-chapter-name"
    }, [_vm._v(_vm._s(task.chapter.name))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user-info"
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-meta-properties"
    }, [(task.recurrent) ? _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-property recurrency"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "sync-alt",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                          53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                          94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                          57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                          0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                          162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                          504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
      }
    })])]) : _vm._e(), _vm._v(" "), (task.mandatory) ? _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-property mandatory"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "exclamation-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                          111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                          136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                          0-12.356 5.78-11.981 12.654z"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user priority",
      class: ['priority-' + _vm.taskPriorityDelta(task.score)]
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-up fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-up",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6\n                                              0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.taskPriorityLabelByValue(_vm.taskPriorityDelta(task.score))))])]), _vm._v(" "), (task.status) ? _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user status",
      class: ['status-' + task.status.id]
    }, [(task.status.id === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (task.status.id === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (task.status.id === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (task.status.id === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "status-text"
    }, [_vm._v(_vm._s(task.status.name))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user user-avatar"
    }, [(task.assignee) ? [(task.assignee.image) ? _c('span', {
      style: ({
        backgroundImage: 'url(\'' + _vm.imageBase + task.assignee.image + '\')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": task.assignee.name,
        "size": 32,
        "color": "#ffffff"
      }
    })] : [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                              88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                              55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                              7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])]], 2)])])])
  }), 1)]) : _vm._e()] : _vm._e()], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article__section--title"
  }, [_c('i', {
    staticClass: "fas fa-sitemap"
  }), _vm._v(" "), _c('h2', [_vm._v("Categories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article__section--title"
  }, [_c('i', {
    staticClass: "fas fa-tag"
  }), _vm._v(" "), _c('h2', [_vm._v("Topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article__section--title"
  }, [_c('i', {
    staticClass: "fas fa-link"
  }), _vm._v(" "), _c('h2', [_vm._v("Related tasks")])])
}]}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-actions"
  }, [_c('div', {
    staticClass: "task-actions-assignee"
  }, [_c('div', {
    staticClass: "task-actions-title"
  }, [_vm._v("\n      Assignee\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-actions-body"
  }, [_c('app-select', {
    staticClass: "task-actions-selector assignee-type",
    attrs: {
      "searchable": true,
      "customType": "assignee",
      "options": _vm.taskAssigneeForSelect,
      "imageBase": _vm.imageBase,
      "customActive": false,
      "clearable": false,
      "placeholder": "Type in a name...",
      "data-vv-name": "Assignee",
      "data-lpignore": "true",
      "name": "assignee",
      "id": "assignee"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskAssignee()
      }
    },
    model: {
      value: (_vm.taskAssignee),
      callback: function($$v) {
        _vm.taskAssignee = $$v
      },
      expression: "taskAssignee"
    }
  })], 1)]), _vm._v(" "), (_vm.taskStatus) ? _c('div', {
    staticClass: "task-actions-status"
  }, [_c('div', {
    staticClass: "task-actions-title"
  }, [_vm._v("\n      Status\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-actions-body"
  }, [_c('app-select', {
    staticClass: "task-actions-selector status-type",
    class: 'status-type-' + _vm.taskStatus.value,
    attrs: {
      "searchable": false,
      "customType": "status",
      "options": _vm.taskStatusesForSelectBasedOnTaskAssessment,
      "customActive": false,
      "clearable": false,
      "data-vv-name": "Status",
      "data-lpignore": "true",
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskStatus()
      }
    },
    model: {
      value: (_vm.taskStatus),
      callback: function($$v) {
        _vm.taskStatus = $$v
      },
      expression: "taskStatus"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.taskBoard) ? _c('div', {
    staticClass: "task-actions-move-to"
  }, [_c('div', {
    staticClass: "task-actions-title"
  }, [_vm._v("\n      Board\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-actions-body"
  }, [_c('app-select', {
    staticClass: "task-actions-selector board-type",
    class: 'board-type-' + _vm.taskBoard.value,
    attrs: {
      "searchable": false,
      "options": _vm.taskBoardsForSelect,
      "customActive": false,
      "clearable": false,
      "data-vv-name": "Board",
      "data-lpignore": "true",
      "name": "board",
      "id": "board"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskBoard()
      }
    },
    model: {
      value: (_vm.taskBoard),
      callback: function($$v) {
        _vm.taskBoard = $$v
      },
      expression: "taskBoard"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.isAdmin) ? _c('button', {
    staticClass: "reset-task-messages background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetTaskMessages()
      }
    }
  }, [_vm._v("\n      Reset task history\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-page company-landing"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section no-padding-top contact-page-hero"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-contact-data"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('h2', {
    staticClass: "color-1-100"
  }, [_vm._v("\n                  Address\n                ")]), _vm._v(" "), (!_vm.pageEditMode) ? _c('p', {
    staticClass: "contact-info color-2-77",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.nl2br(_vm.content.contactsSection.address))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactsSection.address),
      expression: "content.contactsSection.address"
    }],
    staticClass: "contact-info color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Address",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactsSection.address)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactsSection, "address", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('p', {
    staticClass: "contact-info-additional color-2-77",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.nl2br(_vm.content.contactsSection.addressInfo))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactsSection.addressInfo),
      expression: "content.contactsSection.addressInfo"
    }],
    staticClass: "contact-info-additional color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Address info",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactsSection.addressInfo)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactsSection, "addressInfo", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contacts"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('h2', {
    staticClass: "color-1-100"
  }, [_vm._v("\n                    Email\n                  ")]), _vm._v(" "), (!_vm.pageEditMode) ? _c('a', {
    staticClass: "contact-info color-2-77",
    attrs: {
      "href": 'mailto:' + _vm.content.contactsSection.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.content.contactsSection.email))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactsSection.email),
      expression: "content.contactsSection.email"
    }],
    staticClass: "contact-info color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Email",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactsSection.email)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactsSection, "email", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_c('h2', {
    staticClass: "color-1-100"
  }, [_vm._v("\n                    Telephone\n                  ")]), _vm._v(" "), (!_vm.pageEditMode) ? _c('a', {
    staticClass: "contact-info color-2-77",
    attrs: {
      "href": 'tel:' + _vm.content.contactsSection.phone,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.content.contactsSection.phone))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactsSection.phone),
      expression: "content.contactsSection.phone"
    }],
    staticClass: "contact-info color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Telephone",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactsSection.phone)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactsSection, "phone", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "landing-page-contact-data-scroll",
    attrs: {
      "href": "#contact-form"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToSection('contact-form')
      }
    }
  }, [_vm._v("\n                Or, send us your message and we'll get in touch with you.\n                "), _c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-wrapper contact-summary landing-page-wrapper-gray",
    attrs: {
      "id": "contact-form"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-summary"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "landing-page-summary__title background-1-10-before color-1-100"
  }, [_vm._v("\n              " + _vm._s(_vm.content.formSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.formSection.title),
      expression: "content.formSection.title"
    }],
    staticClass: "landing-page-summary__title color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.formSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.formSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.formSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-contact-form"
  }, [_c('form', {
    staticClass: "tcc-form",
    attrs: {
      "aria-describedby": "formInfo"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitContactForm()
      }
    }
  }, [_c('div', {
    staticClass: "flex-section"
  }, [_c('div', [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name.text),
      expression: "formData.name.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.name.text !== '' || _vm.formData.name.focus,
      'not-empty': _vm.formData.name.text !== '' || _vm.formData.name.focus,
      'has-error': this.errors.has('First name')
    }],
    attrs: {
      "id": "name",
      "placeholder": "Type in here...",
      "name": "First name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.name.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.name.focus = true
      },
      "blur": function($event) {
        _vm.formData.name.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.name, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.surname.text),
      expression: "formData.surname.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.surname.text !== '' || _vm.formData.surname.focus,
      'not-empty': _vm.formData.surname.text !== '' || _vm.formData.surname.focus,
      'has-error': this.errors.has('Last name')
    }],
    attrs: {
      "id": "surname",
      "placeholder": "Type in here...",
      "name": "Last name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.surname.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.surname.focus = true
      },
      "blur": function($event) {
        _vm.formData.surname.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.surname, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "job-title"
    }
  }, [_vm._v("Job title*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.jobTitle.text),
      expression: "formData.jobTitle.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.jobTitle.text !== '' || _vm.formData.jobTitle.focus,
      'not-empty': _vm.formData.jobTitle.text !== '' || _vm.formData.jobTitle.focus,
      'has-error': this.errors.has('Job title')
    }],
    attrs: {
      "id": "job-title",
      "placeholder": "Type in here...",
      "name": "Job title",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.jobTitle.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.jobTitle.focus = true
      },
      "blur": function($event) {
        _vm.formData.jobTitle.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.jobTitle, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Job title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Job title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email.text),
      expression: "formData.email.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.email.text !== '' || _vm.formData.email.focus,
      'not-empty': _vm.formData.email.text !== '' || _vm.formData.email.focus,
      'has-error': this.errors.has('Email address')
    }],
    attrs: {
      "id": "email",
      "placeholder": "Type in here...",
      "name": "Email address",
      "type": "email"
    },
    domProps: {
      "value": (_vm.formData.email.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.email.focus = true
      },
      "blur": function($event) {
        _vm.formData.email.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.email, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Telephone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.phone.text),
      expression: "formData.phone.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.phone.text !== '' || _vm.formData.phone.focus,
      'not-empty': _vm.formData.phone.text !== '' || _vm.formData.phone.focus
    }],
    attrs: {
      "id": "phone",
      "placeholder": "Type in here...",
      "name": "Telephone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.phone.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.phone.focus = true
      },
      "blur": function($event) {
        _vm.formData.phone.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.phone, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Telephone')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Telephone')))]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.company.text),
      expression: "formData.company.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.company.text !== '' || _vm.formData.company.focus,
      'not-empty': _vm.formData.company.text !== '' || _vm.formData.company.focus,
      'has-error': this.errors.has('Company name')
    }],
    attrs: {
      "id": "company",
      "placeholder": "Type in here...",
      "name": "Company name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.company.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.company.focus = true
      },
      "blur": function($event) {
        _vm.formData.company.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.company, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "industry"
    }
  }, [_vm._v("Industry")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.industry.text),
      expression: "formData.industry.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.industry.text !== '' || _vm.formData.industry.focus,
      'not-empty': _vm.formData.industry.text !== '' || _vm.formData.industry.focus,
      'has-error': this.errors.has('Industry')
    }],
    attrs: {
      "id": "industry",
      "placeholder": "Type in here...",
      "name": "Industry",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.industry.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.industry.focus = true
      },
      "blur": function($event) {
        _vm.formData.industry.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.industry, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Industry')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "employees"
    }
  }, [_vm._v("Approximate number of employees")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.employees.text),
      expression: "formData.employees.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.formData.employees.text !== '' || _vm.formData.employees.focus,
      'not-empty': _vm.formData.employees.text !== '' || _vm.formData.employees.focus,
      'has-error': this.errors.has('Approximate number of employees')
    }],
    attrs: {
      "id": "employees",
      "name": "Approximate number of employees",
      "placeholder": "Type in here...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.employees.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.employees.focus = true
      },
      "blur": function($event) {
        _vm.formData.employees.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.employees, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Approximate number of employees')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Approximate number of employees')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Your message*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.message.text),
      expression: "formData.message.text"
    }],
    staticClass: "tcc-form-element tcc-form-element__textarea light",
    class: [{
      'border-1-50': _vm.formData.message.text !== '' || _vm.formData.message.focus,
      'not-empty': _vm.formData.message.text !== '' || _vm.formData.message.focus,
      'has-error': this.errors.has('Your message')
    }],
    attrs: {
      "id": "message",
      "placeholder": "Type in here...",
      "name": "Your message"
    },
    domProps: {
      "value": (_vm.formData.message.text)
    },
    on: {
      "focus": function($event) {
        _vm.formData.message.focus = true
      },
      "blur": function($event) {
        _vm.formData.message.focus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.message, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Your message')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Your message')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-contact-form__subscribe"
  }, [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.subscribe),
      expression: "formData.subscribe"
    }],
    staticClass: "tcc-form-element tcc-form-element__checkbox",
    attrs: {
      "type": "checkbox",
      "aria-hidden": "true",
      "tabindex": "-1",
      "id": "subscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.subscribe) ? _vm._i(_vm.formData.subscribe, null) > -1 : (_vm.formData.subscribe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formData.subscribe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formData, "subscribe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formData, "subscribe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formData, "subscribe", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "subscribe",
      "tabindex": "0"
    }
  }, [_vm._v("Subscribe me to the Clear Assured newsletter")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("We value your privacy.")]), _vm._v(" We will only send you inclusion insights and best practice advice accompanied by news about our services and events. We will never sell or use the information you entrusted us with for any purpose other than staying in touch and keeping you informed. Read more about our commitment to privacy in our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("privacy policy")]), _vm._v(".\n                    ")], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                    Submitting\n                  ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                        " + _vm._s(_vm.formStatus.title) + "\n                      ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.formStatus.body) + "\n                      ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                        Some fields are missing.\n                      ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])])])])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-page-contact-form__info"
  }, [_c('p', {
    attrs: {
      "id": "formInfo"
    }
  }, [_vm._v("Fields marked with an asterisk ("), _c('span', [_vm._v("*")]), _vm._v(") are mandatory.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Submit message\n                  ")])])
}]}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tour) ? _c('tour-wizard', {
    attrs: {
      "tour": _vm.tour
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-profile-page"
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [(_vm.canEditDetails) ? [_vm._v("\n        Edit account settings\n      ")] : [_vm._v("\n        Account settings\n      ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyDetails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25",
      "height": "19.667",
      "viewBox": "0 0 25 19.667"
    }
  }, [_c('path', {
    attrs: {
      "id": "organisation-details",
      "d": "M-12186.666-8295.333h-18.667A2.669,2.669,0,0,1-12208-8298v-13.333a2.669,2.669,0,0,1,2.666-2.667h18.667a2.67,2.67,0,0,1,2.667,2.667V-8298A2.67,2.67,0,0,1-12186.666-8295.333Zm-13.6-6.667a1,1,0,0,1,1,1v1.666h2.333a.667.667,0,0,0,.667-.666v-9a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v9a.667.667,0,0,0,.667.666h2.333V-8301A1,1,0,0,1-12200.268-8302Zm7.6-1.334a.668.668,0,0,0-.666.667.667.667,0,0,0,.666.667h5.333a.667.667,0,0,0,.667-.667.668.668,0,0,0-.667-.667Zm0-2.666a.667.667,0,0,0-.666.667.667.667,0,0,0,.666.666h5.333a.667.667,0,0,0,.667-.666.667.667,0,0,0-.667-.667Zm0-2.667a.667.667,0,0,0-.666.667.667.667,0,0,0,.666.667h5.333a.667.667,0,0,0,.667-.667.667.667,0,0,0-.667-.667Zm-5.935,5.333h-.667a.333.333,0,0,1-.333-.333v-.667a.334.334,0,0,1,.333-.333h.667a.33.33,0,0,1,.333.333v.667A.334.334,0,0,1-12198.6-8303.334Zm-2.667,0h-.667a.334.334,0,0,1-.333-.333v-.667a.335.335,0,0,1,.333-.333h.667a.33.33,0,0,1,.333.333v.667A.333.333,0,0,1-12201.268-8303.334Zm2.667-2h-.667a.334.334,0,0,1-.333-.334v-.666a.334.334,0,0,1,.333-.334h.667a.331.331,0,0,1,.333.334v.666A.335.335,0,0,1-12198.6-8305.333Zm-2.667,0h-.667a.335.335,0,0,1-.333-.334v-.666a.335.335,0,0,1,.333-.334h.667a.331.331,0,0,1,.333.334v.666A.334.334,0,0,1-12201.268-8305.333Zm2.667-2.021h-.667a.328.328,0,0,1-.333-.313v-.666a.334.334,0,0,1,.333-.334h.667a.335.335,0,0,1,.333.334v.666A.316.316,0,0,1-12198.6-8307.354Zm-2.667,0h-.667a.329.329,0,0,1-.333-.313v-.666a.335.335,0,0,1,.333-.334h.667a.334.334,0,0,1,.333.334v.666A.316.316,0,0,1-12201.268-8307.354Z",
      "transform": "translate(12208.499 8314.5)",
      "fill": "currentColor",
      "stroke": "rgba(0,0,0,0)",
      "stroke-width": "1"
    }
  })])]), _vm._v(" "), (_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyOwner'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 10 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 10 20",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "cx": "5",
      "cy": "3",
      "r": "3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_3_",
      "d": "M5,6c-2.757,0-5,2.243-5,5v3c0,0.552,0.448,1,1,1h1v4c0,0.552,0.448,1,1,1h4\n                      c0.552,0,1-0.448,1-1v-4h1c0.552,0,1-0.448,1-1v-3C10,8.243,7.757,6,5,6z"
    }
  })])])]), _vm._v(" "), (_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'tasksSettings'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('tasksSettings')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "26.411",
      "height": "19.751",
      "viewBox": "0 0 26.411 19.751"
    }
  }, [_c('path', {
    attrs: {
      "id": "task_settings",
      "data-name": "task settings",
      "d": "M-12206.906-8295.249a1.171,1.171,0,0,1-1.094-1.158,1.109,1.109,0,0,1,1.094-1.094h13.53a1.127,1.127,0,0,1,1.127,1.124,1.128,1.128,0,0,1-1.127,1.128Zm14.746-5.626h0Zm-12.5,0a1.125,1.125,0,0,1-1.094-1.127,1.126,1.126,0,0,1,1.094-1.125h10.258a9.02,9.02,0,0,0,2.239,2.252Zm15.156-1.253a.378.378,0,0,1-.294-.373v-1.263a4.446,4.446,0,0,1-1.422-.818l-1.094.632a.378.378,0,0,1-.2.052c-.512,0-1.5-1.991-1.5-2.319a.386.386,0,0,1,.192-.331l1.091-.631a4.539,4.539,0,0,1-.076-.821,4.588,4.588,0,0,1,.076-.821l-1.091-.631a.382.382,0,0,1-.192-.328c0-.4,1.035-2.322,1.5-2.322a.408.408,0,0,1,.2.052l1.094.632a4.558,4.558,0,0,1,1.422-.818v-1.263a.379.379,0,0,1,.294-.37,5.771,5.771,0,0,1,1.207-.129,5.75,5.75,0,0,1,1.2.129.376.376,0,0,1,.295.37v1.263a4.542,4.542,0,0,1,1.421.818l1.1-.632a.389.389,0,0,1,.192-.052c.512,0,1.5,1.991,1.5,2.322a.39.39,0,0,1-.192.331l-1.091.631a4.692,4.692,0,0,1,.076.818,4.725,4.725,0,0,1-.076.821l1.091.631a.386.386,0,0,1,.192.331c0,.4-1.035,2.319-1.5,2.319a.36.36,0,0,1-.192-.052l-1.1-.632a4.494,4.494,0,0,1-1.421.821v1.263a.4.4,0,0,1-.316.37,5.906,5.906,0,0,1-1.2.129A5.932,5.932,0,0,1-12189.5-8302.128Zm-.668-5.873a1.875,1.875,0,0,0,1.875,1.875,1.878,1.878,0,0,0,1.876-1.875,1.879,1.879,0,0,0-1.876-1.875A1.877,1.877,0,0,0-12190.169-8308Zm-5.661,1.5h-11.076a1.17,1.17,0,0,1-1.094-1.158,1.109,1.109,0,0,1,1.094-1.094h10.92c-.007.178-.013.337-.013.5a9.039,9.039,0,0,0,.172,1.752Z",
      "transform": "translate(12208.5 8314.5)",
      "fill": "currentColor",
      "stroke": "rgba(0,0,0,0)",
      "stroke-width": "1"
    }
  })])]), _vm._v(" "), (_vm.canEditTasksSettings === false) ? [_vm._v("Task settings")] : [_vm._v("Edit task settings")]], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "companyDetails",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyDetails' || _vm.canEditDetails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2), _vm._v(" "), (_vm.canEditDetails === false && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-name"
    }
  }, [_vm._v("Organisation name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.name),
      expression: "company.details.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails,
      'not-empty': _vm.company.details.name !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-name",
      "name": "Company name"
    },
    domProps: {
      "value": (_vm.company.details.name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-size"
    }
  }, [_vm._v("Organisation size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.companySize),
      expression: "company.details.companySize"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Organisation size'),
      'is-blocked': _vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": true,
      "data-lpignore": "true",
      "id": "company-size",
      "name": "Organisation size"
    },
    domProps: {
      "value": (_vm.company.details.companySize)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "companySize", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Organisation size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation size')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "industry-sector"
    }
  }, [_vm._v("Industry sector")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Industry sector'),
      'is-locked': !_vm.canEditDetails,
      'not-empty': _vm.company.details.industrySector !== null
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": true,
      "clearable": false,
      "options": _vm.userIndustrySectors,
      "data-lpignore": "true",
      "name": "Industry sector",
      "id": "industry-sector"
    },
    model: {
      value: (_vm.company.details.industrySector),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "industrySector", $$v)
      },
      expression: "company.details.industrySector"
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Industry sector')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry sector')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.company.details.marketplace) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "marketplace"
    }
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.marketplace),
      expression: "company.details.marketplace"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Marketplace'),
      'is-blocked': _vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": true,
      "data-lpignore": "true",
      "id": "marketplace",
      "name": "Marketplace"
    },
    domProps: {
      "value": (_vm.company.details.marketplace)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "marketplace", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Marketplace')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Marketplace')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "companyOwner",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyOwner' || _vm.canEditOwner
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2), _vm._v(" "), (_vm.canEditOwner === false && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditOwner()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.firstName),
      expression: "company.ownerData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.company.ownerData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.phoneNumber),
      expression: "company.ownerData.phoneNumber"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.phoneNumber !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.company.ownerData.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.lastName),
      expression: "company.ownerData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.company.ownerData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.email),
      expression: "company.ownerData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.email !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.company.ownerData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditOwner && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditOwner()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyOwner()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "tasksSettings",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'tasksSettings' || _vm.canEditTasksSettings
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTasksSettings === false) ? [_vm._v("Task settings")] : [_vm._v("Edit tasks settings")]], 2), _vm._v(" "), (_vm.canEditTasksSettings === false && _vm.getUserRole === 'ca') ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTasksSettings()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-contraption"
    }
  }, [_vm._v("Company contraption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.tasksSettings.contraption),
      expression: "company.tasksSettings.contraption"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company contraption'),
      'is-locked': !_vm.canEditTasksSettings,
      'not-empty': _vm.company.tasksSettings.contraption !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTasksSettings === false,
      "data-lpignore": "true",
      "id": "company-contraption",
      "name": "Company contraption"
    },
    domProps: {
      "value": (_vm.company.tasksSettings.contraption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.tasksSettings, "contraption", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-default-assignee"
    }
  }, [_vm._v("Default assignee")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Default assignee'),
      'is-locked': !_vm.canEditTasksSettings,
      'not-empty': _vm.company.tasksSettings.defaultAssignee !== null
    }],
    attrs: {
      "disabled": _vm.canEditTasksSettings === false,
      "searchable": true,
      "options": _vm.defaultAssigneeForSelect,
      "data-vv-name": "Default assignee",
      "data-lpignore": "true",
      "name": "Default assignee",
      "id": "company-default-assignee"
    },
    model: {
      value: (_vm.company.tasksSettings.defaultAssignee),
      callback: function($$v) {
        _vm.$set(_vm.company.tasksSettings, "defaultAssignee", $$v)
      },
      expression: "company.tasksSettings.defaultAssignee"
    }
  }), _vm._v(" "), (this.errors.has('Default assignee')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Default assignee')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTasksSettings) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTasksSettings()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyTasksSettings()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "security-configuration"
  }, [_c('h1', [_vm._v("Security Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "table actions-table"
  }, [_c('div', {
    staticClass: "table-heading"
  }, [_c('div', {
    staticClass: "table-cell actions-heading__cell"
  }, [_vm._v("Actions:")]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
    return _c('div', {
      staticClass: "table-cell actions-heading__cell"
    }, [_vm._v(_vm._s(role.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "table-body"
  }, _vm._l((_vm.actions), function(action) {
    return _c('div', {
      staticClass: "table-row"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(action.actionName))]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
      return _c('div', {
        staticClass: "table-cell"
      }, [_c('label', [_c('input', {
        staticClass: "table-checkbox",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.checkIdLength(action.actionId, role.id)
        },
        on: {
          "change": function($event) {
            return _vm.select(action.actionId, action.actionName, role.id)
          }
        }
      }), _vm._v("\n      \t\t\t\tDisable\n      \t\t\t")])])
    })], 2)
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-device-filters"
  }, [(_vm.anyFilters) ? _c('div', {
    staticClass: "tasks-device-filters-reset-area"
  }, [_c('button', {
    staticClass: "tasks-device-filters-reset-all",
    on: {
      "click": _vm.clearAllFilters
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-filter fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "filter",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17\n              10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Reset filters")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-container",
    class: {
      'search-container': _vm.onlySearch
    }
  }, [_c('div', [(_vm.onlySearch) ? [_c('div', {
    staticClass: "tasks-device-filters-search",
    class: {
      'not-empty': _vm.titleSearchFilter[_vm.list] !== '', focused: _vm.titleSearchFilterFocused
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-search-input"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-search fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "search",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0\n                208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9\n                0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128\n                0 70.7-57.2 128-128 128z"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "id": 'titleSearchFilter-' + _vm.list,
      "type": "search",
      "aria-label": "Search task by ID or keyword",
      "placeholder": "Search task"
    },
    domProps: {
      "value": _vm.titleSearchFilter[_vm.list]
    },
    on: {
      "input": function($event) {
        return _vm.titleSearchInput($event)
      },
      "focus": function($event) {
        _vm.titleSearchFilterFocused = true
      },
      "blur": function($event) {
        _vm.titleSearchFilterFocused = false
      }
    }
  }), _vm._v(" "), (_vm.titleSearchFilter[_vm.list] !== '') ? _c('button', {
    staticClass: "tasks-device-filters-search-input-clear",
    on: {
      "click": function($event) {
        return _vm.clearFilter('title')
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                  0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                  12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                  0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.titleSearchFilter[_vm.list] !== ''),
      expression: "titleSearchFilter[list] !== ''"
    }],
    staticClass: "tasks-device-filters-search-results"
  }, [((_vm.list === 'backlog' && _vm.backlogTasks.length) || (_vm.list === 'focus' && _vm.focusTasks.length)) ? _vm._l(((_vm.list === 'backlog' ? _vm.backlogTasks : _vm.focusTasks)), function(task) {
    return _c('div', {
      staticClass: "tasks-device-filters-search-result",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToTask(task.id)
        }
      }
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(task.title, _vm.titleSearchFilter[_vm.list]))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tasks-device-filters-search-result-meta"
    }, [_c('div', [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-key",
      class: {
        'line-through': task.status === 4
      },
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(task.key, _vm.titleSearchFilter[_vm.list]))
      }
    }), _vm._v(" "), (task.chapter && _vm.getChapterById(task.chapter)) ? _c('div', {
      staticClass: "tasks-device-filters-search-result-meta-chapter"
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-chapter-progress"
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-chapter-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user-info"
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user status",
      class: ['status-' + task.status]
    }, [(task.status === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (task.status === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (task.status === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (task.status === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user priority",
      class: ['priority-' + _vm.taskPriorityDelta(task.score)]
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-up fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-up",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6\n                        0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user user-avatar"
    }, [(_vm.taskAssigneeById(task.assignee)) ? [(_vm.taskAssigneeById(task.assignee).image) ? _c('span', {
      style: ({
        backgroundImage: 'url(\'' + _vm.imageBase + _vm.taskAssigneeById(task.assignee).image + '\')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": _vm.taskAssigneeById(task.assignee).label,
        "size": 24,
        "color": "#ffffff"
      }
    })] : [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                              88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                              55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                              7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])]], 2)])])])])
  }) : _vm._e()], 2)] : [_c('div', {
    staticClass: "tasks-device-filters-chapter tasks-device-filters-area",
    class: {
      active: _vm.activeChapterFilter[_vm.list]
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-trigger",
    on: {
      "click": function($event) {
        return _vm.triggerFilter('chapter')
      }
    }
  }, [_vm._v("\n            Filter by Task category\n            "), (_vm.activeFiltersCount('chapter')) ? [_vm._v("\n              (" + _vm._s(_vm.activeFiltersCount('chapter')) + ")\n            ")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-trigger-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-chapter-items tasks-device-filters-area-items",
    class: {
      empty: !_vm.filterApplied('chapter')
    }
  }, _vm._l((_vm.taskChapters), function(chapter) {
    return _c('div', {
      staticClass: "tasks-device-filters-chapter-item",
      class: {
        active: _vm.isFilterActive('chapter', chapter.id)
      },
      attrs: {
        "role": "button",
        "aria-label": 'Filter by: \'' + chapter.name + '\' chapter'
      }
    }, [_c('div', {
      staticClass: "tasks-device-filters-chapter-item-progress"
    }, [_c('div', {
      staticClass: "tasks-device-filters-chapter-item-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(chapter)
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + chapter.id,
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'chapterFilterInput-' + chapter.id
      },
      domProps: {
        "checked": _vm.isFilterActive('chapter', chapter.id)
      },
      on: {
        "click": function($event) {
          return _vm.filterByChapter(chapter)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "tasks-device-filters-chapter-item-label",
      attrs: {
        "for": 'chapterFilterInput-' + chapter.id
      }
    }, [_vm._v("\n                " + _vm._s(chapter.name) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "tasks-device-filters-area-item-clear",
      on: {
        "click": function($event) {
          return _vm.clearFilterItem('chapter', chapter.id)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), 0), _vm._v(" "), (_vm.activeFiltersCount('chapter')) ? _c('button', {
    staticClass: "tasks-device-filters-reset",
    on: {
      "click": function($event) {
        return _vm.clearFilter('chapter')
      }
    }
  }, [_vm._v("Clear filters")]) : _vm._e()]), _vm._v(" "), (_vm.list === 'backlog') ? _c('div', {
    staticClass: "tasks-device-filters-status tasks-device-filters-area",
    class: {
      active: _vm.activeStatusFilter[_vm.list]
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-trigger",
    on: {
      "click": function($event) {
        return _vm.triggerFilter('status')
      }
    }
  }, [_vm._v("\n            Filter by Status\n            "), (_vm.activeFiltersCount('status')) ? [_vm._v("\n              (" + _vm._s(_vm.activeFiltersCount('status')) + ")\n            ")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-trigger-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-status-items tasks-device-filters-area-items",
    class: {
      empty: !_vm.filterApplied('status')
    }
  }, _vm._l((_vm.taskStatuses), function(status) {
    return _c('div', {
      staticClass: "tasks-device-filters-status-item-container",
      class: [{
        active: _vm.isFilterActive('status', status.id)
      }]
    }, [_c('div', {
      staticClass: "tasks-device-filters-status-item",
      class: [{
        active: _vm.isFilterActive('status', status.id)
      }, 'status-' + status.id]
    }, [(status.id === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                      0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                      168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (status.id === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                      368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                      48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                      48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                      0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                      21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (status.id === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                      55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                      241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                      0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (status.id === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                      256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                      89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                      303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                      16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "status-text"
    }, [_vm._v("\n                  " + _vm._s(status.name) + "\n                ")])], 2), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'statusFilterInput-' + status.id
      },
      domProps: {
        "checked": _vm.isFilterActive('status', status.id)
      },
      on: {
        "click": function($event) {
          return _vm.filterByStatus(status)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'statusFilterInput-' + status.id,
        "aria-label": 'Filter by: \'' + status.name + '\' status'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tasks-device-filters-area-item-clear",
      on: {
        "click": function($event) {
          return _vm.clearFilterItem('status', status.id)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), 0), _vm._v(" "), (_vm.activeFiltersCount('status')) ? _c('button', {
    staticClass: "tasks-device-filters-reset",
    on: {
      "click": function($event) {
        return _vm.clearFilter('status')
      }
    }
  }, [_vm._v("Clear filters")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-assignee tasks-device-filters-area",
    class: {
      active: _vm.activeAssigneeFilter[_vm.list]
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-trigger",
    on: {
      "click": function($event) {
        return _vm.triggerFilter('assignee')
      }
    }
  }, [_vm._v("\n            Filter by Assignee\n            "), (_vm.activeFiltersCount('assignee')) ? [_vm._v("\n              (" + _vm._s(_vm.activeFiltersCount('assignee')) + ")\n            ")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-trigger-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-assignee-items tasks-device-filters-area-items",
    class: {
      empty: !_vm.filterApplied('assignee')
    }
  }, [_vm._l((_vm.taskAssignee), function(user) {
    return _c('div', {
      staticClass: "tasks-device-filters-assignee-item",
      class: {
        active: _vm.isFilterActive('assignee', user.value)
      }
    }, [_c('div', {
      staticClass: "tasks-device-filters-assignee-item-icon"
    }, [(user.image) ? _c('span', {
      style: ({
        backgroundImage: 'url(\'' + _vm.imageBase + user.image + '\')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": user.label,
        "size": 32,
        "color": "#ffffff"
      }
    })], 1), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'assigneeFilterInput-' + user.value
      },
      domProps: {
        "checked": _vm.isFilterActive('assignee', user.value)
      },
      on: {
        "click": function($event) {
          return _vm.filterByAssignee(user)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'assigneeFilterInput-' + user.value
      }
    }, [_vm._v("\n                " + _vm._s(user.label) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "tasks-device-filters-area-item-clear",
      on: {
        "click": function($event) {
          return _vm.clearFilterItem('assignee', user.value)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-assignee-item unassigned",
    class: {
      active: _vm.isFilterActive('assignee', 'unassigned')
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-assignee-item-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 496 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    }
  })])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": 'assigneeFilterInput-unassigned'
    },
    domProps: {
      "checked": _vm.isFilterActive('assignee', 'unassigned')
    },
    on: {
      "click": function($event) {
        return _vm.filterByAssignee(false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'assigneeFilterInput-unassigned'
    }
  }, [_vm._v("\n                Unassigned\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-area-item-clear",
    on: {
      "click": function($event) {
        return _vm.clearFilterItem('assignee', 'unassigned')
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])])])], 2), _vm._v(" "), (_vm.activeFiltersCount('assignee')) ? _c('button', {
    staticClass: "tasks-device-filters-reset",
    on: {
      "click": function($event) {
        return _vm.clearFilter('assignee')
      }
    }
  }, [_vm._v("Clear filters")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-mandatory tasks-device-filters-area",
    class: {
      active: _vm.activeMandatoryFilter[_vm.list]
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-trigger",
    on: {
      "click": function($event) {
        return _vm.triggerFilter('mandatory')
      }
    }
  }, [_vm._v("\n            Filter by Mandatory\n            "), (_vm.activeFiltersCount('mandatory')) ? [_vm._v("\n              (" + _vm._s(_vm.activeFiltersCount('mandatory')) + ")\n            ")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-trigger-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-mandatory-items tasks-device-filters-area-items",
    class: {
      empty: !_vm.filterApplied('mandatory')
    }
  }, _vm._l((_vm.taskMandatory), function(mandatory) {
    return _c('div', {
      staticClass: "tasks-device-filters-mandatory-item-container",
      class: [{
        active: _vm.isFilterActive('mandatory', mandatory.id)
      }]
    }, [_c('div', {
      staticClass: "tasks-device-filters-mandatory-item",
      class: [{
        active: _vm.isFilterActive('mandatory', mandatory.id)
      }, 'mandatory-' + mandatory.id]
    }, [(mandatory.id === 1) ? [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "19.874",
        "height": "16",
        "viewBox": "0 0 19.874 16"
      }
    }, [_c('path', {
      attrs: {
        "id": "mandatory_yes",
        "d": "M8,.5a6.476,6.476,0,0,0,4.706-2.019.753.753,0,0,1,1.063-.025.753.753,0,0,1,.025,1.063A7.983,7.983,0,0,1,8,2,8,8,0,0,1,0-6a8,8,0,0,1,8-8,8,8,0,0,1,7.284,4.691.745.745,0,0,1-.372.991.749.749,0,0,1-.994-.372A6.511,6.511,0,0,0,7.972-12.5,6.517,6.517,0,0,0,1.472-6,6.517,6.517,0,0,0,7.972.5Zm.75-6.278a.731.731,0,0,1-.75.75.731.731,0,0,1-.75-.75v-3.5a.767.767,0,0,1,.75-.75.767.767,0,0,1,.75.75ZM7-3A1.023,1.023,0,0,1,8-4.028,1.023,1.023,0,0,1,9-3,1,1,0,0,1,8-2,1,1,0,0,1,7-3ZM19.619-8.619a.877.877,0,0,1,0,1.237l-4,4a.877.877,0,0,1-1.237,0l-2-2a.877.877,0,0,1,0-1.237.877.877,0,0,1,1.237,0L15-5.238l3.381-3.381A.877.877,0,0,1,19.619-8.619Z",
        "transform": "translate(0 14)",
        "fill": "#272727"
      }
    })])] : (mandatory.id === 0) ? [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "17",
        "height": "16",
        "viewBox": "0 0 17 16"
      }
    }, [_c('g', {
      attrs: {
        "id": "mandatory_no",
        "transform": "translate(15651 15654)"
      }
    }, [_c('path', {
      attrs: {
        "id": "spinner",
        "d": "M8,.5a6.476,6.476,0,0,0,4.706-2.019.753.753,0,0,1,1.063-.025.753.753,0,0,1,.025,1.063A7.983,7.983,0,0,1,8,2,8,8,0,0,1,0-6a8,8,0,0,1,8-8,8,8,0,0,1,7.284,4.691.745.745,0,0,1-.372.991.749.749,0,0,1-.994-.372A6.511,6.511,0,0,0,7.972-12.5,6.517,6.517,0,0,0,1.472-6,6.517,6.517,0,0,0,7.972.5Zm.75-6.278a.731.731,0,0,1-.75.75.731.731,0,0,1-.75-.75v-3.5a.767.767,0,0,1,.75-.75.767.767,0,0,1,.75.75ZM7-3A1.023,1.023,0,0,1,8-4.028,1.023,1.023,0,0,1,9-3,1,1,0,0,1,8-2,1,1,0,0,1,7-3Z",
        "transform": "translate(-15651 -15640)",
        "fill": "#767676"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "id": "spinner-2",
        "data-name": "spinner",
        "d": "M4.853-1.353a.5.5,0,0,1,0,.707A.5.5,0,0,1,4.5-.5a.5.5,0,0,1-.353-.146L2.5-2.292.854-.647A.5.5,0,0,1,.5-.5.5.5,0,0,1,.146-.647a.5.5,0,0,1,0-.707L1.793-3,.146-4.647a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0L2.5-3.706,4.147-5.353a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707L3.207-3,4.853-1.353Z",
        "transform": "translate(-15639 -15642)",
        "fill": "#767676"
      }
    })])])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mandatory-text"
    }, [_vm._v("\n                  " + _vm._s(mandatory.name) + "\n                ")])], 2), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'mandatoryFilterInput-' + mandatory.id
      },
      domProps: {
        "checked": _vm.isFilterActive('mandatory', mandatory.id)
      },
      on: {
        "click": function($event) {
          return _vm.filterByMandatory(mandatory)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'mandatoryFilterInput-' + mandatory.id,
        "aria-label": 'Filter by: \'' + mandatory.name
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tasks-device-filters-area-item-clear",
      on: {
        "click": function($event) {
          return _vm.clearFilterItem('mandatory', mandatory.id)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), 0), _vm._v(" "), (_vm.activeFiltersCount('mandatory')) ? _c('button', {
    staticClass: "tasks-device-filters-reset",
    on: {
      "click": function($event) {
        return _vm.clearFilter('mandatory')
      }
    }
  }, [_vm._v("Clear filters")]) : _vm._e()])]], 2)])])
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [_vm._v("\n      " + _vm._s(this.industry.details.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "profile-actions float-none"
  }, [_c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    class: [{
      'not-allowed': (_vm.industry.details.companies && _vm.industry.details.companies.length) || _vm.industry.details.id === 1
    }],
    attrs: {
      "title": _vm.deleteMessage()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteIndustry()
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": {
        name: 'edit-industry',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Basic data")]), _vm._v(" "), (_vm.landing) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-landing',
        params: {
          id: _vm.landing
        }
      }
    }
  }, [_vm._v("Landing")]) : _vm._e(), _vm._v(" "), (!_vm.landing) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createLanding()
      }
    }
  }, [_vm._v("Create landing")]) : _vm._e(), _vm._v(" "), (_vm.registrationLanding) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-registration-landing',
        params: {
          industry: _vm.registrationLanding,
          company: 'default'
        }
      }
    }
  }, [_vm._v("Registration landing")]) : _vm._e(), _vm._v(" "), (!_vm.registrationLanding) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createRegistrationLanding()
      }
    }
  }, [_vm._v("Create registration landing")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "companies active",
    attrs: {
      "to": {
        name: 'edit-industry-emails',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom emails")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'edit-industry-styling',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom email and website styling")])], 1), _vm._v(" "), _c('div', {
    staticClass: "industry-emails"
  }, [_c('div', {
    staticClass: "industry-emails-container"
  }, [_c('div', {
    staticClass: "industry-emails-menu"
  }, [(_vm.customizedEmails) ? _c('div', [_c('div', {
    staticClass: "section-head"
  }, [_vm._v("\n            Customized emails\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_vm._l((_vm.customizedEmails), function(item) {
    return _c('router-link', {
      key: item.value,
      staticClass: "section-item",
      class: {
        'active': _vm.template === item.value
      },
      attrs: {
        "to": {
          name: 'edit-industry-emails',
          query: {
            template: item.value
          }
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.defaultEmails) ? _c('div', [_c('div', {
    staticClass: "section-head"
  }, [_vm._v("\n            Default emails\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_vm._l((_vm.defaultEmails), function(item) {
    return _c('router-link', {
      key: item.value,
      staticClass: "section-item",
      class: {
        'active': _vm.template === item.value
      },
      attrs: {
        "to": {
          name: 'edit-industry-emails',
          query: {
            template: item.value
          }
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "industry-emails-content"
  }, [_c('div', {
    ref: "templateDetails",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTemplate === false) ? [_vm._v(_vm._s(_vm.templateLabel) + " email")] : [_vm._v("Edit \"" + _vm._s(_vm.templateLabel) + "\" email")]], 2), _vm._v(" "), (_vm.emailTemplate) ? _c('div', {
    staticClass: "content-section-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.emailTemplate.description))]), _vm._v(" "), _c('p', {
    staticClass: "variables-list"
  }, [_vm._v("\n                It supports the following variables:\n              ")]), _vm._v(" "), _c('dl', [_vm._l((_vm.emailTemplate.variables), function(variable, index) {
    return [_c('dt', [_c('code', [_vm._v("[" + _vm._s(variable) + "]")])]), _vm._v(" "), (index !== Object.keys(_vm.emailTemplate.variables).length - 1) ? _c('dt', {
      staticClass: "code-separator"
    }) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.canEditTemplate === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditTemplate()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "templatePreview",
    staticClass: "content-section content-section__bordered border-1-20",
    class: {
      'content-section__no_padding': _vm.canEditTemplate === false
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditTemplate === false),
      expression: "canEditTemplate === false"
    }]
  }, [_c('div', {
    attrs: {
      "id": "emailBody"
    }
  })]), _vm._v(" "), (_vm.canEditTemplate === true) ? _c('article', {
    staticClass: "personal-info"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-subject"
    }
  }, [_vm._v("Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTemplate.email.subject),
      expression: "emailTemplate.email.subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Subject')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTemplate === false,
      "data-lpignore": "true",
      "id": "template-subject",
      "name": "Subject"
    },
    domProps: {
      "value": (_vm.emailTemplate.email.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailTemplate.email, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Subject')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Subject')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTemplate.email.title),
      expression: "emailTemplate.email.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTemplate === false,
      "data-lpignore": "true",
      "id": "template-title",
      "name": "Title"
    },
    domProps: {
      "value": (_vm.emailTemplate.email.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailTemplate.email, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Title')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-body"
    }
  }, [_vm._v("Email body")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "article-editor",
    attrs: {
      "id": "template-body",
      "editorToolbar": _vm.editorToolbar,
      "name": "body"
    },
    model: {
      value: (_vm.emailTemplate.email.body),
      callback: function($$v) {
        _vm.$set(_vm.emailTemplate.email, "body", $$v)
      },
      expression: "emailTemplate.email.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTemplate) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetEmailTemplate()
      }
    }
  }, [_vm._v("Reset to defaults")]), _vm._v(" "), _c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTemplate()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateEmailTemplate()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "testTemplate",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n              Send test email\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "email-address"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testEmail.email),
      expression: "testEmail.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email address')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "email-address",
      "name": "Email address"
    },
    domProps: {
      "value": (_vm.testEmail.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testEmail, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Email address')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendTestEmail()
      }
    }
  }, [_vm._v("Send")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [_c('span', [(_vm.canEditDetails || _vm.canEditPassword) ? [_vm._v("\n              Edit my profile\n            ")] : [_vm._v("\n              My profile\n            ")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "profile-actions"
  }, [_c('button', {
    staticClass: "delete-profile delete-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteMyProfile()
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 14.431 15.232"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 14.431 15.232",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_8_",
      "points": "9.62,1.603 9.62,0 4.81,0 4.81,1.603 0,1.603 0,3.207 14.431,3.207 14.431,1.603 "
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_7_",
      "d": "M1.603,4.008v9.621c0,0.884,0.719,1.603,1.603,1.603h8.017c0.884,0,1.603-0.72,1.603-1.603V4.008\n                  H1.603z M6.414,12.026H4.81v-4.81h1.603V12.026z M9.62,12.026H8.017v-4.81H9.62V12.026z"
    }
  })])]), _vm._v("\n            Delete my account\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 18"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 18",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12\n                      c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8\n                      S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1\n                      C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"
    }
  })])]), _vm._v(" "), (_vm.canEditDetails === false) ? [_vm._v("My account details")] : [_vm._v("Edit my account details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 password",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userPassword'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userPassword')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65\n                      L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"
    }
  })])]), _vm._v(" "), (_vm.canEditPassword === false) ? [_vm._v("My account password")] : [_vm._v("Edit my account password")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 data",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userData'
    }]
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 19.99 21"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 19.99 21",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0\n                      c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226\n                      c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657\n                      c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878\n                      c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995\n                      c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "10",
      "cy": "9.995",
      "r": "3"
    }
  })])])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userData')
      }
    }
  }, [_vm._v("My Data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.needPasswordChange),
      expression: "!needPasswordChange"
    }],
    ref: "userDetails",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'userDetails' || _vm.canEditDetails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("My account details")] : [_vm._v("Edit my account details")]], 2), _vm._v(" "), (_vm.canEditDetails === false) ? _c('button', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element featured-image"
  }, [_c('div', {
    staticClass: "user-featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Profile image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded && _vm.canEditDetails === true),
      expression: "!isThumbnailFileUploaded && canEditDetails === true"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Image",
      "data-vv-as": "\"Image\"",
      "value.sync": "user.personal.image",
      "disabled": _vm.canEditDetails === false
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded && _vm.canEditDetails === false),
      expression: "!isThumbnailFileUploaded && canEditDetails === false"
    }],
    staticClass: "user-featured-image-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0\n                             224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2\n                             288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    }
  })])]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.user.personal.image + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded && _vm.canEditDetails === true) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.first_name),
      expression: "user.personal.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.user.personal.first_name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-surname"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.last_name),
      expression: "user.personal.last_name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-surname",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.user.personal.last_name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.email),
      expression: "user.personal.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.user.personal.email)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.phone),
      expression: "user.personal.phone"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.user.personal.phone)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-role"
    }
  }, [_vm._v("User type (role)")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked is-blocked",
    class: [{
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": "disabled",
      "searchable": true,
      "options": _vm.getRolesForSelect,
      "data-vv-name": "Company role",
      "id": "new-user-company-role"
    },
    on: {
      "keyup": _vm.fieldChange
    },
    model: {
      value: (_vm.user.personal.role),
      callback: function($$v) {
        _vm.$set(_vm.user.personal, "role", $$v)
      },
      expression: "user.personal.role"
    }
  }), _vm._v(" "), (this.errors.has('Company role')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company role')))]) : _vm._e()], 1), _vm._v(" "), (this.isStakeholder === true) ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-stakeholder_type"
    }
  }, [_vm._v("Stakeholder type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.stakeholder_type),
      expression: "user.personal.stakeholder_type"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Stakeholder type'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': (_vm.getUserRole !== 'gm' && _vm.getUserRole !== 'ca') || _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || (_vm.getUserRole !== 'gm' && _vm.getUserRole !== 'ca') || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "data-vv-name": "Stakeholder type",
      "name": "Stakeholder type",
      "id": "new-user-company-stakeholder_type"
    },
    domProps: {
      "value": (_vm.user.personal.stakeholder_type)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "stakeholder_type", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user.personal.role && _vm.user.personal.role.slug !== 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.getUserRole !== 'gm' || _vm.consentStatus === 0
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false || _vm.getUserRole !== 'gm' || _vm.consentStatus === 0,
      "searchable": true,
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Company name",
      "id": "new-user-company-name"
    },
    on: {
      "keyup": _vm.fieldChange
    },
    model: {
      value: (_vm.user.personal.company),
      callback: function($$v) {
        _vm.$set(_vm.user.personal, "company", $$v)
      },
      expression: "user.personal.company"
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.function),
      expression: "user.personal.function"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Function'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': (_vm.getUserRole !== 'gm' && _vm.getUserRole !== 'ca') || _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || (_vm.getUserRole !== 'gm' && _vm.getUserRole !== 'ca') || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-company-function",
      "name": "Function"
    },
    domProps: {
      "value": (_vm.user.personal.function)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "function", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Function')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Function')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-title"
    }
  }, [_vm._v("Job title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.job_title),
      expression: "user.personal.job_title"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Job title'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': (_vm.getUserRole !== 'gm' && _vm.getUserRole !== 'ca') || _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-company-title",
      "name": "Job title"
    },
    domProps: {
      "value": (_vm.user.personal.job_title)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "job_title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Job title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Job title')))]) : _vm._e()])]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-id"
    }
  }, [_vm._v("User id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.id),
      expression: "user.personal.id"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked",
    class: [{
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-user-id"
    },
    domProps: {
      "value": (_vm.user.personal.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "id", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfileDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "userPassword",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__closed': _vm.canEditPassword === false,
      'content-section__bordered border-1-20': _vm.activeSection === 'userPassword' || _vm.canEditPassword
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditPassword === false) ? [_vm._v("My account password")] : [_vm._v("Edit my account password")]], 2), _vm._v(" "), (_vm.canEditPassword === false) ? _c('button', {
    staticClass: "edit-password edit-password-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditPassword()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditPassword),
      expression: "canEditPassword"
    }],
    staticClass: "form-group",
    attrs: {
      "data-vv-scope": "password"
    },
    on: {
      "submit": function($event) {
        return _vm.updateProfilePassword()
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "current-password"
    }
  }, [_vm._v("Current password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.current_password),
      expression: "user.personal.current_password"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "id": "current-password",
      "disabled": _vm.canEditPassword === false,
      "data-lpignore": "true",
      "type": "password",
      "name": "current-password",
      "data-vv-name": "Current password"
    },
    domProps: {
      "value": (_vm.user.personal.current_password)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "current_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('password.current-password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('password.current-password')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-password"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.plainPassword.first),
      expression: "user.personal.plainPassword.first"
    }],
    ref: "passwordInput",
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.passwordError
    }],
    attrs: {
      "id": "new-password",
      "disabled": _vm.canEditPassword === false,
      "data-lpignore": "true",
      "type": "password",
      "name": "new-password",
      "data-vv-name": "New password"
    },
    domProps: {
      "value": (_vm.user.personal.plainPassword.first)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('password.new-password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('password.new-password')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "retype-password"
    }
  }, [_vm._v("Retype new password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:passwordInput'),
      expression: "'required|confirmed:passwordInput'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.plainPassword.second),
      expression: "user.personal.plainPassword.second"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.passwordError
    }],
    attrs: {
      "id": "retype-password",
      "disabled": _vm.canEditPassword === false,
      "data-lpignore": "true",
      "type": "password",
      "name": "retype-new-password",
      "data-vv-as": "password",
      "data-vv-name": "Retype new password"
    },
    domProps: {
      "value": (_vm.user.personal.plainPassword.second)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('password.retype-new-password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('password.retype-new-password')))]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.canEditPassword) ? _c('div', {
    staticClass: "update-data update-data__password"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditPassword()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfilePassword()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.needPasswordChange),
      expression: "!needPasswordChange"
    }],
    ref: "userData",
    staticClass: "content-section consent-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'userData'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("My data")]), _vm._v(" "), _c('div', {
    staticClass: "consent-data",
    class: this.consentStatus === 1 ? 'consent-given' : 'consent-not-given'
  }, [(this.consentStatus === 1) ? [_vm._v("\n                  You provided us with consent to store and process your data under the GDPR settings on " + _vm._s(this.convertDate(this.consentDate, '.')) + ".\n                ")] : [(this.consentDate) ? [_vm._v("\n                    You withdraw your consent to store and use your data under the GDPR settings on " + _vm._s(this.convertDate(this.consentDate, '.')) + ". "), _c('br'), _vm._v("\n                    Please provide consent so you can use all the website functionalities.\n                  ")] : [_vm._v("\n                    You haven’t provided yet us with consent to use your data, under the GDPR settings."), _c('br'), _vm._v("\n                    Please provide your consent so you can use all the website functionalities.\n                  ")]]], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__consent"
  }, [(_vm.consentStatus === 1) ? _c('button', {
    staticClass: "update-consent not-consent consent background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateConsent(0)
      }
    }
  }, [_vm._v("Withdraw your consent")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "privacy-policy",
    class: _vm.consentStatus === 1 ? 'not-consent background-1-100 color-2-100' : 'consent background-1-20 color-2-100',
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("View our privacy policy")]), _vm._v(" "), (_vm.consentStatus === 0) ? _c('button', {
    staticClass: "update-consent consent background-1-100 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateConsent(1)
      }
    }
  }, [_vm._v("Consent now")]) : _vm._e()], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-helper-text color-2-63"
  }, [_vm._v("\n                  The new password can't be the same as the old password."), _c('br'), _vm._v("\n                  Please use a strong password. It must contain at least 9 characters that include capital letters, lower case letters and numbers.\n                ")])
}]}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user-template"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('a', {
    staticClass: "notifications-read-all border-1-20",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markAllNotificationsAsRead()
      }
    }
  }, [_c('span', {
    staticClass: "notifications-read-all-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.163 9.729"
    },
    attrs: {
      "version": "1.1",
      "id": "icons",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.163 9.729",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "points": "10.394,0 4.841,6.109 1.768,3.035 0,4.804 4.927,9.729 12.163,1.77 "
    }
  })])]), _vm._v("\n        Mark all as read")]), _vm._v(" "), _c('div', {
    staticClass: "notifications-list"
  }, _vm._l((_vm.notifications), function(item, index) {
    return _c('div', {
      staticClass: "notifications-group"
    }, [_c('div', {
      staticClass: "item-date",
      class: [{
        'unread': item.unread
      }]
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('div', _vm._l((item.children), function(child) {
      return _c('div', {
        staticClass: "notifications-item",
        class: [{
          'unread': !child.isRead
        }]
      }, [_c('div', {
        staticClass: "item-time"
      }, [_vm._v(_vm._s(child.time))]), _vm._v(" "), _c('div', {
        staticClass: "item-details",
        on: {
          "click": function($event) {
            return _vm.readNotification(child)
          }
        }
      }, [(child.type === 1) ? [(child.contentId && child.companyId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 2 || child.type === 3) ? [(child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'edit-user',
            params: {
              id: child.userFromId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e(), _vm._v(" "), (!child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'consent-logs'
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 4) ? [(child.contentId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'content',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 5) ? [(_vm.getUserRole === 'gm') ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _c('router-link', {
        attrs: {
          "to": {
            name: 'task',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))])] : [_vm._v("\n                  " + _vm._s(child.message) + "\n                ")]], 2)])
    }), 0)])
  }), 0), _vm._v(" "), (_vm.loadedCount < _vm.allCount) ? _c('div', {
    staticClass: "notifications-load-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadMore()
      }
    }
  }, [_vm._v("Load more")])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "todo"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activate-company"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "activate-company__hero"
  }, [(_vm.emailValidCode === 1 || _vm.emailValidCode === 2) ? [_c('h1', {
    staticClass: "page-title"
  }, [(_vm.emailValidCode === 1) ? _c('svg', {
    staticClass: "svg-inline--fa fa-circle-check fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.emailValidCode === 1) ? [_vm._v("\n              Your email was successfully validated.\n            ")] : [_vm._v("\n              Your email was already validated.\n            ")]], 2), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [(_vm.emailValidCode === 1) ? [_vm._v("\n              In 10 seconds you will be redirected to the login page to finish your registration. If you are not redirected please click the link below.\n            ")] : [_vm._v("\n              In 10 seconds you will be redirected to the login page. If you are not redirected please click the link below.\n            ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "activate-company__hero--count-down"
  }, [_vm._v("\n            Redirecting you to login in..."), _c('span', [_vm._v(_vm._s(_vm.redirectCountDown))])]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__hero--actions"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Go to the login page")])], 1)] : (_vm.emailValidCode === 3 || _vm.emailValidCode === 4) ? [_c('h1', {
    staticClass: "page-title"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n            Error 508 - Invalid token."), _c('br'), _vm._v("\n            The activation token you used is invalid.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n            Please insert your email address in the field below to receive an email with a new activation token.\n          ")]), _vm._v(" "), _c('form', {
    staticClass: "activate-company__hero--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resendActivationToken()
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.resendActivationLinkForm.email !== '' || _vm.resendActivationLinkForm.emailFocus,
      'has-error': _vm.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.resendActivationLinkForm.email),
      expression: "resendActivationLinkForm.email"
    }],
    class: [{
      'border-1-20': _vm.resendActivationLinkForm.email !== '' || _vm.resendActivationLinkForm.emailFocus
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.resendActivationLinkForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.resendActivationLinkForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.resendActivationLinkForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resendActivationLinkForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send activation link")])]), _vm._v(" "), (_vm.emailValidCode === 4) ? [_c('div', {
    staticClass: "activate-company__hero--form__error"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("It looks like it didn't work. Please "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("get in touch")]), _vm._v(".")], 1)])] : _vm._e()] : (_vm.emailValidCode === 5) ? [_c('h1', {
    staticClass: "page-title activate-company-email-sent"
  }, [_vm._v("\n            We have sent you a new email.\n          ")]), _vm._v(" "), _vm._m(0)] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions"
  }, [_c('router-link', {
    attrs: {
      "to": "/callback-request"
    }
  }, [_vm._v("Request a callback")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Message us")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description activate-company-email-sent"
  }, [_vm._v("\n            Please "), _c('strong', [_vm._v("follow the instructions from the email to validate your email address")]), _vm._v(" and move forward to the next step."), _c('br'), _vm._v("\n            The link we have just sent you will expire in 24 hours.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__title"
  }, [_c('h2', {
    staticClass: "content"
  }, [_vm._v("Do you need our help?"), _c('br'), _c('strong', [_vm._v("Get in touch")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__text"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v("\n            If there's something you'd like to ask us about Clear Assured, including our COVID-19 Toolkit, or you would like to arrange a demo, please feel free to fill in the form below, drop us an email or give us a call. We look forward to hearing from you.\n          ")])])
}]}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tour-wizard"
  }, [_c('div', {
    staticClass: "tour-wizard__wrapper"
  }, [_c('header', {
    staticClass: "tour-wizard__header"
  }, [_c('router-link', {
    staticClass: "tour-wizard__header--logo",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": " "
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tour-wizard__header--tour-name",
    attrs: {
      "id": "tourName"
    }
  }, [_vm._v(_vm._s(_vm.tour.name))]), _vm._v(" "), _c('button', {
    staticClass: "tour-wizard__header--exit",
    attrs: {
      "aria-label": "Exit tour"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.exit()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })])])], 1), _vm._v(" "), _c('section', {
    staticClass: "tour-wizard__slides--rail",
    attrs: {
      "aria-labelledby": "tourName"
    },
    on: {
      "touchstart": _vm.touchStart
    }
  }, [_c('div', {
    staticClass: "tour-wizard__slides",
    style: ({
      width: _vm.sliderTotalWidth,
      left: _vm.sliderLeftPosition
    })
  }, _vm._l((this.tour.slides), function(slide, index) {
    return _c('div', {
      staticClass: "tour-wizard__slide",
      class: [{
        active: _vm.currentSlide === index + 1
      }],
      style: ({
        maxWidth: _vm.slideMaxWidth
      }),
      attrs: {
        "role": "group",
        "aria-labelledby": "tourPagination"
      }
    }, [_c('div', {
      staticClass: "tour-wizard__slide--media",
      class: ['type-' + (slide.media.type || 'image')]
    }, [(slide.media.type === 'image') ? [_c('img', {
      attrs: {
        "src": slide.media.resource,
        "alt": slide.media.alt || ' '
      }
    })] : _vm._e(), _vm._v(" "), (slide.media.type === 'video') ? [_c('video', {
      attrs: {
        "loop": "",
        "controls": "",
        "title": slide.media.title || ''
      }
    }, _vm._l((slide.media.sources), function(source) {
      return _c('source', {
        attrs: {
          "src": source.src,
          "type": source.type || 'video/mp4'
        }
      })
    }), 0)] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "tour-wizard__slide--text"
    }, [_c('div', {
      staticClass: "tour-wizard__slide--text__wrapper"
    }, [_c('h1', {
      staticClass: "tour-wizard__slide--text__title",
      domProps: {
        "innerHTML": _vm._s(slide.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tour-wizard__slide--text__text",
      domProps: {
        "innerHTML": _vm._s(slide.text)
      }
    }), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "tour-wizard__slide--text__hint"
    }, [_c('div', [_c('svg', {
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "role": "img",
        "id": "swipe",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "width": "31.14",
        "height": "32",
        "viewBox": "0 0 31.14 32"
      }
    }, [_c('defs', [_c('clipPath', {
      attrs: {
        "id": "clip-path"
      }
    }, [_c('rect', {
      attrs: {
        "id": "Rectangle_1482",
        "data-name": "Rectangle 1482",
        "width": "31.14",
        "height": "32",
        "fill": "currentColor"
      }
    })])]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "Group_13162",
        "data-name": "Group 13162",
        "clip-path": "url(#clip-path)"
      }
    }, [_c('path', {
      attrs: {
        "id": "Path_11133",
        "data-name": "Path 11133",
        "d": "M167.585,93.256a3.083,3.083,0,0,0-.359.022,2.937,2.937,0,0,0-1.263.461,2.769,2.769,0,0,0-.105-.262A3,3,0,0,0,164.8,92.24a2.977,2.977,0,0,0-3.262-.037,3.018,3.018,0,0,0-1.358-1.691,2.931,2.931,0,0,0-1.12-.373,3.027,3.027,0,0,0-.359-.022,2.985,2.985,0,0,0-.6.062,2.933,2.933,0,0,0-.854.319V88.378a2.98,2.98,0,0,0-2.982-3.018,2.985,2.985,0,0,0-2.982,2.982v6.549c0,1.162,0,2.37,0,3.527a3.616,3.616,0,0,0-2.971-1.674h-.221l-.213.06a2.985,2.985,0,0,0-2.063,3.674l1.444,5.25c.315,1.146.392,1.34.425,1.424,1.578,3.992,5.588,6.25,11.6,6.529l.037,0h.132a14.8,14.8,0,0,0,4.4-.633,10.84,10.84,0,0,0,3.494-1.8,8.112,8.112,0,0,0,3.22-6.286c0-.034,0-.2,0-1.366s0-3.329,0-7.357a2.986,2.986,0,0,0-2.982-2.982m1.378,11.675c-.075,3.955-3.709,7.148-9.512,7.148h-.1c-4.1-.191-8.563-1.427-10.18-5.518-.077-.195-.327-1.1-.37-1.259l-1.445-5.254a1.384,1.384,0,0,1,.954-1.7,2.009,2.009,0,0,1,1.822,1.38l1.252,4.447c.009.031.02.062.032.093a.76.76,0,0,0,.709.487h0a.757.757,0,0,0,.757-.757c0-.886,0-5.464,0-9.442,0-.731,0-1.442,0-2.106V88.342a1.382,1.382,0,0,1,1.548-1.37,1.4,1.4,0,0,1,1.212,1.406v10.3a.84.84,0,0,0,1.681,0V93.1a1.384,1.384,0,0,1,1.38-1.38,1.411,1.411,0,0,1,.168.01,1.331,1.331,0,0,1,.561.2,1.434,1.434,0,0,1,.65,1.2v6.306a.84.84,0,0,0,1.681,0V94.716a1.38,1.38,0,0,1,2.759,0v5.963a.84.84,0,1,0,1.681,0v-4.4a1.383,1.383,0,0,1,1.379-1.416,1.384,1.384,0,0,1,1.38,1.38s0,8.681,0,8.693",
        "transform": "translate(-139.427 -81.682)",
        "fill": "currentColor"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "id": "Path_11134",
        "data-name": "Path 11134",
        "d": "M2.7,2.748,4.083,1.364A.8.8,0,0,0,4.1.239.791.791,0,0,0,2.979.232L.231,2.979h0Q.206,3,.184,3.031l-.026.034c-.008.011-.017.022-.025.034s-.014.023-.021.035l-.019.031C.087,3.177.081,3.19.076,3.2s-.011.022-.016.034-.009.024-.013.036S.038,3.3.034,3.309s-.006.024-.009.037-.007.025-.009.038,0,.029-.007.043,0,.022,0,.034a.8.8,0,0,0,0,.156c0,.011,0,.022,0,.034s0,.029.007.043.006.026.009.038,0,.022.008.032l0,0c0,.013.009.025.013.037s.008.024.013.036.01.022.016.033.011.025.018.037l.018.031c.007.012.014.024.022.036l.024.032c.007.01.014.02.023.03s.031.035.047.052L.231,4.1,2.964,6.831a.8.8,0,0,0,1.126.021A.791.791,0,0,0,4.1,5.727l-1.4-1.4h7.322a.791.791,0,0,0,0-1.581Z",
        "transform": "translate(0 0)",
        "fill": "currentColor"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "id": "Path_11135",
        "data-name": "Path 11135",
        "d": "M436.562,4.324l-1.383,1.383a.8.8,0,0,0-.021,1.126.791.791,0,0,0,1.125.007l2.748-2.748h0q.025-.025.047-.052c.008-.009.019-.024.026-.034s.017-.022.025-.034.014-.023.021-.035l.019-.031c.006-.012.012-.024.017-.036s.011-.022.016-.034.009-.024.013-.036.009-.024.013-.037.006-.024.009-.037.007-.025.009-.038,0-.029.006-.043,0-.022,0-.034a.8.8,0,0,0,0-.156c0-.011,0-.022,0-.034s0-.029-.006-.043-.006-.026-.009-.038,0-.022-.008-.032l0,0c0-.013-.009-.025-.013-.037s-.008-.024-.013-.036-.01-.022-.016-.033-.011-.025-.018-.037-.012-.02-.018-.031-.014-.024-.022-.036l-.023-.032-.023-.03c-.015-.018-.031-.035-.047-.052l-.005-.006L436.3.241A.8.8,0,0,0,435.171.22a.791.791,0,0,0-.007,1.125l1.4,1.4H429.24a.791.791,0,0,0,0,1.581Z",
        "transform": "translate(-409.987 0)",
        "fill": "currentColor"
      }
    })])]), _vm._v(" "), _c('svg', {
      staticClass: "svg-inline--fa fa-square-arrow-left",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fal",
        "data-icon": "square-arrow-left",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M336 240H150.6l68.69-68.69c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0l-96 96C97.56 247.8 96 251.9 96 256s1.562 8.184 4.688 11.31l96 96c6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62L150.6 272H336c8.844 0 16-7.154 16-15.1C352 247.2 344.8 240 336 240zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM416 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V416z"
      }
    })]), _vm._v(" "), _c('svg', {
      staticClass: "svg-inline--fa fa-square-arrow-right",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fal",
        "data-icon": "square-arrow-right",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M251.3 148.7c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L297.4 240H112C103.2 240 96 247.2 96 255.1C96 264.8 103.2 272 112 272h185.4l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.62s16.38 6.25 22.62 0l96-96C350.4 264.2 352 260.1 352 255.1s-1.562-8.184-4.688-11.31L251.3 148.7zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM416 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V416z"
      }
    })])]), _vm._v(" "), _c('div', [_vm._v("\n                  Navigate this slider by using the arrows on your keyboard or by clicking on the previous and next buttons below. If you are on a mobile device, swipe left/right.\n                ")])]) : _vm._e()])])])
  }), 0)]), _vm._v(" "), _c('footer', {
    staticClass: "tour-wizard__footer"
  }, [_c('div', {
    staticClass: "tour-wizard__pagination"
  }, [_c('div', {
    staticClass: "tour-wizard__pagination--previous"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.canGoToThePrevious,
      "aria-disabled": !_vm.canGoToThePrevious
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.previous()
      }
    }
  }, [_c('span', [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"
    }
  })]), _vm._v("\n              " + _vm._s(_vm.previousButtonText) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tour-wizard__pagination--controls",
    attrs: {
      "id": "tourPagination",
      "aria-live": "polite",
      "aria-labelledby": 'Slide ' + _vm.currentSlide + ' of ' + _vm.totalSlides
    }
  }, [_vm._v("\n          " + _vm._s(_vm.currentSlide) + "/" + _vm._s(_vm.totalSlides) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tour-wizard__pagination--next"
  }, [_c('button', {
    class: [{
      exit: !_vm.canGoToTheNext
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.canGoToTheNext ? _vm.next() : _vm.exit()
      }
    }
  }, [_c('span', [(_vm.canGoToTheNext) ? [_vm._v("\n                " + _vm._s(_vm.nextButtonText) + "\n                "), _c('svg', {
    staticClass: "svg-inline--fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "arrow-right",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })]), _vm._v("\n                Exit tour\n              ")]], 2)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    attrs: {
      "role": "tabpanel",
      "hidden": !_vm.isActive,
      "aria-labelledby": 'tab-' + _vm.aliasSlug,
      "id": 'tab-content-' + _vm.aliasSlug
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-history"
  }, [_c('div', {
    staticClass: "task-history-container"
  }, [_c('div', {
    staticClass: "task-history-header"
  }, [_vm._v("\n      Task history\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-history-body"
  }, [_c('vuescroll', {
    ref: "historyMsg",
    attrs: {
      "ops": _vm.scrollBarOptions
    },
    on: {
      "handle-scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.taskHistory), function(message) {
    return (_vm.taskHistory.length) ? _c('div', {
      staticClass: "task-history-body-row",
      class: [{
        mine: _vm.isMineMessage(message),
        'not-sent': message.notSent
      }, 'message-type-' + message.type]
    }, [_c('div', {
      staticClass: "task-history-body-message"
    }, [_c('div', {
      staticClass: "task-history-body-message-header"
    }, [(message.type === 1) ? _c('span', {
      staticClass: "task-history-body-message-header-icon"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-user fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128\n                        128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0\n                        26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.getUserId === message.userId) ? [_vm._v("You")] : [_vm._v(_vm._s(message.userName))], _vm._v(" "), (message.clearOfficer) ? [_vm._v(" (Clear Assured)")] : _vm._e(), _vm._v(" "), (message.clearBot) ? [_vm._v("Clear Bot")] : _vm._e(), _vm._v("\n              | " + _vm._s(message.date) + "\n              "), (message.notSent) ? _c('span', {
      staticClass: "task-history-body-message-header-not-sent"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "exclamation-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043\n                        8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595\n                        46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373\n                        0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                        0-12.356 5.78-11.981 12.654z"
      }
    })]), _vm._v("\n                Sending failed\n              ")]) : _vm._e(), _vm._v(" "), (message.notSent) ? _c('button', {
      staticClass: "task-history-body-message-header-not-sent-button",
      on: {
        "click": function($event) {
          return _vm.retrySendMessage(message)
        }
      }
    }, [_vm._v("Retry")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "task-history-body-message-content"
    }, [(message.type === 1) ? _c('div', {
      staticClass: "task-history-body-message-text",
      class: {
        'delete-in-progress': _vm.deleteInProgress === message.id
      }
    }, [(message.deleted) ? [_c('i', [_vm._v("Comment deleted by " + _vm._s(message.deletedBy) + " on " + _vm._s(message.deletedOn))])] : _c('div', {
      domProps: {
        "innerHTML": message.text
      }
    }), _vm._v(" "), (message.files && message.files.length) ? _c('div', {
      staticClass: "task-history-body-message-files",
      class: {
        'has-text': message.text && message.text !== ''
      }
    }, [_c('div', {
      staticClass: "task-history-body-message-files-container"
    }, _vm._l((message.files), function(file) {
      return _c('a', {
        staticClass: "task-history-body-message-file",
        attrs: {
          "href": "#",
          "role": "button",
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.downloadFile(file, message.id)
          }
        }
      }, [_vm._v(_vm._s(file.file))])
    }), 0)]) : _vm._e()], 2) : (message.type === 2) ? _c('div', {
      staticClass: "task-history-body-message-text"
    }, [_c('div', {
      staticClass: "task-history-body-message-status"
    }, [_vm._v("\n                  Changed status to\n                  "), (_vm.getStatusById(message.status)) ? _c('span', [_c('span', {
      staticClass: "status-badge",
      class: ['status-' + _vm.getStatusById(message.status)['id']]
    }, [(_vm.getStatusById(message.status)['id'] === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                                  0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                                  168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (_vm.getStatusById(message.status)['id'] === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                                  368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                                  48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                                  48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                                  0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                                  21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (_vm.getStatusById(message.status)['id'] === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                                  55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                                  241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                                  0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (_vm.getStatusById(message.status)['id'] === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                                  256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                                  89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                                  303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                                  16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "status-text"
    }, [_vm._v("\n                          " + _vm._s(_vm.getStatusById(message.status)['name']) + "\n                        ")])], 2)]) : _vm._e()])]) : (message.type === 3) ? _c('div', {
      staticClass: "task-history-body-message-text"
    }, [_c('div', {
      staticClass: "task-history-body-message-assignee"
    }, [_vm._v("\n                  Assigned to\n                  "), _c('span', [_c('span', {
      staticClass: "assignee-badge"
    }, [_c('span', {
      staticClass: "assignee-badge-image"
    }, [(message.assigneeImage || message.assigneeFullName) ? [(message.assigneeImage) ? _c('span', {
      style: ({
        backgroundImage: 'url(' + message.assigneeImage + ')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": message.assigneeFullName,
        "size": 29,
        "color": "#ffffff"
      }
    })] : [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                                  88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                                  55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                                  7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])]], 2), _vm._v(" "), _c('span', {
      staticClass: "assignee-badge-text"
    }, [_vm._v("\n                          " + _vm._s(message.assigneeName) + "\n                        ")])])])])]) : (message.type === 4) ? _c('div', {
      staticClass: "task-history-body-message-text"
    }, [_vm._v("\n                Moved to '" + _vm._s(message.board) + "'\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isMineMessage(message) && message.type === 1 && !message.deleted) ? _c('div', {
      staticClass: "task-history-body-message-actions"
    }, [(!message.notSent && !message.clearBot) ? _c('button', {
      on: {
        "click": function($event) {
          return _vm.deleteMessage(message)
        }
      }
    }, [_vm._v("Delete message")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.taskHistory.length) ? _c('div', {
    staticClass: "task-history-empty"
  }, [_vm._v("\n          Nothing to see here just yet."), _c('br'), _vm._v("\n          As soon as you start registering progress with this task, you will be able to see here the changes, as well as the messages you send or receive.\n        ")]) : _vm._e()], 2)], 1), _vm._v(" "), _c('form', {
    staticClass: "task-history-footer",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.messageSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "task-history-footer-textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageForm.text),
      expression: "messageForm.text"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "First Name",
      "data-vv-as": "Message",
      "rows": "2",
      "placeholder": "Type in your message...",
      "aria-label": "Message"
    },
    domProps: {
      "value": (_vm.messageForm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.messageForm, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "task-history-footer-actions"
  }, [_c('button', {
    staticClass: "task-history-footer-actions-submit",
    class: {
      'not-empty': _vm.messageForm.text !== '' || _vm.messageForm.files.length, 'submitting': _vm.submitting
    },
    attrs: {
      "type": "submit",
      "aria-label": "Submit message"
    }
  }, [(!_vm.submitting) ? _c('svg', {
    staticClass: "svg-inline--fa fa-paper-plane fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "paper-plane",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9\n                        13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515\n                        7.8 493.3-6.8 476 3.2z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.submitting) ? _c('svg', {
    staticClass: "svg-inline--fa fa-spinner-third fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fad",
      "data-icon": "spinner-third",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    staticClass: "fa-group"
  }, [_c('path', {
    staticClass: "fa-secondary",
    attrs: {
      "fill": "currentColor",
      "d": "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z",
      "opacity": "0.4"
    }
  }), _c('path', {
    staticClass: "fa-primary",
    attrs: {
      "fill": "currentColor",
      "d": "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z"
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.messageForm.files.length) ? _c('div', {
    staticClass: "task-history-footer-files"
  }, [_c('div', {
    staticClass: "task-history-footer-files-wrapper"
  }, _vm._l((_vm.messageForm.files), function(file, index) {
    return _c('div', {
      staticClass: "task-history-footer-files-item"
    }, [_vm._v("\n              " + _vm._s(file.name) + "\n              "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeMessageFile(index)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19\n                        0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48\n                        0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24\n                        22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                        0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "task-history-file-button"
  }, [_c('label', {
    attrs: {
      "for": 'uploadResource_' + _vm.taskId
    }
  }, [_c('span', {
    staticClass: "task-history-file-button-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-paperclip fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "paperclip",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332\n                      116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633\n                      30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422\n                      22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236\n                      13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154\n                      0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319\n                      16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "task-history-file-button-text"
  }, [_vm._v("Attach files")]), _vm._v(" "), _c('input', {
    staticClass: "visually-hidden",
    attrs: {
      "type": "file",
      "name": "Files",
      "multiple": "",
      "id": 'uploadResource_' + _vm.taskId
    },
    on: {
      "change": function($event) {
        return _vm.processFiles($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "task-history-file-info"
  }, [_vm._v("\n    Files attached shouldn't be larger than 1 MB."), _c('br'), _vm._v("\n    Accepted formats: " + _vm._s(_vm.taskMessageAllowedFileFormats.join(', ')) + ".\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app login",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper background-1-60",
    staticStyle: {
      "background": "#64ccdc"
    }
  }, [(!_vm.getIsLoggedIn) ? _c('Authorization-header') : _vm._e(), _vm._v(" "), (_vm.getIsLoggedIn) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "center template-404"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-404-label"
  }, [_c('h1', {
    staticClass: "color-2-100"
  }, [_vm._v("This error is usually triggered by mistyping the page URL, but may also appear when a page was moved or the user doesn't have sufficient permissions to see it.")]), _vm._v(" "), (_vm.getIsLoggedIn) ? _c('p', {
    staticClass: "color-2-100"
  }, [_vm._v("Use the search box above or go to the homepage and start browsing our content from there. If you believe you found a bug in our system or you need any help, please email us at "), _c('a', {
    attrs: {
      "href": "mailto:support.team@clearassured.co.uk"
    }
  }, [_vm._v("support.team@clearassured.co.uk")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "go-to-homepage color-2-100 background-1-30",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Go to Homepage")])])])]), _vm._v(" "), _c('div', {
    staticClass: "push"
  })], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-title-404"
  }, [_c('span', {
    staticClass: "group-404"
  }, [_c('span', [_vm._v("4")]), _c('span'), _c('span', [_vm._v("4")])]), _vm._v("Page not found")])
}]}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user"
  }, [(_vm.step < 2) ? _c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Invite new user to Clear Assured")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [(_vm.step < 2) ? _c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")]) : _vm._e(), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? _c('button', {
    staticClass: "add-users background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.inviteNewUsers()
      }
    }
  }, [_vm._v("Invite new users")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "all-users",
    attrs: {
      "to": {
        name: _vm.getUserRole === 'gm' ? 'users' : 'ca-users'
      }
    }
  }, [_vm._v("Back to all users list")])], 1), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [((_vm.inviteType === 1 && _vm.step === 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 0)) ? [_vm._v("\n            Step 1: invite new users\n          ")] : ((_vm.inviteType === 2 && _vm.currentStepImport === 1)) ? [_vm._v("\n            Step 2: Sync csv columns\n          ")] : (_vm.inviteType === 1 && _vm.step === 1) ? [_vm._v("\n            Step 2: complete user profiles\n            "), _c('span', {
    staticClass: "hide-desktop"
  }, [_vm._v("\n              (" + _vm._s(_vm.userInvites.length) + " "), (_vm.userInvites.length === 1) ? [_vm._v("user")] : [_vm._v("users")], _vm._v(")\n            ")], 2)] : (_vm.inviteType === 2 && _vm.currentStepImport === 2) ? [_vm._v("\n            Step 3: complete user profiles\n            "), _c('span', {
    staticClass: "hide-desktop"
  }, [_vm._v("\n              (" + _vm._s(_vm.userInvites.length) + " "), (_vm.userInvites.length === 1) ? [_vm._v("user")] : [_vm._v("users")], _vm._v(")\n            ")], 2)] : [_vm._v("\n            Users status\n          ")]], 2), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 0)) ? _c('p', {
    staticClass: "content-section-description"
  }, [_vm._v("\n          Add the email addresses of the people you want to invite to use Clear Assured in the Email box below,\n          you can add up to 500 users. Select the user role that you want to assign to these users.\n          You can amend the role on the next page if they are not all the same.\n        ")]) : _vm._e(), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 0)) ? _c('div', {
    staticClass: "invite-users-methods"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control form-control__radio"
  }, [_c('input', {
    attrs: {
      "id": "invite-users-by-paste",
      "type": "radio",
      "name": "invite-type"
    },
    domProps: {
      "checked": _vm.inviteType === 1
    },
    on: {
      "change": function($event) {
        return _vm.changeInviteType(1)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "invite-users-by-paste"
    }
  }, [_vm._v("Paste emails")])]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio"
  }, [_c('input', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "invite-users-by-csv",
      "type": "radio",
      "name": "invite-type"
    },
    domProps: {
      "checked": _vm.inviteType === 2
    },
    on: {
      "change": function($event) {
        return _vm.changeInviteType(2)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "invite-users-by-csv"
    }
  }, [_vm._v("Import CSV file")])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 0 && _vm.inviteType === 1) ? [_c('div', {
    staticClass: "form-group-ninth"
  }, [_c('div', {
    staticClass: "form-group form-group-half invite-emails-container"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-emails"
    }
  }, [_vm._v("\n                  Email addresses\n                  "), (_vm.userInvites.length) ? _c('button', {
    staticClass: "invite-emails-clear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearAllEmails()
      }
    }
  }, [_vm._v("Clear all")]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "emailsAddWrapper",
    staticClass: "invite-emails-wrapper",
    class: [{
      'active': _vm.userInvites.length
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.inputEmails.focus()
      }
    }
  }, [_vm._l((_vm.userInvites), function(item, index) {
    return _c('div', {
      staticClass: "invite-emails-item",
      class: [{
        'error': !item.isValid
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeEmail($event, index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.email) + "\n                    "), _c('button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeEmail(index, 0)
        }
      }
    })])
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.input),
      expression: "email.input"
    }],
    ref: "inputEmails",
    staticClass: "invite-emails-input",
    staticStyle: {
      "white-space": "nowrap",
      "overflow": "hidden"
    },
    attrs: {
      "cols": "20",
      "rows": "1",
      "data-lpignore": "true",
      "id": "new-user-emails"
    },
    domProps: {
      "value": (_vm.email.input)
    },
    on: {
      "blur": function($event) {
        return _vm.createTags($event)
      },
      "paste": function($event) {
        _vm.email.isPaste = true
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "input", $event.target.value)
      }, function($event) {
        return _vm.createTags($event, true)
      }],
      "keydown": function($event) {
        return _vm.emailsKeyDown($event)
      }
    }
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-role"
    }
  }, [_vm._v("User type")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getRolesForSelect,
      "data-lpignore": "true",
      "id": "new-user-company-role"
    },
    model: {
      value: (_vm.defaultRole),
      callback: function($$v) {
        _vm.defaultRole = $$v
      },
      expression: "defaultRole"
    }
  })], 1), _vm._v(" "), ((_vm.defaultRole === null || (_vm.defaultRole && _vm.defaultRole.slug !== 'gm')) && _vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": true,
      "options": _vm.getCompaniesForSelect,
      "data-lpignore": "true",
      "id": "new-user-company"
    },
    model: {
      value: (_vm.defaultCompany),
      callback: function($$v) {
        _vm.defaultCompany = $$v
      },
      expression: "defaultCompany"
    }
  })], 1) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.currentStepImport === 0 && _vm.inviteType === 2) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "invite-users-upload-file"
  }, [_c('div', {
    staticClass: "choose-file-wrapper"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "fileInput"
    },
    on: {
      "change": function($event) {
        return _vm.convertFile($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "choose-file"
  }, [_vm._v("choose file")])]), _vm._v(" "), _c('span', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.fileName))]), _vm._v(" "), (_vm.usersImported) ? _c('button', {
    staticClass: "upload-file",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(2)
      }
    }
  }, [_vm._v("upload CSV file")]) : _vm._e()])] : ((_vm.inviteType === 1 && (_vm.step === 1 || _vm.step === 2)) || (_vm.inviteType === 2 && (_vm.currentStepImport === 2 || _vm.currentStepImport === 3))) ? [_c('div', {
    staticClass: "invite-emails-list",
    class: [{
      'server-response': (_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3),
      'is-admin': _vm.getUserRole === 'gm'
    }, 'step-' + _vm.step]
  }, [(_vm.requestInProcess) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.userInvites), function(item, index) {
    return _c('div', {
      staticClass: "form-group",
      class: [{
        'error': (_vm.inviteType === 1 && _vm.step === 2 && _vm.response[item.id].code > 0) || (_vm.inviteType === 2 && _vm.currentStepImport === 3 && _vm.response[item.id].code > 0)
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.id = index),
        expression: "item.id = index"
      }],
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (item.id = index)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "id = index", $event.target.value)
        }
      }
    }), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? _c('div', {
      staticClass: "form-element status"
    }, [_c('span', {
      class: [{
        'error': _vm.response[item.id].code > 0
      }]
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-element email"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-email-' + index
      }
    }, [_vm._v("Email")]), _vm._v(" "), _c('textarea', {
      staticClass: "form-control form-control__textarea",
      class: [{
        'error': !item.isValid,
        'active': item.email
      }],
      attrs: {
        "data-lpignore": "true",
        "data-gramm_editor": "false",
        "id": 'user-invite-email-' + index
      },
      on: {
        "input": function($event) {
          return _vm.changeValid(item, $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.email))])]), _vm._v(" "), _c('div', {
      staticClass: "form-element role"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-type-' + index
      }
    }, [_vm._v("User type")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      class: [{
        'active': item.role,
        'has-error': _vm.userHasError('role', item)
      }],
      attrs: {
        "searchable": false,
        "on-change": _vm.roleChanged(item),
        "options": _vm.getRolesForSelect,
        "data-lpignore": "true",
        "name": "User type",
        "id": 'user-invite-type-' + index
      },
      model: {
        value: (item.role),
        callback: function($$v) {
          _vm.$set(item, "role", $$v)
        },
        expression: "item.role"
      }
    })], 1), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
      staticClass: "form-element company"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-company-' + index
      }
    }, [_vm._v("Company")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      class: [{
        'active': item.company,
        'is-blocked': item.role && item.role.slug === 'gm',
        'has-error': _vm.userHasError('company', item)
      }],
      attrs: {
        "disabled": item.role && item.role.slug === 'gm',
        "searchable": true,
        "options": _vm.getCompaniesForSelect,
        "data-lpignore": "true",
        "id": 'user-invite-company-' + index
      },
      model: {
        value: (item.company),
        callback: function($$v) {
          _vm.$set(item, "company", $$v)
        },
        expression: "item.company"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-element title"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-title-' + index
      }
    }, [_vm._v("Job title")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      class: [{
        'active': item.title,
        'is-blocked': item.role && item.role.slug === 'gm'
      }],
      attrs: {
        "type": "text",
        "disabled": item.role && item.role.slug === 'gm',
        "data-lpignore": "true",
        "id": 'user-invite-title-' + index
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element function"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-title-' + index
      }
    }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.function),
        expression: "item.function"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      class: [{
        'active': item.function,
        'is-blocked': item.role && item.role.slug === 'gm'
      }],
      attrs: {
        "type": "text",
        "disabled": item.role && item.role.slug === 'gm',
        "data-lpignore": "true",
        "id": 'user-invite-function-' + index
      },
      domProps: {
        "value": (item.function)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "function", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element firstname"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-first-name-' + index
      }
    }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.firstName),
        expression: "item.firstName"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'active': item.firstName
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": 'user-invite-first-name-' + index
      },
      domProps: {
        "value": (item.firstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "firstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element lastname"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-last-name-' + index
      }
    }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.lastName),
        expression: "item.lastName"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'active': item.lastName
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": 'user-invite-last-name-' + index
      },
      domProps: {
        "value": (item.lastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "lastName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element phone"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'user-invite-phone-' + index
      }
    }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.phone),
        expression: "item.phone"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'active': item.phone
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": 'user-invite-phone-' + index
      },
      domProps: {
        "value": (item.phone)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "phone", $event.target.value)
        }
      }
    })]), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 1) || (_vm.inviteType === 2 && _vm.currentStepImport === 2)) ? _c('div', {
      staticClass: "form-element remove"
    }, [_c('a', {
      staticClass: "invite-emails-remove",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeEmail(index, 1)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (!item.isValid || (_vm.step === 2 && _vm.response[item.id].code > 0) || (_vm.currentStepImport === 3 && _vm.response[item.id].code > 0) || _vm.userHasError('role', item) || _vm.userHasError('company', item)) ? _c('div', {
      staticClass: "invite-emails-error",
      class: [{
        'step2': (_vm.inviteType === 1 && _vm.step === 2) || _vm.inviteType === 2 && _vm.currentStepImport === 3
      }]
    }, [(!item.isValid || (_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? [((_vm.inviteType === 1 && _vm.step === 2) || (_vm.inviteType === 2 && _vm.currentStepImport === 3)) ? [(_vm.response[item.id].code === 2) ? [_vm._v("\n                      We were unable to send an email to this address. Please make sure you typed it correctly.\n                      If you need assistance, please send us an email at support.team@clearassured.co.uk.\n                    ")] : (_vm.response[item.id].code === 3) ? [_vm._v("\n                      This user was not invited - the email we sent was marked as spam by the receipient server and rejected.\n                      Please make sure you typed it correctly. If you need assistance, please send us an email at support.team@clearassured.co.uk.\n                    ")] : (_vm.response[item.id].code === 4) ? [_vm._v("\n                      We couldn't send an invite - this user is already in our system.\n                    ")] : (_vm.response[item.id].code === 5) ? [_vm._v("\n                      We encountered an error processing your request - we couldn't associate this user with a company.\n                      Please try again and if the problem persists, get in touch with the website developers.\n                    ")] : (_vm.response[item.id].code === 6) ? [_vm._v("\n                      We couldn't invite this user. The domain of the email address you used is not approved for your organization.\n                    ")] : (_vm.response[item.id].code === 7) ? [(_vm.getUserRole === 'ca') ? [_vm._v("\n                        Users limit exceeded - your plan supports up to " + _vm._s(_vm.user.company.employee_limit) + " active users.\n                      ")] : [_vm._v("\n                        Users limit exceeded - " + _vm._s(item.company.label) + " plan supports up to " + _vm._s(item.company.usersLimit) + " active users.\n                      ")]] : [_vm._v("\n                      We encountered an error processing your request. Some mandatory fields are missing or are filled in wrong.\n                      Please try again and if the problem persists, get in touch with the website developers.\n                    ")]] : [_vm._v("\n                    Wrong email format. Please use a valid email address (e.g. name@domain.tld).\n                  ")]] : _vm._e(), _vm._v(" "), (_vm.userHasError('role', item)) ? [_c('p', [_vm._v("User type is mandatory field")])] : _vm._e(), _vm._v(" "), (_vm.userHasError('company', item)) ? [_c('p', [_vm._v("Company is mandatory field")])] : _vm._e()], 2) : _vm._e()])
  }), _vm._v(" "), ((_vm.inviteType === 1 && _vm.step === 2 && _vm.status) || (_vm.inviteType === 2 && _vm.currentStepImport === 3 && _vm.status)) ? _c('div', {
    staticClass: "invite-emails-status"
  }, [(_vm.status.success) ? _c('p', {
    staticClass: "success"
  }, [(_vm.status.success === 1) ? [_vm._v("\n                  1 user was successfully invited. "), _c('span', [_vm._v("Invitation link expires after 30 days.")])] : [_vm._v("\n                  " + _vm._s(_vm.status.success) + " users were successfully invited. "), _c('span', [_vm._v("Invitation link expires after 30 days.")])]], 2) : _vm._e(), _vm._v(" "), (_vm.status.error) ? _c('p', {
    staticClass: "error"
  }, [(_vm.status.error === 1) ? [_vm._v("\n                  1 user was not invited.\n                ")] : [_vm._v("\n                  " + _vm._s(_vm.status.error) + " users were not invited.\n                ")]], 2) : _vm._e()]) : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (_vm.inviteType === 2 && _vm.currentStepImport === 1) ? [_c('div', {
    staticClass: "invite-emails-list from-import"
  }, [_c('div', {
    staticClass: "flex-block"
  }, _vm._l((_vm.csvData), function(col) {
    return _c('div', {
      staticClass: "form-element"
    }, [_c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      class: [{
        'valid': col.column.value !== 'skip'
      }],
      attrs: {
        "searchable": false,
        "options": _vm.columns,
        "placeholder": "Skip this column",
        "data-lpignore": "true"
      },
      model: {
        value: (col.column),
        callback: function($$v) {
          _vm.$set(col, "column", $$v)
        },
        expression: "col.column"
      }
    }), _vm._v(" "), _vm._l((col.items), function(item, i) {
      return _c('div', {
        staticClass: "form-info email",
        attrs: {
          "hidden": _vm.ignoreFirstRow && i === 0
        }
      }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "invite-users-ignore-first"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    staticClass: "form-control form-control__checkbox",
    attrs: {
      "id": "invite-users-ignore-first",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.ignoreFirstRow
    },
    on: {
      "change": function($event) {
        return _vm.changeIgnoreFirst()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "invite-users-ignore-first"
    }
  }, [_vm._v("Don't import first row")])])])])])] : _vm._e()], 2)]), _vm._v(" "), (_vm.step === 1 || _vm.currentStepImport === 2) ? _c('div', {
    staticClass: "invite-emails-info hide-desktop"
  }, [_vm._v("List contains " + _vm._s(_vm.userInvites.length) + "\n      "), (_vm.userInvites.length === 1) ? [_vm._v("\n        user.\n      ")] : [_vm._v("\n        users.\n      ")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.inviteType === 2 && _vm.currentStepImport === 1) ? _c('div', {
    staticClass: "add-new-user-control-panel"
  }, [_c('button', {
    staticClass: "submit-user",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(2)
      }
    }
  }, [_vm._v("\n        Next\n      ")])]) : _vm._e(), _vm._v(" "), ((_vm.inviteType === 1 && (_vm.step === 0 || _vm.step === 1)) || (_vm.inviteType === 2 && _vm.currentStepImport === 2)) ? _c('div', {
    staticClass: "add-new-user-control-panel"
  }, [_c('button', {
    staticClass: "submit-user",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(3)
      }
    }
  }, [(_vm.inviteType === 1) ? [_vm._v("\n          Next\n        ")] : [_vm._v("\n          Send invitations\n        ")]], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-users-upload-info"
  }, [_vm._v("\n            Please "), _c('a', {
    attrs: {
      "href": "/import-users-sample.csv",
      "download": ""
    }
  }, [_vm._v("download our CSV sample")]), _vm._v(", fill in your data and upload it here.\n          ")])
}]}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.email !== '' || _vm.emailFocus,
      'has-error': this.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.email),
      expression: "formInfo.email"
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.formInfo.email)
    },
    on: {
      "focus": function($event) {
        _vm.emailFocus = true
      },
      "blur": function($event) {
        _vm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.resetInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendFormRequest()
      }
    }
  }, [_vm._v("Send me reset link")])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Invalid token\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          Your password reset token is invalid. Please enter your email address and "), _c('br'), _vm._v("\n          you will be sent a new one by email.\n        ")])
}]}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "all-users-page test-class"
  }, [(_vm.downloadInProcess) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-text"
  }, [_vm._v("loading ...")])]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All Resources")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), _c('router-link', {
    staticClass: "to-do active",
    attrs: {
      "to": {
        name: 'articles-list'
      }
    }
  }, [_vm._v("Resources")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(+_vm.statusbar.published + +_vm.statusbar.archived + +_vm.statusbar.draft) + " resources")]), _vm._v(" "), _c('ul', {
    staticClass: "data-list-statuses data-list-statusbar__block"
  }, [_c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.published) + " published")]), _vm._v(" "), _c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.archived) + " archived")]), _vm._v(" "), _c('li', {
    staticClass: "data-list-statuses__item"
  }, [_vm._v(_vm._s(_vm.statusbar.draft) + " draft")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "data-list-add",
    attrs: {
      "to": {
        name: 'add-article'
      },
      "tabindex": "-1"
    }
  }, [_vm._v("Add new Resource")])], 1), _vm._v(" "), (this.articles.length) ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.tableExport(_vm.csvData)
      }
    }
  }, [_vm._v("Export all resources")]) : _vm._e(), _vm._v(" "), (this.articles.length) ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.csvExport()
      }
    }
  }, [_vm._v("Export Task/Resource documents")]) : _vm._e(), _vm._v(" "), (_vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.editedArticles.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "articles-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 1
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByName),
      expression: "searchByName"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Search in TTCs..."
    },
    domProps: {
      "value": (_vm.searchByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "column-type-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getContentTypeForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getContentTypeForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'table-head-select',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getContentTypeForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.contentType),
      callback: function($$v) {
        _vm.contentType = $$v
      },
      expression: "contentType"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-topics-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getTagsForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getTagsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getTagsForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-categories-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 5,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCategoriesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCategoriesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getCategoriesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.categories),
      callback: function($$v) {
        _vm.categories = $$v
      },
      expression: "categories"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-companies-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 7,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 6,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(6)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 6
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 6),
      expression: "filerTableHead.selectedCeil === 6"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-6",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getCompaniesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.companies),
      callback: function($$v) {
        _vm.companies = $$v
      },
      expression: "companies"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-industries-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 8,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 7,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getIndustriesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(7)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getIndustriesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 7
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 7),
      expression: "filerTableHead.selectedCeil === 7"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-7",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getIndustriesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.industries),
      callback: function($$v) {
        _vm.industries = $$v
      },
      expression: "industries"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('edited', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && this.articleOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && !this.articleOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 10,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 9,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(9)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 9
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 9),
      expression: "filerTableHead.selectedCeil === 9"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-9",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: 'hide-selected-items',
    attrs: {
      "placeholder": "Search here ...",
      "options": _vm.getStatusesForSelect,
      "multiple": true
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedArticles), function(article, i) {
    return (i < _vm.offset) ? _c('tr', {
      on: {
        "click": function($event) {
          return _vm.editArticle(article.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-center cellpadding"
    }, [_c('label', {
      attrs: {
        "for": article.id
      }
    }, [_vm._v(_vm._s(article.id))])]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.content_type.type))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.tags.length ? article.tags[0].name : ''))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(article.categories.length ? article.categories[0].title : ''))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._l((article.companies), function(company) {
      return [_vm._v("\n                " + _vm._s(company.name) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._l((article.industries), function(industry) {
      return [_vm._v("\n                " + _vm._s(industry.name) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v(_vm._s(_vm.convertDate(article.updated_at, '.')))]), _vm._v(" "), _c('td', {
      staticClass: "cellpadding text-center"
    }, [_c('span', {
      staticClass: "status",
      class: {
        'status--archived': article.status === 2, 'status--published': article.status === 1, 'status--draft': article.status === 0
      }
    }, [_vm._v(_vm._s(_vm.getStatus(article.status)))])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "fixed",
      "left": "-2000px",
      "bottom": "-2000px"
    },
    attrs: {
      "href": "#",
      "id": "dataDownload"
    }
  }, [_vm._v("download")]), _vm._v(" "), (this.offset <= this.editedArticles.length) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(7), _vm._v("Load more\n          ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text",
    staticStyle: {
      "max-width": "75px"
    }
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Company specific")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text",
    staticStyle: {
      "max-width": "75px"
    }
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Industry specific")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Last Edited")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "tcc-header"
  }, [_c('button', {
    staticClass: "skip-to-content",
    on: {
      "click": _vm.skipToContent
    }
  }, [_vm._v("Skip to content")]), _vm._v(" "), _c('div', {
    staticClass: "tcc-header__inner"
  }, [_c('div', {
    staticClass: "tcc-header__container"
  }, [_c('router-link', {
    staticClass: "tcc-header__logo",
    class: this.customLogo ? 'industry-logo' : '',
    style: ({
      backgroundImage: this.customLogo ? 'url(' + _vm.getFullServerPath(this.customLogo) + ')' : ''
    }),
    attrs: {
      "to": "/",
      "title": "The Clear Company logo"
    }
  }), _vm._v(" "), (!_vm.getDeviceType('mobile') && !_vm.getDeviceType('tablet')) ? _c('ul', {
    staticClass: "tcc-header__menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#features'
      }
    }
  }, [_vm._v("Features")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#our-clients'
      }
    }
  }, [_vm._v("Our clients")])], 1), _vm._v(" "), _c('li', {
    staticClass: "separator"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#pricing'
      }
    }
  }, [_vm._v("Pricing")])], 1), _vm._v(" "), _vm._l((_vm.headerData), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": _vm.routeName(item.url),
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile') || _vm.getDeviceType('tablet')) ? _c('button', {
    staticClass: "tcc-header__menu--trigger",
    attrs: {
      "aria-expanded": _vm.mobileMenuShown,
      "aria-controls": "mobileMenuContainer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.mobileMenuShown = !_vm.mobileMenuShown
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bars",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "bars",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M424 392H23.1C10.8 392 0 402.8 0 415.1C0 429.2 10.8 440 23.1 440H424c13.2 0 24-10.8 24-23.1C448 402.8 437.2 392 424 392zM424 72H23.1C10.8 72 0 82.8 0 95.1S10.8 120 23.1 120H424c13.2 0 24-10.8 24-23.1S437.2 72 424 72zM424 232H23.1C10.8 232 0 242.8 0 256c0 13.2 10.8 24 23.1 24H424C437.2 280 448 269.2 448 256S437.2 232 424 232z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Menu")]), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mobileMenuShown && (_vm.getDeviceType('mobile') || _vm.getDeviceType('tablet'))) ? _c('div', {
    ref: "mobileMenuContainer",
    staticClass: "tcc-header__mobile-menu",
    attrs: {
      "id": "mobileMenuContainer",
      "aria-expanded": _vm.mobileMenuShown
    }
  }, [_c('div', {
    staticClass: "tcc-header__mobile-menu--inner"
  }, [_c('ul', {
    staticClass: "tcc-header__mobile-menu--list"
  }, _vm._l((_vm.headerData), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": _vm.routeName(item.url),
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "focus-tasks"
  }, [_c('div', {
    staticClass: "focus-tasks-drag-icon"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "id": "Artwork",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M32.056,8.496c0-1.637-1.331-2.961-2.961-2.961c-1.357,0-2.498,0.92-2.85,2.166H18.73\n        c-0.261-1.22-1.344-2.139-2.635-2.139c-1.305,0-2.381,0.907-2.635,2.139H5.867C5.573,6.63,4.686,5.789,3.59,5.586\n        c-1.07-0.202-2.166,0.189-2.857,1.018C0.173,7.289-0.056,8.182,0.107,9.063c0.222,1.174,1.161,2.113,2.335,2.335\n        c0.189,0.039,0.385,0.052,0.574,0.052c0.887,0,1.715-0.391,2.283-1.076c0.267-0.326,0.457-0.698,0.567-1.089h7.521v2.74\n        l-0.065,9.288l-0.939-0.718c-1.213-1.057-4.07-2.355-6.36,0.157c-0.254,0.28-0.28,0.691-0.059,0.998\n        c0.065,0.091,1.598,2.237,4.044,4.559c0.32,0.307,0.828,0.287,1.128-0.033c0.307-0.32,0.287-0.828-0.033-1.128\n        c-1.605-1.52-2.818-2.987-3.418-3.764c1.663-1.22,3.444,0.241,3.653,0.424c0.013,0.013,0.026,0.02,0.039,0.033l2.244,1.729\n        c0.241,0.183,0.567,0.222,0.835,0.085c0.274-0.13,0.444-0.411,0.45-0.711l0.072-10.906V8.241c0-0.007,0-0.013,0-0.026\n        c0.02-0.6,0.502-1.063,1.096-1.063c0.607,0,1.096,0.496,1.096,1.096c0,0.033,0,0.065,0.007,0.098l0.854,7.084\n        c0.039,0.352,0.313,0.633,0.659,0.691c0.052,0.007,5.277,0.9,9.014,3.333c0.137,0.907,0.45,3.594-0.17,6.073\n        c-0.111,0.431,0.15,0.861,0.581,0.972c0.065,0.02,0.13,0.026,0.196,0.026c0.359,0,0.685-0.241,0.776-0.607\n        c0.848-3.379,0.17-6.94,0.137-7.09c-0.039-0.202-0.157-0.385-0.333-0.502c-3.32-2.283-7.743-3.34-9.328-3.666l-0.646-5.368h7.325\n        c0.352,1.246,1.494,2.166,2.85,2.166C30.725,11.457,32.056,10.126,32.056,8.496z M4.073,9.363c-0.32,0.385-0.822,0.567-1.324,0.47\n        C2.221,9.735,1.784,9.298,1.686,8.77c-0.078-0.417,0.02-0.828,0.287-1.148c0.261-0.313,0.646-0.496,1.05-0.496\n        c0.091,0,0.183,0.007,0.274,0.026C3.825,7.25,4.262,7.687,4.36,8.215C4.438,8.639,4.334,9.043,4.073,9.363z M29.094,9.859\n        c-0.724,0-1.311-0.567-1.357-1.272c0.007-0.033,0.007-0.059,0.007-0.091s-0.007-0.059-0.007-0.091\n        c0.046-0.711,0.633-1.272,1.357-1.272c0.75,0,1.363,0.613,1.363,1.363C30.458,9.246,29.845,9.859,29.094,9.859z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "focus-tasks-columns"
  }, _vm._l((_vm.focusTasks), function(status) {
    return _c('div', {
      staticClass: "focus-tasks-column",
      class: [{
        disabled: _vm.statusIsDisabled(status)
      }, status.slug],
      attrs: {
        "id": 'statusColumn-' + status.id
      },
      on: {
        "dragover": function($event) {
          return _vm.dragOverHandle(status.id)
        },
        "dragleave": function($event) {
          this.dragOverStatusId = null
        }
      }
    }, [_c('h3', [(status.slug === 'to-do') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : _vm._e(), _vm._v(" "), (status.slug === 'in-progress') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : _vm._e(), _vm._v(" "), (status.slug === 'in-review') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : _vm._e(), _vm._v(" "), (status.slug === 'completed') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v("\n        " + _vm._s(status.name) + "\n        "), _c('span', [(_vm.hasActiveFilters) ? [_vm._v("\n            (" + _vm._s(status.tasks.length) + " of " + _vm._s(status.count) + ")\n          ")] : [_vm._v("\n            (" + _vm._s(status.count) + ")\n          ")]], 2)], 2), _vm._v(" "), (_vm.statusIsDisabled(status) && _vm.dragOverStatusId === status.id) ? _c('div', {
      staticClass: "focus-tasks-drag-disabled-overlay"
    }, [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 49 49"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "focusable": "false",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 49 49",
        "xml:space": "preserve"
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M24.5,0.5c-13.256,0-24,10.744-24,24s10.744,24,24,24s24-10.744,24-24S37.756,0.5,24.5,0.5z M37.092,11.908\n              c6.333,6.333,6.773,16.013,2,22.803L14.287,9.908C21.081,5.132,30.761,5.58,37.092,11.908z M11.908,37.092\n              c-6.333-6.333-6.773-16.013-2-22.803l24.805,24.805C27.919,43.868,18.239,43.42,11.908,37.092z"
      }
    })]), _vm._v(" "), (status.slug === 'completed') ? [_vm._v("This task requires Clear Assured validation before completion. When it's done, move it to 'Submitted for review'.")] : _vm._e(), _vm._v(" "), (status.slug === 'in-review') ? [_vm._v("This is a self assessed task so there is no need to submit it for review. Once it’s done, simply move it to 'Completed'.")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('draggable', _vm._b({
      staticClass: "focus-tasks-group",
      class: {
        hidden: _vm.statusIsDisabled(status) && _vm.dragOverStatusId === status.id
      },
      attrs: {
        "tag": "ul",
        "draggable": ".task",
        "group": "focusTasks"
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": function($event) {
          return _vm.dragEnd()
        },
        "change": function($event) {
          return _vm.handleChange($event, status)
        }
      },
      model: {
        value: (status.tasks),
        callback: function($$v) {
          _vm.$set(status, "tasks", $$v)
        },
        expression: "status.tasks"
      }
    }, 'draggable', _vm.dragOptions(status), false), [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": !_vm.drag ? 'flip-list' : null
      }
    }, _vm._l((status.tasks), function(task) {
      return _c('li', {
        key: task.id,
        staticClass: "focus-tasks-group-item task",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.goToTask(task.id)
          },
          "dragstart": function($event) {
            return _vm.draggingItem(task, true)
          },
          "dragend": function($event) {
            return _vm.draggingItem(task, false)
          }
        }
      }, [_c('div', {
        staticClass: "focus-tasks-group-item-name"
      }, [_vm._v("\n              " + _vm._s(task.title) + "\n            ")]), _vm._v(" "), _c('div', {
        staticClass: "focus-tasks-group-item-meta"
      }, [_c('div', [_c('div', {
        staticClass: "focus-tasks-group-item-meta-key"
      }, [_vm._v("\n                  " + _vm._s(task.key) + "\n                ")]), _vm._v(" "), (task.chapter && _vm.getChapterById(task.chapter)) ? _c('div', {
        staticClass: "focus-tasks-group-item-meta-chapter"
      }, [_c('div', {
        staticClass: "focus-tasks-group-item-meta-chapter-progress"
      }, [_c('div', {
        staticClass: "focus-tasks-group-item-meta-chapter-image",
        style: ({
          backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
        })
      }), _vm._v(" "), _c('svg', {
        staticClass: "progress",
        attrs: {
          "width": "130",
          "height": "130",
          "viewBox": "0 0 100 100"
        }
      }, [_c('circle', {
        staticClass: "progress_meter",
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
        staticClass: "progress_value",
        class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
        staticClass: "focus-tasks-group-item-meta-properties"
      }, [(task.recurrent) ? _c('div', {
        staticClass: "focus-tasks-group-item-meta-property recurrency"
      }, [_c('svg', {
        staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "sync-alt",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                        53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                        94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                        57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                        0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                        162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                        504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
        }
      })])]) : _vm._e(), _vm._v(" "), (task.mandatory) ? _c('div', {
        staticClass: "focus-tasks-group-item-meta-property mandatory"
      }, [_c('svg', {
        staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "exclamation-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                        111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                        136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                        0-12.356 5.78-11.981 12.654z"
        }
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "focus-tasks-group-item-meta-user-info"
      }, [_c('div', {
        staticClass: "focus-tasks-group-item-meta-user user-avatar"
      }, [(_vm.taskAssigneeById(task.assignee)) ? [(_vm.taskAssigneeById(task.assignee).image) ? _c('span', {
        style: ({
          backgroundImage: 'url(\'' + _vm.imageBase + _vm.taskAssigneeById(task.assignee).image + '\')'
        })
      }) : _c('avatar', {
        attrs: {
          "username": _vm.taskAssigneeById(task.assignee).label,
          "size": 32,
          "color": "#ffffff"
        }
      })] : [_c('svg', {
        staticClass: "svg-inline--fa fa-user-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "user-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 496 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                              88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                              55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                              7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
        }
      })])]], 2)])])])])
    }), 0)], 1)], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-server-messages text-center"
  }, [(_vm.messages.success.length) ? _c('ul', {
    staticClass: "form-server-messages-list"
  }, _vm._l((_vm.messages.success), function(message) {
    return _c('li', {
      staticClass: "form-success-messages"
    }, [_vm._v(_vm._s(message))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.messages.errors.length) ? _c('ul', {
    staticClass: "form-server-messages-list"
  }, _vm._l((_vm.messages.errors), function(error) {
    return _c('li', {
      staticClass: "form-errors"
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.tags.length) + " topics")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new topic")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-name"
    }
  }, [_vm._v("Topic name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.name),
      expression: "newTag.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-name"
    },
    domProps: {
      "value": (_vm.newTag.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTag, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-icon"
    }
  }, [_vm._v("Topic icon")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.icon),
      expression: "newTag.icon"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-icon"
    },
    domProps: {
      "value": (_vm.newTag.icon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTag, "icon", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.featured),
      expression: "newTag.featured"
    }],
    staticClass: "form-control form-control__checkbox background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "checkbox",
      "id": "new-featured"
    },
    domProps: {
      "checked": Array.isArray(_vm.newTag.featured) ? _vm._i(_vm.newTag.featured, null) > -1 : (_vm.newTag.featured)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newTag.featured,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newTag, "featured", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newTag, "featured", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newTag, "featured", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-featured"
    }
  }, [_vm._v("Featured")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-category-desc"
    }
  }, [_vm._v("Topic description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.description),
      expression: "newTag.description"
    }],
    staticClass: "form-control form-control__textarea",
    staticStyle: {
      "height": "140px"
    },
    attrs: {
      "name": "category-desc",
      "id": "textarea-category-desc",
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.newTag.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTag, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createTag()
      }
    }
  }, [_vm._v("Create topic")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cellpadding tag-list-body__head_id table-head-ceil id-column"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left tag-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Search in topics..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding tag-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.updatedTags), function(tag) {
    return _c('tr', [(tag.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding text-center"
    }, [_vm._v("\n            " + _vm._s(tag.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (tag.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(tag.name))]) : _vm._e(), _vm._v(" "), (tag.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center action-column"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showEditionForm(tag.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (tag.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center action-column"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeTag(tag.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Remove")])])]) : _vm._e(), _vm._v(" "), (tag.type === 'edit') ? _c('td', {
      staticClass: "edit-row",
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form",
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "row-edit-form",
      staticStyle: {
        "max-width": "unset",
        "margin-bottom": "32px",
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "wrap-title-input",
      staticStyle: {
        "max-width": "140px"
      }
    }, [_c('div', {
      staticClass: "form-element",
      staticStyle: {
        "margin": "0 !important"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.featured),
        expression: "tag.featured"
      }],
      staticClass: "form-control form-control__checkbox background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "checkbox",
        "id": "edit-featured"
      },
      domProps: {
        "checked": Array.isArray(tag.featured) ? _vm._i(tag.featured, null) > -1 : (tag.featured)
      },
      on: {
        "change": function($event) {
          var $$a = tag.featured,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(tag, "featured", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(tag, "featured", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(tag, "featured", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-featured"
      }
    }, [_vm._v("Featured")])])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input",
      staticStyle: {
        "max-width": "unset"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.name),
        expression: "tag.name"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Name"
      },
      domProps: {
        "value": (tag.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tag, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input",
      staticStyle: {
        "max-width": "unset"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.icon),
        expression: "tag.icon"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Icon"
      },
      domProps: {
        "value": (tag.icon)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tag, "icon", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea",
      staticStyle: {
        "max-width": "unset"
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.description),
        expression: "tag.description"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "name": "desc-textarea",
        "cols": "10",
        "rows": "3",
        "placeholder": "Description"
      },
      domProps: {
        "value": (tag.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tag, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel",
      staticStyle: {
        "width": "100%",
        "text-align": "right"
      }
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.discardСhanges(tag.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editTag(tag.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Topics list")])])
}]}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-profile-page"
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content-not-ready-container"
  }, [_c('div', {
    staticClass: "content-not-ready border-1-100"
  })]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Organisation profile")]), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    staticClass: "content-section no-margin-top progress-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', [_c('div', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_c('h3', [_vm._v("Progress chart")]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "content-company-badge",
    attrs: {
      "id": "contentCompanyBadge"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.badgeCopy = true
      }
    }
  }, [_c('iframe', {
    attrs: {
      "title": _vm.user && _vm.user.company ? _vm.user.company.name + ' badge' : 'Company badge',
      "width": "210",
      "height": "85",
      "src": _vm.getBadgeLink() + '?company=' + (_vm.user.company ? _vm.user.company.hash : '') + '&theme=' + (_vm.selectedHightCont === 1 ? 'dark' : 'light')
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-date",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.getCurrentDate()))]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-chart-body",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('div', {
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, [_c('div', {
    staticClass: "content-chart-data",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, [(!_vm.chartData) ? _c('div', {
    staticClass: "content-loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid"
  }, [_c('div', {
    staticClass: "content-chart-grid-line line_10"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_9",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_8",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_7",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_6",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_5",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_4",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_3",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_2",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_1",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  })]), _vm._v(" "), _vm._l((_vm.chartData), function(c, index) {
    return (c) ? _c('div', {
      staticClass: "content-chart-points"
    }, [_vm._l((c.scores), function(p) {
      return _c('div', {
        staticClass: "content-chart-point",
        class: 'chapter__' + c.chapter.id,
        style: ({
          left: p.left + 'px',
          top: p.top + '%',
          borderColor: c.chapter.color
        }),
        attrs: {
          "data-chapter": 'chapter-legend-' + c.chapter.id,
          "data-color": c.chapter.color
        }
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "content-chart-chapters__item",
      class: 'chapter_' + _vm.getChapterIndex(c),
      style: ({
        backgroundColor: c.hover && c.hover.type === 'level' && c.hover.show === true ? c.chapter.color : '',
        color: _vm.selectedHightCont === 1 ? (c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : c.chapter.color) : c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : '',
        borderColor: c.chapter.color
      }),
      attrs: {
        "id": 'chapter-legend-' + c.chapter.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addChapterHover(c, 'level')
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getChapterCustomName(c.chapter)))]), _vm._v(" "), (_vm.hasBenchmark(c)) ? _c('span', {
      staticClass: "show-benchmark tooltip",
      class: [{
        'active': c.hover && c.hover.type === 'benchmark' && c.hover.show === true
      }, 'chapter_' + _vm.getChapterIndex(c)],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addChapterHover(c, 'benchmark')
        }
      }
    }, [_c('span', {
      staticClass: "tooltip-text"
    }, [_vm._v("Show benchmark")])]) : _vm._e(), _vm._v(" "), (c.hover && c.hover.type === 'level' && c.hover.show === true) ? _c('div', {
      staticClass: "chapter-level",
      style: ({
        top: (100 - c.hover.top) + '%',
        height: c.hover.top + '%'
      })
    }) : _vm._e(), _vm._v(" "), (c.hover && c.hover.type === 'benchmark' && c.hover.show === true) ? _c('div', {
      staticClass: "chapter-benchmark",
      style: ({
        top: (100 - c.hover.top) + '%',
        height: c.hover.top + '%'
      })
    }) : _vm._e()], 2) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-x",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, _vm._l((_vm.reverseItems(_vm.quarters)), function(quarter) {
    return _c('div', {
      staticClass: "content-chart-legend-x__item"
    }, [_vm._v("\n                      Q" + _vm._s(quarter.quarter) + " " + _vm._s(quarter.year) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "chart-accessibility-table",
    attrs: {
      "id": "chartAccessibilityTable",
      "tabindex": "-1"
    }
  }, [_c('table', [_c('caption', [_vm._v(_vm._s((_vm.user && _vm.user.company) ? _vm.user.company.name : 'Company') + " progress")]), _vm._v(" "), _c('thead', [_c('tr', [_c('td', [_vm._v("Task category")]), _vm._v(" "), _vm._l((_vm.reverseItems(_vm.quarters)), function(quarter) {
    return _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("Q" + _vm._s(quarter.quarter) + " " + _vm._s(quarter.year))])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Industry benchmark")])], 2)]), _vm._v(" "), _vm._l((_vm.chartData), function(c) {
    return (c) ? _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.getChapterCustomName(c.chapter)) + "\n                      ")]), _vm._v(" "), _vm._l((c.scores), function(p, index) {
      return [_c('td', [_vm._v(_vm._s(p.score))]), _vm._v(" "), (index === (c.scores.length - 1)) ? _c('td', [_vm._v(_vm._s(p.benchmark))]) : _vm._e()]
    })], 2) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "progress-action-links"
  }, [_c('button', {
    staticClass: "background-1-20 background-1-100-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.htmlToCanvas2()
      }
    }
  }, [_c('span', {
    staticClass: "color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M501.333,490.667H10.667C4.779,490.667,0,495.445,0,501.333C0,507.221,4.779,512,10.667,512h490.667\n                      c5.888,0,10.667-4.779,10.667-10.667C512,495.445,507.221,490.667,501.333,490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M96,362.667H32c-5.888,0-10.667,4.779-10.667,10.667v128C21.333,507.221,26.112,512,32,512h64\n                      c5.888,0,10.667-4.779,10.667-10.667v-128C106.667,367.445,101.888,362.667,96,362.667z M85.333,490.667H42.667V384h42.667\n                      V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M224,256h-64c-5.888,0-10.667,4.779-10.667,10.667v234.667c0,5.888,4.779,10.667,10.667,10.667h64\n                      c5.888,0,10.667-4.779,10.667-10.667V266.667C234.667,260.779,229.888,256,224,256z M213.333,490.667h-42.667V277.333h42.667\n                      V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M352,298.667h-64c-5.888,0-10.667,4.779-10.667,10.667v192c0,5.888,4.779,10.667,10.667,10.667h64\n                      c5.888,0,10.667-4.779,10.667-10.667v-192C362.667,303.445,357.888,298.667,352,298.667z M341.333,490.667h-42.667V320h42.667\n                      V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M480,170.667h-64c-5.888,0-10.667,4.779-10.667,10.667v320c0,5.888,4.779,10.667,10.667,10.667h64\n                      c5.888,0,10.667-4.779,10.667-10.667v-320C490.667,175.445,485.888,170.667,480,170.667z M469.333,490.667h-42.667V192h42.667\n                      V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M64,192c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                      c23.531,0,42.667-19.136,42.667-42.667C106.667,211.136,87.531,192,64,192z M64,256c-11.776,0-21.333-9.579-21.333-21.333\n                      c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C85.333,246.421,75.776,256,64,256z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M192,85.333c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667s42.667-19.136,42.667-42.667\n                      C234.667,104.469,215.531,85.333,192,85.333z M192,149.333c-11.776,0-21.333-9.579-21.333-21.333\n                      c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C213.333,139.755,203.776,149.333,192,149.333z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M320,128c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                      c23.531,0,42.667-19.136,42.667-42.667C362.667,147.136,343.531,128,320,128z M320,192c-11.776,0-21.333-9.579-21.333-21.333\n                      c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C341.333,182.421,331.776,192,320,192z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M448,0c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                      c23.531,0,42.667-19.136,42.667-42.667C490.667,19.136,471.531,0,448,0z M448,64c-11.776,0-21.333-9.579-21.333-21.333\n                      c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C469.333,54.421,459.776,64,448,64z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M432.939,57.728c-4.16-4.16-10.923-4.16-15.083,0l-82.773,82.773c-4.16,4.16-4.16,10.923,0,15.083\n                      c2.091,2.069,4.821,3.115,7.552,3.115c2.709,0,5.44-1.024,7.531-3.115l82.773-82.773\n                      C437.099,68.651,437.099,61.888,432.939,57.728z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M294.208,146.048l-68.523-19.541c-5.739-1.664-11.563,1.664-13.163,7.339c-1.621,5.675,1.664,11.563,7.317,13.184\n                      l68.523,19.541c0.981,0.277,1.963,0.405,2.923,0.405c4.651,0,8.917-3.051,10.261-7.744\n                      C303.168,153.579,299.883,147.669,294.208,146.048z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M175.36,141.291c-3.669-4.608-10.368-5.355-14.976-1.707l-80.427,64.128c-4.608,3.691-5.376,10.389-1.685,14.997\n                      c2.112,2.645,5.227,4.011,8.341,4.011c2.325,0,4.672-0.768,6.635-2.304l80.427-64.128\n                      C178.283,152.597,179.051,145.899,175.36,141.291z"
    }
  })])])])]), _vm._v("\n              Download Progress chart\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "background-1-20 background-1-100-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.badgeCopy = true
      }
    }
  }, [_c('span', {
    staticClass: "color-1-100"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "511pt",
      "version": "1.1",
      "viewBox": "-55 0 511 511.9999",
      "width": "511pt"
    }
  }, [_c('g', {
    attrs: {
      "id": "surface1"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M 335.175781 190.992188 C 335.175781 117.195312 275.136719 57.15625 201.339844 57.15625 C 127.539062 57.15625 67.5 117.195312 67.5 190.992188 C 67.5 264.792969 127.539062 324.832031 201.339844 324.832031 C 275.136719 324.832031 335.175781 264.792969 335.175781 190.992188 Z M 201.339844 309.832031 C 135.8125 309.832031 82.5 256.519531 82.5 190.992188 C 82.5 125.46875 135.8125 72.15625 201.339844 72.15625 C 266.867188 72.15625 320.175781 125.46875 320.175781 190.992188 C 320.175781 256.519531 266.867188 309.832031 201.339844 309.832031 Z M 201.339844 309.832031 "
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M 294.546875 161.652344 C 293.132812 157.292969 289.105469 154.367188 284.523438 154.367188 L 228.632812 154.367188 L 211.363281 101.214844 C 209.945312 96.859375 205.917969 93.933594 201.339844 93.933594 C 196.761719 93.933594 192.734375 96.859375 191.316406 101.214844 L 174.046875 154.371094 L 118.15625 154.371094 C 113.574219 154.371094 109.546875 157.296875 108.132812 161.652344 C 106.71875 166.007812 108.257812 170.742188 111.960938 173.433594 L 157.175781 206.285156 L 139.90625 259.4375 C 138.492188 263.792969 140.027344 268.53125 143.734375 271.222656 C 147.4375 273.914062 152.417969 273.914062 156.125 271.222656 L 201.339844 238.371094 L 246.554688 271.222656 C 248.410156 272.570312 250.578125 273.242188 252.75 273.242188 C 254.921875 273.242188 257.09375 272.570312 258.945312 271.222656 C 262.652344 268.53125 264.1875 263.792969 262.773438 259.4375 L 245.5 206.285156 L 290.714844 173.433594 C 294.421875 170.742188 295.960938 166.007812 294.546875 161.652344 Z M 234.0625 196.054688 C 230.359375 198.746094 228.820312 203.480469 230.234375 207.839844 L 244.261719 251.015625 L 207.535156 224.332031 C 205.679688 222.984375 203.511719 222.3125 201.339844 222.3125 C 199.167969 222.3125 196.996094 222.984375 195.144531 224.332031 L 158.417969 251.015625 L 172.445312 207.835938 C 173.859375 203.480469 172.320312 198.746094 168.617188 196.054688 L 131.886719 169.367188 L 177.289062 169.367188 C 181.867188 169.367188 185.894531 166.441406 187.3125 162.085938 L 201.339844 118.90625 L 215.367188 162.085938 C 216.785156 166.441406 220.8125 169.367188 225.390625 169.367188 L 270.792969 169.367188 Z M 234.0625 196.054688 "
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M 400.640625 439.113281 L 330.316406 315.652344 L 342.636719 311.699219 C 357.480469 306.941406 367.277344 292.746094 366.464844 277.179688 L 365.53125 259.300781 C 365.246094 253.890625 367.261719 248.570312 371.0625 244.707031 L 383.621094 231.945312 C 394.550781 220.832031 396.628906 203.710938 388.675781 190.304688 L 379.539062 174.910156 C 376.773438 170.25 376.089844 164.601562 377.65625 159.414062 L 382.84375 142.277344 C 387.359375 127.359375 381.242188 111.234375 367.972656 103.0625 L 352.726562 93.671875 C 348.113281 90.832031 344.878906 86.152344 343.859375 80.828125 L 340.488281 63.246094 C 337.554688 47.9375 324.644531 36.5 309.09375 35.429688 L 291.230469 34.203125 C 285.824219 33.832031 280.789062 31.1875 277.414062 26.949219 L 266.253906 12.945312 C 256.542969 0.757812 239.792969 -3.367188 225.53125 2.910156 L 209.144531 10.125 C 209.144531 10.125 209.144531 10.125 209.140625 10.125 C 204.183594 12.308594 198.496094 12.308594 193.535156 10.125 L 177.148438 2.910156 C 162.882812 -3.367188 146.136719 0.757812 136.421875 12.949219 L 125.265625 26.949219 C 121.890625 31.1875 116.855469 33.832031 111.449219 34.203125 L 93.585938 35.429688 C 78.035156 36.5 65.125 47.9375 62.191406 63.246094 L 58.820312 80.828125 C 57.796875 86.148438 54.566406 90.832031 49.953125 93.671875 L 34.707031 103.058594 C 21.4375 111.230469 15.320312 127.359375 19.835938 142.277344 L 25.019531 159.414062 C 26.589844 164.601562 25.90625 170.246094 23.140625 174.90625 L 14.003906 190.304688 C 6.050781 203.707031 8.128906 220.832031 19.058594 231.941406 L 31.617188 244.707031 C 35.414062 248.570312 37.433594 253.886719 37.148438 259.296875 L 36.214844 277.179688 C 35.402344 292.742188 45.199219 306.9375 60.039062 311.699219 L 72.363281 315.648438 L 2.039062 439.113281 C -0.0859375 442.84375 -0.0078125 447.429688 2.246094 451.085938 C 4.5 454.742188 8.582031 456.882812 12.851562 456.648438 L 71.628906 453.605469 L 98.992188 505.71875 C 100.988281 509.515625 104.894531 511.925781 109.1875 511.996094 C 109.253906 511.996094 109.320312 512 109.386719 512 C 113.601562 512 117.5 509.742188 119.589844 506.070312 L 191.15625 380.421875 C 194.46875 381.449219 197.902344 381.984375 201.339844 381.984375 C 204.777344 381.984375 208.207031 381.449219 211.523438 380.421875 L 283.089844 506.070312 C 285.179688 509.742188 289.074219 512 293.289062 512 C 293.355469 512 293.425781 512 293.492188 511.996094 C 297.785156 511.925781 301.691406 509.519531 303.6875 505.71875 L 331.046875 453.605469 L 389.828125 456.648438 C 394.132812 456.875 398.179688 454.738281 400.429688 451.085938 C 402.683594 447.429688 402.765625 442.84375 400.640625 439.113281 Z M 109.503906 493.472656 L 84.582031 446.011719 L 99.296875 420.183594 C 101.347656 416.582031 100.09375 412.003906 96.492188 409.953125 C 92.898438 407.90625 88.316406 409.160156 86.265625 412.757812 L 71.550781 438.589844 L 18.019531 441.363281 L 85.605469 322.710938 C 86.878906 324.136719 87.957031 325.75 88.769531 327.515625 L 96.253906 343.785156 C 100.136719 352.226562 107.136719 358.484375 115.40625 361.589844 L 103.6875 382.167969 C 101.636719 385.765625 102.894531 390.347656 106.492188 392.398438 C 107.664062 393.0625 108.941406 393.378906 110.199219 393.378906 C 112.804688 393.378906 115.339844 392.019531 116.722656 389.589844 L 131.5625 363.539062 C 132.171875 363.464844 132.78125 363.382812 133.390625 363.273438 L 151.03125 360.191406 C 156.363281 359.257812 161.886719 360.621094 166.179688 363.925781 L 178.074219 373.085938 Z M 211.089844 364.339844 C 211.0625 364.355469 211.039062 364.363281 211.015625 364.378906 C 210.976562 364.402344 210.9375 364.429688 210.898438 364.453125 C 204.980469 367.816406 197.699219 367.816406 191.78125 364.453125 C 191.742188 364.429688 191.707031 364.402344 191.664062 364.378906 C 191.640625 364.363281 191.617188 364.355469 191.59375 364.339844 C 190.882812 363.925781 190.1875 363.480469 189.523438 362.96875 L 175.335938 352.042969 C 169.292969 347.386719 161.875 344.902344 154.335938 344.902344 C 152.375 344.902344 150.40625 345.074219 148.449219 345.414062 L 130.808594 348.496094 C 129.671875 348.695312 128.535156 348.785156 127.410156 348.78125 C 127.316406 348.777344 127.226562 348.773438 127.136719 348.773438 C 119.8125 348.644531 113.03125 344.359375 109.882812 337.511719 L 102.398438 321.246094 C 99.199219 314.289062 93.75 308.636719 87.042969 305.136719 C 87.027344 305.128906 87.015625 305.117188 87 305.109375 C 86.957031 305.085938 86.914062 305.066406 86.875 305.046875 C 86.714844 304.964844 86.554688 304.882812 86.394531 304.804688 C 86.355469 304.785156 86.324219 304.769531 86.285156 304.753906 C 84.800781 304.023438 83.261719 303.394531 81.671875 302.882812 L 64.621094 297.417969 C 56.257812 294.734375 50.734375 286.734375 51.195312 277.964844 L 52.128906 260.082031 C 52.628906 250.480469 49.050781 241.042969 42.308594 234.191406 L 29.753906 221.425781 C 23.59375 215.164062 22.421875 205.515625 26.902344 197.960938 L 36.039062 182.5625 C 40.945312 174.292969 42.164062 164.273438 39.378906 155.070312 L 34.191406 137.933594 C 31.644531 129.527344 35.09375 120.4375 42.574219 115.835938 L 57.820312 106.445312 C 66.007812 101.402344 71.742188 93.097656 73.550781 83.652344 L 76.921875 66.070312 C 78.574219 57.445312 85.851562 51 94.613281 50.394531 L 112.476562 49.167969 C 122.066406 48.507812 131.003906 43.816406 136.996094 36.296875 L 148.152344 22.296875 C 153.628906 15.425781 163.066406 13.101562 171.105469 16.640625 L 187.488281 23.851562 C 196.289062 27.726562 206.386719 27.726562 215.183594 23.851562 L 231.570312 16.640625 C 239.613281 13.101562 249.046875 15.425781 254.519531 22.296875 L 265.679688 36.300781 C 271.667969 43.820312 280.609375 48.507812 290.199219 49.167969 L 308.0625 50.398438 C 316.824219 51 324.101562 57.445312 325.753906 66.070312 L 329.125 83.65625 C 330.9375 93.097656 336.671875 101.40625 344.855469 106.445312 L 360.101562 115.835938 C 367.582031 120.441406 371.03125 129.527344 368.484375 137.933594 L 363.296875 155.074219 C 360.511719 164.273438 361.730469 174.292969 366.636719 182.566406 L 375.773438 197.960938 C 380.253906 205.515625 379.085938 215.164062 372.921875 221.425781 L 360.367188 234.191406 C 353.625 241.042969 350.046875 250.480469 350.546875 260.085938 L 351.480469 277.964844 C 351.941406 286.734375 346.417969 294.734375 338.054688 297.417969 L 321.003906 302.882812 C 319.414062 303.394531 317.875 304.023438 316.390625 304.75 C 316.351562 304.769531 316.316406 304.785156 316.28125 304.800781 C 316.121094 304.882812 315.957031 304.964844 315.796875 305.046875 C 315.757812 305.070312 315.714844 305.085938 315.675781 305.109375 C 315.660156 305.117188 315.648438 305.125 315.636719 305.132812 C 308.925781 308.632812 303.476562 314.289062 300.277344 321.246094 L 292.792969 337.515625 C 289.648438 344.355469 282.875 348.640625 275.554688 348.773438 C 275.449219 348.773438 275.339844 348.777344 275.234375 348.785156 C 274.117188 348.785156 272.992188 348.695312 271.863281 348.496094 L 254.226562 345.414062 C 244.753906 343.757812 234.953125 346.175781 227.335938 352.042969 L 213.152344 362.96875 C 212.492188 363.480469 211.796875 363.925781 211.089844 364.339844 Z M 331.128906 438.589844 L 316.292969 412.546875 C 314.242188 408.945312 309.660156 407.691406 306.066406 409.742188 C 302.464844 411.792969 301.210938 416.371094 303.261719 419.972656 L 318.09375 446.011719 L 293.175781 493.472656 L 224.605469 373.085938 L 236.496094 363.925781 C 240.789062 360.621094 246.3125 359.257812 251.648438 360.191406 L 269.285156 363.273438 C 269.894531 363.382812 270.507812 363.464844 271.117188 363.539062 L 285.949219 389.582031 C 287.332031 392.007812 289.867188 393.371094 292.472656 393.371094 C 293.730469 393.371094 295.007812 393.054688 296.179688 392.386719 C 299.777344 390.335938 301.03125 385.757812 298.984375 382.15625 L 287.269531 361.589844 C 295.539062 358.480469 302.539062 352.226562 306.421875 343.785156 L 313.90625 327.515625 C 314.71875 325.75 315.796875 324.136719 317.070312 322.710938 L 384.65625 441.363281 Z M 331.128906 438.589844 "
    }
  })])])]), _vm._v("\n              Embed badge to your website\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-section no-margin-top progress-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_c('h3', [_vm._v("Task categories")]), _vm._v(" "), _c('div', {
    staticClass: "content-chapters"
  }, [_vm._l((_vm.chapters), function(chapter) {
    return _c('router-link', {
      key: chapter.chapter.id,
      staticClass: "content-chapters__item background-1-100-after background-1-50-child-hover main-svg-stroke-color-one-50",
      attrs: {
        "to": _vm.getContentPageProps(chapter.chapter),
        "aria-label": _vm.getChapterCustomName(chapter.chapter) + ', level: ' + chapter.scores.level.name + ', ' + chapter.scores.score + '% complete'
      },
      on: {
        "contextmenu": function($event) {
          return this.gaRelatedClicked(chapter.chapter)
        },
        "click": function($event) {
          return this.gaRelatedClicked(chapter.chapter)
        }
      }
    }, [_c('div', {
      staticClass: "content-chapters_progress__icon"
    }, [_c('div', {
      staticClass: "content-chapters_image",
      style: ({
        backgroundImage: _vm.getChapterBackground(chapter.chapter)
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress__meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
      staticClass: "chapter__progress__value",
      class: 'progress__value-' + chapter.chapter.id,
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "content-chapters__item-name background-1-10 background-1-50-hover color-2-100"
    }, [_vm._v("\n                  " + _vm._s(_vm.getChapterCustomName(chapter.chapter)) + "\n                ")]), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu' && _vm.getUserRole !== 'la' && _vm.getUserRole !== 'lu') ? _c('span', {
      staticClass: "content-chapters__item-level content-chapters__item-level-custom",
      class: [chapter.scores.level.id === 5 ? 'color-1-100' : 'color-2-77', 'level-' + chapter.scores.level.id]
    }, [_c('span', {
      staticClass: "progress-level-icon",
      class: chapter.scores.level.id <= 4 ? 'type-one' : 'type-two'
    }, [(chapter.scores.level.id === 1) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 5 3"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 5 3",
        "xml:space": "preserve"
      }
    }, [_c('g', {
      attrs: {
        "id": "XMLID_53_"
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_15_",
        "d": "M5,3H0V2.5C0,1.119,1.119,0,2.5,0h0C3.881,0,5,1.119,5,2.5V3z"
      }
    })])])] : _vm._e(), _vm._v(" "), (chapter.scores.level.id === 2) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 10 6"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 10 6",
        "xml:space": "preserve"
      }
    }, [_c('g', {
      attrs: {
        "id": "XMLID_53_"
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_15_",
        "d": "M5,6H0V5.5C0,4.119,1.119,3,2.5,3h0C3.881,3,5,4.119,5,5.5V6z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "XMLID_17_",
        "d": "M10,6H5V2.5C5,1.119,6.119,0,7.5,0h0C8.881,0,10,1.119,10,2.5V6z"
      }
    })])])] : _vm._e(), _vm._v(" "), (chapter.scores.level.id === 3) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 15 9"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15 9",
        "xml:space": "preserve"
      }
    }, [_c('g', {
      attrs: {
        "id": "XMLID_53_"
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_15_",
        "d": "M5,9H0V8.5C0,7.119,1.119,6,2.5,6h0C3.881,6,5,7.119,5,8.5V9z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "XMLID_17_",
        "d": "M10,9H5V5.5C5,4.119,6.119,3,7.5,3h0C8.881,3,10,4.119,10,5.5V9z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st2",
      attrs: {
        "id": "XMLID_18_",
        "d": "M15,9h-5V2.5C10,1.119,11.119,0,12.5,0h0C13.881,0,15,1.119,15,2.5V9z"
      }
    })])])] : _vm._e(), _vm._v(" "), (chapter.scores.level.id === 4) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 15 9"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15 9",
        "xml:space": "preserve"
      }
    }, [_c('g', {
      attrs: {
        "id": "XMLID_53_"
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_15_",
        "d": "M5,9H0V8.5C0,7.119,1.119,6,2.5,6h0C3.881,6,5,7.119,5,8.5V9z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "XMLID_17_",
        "d": "M10,9H5V5.5C5,4.119,6.119,3,7.5,3h0C8.881,3,10,4.119,10,5.5V9z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st2",
      attrs: {
        "id": "XMLID_18_",
        "d": "M15,9h-5V2.5C10,1.119,11.119,0,12.5,0h0C13.881,0,15,1.119,15,2.5V9z"
      }
    })])])] : _vm._e(), _vm._v(" "), (chapter.scores.level.id === 5) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 25 15"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 25 15",
        "xml:space": "preserve"
      }
    }, [_c('g', {
      attrs: {
        "id": "XMLID_53_"
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_14_",
        "d": "M25,15h-5V2.5C20,1.125,21.125,0,22.5,0h0C23.875,0,25,1.125,25,2.5V15z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "XMLID_15_",
        "d": "M5,14.999H0v-0.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st2",
      attrs: {
        "id": "XMLID_17_",
        "d": "M10,14.999H5v-3.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st3",
      attrs: {
        "id": "XMLID_18_",
        "d": "M15,14.999h-5v-6.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st4",
      attrs: {
        "id": "XMLID_19_",
        "d": "M20,14.999h-5v-9.5c0-1.381,1.119-2.5,2.5-2.5h0c1.381,0,2.5,1.119,2.5,2.5V14.999z"
      }
    })])])] : _vm._e()], 2), _vm._v(" "), _c('span', [_vm._v("\n                  Level: " + _vm._s(chapter.scores.level.name) + "\n                ")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])])]), _vm._v(" "), (_vm.badgeCopy === true) ? _c('div', {
    staticClass: "badge-copy"
  }, [_c('div', {
    staticClass: "badge-copy-container",
    attrs: {
      "aria-modal": "true",
      "aria-labelledby": "confirmation-popup-title"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#777777"
    },
    attrs: {
      "id": "confirmation-popup-title"
    }
  }, [_vm._v("Embed ClearAssured to your website")]), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-selector"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "iframe-themes"
    }
  }, [_vm._v("Theme")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": true,
      "placeholder": 'Theme',
      "options": _vm.iframeThemes,
      "data-lpignore": "true",
      "id": "iframe-themes"
    },
    model: {
      value: (_vm.iframeTheme),
      callback: function($$v) {
        _vm.iframeTheme = $$v
      },
      expression: "iframeTheme"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-iframe",
    class: _vm.iframeTheme.value
  }, [_c('iframe', {
    attrs: {
      "title": _vm.user && _vm.user.company ? _vm.user.company.name + ' badge' : 'Company badge',
      "width": "210",
      "height": "85",
      "id": "previewIframe",
      "src": _vm.getBadgeLink() + '?company=' + (_vm.user.company ? _vm.user.company.hash : '') + '&theme=' + _vm.iframeTheme.value
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-code"
  }, [_c('button', {
    attrs: {
      "aria-label": "Copy company badge code"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyIframe()
      }
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "title": _vm.user && _vm.user.company ? _vm.user.company.name + ' badge code' : 'Company badge code',
      "aria-placeholder": "The embed code was copied to your clipboard",
      "aria-hidden": "true",
      "id": "iframeCode",
      "rows": "3",
      "cols": "50",
      "onclick": "this.focus(); this.select()",
      "readonly": "readonly"
    }
  }, [_vm._v(_vm._s(_vm.getIframeCode()))])]), _vm._v(" "), _c('button', {
    staticClass: "badge-copy-close",
    attrs: {
      "aria-label": "Close dialog"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.badgeCopy = false
      }
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-chart-legend-y",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "content-chart-legend-y__item level-5"
  }, [_c('span', [_vm._v("Platinum")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-4"
  }, [_c('span', [_vm._v("Gold")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-3"
  }, [_c('span', [_vm._v("Silver")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-2"
  }, [_c('span', [_vm._v("Bronze")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-1"
  }, [_c('span', [_vm._v("Foundation")])])])
}]}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "popup__inner"
  }, [_c('button', {
    staticClass: "popup-close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close($event)
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "popup-heading"
  }, [(_vm.title) ? _c('h2', {
    staticClass: "popup-title text-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    staticClass: "popup-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.description))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "popup-footer"
  }, [_vm._t("footer")], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article"
  }, [_c('div', {
    attrs: {
      "id": "headerPlaceholder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__header"
  }, [_c('div', {
    staticClass: "article__container article__header--container"
  }, [_c('router-link', {
    staticClass: "article__header--button",
    attrs: {
      "to": {
        name: 'todo-list'
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n        Back\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "article__header--actions"
  }, [_c('button', {
    staticClass: "blue-border-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(_vm.entity.status, true, false)
      }
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('button', {
    staticClass: "light-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(0)
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('button', {
    staticClass: "dark-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(1)
      }
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('button', {
    staticClass: "gray-border-btn",
    on: {
      "click": function($event) {
        return _vm.goToAllArticles()
      }
    }
  }, [_vm._v("Exit without saving")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__content"
  }, [_c('div', {
    staticClass: "article__container"
  }, [_c('div', {
    staticClass: "article__content--title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.entity.title))]), _vm._v(" "), _c('div', {
    staticClass: "article__content--actions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.archiveArticle()
      }
    }
  }, [(_vm.entity.status === 1) ? [_c('svg', {
    staticClass: "archive-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "14",
      "viewBox": "0 0 16 14"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M14.5-11a1.447,1.447,0,0,1,1.063.438A1.447,1.447,0,0,1,16-9.5V-9H0v-2.5a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-13h5l2,2ZM0-.5V-8H16V-.5A1.447,1.447,0,0,1,15.563.563,1.447,1.447,0,0,1,14.5,1H1.5A1.447,1.447,0,0,1,.438.563,1.447,1.447,0,0,1,0-.5Z",
      "transform": "translate(0 13)"
    }
  })]), _vm._v("\n              Archive\n            ")] : [_c('svg', {
    staticClass: "restore-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15.76",
      "height": "15.75",
      "viewBox": "0 0 15.76 15.75"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M6.635-6.99a.375.375,0,0,0,.375-.375v-1.5a.375.375,0,0,0-.375-.375H3.564A5.49,5.49,0,0,1,8.01-11.5,5.5,5.5,0,0,1,13.51-6,5.5,5.5,0,0,1,8.01-.5,5.479,5.479,0,0,1,4.366-1.879a.374.374,0,0,0-.513.016L2.792-.8a.376.376,0,0,0,.015.544A7.721,7.721,0,0,0,8.01,1.75a7.75,7.75,0,0,0,7.75-7.733A7.732,7.732,0,0,0,8.068-13.75,7.73,7.73,0,0,0,2.25-11.184v-2.441A.375.375,0,0,0,1.875-14H.375A.375.375,0,0,0,0-13.625v6.26a.375.375,0,0,0,.375.375Z",
      "transform": "translate(0 14)"
    }
  })]), _vm._v("\n              Restore\n            ")]], 2), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.deleteArticle()
      }
    }
  }, [_c('svg', {
    staticClass: "delete-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "16",
      "viewBox": "0 0 14 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M1.656.594,1-10H13L12.344.594a1.574,1.574,0,0,1-.484,1A1.412,1.412,0,0,1,10.844,2H3.156a1.412,1.412,0,0,1-1.016-.406A1.574,1.574,0,0,1,1.656.594ZM13.5-13a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5H.5a.442.442,0,0,1-.5-.5v-1A.442.442,0,0,1,.5-13H4l.375-.719A.409.409,0,0,1,4.813-14H9.188a.409.409,0,0,1,.438.281L10-13Z",
      "transform": "translate(0 14)"
    }
  })]), _vm._v("\n            Delete")])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--statusbar"
  }, [_c('div', [_vm._v("Status")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getStatus(_vm.entity.status)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lastTimeEdited(_vm.entity.lastTimeEditedDate, _vm.entity.lastTimeEditedBy)))])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--editor"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleEditBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Edit task")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleEditBoxActive = !_vm.articleEditBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label"
  }, [_vm._v("Task content")]), _vm._v(" "), _c('Vueditor', {
    ref: "contentEditor",
    staticClass: "form-control__editor"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--fourth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "title",
      "data-vv-name": "Title",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "topic"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Topic')
    }],
    attrs: {
      "searchable": false,
      "multiple": true,
      "options": _vm.getTagsForSelect,
      "data-vv-name": "Topic",
      "data-lpignore": "true",
      "name": "topic",
      "id": "topic"
    },
    model: {
      value: (_vm.entity.topic),
      callback: function($$v) {
        _vm.$set(_vm.entity, "topic", $$v)
      },
      expression: "entity.topic"
    }
  }), _vm._v(" "), (this.errors.has('Topic')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Topic')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Type')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getContentTypeForSelect,
      "data-vv-name": "Type",
      "data-lpignore": "true",
      "name": "type",
      "id": "type"
    },
    model: {
      value: (_vm.entity.type),
      callback: function($$v) {
        _vm.$set(_vm.entity, "type", $$v)
      },
      expression: "entity.type"
    }
  }), _vm._v(" "), (this.errors.has('Type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Type')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Category')
    }],
    attrs: {
      "searchable": false,
      "multiple": false,
      "options": _vm.getContentChapterForSelect,
      "data-vv-name": "Category",
      "data-lpignore": "true",
      "name": "category",
      "id": "category"
    },
    model: {
      value: (_vm.entity.chapter),
      callback: function($$v) {
        _vm.$set(_vm.entity, "chapter", $$v)
      },
      expression: "entity.chapter"
    }
  }), _vm._v(" "), (this.errors.has('Category')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Category')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-element article__featured-image"
  }, [_c('span', {
    staticClass: "article__form-label"
  }, [_vm._v("Featured image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded),
      expression: "!isThumbnailFileUploaded"
    }],
    staticClass: "article__form-label article__form-label--file-upload"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "24",
      "viewBox": "0 0 32 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M29,0a3,3,0,0,0,3-3V-21a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3V-3A3,3,0,0,0,3,0ZM7-20.5A3.5,3.5,0,0,1,10.5-17,3.5,3.5,0,0,1,7-13.5,3.5,3.5,0,0,1,3.5-17,3.5,3.5,0,0,1,7-20.5ZM4-4V-7l4.47-4.47a.75.75,0,0,1,1.061,0L13-8l8.47-8.47a.75.75,0,0,1,1.061,0L28-11v7Z",
      "transform": "translate(0 24)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.altImage),
      expression: "entity.altImage"
    }],
    staticClass: "form-control form-control__textarea has-no-label",
    class: {
      'is-blocked': !_vm.isThumbnailFileUploaded
    },
    attrs: {
      "disabled": !_vm.isThumbnailFileUploaded,
      "data-lpignore": "true",
      "id": "image",
      "placeholder": _vm.isThumbnailFileUploaded ? 'Type in Alt text for the image...' : '',
      "data-vv-name": "Image alt",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "altImage", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__container"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleAccessBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Access Settings")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleAccessBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleAccessBoxActive = !_vm.articleAccessBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleAccessBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-specific"
    }
  }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Company specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getCompaniesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'industry') || _vm.isExcluded !== null,
      "data-vv-name": "Company specific",
      "data-lpignore": "true",
      "name": "company",
      "id": "company-specific"
    },
    model: {
      value: (_vm.entity.company),
      callback: function($$v) {
        _vm.$set(_vm.entity, "company", $$v)
      },
      expression: "entity.company"
    }
  }), _vm._v(" "), (this.errors.has('Company specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-specific"
    }
  }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Industry specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getIndustriesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'company') || _vm.isExcluded !== null,
      "data-vv-name": "Industry specific",
      "data-lpignore": "true",
      "name": "industry",
      "id": "industry-specific"
    },
    model: {
      value: (_vm.entity.industry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "industry", $$v)
      },
      expression: "entity.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-specific"
    }
  }, [_vm._v("Location specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Location specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Location specific",
      "data-lpignore": "true",
      "name": "Location specific",
      "id": "location-specific"
    },
    model: {
      value: (_vm.entity.location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "location", $$v)
      },
      expression: "entity.location"
    }
  }), _vm._v(" "), (this.errors.has('Location specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Location specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-specific"
    }
  }, [_vm._v("Organisation size specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Organisation size specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Organisation size specific",
      "data-lpignore": "true",
      "name": "size",
      "id": "size-specific"
    },
    model: {
      value: (_vm.entity.size),
      callback: function($$v) {
        _vm.$set(_vm.entity, "size", $$v)
      },
      expression: "entity.size"
    }
  }), _vm._v(" "), (this.errors.has('Organisation size specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation size specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-exclude"
    }
  }, [_vm._v("Exclude companies")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude companies')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'industry') || (_vm.isSpecific !== null && _vm.isSpecific !== 'industry'),
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Exclude companies",
      "data-lpignore": "true",
      "name": "notCompany",
      "id": "company-exclude"
    },
    model: {
      value: (_vm.entity.notCompany),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notCompany", $$v)
      },
      expression: "entity.notCompany"
    }
  }), _vm._v(" "), (this.errors.has('Exclude companies')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude companies')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-exclude"
    }
  }, [_vm._v("Exclude industries")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude industries')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'company') || _vm.isSpecific !== null,
      "options": _vm.getIndustriesForSelect,
      "data-vv-name": "Exclude industries",
      "data-lpignore": "true",
      "name": "notIndustry",
      "id": "industry-exclude"
    },
    model: {
      value: (_vm.entity.notIndustry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notIndustry", $$v)
      },
      expression: "entity.notIndustry"
    }
  }), _vm._v(" "), (this.errors.has('Exclude industries')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude industries')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-exclude"
    }
  }, [_vm._v("Exclude locations")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude locations')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Exclude locations",
      "data-lpignore": "true",
      "name": "notLocation",
      "id": "location-exclude"
    },
    model: {
      value: (_vm.entity.notLocation),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notLocation", $$v)
      },
      expression: "entity.notLocation"
    }
  }), _vm._v(" "), (this.errors.has('Exclude locations')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude locations')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-exclude"
    }
  }, [_vm._v("Exclude organisation sizes")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude organisation sizes')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Exclude organisation sizes",
      "data-lpignore": "true",
      "name": "notSize",
      "id": "size-exclude"
    },
    model: {
      value: (_vm.entity.notSize),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notSize", $$v)
      },
      expression: "entity.notSize"
    }
  }), _vm._v(" "), (this.errors.has('Exclude organisation sizes')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude organisation sizes')))]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleRelatedBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Related resources")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleRelatedBoxActive = !_vm.articleRelatedBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-articles"
    }
  }, [_vm._v("Related Resources")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": true,
      "id": "related-articles",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttc),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttc", $$v)
      },
      expression: "entity.ttc"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleSettingsBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Task settings")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleSettingsBoxActive = !_vm.articleSettingsBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--seventh"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "repeats"
    }
  }, [_vm._v("Repeats")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "options": _vm.recurrences,
      "multiple": false,
      "searchable": false,
      "id": "repeats"
    },
    model: {
      value: (_vm.entity.settings.recurrence),
      callback: function($$v) {
        _vm.$set(_vm.entity.settings, "recurrence", $$v)
      },
      expression: "entity.settings.recurrence"
    }
  })], 1), _vm._v(" "), (_vm.entity.settings.recurrence && _vm.entity.settings.recurrence.label === 'Custom') ? _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "repeats-custom"
    }
  }, [_vm._v("Custom repeats value (in days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.settings.recurrence.value),
      expression: "entity.settings.recurrence.value"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "number",
      "min": "0",
      "data-lpignore": "true",
      "id": "repeats-custom"
    },
    domProps: {
      "value": (_vm.entity.settings.recurrence.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.settings.recurrence, "value", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "score"
    }
  }, [_vm._v("Priority points")]), _vm._v(" "), _c('span', {
    staticClass: "form-description",
    attrs: {
      "id": "scoreDesc",
      "tabindex": "-1"
    }
  }, [_vm._v("[1..33] → Low, [34..66] → Medium, [67..100] → High")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.settings.score),
      expression: "entity.settings.score"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100",
      "aria-describedby": "scoreDesc",
      "data-lpignore": "true",
      "id": "score"
    },
    domProps: {
      "value": (_vm.entity.settings.score)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.settings, "score", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--third"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "mandatory"
    }
  }, [_vm._v("Mandatory")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "mandatory"
    }
  }, _vm._l(([{
    label: 'Yes',
    value: 'true'
  }, {
    label: 'No',
    value: 'false'
  }]), function(choice, index) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.settings.mandatory),
        expression: "entity.settings.mandatory"
      }],
      attrs: {
        "type": "radio",
        "id": 'mandatory-' + choice.label
      },
      domProps: {
        "checked": choice.value === _vm.entity.settings.mandatory,
        "value": choice.value,
        "checked": _vm._q(_vm.entity.settings.mandatory, choice.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.entity.settings, "mandatory", choice.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'mandatory-' + choice.label
      }
    }, [_vm._v(_vm._s(choice.label))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "assessed"
    }
  }, [_vm._v("Self assessed")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "assessed"
    }
  }, _vm._l(([{
    label: 'Yes',
    value: 'true'
  }, {
    label: 'No',
    value: 'false'
  }]), function(choice, index) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.settings.assessed),
        expression: "entity.settings.assessed"
      }],
      attrs: {
        "type": "radio",
        "id": 'assessed-' + choice.label
      },
      domProps: {
        "checked": choice.value === _vm.entity.settings.assessed,
        "value": choice.value,
        "checked": _vm._q(_vm.entity.settings.assessed, choice.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.entity.settings, "assessed", choice.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'assessed-' + choice.label
      }
    }, [_vm._v(_vm._s(choice.label))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "on-boarding"
    }
  }, [_vm._v("On boarding task")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "on-boarding"
    }
  }, _vm._l(([{
    label: 'Yes',
    value: 'true'
  }, {
    label: 'No',
    value: 'false'
  }]), function(choice, index) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.settings.onBoarding),
        expression: "entity.settings.onBoarding"
      }],
      attrs: {
        "type": "radio",
        "id": 'on-boarding-' + choice.label
      },
      domProps: {
        "checked": choice.value === _vm.entity.settings.onBoarding,
        "value": choice.value,
        "checked": _vm._q(_vm.entity.settings.onBoarding, choice.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.entity.settings, "onBoarding", choice.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'on-boarding-' + choice.label
      }
    }, [_vm._v(_vm._s(choice.label))])])
  }), 0)])])])])])])]), _vm._v(" "), (_vm.articleType.type === 'video' || _vm.articleType.type === 'document') ? _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleResourcesBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Useful resources")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleResourcesBoxActive = !_vm.articleResourcesBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_vm._l((_vm.entity.resources.video), function(row, index) {
    return (_vm.articleType.type === 'video') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-url"
      }
    }, [_vm._v("Video URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoUrl),
        expression: "row.videoUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Video URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-url",
        "data-vv-name": "Video URL",
        "name": "video-url"
      },
      domProps: {
        "value": (row.videoUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Video URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Video URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-transcript"
      }
    }, [_vm._v("Transcript for video")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoTranscript),
        expression: "row.videoTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.videoTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoTranscript", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.video.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.entity.resources.document), function(row, index) {
    return (_vm.articleType.type === 'document') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('span', {
      staticClass: "article__form-label"
    }, [_vm._v("Upload resource")]), _vm._v(" "), _c('label', {
      staticClass: "form-label"
    }, [(row.resource === null) ? _c('span', {
      staticClass: "form-control form-control__input"
    }, [_vm._v("+Upload resource")]) : _vm._e(), _vm._v(" "), (row.resource !== null) ? _c('span', {
      staticClass: "form-control form-control__input",
      attrs: {
        "id": 'uploadedResource_' + index
      }
    }, [_vm._v(_vm._s(row.name))]) : _vm._e(), _vm._v(" "), _c('input', {
      staticClass: "form-control visually-hidden form-control--file input-file-resource",
      attrs: {
        "type": "file",
        "id": 'uploadResource_' + index,
        "placeholder": "Type in to add title..."
      },
      on: {
        "change": function($event) {
          return _vm.onResourceFileChange($event, index)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.document.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-url"
      }
    }, [_vm._v("Resource URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceUrl),
        expression: "row.resourceUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Resource URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-url",
        "data-vv-name": "Resource URL",
        "name": "resource-url"
      },
      domProps: {
        "value": (row.resourceUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Resource URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Resource URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-transcript"
      }
    }, [_vm._v("Transcript for resource")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceTranscript),
        expression: "row.resourceTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.resourceTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceTranscript", $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--full form-group__video-add-button",
    on: {
      "click": _vm.addVideoRow
    }
  }, [_c('div', {
    staticClass: "add-new-video"
  }, [_vm._v("Add new")])])], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleChangelogBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Changelog")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleChangelogBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleChangelogBoxActive = !_vm.articleChangelogBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleChangelogBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('table', {
    staticClass: "changelog-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.articleLog.length) ? _vm._l((_vm.articleLog), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.created_at !== null ? _vm.convertDate(row.created_at, '.') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user !== null ? row.user.first_name + ' ' + row.user.last_name : '-'))])])
  }) : [_vm._m(1)]], 2)])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Action performed")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("User")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nothing to display here")])])
}]}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-badge",
    class: _vm.badgeTheme
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.badgeReady),
      expression: "badgeReady"
    }],
    staticClass: "badge-wrapper"
  }, [_c('div', {
    staticClass: "badge-progress"
  }, [_c('svg', {
    attrs: {
      "id": "progress",
      "width": "64",
      "height": "64",
      "viewBox": "0 0 100 100"
    }
  }, [_c('circle', {
    staticClass: "progress__meter",
    attrs: {
      "cx": "50%",
      "cy": "50%",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-ft",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-pp",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-at",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-rt",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "badge-text"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "level",
    style: ({
      backgroundColor: _vm.getCompanyLevel('color')
    })
  }, [_vm._v("\n        " + _vm._s(this.getCompanyLevel('name')) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All companies")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [(_vm.getUserRole !== 'gm') ? _c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Dashboard")]) : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'gm' || _vm.getUserRole !== 'ca') ? _c('router-link', {
    staticClass: "companies active",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "all-users",
    attrs: {
      "to": {
        name: _vm.getUserRole === 'gm' ? 'users' : 'ca-users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), (_vm.getUserRole !== 'gm') ? _c('router-link', {
    staticClass: "to-do",
    attrs: {
      "to": {
        name: 'tasks'
      }
    }
  }, [_vm._v("Tasks")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(this.companiesSum) + " companies")]), _vm._v(" "), _c('ul', {
    staticClass: "data-list-statuses data-list-statusbar__block"
  }, _vm._l((_vm.statusbar.data), function(row, index) {
    return _c('li', {
      staticClass: "data-list-statuses__item"
    }, [_vm._v(_vm._s(row + ' ') + "\n            "), (index === 'active') ? [_vm._v("\n              active\n            ")] : (index === 'notactive') ? [_vm._v("\n              inactive\n            ")] : [_vm._v("\n              archived\n            ")]], 2)
  }), 0)]), _vm._v(" "), _c('router-link', {
    staticClass: "data-list-add",
    attrs: {
      "to": {
        name: 'add-company'
      },
      "tabindex": "-1"
    }
  }, [_vm._v("Add new company")])], 1), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.editedCompanies.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [((_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) && _vm.selectedFilters.length) ? _c('tr', {
    staticClass: "inside-table-filters"
  }, [_c('th', {
    attrs: {
      "colspan": "9"
    }
  }, [_c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistSearchInOptions('name')
    },
    attrs: {
      "colspan": "2"
    },
    on: {
      "mouseover": function($event) {
        return _vm.addSearchHoverElement('name')
      },
      "mouseleave": _vm.removeSearchHoverElements
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByName),
      expression: "searchByName"
    }],
    staticClass: "table-search",
    attrs: {
      "title": "ID and full name",
      "aria-label": "ID and full name",
      "type": "search",
      "placeholder": "ID and full name"
    },
    domProps: {
      "value": (_vm.searchByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getIndustriesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getIndustriesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getIndustriesForSelect
    },
    model: {
      value: (_vm.companyIndustry),
      callback: function($$v) {
        _vm.companyIndustry = $$v
      },
      expression: "companyIndustry"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getDefaultRegistrationRolesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(5)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getDefaultRegistrationRolesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 5
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 5),
      expression: "filerTableHead.selectedCeil === 5"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-5",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getDefaultRegistrationRolesForSelect
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-role-head table-head-hover table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-1",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getCompaniesForSelect
    },
    model: {
      value: (_vm.companyParent),
      callback: function($$v) {
        _vm.companyParent = $$v
      },
      expression: "companyParent"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getStatusesForSelect
    },
    model: {
      value: (_vm.companyStatus),
      callback: function($$v) {
        _vm.companyStatus = $$v
      },
      expression: "companyStatus"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('users', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'users' && this.companyOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'users' && !this.companyOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('created', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'created' && this.companyOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'created' && !this.companyOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('expire', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'expire' && this.companyOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.companyOrderBy !== null && this.companyOrderBy.type === 'expire' && !this.companyOrderBy.order
    }
  })])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedCompanies), function(company, i) {
    return (i < _vm.offset) ? _c('tr', {
      on: {
        "click": function($event) {
          return _vm.goToCompanyEdit(company.id)
        }
      }
    }, [(company.type === 'show') ? _c('td', {
      staticClass: "id-cell text-center cellpadding",
      attrs: {
        "data-title": "ID"
      }
    }, [_vm._v(_vm._s(company.id))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "name-cell cellpadding",
      attrs: {
        "data-title": "ID and full name:"
      }
    }, [(_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) ? _c('span', [_vm._v(_vm._s(company.id) + " ")]) : _vm._e(), _vm._v(_vm._s(company.name))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "title-cell cellpadding",
      attrs: {
        "data-title": "Industry:"
      }
    }, [_vm._v(_vm._s(company.industry ? company.industry.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "title-cell cellpadding",
      attrs: {
        "data-title": "Type:"
      }
    }, [_vm._v(_vm._s(company.userType ? company.userType.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Parent:"
      }
    }, [_vm._v(_vm._s(company.parent ? company.parent.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "role-cell cellpadding",
      attrs: {
        "data-title": "Status:"
      }
    }, [_vm._v(_vm._s(_vm.getCompanyStatus(company).label))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "company-cell cellpadding",
      attrs: {
        "data-title": "No. of users:"
      }
    }, [_vm._v(_vm._s(company.users))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "created-cell cellpadding text-center",
      attrs: {
        "data-title": "Created on:"
      }
    }, [_vm._v(_vm._s(company.created ? _vm.convertDate(company.created, '.') : _vm.convertDate(company.start_date, '.')))]) : _vm._e(), _vm._v(" "), (company.type === 'show') ? _c('td', {
      staticClass: "last-login-cell cellpadding text-center",
      attrs: {
        "data-title": "Last login:"
      }
    }, [_vm._v(_vm._s(company.subscription_end ? _vm.convertDate(company.subscription_end, '.') : 'n/a'))]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), (this.offset <= this.editedCompanies.length) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(7), _vm._v("Load more\n        ")])]) : _vm._e()])]), _vm._v(" "), (false) ? _c('app-spiner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Industry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Parent company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("No. of users")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Start date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Expires on")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-profile-page",
    class: [{
      'no-margin-top': _vm.embedded,
      'no-padding-top': _vm.embedded
    }]
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [(!_vm.embedded) ? _c('h1', {
    staticClass: "page-header color-1-100"
  }, [(_vm.canEditBillingContact) ? [_vm._v("\n        Edit billing profile\n      ")] : [_vm._v("\n        Billing profile\n      ")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-block",
    class: [{
      'no-margin-top': _vm.embedded,
      'no-padding-top': _vm.embedded
    }]
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [(_vm.currentPlan && _vm.currentPlan.plan) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'subscriptionDetails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('subscriptionDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "19.25",
      "height": "22",
      "viewBox": "0 0 19.25 22"
    }
  }, [_c('path', {
    attrs: {
      "id": "plan-summary",
      "d": "M16.5-19.25H2.75A2.75,2.75,0,0,0,0-16.5V0A2.75,2.75,0,0,0,2.75,2.75H16.5A2.75,2.75,0,0,0,19.25,0V-16.5A2.751,2.751,0,0,0,16.5-19.25ZM2.75-14.437a.694.694,0,0,1,.688-.687H4.813a.692.692,0,0,1,.688.688v1.375a.69.69,0,0,1-.687.688H3.438a.691.691,0,0,1-.687-.687ZM5.5-2.062a.69.69,0,0,1-.687.688H3.438a.691.691,0,0,1-.687-.687V-3.437a.694.694,0,0,1,.688-.687H4.813a.692.692,0,0,1,.688.688ZM7.017-9.483,4.611-7.077a.687.687,0,0,1-.486.2.689.689,0,0,1-.486-.2L2.608-8.108a.687.687,0,0,1,0-.972.687.687,0,0,1,.972,0l.545.547,1.92-1.92a.687.687,0,0,1,.972,0,.684.684,0,0,1,0,.971Zm8.8,7.421H8.937A.69.69,0,0,1,8.25-2.75a.689.689,0,0,1,.688-.687h6.875a.688.688,0,0,1,.688.688A.689.689,0,0,1,15.813-2.062Zm0-5.5H8.937A.69.69,0,0,1,8.25-8.25a.689.689,0,0,1,.688-.687h6.875a.69.69,0,0,1,.688.688A.69.69,0,0,1,15.813-7.562Zm0-5.5H8.937a.69.69,0,0,1-.687-.687.689.689,0,0,1,.688-.687h6.875a.69.69,0,0,1,.688.688A.69.69,0,0,1,15.813-13.062Z",
      "transform": "translate(0 19.25)",
      "fill": "currentColor"
    }
  })])]), _vm._v("\n              Plan summary\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'billingContact'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('billingContact')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20.625",
      "height": "22",
      "viewBox": "0 0 20.625 22"
    }
  }, [_c('path', {
    attrs: {
      "id": "billing-contact",
      "d": "M16.5-19.25H4.125a2.75,2.75,0,0,0-2.75,2.75V0a2.75,2.75,0,0,0,2.75,2.75H16.5A2.75,2.75,0,0,0,19.25,0V-16.5A2.751,2.751,0,0,0,16.5-19.25Zm-6.187,5.5A2.75,2.75,0,0,1,13.063-11a2.75,2.75,0,0,1-2.75,2.75A2.75,2.75,0,0,1,7.563-11,2.751,2.751,0,0,1,10.313-13.75Zm4.125,11H6.188A.69.69,0,0,1,5.5-3.437,3.437,3.437,0,0,1,8.938-6.875h2.75a3.438,3.438,0,0,1,3.438,3.438A.69.69,0,0,1,14.438-2.75ZM21.313-16.5h-.687v4.125h.688A.69.69,0,0,0,22-13.062v-2.75A.688.688,0,0,0,21.313-16.5Zm0,5.5h-.687v4.125h.688A.69.69,0,0,0,22-7.562v-2.75A.69.69,0,0,0,21.313-11Zm0,5.5h-.687v4.125h.688A.688.688,0,0,0,22-2.062v-2.75A.69.69,0,0,0,21.313-5.5Z",
      "transform": "translate(-1.375 19.25)",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), (_vm.canEditBillingContact === false) ? [_vm._v("Billing contact")] : [_vm._v("Edit billing contact")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'billingDetails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('billingDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24.75",
      "height": "19.25",
      "viewBox": "0 0 24.75 19.25"
    }
  }, [_c('path', {
    attrs: {
      "id": "billing-details",
      "d": "M22-17.875H2.75A2.75,2.75,0,0,0,0-15.125v13.75a2.75,2.75,0,0,0,2.75,2.75H22a2.75,2.75,0,0,0,2.75-2.75v-13.75A2.751,2.751,0,0,0,22-17.875ZM2.711-7.562A.687.687,0,0,1,3.4-8.25H7.524a.687.687,0,0,1,.688.688v1.375a.688.688,0,0,1-.687.688H3.4a.688.688,0,0,1-.687-.687V-7.562ZM6.875-1.719a.345.345,0,0,1-.344.344H3.094a.344.344,0,0,1-.344-.344v-.687a.344.344,0,0,1,.344-.344H6.531a.344.344,0,0,1,.344.344Zm8.25,0a.344.344,0,0,1-.344.344H8.594a.345.345,0,0,1-.344-.344v-.687a.344.344,0,0,1,.344-.344h6.149a.344.344,0,0,1,.344.344ZM16.5-6.187a.688.688,0,0,1-.687.688h-5.5a.688.688,0,0,1-.687-.687V-7.562a.681.681,0,0,1,.649-.687h5.5a.687.687,0,0,1,.688.688Zm5.5,0a.688.688,0,0,1-.687.688h-2.75a.69.69,0,0,1-.687-.687V-7.562a.687.687,0,0,1,.688-.687h2.75A.69.69,0,0,1,22-7.562Zm0-5.5a.69.69,0,0,1-.687.688H17.188a.688.688,0,0,1-.687-.687v-2.75a.687.687,0,0,1,.688-.687h4.125a.69.69,0,0,1,.688.688Z",
      "transform": "translate(0 17.875)",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), (_vm.canEditBillingDetails === false) ? [_vm._v("Billing details")] : [_vm._v("Edit billing details")]], 2)]), _vm._v(" "), (_vm.invoices && _vm.invoices.length > 0) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'billingInvoices'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('billingInvoices')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16.5",
      "height": "22",
      "viewBox": "0 0 16.5 22"
    }
  }, [_c('path', {
    attrs: {
      "id": "invoices",
      "d": "M14.25-.25v5.5h5.5Zm1.375,11H7.375V13.5h8.25Zm-2.75-5.5V-.25H5.313A2.062,2.062,0,0,0,3.25,1.813V19.688A2.063,2.063,0,0,0,5.313,21.75H17.688a2.062,2.062,0,0,0,2.063-2.062V6.625H14.289A1.382,1.382,0,0,1,12.875,5.25ZM6,2.844A.346.346,0,0,1,6.344,2.5H9.781a.346.346,0,0,1,.344.344v.688a.345.345,0,0,1-.344.344H6.344A.346.346,0,0,1,6,3.531Zm0,2.75a.346.346,0,0,1,.344-.344H9.781a.345.345,0,0,1,.344.344v.688a.345.345,0,0,1-.344.344H6.344A.346.346,0,0,1,6,6.281ZM17,18.656a.346.346,0,0,1-.344.344H13.219a.345.345,0,0,1-.344-.344v-.687a.346.346,0,0,1,.344-.344h3.438a.346.346,0,0,1,.344.344Zm0-8.594v4.125a.685.685,0,0,1-.687.688H6.688A.685.685,0,0,1,6,14.188V10.063a.685.685,0,0,1,.688-.687h9.625A.684.684,0,0,1,17,10.063Z",
      "transform": "translate(-3.25 0.25)",
      "fill": "currentColor"
    }
  })])]), _vm._v("\n              Documents\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [(_vm.currentPlan && _vm.currentPlan.plan) ? _c('div', {
    ref: "subscriptionDetails",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'subscriptionDetails'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n              Plan summary\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "edit-details-billing-group"
  }, [(_vm.company.billingDetailsData.disconnectedFromBilling === 0 && _vm.getUserRole === 'ca') ? _c('a', {
    staticClass: "edit-details edit-details-billing border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.initCancelSubscription()
      }
    }
  }, [_c('span', {
    staticClass: "cancel-subscription color-1-100"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "id": "times",
      "fill": "currentColor",
      "d": "M8-14A8,8,0,0,0,0-6,8,8,0,0,0,8,2a8,8,0,0,0,8-8A8,8,0,0,0,8-14Zm2.5,9.469a.75.75,0,0,1,0,1.061.75.75,0,0,1-1.061,0L8-4.941,6.53-3.471a.75.75,0,0,1-1.061,0,.75.75,0,0,1,0-1.061L6.939-6,5.469-7.5a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0L8-7.059l1.47-1.47a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061L9.061-6Z",
      "transform": "translate(0 14)"
    }
  })])]), _vm._v("\n                Cancel subscription\n              ")]) : _vm._e(), _vm._v(" "), (_vm.invoicesToBePaid && _vm.canEditPayment === false && _vm.getUserRole === 'ca') ? _c('a', {
    staticClass: "edit-details edit-details-pay-now border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditPayment()
      }
    }
  }, [_c('span', {
    staticClass: "pay-now color-1-100"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "14",
      "viewBox": "0 0 18 14"
    }
  }, [_c('path', {
    attrs: {
      "id": "credit-card",
      "d": "M16-13H2a2,2,0,0,0-2,2V-1A2,2,0,0,0,2,1H16a2,2,0,0,0,2-2V-11A2,2,0,0,0,16-13ZM1.972-5.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1ZM5-1.25A.251.251,0,0,1,4.75-1H2.25A.25.25,0,0,1,2-1.25v-.5A.25.25,0,0,1,2.25-2h2.5A.25.25,0,0,1,5-1.75Zm6,0a.25.25,0,0,1-.25.25H6.25A.251.251,0,0,1,6-1.25v-.5A.25.25,0,0,1,6.25-2h4.472a.25.25,0,0,1,.25.25ZM12-4.5a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,7-4.5v-1A.5.5,0,0,1,7.472-6h4a.5.5,0,0,1,.5.5Zm4,0a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z",
      "transform": "translate(0 13)",
      "fill": "currentColor"
    }
  })])]), _vm._v("\n                Pay now\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data__wrapper"
  }, [_c('div', {
    staticClass: "subscription__plan-data blue-section"
  }, [_c('p', {
    staticClass: "subscription__plan-data--text"
  }, [_vm._v("\n                  You pay "), _c('strong', [_vm._v("£" + _vm._s(_vm.planPrice) + " "), (_vm.vatDisplay) ? [_vm._v("(including VAT)")] : _vm._e(), _vm._v(" / " + _vm._s(_vm.currentPlanSubscriptionPaymentPeriod))], 2), _vm._v(" via "), (_vm.profile && _vm.profile.company && _vm.profile.company.payment_method === 0) ? [_vm._v("Credit Card")] : [_vm._v("Bank Transfer")], _vm._v(" for your "), _c('strong', [_vm._v(_vm._s(_vm.currentPlan.plan.name) + " plan for " + _vm._s(_vm.currentPlanSize) + " organisations")]), _vm._v(".\n                ")], 2), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Billing period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanPaymentPeriod))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Commitment period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanCommitment))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Active until")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.commitmentExpiryDate))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Next payment date")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.nextPaymentDate))])])])])]), _vm._v(" "), (_vm.invoicesToBePaid && _vm.canEditPayment === true) ? [_c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area--info"
  }, [_c('div', {
    staticClass: "card-payment-area--info__secure-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-shield-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "shield-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M466.5 83.71l-192-80c-4.875-2.031-13.16-3.703-18.44-3.703c-5.312 0-13.55 1.672-18.46 3.703L45.61 83.71C27.7 91.1 16 108.6 16 127.1C16 385.2 205.2 512 255.9 512C307.1 512 496 383.8 496 127.1C496 108.6 484.3 91.1 466.5 83.71zM352 200c0 5.531-1.901 11.09-5.781 15.62l-96 112C243.5 335.5 234.6 335.1 232 335.1c-6.344 0-12.47-2.531-16.97-7.031l-48-48C162.3 276.3 160 270.1 160 263.1c0-12.79 10.3-24 24-24c6.141 0 12.28 2.344 16.97 7.031l29.69 29.69l79.13-92.34c4.759-5.532 11.48-8.362 18.24-8.362C346.4 176 352 192.6 352 200z"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-credit-card-front",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "credit-card-front",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 32h-448c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM63.1 272c0-8.838 7.164-16 16-16h96c8.836 0 16 7.162 16 16v32c0 8.836-7.164 16-16 16h-96c-8.836 0-16-7.164-16-16V272zM160 408C160 412.4 156.4 416 152 416h-80C67.58 416 64 412.4 64 408l0-16c0-4.42 3.582-8 8-8h80c4.418 0 8 3.58 8 8L160 408zM352 408c0 4.418-3.582 8-8 8h-144C195.6 416 192 412.4 192 408l0-16c0-4.42 3.582-8 8-8h143.1c4.418 0 8 3.58 8 8L352 408zM384 304c0 8.836-7.164 16-16 16h-128c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 15.1-16h128c8.836 0 16 7.162 16 16L384 304zM512 304c0 8.836-7.164 16-16 16h-64C423.2 320 416 312.8 416 304l0-32c0-8.838 7.164-16 16-16H496C504.8 256 512 263.2 512 272V304zM512 176C512 184.8 504.8 192 496 192h-96c-8.836 0-16-7.164-16-16v-64c0-8.838 7.164-16 16-16H496C504.8 96 512 103.2 512 112V176z"
    }
  })]), _vm._v(" "), _c('strong', [_vm._v("SECURE")]), _vm._v(" PAY\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area"
  }, [_c('div', {
    attrs: {
      "id": "stripePaymentIframe"
    },
    on: {
      "mousedown": function($event) {
        return _vm.paymentIframeActioned()
      }
    }
  }, [_c('iframe', {
    attrs: {
      "src": _vm.stripeBillingUrl
    }
  })]), _vm._v(" "), (_vm.payment.error) ? _c('div', {
    staticClass: "card-payment-area--error"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-error"
    }
  }, [_vm._v(_vm._s(_vm.payment.error))])]) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "billingContact",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'billingContact' || _vm.canEditBillingContact,
      'no-margin-top': !(_vm.currentPlan && _vm.currentPlan.plan)
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditBillingContact === false) ? [_vm._v("Billing contact")] : [_vm._v("Edit billing contact")]], 2), _vm._v(" "), (_vm.canEditBillingContact === false && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditBillingContact()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "billing-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.firstName),
      expression: "company.billingContactData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "billing-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.company.billingContactData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "billing-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.phone),
      expression: "company.billingContactData.phone"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.phone !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "billing-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.company.billingContactData.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "billing-first-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.lastName),
      expression: "company.billingContactData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "billing-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.company.billingContactData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.email),
      expression: "company.billingContactData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.email !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.company.billingContactData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditBillingContact && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditBillingContact()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyBillingContactData()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "billingDetails",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'billingDetails' || _vm.canEditBillingDetails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditBillingDetails === false) ? [_vm._v("Billing details")] : [_vm._v("Edit billing details")]], 2), _vm._v(" "), (_vm.canEditBillingDetails === false && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditBillingDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation"
    }
  }, [_vm._v("Organisation name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.organisationName),
      expression: "company.billingDetailsData.organisationName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing organisation name'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.organisationName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-organisation",
      "name": "Billing organisation name"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.organisationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "organisationName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation-type"
    }
  }, [_vm._v("Organisation type*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Billing organisation type'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.organisationType !== null
    }],
    attrs: {
      "disabled": _vm.canEditBillingDetails === false,
      "searchable": true,
      "clearable": false,
      "options": _vm.companyOrganizationTypes,
      "data-lpignore": "true",
      "name": "Organisation type",
      "id": "complete-profile-billing-organisation-type"
    },
    model: {
      value: (_vm.company.billingDetailsData.organisationType),
      callback: function($$v) {
        _vm.$set(_vm.company.billingDetailsData, "organisationType", $$v)
      },
      expression: "company.billingDetailsData.organisationType"
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation type')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-vat"
    }
  }, [_vm._v("VAT")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.organisationVat),
      expression: "company.billingDetailsData.organisationVat"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('VAT'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.organisationVat !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-vat",
      "name": "VAT"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.organisationVat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "organisationVat", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('VAT')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('VAT')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-county"
    }
  }, [_vm._v("County/State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressCounty),
      expression: "company.billingDetailsData.addressCounty"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('County/State'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressCounty !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-county",
      "name": "County/State"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressCounty", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('County/State')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('County/State')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-street"
    }
  }, [_vm._v("Street address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressStreet),
      expression: "company.billingDetailsData.addressStreet"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Street address'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressStreet !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-street",
      "name": "Street address"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressStreet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressStreet", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Street address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Street address')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-postal-code"
    }
  }, [_vm._v("Postcode*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressPostalCode),
      expression: "company.billingDetailsData.addressPostalCode"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Postcode'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressPostalCode !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-postal-code",
      "name": "Postcode"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressPostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Postcode')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Postcode')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-city"
    }
  }, [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressCity),
      expression: "company.billingDetailsData.addressCity"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('City'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressCity !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-city",
      "name": "City"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressCity", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('City')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('City')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-country"
    }
  }, [_vm._v("Country*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressCountry),
      expression: "company.billingDetailsData.addressCountry"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Country'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressCountry !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-country",
      "name": "Country"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressCountry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressCountry", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Country')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Country')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditBillingDetails && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditBillingDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyBillingDetailsData()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), (_vm.invoices && _vm.invoices.length > 0) ? _c('div', {
    ref: "billingInvoices",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'billingInvoices'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n              Documents\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data border-1-20"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice, i) {
    return _c('tr', {
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.downloadInvoice(invoice.id)
        }
      }
    }, [_c('td', {
      staticClass: "created-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Invoice number:"
      }
    }, [_vm._v(_vm._s(invoice.columns.number ? invoice.columns.number : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "last-login-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Issue date:"
      }
    }, [_vm._v(_vm._s(invoice.columns.issueDate ? _vm.convertDate(invoice.columns.issueDate.text, '.') : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "created-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Billed:"
      }
    }, [_vm._v(_vm._s(invoice.columns.billed ? ('£' + invoice.columns.billed) : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "status-cell cellpadding text-center border-1-20",
      class: [{
        expired: invoice.columns.expired
      }],
      attrs: {
        "data-title": "Status:"
      }
    }, [_vm._v(_vm._s(invoice.columns.status ? invoice.columns.status : 'n/a'))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Card details")]), _vm._v(" "), _c('p', [_vm._v("\n                    Please fill in the fields below with the required details. Learn more about each section by tapping the ‘i’ icon next to the field label."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "table-head-mobile-custom background-1-40-before border-1-40"
  }, [_c('tr', [_c('th', {
    staticClass: "column-created-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Document number\n                  ")])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Issue date\n                  ")])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Amount\n                  ")])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Status\n                  ")])])])])
}]}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Logs")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "email-logs",
    attrs: {
      "to": {
        name: 'email-logs'
      }
    }
  }, [_vm._v("Email logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": {
        name: 'consent-logs'
      }
    }
  }, [_vm._v("Consent logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "ttd-logs active",
    attrs: {
      "to": {
        name: 'logs'
      }
    }
  }, [_vm._v("Logs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [(!_vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-statusbar",
    staticStyle: {
      "margin": "0 15px 20px"
    }
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.logsCount) + " logs")])]) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.logs.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [((_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) && _vm.selectedFilters.length) ? _c('tr', {
    staticClass: "inside-table-filters"
  }, [_c('th', {
    attrs: {
      "colspan": "9"
    }
  }, [_c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getUsersForSelect),
        'locked-ceil-head': _vm.userFilterLocked
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(1)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getUsersForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 1),
      expression: "filerTableHead.selectedCeil === 1"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-1",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getUsersForSelect
    },
    model: {
      value: (_vm.logsUser),
      callback: function($$v) {
        _vm.logsUser = $$v
      },
      expression: "logsUser"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getEmailsForSelect),
        'locked-ceil-head': _vm.emailFilterLocked
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getEmailsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getEmailsForSelect
    },
    model: {
      value: (_vm.logsEmail),
      callback: function($$v) {
        _vm.logsEmail = $$v
      },
      expression: "logsEmail"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-role-head table-head-hover table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect),
        'locked-ceil-head': _vm.companyFilterLocked
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getCompaniesForSelect
    },
    model: {
      value: (_vm.logsCompany),
      callback: function($$v) {
        _vm.logsCompany = $$v
      },
      expression: "logsCompany"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getActionsForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getActionsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getActionsForSelect
    },
    model: {
      value: (_vm.logsAction),
      callback: function($$v) {
        _vm.logsAction = $$v
      },
      expression: "logsAction"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy(true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.logOrderBy !== null && this.logOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.logOrderBy !== null && !this.logOrderBy.order
    }
  })])])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log, i) {
    return _c('tr', [_c('td', {
      staticClass: "name-cell cellpadding",
      attrs: {
        "data-title": "User:"
      }
    }, [_vm._v(_vm._s(_vm.getUser(log)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Email:"
      }
    }, [_vm._v(_vm._s(_vm.getEmail(log)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Company:"
      }
    }, [_vm._v(_vm._s(log.companyName ? log.companyName : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "role-cell cellpadding",
      attrs: {
        "data-title": "Action:"
      }
    }, [_vm._v(_vm._s(_vm.getActionName(log)))]), _vm._v(" "), _c('td', {
      staticClass: "created-cell cellpadding text-center",
      attrs: {
        "data-title": "Date and time:"
      }
    }, [_vm._v(_vm._s(_vm.convertDate(log.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "last-login-cell cellpadding text-center",
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "data-title": "Details:"
      }
    }, [_vm._v(_vm._s(log.action ? log.action : 'n/a'))])])
  }), 0)]), _vm._v(" "), (this.logs.length < this.logsCount) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(6), _vm._v("Load more\n        ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("User")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Date and time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "column-active-head table-head-ceil"
  }, [_c('div', {
    staticClass: "caption-head"
  }, [_c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Details")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-page"
  }, [_c('tasks-list', {
    attrs: {
      "company": _vm.companyId
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile"
  }, [(!_vm.registrationCompleted) ? [_c('div', {
    staticClass: "complete-profile__progress",
    attrs: {
      "role": "group",
      "aria-label": "Complete you profile steps"
    }
  }, [_c('div', {
    staticClass: "complete-profile__progress-wrapper"
  }, [_c('ol', {
    staticClass: "complete-profile__progress-tracker"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('li', {
      staticClass: "complete-profile__progress-step",
      class: [{
        'is-completed': _vm.currentRealStep > index,
        'not-completed': _vm.currentRealStep <= index,
        'is-active': _vm.currentStep === index
      }],
      attrs: {
        "id": 'step-' + index,
        "aria-current": _vm.currentStep === index ? 'step' : null
      }
    }, [_c('button', {
      class: [{
        'not-clickable': index > _vm.currentRealStep
      }],
      attrs: {
        "aria-disabled": index > _vm.currentRealStep,
        "disabled": index > _vm.currentRealStep
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.activateStep(index)
        }
      }
    }, [_c('span', {
      staticClass: "complete-profile__progress-step--icon"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-check fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M480.1 128.1l-272 272C204.3 405.7 198.2 408 192 408s-12.28-2.344-16.97-7.031l-144-144c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L192 350.1l255-255c9.375-9.375 24.56-9.375 33.94 0S490.3 119.6 480.1 128.1z"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "complete-profile__progress-step--text"
    }, [_vm._v("\n                  " + _vm._s(index + 1)), _c('span', {
      staticClass: "complete-profile__progress-step--total"
    }, [_vm._v(" of " + _vm._s(_vm.steps.length))]), _vm._v(". " + _vm._s(step.name) + "\n                ")]), _vm._v(" "), (_vm.currentRealStep > index) ? _c('span', {
      staticClass: "sr-only"
    }, [_vm._v("\n                  completed\n                ")]) : (_vm.currentRealStep <= index) ? _c('span', {
      staticClass: "sr-only"
    }, [_vm._v("\n                  not completed\n                ")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), (_vm.currentStep === 0 || _vm.currentStep === 1 || _vm.currentStep === 2 || _vm.currentStep === 4) ? [_c('div', {
    staticClass: "complete-profile__content"
  }, [(_vm.currentStep === 0) ? [_vm._m(0), _vm._v(" "), (_vm.formReady) ? _c('div', {
    staticClass: "complete-profile__content--form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.firstName),
      expression: "profileData.user.firstName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'not-empty': _vm.profileData.user.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-name",
      "placeholder": "Type in here...",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.profileData.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.lastName),
      expression: "profileData.user.lastName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'not-empty': _vm.profileData.user.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-surname",
      "placeholder": "Type in here...",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.profileData.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-email"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.email),
      expression: "profileData.user.email"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required|email'),
      expression: "'required|email'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled is-blocked",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'not-empty': _vm.profileData.user.email !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": true,
      "data-lpignore": "true",
      "id": "complete-profile-email",
      "placeholder": "Type in here...",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.profileData.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-field-tooltip"
  }, [_vm._v("This can't be edited")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-phone"
    }
  }, [_vm._v("Phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.phone),
      expression: "profileData.user.phone"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'not-empty': _vm.profileData.user.phone !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-phone",
      "placeholder": "Type in here...",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.profileData.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-title"
    }
  }, [_vm._v("Job title*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.jobTitle),
      expression: "profileData.user.jobTitle"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Job title'),
      'not-empty': _vm.profileData.user.jobTitle !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "placeholder": "Type in (e.g. Diversity Director)",
      "id": "complete-profile-title",
      "name": "Job title"
    },
    domProps: {
      "value": (_vm.profileData.user.jobTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "jobTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Job title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Job title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-function"
    }
  }, [_vm._v("Functional area*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Functional area'),
      'not-empty': _vm.profileData.user.function !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.userFunctionalAreas,
      "data-lpignore": "true",
      "placeholder": "Start typing in...",
      "name": "Functional area",
      "id": "complete-profile-function"
    },
    model: {
      value: (_vm.profileData.user.function),
      callback: function($$v) {
        _vm.$set(_vm.profileData.user, "function", $$v)
      },
      expression: "profileData.user.function"
    }
  }), _vm._v(" "), (this.errors.has('Functional area')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Functional area')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("All fields marked with an asterisk (*) are mandatory.")])]) : _vm._e()] : (_vm.currentStep === 1) ? [_vm._m(1), _vm._v(" "), (_vm.formReady) ? _c('div', {
    staticClass: "complete-profile__content--form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-organisation"
    }
  }, [_vm._v("Organisation name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.organisation.name),
      expression: "profileData.organisation.name"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Organisation name'),
      'not-empty': _vm.profileData.organisation.name !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-organisation",
      "placeholder": "Type in here...",
      "name": "Organisation name"
    },
    domProps: {
      "value": (_vm.profileData.organisation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.organisation, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Organisation name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-size"
    }
  }, [_vm._v("Organisation size*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Organisation size'),
      'not-empty': _vm.profileData.organisation.size !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.companySizes,
      "value": _vm.filteredCompanySizes && _vm.filteredCompanySizes.length ? _vm.filteredCompanySizes[0].value : null,
      "data-lpignore": "true",
      "name": "Organisation size",
      "placeholder": "Start typing in...",
      "id": "complete-profile-size"
    },
    model: {
      value: (_vm.profileData.organisation.size),
      callback: function($$v) {
        _vm.$set(_vm.profileData.organisation, "size", $$v)
      },
      expression: "profileData.organisation.size"
    }
  }), _vm._v(" "), (this.errors.has('Organisation size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation size')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-industry"
    }
  }, [_vm._v("Industry sector*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Industry sector'),
      'not-empty': _vm.profileData.organisation.industrySector !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.userIndustrySectors,
      "data-lpignore": "true",
      "placeholder": "Start typing in...",
      "name": "Industry sector",
      "id": "complete-profile-industry"
    },
    model: {
      value: (_vm.profileData.organisation.industrySector),
      callback: function($$v) {
        _vm.$set(_vm.profileData.organisation, "industrySector", $$v)
      },
      expression: "profileData.organisation.industrySector"
    }
  }), _vm._v(" "), (this.errors.has('Industry sector')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry sector')))]) : _vm._e()], 1), _vm._v(" "), (_vm.profileData.organisation.marketplace) ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-marketplace"
    }
  }, [_vm._v("Clear Assured marketplace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.organisation.marketplace),
      expression: "profileData.organisation.marketplace"
    }],
    staticClass: "form-control form-control__input is-blocked background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Clear Assured marketplace'),
      'not-empty': _vm.profileData.organisation.marketplace !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": true,
      "data-lpignore": "true",
      "id": "complete-profile-marketplace",
      "placeholder": "Type in here...",
      "name": "Clear Assured marketplace"
    },
    domProps: {
      "value": (_vm.profileData.organisation.marketplace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.organisation, "marketplace", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Clear Assured marketplace')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Clear Assured marketplace')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("All fields marked with an asterisk (*) are mandatory.")])]) : _vm._e()] : (_vm.currentStep === 2) ? [_vm._m(2), _vm._v(" "), (_vm.formReady) ? _c('div', {
    staticClass: "complete-profile__content--form"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.firstName),
      expression: "profileData.billing.firstName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing first name'),
      'not-empty': _vm.profileData.billing.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-name",
      "placeholder": "Type in here...",
      "name": "Billing first name"
    },
    domProps: {
      "value": (_vm.profileData.billing.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing first name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing first name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.lastName),
      expression: "profileData.billing.lastName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing last name'),
      'not-empty': _vm.profileData.billing.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-surname",
      "placeholder": "Type in here...",
      "name": "Billing last name"
    },
    domProps: {
      "value": (_vm.profileData.billing.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing last name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-email"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.email),
      expression: "profileData.billing.email"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing email'),
      'not-empty': _vm.profileData.billing.email !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-email",
      "placeholder": "Type in here...",
      "name": "Billing email"
    },
    domProps: {
      "value": (_vm.profileData.billing.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-phone"
    }
  }, [_vm._v("Phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.phone),
      expression: "profileData.billing.phone"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing phone number'),
      'not-empty': _vm.profileData.billing.phone !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-phone",
      "placeholder": "Type in here...",
      "name": "Billing phone number"
    },
    domProps: {
      "value": (_vm.profileData.billing.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__separator"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation"
    }
  }, [_vm._v("Organisation name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.organisationName),
      expression: "profileData.billing.organisationName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing organisation name'),
      'not-empty': _vm.profileData.billing.organisationName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-organisation",
      "placeholder": "Type in here...",
      "name": "Billing organisation name"
    },
    domProps: {
      "value": (_vm.profileData.billing.organisationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "organisationName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation-type"
    }
  }, [_vm._v("Organisation type*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Billing organisation type'),
      'not-empty': _vm.profileData.billing.organisationType !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.companyOrganizationTypes,
      "data-lpignore": "true",
      "name": "Billing organisation type",
      "placeholder": "Start typing in...",
      "id": "complete-profile-billing-organisation-type"
    },
    model: {
      value: (_vm.profileData.billing.organisationType),
      callback: function($$v) {
        _vm.$set(_vm.profileData.billing, "organisationType", $$v)
      },
      expression: "profileData.billing.organisationType"
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation type')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-vat"
    }
  }, [_vm._v("VAT")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.organisationVat),
      expression: "profileData.billing.organisationVat"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('VAT'),
      'not-empty': _vm.profileData.billing.organisationVat !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-vat",
      "placeholder": "Type in here...",
      "name": "VAT"
    },
    domProps: {
      "value": (_vm.profileData.billing.organisationVat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "organisationVat", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('VAT')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('VAT')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-county"
    }
  }, [_vm._v("County/State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressCounty),
      expression: "profileData.billing.addressCounty"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('County/State'),
      'not-empty': _vm.profileData.billing.addressCounty !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-county",
      "placeholder": "Type in here...",
      "name": "County/State"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressCounty", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('County/State')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('County/State')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-street"
    }
  }, [_vm._v("Street address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressStreet),
      expression: "profileData.billing.addressStreet"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Street address'),
      'not-empty': _vm.profileData.billing.addressStreet !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-street",
      "placeholder": "Type in here...",
      "name": "Street address"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressStreet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressStreet", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Street address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Street address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-postal-code"
    }
  }, [_vm._v("Postcode*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressPostalCode),
      expression: "profileData.billing.addressPostalCode"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Postcode'),
      'not-empty': _vm.profileData.billing.addressPostalCode !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-postal-code",
      "placeholder": "Type in here...",
      "name": "Postcode"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressPostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Postcode')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Postcode')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-city"
    }
  }, [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressCity),
      expression: "profileData.billing.addressCity"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('City'),
      'not-empty': _vm.profileData.billing.addressCity !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-city",
      "placeholder": "Type in here...",
      "name": "City"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressCity", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('City')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('City')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-country"
    }
  }, [_vm._v("Country*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Country'),
      'not-empty': _vm.profileData.billing.addressCountry !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.countries,
      "data-lpignore": "true",
      "name": "Country",
      "placeholder": "Start typing in...",
      "id": "complete-profile-billing-address-country"
    },
    model: {
      value: (_vm.profileData.billing.addressCountry),
      callback: function($$v) {
        _vm.$set(_vm.profileData.billing, "addressCountry", $$v)
      },
      expression: "profileData.billing.addressCountry"
    }
  }), _vm._v(" "), (this.errors.has('Country')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Country')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("All fields marked with an asterisk (*) are mandatory.")])]) : _vm._e()] : (_vm.currentStep === 4) ? [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__payment-methods"
  }, _vm._l((_vm.paymentMethods), function(paymentMethod) {
    return _c('div', {
      staticClass: "form-group"
    }, [(_vm.companyVariation && ((paymentMethod.value === 0 && _vm.companyVariation.ccPayment) || (paymentMethod.value === 1 && _vm.companyVariation.poPayment))) ? _c('div', {
      staticClass: "form-control form-control__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileData.payment.method),
        expression: "profileData.payment.method"
      }],
      attrs: {
        "type": "radio",
        "data-lpignore": "true",
        "id": 'complete-profile-payment-method' + paymentMethod.value,
        "name": "Payment method"
      },
      domProps: {
        "checked": _vm.profileData.payment.method === paymentMethod.value ? 'checked' : null,
        "value": paymentMethod.value,
        "checked": _vm._q(_vm.profileData.payment.method, paymentMethod.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.profileData.payment, "method", paymentMethod.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'complete-profile-payment-method' + paymentMethod.value
      }
    }, [_vm._v(_vm._s(paymentMethod.label))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data__wrapper"
  }, [(_vm.currentPlan) ? [_c('div', {
    staticClass: "subscription__plan-data"
  }, [_c('h3', {
    staticClass: "subscription__plan-data--title"
  }, [_vm._v("\n                      Plan summary\n                    ")]), _vm._v(" "), (_vm.currentPlan.plan) ? _c('p', {
    staticClass: "subscription__plan-data--text"
  }, [_vm._v("\n                      You pay "), _c('strong', [_vm._v("£" + _vm._s(_vm.planPrice) + " "), (_vm.vatDisplay) ? [_vm._v("(including VAT)")] : _vm._e(), _vm._v(" / " + _vm._s(_vm.currentPlanSubscriptionPaymentPeriod))], 2), _vm._v(" via "), (_vm.profileData.payment.method === 0) ? [_vm._v("Credit Card")] : [_vm._v("Bank Transfer")], _vm._v(" for your "), _c('strong', [_vm._v(_vm._s(_vm.currentPlan.plan.name) + " plan for " + _vm._s(_vm.currentPlanSize) + " organisations")]), _vm._v(".\n                    ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Billing period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanPaymentPeriod))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Commitment period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanCommitment))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Active until")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.commitmentExpiryDate))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Next payment date")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.nextPaymentDate))])])])])] : [_vm._m(7)]], 2), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__payment-terms"
  }, [_c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Terms of service")]), _vm._v(" "), (_vm.profileData.payment.method === 0) ? _c('p', [_vm._v("Before paying and starting to use our services you must read and accept our terms of service. Once you do so we will allow you to enter your card details to finish creating your account.")]) : _c('p', [_vm._v("Please confirm that you've read and you accept our terms of service. Once you do so we will provide you with a quote that includes payment instructions and a white-paper that may come in handy when discussing the business case with your colleagues.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element terms-of-service"
  }, [(!_vm.profileData.payment.paymentAreaActivated) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.payment.termsOfService),
      expression: "profileData.payment.termsOfService"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Terms of service'),
      'not-empty': _vm.profileData.payment.termsOfService !== null
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "disabled": _vm.profileData.payment.paymentAreaActivated,
      "id": "complete-profile-terms-of-service",
      "name": "Terms of service"
    },
    domProps: {
      "checked": _vm.profileData.payment.termsOfService ? 'checked' : null,
      "checked": Array.isArray(_vm.profileData.payment.termsOfService) ? _vm._i(_vm.profileData.payment.termsOfService, null) > -1 : (_vm.profileData.payment.termsOfService)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profileData.payment.termsOfService,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profileData.payment, "termsOfService", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profileData.payment, "termsOfService", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profileData.payment, "termsOfService", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "complete-profile-terms-of-service"
    }
  }, [_vm._v("\n                        I have read, I understood and I accept the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'terms-of-service'
      }
    }
  }, [_vm._v("Clear Assured terms of service")]), _vm._v(".\n                      ")], 1)] : _vm._e(), _vm._v(" "), (this.errors.has('Terms of service')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("You must accept our terms and conditions in order to move on to the next step")]) : _vm._e(), _vm._v(" "), (_vm.profileData.payment.paymentAreaActivated && _vm.profileData.payment.method === 0) ? _c('span', {
    staticClass: "form-field-success"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'terms-of-service'
      }
    }
  }, [_vm._v("Terms of service")]), _vm._v(" accepted on: " + _vm._s(_vm.convertDateTime(_vm.profileData.payment.termsOfServiceAccepted)))], 1) : _vm._e()], 2)])]), _vm._v(" "), (!_vm.profileData.payment.paymentAreaActivated || _vm.profileData.payment.method === 1) ? _c('button', {
    staticClass: "card-payment-area--button",
    class: [{
      'submitting': _vm.submitting
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.activatePaymentArea()
      }
    }
  }, [(_vm.profileData.payment.method === 0) ? [_vm._v("\n                  Go to payment\n                ")] : [_vm._v("\n                  Get quote\n                ")]], 2) : _vm._e(), _vm._v(" "), (_vm.profileData.payment.paymentAreaActivated && _vm.companyVariation && _vm.profileData.payment.method === 0 && _vm.companyVariation.ccPayment) ? [_c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area--info"
  }, [_c('div', {
    staticClass: "card-payment-area--info__secure-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-shield-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "shield-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M466.5 83.71l-192-80c-4.875-2.031-13.16-3.703-18.44-3.703c-5.312 0-13.55 1.672-18.46 3.703L45.61 83.71C27.7 91.1 16 108.6 16 127.1C16 385.2 205.2 512 255.9 512C307.1 512 496 383.8 496 127.1C496 108.6 484.3 91.1 466.5 83.71zM352 200c0 5.531-1.901 11.09-5.781 15.62l-96 112C243.5 335.5 234.6 335.1 232 335.1c-6.344 0-12.47-2.531-16.97-7.031l-48-48C162.3 276.3 160 270.1 160 263.1c0-12.79 10.3-24 24-24c6.141 0 12.28 2.344 16.97 7.031l29.69 29.69l79.13-92.34c4.759-5.532 11.48-8.362 18.24-8.362C346.4 176 352 192.6 352 200z"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-credit-card-front",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "credit-card-front",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 32h-448c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM63.1 272c0-8.838 7.164-16 16-16h96c8.836 0 16 7.162 16 16v32c0 8.836-7.164 16-16 16h-96c-8.836 0-16-7.164-16-16V272zM160 408C160 412.4 156.4 416 152 416h-80C67.58 416 64 412.4 64 408l0-16c0-4.42 3.582-8 8-8h80c4.418 0 8 3.58 8 8L160 408zM352 408c0 4.418-3.582 8-8 8h-144C195.6 416 192 412.4 192 408l0-16c0-4.42 3.582-8 8-8h143.1c4.418 0 8 3.58 8 8L352 408zM384 304c0 8.836-7.164 16-16 16h-128c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 15.1-16h128c8.836 0 16 7.162 16 16L384 304zM512 304c0 8.836-7.164 16-16 16h-64C423.2 320 416 312.8 416 304l0-32c0-8.838 7.164-16 16-16H496C504.8 256 512 263.2 512 272V304zM512 176C512 184.8 504.8 192 496 192h-96c-8.836 0-16-7.164-16-16v-64c0-8.838 7.164-16 16-16H496C504.8 96 512 103.2 512 112V176z"
    }
  })]), _vm._v(" "), _c('strong', [_vm._v("SECURE")]), _vm._v(" PAY\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area"
  }, [_c('div', {
    attrs: {
      "id": "stripePaymentIframe"
    },
    on: {
      "mousedown": function($event) {
        return _vm.paymentIframeActioned()
      }
    }
  }, [_c('iframe', {
    style: ({
      'pointer-events': _vm.profileData.payment.termsOfService ? 'all' : 'none'
    }),
    attrs: {
      "src": _vm.stripeBillingUrl
    }
  })]), _vm._v(" "), (_vm.profileData.payment.error) ? _c('div', {
    staticClass: "card-payment-area--error"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-error"
    }
  }, [_vm._v(_vm._s(_vm.profileData.payment.error))])]) : _vm._e()])] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--actions"
  }, [_c('div', [(this.currentStep > 0) ? _c('button', {
    staticClass: "previous-step-btn",
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("Previous step")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.currentStep !== 4) ? _c('button', {
    staticClass: "next-step-btn",
    class: [{
      'submitting': _vm.submitting
    }],
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.preSubmitData()
      }
    }
  }, [_vm._v("\n                Next step\n              ")]) : _vm._e()])])], 2)] : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? [(_vm.planChanged || _vm.noPlans) ? _c('div', {
    staticClass: "company-warning-message",
    class: [{
      error: _vm.noPlans
    }]
  }, [_c('div', {
    staticClass: "company-warning-message--container"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--text"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-triangle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "triangle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"
    }
  })]), _vm._v(" "), (_vm.noPlans) ? [_vm._v("\n                Our current offer doesn't include any plans that fit the size and the type of your organisation. Please "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("get in touch")]), _vm._v(" to discuss your licensing needs.\n              ")] : [_vm._v("\n                The plan you initially selected is no longer available because it doesn't match your organisation profile. Please choose one of the plans below.\n              ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--action"
  }, [(!_vm.noPlans) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.planChanged = false
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })]), _vm._v("\n                Ok, close this")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.noPlans) ? _c('div', {
    staticClass: "complete-profile__content--current-plan"
  }, [_c('plans-list', {
    attrs: {
      "title": "Choose your plan",
      "subtitle": "Here are the plans that match the type and the size of your organisation. Choose the one that’s best for you and keep in mind that you can upgrade anytime you want.",
      "current-plan": _vm.currentPlan,
      "current-variation": _vm.temporaryVariation,
      "vat-display": _vm.vatDisplay,
      "submitting": _vm.submitting,
      "pre-selected-size": _vm.preSelectedSize,
      "heading-type": 'h1'
    },
    on: {
      "plan-selected": function($event) {
        return _vm.planSelected($event)
      },
      "plans-loaded": function($event) {
        return _vm.plansLoaded($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "complete-profile__content--current-plan__previous-step",
    on: {
      "click": _vm.previousStep
    }
  }, [_vm._v("Previous step")])], 1) : _vm._e()] : _vm._e()] : [(_vm.profileData.payment.method === 0) ? [_c('div', {
    staticClass: "complete-profile__content--success__wrapper"
  }, [_c('div', {
    staticClass: "complete-profile__content--success"
  }, [_c('h1', {
    staticClass: "complete-profile__content--success__title"
  }, [_c('span', {
    staticClass: "complete-profile__content--success__title--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
    }
  })])]), _vm._v("\n              You completed your registration. Let's get to work!\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n              Start by "), _c('router-link', {
    attrs: {
      "to": {
        name: 'tour-wizard',
        params: {
          id: 'manager-onboarding-tour'
        }
      }
    }
  }, [_vm._v("taking the onboarding tour")]), _vm._v(" to get familiar with the application. When ready, jump into your dashboard and start working on your onboarding tasks.\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__boxes"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-street-view",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fal",
      "data-icon": "street-view",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 128c35.38 0 64-28.62 64-64s-28.62-64-64-64S192 28.62 192 64S220.6 128 256 128zM256 32c17.64 0 32 14.36 32 32s-14.36 32-32 32S224 81.64 224 64S238.4 32 256 32zM192 304l12.5 99.97C206.5 419.1 220.1 432 236.2 432h39.5c16.14 0 29.75-12.02 31.75-28.03L320 304c17.67 0 32-14.33 32-32V224c0-35.35-28.65-64-64-64H224C188.7 160 160 188.7 160 224v48C160 289.7 174.3 304 192 304zM192 224c0-17.64 14.36-32 32-32h64c17.64 0 32 14.36 32 32v48h-28.25l-16 128h-39.5l-16-128H192V224zM386.1 347.4c-8.891-1.625-17.06 4.062-18.7 12.75s4.062 17.03 12.73 18.69C453.1 392.5 480 413.8 480 424c0 19-79.06 56-224 56s-224-37-224-56c0-10.22 26.88-31.53 98.98-45.19c8.672-1.656 14.38-10 12.73-18.69c-1.625-8.688-9.906-14.28-18.7-12.75C78.33 356.2 0 377.9 0 424C0 481.8 128.8 512 256 512s256-30.22 256-88C512 377.9 433.7 356.2 386.1 347.4z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [_vm._v("\n                  Take the onboarding tour\n                ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('router-link', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "to": {
        name: 'tour-wizard',
        params: {
          id: 'manager-onboarding-tour'
        }
      }
    }
  }, [_vm._v("Take the Tour")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-home-lg-alt fa-w-18",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fal",
      "data-icon": "home-lg-alt",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M573.48 219.91L310.6 8a35.85 35.85 0 0 0-45.19 0L2.53 219.91a6.71 6.71 0 0 0-1 9.5l14.2 17.5a6.82 6.82 0 0 0 9.6 1L64 216.72V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V216.82l38.8 31.29a6.83 6.83 0 0 0 9.6-1l14.19-17.5a7.14 7.14 0 0 0-1.11-9.7zM240 480V320h96v160zm240 0H368V304a16 16 0 0 0-16-16H224a16 16 0 0 0-16 16v176H96V190.92l187.71-151.4a6.63 6.63 0 0 1 8.4 0L480 191z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [_vm._v("\n                  Go to your dashboard\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [_vm._v("\n                  Go to your dashboard and start working on your onboarding tasks.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('router-link', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")])], 1)])])])])] : [_c('div', {
    staticClass: "complete-profile__content--success__wrapper"
  }, [_c('div', {
    staticClass: "complete-profile__content--success"
  }, [_c('h1', {
    staticClass: "complete-profile__content--success__title"
  }, [_c('span', {
    staticClass: "complete-profile__content--success__title--icon",
    class: [{
      'po-payment': _vm.profileData.payment.method === 1
    }]
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "42",
      "height": "42",
      "viewBox": "0 0 42 42"
    }
  }, [_c('g', {
    attrs: {
      "id": "Check-AlmostDone",
      "transform": "translate(-493 -255)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Union_20",
      "data-name": "Union 20",
      "d": "M-8872.443-10562.139a21.881,21.881,0,0,1-4.748-6.66,19.632,19.632,0,0,1-1.809-8.2,21.169,21.169,0,0,1,6.139-14.445,21.906,21.906,0,0,1,6.66-4.747,19.634,19.634,0,0,1,8.2-1.809c.349,0,.705.011,1.059.032a1,1,0,0,1,.939,1.056,1,1,0,0,1-1,.941h-.061c-.314-.019-.631-.029-.939-.029a17.624,17.624,0,0,0-7.37,1.628,19.887,19.887,0,0,0-6.054,4.316A19.159,19.159,0,0,0-8877-10577a17.622,17.622,0,0,0,1.628,7.368,19.871,19.871,0,0,0,4.316,6.053A19.156,19.156,0,0,0-8858-10558a17.622,17.622,0,0,0,7.368-1.628,19.854,19.854,0,0,0,6.053-4.316A19.157,19.157,0,0,0-8839-10577a1,1,0,0,1,1-1,1,1,0,0,1,1,1,21.167,21.167,0,0,1-6.139,14.442,21.886,21.886,0,0,1-6.66,4.748,19.632,19.632,0,0,1-8.2,1.809A21.169,21.169,0,0,1-8872.443-10562.139Zm32.465-20.613c-.1-.3-.216-.6-.336-.889a1,1,0,0,1,.551-1.3,1,1,0,0,1,1.3.551c.13.324.255.654.369.983a1,1,0,0,1-.617,1.271.933.933,0,0,1-.327.056A1,1,0,0,1-8839.979-10582.752Zm-3.852-6.508c-.208-.237-.429-.472-.649-.7a1,1,0,0,1,.021-1.412,1,1,0,0,1,1.412.019c.242.25.481.508.713.766a1,1,0,0,1-.085,1.413,1,1,0,0,1-.662.25A1,1,0,0,1-8843.83-10589.26Zm-5.987-4.666c-.279-.144-.569-.284-.854-.415a1,1,0,0,1-.5-1.324,1,1,0,0,1,1.327-.494c.314.144.631.3.939.457a1,1,0,0,1,.431,1.349,1,1,0,0,1-.889.54A1,1,0,0,1-8849.817-10593.926Z",
      "transform": "translate(9372 10853)",
      "fill": "#4ed7ab"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "check",
      "d": "M16.75,5.5a1.245,1.245,0,0,1-.366.884l-10,10a1.249,1.249,0,0,1-1.767,0l-5-5A1.244,1.244,0,0,1-.75,10.5a1.25,1.25,0,0,1,2.134-.884L5.5,13.734l9.117-9.117A1.248,1.248,0,0,1,16.75,5.5Z",
      "transform": "translate(506 266)",
      "fill": "#4ed7ab"
    }
  })])])]), _vm._v("\n              We're almost there. Your account is now pending payment.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__quote-area"
  }, [(_vm.profileData.quote) ? [_c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n                  Use the button below to download your quote. It contains your plan details, payment instructions and a link to our terms of service. Should you require more information, please get in touch and we’ll be happy to help you.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n                  This page will remain available until we receive your payment. Once we process your payment you will receive an email with your invoice and your account will be automatically activated.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__links quote-final-links"
  }, [_c('button', {
    class: [{
      'submitting': _vm.quoteDownloading && _vm.quoteDownloadActioned
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.quoteDownloading && _vm.quoteDownloadActioned
    },
    on: {
      "click": function($event) {
        return _vm.downloadQuote()
      }
    }
  }, [_c('span', [_c('svg', {
    staticClass: "svg-inline--fa fa-file-invoice",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "file-invoice",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0v128h128L256 0zM288 256H96v64h192V256zM224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM64 72C64 67.63 67.63 64 72 64h80C156.4 64 160 67.63 160 72v16C160 92.38 156.4 96 152 96h-80C67.63 96 64 92.38 64 88V72zM64 136C64 131.6 67.63 128 72 128h80C156.4 128 160 131.6 160 136v16C160 156.4 156.4 160 152 160h-80C67.63 160 64 156.4 64 152V136zM320 440c0 4.375-3.625 8-8 8h-80C227.6 448 224 444.4 224 440v-16c0-4.375 3.625-8 8-8h80c4.375 0 8 3.625 8 8V440zM320 240v96c0 8.875-7.125 16-16 16h-224C71.13 352 64 344.9 64 336v-96C64 231.1 71.13 224 80 224h224C312.9 224 320 231.1 320 240z"
    }
  })])]), _vm._v("\n                    Download quote\n                  ")])])] : [_vm._m(10)]], 2), _vm._v(" "), _c('h2', {
    staticClass: "complete-profile__content--success__subhead"
  }, [_vm._v("The Clear Assured business case")]), _vm._v(" "), _c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n              If you need to present the Clear Assured business case to your colleagues, please use the information and materials from the Clear Assured white-paper or get in touch to ask for our help.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__boxes"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-file-arrow-down",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "file-arrow-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M384 128h-128V0L384 128zM256 160H384v304c0 26.51-21.49 48-48 48h-288C21.49 512 0 490.5 0 464v-416C0 21.49 21.49 0 48 0H224l.0039 128C224 145.7 238.3 160 256 160zM255 295L216 334.1V232c0-13.25-10.75-24-24-24S168 218.8 168 232v102.1L128.1 295C124.3 290.3 118.2 288 112 288S99.72 290.3 95.03 295c-9.375 9.375-9.375 24.56 0 33.94l80 80c9.375 9.375 24.56 9.375 33.94 0l80-80c9.375-9.375 9.375-24.56 0-33.94S264.4 285.7 255 295z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [_vm._v("\n                  The business Case\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [_vm._v("\n                  The white-paper has all the information you need to discuss the Clear Assured business case with your colleagues.\n                ")]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-message-smile",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "message-smile",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M447.1 .0041h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.99c0 9.75 11.25 15.45 19.12 9.7l124.9-93.69h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 .0041 447.1 .0041zM320 112c17.75 0 31.1 14.25 31.1 32s-14.25 31.1-32 31.1S288 161.8 288 144S302.3 112 320 112zM192 112c17.75 0 31.1 14.25 31.1 32S209.8 175.1 192 175.1S160 161.8 160 144S174.3 112 192 112zM362.3 271.3c-26.5 31-65.14 48.74-106.3 48.74c-41.12 0-79.72-17.74-106.2-48.74c-8.5-10-7.5-25.12 2.625-33.75c9.998-8.5 25.25-7.375 33.87 2.75C203.5 260.4 228.9 272 256 272c27.12 0 52.49-11.62 69.74-31.75c8.623-10.12 23.75-11.38 33.74-2.75C369.6 246.1 370.8 261.3 362.3 271.3z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [_vm._v("\n                  Ask us anything\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [_vm._v("\n                  Let us know if you have any questions or if you need any help.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('router-link', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "to": {
        name: 'contact'
      },
      "target": "_blank"
    }
  }, [_vm._v("Get in touch")])], 1)])])])])]], _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Get in touch")])], 1)])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Setup your personal profile")]), _vm._v(" "), _c('p', [_vm._v("\n                Let's get to know eachother better. Please tell us a little bit about yourself.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Setup your organisation profile")]), _vm._v(" "), _c('p', [_vm._v("\n                Workflows and resources are allocated based on organisation sizes and industry sectors. Please ensure that this information is accurate.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Add your billing details")]), _vm._v(" "), _c('p', [_vm._v("\n                Please fill in the forms below so we can send our invoices to the right place.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Billing contact")]), _vm._v(" "), _c('p', [_vm._v("Let us know who will handle billing related queries. We will send all billing related emails to the address below. Please use a mailing list if you want these notifications to reach more than one email.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Organisation details")]), _vm._v(" "), _c('p', [_vm._v("Fill in your organisation billing data. Make sure to use the organisation legal name and a registered address.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Choose your payment method")]), _vm._v(" "), _c('p', [_vm._v("\n                Depending on your chosen plan you will be able to pay by card, bank transfer or both. Your account will be activated automatically as soon as your payment is confirmed.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Choose your payment preferred option")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Card details")]), _vm._v(" "), _c('p', [_vm._v("\n                      Please fill in the fields below with the required details. Learn more about each section by tapping the ‘i’ icon next to the field label."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [_vm._v("\n                  We'll walk you through the main features and explain how things work.\n                  "), _c('span', [_vm._v("10 minutes tour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('a', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "href": "/ClearAssured WhitePaper.pdf",
      "download": "ClearAssured WhitePaper.pdf"
    }
  }, [_vm._v("Download the white-paper")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__title"
  }, [_c('h2', {
    staticClass: "content"
  }, [_vm._v("Do you need our help? "), _c('strong', [_vm._v("Get in touch")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__text"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v("If you're struggling with anything or there's something you'd like to ask us, please get in touch. We look forward to hearing from you.")])])
}]}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backlog-tasks"
  }, [_c('div', {
    staticClass: "backlog-tasks-rows"
  }, [(_vm.backlogTasks) ? _vm._l((_vm.backlogTasks), function(board) {
    return _c('div', {
      staticClass: "backlog-tasks-row",
      class: [{
        active: board.active,
        'active-filters': _vm.hasActiveFilters,
        'empty': !board.tasks.length
      }, board.slug]
    }, [_c('div', {
      staticClass: "backlog-tasks-row-header",
      on: {
        "dragover": function($event) {
          board.active = true
        },
        "click": function($event) {
          return _vm.activateBoard(board)
        }
      }
    }, [_c('div', {
      staticClass: "backlog-tasks-row-title"
    }, [_vm._v("\n              " + _vm._s(board.name) + "\n              "), _c('span', {
      staticClass: "backlog-tasks-row-title-counter"
    }, [(board.slug === 'completed') ? [_vm._v("\n                Showing " + _vm._s(board.tasks.length) + " of\n              ")] : (_vm.hasActiveFilters) ? [_vm._v("\n                " + _vm._s(board.tasks.length) + " of\n              ")] : _vm._e(), _vm._v("\n              " + _vm._s(board.count) + "\n            ")], 2)]), _vm._v(" "), _c('div', {
      staticClass: "backlog-tasks-row-arrow"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "chevron-down",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "backlog-tasks-row-body",
      class: {
        'no-items': !board.tasks.length
      }
    }, [(!board.tasks.length) ? _c('div', {
      staticClass: "no-items-text"
    }, [(_vm.hasActiveFilters) ? [_c('span', [_vm._v("\n                    No items in the list match the filters applied.\n                    "), _c('svg', {
      staticClass: "svg-inline--fa fa-inbox fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "inbox",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0\n                          0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49\n                          48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
      }
    })])])] : [(board.slug !== 'completed') ? [_c('span', [_vm._v("\n                    Drag in here a task from the other lists, start organizing your workspace.\n                    "), _c('svg', {
      staticClass: "svg-inline--fa fa-magic fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "magic",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160\n                          80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432\n                          448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19\n                          0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37\n                          8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
      }
    })])])] : [_c('span', [_vm._v("\n                    Nothing to show here yet. When a task changes the status to 'complete', it will appear here.\n                    "), _c('svg', {
      staticClass: "svg-inline--fa fa-inbox fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "inbox",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0\n                          0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49\n                          48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
      }
    })])])]]], 2) : _vm._e(), _vm._v(" "), _c('draggable', _vm._b({
      staticClass: "backlog-tasks-group",
      attrs: {
        "tag": "ul",
        "draggable": ".task",
        "group": board.slug !== 'completed' ? 'backlogTasks' : 'completedTasks'
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": function($event) {
          _vm.drag = false
        },
        "change": function($event) {
          return _vm.handleChange($event, board)
        }
      },
      model: {
        value: (board.tasks),
        callback: function($$v) {
          _vm.$set(board, "tasks", $$v)
        },
        expression: "board.tasks"
      }
    }, 'draggable', board.slug !== 'completed' ? _vm.dragOptions : _vm.completedDragOptions, false), [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": !_vm.drag ? 'flip-list' : null
      }
    }, _vm._l((board.tasks), function(task) {
      return _c('li', {
        key: task.id,
        staticClass: "backlog-tasks-group-item task",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.goToTask(task.id)
          },
          "dragstart": function($event) {
            return _vm.draggingItem(true)
          },
          "dragend": function($event) {
            return _vm.draggingItem(false)
          },
          "dragover": function($event) {
            return _vm.itemDragOver($event)
          }
        }
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-data"
      }, [_c('span', {
        staticClass: "backlog-tasks-group-item-key",
        class: {
          'line-through': task.status === 4
        }
      }, [_vm._v("\n                      " + _vm._s(task.key) + "\n                    ")]), _vm._v(" "), _c('span', {
        staticClass: "backlog-tasks-group-item-name"
      }, [_vm._v("\n                      " + _vm._s(task.title) + "\n                    ")]), _vm._v(" "), (board.slug !== 'completed' && task.chapter && _vm.getChapterById(task.chapter)) ? _c('div', {
        staticClass: "backlog-tasks-group-item-chapter"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-progress"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-image",
        style: ({
          backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
        })
      }), _vm._v(" "), _c('svg', {
        staticClass: "progress",
        attrs: {
          "width": "130",
          "height": "130",
          "viewBox": "0 0 100 100"
        }
      }, [_c('circle', {
        staticClass: "progress_meter",
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
        staticClass: "progress_value",
        class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-chapter-name"
      }, [_vm._v(_vm._s(_vm.getChapterById(task.chapter)['name']))])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-meta-mobile-chapter"
      }, [(board.slug !== 'completed' && task.chapter && _vm.getChapterById(task.chapter)) ? _c('div', {
        staticClass: "backlog-tasks-group-item-chapter"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-progress"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-image",
        style: ({
          backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
        })
      }), _vm._v(" "), _c('svg', {
        staticClass: "progress",
        attrs: {
          "width": "130",
          "height": "130",
          "viewBox": "0 0 100 100"
        }
      }, [_c('circle', {
        staticClass: "progress_meter",
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
        staticClass: "progress_value",
        class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-chapter-name"
      }, [_vm._v(_vm._s(_vm.getChapterById(task.chapter)['name']))])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta-properties"
      }, [(task.recurrent) ? _c('div', {
        staticClass: "backlog-tasks-group-item-meta-property recurrency"
      }, [_c('svg', {
        staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "sync-alt",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                            53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                            94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                            57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                            0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                            162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                            504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
        }
      })])]) : _vm._e(), _vm._v(" "), (task.mandatory) ? _c('div', {
        staticClass: "backlog-tasks-group-item-meta-property mandatory"
      }, [_c('svg', {
        staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "exclamation-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                            111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                            136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                            0-12.356 5.78-11.981 12.654z"
        }
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta-user-info"
      }, [(board.slug !== 'completed') ? _c('div', {
        staticClass: "backlog-tasks-group-item-meta-user status",
        class: ['status-' + task.status]
      }, [(task.status === 1) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "far",
          "data-icon": "dot-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                                0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                                168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
        }
      })])] : (task.status === 2) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-spinner fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "spinner",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                                368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                                48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                                48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                                0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                                21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
        }
      })])] : (task.status === 3) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-eye fa-w-18",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "far",
          "data-icon": "eye",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 576 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                                55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                                241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                                0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
        }
      })])] : (task.status === 4) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-check-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "far",
          "data-icon": "check-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                                256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                                89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                                303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                                16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
        }
      })])] : _vm._e(), _vm._v(" "), (_vm.getStatusById(task.status)) ? _c('span', {
        staticClass: "status-text"
      }, [_vm._v(_vm._s(_vm.getStatusById(task.status).name))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta-user user-avatar"
      }, [(_vm.taskAssigneeById(task.assignee)) ? [(_vm.taskAssigneeById(task.assignee).image) ? _c('span', {
        style: ({
          backgroundImage: 'url(\'' + _vm.imageBase + _vm.taskAssigneeById(task.assignee).image + '\')'
        })
      }) : _c('avatar', {
        attrs: {
          "username": _vm.taskAssigneeById(task.assignee).label,
          "size": 32,
          "color": "#ffffff"
        }
      })] : [_c('svg', {
        staticClass: "svg-inline--fa fa-user-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "user-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 496 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                                88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                                55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                                7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
        }
      })])]], 2)])])])
    }), 0)], 1)], 1)])
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "search",
    staticClass: "ac-wrapper",
    class: _vm.isOpen ? 'opened' : 'closed'
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "icon-input close-icon",
    on: {
      "click": _vm.closeSearchList
    }
  }, [_c('span', {
    staticClass: "close-icon-icon color-2-63"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 15.002 15.002"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 15.002 15.002",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "points": "7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208\n          12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-input open-icon"
  }, [_c('span', {
    staticClass: "open-icon-icon",
    class: _vm.isOpen ? 'color-2-30' : 'color-1-100'
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 33.643 32.855"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 33.643 32.855",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_34_",
      "d": "M33.204,30.294l-8.119-8.119c1.716-2.314,2.744-5.166,2.744-8.261\n          C27.829,6.243,21.587,0,13.914,0S0,6.243,0,13.915s6.242,13.914,13.915,13.914c3.497,0,6.689-1.307,9.136-3.445l8.032,8.032\n          c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439s0.439-0.677,0.439-1.061S33.497,30.587,33.204,30.294z\n           M13.914,24.829C7.896,24.829,3,19.932,3,13.915S7.896,3,13.914,3s10.915,4.896,10.915,10.914S19.932,24.829,13.914,24.829z"
    }
  })])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchQuery),
      expression: "searchQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "ac-input",
    class: _vm.isOpen ? 'opened' : 'closed',
    attrs: {
      "aria-label": "Search input",
      "title": "Search input",
      "disabled": !_vm.getIsLoggedIn,
      "placeholder": _vm.getIsLoggedIn ? 'Search' : 'You need to login to use the search'
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keydown": function($event) {
        return _vm.keyDownPressed($event)
      },
      "blur": [function($event) {
        return _vm.searchLeave($event)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value.trim()
      }, function($event) {
        return _vm.onInput($event.target.value)
      }],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }
    }
  }), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "ac-results border-1-20"
  }, [_c('div', {
    staticClass: "ac-filters"
  }, [_c('ul', {
    staticClass: "ac-filters-list"
  }, [_c('li', {
    staticClass: "ac-filters-list__item first"
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Filter by type",
      "value.sync": "selectedType",
      "on-change": _vm.selectType,
      "on-input": _vm.startsTyping,
      "options": _vm.getContentTypeForSelect
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('span', [_vm._v(_vm._s(option.label))])]
      }
    }], null, false, 1193437580)
  })], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "ac-list"
  }, [_vm._l((_vm.optionsComputed), function(option, index) {
    return _c('li', {
      staticClass: "ac-filters-list__item border-1-20 background-1-20-hover color-2-100",
      class: {
        'hight-contrast-dropdown': _vm.selectedHightCont === 1
      },
      staticStyle: {
        "min-height": "66px"
      },
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.select(option.id, option.title, option.isArticle)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"]) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.select(option.id, option.title, option.isArticle)
        },
        "mouseenter": function($event) {
          _vm.highlightedPosition = index
        }
      }
    }, [_c('div', [_c('span', {
      class: option.itemClass
    }, [(option.itemClass === 'screentext') ? _c('span', [_c('svg', {
      staticStyle: {
        "enable-background": "new 266 -229.629 548.173 475.087"
      },
      attrs: {
        "version": "1.1",
        "id": "Capa_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "266 -229.629 548.173 475.087",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M800.75-216.207c-8.945-8.945-19.694-13.422-32.261-13.422H311.681c-12.562,0-23.313,4.477-32.264,13.422\n                      C270.471-207.259,266-196.509,266-183.946v310.633c0,12.566,4.471,23.315,13.417,32.265c8.951,8.945,19.702,13.414,32.264,13.414\n                      h155.318c0,7.231-1.524,14.661-4.57,22.269c-3.044,7.614-6.09,14.273-9.136,19.981c-3.042,5.715-4.565,9.897-4.565,12.56\n                      c0,4.948,1.807,9.24,5.424,12.847c3.615,3.621,7.898,5.435,12.847,5.435h146.179c4.949,0,9.233-1.813,12.848-5.435\n                      c3.62-3.606,5.427-7.898,5.427-12.847c0-2.468-1.526-6.611-4.571-12.415c-3.046-5.801-6.092-12.566-9.134-20.267\n                      c-3.046-7.71-4.569-15.085-4.569-22.128h155.318c12.56,0,23.309-4.469,32.254-13.414c8.949-8.949,13.422-19.698,13.422-32.265\n                      v-310.633C814.176-196.509,809.699-207.259,800.75-216.207z M777.627,53.596c0,2.475-0.903,4.613-2.711,6.424\n                      c-1.81,1.804-3.952,2.707-6.427,2.707H311.681c-2.473,0-4.615-0.903-6.423-2.707c-1.807-1.817-2.712-3.949-2.712-6.424v-237.542\n                      c0-2.475,0.902-4.615,2.712-6.423c1.809-1.805,3.951-2.712,6.423-2.712h456.815c2.471,0,4.617,0.904,6.42,2.712\n                      c1.808,1.809,2.711,3.949,2.711,6.423V53.596z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M578.895-30.559H448.674c-7.346,0-13.303,7.34-13.303,16.403s5.957,16.403,13.303,16.403h130.221\n                      c7.346,0,13.303-7.34,13.303-16.403S586.242-30.559,578.895-30.559z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M648.895-112.601H448.674c-7.346,0-13.303,7.34-13.303,16.404c0,9.064,5.957,16.403,13.303,16.403h200.221\n                      c7.346,0,13.303-7.34,13.303-16.403C662.199-105.262,656.242-112.601,648.895-112.601z"
      }
    })])])]) : (option.itemClass === 'casestudy') ? _c('span', [_c('svg', {
      staticStyle: {
        "enable-background": "new 496.239 -496 437.522 512"
      },
      attrs: {
        "version": "1.1",
        "id": "Capa_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "496.239 -496 437.522 512",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M671.136-108.138H529.342v-242.759h95.449c9.142,0,16.552-7.41,16.552-16.552v-95.448h156.689v214.621\n                      c0,9.137,7.41,16.552,16.552,16.552s16.552-7.41,16.552-16.552v-231.172c-0.001-9.142-7.41-16.552-16.552-16.552H624.791\n                      c-4.392,0-8.601,1.743-11.702,4.85l-112,112c-3.106,3.101-4.85,7.316-4.85,11.702v275.862c0,9.142,7.41,16.552,16.552,16.552\n                      h158.345c9.142,0,16.552-7.41,16.552-16.552S680.278-108.138,671.136-108.138z M552.746-384l55.493-55.493V-384H552.746z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M594.446-312.828c-9.142,0-16.552,7.41-16.552,16.552s7.41,16.552,16.552,16.552h138.483\n                      c9.148,0,16.552-7.41,16.552-16.552c-0.001-9.142-7.41-16.552-16.552-16.552H594.446z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M676.929-246.621h-82.483c-9.142,0-16.552,7.41-16.552,16.552s7.41,16.552,16.552,16.552h82.483\n                      c9.148,0,16.552-7.41,16.552-16.552S686.071-246.621,676.929-246.621z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M928.851-12.309l-44.995-44.54c10.581-15.184,16.797-33.626,16.797-53.496\n                      c0-51.719-42.075-93.793-93.793-93.793c-51.719,0-93.793,42.074-93.793,93.793s42.074,93.793,93.793,93.793\n                      c19.919,0,38.404-6.246,53.609-16.875l45.094,44.638c3.228,3.194,7.432,4.789,11.641,4.789c4.259,0,8.524-1.639,11.763-4.905\n                      C935.406,4.596,935.351-5.881,928.851-12.309z M746.17-110.345c0-33.462,27.228-60.69,60.69-60.69s60.69,27.228,60.69,60.69\n                      c-0.001,33.462-27.228,60.69-60.69,60.69S746.17-76.883,746.17-110.345z"
      }
    })])])]) : (option.itemClass === 'template') ? _c('span', [_c('svg', {
      staticStyle: {
        "enable-background": "new -429 388.404 25.408 24.561"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "-429 388.404 25.408 24.561",
        "xml:space": "preserve"
      }
    }, [_c('g', {
      attrs: {
        "id": "Clip-2"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M-403.621,391.797c0.061-0.651-0.456-1.157-1.114-1.091c-3.086-0.049-6.171,0-9.26-0.017v-2.285h-1.726\n                    c-4.425,0.78-8.853,1.525-13.278,2.29c0,6.66-0.003,13.323,0,19.987c4.402,0.762,8.807,1.491,13.2,2.285h1.804v-2.285\n                    c2.889,0,5.776-0.006,8.665,0.008c0.49-0.023,1.036,0.014,1.457-0.282c0.338-0.511,0.251-1.151,0.28-1.727\n                    C-403.633,403.052-403.572,397.423-403.621,391.797z M-419.37,404.566c-0.482,0.249-1.204-0.011-1.775,0.029\n                    c-0.384-1.891-0.831-3.77-1.175-5.669c-0.338,1.845-0.776,3.673-1.163,5.506c-0.554-0.028-1.111-0.062-1.669-0.1\n                    c-0.479-2.513-1.042-5.009-1.489-7.528c0.493-0.023,0.99-0.043,1.484-0.06c0.297,1.819,0.635,3.63,0.895,5.452\n                    c0.407-1.868,0.823-3.736,1.227-5.604c0.549-0.031,1.097-0.054,1.645-0.083c0.384,1.928,0.776,3.853,1.192,5.772\n                    c0.326-1.982,0.687-3.958,1.036-5.938c0.578-0.02,1.155-0.051,1.729-0.086C-418.086,399.025-418.657,401.816-419.37,404.566z\n                     M-404.906,409.227h-9.188v-2.136v-1.068v-1.335v-1.068v-1.217h4.098c0.291,0,0.527-0.35,0.527-0.781\n                    c0-0.432-0.236-0.781-0.527-0.781h-4.098v-0.958v-1.068v-0.037h6.098c0.291,0,0.527-0.376,0.527-0.839s-0.236-0.839-0.527-0.839\n                    h-6.098v-0.688v-1.335v-1.068v-1.869h9.188V409.227z"
      }
    })])]) : (option.itemClass === 'video') ? _c('span', [_c('svg', {
      staticStyle: {
        "enable-background": "new -296 391.193 24 17.711"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "-296 391.193 24 17.711",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('polygon', {
      staticClass: "st0",
      attrs: {
        "id": "path-1_2_",
        "points": "-296,391.193 -296,408.904 -272,408.904 -272,391.193 \t"
      }
    })]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "Welcome"
      }
    }, [_c('g', {
      attrs: {
        "id": "Search-Drop-Down-Menu",
        "transform": "translate(-457.000000, -212.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Page-1",
        "transform": "translate(457.000000, 212.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Clip-2"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "Fill-1",
        "d": "M-279.841,400.693l-6.429,3.8c-0.497,0.294-1.125-0.066-1.125-0.645v-7.6\n                          c0-0.579,0.628-0.939,1.125-0.645l6.429,3.8C-279.351,399.693-279.351,400.404-279.841,400.693 M-272.396,393.351\n                          c-0.084-0.699-0.752-1.358-1.468-1.458c-6.848-0.932-13.423-0.932-20.271,0c-0.716,0.101-1.384,0.76-1.468,1.458\n                          c-0.529,4.45-0.529,8.946,0,13.396c0.084,0.699,0.752,1.358,1.468,1.458c6.848,0.932,13.423,0.932,20.271,0\n                          c0.716-0.101,1.384-0.76,1.468-1.458C-271.868,402.297-271.868,397.8-272.396,393.351"
      }
    })])])])])]) : (option.itemClass === 'document') ? _c('span', [_c('svg', {
      staticStyle: {
        "enable-background": "new 557.9 -470.6 672.9 849.199"
      },
      attrs: {
        "version": "1.1",
        "id": "Capa_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "557.9 -470.6 672.9 849.199",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M894.3,378.599h283.6c29.2,0,52.9-23.699,52.9-52.898V-362.2v-55.5c0-29.2-23.7-52.9-52.9-52.9H894.3H800v17.5\n                        c0.199,1.8,0.3,3.7,0.3,5.6v115.3v29.6c0,41.1-33.4,74.5-74.5,74.5h-29.6H580.9c-1.5,0-3.1-0.1-4.6-0.2h-18.4v554.001\n                        c0,29.199,23.7,52.898,52.9,52.898h58H894.3L894.3,378.599z M905,105.4H720.1c-13.8,0-25-12.393-25-27.66\n                        c0-15.27,11.2-27.66,25-27.66h185c13.8,0,25,12.391,25,27.66C930.1,93.007,918.8,105.4,905,105.4z M720.1-85.6H1060\n                        c13.8,0,25,12.544,25,28s-11.2,28-25,28H720.1c-13.8,0-25-12.544-25-28S706.3-85.6,720.1-85.6z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M580.9-258.1h144.9c0.1,0,0.3,0,0.4,0c24.2-0.2,43.8-19.8,44-44c0-0.1,0-0.3,0-0.4v-145\n                        c0-13.4-11-22.3-22.399-22.3c-5.5,0-11,2-15.6,6.6L565.1-296.1C551.1-282.1,561-258.1,580.9-258.1z"
      }
    })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "ac-content"
    }, [(option.title) ? _c('span', {
      staticClass: "ac-title"
    }, [_vm._v(_vm._s(option.title))]) : _vm._e()])])
  }), _vm._v(" "), (_vm.moreResults) ? _c('li', {
    staticClass: "more-results border-1-20"
  }, [_c('button', {
    staticClass: "ac-blocktitle ac-more color-2-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.seeMore()
      }
    }
  }, [_vm._v("\n              See all search results\n              "), _c('span', {
    staticClass: "ac-more-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 11 6.243"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 11 6.243",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M10.923,3.503c0.101-0.244,0.101-0.519,0-0.764c-0.051-0.123-0.125-0.234-0.217-0.327l-2.12-2.12\n                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l0.414,0.414H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h6.586L7.172,4.535\n                    c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l2.12-2.12\n                    C10.799,3.737,10.872,3.626,10.923,3.503z"
    }
  })])])])]) : _vm._e()], 2)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard"
  }, [_c('promotions'), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__container"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__content"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__listings"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__tasks"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__tasks--items"
  }, [(!_vm.loadingTasks) ? [(_vm.tasks && _vm.tasks.length) ? [_c('vuescroll', {
    attrs: {
      "ops": _vm.scrollBarOptions
    }
  }, _vm._l((_vm.tasks), function(task) {
    return _c('router-link', {
      key: task.id,
      staticClass: "next-gen-dashboard__tasks--item",
      attrs: {
        "to": {
          name: 'task',
          params: {
            id: task.id
          }
        },
        "aria-label": task.title
      }
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-data"
    }, [_c('span', {
      staticClass: "next-gen-dashboard__tasks--item-key",
      class: {
        'line-through': task.status === 4
      }
    }, [_vm._v("\n                    " + _vm._s(task.key) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "next-gen-dashboard__tasks--item-name"
    }, [_vm._v("\n                    " + _vm._s(task.title) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta"
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter",
      class: {
        empty: !task.chapter || !_vm.getChapterById(task.chapter)
      }
    }, [(task.chapter && _vm.getChapterById(task.chapter)) ? [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter-progress"
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter-name"
    }, [_vm._v(_vm._s(_vm.getChapterById(task.chapter)['name']))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-user-info"
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-properties"
    }, [(task.recurrent) ? _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-property recurrency"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "sync-alt",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                          53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                          94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                          57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                          0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                          162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                          504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
      }
    })])]) : _vm._e(), _vm._v(" "), (task.mandatory) ? _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-property mandatory"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "exclamation-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                          111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                          136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                          0-12.356 5.78-11.981 12.654z"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-user priority",
      class: ['priority-' + _vm.taskPriorityDelta(task.score)]
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-up fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-up",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6\n                                              0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.taskPriorityLabelByValue(_vm.taskPriorityDelta(task.score))))])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-user status",
      class: ['status-' + task.status]
    }, [(task.status === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (task.status === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (task.status === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (task.status === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.getStatusById(task.status)) ? _c('span', {
      staticClass: "status-text"
    }, [_vm._v(_vm._s(_vm.getStatusById(task.status).name))]) : _vm._e()], 2)])])])
  }), 1)] : [_vm._m(1)]] : [_vm._m(2)], _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__listings--action"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'tasks'
      }
    }
  }, [_vm._v("Go to Backlog")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__articles"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__articles--items"
  }, [_c('vuescroll', {
    attrs: {
      "ops": _vm.scrollBarOptions
    }
  }, _vm._l((_vm.articles), function(article) {
    return _c('router-link', {
      key: article.id,
      staticClass: "next-gen-dashboard__articles--item",
      attrs: {
        "to": {
          name: 'content',
          params: {
            id: article.id
          }
        },
        "aria-label": article.title
      }
    }, [_c('div', {
      staticClass: "next-gen-dashboard__articles--item--title"
    }, [(article.contentType === 7) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "21",
        "height": "21",
        "viewBox": "0 0 21 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M22.68,17.019l-7.452-4.53a1.018,1.018,0,0,0-1.511.889v8.807a1.02,1.02,0,0,0,1.511.889L22.68,18.8a1.019,1.019,0,0,0,0-1.779Zm5.6.762a10.5,10.5,0,0,0-10.5-10.5h0a10.5,10.5,0,0,0-10.5,10.5v0a10.5,10.5,0,0,0,10.5,10.5h0a10.5,10.5,0,0,0,10.5-10.5Zm-18.967,0a8.465,8.465,0,0,1,8.462-8.467h0a8.465,8.465,0,0,1,8.467,8.462v0a8.465,8.465,0,0,1-8.462,8.467h0a8.465,8.465,0,0,1-8.467-8.462Z",
        "transform": "translate(-7.281 -7.281)"
      }
    })])]) : (article.contentType === 8) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.746",
        "height": "21.004",
        "viewBox": "0 0 15.746 21.004"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M24.417,11.02,20.972,7.579A1.97,1.97,0,0,0,19.582,7H11.219A1.975,1.975,0,0,0,9.25,8.974V26.032A1.969,1.969,0,0,0,11.219,28h11.81A1.97,1.97,0,0,0,25,26.032V12.414A1.982,1.982,0,0,0,24.417,11.02Zm-1.55,1.234h-3.12V9.134ZM11.219,26.032V8.974H17.78v4.264a.982.982,0,0,0,.98.984h4.269v11.81H11.219ZM21.483,20.14c-.511-.492-1.933-.363-2.645-.267a3.551,3.551,0,0,1-1.509-1.9,5.165,5.165,0,0,0,.222-2.3.914.914,0,0,0-1.75-.241,5.915,5.915,0,0,0,.289,2.751,33.027,33.027,0,0,1-1.451,3.051c-.816.422-1.927,1.074-2.091,1.894-.135.647,1.066,2.264,3.12-1.283a20.322,20.322,0,0,1,2.8-.825,5.45,5.45,0,0,0,2.288.7.947.947,0,0,0,.723-1.585h0Zm-8.128,3.19A4.918,4.918,0,0,1,14.6,21.9C13.822,23.136,13.354,23.358,13.354,23.33ZM16.7,15.515c.3,0,.275,1.317.073,1.673a3.433,3.433,0,0,1-.073-1.674Zm-1,5.6a16.12,16.12,0,0,0,1.012-2.242,4.513,4.513,0,0,0,1.235,1.456,13.949,13.949,0,0,0-2.248.786Zm5.4-.205s-.205.247-1.524-.315c1.433-.11,1.671.218,1.524.315Z",
        "transform": "translate(-9.25 -6.996)"
      }
    })])]) : (article.contentType === 9) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.75",
        "height": "21",
        "viewBox": "0 0 15.75 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M21.063,17.172a.493.493,0,0,0-.495-.492H13.683a.494.494,0,0,0-.492.492V18.32a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492Zm-.5,2.953H13.683a.494.494,0,0,0-.492.492v1.148a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492V20.617A.494.494,0,0,0,20.567,20.125ZM25,12.41a1.959,1.959,0,0,0-.583-1.385L20.975,7.583A1.97,1.97,0,0,0,19.584,7H11.219A1.97,1.97,0,0,0,9.25,8.969V26.032A1.969,1.969,0,0,0,11.219,28H23.032A1.971,1.971,0,0,0,25,26.032ZM19.75,9.129l3.121,3.121H19.75Zm3.282,16.9H11.219V8.969h6.563v4.265a.982.982,0,0,0,.98.985h4.27Z",
        "transform": "translate(-9.25 -7)"
      }
    })])]) : (article.contentType === 10) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "23.627",
        "height": "21",
        "viewBox": "0 0 23.627 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M20219.232-8589a.984.984,0,0,1-.98-.984.985.985,0,0,1,.98-.985h2.955l.656-1.971h-7.873a1.969,1.969,0,0,1-1.971-1.966v-13.128a1.969,1.969,0,0,1,1.971-1.966h19.686a1.969,1.969,0,0,1,1.971,1.966v13.128a1.976,1.976,0,0,1-1.971,1.971h-7.877l.66,1.966h2.951a.982.982,0,0,1,.949.949.986.986,0,0,1-.949,1.021Zm-3.605-6.566H20234v-11.813h-18.375Zm3.209-2.479a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h7a.58.58,0,0,1,.58.584v1.163a.58.58,0,0,1-.58.584Zm0-4.667a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h10.5a.584.584,0,0,1,.584.584v1.163a.584.584,0,0,1-.584.584Z",
        "transform": "translate(-20213 8609.998)"
      }
    })])]) : (article.contentType === 11) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "18.53",
        "height": "22.876",
        "viewBox": "0 0 18.53 22.876"
      }
    }, [_c('g', {
      attrs: {
        "transform": "translate(-8 -6.124)"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M18.744,14.421H11.87a.493.493,0,0,0-.492.492v1.147a.493.493,0,0,0,.492.492h6.425a5.959,5.959,0,0,1,.886-.275.486.486,0,0,0,.056-.217l0-1.147a.493.493,0,0,0-.5-.492Z",
        "transform": "translate(0.517 1.307)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M11.378,17.866v1.147a.493.493,0,0,0,.492.492h3a6.083,6.083,0,0,1,1.4-2.13h-4.4A.493.493,0,0,0,11.378,17.866Z",
        "transform": "translate(0.526 1.772)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M9.967,25.007V8.078h6.554V12.31a.978.978,0,0,0,.979.977h4.264v4.19a6.065,6.065,0,0,1,1.966.552V11.491a1.937,1.937,0,0,0-.583-1.374L19.71,6.7a1.974,1.974,0,0,0-1.389-.579H9.967A1.961,1.961,0,0,0,8,8.078V25.007A1.961,1.961,0,0,0,9.967,26.96h6.152a5.993,5.993,0,0,1-.9-1.953Zm8.52-16.77,3.117,3.1H18.486Z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M25.194,25.933l-1.815-1.815a.44.44,0,0,0-.31-.127h-.3a3.787,3.787,0,0,0-2.983-6.117h0A3.786,3.786,0,0,0,16,21.658v0a3.786,3.786,0,0,0,3.784,3.787h0a3.763,3.763,0,0,0,2.33-.8v.3a.44.44,0,0,0,.127.31l1.815,1.814a.437.437,0,0,0,.615,0l0,0,.515-.516A.441.441,0,0,0,25.194,25.933Zm-5.407-1.942a2.33,2.33,0,1,1,2.33-2.33A2.33,2.33,0,0,1,19.787,23.991Z",
        "transform": "translate(1.21 1.803)"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(article.title))])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__articles--item--text",
      domProps: {
        "innerHTML": _vm._s(_vm.articleText(article.content))
      }
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__listings--action"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'knowledge-base'
      }
    }
  }, [_vm._v("Go to Inclusion hub")])], 1)], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__listings--title"
  }, [_c('i', {
    staticClass: "fas fa-stream"
  }), _vm._v(" "), _c('h2', [_vm._v("My tasks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__icon"
  }, [_c('i', {
    staticClass: "fas fa-thumbtack"
  })]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__text"
  }, [_vm._v("\n                    There are no tasks assigned to you yet\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__icon"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__text"
  }, [_vm._v("\n                  Loading tasks assigned to you\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__listings--title"
  }, [_c('i', {
    staticClass: "fas fa-pen"
  }), _vm._v(" "), _c('h2', [_vm._v("Latest resources")])])
}]}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-filters"
  }, [_c('div', {
    staticClass: "tasks-filters-container"
  }, [_c('div', [_c('div', {
    staticClass: "tasks-filters-search",
    class: {
      'not-empty': _vm.titleSearchFilter[_vm.list] !== '', focused: _vm.titleSearchFilterFocused
    }
  }, [_c('label', {
    staticClass: "tasks-filters-title",
    attrs: {
      "for": 'titleSearchFilter-' + _vm.list
    }
  }, [_vm._v("Search task by ID or keyword")]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-search-input"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-search fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "search",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0\n                208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9\n                0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128\n                0 70.7-57.2 128-128 128z"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "id": 'titleSearchFilter-' + _vm.list,
      "type": "search",
      "placeholder": "Search task"
    },
    domProps: {
      "value": _vm.titleSearchFilter[_vm.list]
    },
    on: {
      "input": function($event) {
        return _vm.titleSearchInput($event)
      },
      "focus": function($event) {
        _vm.titleSearchFilterFocused = true
      },
      "blur": function($event) {
        _vm.titleSearchFilterFocused = false
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-chapter"
  }, [_c('div', {
    staticClass: "tasks-filters-title"
  }, [_vm._v("\n          Task category\n          "), (_vm.activeFiltersCount('chapter')) ? _c('button', {
    staticClass: "tasks-filters-title-counter",
    on: {
      "click": function($event) {
        return _vm.clearFilter('chapter')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.activeFiltersCount('chapter')) + "\n            "), _c('span', {
    staticClass: "tasks-filters-title-counter-x"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n              0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n              12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n              0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-chapter-items"
  }, _vm._l((_vm.taskChapters), function(chapter) {
    return _c('div', {
      staticClass: "tasks-filters-chapter-item tasks-filters-tooltip-container",
      class: {
        active: _vm.isFilterActive('chapter', chapter.id)
      },
      attrs: {
        "role": "button",
        "tabindex": "0",
        "aria-label": 'Filter by: \'' + chapter.name + '\' chapter'
      },
      on: {
        "click": function($event) {
          return _vm.filterByChapter(chapter)
        }
      }
    }, [_c('div', {
      staticClass: "tasks-filters-chapter-item-progress"
    }, [_c('div', {
      staticClass: "tasks-filters-chapter-item-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(chapter)
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + chapter.id,
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "tasks-filters-tooltip"
    }, [_vm._v("\n              " + _vm._s(chapter.name) + "\n            ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-assignee"
  }, [_c('div', {
    staticClass: "tasks-filters-title"
  }, [_vm._v("\n          Assignee\n          "), (_vm.activeFiltersCount('assignee')) ? _c('button', {
    staticClass: "tasks-filters-title-counter",
    on: {
      "click": function($event) {
        return _vm.clearFilter('assignee')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.activeFiltersCount('assignee')) + "\n            "), _c('span', {
    staticClass: "tasks-filters-title-counter-x"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n              0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n              12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n              0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-assignee-items"
  }, [_vm._l((_vm.taskAssignee), function(user) {
    return _c('div', {
      staticClass: "tasks-filters-assignee-item tasks-filters-tooltip-container",
      class: {
        active: _vm.isFilterActive('assignee', user.value)
      },
      attrs: {
        "role": "button",
        "tabindex": "0",
        "aria-label": 'Filter by: \'' + user.label + '\' user'
      },
      on: {
        "click": function($event) {
          return _vm.filterByAssignee(user)
        }
      }
    }, [_c('div', {
      staticClass: "tasks-filters-assignee-item-icon"
    }, [(user.image) ? _c('span', {
      style: ({
        backgroundImage: 'url(\'' + _vm.imageBase + user.image + '\')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": user.label,
        "size": 32,
        "color": "#ffffff"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "tasks-filters-tooltip"
    }, [_vm._v("\n              " + _vm._s(user.label) + "\n            ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-assignee-item unassigned tasks-filters-tooltip-container",
    class: {
      active: _vm.isFilterActive('assignee', 'unassigned')
    },
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": 'Filter by: \'Unassigned\''
    },
    on: {
      "click": function($event) {
        return _vm.filterByAssignee(false)
      }
    }
  }, [_c('div', {
    staticClass: "tasks-filters-assignee-item-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 496 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-tooltip"
  }, [_vm._v("\n              Unassigned\n            ")])])], 2)]), _vm._v(" "), (_vm.list === 'backlog') ? _c('div', {
    staticClass: "tasks-filters-status"
  }, [_c('div', {
    staticClass: "tasks-filters-title"
  }, [_vm._v("\n          Status\n          "), (_vm.activeFiltersCount('status')) ? _c('button', {
    staticClass: "tasks-filters-title-counter",
    on: {
      "click": function($event) {
        return _vm.clearFilter('status')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.activeFiltersCount('status')) + "\n            "), _c('span', {
    staticClass: "tasks-filters-title-counter-x"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n              0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n              12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n              0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-status-items"
  }, _vm._l((_vm.taskStatuses), function(status) {
    return _c('div', {
      staticClass: "tasks-filters-status-item tasks-filters-tooltip-container",
      class: [{
        active: _vm.isFilterActive('status', status.id)
      }, 'status-' + status.id],
      attrs: {
        "role": "button",
        "tabindex": "0",
        "aria-label": 'Filter by: \'' + status.name + '\' status'
      },
      on: {
        "click": function($event) {
          return _vm.filterByStatus(status)
        }
      }
    }, [(status.id === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (status.id === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (status.id === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (status.id === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "status-text"
    }, [_vm._v(_vm._s(status.counter))]), _vm._v(" "), _c('div', {
      staticClass: "tasks-filters-tooltip"
    }, [_vm._v("\n              " + _vm._s(status.name) + "\n            ")])], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-mandatory"
  }, [_c('div', {
    staticClass: "tasks-filters-title"
  }, [_vm._v("\n          Mandatory\n          "), (_vm.activeFiltersCount('mandatory')) ? _c('button', {
    staticClass: "tasks-filters-title-counter",
    on: {
      "click": function($event) {
        return _vm.clearFilter('mandatory')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.activeFiltersCount('mandatory')) + "\n            "), _c('span', {
    staticClass: "tasks-filters-title-counter-x"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n              0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n              12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n              0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tasks-filters-mandatory-items"
  }, _vm._l((_vm.taskMandatory), function(mandatory) {
    return _c('div', {
      staticClass: "tasks-filters-mandatory-item tasks-filters-tooltip-container",
      class: [{
        active: _vm.isFilterActive('mandatory', mandatory.id)
      }, 'mandatory-' + mandatory.id],
      attrs: {
        "role": "button",
        "tabindex": "0",
        "aria-label": 'Filter by: \'' + mandatory.name
      },
      on: {
        "click": function($event) {
          return _vm.filterByMandatory(mandatory)
        }
      }
    }, [(mandatory.id === 1) ? [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "19.874",
        "height": "16",
        "viewBox": "0 0 19.874 16"
      }
    }, [_c('path', {
      attrs: {
        "id": "mandatory_yes",
        "d": "M8,.5a6.476,6.476,0,0,0,4.706-2.019.753.753,0,0,1,1.063-.025.753.753,0,0,1,.025,1.063A7.983,7.983,0,0,1,8,2,8,8,0,0,1,0-6a8,8,0,0,1,8-8,8,8,0,0,1,7.284,4.691.745.745,0,0,1-.372.991.749.749,0,0,1-.994-.372A6.511,6.511,0,0,0,7.972-12.5,6.517,6.517,0,0,0,1.472-6,6.517,6.517,0,0,0,7.972.5Zm.75-6.278a.731.731,0,0,1-.75.75.731.731,0,0,1-.75-.75v-3.5a.767.767,0,0,1,.75-.75.767.767,0,0,1,.75.75ZM7-3A1.023,1.023,0,0,1,8-4.028,1.023,1.023,0,0,1,9-3,1,1,0,0,1,8-2,1,1,0,0,1,7-3ZM19.619-8.619a.877.877,0,0,1,0,1.237l-4,4a.877.877,0,0,1-1.237,0l-2-2a.877.877,0,0,1,0-1.237.877.877,0,0,1,1.237,0L15-5.238l3.381-3.381A.877.877,0,0,1,19.619-8.619Z",
        "transform": "translate(0 14)",
        "fill": "#272727"
      }
    })])] : (mandatory.id === 0) ? [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "17",
        "height": "16",
        "viewBox": "0 0 17 16"
      }
    }, [_c('g', {
      attrs: {
        "id": "mandatory_no",
        "transform": "translate(15651 15654)"
      }
    }, [_c('path', {
      attrs: {
        "id": "spinner",
        "d": "M8,.5a6.476,6.476,0,0,0,4.706-2.019.753.753,0,0,1,1.063-.025.753.753,0,0,1,.025,1.063A7.983,7.983,0,0,1,8,2,8,8,0,0,1,0-6a8,8,0,0,1,8-8,8,8,0,0,1,7.284,4.691.745.745,0,0,1-.372.991.749.749,0,0,1-.994-.372A6.511,6.511,0,0,0,7.972-12.5,6.517,6.517,0,0,0,1.472-6,6.517,6.517,0,0,0,7.972.5Zm.75-6.278a.731.731,0,0,1-.75.75.731.731,0,0,1-.75-.75v-3.5a.767.767,0,0,1,.75-.75.767.767,0,0,1,.75.75ZM7-3A1.023,1.023,0,0,1,8-4.028,1.023,1.023,0,0,1,9-3,1,1,0,0,1,8-2,1,1,0,0,1,7-3Z",
        "transform": "translate(-15651 -15640)",
        "fill": "#767676"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "id": "spinner-2",
        "data-name": "spinner",
        "d": "M4.853-1.353a.5.5,0,0,1,0,.707A.5.5,0,0,1,4.5-.5a.5.5,0,0,1-.353-.146L2.5-2.292.854-.647A.5.5,0,0,1,.5-.5.5.5,0,0,1,.146-.647a.5.5,0,0,1,0-.707L1.793-3,.146-4.647a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0L2.5-3.706,4.147-5.353a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707L3.207-3,4.853-1.353Z",
        "transform": "translate(-15639 -15642)",
        "fill": "#767676"
      }
    })])])] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "mandatory-text"
    }, [_vm._v(_vm._s(mandatory.counter))]), _vm._v(" "), _c('div', {
      staticClass: "tasks-filters-tooltip"
    }, [_vm._v("\n              " + _vm._s(mandatory.name) + "\n            ")])], 2)
  }), 0)])]), _vm._v(" "), _c('div', [(_vm.anyFilters) ? _c('button', {
    staticClass: "tasks-filters-reset",
    on: {
      "click": _vm.clearAllFilters
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-filter fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "filter",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17\n              10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Reset filters")])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "status-badge"
  }, [(_vm.status == 0) ? _c('span', {
    staticClass: "draft"
  }, [_vm._v("Draft")]) : _vm._e(), _vm._v(" "), (_vm.status == 1) ? _c('span', {
    staticClass: "published"
  }, [_vm._v("Published")]) : _vm._e(), _vm._v(" "), (_vm.status == 2) ? _c('span', {
    staticClass: "archived"
  }, [_vm._v("Archived")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Category")])])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.disableAPI) ? _c('div', {
    staticClass: "loading-data-wrapper",
    staticStyle: {
      "position": "fixed"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.registrationForm.registrationFormSubmitted && !_vm.registrationForm.registrationErrors) ? _c('div', [_c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password custom-response",
    class: 'custom-response-' + _vm.registrationForm.registrationFormResponseCode
  }, [_c('h1', {
    staticClass: "page-title color-1-100 text-left"
  }, [_c('span', {
    staticClass: "page-title-icon"
  }, [(_vm.registrationForm.registrationFormResponseCode === 1 ||
    _vm.registrationForm.registrationFormResponseCode === 2 ||
    _vm.registrationForm.registrationFormResponseCode === 3 ||
    _vm.registrationForm.registrationFormResponseCode === 4 ||
    _vm.registrationForm.registrationFormResponseCode === 5 ||
    _vm.registrationForm.registrationFormResponseCode === 6 ||
    _vm.registrationForm.registrationFormResponseCode === 7 ||
    _vm.registrationForm.registrationFormResponseCode === 8) ? [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 15.002 15.002"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 15.002 15.002",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "points": "7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208\n                      12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "
    }
  })])] : [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.163 9.729"
    },
    attrs: {
      "version": "1.1",
      "id": "icons",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.163 9.729",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "points": "10.394,0 4.841,6.109 1.768,3.035 0,4.804 4.927,9.729 12.163,1.77 "
    }
  })])]], 2), _vm._v(" "), (_vm.registrationForm.registrationFormResponseCode === 7) ? [_vm._v("\n                Your email domain is not in the list of approved domains for this company\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 8) ? [_vm._v("\n                Your email domain is not in the list of approved domains for this company\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 9) ? [_vm._v("\n                Your request was successfully sent\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 10) ? [_vm._v("\n                Your account was successfully created.\n              ")] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "page-description color-2-77 text-left"
  }, [(_vm.registrationForm.registrationFormResponseCode === 7) ? [_vm._v("\n                Use your work email if you want your account to be automatically activated. Alternatively,\n                you can submit your request and wait until it's manually approved by a company administrator.\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 8) ? [_vm._v("\n                You need to use your work email to create an account.\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 9) ? [_vm._v("\n                We'll send you an email with credentials and login instructions you as soon as your request\n                is approved by a company administrator.\n              ")] : (_vm.registrationForm.registrationFormResponseCode === 10) ? [_vm._v("\n                We've sent you an email with your temporary credentials."), _c('br'), _c('br'), _vm._v("\n                Please be patient, it make take a few minutes before the email arrives in your inbox.\n                If it doesn't, please look for it in the spam or junk folder as well.\n              ")] : _vm._e()], 2), _vm._v(" "), (_vm.registrationForm.registrationFormResponseCode === 9 || _vm.registrationForm.registrationFormResponseCode === 10) ? _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n              Have a question? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Send us your message here")]), _vm._v(".\n            ")], 1) : _c('div', {
    staticClass: "landing-page-login-info-buttons"
  }, [_c('button', {
    staticClass: "background-1-10 background-1-50-hover color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.changeEmail()
      }
    }
  }, [_vm._v("\n                Change email\n              ")]), _vm._v(" "), (_vm.registrationForm.registrationFormResponseCode === 7) ? _c('button', {
    staticClass: "color-2-100 border-1-50",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submitForm(true)
      }
    }
  }, [_vm._v("\n                Submit request\n              ")]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.registrationForm.registrationFormSubmitted) ? _c('div', {
    staticClass: "homepage company-landing"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.footerEdit = true
      }
    }
  }, [_vm._v("Edit page footer logos")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editPageLogo()
      }
    }
  }, [_vm._v("Edit page logo")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-pwd"
  }, [_c('div', {
    staticClass: "hero-pwd-text"
  }, [_vm._v("\n                Powered by\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "hero-pwd-logo"
  }, [(_vm.selectedHightCont != 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": " "
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(228),
      "alt": " "
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-login registration-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm(false)
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.firstName !== '' || _vm.focus === 'firstName',
      'has-error': _vm.errors.has('First name')
    }]
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.firstName),
      expression: "registrationForm.firstName"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.firstName !== '' || _vm.focus === 'firstName'
    }],
    attrs: {
      "id": "firstName",
      "type": "text",
      "data-vv-name": "First name"
    },
    domProps: {
      "value": (_vm.registrationForm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'firstName'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.lastName !== '' || _vm.focus === 'lastName',
      'has-error': _vm.errors.has('Last name')
    }]
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.lastName),
      expression: "registrationForm.lastName"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.lastName !== '' || _vm.focus === 'lastName'
    }],
    attrs: {
      "id": "lastName",
      "type": "text",
      "data-vv-name": "Last name"
    },
    domProps: {
      "value": (_vm.registrationForm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'lastName'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.email !== '' || _vm.focus === 'email',
      'has-error': _vm.errors.has('Email address')
    }]
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.email),
      expression: "registrationForm.email"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.email !== '' || _vm.focus === 'email'
    }],
    attrs: {
      "id": "email",
      "type": "email",
      "data-vv-name": "Email address"
    },
    domProps: {
      "value": (_vm.registrationForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'email'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.phone !== '' || _vm.focus === 'phone',
      'has-error': _vm.errors.has('Phone number')
    }]
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.phone),
      expression: "registrationForm.phone"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.phone !== '' || _vm.focus === 'phone'
    }],
    attrs: {
      "id": "phone",
      "type": "text",
      "data-vv-name": "Phone number"
    },
    domProps: {
      "value": (_vm.registrationForm.phone)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'phone'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.function !== '' || _vm.focus === 'function',
      'has-error': _vm.errors.has('Function')
    }]
  }, [_c('label', {
    attrs: {
      "for": "function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.function),
      expression: "registrationForm.function"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.function !== '' || _vm.focus === 'function'
    }],
    attrs: {
      "id": "function",
      "type": "text",
      "data-vv-name": "Function"
    },
    domProps: {
      "value": (_vm.registrationForm.function)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'function'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "function", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Function')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Function')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.registrationForm.title !== '' || _vm.focus === 'title',
      'has-error': _vm.errors.has('Title')
    }]
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationForm.title),
      expression: "registrationForm.title"
    }],
    class: [{
      'border-1-20': _vm.registrationForm.title !== '' || _vm.focus === 'title'
    }],
    attrs: {
      "id": "title",
      "type": "text",
      "data-vv-name": "Title"
    },
    domProps: {
      "value": (_vm.registrationForm.title)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 'title'
      },
      "blur": function($event) {
        _vm.focus = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registrationForm, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Title')))]) : _vm._e()]), _vm._v(" "), (_vm.registrationForm.registrationErrors) ? _c('div', {
    staticClass: "login-form-error"
  }, _vm._l((_vm.registrationForm.registrationErrors), function(error) {
    return _c('ul', {
      staticClass: "error-list"
    }, [_c('li', [_vm._v(_vm._s(error))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('button', {
    staticClass: "register background-1-10 background-1-50-hover color-2-100",
    class: [{
      'active-logging': _vm.registrationForm.registrationInProgress
    }],
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "registration-form-info"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Privacy:")]), _vm._v(" Your details will be used to keep you informed about resources provided by The Clear Company.\n                  "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to find out more about the services we provide.\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "have-account"
  }, [_c('span', [_vm._v("Already have an account?")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        'name': 'company-landing',
        'params': {
          'id': _vm.industryLanding
        }
      }
    }
  }, [_vm._v("\n                    Log in here\n                  ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.stepSection.hideSection || _vm.content.stepSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.stepSection.hideSection || content.stepSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper login-steps landing-page-wrapper-gray"
  }, [_c('div', {
    staticClass: "landing-page-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-content background-1-100-before"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.stepSection.hideSection),
      expression: "content.stepSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showStep"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.stepSection.hideSection) ? _vm._i(_vm.content.stepSection.hideSection, null) > -1 : (_vm.content.stepSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.stepSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.stepSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.stepSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.stepSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showStep"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-steps-text color-2-77",
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml(_vm.content.stepSection.description))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.stepSection.description),
      expression: "content.stepSection.description"
    }],
    staticClass: "landing-page-steps-text color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.stepSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.stepSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.decodeHtml(_vm.content.stepSection.description)))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "steps",
    staticClass: "landing-page-steps-wrapper"
  }, [_vm._l((_vm.content.stepSection.steps), function(step, index) {
    return _c('div', {
      staticClass: "step-item",
      class: [{
        'step-active': _vm.stepActive === (index + 1)
      }, 'step__' + step.id]
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "step-item-content"
    }, [_vm._v("\n              " + _vm._s(step.text) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (step.text),
        expression: "step.text"
      }],
      staticClass: "step-item-content",
      attrs: {
        "data-gramm_editor": "false",
        "data-lpignore": "true",
        "placeholder": "Step item text",
        "rows": "1"
      },
      domProps: {
        "value": (step.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(step, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(step.text))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "step-item-image",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(step))
      }),
      attrs: {
        "title": step.altImage
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(step)
        }
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "step-item-upload"
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "landing-page-steps-pagination"
  }, [_c('span', {
    staticClass: "step-item__1",
    class: [{
      'active': _vm.stepActive === 1
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 1
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-item__2",
    class: [{
      'active': _vm.stepActive === 2
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 2
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-item__3",
    class: [{
      'active': _vm.stepActive === 3
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 3
      }
    }
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.featuresSection.hideSection || _vm.content.featuresSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper features-section landing-page-wrapper-gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.hideSection),
      expression: "content.featuresSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFeatures"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.featuresSection.hideSection) ? _vm._i(_vm.content.featuresSection.hideSection, null) > -1 : (_vm.content.featuresSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.featuresSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.featuresSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showFeatures'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.featuresSection.title) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.featuresSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.title),
      expression: "content.featuresSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.featuresSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.featuresSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.featuresSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  }, [_vm._l((_vm.content.featuresSection.items), function(item, index) {
    return (index < _vm.ppp) ? _c('div', {
      ref: 'feature-' + index,
      refInFor: true,
      staticClass: "feature-item",
      class: [{
        'expanded': item.expanded && !_vm.pageEditMode
      }]
    }, [(!_vm.pageEditMode && item.expanded) ? _c('a', {
      staticClass: "feature-close border-1-50",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.expandSection('feature-' + index, item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "feature-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": item.altImage
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "landing-page-image-upload",
      attrs: {
        "for": 'feature-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'feature-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "feature-content"
    }, [(!_vm.pageEditMode && !_vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.date) ? _c('div', {
      staticClass: "feature-date"
    }, [_vm._v("Posted on " + _vm._s(_vm.getCurrentDate(item.date)))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-excerpt",
      domProps: {
        "innerHTML": _vm._s(item.excerpt)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.expanded) ? _c('div', {
      staticClass: "feature-text background-1-50-before",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.text && item.text !== '') ? _c('a', {
      staticClass: "feature-link background-1-10 background-1-50-hover color-2-100 border-1-50",
      class: [{
        'expanded': item.expanded
      }],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.expandSection('feature-' + index, item)
        }
      }
    }, [(item.expanded) ? [_vm._v("Show less")] : [_vm._v("Show more")]], 2) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "feature-date"
    }, [_vm._v("\n                Posted on\n                "), _c('datepicker', {
      attrs: {
        "inline": false,
        "open-date": item.date,
        "format": 'dd MMMM yyyy'
      },
      model: {
        value: (item.date),
        callback: function($$v) {
          _vm.$set(item, "date", $$v)
        },
        expression: "item.date"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.excerpt),
        expression: "item.excerpt"
      }],
      staticClass: "feature-excerpt",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item excerpt",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.excerpt)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "excerpt", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.excerpt))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('wysiwyg', {
      staticClass: "feature-text edit-mode",
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.featuresSection.items, index)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('features')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list-more background-1-10 background-1-50-hover color-2-100"
  }, [(_vm.content.featuresSection.items && _vm.ppp < _vm.content.featuresSection.items.length) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ppp += 5
      }
    }
  }, [_vm._v("\n              Load more news\n            ")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClients"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showClients'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section center background-1-100-before"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "section-title text-left",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description text-left",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons text-left"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && _vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action background-1-10 background-1-50-hover color-2-100",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode || _vm.content.clientSection.logos.length) ? _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "logos flex-section"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "slick",
    staticClass: "clients-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mobile-left-section center background-1-100-before"
  }, [(!_vm.pageEditMode && !_vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && !_vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.logoEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "logoEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page logo")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "modal-item"
  }, [_c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.landing.logo)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "page-logo"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "page-logo"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.landing, 'logo')
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.footerEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "footerEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change footer logos")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', {
    staticClass: "footerLogos"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "logosLabel"
    }
  }, [_vm._v("Footer logos label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerData.logosLabel),
      expression: "content.footerData.logosLabel"
    }],
    attrs: {
      "id": "logosLabel"
    },
    domProps: {
      "value": (_vm.content.footerData.logosLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerData, "logosLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _vm._l((_vm.content.footerData.logos), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.footerData.logos, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-logos')
      }
    }
  }, [_vm._v("+ Add logos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Fields marked with an asterisk ("), _c('span', [_vm._v("*")]), _vm._v(") are mandatory.")])
}]}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Type")])])
}]}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown v-select",
    class: _vm.dropdownClasses,
    attrs: {
      "dir": _vm.dir
    }
  }, [_c('div', {
    ref: "toggle",
    staticClass: "dropdown-toggle",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggleDropdown($event)
      }
    }
  }, [_c('div', {
    ref: "selectedOptions",
    staticClass: "vs__selected-options"
  }, [_vm._l((_vm.valueAsArray), function(option) {
    var _obj, _obj$1;

    return _vm._t("selected-option-container", [_c('span', {
      key: option.index,
      staticClass: "selected-tag"
    }, [_vm._t("selected-option", [(_vm.customType) ? [(_vm.customType === 'assignee') ? _c('span', {
      staticClass: "selected-tag-image"
    }, [(option.value == null) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                              88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                              55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                              7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])] : [(option.image && option.image !== '') ? _c('span', {
      style: ({
        backgroundImage: 'url(' + _vm.imageBase + option.image + ')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": option.label,
        "size": 29,
        "color": "#ffffff"
      }
    })]], 2) : _vm._e(), _vm._v(" "), (_vm.customType === 'status') ? _c('span', {
      staticClass: "selected-tag-icon"
    }, [(option.value == '1') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (option.value == '2') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (option.value == '3') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (option.value == '4') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e()], 2) : _vm._e()] : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], null, (typeof option === 'object') ? option : ( _obj = {}, _obj[_vm.label] = option, _obj )), _vm._v(" "), (_vm.multiple) ? _c('button', {
      staticClass: "close",
      attrs: {
        "disabled": _vm.disabled,
        "type": "button",
        "aria-label": "Remove option"
      },
      on: {
        "click": function($event) {
          return _vm.deselect(option)
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])]) : _vm._e()], 2)], {
      "option": (typeof option === 'object') ? option : ( _obj$1 = {}, _obj$1[_vm.label] = option, _obj$1 ),
      "deselect": _vm.deselect,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled
    })
  }), _vm._v(" "), _c('input', {
    ref: "search",
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "autocomplete": _vm.autocomplete,
      "disabled": _vm.disabled,
      "placeholder": _vm.searchPlaceholder,
      "tabindex": _vm.tabindex,
      "readonly": !_vm.searchable,
      "id": _vm.inputId,
      "role": "combobox",
      "aria-expanded": _vm.dropdownOpen,
      "aria-label": "Search for option"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.maybeDeleteValue($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.typeAheadUp($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.typeAheadDown($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.typeAheadSelect($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.onTab($event)
      }],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.onEscape($event)
      },
      "blur": _vm.onSearchBlur,
      "focus": _vm.onSearchFocus,
      "input": function($event) {
        _vm.search = $event.target.value
      }
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "vs__actions"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClearButton),
      expression: "showClearButton"
    }],
    staticClass: "clear",
    attrs: {
      "disabled": _vm.disabled,
      "type": "button",
      "title": "Clear selection"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), (!_vm.noDrop) ? _c('i', {
    ref: "openIndicator",
    staticClass: "open-indicator",
    attrs: {
      "role": "presentation"
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n              24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373\n              24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._t("spinner", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mutableLoading),
      expression: "mutableLoading"
    }],
    staticClass: "spinner"
  }, [_vm._v("Loading...")])])], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.customActive ? _vm.customActive : _vm.dropdownOpen) ? _c('ul', {
    ref: "dropdownMenu",
    staticClass: "dropdown-menu",
    style: ({
      'max-height': _vm.maxHeight
    }),
    attrs: {
      "role": "listbox"
    },
    on: {
      "mousedown": _vm.onMousedown,
      "mouseup": _vm.onMouseup
    }
  }, [_vm._l((_vm.filteredOptions), function(option, index) {
    var _obj;

    return _c('li', {
      key: index,
      class: {
        active: _vm.isOptionSelected(option), highlight: index === _vm.typeAheadPointer
      },
      attrs: {
        "role": "option"
      },
      on: {
        "mouseover": function($event) {
          _vm.typeAheadPointer = index
        }
      }
    }, [_c('a', {
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.select(option)
        }
      }
    }, [_vm._t("option", [_c('span', {
      attrs: {
        "data-value": option.value
      }
    }, [(_vm.customType) ? [(_vm.customType === 'assignee') ? _c('span', {
      staticClass: "dropdown-menu-item-image"
    }, [(option.value == null) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                              88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                              55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                              7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])] : [(option.image && option.image !== '') ? _c('span', {
      style: ({
        backgroundImage: 'url(' + _vm.imageBase + option.image + ')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": option.label,
        "size": 29,
        "color": "#ffffff"
      }
    })]], 2) : _vm._e(), _vm._v(" "), (_vm.customType === 'status') ? _c('span', {
      staticClass: "dropdown-menu-item-icon"
    }, [(option.value == '1') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                                0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                                168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (option.value == '2') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                                368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                                48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                                48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                                0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                                21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (option.value == '3') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                                55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                                241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                                0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (option.value == '4') ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                                256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                                89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                                303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                                16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e()], 2) : _vm._e()] : _vm._e(), _vm._v("\n              " + _vm._s(_vm.getOptionLabel(option)) + "\n            ")], 2)], null, (typeof option === 'object') ? option : ( _obj = {}, _obj[_vm.label] = option, _obj ))], 2)])
  }), _vm._v(" "), (!_vm.filteredOptions.length) ? _c('li', {
    staticClass: "no-options",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("no-options", [_vm._v("Sorry, no matching options.")])], 2) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage company-landing"
  }, [(_vm.disableAPI) ? _c('div', {
    staticClass: "loading-data-wrapper"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.footerEdit = true
      }
    }
  }, [_vm._v("Edit page footer logos")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editPageLogo()
      }
    }
  }, [_vm._v("Edit page logo")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [(_vm.activatePage) ? _c('div', {
    ref: "informationMsg",
    staticClass: "inform-popup success",
    attrs: {
      "id": "information-message"
    }
  }, [_c('div', {
    staticClass: "inform-message-inner"
  }, [_c('div', {
    staticClass: "inform-title"
  }, [_vm._v("\n                Your account was successfully activated.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "inform-content"
  }, [_vm._v("\n                Please use the temporary credentials from your invitation email to login.\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "inform-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeCustomMsg()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-pwd"
  }, [_c('div', {
    staticClass: "hero-pwd-text"
  }, [_vm._v("\n              Powered by\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "hero-pwd-logo"
  }, [(_vm.selectedHightCont != 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(109)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(228)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-login"
  }, [_c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        return _vm.authenticate('top')
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.email !== '' || _vm.topLoginForm.emailFocus,
      'has-error': _vm.topLoginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.email),
      expression: "topLoginForm.email"
    }],
    class: [{
      'border-1-20': _vm.topLoginForm.email !== '' || _vm.topLoginForm.emailFocus
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.topLoginForm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus,
      'has-error': _vm.topLoginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('top')
      }
    }
  }), _vm._v(" "), ((_vm.topLoginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    class: [{
      'border-1-20': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.topLoginForm.password) ? _vm._i(_vm.topLoginForm.password, null) > -1 : (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.topLoginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.topLoginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.topLoginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.topLoginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.topLoginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    class: [{
      'border-1-20': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.topLoginForm.password, null)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.topLoginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    class: [{
      'border-1-20': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": _vm.topLoginForm.passwordType
    },
    domProps: {
      "value": (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.topLoginForm.isError) ? _c('div', {
    staticClass: "login-form-error"
  }, [_vm._v("\n                  " + _vm._s(_vm.topLoginForm.loginErrorMessage) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('button', {
    staticClass: "login background-1-10 background-1-50-hover color-2-100",
    class: [{
      'active-logging': _vm.topLoginForm.loginInProgress
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate('top')
      }
    }
  }, [_vm._v("Login")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.featuresSection.hideSection || _vm.content.featuresSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper features-section landing-page-wrapper-gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.hideSection),
      expression: "content.featuresSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFeatures"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.featuresSection.hideSection) ? _vm._i(_vm.content.featuresSection.hideSection, null) > -1 : (_vm.content.featuresSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.featuresSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.featuresSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showFeatures'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.featuresSection.title) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.featuresSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.title),
      expression: "content.featuresSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.featuresSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.featuresSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.featuresSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  }, [_vm._l((_vm.content.featuresSection.items), function(item, index) {
    return (index < _vm.ppp) ? _c('div', {
      ref: 'feature-' + index,
      refInFor: true,
      staticClass: "feature-item",
      class: [{
        'expanded': item.expanded && !_vm.pageEditMode
      }]
    }, [(!_vm.pageEditMode && item.expanded) ? _c('a', {
      staticClass: "feature-close border-1-50",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.expandSection('feature-' + index, item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "feature-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": item.altImage
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "landing-page-image-upload",
      attrs: {
        "for": 'feature-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'feature-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "feature-content"
    }, [(!_vm.pageEditMode && !_vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.date) ? _c('div', {
      staticClass: "feature-date"
    }, [_vm._v("Posted on " + _vm._s(_vm.getCurrentDate(item.date)))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-excerpt",
      domProps: {
        "innerHTML": _vm._s(item.excerpt)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.expanded) ? _c('div', {
      staticClass: "feature-text background-1-50-before",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.text && item.text !== '') ? _c('a', {
      staticClass: "feature-link background-1-10 background-1-50-hover color-2-100 border-1-50",
      class: [{
        'expanded': item.expanded
      }],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.expandSection('feature-' + index, item)
        }
      }
    }, [(item.expanded) ? [_vm._v("Show less")] : [_vm._v("Show more")]], 2) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "feature-date"
    }, [_vm._v("\n              Posted on\n              "), _c('datepicker', {
      attrs: {
        "inline": false,
        "open-date": item.date,
        "format": 'dd MMMM yyyy'
      },
      model: {
        value: (item.date),
        callback: function($$v) {
          _vm.$set(item, "date", $$v)
        },
        expression: "item.date"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.excerpt),
        expression: "item.excerpt"
      }],
      staticClass: "feature-excerpt",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item excerpt",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.excerpt)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "excerpt", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.excerpt))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('wysiwyg', {
      staticClass: "feature-text edit-mode",
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.featuresSection.items, index)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('features')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list-more background-1-10 background-1-50-hover color-2-100"
  }, [(_vm.content.featuresSection.items && _vm.ppp < _vm.content.featuresSection.items.length) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ppp += 5
      }
    }
  }, [_vm._v("\n            Load more news\n          ")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClients"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showClients'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section center background-1-100-before"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && _vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action background-1-10 background-1-50-hover color-2-100",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode || _vm.content.clientSection.logos.length) ? _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "logos flex-section"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "slick",
    staticClass: "clients-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mobile-left-section center background-1-100-before"
  }, [(!_vm.pageEditMode && !_vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && !_vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.logoEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "logoEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page logo")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "modal-item"
  }, [_c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.landing.logo)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "page-logo"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "page-logo"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.landing, 'logo')
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.footerEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "footerEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change footer logos")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', {
    staticClass: "footerLogos"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "logosLabel"
    }
  }, [_vm._v("Footer logos label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerData.logosLabel),
      expression: "content.footerData.logosLabel"
    }],
    attrs: {
      "id": "logosLabel"
    },
    domProps: {
      "value": (_vm.content.footerData.logosLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerData, "logosLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _vm._l((_vm.content.footerData.logos), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.footerData.logos, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-logos')
      }
    }
  }, [_vm._v("+ Add logos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
}]}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('a', {
      attrs: {
        "href": tab.href,
        "role": "tab",
        "tabindex": tab.isActive ? 0 : -1,
        "aria-selected": tab.isActive,
        "aria-controls": 'tab-content-' + tab.aliasSlug,
        "id": 'tab-' + tab.aliasSlug
      },
      on: {
        "keydown": function($event) {
          return _vm.focusTab($event)
        },
        "click": function($event) {
          return _vm.selectTab(tab, $event)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tab.name))])])
  }), 0), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.promotions && _vm.promotions.length) ? _c('div', {
    staticClass: "promotion-section__container"
  }, _vm._l((_vm.promotions), function(promotion) {
    return _c('div', {
      ref: 'promotion-' + promotion.id,
      refInFor: true,
      staticClass: "content-section no-margin-top content-section__bordered border-1-20 promotion-section__content"
    }, [_c('div', [_c('div', [_c('div', {
      staticClass: "content-section-title color-1-100 background-1-100-before"
    }, [_c('h3', [_vm._v(_vm._s(promotion.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content-section-text",
      domProps: {
        "innerHTML": _vm._s(promotion.text)
      }
    }), _vm._v(" "), (promotion.link && promotion.button && promotion.link !== '' && promotion.button !== '') ? _c('a', {
      staticClass: "content-section-button border-1-60",
      attrs: {
        "href": promotion.link
      }
    }, [_vm._v("\n          " + _vm._s(promotion.button) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "content-section-image",
      attrs: {
        "alt": promotion.imageAlt,
        "src": _vm.getImageFullPath(promotion.image)
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "content-section-close",
      on: {
        "click": function($event) {
          return _vm.hidePromotion(promotion.id)
        }
      }
    }, [_vm._v("Dismiss info")])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "forgot-password--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendFormRequest()
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.email !== '' || _vm.emailFocus,
      'has-error': _vm.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.email),
      expression: "formInfo.email"
    }],
    class: [{
      'border-1-20': _vm.formInfo.email !== '' || _vm.emailFocus
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email",
      "placeholder": "Type in your e-mail address..."
    },
    domProps: {
      "value": (_vm.formInfo.email)
    },
    on: {
      "focus": function($event) {
        _vm.emailFocus = true
      },
      "blur": function($event) {
        _vm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send me reset link")])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account several times? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n            Submitting\n          ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                " + _vm._s(_vm.formStatus.title) + "\n              ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                " + _vm._s(_vm.formStatus.body) + "\n              ")]) : _vm._e()] : (_vm.formStatus.submitted && this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                Please fill in the required information\n              ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk.")])] : _vm._e()]], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title color-1-100"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Forgot password?\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description color-2-77"
  }, [_vm._v("\n          Please enter the email address associated with your Clear Assured account."), _c('br'), _vm._v("\n          We will send you a reset password link and instructions on how to change it.\n        ")])
}]}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Company specific")])])
}]}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage company-landing"
  }, [(_vm.disableAPI) ? _c('div', {
    staticClass: "loading-data-wrapper"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-register"
  }, [_c('div', {
    staticClass: "hero-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "tcc-form"
  }), _vm._v(" "), _c('form', {
    staticClass: "tcc-form",
    on: {
      "submit": function($event) {
        return _vm.submitCallbackRequest()
      }
    }
  }, [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.name),
      expression: "registerForm.name"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'not-empty': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'has-error': _vm.errors.has('First name')
    }],
    attrs: {
      "id": "register-name",
      "data-lpignore": "true",
      "type": "text",
      "name": "First name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.name)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.nameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.nameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.surname),
      expression: "registerForm.surname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'not-empty': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'has-error': _vm.errors.has('Last name')
    }],
    attrs: {
      "id": "register-surname",
      "data-lpignore": "true",
      "type": "text",
      "name": "Last name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.surname)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.surnameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.surnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-phone"
    }
  }, [_vm._v("Contact number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.phone),
      expression: "registerForm.phone"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.phone !== '' || _vm.registerForm.phoneFocus,
      'not-empty': _vm.registerForm.phone !== '' || _vm.registerForm.phoneFocus,
      'has-error': _vm.errors.has('Contact number')
    }],
    attrs: {
      "id": "register-phone",
      "data-lpignore": "true",
      "type": "text",
      "name": "Contact number",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.phone)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.phoneFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.phoneFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Contact number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Contact number')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.email),
      expression: "registerForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'not-empty': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'has-error': _vm.errors.has('Email address')
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email address",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-subject"
    }
  }, [_vm._v("Subject (Short but descriptive)*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.subject),
      expression: "registerForm.subject"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.subject !== '' || _vm.registerForm.subjectFocus,
      'not-empty': _vm.registerForm.subject !== '' || _vm.registerForm.subjectFocus,
      'has-error': _vm.errors.has('Subject')
    }],
    attrs: {
      "id": "register-subject",
      "data-lpignore": "true",
      "type": "text",
      "name": "Subject",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.subject)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.subjectFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.subjectFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Subject')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Subject')))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "callback-request-message-info",
    attrs: {
      "id": "messageDescription"
    }
  }, [_vm._v("\n                  Tell us about the difficulties that you encountered with Clear Assured and we’ll contact you with a solution shortly.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-message"
    }
  }, [_vm._v("Description (Please be as descriptive as possible)*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.message),
      expression: "registerForm.message"
    }],
    staticClass: "tcc-form-element tcc-form-element__textarea",
    class: [{
      'border-1-20': _vm.registerForm.message !== '' || _vm.registerForm.messageFocus,
      'not-empty': _vm.registerForm.message !== '' || _vm.registerForm.messageFocus,
      'has-error': _vm.errors.has('Your message')
    }],
    attrs: {
      "id": "register-message",
      "data-lpignore": "true",
      "type": "text",
      "name": "Your message",
      "aria-describedby": "messageDescription",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.message)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.messageFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.messageFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Your message')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Your message')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-register-terms"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.privacy),
      expression: "registerForm.privacy"
    }],
    staticClass: "tcc-form-element tcc-form-element__checkbox",
    class: [{
      'has-error': _vm.errors.has('Privacy policy')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "register-privacy",
      "name": "Privacy policy"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.privacy) ? _vm._i(_vm.registerForm.privacy, null) > -1 : (_vm.registerForm.privacy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registerForm.privacy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "privacy", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "privacy", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "privacy", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "register-privacy"
    }
  }, [_vm._v("Agree to the Clear Assured "), _c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v("*.")], 1), _vm._v(" "), (this.errors.has('Privacy policy')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Privacy policy')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action",
    class: [{
      'submitting': _vm.registerForm.requestInProgress
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitCallbackRequest()
      }
    }
  }, [_vm._v("\n                    Submit help request\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                    Submitting\n                  ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                        " + _vm._s(_vm.formStatus.title) + "\n                      ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.formStatus.body) + "\n                      ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                        Some fields are missing.\n                      ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Fields marked with an asterisk ("), _c('span', [_vm._v("*")]), _vm._v(") are mandatory.")])
}]}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resetting"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("ID")])
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base"
  }, [_c('promotions'), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__container"
  }, [_c('div', {
    staticClass: "knowledge-base__content"
  }, [_c('div', {
    staticClass: "knowledge-base__content--head"
  }, [_c('h1', [_vm._v("The Clear Assured inclusion hub")]), _vm._v(" "), _c('p', [_vm._v("\n          Find the subject you're interested in by searching a keyword, browsing resources by categories and topics.\n          If there is anything you'd like to read about, but can't find in our inclusion hub "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("get in touch")]), _vm._v(" and share your ideas with us, we'd be happy to add more content that's of interest.\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__control"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__control--icon",
    class: {
      'active': _vm.searchKey
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16.031",
      "height": "16.031",
      "viewBox": "0 0 16.031 16.031"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15.781,0a.689.689,0,0,1,0,1.063l-.719.719a.689.689,0,0,1-1.062,0L10.125-2.094A6.348,6.348,0,0,1,6.5-1,6.261,6.261,0,0,1,1.906-2.906,6.261,6.261,0,0,1,0-7.5a6.261,6.261,0,0,1,1.906-4.594A6.261,6.261,0,0,1,6.5-14a6.261,6.261,0,0,1,4.594,1.906A6.261,6.261,0,0,1,13-7.5a6.348,6.348,0,0,1-1.094,3.625ZM3.672-10.328A3.854,3.854,0,0,0,2.5-7.5,3.854,3.854,0,0,0,3.672-4.672,3.854,3.854,0,0,0,6.5-3.5,3.854,3.854,0,0,0,9.328-4.672,3.854,3.854,0,0,0,10.5-7.5a3.854,3.854,0,0,0-1.172-2.828A3.854,3.854,0,0,0,6.5-11.5,3.854,3.854,0,0,0,3.672-10.328Z",
      "transform": "translate(0 14)"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchKey),
      expression: "searchKey",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "knowledgeSearch",
      "placeholder": "Search resource...",
      "aria-label": "Search resource"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value.trim()
      }, function($event) {
        return _vm.search()
      }],
      "keydown": function($event) {
        return _vm.keyDownPressed($event)
      },
      "blur": [function($event) {
        return _vm.searchLeave($event)
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), (_vm.searchKey) ? _c('button', {
    staticClass: "knowledge-base__content--search__control--reset",
    attrs: {
      "aria-label": "Reset search"
    },
    on: {
      "click": function($event) {
        return _vm.searchReset()
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "11.188",
      "height": "11.188",
      "viewBox": "0 0 11.188 11.188"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M8.125,8l3.188,3.188a1.02,1.02,0,0,1,0,1.406l-.719.719a1.02,1.02,0,0,1-1.406,0L6,10.125,2.813,13.313a.954.954,0,0,1-.7.281.954.954,0,0,1-.7-.281l-.719-.719a1.02,1.02,0,0,1,0-1.406L3.875,8,.688,4.813a.954.954,0,0,1-.281-.7.954.954,0,0,1,.281-.7l.719-.719a.954.954,0,0,1,.7-.281.954.954,0,0,1,.7.281L6,5.875,9.188,2.688a1.02,1.02,0,0,1,1.406,0l.719.719a.954.954,0,0,1,.281.7.954.954,0,0,1-.281.7Z",
      "transform": "translate(-0.406 -2.406)"
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.searchKey || (_vm.searchCategories && _vm.searchCategories.length) || (_vm.searchTopics && _vm.searchTopics.length) || (_vm.searchTypes && _vm.searchTypes.length)) ? [_c('div', {
    staticClass: "knowledge-base__content--search__filters"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__filters--selectors"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__filters--selector"
  }, [_c('filters-select', {
    staticClass: "categories-selector",
    attrs: {
      "searchable": true,
      "multiple": true,
      "closeOnSelect": false,
      "clearSearchOnSelect": false,
      "clearSearchOnBlur": true,
      "placeholder": "Type Category name...",
      "options": _vm.getNonEmptyCategoriesForSelect,
      "data-lpignore": "true",
      "inputId": "searchCategories"
    },
    model: {
      value: (_vm.searchCategories),
      callback: function($$v) {
        _vm.searchCategories = $$v
      },
      expression: "searchCategories"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'searchCategories'
    }
  }, [_c('i', {
    staticClass: "fas fa-sitemap"
  }), _vm._v(" "), _c('span', [_vm._v("\n                  Filter by Category "), (_vm.searchCategories && _vm.searchCategories.length) ? [_vm._v("(" + _vm._s(_vm.searchCategories.length) + ")")] : _vm._e()], 2)]), _vm._v(" "), (_vm.searchCategories && _vm.searchCategories.length) ? _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.searchCategories = []
      }
    }
  }, [_c('span', [_vm._v("Clear Category filters")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--selector"
  }, [_c('filters-select', {
    staticClass: "topics-selector",
    attrs: {
      "searchable": true,
      "multiple": true,
      "closeOnSelect": false,
      "clearSearchOnSelect": false,
      "clearSearchOnBlur": true,
      "placeholder": "Type Topic name...",
      "options": _vm.getNonEmptyTagsForSelect,
      "data-lpignore": "true",
      "inputId": "searchTopics"
    },
    model: {
      value: (_vm.searchTopics),
      callback: function($$v) {
        _vm.searchTopics = $$v
      },
      expression: "searchTopics"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'searchTopics'
    }
  }, [_c('i', {
    staticClass: "fas fa-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Filter by Topic "), (_vm.searchTopics && _vm.searchTopics.length) ? [_vm._v("(" + _vm._s(_vm.searchTopics.length) + ")")] : _vm._e()], 2)]), _vm._v(" "), (_vm.searchTopics && _vm.searchTopics.length) ? _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.searchTopics = []
      }
    }
  }, [_c('span', [_vm._v("Clear Category filters")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--selector"
  }, [_c('filters-select', {
    staticClass: "types-selector",
    attrs: {
      "searchable": true,
      "multiple": true,
      "closeOnSelect": false,
      "clearSearchOnSelect": false,
      "clearSearchOnBlur": true,
      "placeholder": "Type Type name...",
      "options": _vm.getContentTypeForSelect,
      "data-lpignore": "true",
      "inputId": "searchTypes"
    },
    model: {
      value: (_vm.searchTypes),
      callback: function($$v) {
        _vm.searchTypes = $$v
      },
      expression: "searchTypes"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'searchTypes'
    }
  }, [_c('i', {
    staticClass: "fas fa-shapes"
  }), _vm._v(" "), _c('span', [_vm._v("Filter by Type "), (_vm.searchTypes && _vm.searchTypes.length) ? [_vm._v("(" + _vm._s(_vm.searchTypes.length) + ")")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset"
  }, [(_vm.searchTypes && _vm.searchTypes.length) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.searchTypes = []
      }
    }
  }, [_c('span', [_vm._v("Clear Category filters")])]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--actions"
  }, [((_vm.searchCategories && _vm.searchCategories.length) || (_vm.searchTopics && _vm.searchTopics.length) || (_vm.searchTypes && _vm.searchTypes.length)) ? _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset reset-all"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.resetAllFilters()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-filter"
  }), _c('span', [_vm._v("Clear all filters")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__results"
  }, [(!_vm.loadingResources) ? [(_vm.results && _vm.results.length > 0) ? _vm._l((_vm.results), function(result) {
    return _c('router-link', {
      key: result.id,
      staticClass: "knowledge-base__content--search__result",
      attrs: {
        "to": {
          name: 'content',
          params: {
            id: result.id
          }
        },
        "aria-label": result.title
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--search__result--title"
    }, [(result.content_type.id === 7) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "21",
        "height": "21",
        "viewBox": "0 0 21 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M22.68,17.019l-7.452-4.53a1.018,1.018,0,0,0-1.511.889v8.807a1.02,1.02,0,0,0,1.511.889L22.68,18.8a1.019,1.019,0,0,0,0-1.779Zm5.6.762a10.5,10.5,0,0,0-10.5-10.5h0a10.5,10.5,0,0,0-10.5,10.5v0a10.5,10.5,0,0,0,10.5,10.5h0a10.5,10.5,0,0,0,10.5-10.5Zm-18.967,0a8.465,8.465,0,0,1,8.462-8.467h0a8.465,8.465,0,0,1,8.467,8.462v0a8.465,8.465,0,0,1-8.462,8.467h0a8.465,8.465,0,0,1-8.467-8.462Z",
        "transform": "translate(-7.281 -7.281)"
      }
    })])]) : (result.content_type.id === 8) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.746",
        "height": "21.004",
        "viewBox": "0 0 15.746 21.004"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M24.417,11.02,20.972,7.579A1.97,1.97,0,0,0,19.582,7H11.219A1.975,1.975,0,0,0,9.25,8.974V26.032A1.969,1.969,0,0,0,11.219,28h11.81A1.97,1.97,0,0,0,25,26.032V12.414A1.982,1.982,0,0,0,24.417,11.02Zm-1.55,1.234h-3.12V9.134ZM11.219,26.032V8.974H17.78v4.264a.982.982,0,0,0,.98.984h4.269v11.81H11.219ZM21.483,20.14c-.511-.492-1.933-.363-2.645-.267a3.551,3.551,0,0,1-1.509-1.9,5.165,5.165,0,0,0,.222-2.3.914.914,0,0,0-1.75-.241,5.915,5.915,0,0,0,.289,2.751,33.027,33.027,0,0,1-1.451,3.051c-.816.422-1.927,1.074-2.091,1.894-.135.647,1.066,2.264,3.12-1.283a20.322,20.322,0,0,1,2.8-.825,5.45,5.45,0,0,0,2.288.7.947.947,0,0,0,.723-1.585h0Zm-8.128,3.19A4.918,4.918,0,0,1,14.6,21.9C13.822,23.136,13.354,23.358,13.354,23.33ZM16.7,15.515c.3,0,.275,1.317.073,1.673a3.433,3.433,0,0,1-.073-1.674Zm-1,5.6a16.12,16.12,0,0,0,1.012-2.242,4.513,4.513,0,0,0,1.235,1.456,13.949,13.949,0,0,0-2.248.786Zm5.4-.205s-.205.247-1.524-.315c1.433-.11,1.671.218,1.524.315Z",
        "transform": "translate(-9.25 -6.996)"
      }
    })])]) : (result.content_type.id === 9) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.75",
        "height": "21",
        "viewBox": "0 0 15.75 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M21.063,17.172a.493.493,0,0,0-.495-.492H13.683a.494.494,0,0,0-.492.492V18.32a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492Zm-.5,2.953H13.683a.494.494,0,0,0-.492.492v1.148a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492V20.617A.494.494,0,0,0,20.567,20.125ZM25,12.41a1.959,1.959,0,0,0-.583-1.385L20.975,7.583A1.97,1.97,0,0,0,19.584,7H11.219A1.97,1.97,0,0,0,9.25,8.969V26.032A1.969,1.969,0,0,0,11.219,28H23.032A1.971,1.971,0,0,0,25,26.032ZM19.75,9.129l3.121,3.121H19.75Zm3.282,16.9H11.219V8.969h6.563v4.265a.982.982,0,0,0,.98.985h4.27Z",
        "transform": "translate(-9.25 -7)"
      }
    })])]) : (result.content_type.id === 10) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "23.627",
        "height": "21",
        "viewBox": "0 0 23.627 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M20219.232-8589a.984.984,0,0,1-.98-.984.985.985,0,0,1,.98-.985h2.955l.656-1.971h-7.873a1.969,1.969,0,0,1-1.971-1.966v-13.128a1.969,1.969,0,0,1,1.971-1.966h19.686a1.969,1.969,0,0,1,1.971,1.966v13.128a1.976,1.976,0,0,1-1.971,1.971h-7.877l.66,1.966h2.951a.982.982,0,0,1,.949.949.986.986,0,0,1-.949,1.021Zm-3.605-6.566H20234v-11.813h-18.375Zm3.209-2.479a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h7a.58.58,0,0,1,.58.584v1.163a.58.58,0,0,1-.58.584Zm0-4.667a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h10.5a.584.584,0,0,1,.584.584v1.163a.584.584,0,0,1-.584.584Z",
        "transform": "translate(-20213 8609.998)"
      }
    })])]) : (result.content_type.id === 11) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "18.53",
        "height": "22.876",
        "viewBox": "0 0 18.53 22.876"
      }
    }, [_c('g', {
      attrs: {
        "transform": "translate(-8 -6.124)"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M18.744,14.421H11.87a.493.493,0,0,0-.492.492v1.147a.493.493,0,0,0,.492.492h6.425a5.959,5.959,0,0,1,.886-.275.486.486,0,0,0,.056-.217l0-1.147a.493.493,0,0,0-.5-.492Z",
        "transform": "translate(0.517 1.307)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M11.378,17.866v1.147a.493.493,0,0,0,.492.492h3a6.083,6.083,0,0,1,1.4-2.13h-4.4A.493.493,0,0,0,11.378,17.866Z",
        "transform": "translate(0.526 1.772)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M9.967,25.007V8.078h6.554V12.31a.978.978,0,0,0,.979.977h4.264v4.19a6.065,6.065,0,0,1,1.966.552V11.491a1.937,1.937,0,0,0-.583-1.374L19.71,6.7a1.974,1.974,0,0,0-1.389-.579H9.967A1.961,1.961,0,0,0,8,8.078V25.007A1.961,1.961,0,0,0,9.967,26.96h6.152a5.993,5.993,0,0,1-.9-1.953Zm8.52-16.77,3.117,3.1H18.486Z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M25.194,25.933l-1.815-1.815a.44.44,0,0,0-.31-.127h-.3a3.787,3.787,0,0,0-2.983-6.117h0A3.786,3.786,0,0,0,16,21.658v0a3.786,3.786,0,0,0,3.784,3.787h0a3.763,3.763,0,0,0,2.33-.8v.3a.44.44,0,0,0,.127.31l1.815,1.814a.437.437,0,0,0,.615,0l0,0,.515-.516A.441.441,0,0,0,25.194,25.933Zm-5.407-1.942a2.33,2.33,0,1,1,2.33-2.33A2.33,2.33,0,0,1,19.787,23.991Z",
        "transform": "translate(1.21 1.803)"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHighLightedResult(result.title))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "knowledge-base__content--search__result--text",
      domProps: {
        "innerHTML": _vm._s(_vm.getHighLightedResult(result.content))
      }
    })])
  }) : [_c('div', {
    staticClass: "knowledge-base__content--search__results--empty"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__results--empty__icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "22.5",
      "height": "30",
      "viewBox": "0 0 22.5 30"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15-26.25v7.5h7.5ZM10.313-11.719A3.285,3.285,0,0,0,7.031-8.437a3.285,3.285,0,0,0,3.281,3.281,3.285,3.285,0,0,0,3.281-3.281A3.285,3.285,0,0,0,10.313-11.719Zm2.813-7.031v-7.5H2.813A2.813,2.813,0,0,0,0-23.437V.938A2.813,2.813,0,0,0,2.813,3.75H19.688A2.813,2.813,0,0,0,22.5.938V-16.875H15A1.875,1.875,0,0,1,13.125-18.75Zm5.35,16.487a.937.937,0,0,1,0,1.326l-.663.663a.937.937,0,0,1-1.326,0L13.433-3.229a6.036,6.036,0,0,1-3.12.885A6.094,6.094,0,0,1,4.219-8.437a6.094,6.094,0,0,1,6.094-6.094,6.094,6.094,0,0,1,6.094,6.094,6.048,6.048,0,0,1-.955,3.249Z",
      "transform": "translate(0 26.25)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__results--empty__text"
  }, [_vm._v("\n                  No results found. Try again.\n                ")])])]] : [_vm._m(0)]], 2), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "knowledge-base__content--search__load-more"
  }, [_c('span', [_vm._v("Showing " + _vm._s(_vm.results.length) + " resources")]), _vm._v(" "), (_vm.moreResults) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._v("Load more resources")]) : _vm._e()]) : _vm._e()] : [_c('div', {
    staticClass: "knowledge-base__content--categories"
  }, [_c('div', {
    staticClass: "knowledge-base__content--category"
  }, [_c('div', {
    staticClass: "knowledge-base__content--category__title"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "16",
      "viewBox": "0 0 20 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M4-3a.973.973,0,0,1,.719.281A.973.973,0,0,1,5-2V1A.963.963,0,0,1,4,2H1A.963.963,0,0,1,0,1V-2a.973.973,0,0,1,.281-.719A.973.973,0,0,1,1-3ZM3.25-5.5V-4H1.75V-5.812a1.147,1.147,0,0,1,.344-.844A1.147,1.147,0,0,1,2.938-7H9.25V-9H8a.973.973,0,0,1-.719-.281A.973.973,0,0,1,7-10v-3a.973.973,0,0,1,.281-.719A.973.973,0,0,1,8-14h4a.973.973,0,0,1,.719.281A.973.973,0,0,1,13-13v3a.973.973,0,0,1-.281.719A.973.973,0,0,1,12-9H10.75v2h6.313a1.147,1.147,0,0,1,.844.344,1.147,1.147,0,0,1,.344.844V-4h-1.5V-5.5h-6V-4H9.25V-5.5ZM11.5-3a.973.973,0,0,1,.719.281A.973.973,0,0,1,12.5-2V1a.963.963,0,0,1-1,1h-3a.963.963,0,0,1-1-1V-2a.973.973,0,0,1,.281-.719A.973.973,0,0,1,8.5-3ZM19-3a.973.973,0,0,1,.719.281A.973.973,0,0,1,20-2V1a.963.963,0,0,1-1,1H16a.963.963,0,0,1-1-1V-2a.973.973,0,0,1,.281-.719A.973.973,0,0,1,16-3Z",
      "transform": "translate(0 14)"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Browse by Categories")])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--category__items"
  }, _vm._l((_vm.articleCategories), function(category) {
    return _c('a', {
      staticClass: "knowledge-base__content--category__item",
      attrs: {
        "aria-label": category.title
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateFilter(category, 'searchCategories')
        }
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--category__item--title"
    }, [(category.icon) ? _c('div', {
      staticClass: "knowledge-base__content--category__item--icon",
      domProps: {
        "innerHTML": _vm._s(category.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(category.title))])]), _vm._v(" "), (category.description && category.description !== '') ? _c('div', {
      staticClass: "knowledge-base__content--category__item--text"
    }, [_vm._v(_vm._s(category.description))]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--category"
  }, [_c('div', {
    staticClass: "knowledge-base__content--category__title"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M0-12.125a.838.838,0,0,1,.266-.609A.838.838,0,0,1,.875-13H6.719a1.658,1.658,0,0,1,1.219.5L13.5-6.937A1.658,1.658,0,0,1,14-5.719a1.764,1.764,0,0,1-.5,1.25L8.531.5a1.764,1.764,0,0,1-1.25.5A1.658,1.658,0,0,1,6.063.5L.5-5.062A1.658,1.658,0,0,1,0-6.281Zm2.781,1.906A.973.973,0,0,0,2.5-9.5a.973.973,0,0,0,.281.719A.973.973,0,0,0,3.5-8.5a.973.973,0,0,0,.719-.281A.973.973,0,0,0,4.5-9.5a.973.973,0,0,0-.281-.719A.973.973,0,0,0,3.5-10.5.973.973,0,0,0,2.781-10.219Z",
      "transform": "translate(0 13)"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Browse by Topics")])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--category__items"
  }, _vm._l((_vm.articleTopics.slice(0, 4)), function(topic) {
    return _c('a', {
      staticClass: "knowledge-base__content--category__item",
      attrs: {
        "aria-label": topic.title
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateFilter(topic, 'searchTopics')
        }
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--category__item--title"
    }, [(topic.icon) ? _c('div', {
      staticClass: "knowledge-base__content--category__item--icon topic-icon",
      domProps: {
        "innerHTML": _vm._s(topic.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(topic.title))])]), _vm._v(" "), (topic.description && topic.description !== '') ? _c('div', {
      staticClass: "knowledge-base__content--category__item--text"
    }, [_vm._v(_vm._s(topic.description))]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__all"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics__content"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__items"
  }, _vm._l((_vm.articleTopics), function(topic) {
    return _c('a', {
      staticClass: "knowledge-base__content--topics__item",
      attrs: {
        "aria-label": topic.title
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateFilter(topic, 'searchTopics')
        }
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--topics__item--title"
    }, [(topic.icon) ? _c('div', {
      staticClass: "knowledge-base__content--topics__item--icon topic-icon",
      domProps: {
        "innerHTML": _vm._s(topic.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(topic.title))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics__suggest"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics__content"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__suggest--container"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__suggest--text"
  }, [_vm._v("\n                  We are permanently looking to enrich the inclusion hub. If you'd like to read resources on other topics, share with us what topics you are interested in and we'll do our best to cover those subjects.\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "knowledge-base__content--topics__suggest--button",
    on: {
      "click": function($event) {
        return _vm.activateTopicSuggestion()
      }
    }
  }, [_vm._v("\n                  Suggest topic\n                ")])])])])])]], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base__content--search__results--empty"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__results--empty__icon"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__results--empty__text"
  }, [_vm._v("\n                Loading search results\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base__content--topics__title"
  }, [_c('h2', [_vm._v("All topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base__content--topics__title"
  }, [_c('h2', [_vm._v("Suggest us a new topic!")])])
}]}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "management"
  }, [_c('h1', [_vm._v("Create User")]), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.username),
      expression: "formInfo.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "First Name",
      "data-vv-as": "\"First Name\"",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.formInfo.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('First Name')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('First Name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.lastName),
      expression: "formInfo.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Last Name",
      "data-vv-as": "\"Last Name\"",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.formInfo.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Last Name')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Last Name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.email),
      expression: "formInfo.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "Email Address",
      "data-vv-as": "\"Email Address\"",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.formInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Email Address')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Email Address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.plainPassword.first),
      expression: "formInfo.plainPassword.first"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "PasswordFirst",
      "data-vv-as": "\"PasswordFirst\"",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.formInfo.plainPassword.first)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('PasswordFirst')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('PasswordFirst')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.plainPassword.second),
      expression: "formInfo.plainPassword.second"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:PasswordFirst'),
      expression: "'required|confirmed:PasswordFirst'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "PasswordSecond",
      "data-vv-as": "\"PasswordSecond\"",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.formInfo.plainPassword.second)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('PasswordSecond')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('PasswordSecond')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control--select",
    attrs: {
      "placeholder": "Function",
      "name": "Function",
      "data-vv-name": "Function",
      "data-vv-as": "\"Function\"",
      "options": _vm.functionOptions
    },
    model: {
      value: (_vm.formInfo.function),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "function", $$v)
      },
      expression: "formInfo.function"
    }
  }), _vm._v(" "), (_vm.errors.has('Function')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Function')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control--select",
    attrs: {
      "placeholder": "User Role",
      "name": "userRole",
      "data-vv-name": "userRole",
      "data-vv-as": "\"userRole\"",
      "options": _vm.getRolesForSelect
    },
    model: {
      value: (_vm.userRole),
      callback: function($$v) {
        _vm.userRole = $$v
      },
      expression: "userRole"
    }
  }), _vm._v(" "), (_vm.errors.has('userRole')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('userRole')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.jobTitle),
      expression: "formInfo.jobTitle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Job Title",
      "data-vv-as": "\"Job Title\"",
      "placeholder": "Job Title"
    },
    domProps: {
      "value": (_vm.formInfo.jobTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "jobTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Job Title')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Job Title')))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "form-control form-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create User")]), _vm._v(" "), _c('form-messages', {
    attrs: {
      "messages": _vm.formServerMessages
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page company-landing"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section no-padding-top"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [(_vm.activatePage) ? _c('div', {
    ref: "informationMsg",
    staticClass: "inform-popup success",
    attrs: {
      "id": "information-message"
    }
  }, [_c('div', {
    staticClass: "inform-message-inner"
  }, [_c('div', {
    staticClass: "inform-title"
  }, [_vm._v("\n                    Your account was successfully activated.\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "inform-content"
  }, [_vm._v("\n                    Please use the temporary credentials from your invitation email to login.\n                  ")]), _vm._v(" "), _c('a', {
    staticClass: "inform-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeCustomMsg()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-login"
  }, [_c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        return _vm.authenticate()
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.email),
      expression: "loginForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-50': _vm.loginForm.email !== '' || _vm.loginForm.emailFocus,
      'not-empty': _vm.loginForm.email !== '' || _vm.loginForm.emailFocus,
      'has-error': _vm.loginForm.isError || _vm.errors.has('Email address')
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email",
      "placeholder": "Type in here...",
      "data-vv-name": "Email address"
    },
    domProps: {
      "value": (_vm.loginForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password"
    }
  }, [_vm._v("Password*")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword()
      }
    }
  }), _vm._v(" "), ((_vm.loginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'not-empty': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'has-error': _vm.loginForm.isError || _vm.errors.has('Password')
    }],
    attrs: {
      "id": "landing-page-login-password",
      "placeholder": "Type in here...",
      "data-vv-name": "Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginForm.password) ? _vm._i(_vm.loginForm.password, null) > -1 : (_vm.loginForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.loginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.loginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.loginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.loginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.loginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'not-empty': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'has-error': _vm.loginForm.isError || _vm.errors.has('Password')
    }],
    attrs: {
      "id": "landing-page-login-password",
      "placeholder": "Type in here...",
      "data-vv-name": "Password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.loginForm.password, null)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.loginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'not-empty': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'has-error': _vm.loginForm.isError || _vm.errors.has('Password')
    }],
    attrs: {
      "id": "landing-page-login-password",
      "placeholder": "Type in here...",
      "data-vv-name": "Password",
      "type": _vm.loginForm.passwordType
    },
    domProps: {
      "value": (_vm.loginForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('button', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.formStatus.submitting
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate('top')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("Forgot password?")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-footer"
  }, [_c('div', {
    staticClass: "landing-page-login-footer__top"
  }, [_vm._v("\n                    Don't have an account? "), _c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign up here")]), _vm._v(".\n                  ")], 1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-footer__bottom"
  }, [_vm._v("\n                    Struggling with something? Tell us about it "), _c('router-link', {
    attrs: {
      "to": "/need-help"
    }
  }, [_vm._v("here")]), _vm._v(".\n                  ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                    Submitting\n                  ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-envelope",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-envelope",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM384 320c0 17.67-14.33 32-32 32H160c-17.67 0-32-14.33-32-32V238l122.1 48.82C251.1 287.6 253.1 288 256 288s4.031-.375 5.938-1.141L384 238V320zM384 203.6l-128 51.2L128 203.6V192c0-17.67 14.33-32 32-32h192c17.67 0 32 14.33 32 32V203.6z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                        " + _vm._s(_vm.formStatus.title) + "\n                      ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.formStatus.body) + "\n                      ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                        Some fields are missing.\n                      ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.contactCTA.hideSection || _vm.content.contactCTA.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.contactCTA.hideSection || content.contactCTA.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper contact-cta-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.hideSection),
      expression: "content.contactCTA.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showContactCTA"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.contactCTA.hideSection) ? _vm._i(_vm.content.contactCTA.hideSection, null) > -1 : (_vm.content.contactCTA.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.contactCTA.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.contactCTA, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showContactCTA'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_c('div', {
    staticClass: "contact-cta--content__title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.contactCTA.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.title),
      expression: "content.contactCTA.title"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactCTA.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactCTA, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactCTA.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions",
    class: _vm.pageEditMode ? 'edit-mode' : ''
  }, [_vm._l((_vm.content.contactCTA.buttons), function(button) {
    return [(_vm.pageEditMode) ? [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.text),
        expression: "button.text"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button text"
      },
      domProps: {
        "value": (button.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "text", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.link),
        expression: "button.link"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button link"
      },
      domProps: {
        "value": (button.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "link", $event.target.value)
        }
      }
    })])])] : [_c('a', {
      attrs: {
        "href": button.link
      }
    }, [_vm._v(_vm._s(button.text))])]]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('contact-cta-button')
      }
    }
  }, [_vm._v("+ Add button")]) : _vm._e()], 2)])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    ref: "pageMetaPopup",
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "post-title color-1-100 background-1-10-after"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statusbar"
  }, [_c('status', {
    attrs: {
      "status": _vm.status
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time-ago"
  }, [_vm._v("\n        Last edited: "), _c('timeago', {
    attrs: {
      "since": _vm.updatedAt
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown v-select",
    class: _vm.dropdownClasses,
    attrs: {
      "dir": _vm.dir
    }
  }, [_c('div', {
    ref: "toggle",
    staticClass: "dropdown-toggle",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggleDropdown($event)
      }
    }
  }, [_c('div', {
    ref: "selectedOptions",
    staticClass: "vs__selected-options"
  }, [_c('input', {
    ref: "search",
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "autocomplete": _vm.autocomplete,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "tabindex": _vm.tabindex,
      "readonly": !_vm.searchable,
      "id": _vm.inputId,
      "role": "combobox",
      "aria-expanded": _vm.dropdownOpen,
      "aria-label": "Search for option"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.onEscape($event)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.typeAheadUp($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.typeAheadDown($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.typeAheadSelect($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.onTab($event)
      }],
      "blur": _vm.onSearchBlur,
      "focus": _vm.onSearchFocus,
      "input": function($event) {
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vs__actions"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClearButton),
      expression: "showClearButton"
    }],
    staticClass: "clear",
    attrs: {
      "disabled": _vm.disabled,
      "type": "button",
      "title": "Clear selection"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), (!_vm.noDrop) ? _c('i', {
    ref: "openIndicator",
    staticClass: "open-indicator",
    attrs: {
      "role": "presentation"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("spinner", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mutableLoading),
      expression: "mutableLoading"
    }],
    staticClass: "spinner"
  }, [_vm._v("Loading...")])])], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.dropdownOpen) ? _c('ul', {
    ref: "dropdownMenu",
    staticClass: "dropdown-menu",
    style: ({
      'max-height': _vm.maxHeight
    }),
    attrs: {
      "role": "listbox"
    },
    on: {
      "mousedown": _vm.onMousedown,
      "mouseup": _vm.onMouseup
    }
  }, [_vm._l((_vm.filteredOptions), function(option, index) {
    var _obj;

    return _c('li', {
      key: index,
      class: {
        active: _vm.isOptionSelected(option), highlight: index === _vm.typeAheadPointer, 'child': option.level && option.level === 2
      },
      attrs: {
        "role": "option"
      },
      on: {
        "mouseover": function($event) {
          _vm.typeAheadPointer = index
        }
      }
    }, [_c('a', {
      class: {
        'child': option.level && option.level === 2
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.select(option)
        }
      }
    }, [_vm._t("option", [_vm._v("\n            " + _vm._s(_vm.getOptionLabel(option)) + "\n          ")], null, (typeof option === 'object') ? option : ( _obj = {}, _obj[_vm.label] = option, _obj ))], 2)])
  }), _vm._v(" "), (!_vm.filteredOptions.length) ? _c('li', {
    staticClass: "no-options",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("no-options", [_vm._v("Sorry, no matching options.")])], 2) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage company-landing"
  }, [(_vm.disableAPI) ? _c('div', {
    staticClass: "loading-data-wrapper"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-register"
  }, [_c('div', {
    staticClass: "hero-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "tcc-form",
    on: {
      "submit": function($event) {
        return _vm.submitCallbackRequest()
      }
    }
  }, [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.name),
      expression: "registerForm.name"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'not-empty': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'has-error': _vm.errors.has('First name')
    }],
    attrs: {
      "id": "register-name",
      "data-lpignore": "true",
      "type": "text",
      "name": "First name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.name)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.nameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.nameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.surname),
      expression: "registerForm.surname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'not-empty': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'has-error': _vm.errors.has('Last name')
    }],
    attrs: {
      "id": "register-surname",
      "data-lpignore": "true",
      "type": "text",
      "name": "Last name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.surname)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.surnameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.surnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-job"
    }
  }, [_vm._v("Job title*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.jobTitle),
      expression: "registerForm.jobTitle"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.jobTitle !== '' || _vm.registerForm.jobTitleFocus,
      'not-empty': _vm.registerForm.jobTitle !== '' || _vm.registerForm.jobTitleFocus,
      'has-error': _vm.errors.has('Job title')
    }],
    attrs: {
      "id": "register-job",
      "data-lpignore": "true",
      "type": "text",
      "name": "Job title",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.jobTitle)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.jobTitleFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.jobTitleFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "jobTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Job title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Job title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-company"
    }
  }, [_vm._v("Company name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.companyName),
      expression: "registerForm.companyName"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.companyName !== '' || _vm.registerForm.companyNameFocus,
      'not-empty': _vm.registerForm.companyName !== '' || _vm.registerForm.companyNameFocus,
      'has-error': _vm.errors.has('Company name')
    }],
    attrs: {
      "id": "register-company",
      "data-lpignore": "true",
      "type": "text",
      "name": "Company name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.companyName)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.companyNameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.companyNameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-phone"
    }
  }, [_vm._v("Phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.phone),
      expression: "registerForm.phone"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.phone !== '' || _vm.registerForm.phoneFocus,
      'not-empty': _vm.registerForm.phone !== '' || _vm.registerForm.phoneFocus,
      'has-error': _vm.errors.has('Phone number')
    }],
    attrs: {
      "id": "register-phone",
      "data-lpignore": "true",
      "type": "text",
      "name": "Phone number",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.phone)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.phoneFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.phoneFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.email),
      expression: "registerForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'not-empty': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'has-error': _vm.errors.has('Email address')
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email address",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "callback-request-message-info",
    attrs: {
      "id": "messageDescription"
    }
  }, [_vm._v("Let us know why you're getting in touch.")]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-message"
    }
  }, [_vm._v("Your message*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.message),
      expression: "registerForm.message"
    }],
    staticClass: "tcc-form-element tcc-form-element__textarea",
    class: [{
      'border-1-20': _vm.registerForm.message !== '' || _vm.registerForm.messageFocus,
      'not-empty': _vm.registerForm.message !== '' || _vm.registerForm.messageFocus,
      'has-error': _vm.errors.has('Your message')
    }],
    attrs: {
      "id": "register-message",
      "data-lpignore": "true",
      "type": "text",
      "name": "Your message",
      "aria-describedby": "messageDescription",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.message)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.messageFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.messageFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Your message')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Your message')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-register-terms"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.terms),
      expression: "registerForm.terms"
    }],
    staticClass: "tcc-form-element tcc-form-element__checkbox",
    class: [{
      'has-error': _vm.errors.has('Terms and Conditions')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "register-terms",
      "name": "Terms and Conditions"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.terms) ? _vm._i(_vm.registerForm.terms, null) > -1 : (_vm.registerForm.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registerForm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "terms", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "terms", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "terms", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "register-terms"
    }
  }, [_vm._v("Agree to the Clear Assured "), _c('router-link', {
    attrs: {
      "to": "/terms-of-service"
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v("*.")], 1), _vm._v(" "), (this.errors.has('Terms and Conditions')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Terms and Conditions')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.privacy),
      expression: "registerForm.privacy"
    }],
    staticClass: "tcc-form-element tcc-form-element__checkbox",
    class: [{
      'has-error': _vm.errors.has('Privacy policy')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "register-privacy",
      "name": "Privacy policy"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.privacy) ? _vm._i(_vm.registerForm.privacy, null) > -1 : (_vm.registerForm.privacy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registerForm.privacy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "privacy", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "privacy", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "privacy", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "register-privacy"
    }
  }, [_vm._v("Agree to the Clear Assured "), _c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v("*.")], 1), _vm._v(" "), (this.errors.has('Privacy policy')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Privacy policy')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action",
    class: [{
      'submitting': _vm.formStatus.submitting
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitCallbackRequest()
      }
    }
  }, [_vm._v("\n                    Submit callback request\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                    Submitting\n                  ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                        " + _vm._s(_vm.formStatus.title) + "\n                      ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.formStatus.body) + "\n                      ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                        Some fields are missing.\n                      ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tcc-form"
  }, [_c('div', {
    attrs: {
      "id": "callbackRequestForm"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Fields marked with an asterisk ("), _c('span', [_vm._v("*")]), _vm._v(") are mandatory.")])
}]}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('router-link', {
    staticClass: "login background-1-100",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact us")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n            It looks like you don’t have permission to access this page\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description text-left"
  }, [_vm._v("\n          Unfortunately, your membership level doesn’t allow you to access this page."), _c('br'), _vm._v("\n          If you’d like to find out more about how this works and how you can be granted access to this page and others, please get in touch with us.\n        ")])
}]}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password custom-left-align"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("\n          Your invitation is either expired or was already used\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          The invitation link you used is not working. This may happen because:\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.email !== '' || _vm.topLoginForm.emailFocus,
      'has-error': _vm.topLoginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.email),
      expression: "topLoginForm.email"
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.topLoginForm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus,
      'has-error': _vm.topLoginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('top')
      }
    }
  }), _vm._v(" "), ((_vm.topLoginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.topLoginForm.password) ? _vm._i(_vm.topLoginForm.password, null) > -1 : (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.topLoginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.topLoginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.topLoginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.topLoginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.topLoginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.topLoginForm.password, null)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.topLoginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": _vm.topLoginForm.passwordType
    },
    domProps: {
      "value": (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.topLoginForm.isError) ? _c('div', {
    staticClass: "login-form-error"
  }, [_vm._v("\n            " + _vm._s(_vm.topLoginForm.loginErrorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions custom-left-align-actions"
  }, [_c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.topLoginForm.loginInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate('top')
      }
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("\n            Your invitation was sent more than 30 days ago or your invitation was revoked. In this case, please ask the person who invited you to do it again.\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            You may have already activated your account.If so, please check your invitation email for the temporary\n            credentials we sent you and try to login using the form below. Otherwise, please contact support.team@clearassured.co.uk\n          ")])])
}]}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditColors) ? [_vm._v("\n        Edit industry colors:\n      ")] : _vm._e(), _vm._v(" "), (_vm.canEditLogo) ? [_vm._v("\n        Edit industry colors:\n      ")] : _vm._e(), _vm._v("\n      " + _vm._s(this.industry.details.name) + "\n    ")], 2), _vm._v(" "), _c('div', {
    staticClass: "profile-actions float-none"
  }, [_c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    class: [{
      'not-allowed': (_vm.industry.details.companies && _vm.industry.details.companies.length) || _vm.industry.details.id === 1
    }],
    attrs: {
      "title": _vm.deleteMessage()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteIndustry()
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), (_vm.resetNeeded) ? _c('button', {
    staticClass: "reset-btn background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetToDefault()
      }
    }
  }, [_vm._v("\n        Reset to default\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": {
        name: 'edit-industry',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Basic data")]), _vm._v(" "), (_vm.landing) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-landing',
        params: {
          id: _vm.landing
        }
      }
    }
  }, [_vm._v("Landing")]) : _vm._e(), _vm._v(" "), (!_vm.landing) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createLanding()
      }
    }
  }, [_vm._v("Create landing")]) : _vm._e(), _vm._v(" "), (_vm.registrationLanding) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-registration-landing',
        params: {
          industry: _vm.registrationLanding,
          company: 'default'
        }
      }
    }
  }, [_vm._v("Registration landing")]) : _vm._e(), _vm._v(" "), (!_vm.registrationLanding) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createRegistrationLanding()
      }
    }
  }, [_vm._v("Create registration landing")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'edit-industry-emails',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom emails")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies active",
    attrs: {
      "to": {
        name: 'edit-industry-styling',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom email and website styling")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "industryColors",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditColors === false) ? [_vm._v("Industry colors")] : [_vm._v("Edit industry colors")]], 2), _vm._v(" "), (_vm.canEditColors === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditColors()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideDatepicker),
      expression: "hideDatepicker"
    }],
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "main-color-one"
    }
  }, [_vm._v("Main color one")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.mainColorOne),
      expression: "industry.details.mainColorOne"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Main color one')
    }],
    attrs: {
      "type": "color",
      "disabled": _vm.canEditColors === false,
      "data-lpignore": "true",
      "id": "main-color-one",
      "name": "Main color one"
    },
    domProps: {
      "value": (_vm.industry.details.mainColorOne)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "mainColorOne", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Main color one')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                " + _vm._s(this.errors.first('Main color one')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideDatepicker),
      expression: "hideDatepicker"
    }],
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "main-color-two"
    }
  }, [_vm._v("Main color two")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.mainColorTwo),
      expression: "industry.details.mainColorTwo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Main color two')
    }],
    attrs: {
      "type": "color",
      "disabled": _vm.canEditColors === false,
      "data-lpignore": "true",
      "id": "main-color-two",
      "name": "Main color two"
    },
    domProps: {
      "value": (_vm.industry.details.mainColorTwo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "mainColorTwo", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Main color two')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                " + _vm._s(this.errors.first('Main color two')) + "\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditColors) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditColors()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryColors()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industryLogo",
    staticClass: "content-section content-section__bordered border-1-20",
    class: [{
      'content-section__dark': _vm.canEditLogo === false
    }]
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditLogo === false) ? [_vm._v("Industry logo")] : [_vm._v("Edit industry logo")]], 2), _vm._v(" "), (_vm.canEditLogo === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditLogo()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.canEditLogo === true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "sponsor-list"
  }, [_c('div', {
    staticClass: "sponsor-item"
  }, [_c('div', {
    staticClass: "sponsor-item-logo sponsor-item-logo-industry",
    attrs: {
      "id": 'uploadLogo'
    }
  }, [(_vm.industry.details.customLogo !== null) ? _c('div', {
    staticClass: "sponsor-item-logo__image sponsor-item-logo__image-industry",
    style: ({
      backgroundImage: _vm.getImage(_vm.industry.details.customLogo)
    })
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.industry.details.customLogo === null),
      expression: "industry.details.customLogo === null"
    }],
    staticClass: "form-label color-2-63 form-label__logo-upload",
    class: [{
      'disabled': _vm.canEditLogo === false
    }],
    attrs: {
      "for": 'uploadInput'
    }
  }, [_vm._v("\n                    +Upload logo\n                    "), (_vm.industry.details.customLogo === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "disabled": _vm.canEditLogo === false,
      "id": 'uploadInput',
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "industry.details.customLogo",
      "placeholder": "+Upload logo"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.industry.details.customLogo !== null) ? _c('div', {
    staticClass: "sponsor-item-logo__remove",
    on: {
      "click": function($event) {
        return _vm.removeLogo()
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('span', {
    staticClass: "sponsor-item-logo__info"
  }, [_vm._v("\n              Max size: 275px / 75px. Recommended: 275px / 35px.\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.canEditLogo === false) ? _c('div', {
    staticClass: "sponsors-list__edit"
  }, [(_vm.industry.details.customLogo !== '') ? _c('div', {
    staticClass: "sponsor-item"
  }, [_c('div', {
    staticClass: "sponsor-item-logo",
    attrs: {
      "id": 'uploadLogo'
    }
  }, [_c('img', {
    staticClass: "sponsor-item-logo__image",
    attrs: {
      "src": _vm.getImageFullPath(_vm.industry.details.customLogo)
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditLogo) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditLogo()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryLogo()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before"
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 colors",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryColors'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryColors')
      }
    }
  }, [_vm._v("Industry colors")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 sponsors",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryLogo'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryLogo')
      }
    }
  }, [_vm._v("Industry logo")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page admin-dashboard"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Welcome to your dashboard!")]), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 companies",
    class: [{
      'active  color-1-100': _vm.activeSection === 'dashboardCompanies'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('dashboardCompanies')
      }
    }
  }, [_vm._v("Companies and Users")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 searches",
    class: [{
      'active  color-1-100': _vm.activeSection === 'dashboardSearches'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('dashboardSearches')
      }
    }
  }, [_vm._v("Popular Searches")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "dashboardCompanies",
    staticClass: "content-section company-section no-margin-top",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n          Companies and users\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "companies-section"
  }, [_c('div', {
    staticClass: "section-head has-icon"
  }, [_c('span', {
    staticClass: "section-title company-icon"
  }, [_vm._v("\n                Companies\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('router-link', {
    staticClass: "action-all",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("See all")]), _vm._v(" "), _c('router-link', {
    staticClass: "action-add",
    attrs: {
      "to": {
        name: 'add-company'
      }
    }
  }, [_vm._v("Add new")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.companies), function(count, index) {
    return _c('router-link', {
      key: index,
      staticClass: "section-item",
      attrs: {
        "to": {
          name: 'companies',
          query: {
            status: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(_vm.getCompanyStatus(index)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(count))]), _vm._v(" "), _c('span', {
      staticClass: "item-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "users-section"
  }, [_c('div', {
    staticClass: "section-head has-icon"
  }, [_c('span', {
    staticClass: "section-title user-icon"
  }, [_vm._v("\n                Users\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('router-link', {
    staticClass: "action-all",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("See all")]), _vm._v(" "), _c('router-link', {
    staticClass: "action-add",
    attrs: {
      "to": {
        name: 'add-user'
      }
    }
  }, [_vm._v("Add new")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.users), function(user) {
    return _c('router-link', {
      key: user.slug,
      staticClass: "section-item",
      attrs: {
        "to": {
          name: 'users',
          query: {
            role: user.slug
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(_vm.getUserRoleName(user.slug)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(user.c))]), _vm._v(" "), _c('span', {
      staticClass: "item-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "dashboardSearches",
    staticClass: "content-section searches-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n          Popular searches in the past 30 days\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "companies-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.topZeroSearch), function(item) {
    return _c('div', {
      staticClass: "section-item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(item.search) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(item.count))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "users-section"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.topSearch), function(item) {
    return _c('div', {
      staticClass: "section-item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(item.search) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(item.count))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n                Searches with 0 results\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n                Searches with results\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user-template"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [(_vm.downloadInProcess) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-text"
  }, [_vm._v("loading ...")])]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Logs")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "email-logs",
    attrs: {
      "to": {
        name: 'email-logs'
      }
    }
  }, [_vm._v("Email logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "dashboard active",
    attrs: {
      "to": {
        name: 'consent-logs'
      }
    }
  }, [_vm._v("Consent logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "ttd-logs",
    attrs: {
      "to": {
        name: 'logs'
      }
    }
  }, [_vm._v("Logs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [(!_vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-statusbar",
    staticStyle: {
      "margin": "0 15px 20px"
    }
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.logsCount) + " logs")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadConsentLogs()
      }
    }
  }, [_vm._v("Download consent logs")])]), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.logs.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [((_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) && _vm.selectedFilters.length) ? _c('tr', {
    staticClass: "inside-table-filters"
  }, [_c('th', {
    attrs: {
      "colspan": "9"
    }
  }, [_c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getUsersForSelect)
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(1)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getUsersForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 1),
      expression: "filerTableHead.selectedCeil === 1"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-1",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getUsersForSelect
    },
    model: {
      value: (_vm.logsUser),
      callback: function($$v) {
        _vm.logsUser = $$v
      },
      expression: "logsUser"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getEmailsForSelect),
        'locked-ceil-head': _vm.emailFilterLocked
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getEmailsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getEmailsForSelect
    },
    model: {
      value: (_vm.logsEmail),
      callback: function($$v) {
        _vm.logsEmail = $$v
      },
      expression: "logsEmail"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-role-head table-head-hover table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect),
        'locked-ceil-head': _vm.companyFilterLocked
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getCompaniesForSelect
    },
    model: {
      value: (_vm.logsCompany),
      callback: function($$v) {
        _vm.logsCompany = $$v
      },
      expression: "logsCompany"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getActionsForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getActionsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getActionsForSelect
    },
    model: {
      value: (_vm.logsAction),
      callback: function($$v) {
        _vm.logsAction = $$v
      },
      expression: "logsAction"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy(true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.logOrderBy !== null && this.logOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.logOrderBy !== null && !this.logOrderBy.order
    }
  })])])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log, i) {
    return _c('tr', [_c('td', {
      staticClass: "name-cell cellpadding",
      attrs: {
        "data-title": "User:"
      }
    }, [_vm._v(_vm._s(_vm.getUser(log)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Email:"
      }
    }, [_vm._v(_vm._s(_vm.getEmail(log)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Company:"
      }
    }, [_vm._v(_vm._s(log.companyName ? log.companyName : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "role-cell cellpadding",
      attrs: {
        "data-title": "Action:"
      }
    }, [_vm._v(_vm._s(_vm.getActionName(log)))]), _vm._v(" "), _c('td', {
      staticClass: "created-cell cellpadding text-center",
      attrs: {
        "data-title": "Date and time:"
      }
    }, [_vm._v(_vm._s(_vm.convertDate(log.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "last-login-cell cellpadding text-center",
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "data-title": "Details:"
      }
    }, [_vm._v(_vm._s(log.action ? log.action : 'n/a'))])])
  }), 0)]), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "fixed",
      "left": "-2000px",
      "bottom": "-2000px"
    },
    attrs: {
      "href": "#",
      "id": "consentDownload"
    }
  }, [_vm._v("download")]), _vm._v(" "), (this.logs.length < this.logsCount) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(6), _vm._v("Load more\n        ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("User")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Date and time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "column-active-head table-head-ceil"
  }, [_c('div', {
    staticClass: "caption-head"
  }, [_c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Details")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cellpadding column-id-head table-head-ceil"
  }, [_c('articleId')], 1), _vm._v(" "), _c('th', {
    staticClass: "articles-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_c('searchInArticles')], 1), _vm._v(" "), _c('th', {
    staticClass: "column-lng-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getLanguagesForSelect)
    },
    on: {
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getLanguagesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('languageArticles')], 1), _vm._v(" "), _c('th', [_c('typeArticles')], 1), _vm._v(" "), _c('th', [_c('topicsArticle')], 1), _vm._v(" "), _c('th', [_c('categoryArticles')], 1), _vm._v(" "), _c('th', [_c('accessArticle')], 1), _vm._v(" "), _c('th', [_c('companySpecificArticles')], 1), _vm._v(" "), _c('th', [_c('lastEditedArticles')], 1), _vm._v(" "), _c('th', [_c('uploaderEditorArticles')], 1), _vm._v(" "), _c('th', [_c('statusArticles')], 1), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('actionsArticles')], 1)])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "cellpadding"
  }, [_c('button', {
    staticClass: "table-crud-btn icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editArticle(_vm.article.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "table-tooltip-edit"
  }, [_vm._v("Edit")])], 1)]), _vm._v(" "), _c('td', {
    staticClass: "cellpadding"
  }, [_c('button', {
    staticClass: "table-crud-btn icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.initAction('removeArticle', {
          articleId: _vm.article.id,
          i: _vm.i
        })
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articles-list"
  }, [_c('div', {
    staticClass: "articles-list-heading"
  })])
}]}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Uploader / Editor")])])
}]}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive || _vm.isStop),
      expression: "isActive || isStop"
    }],
    staticClass: "wrap-spiner",
    attrs: {
      "id": "spiner"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article"
  }, [_c('div', {
    attrs: {
      "id": "headerPlaceholder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__header"
  }, [_c('div', {
    staticClass: "article__container article__header--container"
  }, [_c('router-link', {
    staticClass: "article__header--button",
    attrs: {
      "to": {
        name: 'todo-list'
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n        Back\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "article__header--actions"
  }, [_c('button', {
    staticClass: "blue-border-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(_vm.entity.status, true, false)
      }
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('button', {
    staticClass: "light-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(0)
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('button', {
    staticClass: "dark-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(1)
      }
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('button', {
    staticClass: "gray-border-btn",
    on: {
      "click": function($event) {
        return _vm.goToAllArticles()
      }
    }
  }, [_vm._v("Exit without saving")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__content"
  }, [_c('div', {
    staticClass: "article__container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article__content--editor"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleEditBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Edit task")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleEditBoxActive = !_vm.articleEditBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label"
  }, [_vm._v("Task content")]), _vm._v(" "), _c('Vueditor', {
    ref: "contentEditor",
    staticClass: "form-control__editor"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--fourth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "title",
      "data-vv-name": "Title",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "topic"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Topic')
    }],
    attrs: {
      "searchable": false,
      "multiple": true,
      "options": _vm.getTagsForSelect,
      "data-vv-name": "Topic",
      "data-lpignore": "true",
      "name": "topic",
      "id": "topic"
    },
    model: {
      value: (_vm.entity.topic),
      callback: function($$v) {
        _vm.$set(_vm.entity, "topic", $$v)
      },
      expression: "entity.topic"
    }
  }), _vm._v(" "), (this.errors.has('Topic')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Topic')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Type')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getContentTypeForSelect,
      "data-vv-name": "Type",
      "data-lpignore": "true",
      "name": "type",
      "id": "type"
    },
    model: {
      value: (_vm.entity.type),
      callback: function($$v) {
        _vm.$set(_vm.entity, "type", $$v)
      },
      expression: "entity.type"
    }
  }), _vm._v(" "), (this.errors.has('Type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Type')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Category')
    }],
    attrs: {
      "searchable": false,
      "multiple": false,
      "options": _vm.getContentChapterForSelect,
      "data-vv-name": "Category",
      "data-lpignore": "true",
      "name": "category",
      "id": "category"
    },
    model: {
      value: (_vm.entity.chapter),
      callback: function($$v) {
        _vm.$set(_vm.entity, "chapter", $$v)
      },
      expression: "entity.chapter"
    }
  }), _vm._v(" "), (this.errors.has('Category')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Category')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-element article__featured-image"
  }, [_c('span', {
    staticClass: "article__form-label"
  }, [_vm._v("Featured image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded),
      expression: "!isThumbnailFileUploaded"
    }],
    staticClass: "article__form-label article__form-label--file-upload"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "24",
      "viewBox": "0 0 32 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M29,0a3,3,0,0,0,3-3V-21a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3V-3A3,3,0,0,0,3,0ZM7-20.5A3.5,3.5,0,0,1,10.5-17,3.5,3.5,0,0,1,7-13.5,3.5,3.5,0,0,1,3.5-17,3.5,3.5,0,0,1,7-20.5ZM4-4V-7l4.47-4.47a.75.75,0,0,1,1.061,0L13-8l8.47-8.47a.75.75,0,0,1,1.061,0L28-11v7Z",
      "transform": "translate(0 24)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.altImage),
      expression: "entity.altImage"
    }],
    staticClass: "form-control form-control__textarea has-no-label",
    class: {
      'is-blocked': !_vm.isThumbnailFileUploaded
    },
    attrs: {
      "disabled": !_vm.isThumbnailFileUploaded,
      "data-lpignore": "true",
      "id": "image",
      "placeholder": _vm.isThumbnailFileUploaded ? 'Type in Alt text for the image...' : '',
      "data-vv-name": "Image alt",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "altImage", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__container"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleAccessBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Access Settings")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleAccessBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleAccessBoxActive = !_vm.articleAccessBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleAccessBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-specific"
    }
  }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Company specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getCompaniesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'industry') || _vm.isExcluded !== null,
      "data-vv-name": "Company specific",
      "data-lpignore": "true",
      "name": "company",
      "id": "company-specific"
    },
    model: {
      value: (_vm.entity.company),
      callback: function($$v) {
        _vm.$set(_vm.entity, "company", $$v)
      },
      expression: "entity.company"
    }
  }), _vm._v(" "), (this.errors.has('Company specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-specific"
    }
  }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Industry specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getIndustriesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'company') || _vm.isExcluded !== null,
      "data-vv-name": "Industry specific",
      "data-lpignore": "true",
      "name": "industry",
      "id": "industry-specific"
    },
    model: {
      value: (_vm.entity.industry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "industry", $$v)
      },
      expression: "entity.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-specific"
    }
  }, [_vm._v("Location specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Location specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Location specific",
      "data-lpignore": "true",
      "name": "Location specific",
      "id": "location-specific"
    },
    model: {
      value: (_vm.entity.location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "location", $$v)
      },
      expression: "entity.location"
    }
  }), _vm._v(" "), (this.errors.has('Location specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Location specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-specific"
    }
  }, [_vm._v("Organisation size specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Organisation size specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Organisation size specific",
      "data-lpignore": "true",
      "name": "size",
      "id": "size-specific"
    },
    model: {
      value: (_vm.entity.size),
      callback: function($$v) {
        _vm.$set(_vm.entity, "size", $$v)
      },
      expression: "entity.size"
    }
  }), _vm._v(" "), (this.errors.has('Organisation size specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation size specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-exclude"
    }
  }, [_vm._v("Exclude companies")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude companies')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'industry') || (_vm.isSpecific !== null && _vm.isSpecific !== 'industry'),
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Exclude companies",
      "data-lpignore": "true",
      "name": "notCompany",
      "id": "company-exclude"
    },
    model: {
      value: (_vm.entity.notCompany),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notCompany", $$v)
      },
      expression: "entity.notCompany"
    }
  }), _vm._v(" "), (this.errors.has('Exclude companies')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude companies')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-exclude"
    }
  }, [_vm._v("Exclude industries")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude industries')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'company') || _vm.isSpecific !== null,
      "options": _vm.getIndustriesForSelect,
      "data-vv-name": "Exclude industries",
      "data-lpignore": "true",
      "name": "notIndustry",
      "id": "industry-exclude"
    },
    model: {
      value: (_vm.entity.notIndustry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notIndustry", $$v)
      },
      expression: "entity.notIndustry"
    }
  }), _vm._v(" "), (this.errors.has('Exclude industries')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude industries')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-exclude"
    }
  }, [_vm._v("Exclude locations")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude locations')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Exclude locations",
      "data-lpignore": "true",
      "name": "notLocation",
      "id": "location-exclude"
    },
    model: {
      value: (_vm.entity.notLocation),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notLocation", $$v)
      },
      expression: "entity.notLocation"
    }
  }), _vm._v(" "), (this.errors.has('Exclude locations')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude locations')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "size-exclude"
    }
  }, [_vm._v("Exclude organisation sizes")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude organisation sizes')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companySizes,
      "data-vv-name": "Exclude organisation sizes",
      "data-lpignore": "true",
      "name": "notSize",
      "id": "size-exclude"
    },
    model: {
      value: (_vm.entity.notSize),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notSize", $$v)
      },
      expression: "entity.notSize"
    }
  }), _vm._v(" "), (this.errors.has('Exclude organisation sizes')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude organisation sizes')))]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleRelatedBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Related resources")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleRelatedBoxActive = !_vm.articleRelatedBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-articles"
    }
  }, [_vm._v("Related Resources")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": true,
      "id": "related-articles",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttc),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttc", $$v)
      },
      expression: "entity.ttc"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleSettingsBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Task settings")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleSettingsBoxActive = !_vm.articleSettingsBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--seventh"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "repeats"
    }
  }, [_vm._v("Repeats")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "options": _vm.recurrences,
      "multiple": false,
      "searchable": false,
      "id": "repeats"
    },
    model: {
      value: (_vm.entity.settings.recurrence),
      callback: function($$v) {
        _vm.$set(_vm.entity.settings, "recurrence", $$v)
      },
      expression: "entity.settings.recurrence"
    }
  })], 1), _vm._v(" "), (_vm.entity.settings.recurrence && _vm.entity.settings.recurrence.label === 'Custom') ? _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "repeats-custom"
    }
  }, [_vm._v("Custom repeats value (in days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.settings.recurrence.value),
      expression: "entity.settings.recurrence.value"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "number",
      "min": "0",
      "data-lpignore": "true",
      "id": "repeats-custom"
    },
    domProps: {
      "value": (_vm.entity.settings.recurrence.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.settings.recurrence, "value", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "score"
    }
  }, [_vm._v("Priority points")]), _vm._v(" "), _c('span', {
    staticClass: "form-description",
    attrs: {
      "id": "scoreDesc",
      "tabindex": "-1"
    }
  }, [_vm._v("[1..33] → Low, [34..66] → Medium, [67..100] → High")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.settings.score),
      expression: "entity.settings.score"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100",
      "aria-describedby": "scoreDesc",
      "data-lpignore": "true",
      "id": "score"
    },
    domProps: {
      "value": (_vm.entity.settings.score)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.settings, "score", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--third"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "mandatory"
    }
  }, [_vm._v("Mandatory")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "mandatory"
    }
  }, _vm._l(([{
    label: 'Yes',
    value: 'true'
  }, {
    label: 'No',
    value: 'false'
  }]), function(choice, index) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.settings.mandatory),
        expression: "entity.settings.mandatory"
      }],
      attrs: {
        "type": "radio",
        "id": 'mandatory-' + choice.label
      },
      domProps: {
        "checked": choice.value === _vm.entity.settings.mandatory,
        "value": choice.value,
        "checked": _vm._q(_vm.entity.settings.mandatory, choice.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.entity.settings, "mandatory", choice.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'mandatory-' + choice.label
      }
    }, [_vm._v(_vm._s(choice.label))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "assessed"
    }
  }, [_vm._v("Self assessed")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "assessed"
    }
  }, _vm._l(([{
    label: 'Yes',
    value: 'true'
  }, {
    label: 'No',
    value: 'false'
  }]), function(choice, index) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.settings.assessed),
        expression: "entity.settings.assessed"
      }],
      attrs: {
        "type": "radio",
        "id": 'assessed-' + choice.label
      },
      domProps: {
        "checked": choice.value === _vm.entity.settings.assessed,
        "value": choice.value,
        "checked": _vm._q(_vm.entity.settings.assessed, choice.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.entity.settings, "assessed", choice.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'assessed-' + choice.label
      }
    }, [_vm._v(_vm._s(choice.label))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "on-boarding"
    }
  }, [_vm._v("On boarding task")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-control__radio",
    attrs: {
      "id": "on-boarding"
    }
  }, _vm._l(([{
    label: 'Yes',
    value: 'true'
  }, {
    label: 'No',
    value: 'false'
  }]), function(choice, index) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.settings.onBoarding),
        expression: "entity.settings.onBoarding"
      }],
      attrs: {
        "type": "radio",
        "id": 'on-boarding-' + choice.label
      },
      domProps: {
        "checked": choice.value === _vm.entity.settings.onBoarding,
        "value": choice.value,
        "checked": _vm._q(_vm.entity.settings.onBoarding, choice.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.entity.settings, "onBoarding", choice.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'on-boarding-' + choice.label
      }
    }, [_vm._v(_vm._s(choice.label))])])
  }), 0)])])])])])])]), _vm._v(" "), (_vm.articleType.type === 'video' || _vm.articleType.type === 'document') ? _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleResourcesBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Useful resources")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleResourcesBoxActive = !_vm.articleResourcesBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_vm._l((_vm.entity.resources.video), function(row, index) {
    return (_vm.articleType.type === 'video') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-url"
      }
    }, [_vm._v("Video URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoUrl),
        expression: "row.videoUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Video URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-url",
        "data-vv-name": "Video URL",
        "name": "video-url"
      },
      domProps: {
        "value": (row.videoUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Video URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Video URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-transcript"
      }
    }, [_vm._v("Transcript for video")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoTranscript),
        expression: "row.videoTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.videoTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoTranscript", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.video.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.entity.resources.document), function(row, index) {
    return (_vm.articleType.type === 'document') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('span', {
      staticClass: "article__form-label"
    }, [_vm._v("Upload resource")]), _vm._v(" "), _c('label', {
      staticClass: "form-label"
    }, [(row.resource === null) ? _c('span', {
      staticClass: "form-control form-control__input"
    }, [_vm._v("+Upload resource")]) : _vm._e(), _vm._v(" "), (row.resource !== null) ? _c('span', {
      staticClass: "form-control form-control__input",
      attrs: {
        "id": 'uploadedResource_' + index
      }
    }, [_vm._v(_vm._s(row.name))]) : _vm._e(), _vm._v(" "), _c('input', {
      staticClass: "form-control visually-hidden form-control--file input-file-resource",
      attrs: {
        "type": "file",
        "id": 'uploadResource_' + index,
        "placeholder": "Type in to add title..."
      },
      on: {
        "change": function($event) {
          return _vm.onResourceFileChange($event, index)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.document.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-url"
      }
    }, [_vm._v("Resource URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceUrl),
        expression: "row.resourceUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Resource URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-url",
        "data-vv-name": "Resource URL",
        "name": "resource-url"
      },
      domProps: {
        "value": (row.resourceUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Resource URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Resource URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-transcript"
      }
    }, [_vm._v("Transcript for resource")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceTranscript),
        expression: "row.resourceTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.resourceTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceTranscript", $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--full form-group__video-add-button",
    on: {
      "click": _vm.addVideoRow
    }
  }, [_c('div', {
    staticClass: "add-new-video"
  }, [_vm._v("Add new")])])], 2)])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article__content--title"
  }, [_c('h1', [_vm._v("Add task")])])
}]}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w1"
  }, [_c('div', {
    staticClass: "wrap-admin"
  }, [_c('div', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "all-pages-list",
    attrs: {
      "div": ""
    }
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All landing pages")]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-homepage')
      }
    }
  }, [_vm._v("Homepage")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('homepage')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('homepage')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-about')
      }
    }
  }, [_vm._v("About page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('about-us')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('about-us')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-login')
      }
    }
  }, [_vm._v("Login page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('login-page')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('login-page')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-contact')
      }
    }
  }, [_vm._v("Contact page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('contact-page')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('contact-page')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-terms-and-conditions')
      }
    }
  }, [_vm._v("Terms and conditions")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('terms-and-conditions')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('terms-and-conditions')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-privacy-policy')
      }
    }
  }, [_vm._v("Privacy policy")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('privacy-policy')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('privacy-policy')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-accessibility-section')
      }
    }
  }, [_vm._v("Accessibility section")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('accessibility-section')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('accessibility-section')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-give-consent')
      }
    }
  }, [_vm._v("Give consent page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('give-consent')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('give-consent')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-confirm-subscription')
      }
    }
  }, [_vm._v("Confirm subscription page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('confirm-subscription')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('confirm-subscription')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-register')
      }
    }
  }, [_vm._v("Register page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('register')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('register')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-callback-request')
      }
    }
  }, [_vm._v("Callback request")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('callback-request')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('callback-request')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-need-help')
      }
    }
  }, [_vm._v("Need help request")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('need-help')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('need-help')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-terms-of-service')
      }
    }
  }, [_vm._v("Terms of service")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('terms-of-service')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('terms-of-service')
      }
    }
  }, [_vm._v("Export")])])])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "href": "#",
      "id": "exportLanding"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "type": "file",
      "id": "importLanding"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "table-head-ceil"
  }, [_c('div', {
    staticClass: "caption-head"
  }, [_c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Page name")])])])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                    Actions\n                  ")])])])
}]}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Logs")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "email-logs active",
    attrs: {
      "to": {
        name: 'email-logs'
      }
    }
  }, [_vm._v("Email logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "consent-logs",
    attrs: {
      "to": {
        name: 'consent-logs'
      }
    }
  }, [_vm._v("Consent logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "ttd-logs",
    attrs: {
      "to": {
        name: 'logs'
      }
    }
  }, [_vm._v("Logs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [(!_vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-statusbar",
    staticStyle: {
      "margin": "0 15px 20px"
    }
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.logsCount) + " logs")])]) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.logs.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [((_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) && _vm.selectedFilters.length) ? _c('tr', {
    staticClass: "inside-table-filters"
  }, [_c('th', {
    attrs: {
      "colspan": "9"
    }
  }, [_c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getUsersForSelect),
        'locked-ceil-head': _vm.userFilterLocked
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(1)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getUsersForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 1),
      expression: "filerTableHead.selectedCeil === 1"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-1",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getUsersForSelect
    },
    model: {
      value: (_vm.logsUser),
      callback: function($$v) {
        _vm.logsUser = $$v
      },
      expression: "logsUser"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getEmailsForSelect),
        'locked-ceil-head': _vm.emailFilterLocked
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getEmailsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getEmailsForSelect
    },
    model: {
      value: (_vm.logsEmail),
      callback: function($$v) {
        _vm.logsEmail = $$v
      },
      expression: "logsEmail"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getTypesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getTypesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getTypesForSelect
    },
    model: {
      value: (_vm.logsType),
      callback: function($$v) {
        _vm.logsType = $$v
      },
      expression: "logsType"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getStatusesForSelect
    },
    model: {
      value: (_vm.logsStatus),
      callback: function($$v) {
        _vm.logsStatus = $$v
      },
      expression: "logsStatus"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy(true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.logOrderBy !== null && this.logOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.logOrderBy !== null && !this.logOrderBy.order
    }
  })])])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log, i) {
    return _c('tr', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openEmail(log)
        }
      }
    }, [_c('td', {
      staticClass: "name-cell cellpadding",
      attrs: {
        "data-title": "User:"
      }
    }, [_vm._v(_vm._s(_vm.getUser(log)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Email:"
      }
    }, [_vm._v(_vm._s(log.mailTo ? log.mailTo : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "role-cell cellpadding",
      attrs: {
        "data-title": "Type:"
      }
    }, [_vm._v(_vm._s(_vm.getTypeName(log)))]), _vm._v(" "), _c('td', {
      staticClass: "role-cell cellpadding",
      attrs: {
        "data-title": "Status:"
      }
    }, [_vm._v(_vm._s(_vm.getStatusName(log)))]), _vm._v(" "), _c('td', {
      staticClass: "created-cell cellpadding text-center",
      attrs: {
        "data-title": "Date and time:"
      }
    }, [_vm._v(_vm._s(_vm.convertDate(log.created)))]), _vm._v(" "), _c('td', {
      staticClass: "last-login-cell cellpadding text-center",
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "data-title": "Subject:"
      }
    }, [_vm._v(_vm._s(log.subject ? log.subject : 'n/a'))])])
  }), 0)]), _vm._v(" "), (this.logs.length < this.logsCount) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(6), _vm._v("Load more\n        ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("User")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Date and time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "column-active-head table-head-ceil"
  }, [_c('div', {
    staticClass: "caption-head"
  }, [_c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Subject")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getInformationMsg.isShown == true) ? _c('div', {
    ref: "informationMsg",
    staticClass: "inform-popup",
    class: _vm.getInformationMsg.className,
    attrs: {
      "role": "alert",
      "id": "information-message"
    }
  }, [_c('div', {
    staticClass: "inform-message-inner"
  }, [_c('h2', {
    staticClass: "inform-title"
  }, [_vm._v(_vm._s(_vm.getInformationMsg.title))]), _vm._v(" "), _c('p', {
    staticClass: "inform-content"
  }, [_vm._v(_vm._s(_vm.getInformationMsg.text))]), _vm._v(" "), _c('button', {
    staticClass: "inform-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeInformationMsg($event)
      }
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section about-page-hero"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content background-1-20-before"
  }, [_c('div', {
    staticClass: "hero-title background-1-50-before background-1-100-after"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-1-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description background-1-10-before"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-77",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-button",
    class: _vm.pageEditMode ? 'edit-mode' : ''
  }, [(_vm.pageEditMode) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element form-element--half"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.text),
      expression: "content.heroSection.button.text"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "text",
      "placeholder": "Button text"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element form-element--half"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.link),
      expression: "content.heroSection.button.link"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "text",
      "placeholder": "Button link"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "link", $event.target.value)
      }
    }
  })])])] : [_c('a', {
    attrs: {
      "href": _vm.content.heroSection.button.link
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.button.text))])], _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image hero-image__about background-1-10-after background-2-4-before"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.howItWorksSection.hideSection || _vm.content.howItWorksSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper how-it-works-section about-page-section landing-page-wrapper__gray",
    attrs: {
      "role": "region",
      "aria-labelledby": "howItWorksTitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.hideSection),
      expression: "content.howItWorksSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showhowItWorksSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.howItWorksSection.hideSection) ? _vm._i(_vm.content.howItWorksSection.hideSection, null) > -1 : (_vm.content.howItWorksSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.howItWorksSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.howItWorksSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showhowItWorksSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [(!_vm.pageEditMode && _vm.content.howItWorksSection.title !== '') ? _c('h2', {
    staticClass: "section-title",
    attrs: {
      "id": "howItWorksTitle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.howItWorksSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.title),
      expression: "content.howItWorksSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "title", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.howItWorksSection.description !== '') ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.howItWorksSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.description),
      expression: "content.howItWorksSection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "description", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "list flex-section"
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item, index) {
    return _c('div', {
      staticClass: "list-item"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.howItWorksSection.sections, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "content-slider"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "howItWorksSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.howItWorksOptionsContent
    }
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('how-it-works')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.subscribeSection.hideSection || _vm.content.subscribeSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.subscribeSection.hideSection || content.subscribeSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper subscribe-section about-page landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.hideSection),
      expression: "content.subscribeSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showSubscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.subscribeSection.hideSection) ? _vm._i(_vm.content.subscribeSection.hideSection, null) > -1 : (_vm.content.subscribeSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.subscribeSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.subscribeSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showSubscribe"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.title),
      expression: "content.subscribeSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.subscribeSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.description),
      expression: "content.subscribeSection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('form', {
    staticClass: "tcc-form",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.subscribeMe()
      }
    }
  }, [(!_vm.pageEditMode) ? _c('h3', {
    staticClass: "section-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.formTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.formTitle),
      expression: "content.subscribeSection.formTitle"
    }],
    staticClass: "section-subtitle",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Form title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.formTitle)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "formTitle", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-firstname"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.firstname),
      expression: "subscribeForm.firstname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'not-empty': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'has-error': this.errors.has('First name')
    }],
    attrs: {
      "id": "tcc-form-firstname",
      "type": "text",
      "name": "First name",
      "data-vv-name": "First name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.firstname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.firstnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.firstnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-lastname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.lastname),
      expression: "subscribeForm.lastname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'not-empty': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'has-error': this.errors.has('Last name')
    }],
    attrs: {
      "id": "tcc-form-lastname",
      "type": "text",
      "name": "Last name",
      "data-vv-name": "Last name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.lastname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.lastnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.lastnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.email),
      expression: "subscribeForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'not-empty': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'has-error': this.errors.has('Email address')
    }],
    attrs: {
      "id": "tcc-form-email",
      "type": "email",
      "name": "Email address",
      "data-vv-name": "Email address",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                Submitting\n              ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-envelope",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-envelope",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM384 320c0 17.67-14.33 32-32 32H160c-17.67 0-32-14.33-32-32V238l122.1 48.82C251.1 287.6 253.1 288 256 288s4.031-.375 5.938-1.141L384 238V320zM384 203.6l-128 51.2L128 203.6V192c0-17.67 14.33-32 32-32h192c17.67 0 32 14.33 32 32V203.6z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                    " + _vm._s(_vm.formStatus.title) + "\n                  ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.formStatus.body) + "\n                  ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                    Some fields are missing.\n                  ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClient"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showClient"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.title && _vm.content.clientSection.title !== '') ? _c('h2', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.description && _vm.content.clientSection.description !== '') ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_c('div', {
    staticClass: "clients-slider"
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.testimonialsSection.hideSection || _vm.content.testimonialsSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.testimonialsSection.hideSection || content.testimonialsSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper testimonials-section landing-page-wrapper__gray",
    attrs: {
      "id": "our-clients",
      "role": "region",
      "aria-labelledby": "testimonialsTitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.testimonialsSection.hideSection),
      expression: "content.testimonialsSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showTestimonialsSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.testimonialsSection.hideSection) ? _vm._i(_vm.content.testimonialsSection.hideSection, null) > -1 : (_vm.content.testimonialsSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.testimonialsSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.testimonialsSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.testimonialsSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.testimonialsSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showTestimonialsSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title center",
    attrs: {
      "id": "testimonialsTitle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.testimonialsSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.testimonialsSection.title),
      expression: "content.testimonialsSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.testimonialsSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.testimonialsSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.testimonialsSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.content.testimonialsSection.testimonials), function(item, index) {
    return (_vm.pageEditMode) ? _c('div', {
      key: index,
      staticClass: "list-item edit-mode"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.testimonialsSection.testimonials, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "list-item-content"
    }, [_c('div', {
      staticClass: "list-item-text"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-image"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.image = null
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [(_vm.isGM()) ? _c('label', {
      staticClass: "list-item-image-upload",
      attrs: {
        "for": 'testimonial-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'testimonial-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta"
    }, [_c('div', {
      staticClass: "list-item-meta-name"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Name",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta-company"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.company),
        expression: "item.company"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Company",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.company)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "company", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.company))]) : _vm._e()])])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.pageEditMode && _vm.slidesReady) ? _c('slick', {
    ref: "testimonialsSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.testimonialsOptionsContent
    }
  }, _vm._l((_vm.content.testimonialsSection.testimonials), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-content"
    }, [_c('div', {
      staticClass: "list-item-text"
    }, [_c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "list-item-image"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" | "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.company)
      }
    })])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('testimonials')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.contactCTA.hideSection || _vm.content.contactCTA.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.contactCTA.hideSection || content.contactCTA.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper contact-cta-section",
    attrs: {
      "role": "region",
      "aria-labelledby": "contactCTATitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.hideSection),
      expression: "content.contactCTA.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showContactCTASection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.contactCTA.hideSection) ? _vm._i(_vm.content.contactCTA.hideSection, null) > -1 : (_vm.content.contactCTA.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.contactCTA.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.contactCTA, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showContactCTASection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_c('div', {
    staticClass: "contact-cta--content__title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.contactCTA.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.title),
      expression: "content.contactCTA.title"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactCTA.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactCTA, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactCTA.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--content__text"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.contactCTA.text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.text),
      expression: "content.contactCTA.text"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactCTA.text)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactCTA, "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactCTA.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions",
    class: _vm.pageEditMode ? 'edit-mode' : ''
  }, [_vm._l((_vm.content.contactCTA.buttons), function(button) {
    return [(_vm.pageEditMode) ? [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.text),
        expression: "button.text"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button text"
      },
      domProps: {
        "value": (button.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "text", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.link),
        expression: "button.link"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button link"
      },
      domProps: {
        "value": (button.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "link", $event.target.value)
        }
      }
    })])])] : [_c('a', {
      attrs: {
        "href": button.link
      }
    }, [_vm._v(_vm._s(button.text))])]]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('contact-cta-button')
      }
    }
  }, [_vm._v("+ Add button")]) : _vm._e()], 2)])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action background-1-20 background-1-60-hover",
    attrs: {
      "name": "subscribe",
      "type": "submit"
    }
  }, [_vm._v("Subscribe")])])
}]}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text",
    attrs: {
      "on-click": ""
    }
  }, [_c('span', [_vm._v("Access")])])
}]}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "post-title color-1-100 background-1-10-after"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "post-title color-1-100 background-1-10-after"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "front-footer"
  }, [_c('div', {
    staticClass: "front-footer-go-up-container"
  }, [(_vm.isGoUpNeeded) ? _c('button', {
    staticClass: "go-up-button",
    attrs: {
      "title": "Go back to the top of the page"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goUpAction()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "front-footer-top"
  }, [_c('div', {
    staticClass: "myContainer"
  }, [_c('div', {
    staticClass: "front-footer-top__inner"
  }, [_c('div', {
    staticClass: "front-footer-supported-by"
  }, [(_vm.sponsors.length) ? [(_vm.sponsorsLogo) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(_vm.sponsorsLogo))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("In association with")]), _vm._v(" "), _c('div', {
    staticClass: "industry-logos"
  }, [_vm._l((_vm.sponsors), function(row, index) {
    return [(row.url) ? [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": row.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": row.altImage
      }
    })]) : _vm._e()] : [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": row.altImage
      }
    })]) : _vm._e()]]
  })], 2)] : [(this.footerData.logosLabel) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(this.footerData.logosLabel))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("Sponsors")]), _vm._v(" "), _c('div', {
    staticClass: "industry-logos"
  }, [_vm._l((this.footerData.logos), function(row, index) {
    return [(row.url) ? [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      staticStyle: {
        "background-color": "transparent"
      },
      attrs: {
        "href": row.url,
        "target": "_blank",
        "title": row.alt
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(_vm.getHighImage(row)),
        "alt": row.altImage
      }
    })]) : _vm._e()] : [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      staticStyle: {
        "background-color": "transparent"
      },
      attrs: {
        "href": row.url,
        "title": row.alt
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(_vm.getHighImage(row)),
        "alt": row.altImage
      }
    })]) : _vm._e()]]
  })], 2)]], 2), _vm._v(" "), _c('div', {
    staticClass: "front-footer-info"
  }, [(this.footerData.addressLabel) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(this.footerData.addressLabel))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("Address")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(this.footerData.address)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "front-footer-social"
  }, [(this.footerData.socialLabel) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(this.footerData.socialLabel))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("Join us")]), _vm._v(" "), _c('ul', {
    staticClass: "front-footer-social-list"
  }, _vm._l((this.footerData.social), function(item) {
    return _c('li', {
      staticClass: "front-footer-social-list__item"
    }, [_c('a', {
      staticClass: "front-footer-social-list__link",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "href": item.url,
        "target": "_blank",
        "title": item.altImage,
        "aria-label": item.altImage
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "front-footer-links"
  }, [_c('div', {
    staticClass: "myContainer"
  }, [_c('div', {
    staticClass: "front-footer-links__inner"
  }, [_c('ul', {
    staticClass: "front-footer-links-list"
  }, _vm._l((this.footerData.menu), function(item) {
    return _c('li', {
      staticClass: "front-footer-links-list__item"
    }, [_c('router-link', {
      staticClass: "front-footer-links-list__link",
      attrs: {
        "to": _vm.routeName(item.url),
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])])])])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w1"
  }, [_c('div', {
    staticClass: "wrap-admin"
  }, [_c('app-header'), _vm._v(" "), _c('inform-msg'), _vm._v(" "), _c('conf-popup'), _vm._v(" "), _c('div', {
    staticClass: "admin",
    class: {
      'container-large': _vm.isInvitePage, 'full-page': _vm.isFullPage
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-page"
  }, [_c('task-single', {
    attrs: {
      "company": _vm.companyId
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.chapters.length) + " task categories\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new task category")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-chapter-name"
    }
  }, [_vm._v("Category Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChapter.name),
      expression: "newChapter.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-chapter-name"
    },
    domProps: {
      "value": (_vm.newChapter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChapter, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "chapter-slug"
    }
  }, [_vm._v("Slug")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChapter.slug),
      expression: "newChapter.slug"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "chapter-desc",
      "id": "chapter-slug"
    },
    domProps: {
      "value": (_vm.newChapter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChapter, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "chapter-slug"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChapter.color),
      expression: "newChapter.color"
    }],
    staticClass: "form-control form-control__color",
    attrs: {
      "type": "color",
      "name": "chapter-desc",
      "id": "chapter-color"
    },
    domProps: {
      "value": (_vm.newChapter.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChapter, "color", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image (blue)")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploadedBlue),
      expression: "!isThumbnailFileUploadedBlue"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail_blue_0",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0, 'blue')
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploadedBlue) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: 'url(' + _vm.newChapter.image + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploadedBlue) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0, 'blue')
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image (gray)")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploadedGray),
      expression: "!isThumbnailFileUploadedGray"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail_gray_0",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0, 'gray')
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploadedGray) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: 'url(' + _vm.newChapter.imageGray + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploadedGray) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0, 'gray')
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploadedHigh),
      expression: "!isThumbnailFileUploadedHigh"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail_high_0",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0, 'high')
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploadedHigh) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: 'url(' + _vm.newChapter.imageHigh + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploadedHigh) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0, 'high')
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-chapter-desc"
    }
  }, [_vm._v("Key information")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar
    },
    model: {
      value: (_vm.newChapter.description),
      callback: function($$v) {
        _vm.$set(_vm.newChapter, "description", $$v)
      },
      expression: "newChapter.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCategory()
      }
    }
  }, [_vm._v("Create task category")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Image")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Category name..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedChapters), function(chapter, i) {
    return _c('tr', [(chapter.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v("\n            " + _vm._s(chapter.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [(chapter.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      staticStyle: {
        "width": "50px",
        "height": "50px",
        "border": "none"
      },
      style: ({
        backgroundImage: 'url(' + chapter.image + ')'
      })
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(chapter.name) + "\n          ")]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(chapter.isChild ? '- ' + chapter.slug : chapter.slug) + "\n          ")]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showEditionForm(chapter.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeCategory(chapter.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (chapter.type === 'edit') ? _c('td', {
      staticClass: "edit-row chapter-edit",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!chapter.image),
        expression: "!chapter.image"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'uploadThumbnail_blue_' + chapter.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, chapter.id, 'blue')
        }
      }
    })]), _vm._v(" "), (chapter.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: 'url(' + chapter.image + ')'
      })
    }) : _vm._e(), _vm._v(" "), (chapter.image) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(chapter.id, 'blue')
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!chapter.imageGray),
        expression: "!chapter.imageGray"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'uploadThumbnail_gray_' + chapter.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, chapter.id, 'gray')
        }
      }
    })]), _vm._v(" "), (chapter.imageGray) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: 'url(' + chapter.imageGray + ')'
      })
    }) : _vm._e(), _vm._v(" "), (chapter.imageGray) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(chapter.id, 'gray')
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!chapter.imageHigh),
        expression: "!chapter.imageHigh"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'uploadThumbnail_high_' + chapter.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, chapter.id, 'high')
        }
      }
    })]), _vm._v(" "), (chapter.imageHigh) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: 'url(' + chapter.imageHigh + ')'
      })
    }) : _vm._e(), _vm._v(" "), (chapter.imageHigh) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(chapter.id, 'high')
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-color-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.color),
        expression: "chapter.color"
      }],
      staticClass: "form-control form-control__color",
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (chapter.color)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(chapter, "color", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.name),
        expression: "chapter.name"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (chapter.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(chapter, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea"
    }, [_c('vue-editor', {
      staticClass: "form-control form-control__editor",
      attrs: {
        "name": "content",
        "editorToolbar": _vm.editorToolbar
      },
      model: {
        value: (chapter.description),
        callback: function($$v) {
          _vm.$set(chapter, "description", $$v)
        },
        expression: "chapter.description"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.discardСhanges(chapter.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editCategory(chapter.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Task categories")])])
}]}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content color-1-100"
  }, [(_vm.formStatus.success) ? [_vm._v("\n              Login\n            ")] : [_vm._v("\n              Reset password\n            ")]], 2)]), _vm._v(" "), (!_vm.formStatus.success) ? _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          Please enter below the new password for your Clear Assured account.\n          It must contain at least 9 characters that include capital letters, lower case letters and numbers.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formStatus.success) ? _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.loginForm.email !== '' || _vm.loginForm.emailFocus,
      'has-error': _vm.loginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.email),
      expression: "loginForm.email"
    }],
    class: [{
      'border-1-50': _vm.loginForm.email !== '' || _vm.loginForm.emailFocus
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email",
      "data-vv-name": "Email"
    },
    domProps: {
      "value": (_vm.loginForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'has-error': _vm.loginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('a', {
    staticClass: "landing-page-login-password-show",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('top')
      }
    }
  }), _vm._v(" "), ((_vm.loginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginForm.password) ? _vm._i(_vm.loginForm.password, null) > -1 : (_vm.loginForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.loginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.loginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.loginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.loginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.loginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "Password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.loginForm.password, null)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.loginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "Password",
      "type": _vm.loginForm.passwordType
    },
    domProps: {
      "value": (_vm.loginForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.loginForm.loginInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate()
      }
    }
  }, [_vm._v("Login")])])]) : _vm._e(), _vm._v(" "), (!_vm.formStatus.success) ? _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.first !== '' || _vm.passwordFocus,
      'has-error': this.errors.has('New password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-reset-password"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('a', {
    staticClass: "landing-page-login-password-show",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('password')
      }
    }
  }), _vm._v(" "), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    ref: "password",
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "New password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.first) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.first,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$c)
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    ref: "password",
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "New password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    ref: "password",
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "New password",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('New password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('New password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.second !== '' || _vm.retypePasswordFocus,
      'has-error': this.errors.has('Retype new password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password-retype"
    }
  }, [_vm._v("Retype new password")]), _vm._v(" "), _c('a', {
    staticClass: "landing-page-login-password-show",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('retypePassword')
      }
    }
  }), _vm._v(" "), ((_vm.retypePasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype new password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.second) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.second,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$c)
        }
      }
    }
  }) : ((_vm.retypePasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype new password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype new password",
      "type": _vm.retypePasswordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Retype new password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Retype new password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login-form-error",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(_vm.loginForm.isError) ? [_vm._v("\n              " + _vm._s(_vm.loginForm.loginErrorMessage) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.resetInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetPassword()
      }
    }
  }, [_vm._v("Submit")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account several times? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "form-message",
    class: _vm.formStatus.success ? 'success' : 'error',
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? [_vm._v("\n            Submitting\n          ")] : _vm._e(), _vm._v(" "), (_vm.formStatus.shown && !this.formStatus.submitting) ? [(_vm.formStatus.title !== '') ? _c('h2', [_vm._v(_vm._s(_vm.formStatus.title))]) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v(_vm._s(_vm.formStatus.body))]) : _vm._e()] : _vm._e()], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template company-edit"
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [(_vm.dataLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-text"
  }, [_vm._v("loading ...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditDetails) ? [_vm._v("\n          Edit organisation details:\n        ")] : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'gm') ? [_vm._v("\n          " + _vm._s(this.company.details.name) + "\n        ")] : [_vm._v("\n          My company profile\n        ")]], 2), _vm._v(" "), (_vm.getUserRole === 'gm') ? [_c('div', {
    staticClass: "profile-actions float-none"
  }, [_c('button', {
    staticClass: "archive-profile",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.archiveProfile()
      }
    }
  }, [(_vm.company.details.enabled.value) ? [_vm._v("\n              Archive\n            ")] : [_vm._v("\n              Unarchive\n            ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteProfile()
      }
    }
  }, [_vm._v("Delete\n          ")]), _vm._v(" "), (_vm.company.details.isDemo) ? _c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetTaskHistory()
      }
    }
  }, [_vm._v("\n            Reset task history\n          ")]) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), (_vm.getUserRole !== 'gm') ? [_c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")])], 1)] : [_c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('button', {
    staticClass: "dashboard",
    class: [{
      'active': this.tabActive === 'profile'
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeTabActive('profile')
      }
    }
  }, [_vm._v("Profile\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "dashboard",
    class: [{
      'active': this.tabActive === 'billing'
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeTabActive('billing')
      }
    }
  }, [_vm._v("Billing")]), _vm._v(" "), (_vm.company.details.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'company-tasks',
        params: {
          companyId: _vm.company.details.id
        }
      }
    }
  }, [_vm._v("Tasks")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "progress",
    class: [{
      'active': this.tabActive === 'progress'
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeTabActive('progress')
      }
    }
  }, [_vm._v("Progress\n        ")]), _vm._v(" "), (_vm.company.details.industry && _vm.company.details.industry.landing) ? [_c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-landing',
        params: {
          id: _vm.company.details.industry.landing.slug
        }
      }
    }
  }, [_vm._v("\n            Landing\n          ")]), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value && _vm.company.details.url) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-registration-landing',
        params: {
          industry: _vm.company.details.industry.landing.slug,
          company: _vm.company.details.url.toLowerCase()
        }
      }
    }
  }, [_vm._v("\n            Registration landing\n          ")]) : _vm._e()] : _vm._e()], 2)], _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [(this.tabActive === 'profile' || this.tabActive === 'progress') ? _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [(this.tabActive === 'profile') ? [_c('div', {
    staticClass: "anchor-item color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyDetails')
      }
    }
  }, [(_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyOwner'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [(_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2)]), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "anchor-item color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'tasksSettings'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('tasksSettings')
      }
    }
  }, [(_vm.canEditDetails === false) ? [_vm._v("Tasks settings")] : [_vm._v("Edit tasks settings")]], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 email-endings",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyRegistration'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyRegistration')
      }
    }
  }, [(_vm.canEditCompanyRegistration === false) ? [_vm._v("User registration settings")] : [_vm._v("Edit user registration settings")]], 2)])] : (this.tabActive === 'progress') ? [_c('div', {
    staticClass: "anchor-item color-1-20 progress",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyChart'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyChart')
      }
    }
  }, [_vm._v("Company chart")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 progress",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyProgress'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyProgress')
      }
    }
  }, [(_vm.canEditProgressChapters === false) ? [_vm._v("Company progress")] : [_vm._v("Edit company progress")]], 2)])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [(this.tabActive === 'profile') ? [_c('div', {
    ref: "companyDetails",
    staticClass: "content-section content-section__bordered border-1-20 profile-section no-margin-top",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2), _vm._v(" "), (_vm.canEditDetails === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.name),
      expression: "company.details.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-name",
      "name": "Company name"
    },
    domProps: {
      "value": (_vm.company.details.name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-parent"
    }
  }, [_vm._v("Parent company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": true,
      "options": _vm.preparedCompanies,
      "data-vv-name": "Parent company",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-parent"
    },
    model: {
      value: (_vm.company.details.parent),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "parent", $$v)
      },
      expression: "company.details.parent"
    }
  }), _vm._v(" "), (this.errors.has('Parent company')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Parent company')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-industry"
    }
  }, [_vm._v("Industry")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Industry'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "clearable": false,
      "searchable": false,
      "options": _vm.getIndustriesForSelect,
      "data-vv-name": "Industry",
      "data-lpignore": "true",
      "name": "Industry",
      "id": "new-company-industry"
    },
    model: {
      value: (_vm.company.details.industry),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "industry", $$v)
      },
      expression: "company.details.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element form-element-date",
    attrs: {
      "id": "date-selector"
    }
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-subscription-end"
    }
  }, [_vm._v("Subscription ends on:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.subscriptionEnd),
      expression: "company.details.subscriptionEnd"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Subscription ends'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-subscription-end",
      "name": "Subscription ends"
    },
    domProps: {
      "value": (_vm.company.details.subscriptionEnd)
    },
    on: {
      "focus": function($event) {
        _vm.datepicker.shown = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "subscriptionEnd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditDetails && _vm.datepicker.shown),
      expression: "canEditDetails && datepicker.shown"
    }],
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-calendar-half"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "open-date": _vm.datepicker.subscription,
      "format": 'dd/MM/yyyy'
    },
    on: {
      "selected": function($event) {
        return _vm.dateSelected($event, 'subscriptionEnd')
      }
    },
    model: {
      value: (_vm.datepicker.subscription),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "subscription", $$v)
      },
      expression: "datepicker.subscription"
    }
  })], 1)]), _vm._v(" "), (this.errors.has('Subscription ends')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Subscription ends')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-status"
    }
  }, [_vm._v("Company status")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked is-blocked",
    class: [{
      'has-error': _vm.errors.has('Company status'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": true,
      "searchable": false,
      "options": _vm.getStatusesForSelect,
      "data-vv-name": "Company status",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-status"
    },
    model: {
      value: (_vm.company.details.enabled),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "enabled", $$v)
      },
      expression: "company.details.enabled"
    }
  }), _vm._v(" "), (this.errors.has('Company status')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company status')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [(_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companySizes"
    }
  }, [_vm._v("Company size")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': this.errors.has('Company size'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "clearable": false,
      "searchable": false,
      "options": _vm.companySizes,
      "data-vv-name": "Company size",
      "data-lpignore": "true",
      "name": "Company size",
      "id": "companySizes"
    },
    model: {
      value: (_vm.company.details.companySize),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "companySize", $$v)
      },
      expression: "company.details.companySize"
    }
  }), _vm._v(" "), (this.errors.has('Company size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company size')))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [(_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-types"
    }
  }, [_vm._v("User types")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': this.errors.has('User types'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": false,
      "clearable": false,
      "options": _vm.getDefaultRegistrationRolesForSelect,
      "data-vv-name": "User types",
      "data-lpignore": "true",
      "name": "User types",
      "id": "new-user-types"
    },
    model: {
      value: (_vm.company.details.usersType),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "usersType", $$v)
      },
      expression: "company.details.usersType"
    }
  }), _vm._v(" "), (this.errors.has('User types')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('User types')))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [(_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companyLocations"
    }
  }, [_vm._v("Company location")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company location'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": false,
      "options": _vm.companyLocations,
      "data-vv-name": "Company location",
      "data-lpignore": "true",
      "name": "Company location",
      "id": "companyLocations"
    },
    model: {
      value: (_vm.company.details.companyLocation),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "companyLocation", $$v)
      },
      expression: "company.details.companyLocation"
    }
  }), _vm._v(" "), (this.errors.has('Company location')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company location')))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-id"
    }
  }, [_vm._v("Company id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.id),
      expression: "company.details.id"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'is-blocked': _vm.canEditDetails,
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-company-id",
      "name": "Company id"
    },
    domProps: {
      "value": (_vm.company.details.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.seesChat),
      expression: "company.details.seesChat"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Sees the Chat box'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-chat",
      "name": "Sees the Chat box"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.details.seesChat) ? _vm._i(_vm.company.details.seesChat, null) > -1 : (_vm.company.details.seesChat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.details.seesChat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company.details, "seesChat", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company.details, "seesChat", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company.details, "seesChat", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-chat"
    }
  }, [_vm._v("Sees the Chat box")])]), _vm._v(" "), (_vm.company.details.disconnectedFromBilling) ? _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.isDemo),
      expression: "company.details.isDemo"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Demo company'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-demo",
      "name": "Demo company"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.details.isDemo) ? _vm._i(_vm.company.details.isDemo, null) > -1 : (_vm.company.details.isDemo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.details.isDemo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company.details, "isDemo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company.details, "isDemo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company.details, "isDemo", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-demo"
    }
  }, [_vm._v("Demo company")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.disconnectedFromBilling),
      expression: "company.details.disconnectedFromBilling"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Disconnected from billing'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-disconnected-from-billing",
      "name": "Disconnected from billing"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.details.disconnectedFromBilling) ? _vm._i(_vm.company.details.disconnectedFromBilling, null) > -1 : (_vm.company.details.disconnectedFromBilling)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.details.disconnectedFromBilling,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company.details, "disconnectedFromBilling", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company.details, "disconnectedFromBilling", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company.details, "disconnectedFromBilling", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-disconnected-from-billing"
    }
  }, [_vm._v("Disconnected from billing")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyDetails()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "companyOwner",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2), _vm._v(" "), (_vm.canEditOwner === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditOwner()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.firstName),
      expression: "company.ownerData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.company.ownerData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.phoneNumber),
      expression: "company.ownerData.phoneNumber"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.company.ownerData.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.lastName),
      expression: "company.ownerData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.company.ownerData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.email),
      expression: "company.ownerData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.company.ownerData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditOwner) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditOwner()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyOwner()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()]), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'gm') ? _c('div', {
    ref: "tasksSettings",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTasksSettings === false) ? [_vm._v("Tasks settings")] : [_vm._v("Edit tasks settings")]], 2), _vm._v(" "), (_vm.canEditTasksSettings === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTasksSettings()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-contraption"
    }
  }, [_vm._v("Company contraption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.tasksSettings.contraption),
      expression: "company.tasksSettings.contraption"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company contraption'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTasksSettings === false,
      "data-lpignore": "true",
      "maxlength": "4",
      "id": "company-contraption",
      "name": "Company contraption"
    },
    domProps: {
      "value": (_vm.company.tasksSettings.contraption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.tasksSettings, "contraption", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-default-assignee"
    }
  }, [_vm._v("Default assignee")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Default assignee'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    attrs: {
      "disabled": _vm.canEditTasksSettings === false,
      "searchable": true,
      "options": _vm.defaultAssigneeForSelect,
      "data-vv-name": "Default assignee",
      "data-lpignore": "true",
      "name": "Default assignee",
      "id": "company-default-assignee"
    },
    model: {
      value: (_vm.company.tasksSettings.defaultAssignee),
      callback: function($$v) {
        _vm.$set(_vm.company.tasksSettings, "defaultAssignee", $$v)
      },
      expression: "company.tasksSettings.defaultAssignee"
    }
  }), _vm._v(" "), (this.errors.has('Default assignee')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Default assignee')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-account-manager"
    }
  }, [_vm._v("Account manager")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Account manager'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    attrs: {
      "disabled": _vm.canEditTasksSettings === false,
      "searchable": true,
      "options": _vm.adminUsersForSelect,
      "data-vv-name": "Account manager",
      "data-lpignore": "true",
      "name": "Account manager",
      "id": "company-account-manager"
    },
    model: {
      value: (_vm.company.tasksSettings.accountManager),
      callback: function($$v) {
        _vm.$set(_vm.company.tasksSettings, "accountManager", $$v)
      },
      expression: "company.tasksSettings.accountManager"
    }
  }), _vm._v(" "), (this.errors.has('Account manager')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Account manager')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTasksSettings) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTasksSettings()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyTasksSettings()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "companyRegistration",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditCompanyRegistration === false) ? [_vm._v("User registration settings")] : [_vm._v("Edit user registration settings")]], 2), _vm._v(" "), (_vm.canEditCompanyRegistration === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditCompanyRegistration()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration"
    }
  }, [_vm._v("Allow user registration")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow user registration'),
      'is-locked is-blocked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "disabled": !_vm.canEditCompanyRegistration,
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow user registration",
      "data-lpignore": "true",
      "name": "Allow user registration",
      "id": "company-registration"
    },
    model: {
      value: (_vm.company.details.allowRegistration),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "allowRegistration", $$v)
      },
      expression: "company.details.allowRegistration"
    }
  }), _vm._v(" "), (this.errors.has('Allow user registration')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow user registration')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-url"
    }
  }, [_vm._v("Company URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.url),
      expression: "company.details.url"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company url'),
      'is-locked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditCompanyRegistration === false,
      "data-lpignore": "true",
      "id": "new-company-url",
      "name": "Company url"
    },
    domProps: {
      "value": (_vm.company.details.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "url", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-all-emails"
    }
  }, [_vm._v("Only allow emails from an approved domain")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow all emails'),
      'is-locked is-blocked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "disabled": !_vm.canEditCompanyRegistration,
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow all emails",
      "data-lpignore": "true",
      "name": "Allow all emails",
      "id": "company-registration-all-emails"
    },
    model: {
      value: (_vm.company.details.allowAllEmails),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "allowAllEmails", $$v)
      },
      expression: "company.details.allowAllEmails"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow all emails')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-need-approval"
    }
  }, [_vm._v("New users must be approved by an admin")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Request approval'),
      'is-locked is-blocked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "disabled": !_vm.canEditCompanyRegistration || (_vm.company.details.allowRegistration && !_vm.company.details.allowRegistration.value),
      "searchable": false,
      "options": _vm.yesNoOptionsForSelectNew,
      "data-vv-name": "Request approval",
      "data-lpignore": "true",
      "name": "Request approval",
      "id": "company-registration-need-approval"
    },
    model: {
      value: (_vm.company.details.emailApproval),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "emailApproval", $$v)
      },
      expression: "company.details.emailApproval"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Request approval')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', [_c('h3', {
    staticClass: "content-section-subtitle color-2-63"
  }, [_vm._v("Approved email domains")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.canEditCompanyRegistration === true) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "pasteEmails"
    }
  }, [_vm._v("Bulk paste")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailControl['input']),
      expression: "emailControl['input']"
    }],
    staticClass: "form-control form-control__textarea",
    attrs: {
      "data-lpignore": "true",
      "rows": "2",
      "id": "pasteEmails",
      "cols": "20"
    },
    domProps: {
      "value": (_vm.emailControl['input'])
    },
    on: {
      "paste": function($event) {
        _vm.emailControl['isPaste'] = true
      },
      "blur": function($event) {
        return _vm.createTags($event, false, true)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailControl, 'input', $event.target.value)
      }, function($event) {
        return _vm.createTags($event, true)
      }]
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.company.approvedEmails), function(row, index) {
    return _c('div', {
      staticClass: "form-group form-group-half",
      class: [{
        'form-group-right-item': (index > 0 && (index + 1) % 2 === 0) && _vm.canEditCompanyRegistration === true,
        'form-group__email-ending-input': _vm.canEditCompanyRegistration === true
      }]
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.email),
        expression: "row.email"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "title": "Email",
        "aria-label": "Email",
        "disabled": _vm.canEditCompanyRegistration === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.canEditCompanyRegistration === true) ? _c('div', {
      staticClass: "form-group form-group-half form-group__email-ending-button form-group__email-ending-remove"
    }, [_c('div', {
      staticClass: "add-email-ending",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.canEditCompanyRegistration === true) ? _c('div', {
    staticClass: "form-group form-group-half form-group__email-add-button"
  }, [_c('div', {
    staticClass: "add-email-ending",
    on: {
      "click": _vm.addEmailRow
    }
  }, [_vm._v("Add new")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditCompanyRegistration) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditCompanyRegistration()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyRegistration()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()])] : (this.tabActive === 'billing') ? [_c('billing-profile', {
    attrs: {
      "embedded": true,
      "embedded-company-id": _vm.companyId
    }
  })] : (this.tabActive === 'progress') ? [_c('div', {
    ref: "companyChart",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyChart'
    }],
    style: ({
      display: !_vm.hasPoints ? 'none' : ''
    }),
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_c('h3', [_vm._v("Company progress")]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "content-company-badge",
    attrs: {
      "id": "contentCompanyBadge"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.badgeCopy = true
      }
    }
  }, [_c('iframe', {
    attrs: {
      "width": "210",
      "height": "85",
      "src": _vm.getBadgeLink() + '?company=' + (_vm.company ? _vm.company.hash : '') + '&theme=' + (_vm.selectedHightCont === 1 ? 'dark' : 'light')
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-date"
  }, [_vm._v(_vm._s(_vm.getCurrentDate()))]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-chart-body"
  }, [_c('div', {
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, [_c('div', {
    staticClass: "content-chart-data",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, [(!_vm.chartData) ? _c('div', {
    staticClass: "content-loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid"
  }, [_c('div', {
    staticClass: "content-chart-grid-line line_10"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_9",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_8",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_7",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_6",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_5",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_4",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_3",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_2",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_1",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  })]), _vm._v(" "), _vm._l((_vm.chartData), function(c, index) {
    return (c) ? _c('div', {
      staticClass: "content-chart-points"
    }, [_vm._l((c.scores), function(p) {
      return _c('div', {
        staticClass: "content-chart-point",
        class: 'chapter__' + c.chapter.id,
        style: ({
          left: p.left + 'px',
          top: p.top + '%',
          borderColor: c.chapter.color
        }),
        attrs: {
          "data-chapter": 'chapter-legend-' + c.chapter.id,
          "data-color": c.chapter.color
        }
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "content-chart-chapters__item",
      class: 'chapter_' + _vm.getChapterIndex(c),
      style: ({
        backgroundColor: c.hover && c.hover.type === 'level' && c.hover.show === true ? c.chapter.color : '',
        color: _vm.selectedHightCont === 1 ? (c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : c.chapter.color) : c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : '',
        borderColor: c.chapter.color
      }),
      attrs: {
        "id": 'chapter-legend-' + c.chapter.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addChapterHover(c, 'level')
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getChapterCustomName(c.chapter)) + "\n                      ")]), _vm._v(" "), (_vm.hasBenchmark(c)) ? _c('span', {
      staticClass: "show-benchmark tooltip",
      class: [{
        'active': c.hover && c.hover.type === 'benchmark' && c.hover.show === true
      }, 'chapter_' + _vm.getChapterIndex(c)],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addChapterHover(c, 'benchmark')
        }
      }
    }, [_c('span', {
      staticClass: "tooltip-text"
    }, [_vm._v("Show benchmark")])]) : _vm._e(), _vm._v(" "), (c.hover && c.hover.type === 'level' && c.hover.show === true) ? _c('div', {
      staticClass: "chapter-level",
      style: ({
        top: (100 - c.hover.top) + '%',
        height: c.hover.top + '%'
      })
    }) : _vm._e(), _vm._v(" "), (c.hover && c.hover.type === 'benchmark' && c.hover.show === true) ? _c('div', {
      staticClass: "chapter-benchmark",
      style: ({
        top: (100 - c.hover.top) + '%',
        height: c.hover.top + '%'
      })
    }) : _vm._e()], 2) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-x",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, _vm._l((_vm.quarters), function(quarter) {
    return _c('div', {
      staticClass: "content-chart-legend-x__item"
    }, [_vm._v("\n                      Q" + _vm._s(quarter.quarter) + " " + _vm._s(quarter.year) + "\n                    ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    ref: "companyProgress",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditProgressChapters === false) ? [_vm._v("Company progress on task categories")] : [_vm._v("Edit company progress on task categories")]], 2), _vm._v(" "), (_vm.canEditProgressChapters === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openProgressChapters()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group progress-table"
  }, [_c('table', {
    staticClass: "benchmark-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "has-order"
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrder()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.chapterOrderBy !== null && this.chapterOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.chapterOrderBy !== null && !this.chapterOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', [_vm._v("Policies and procedures")]), _vm._v(" "), _c('th', [_vm._v("Finding talent")]), _vm._v(" "), _c('th', [_vm._v("Assessing talent")]), _vm._v(" "), _c('th', [_vm._v("Retaining talent")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedChapters), function(row, index) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v("Q" + _vm._s(row.quarter) + " " + _vm._s(row.year))]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.policies),
        expression: "row.score.policies"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Policies and procedures score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.policies)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "policies", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.finding),
        expression: "row.score.finding"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Finding talent score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.finding)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "finding", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.assessing),
        expression: "row.score.assessing"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Assessing talent score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.assessing)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "assessing", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.retaining),
        expression: "row.score.retaining"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Retaining talent score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.retaining)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "retaining", $event.target.value)
        }
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditProgressChapters) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditProgressChapters()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProgressChapters()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()])] : _vm._e()], 2)]), _vm._v(" "), (_vm.badgeCopy === true) ? _c('div', {
    staticClass: "badge-copy"
  }, [_c('div', {
    staticClass: "badge-copy-container"
  }, [_c('div', {
    staticClass: "badge-copy-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.badgeCopy = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-selector"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "iframe-themes"
    }
  }, [_vm._v("Theme")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": true,
      "options": _vm.iframeThemes,
      "data-lpignore": "true",
      "id": "iframe-themes"
    },
    model: {
      value: (_vm.iframeTheme),
      callback: function($$v) {
        _vm.iframeTheme = $$v
      },
      expression: "iframeTheme"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-iframe",
    class: _vm.iframeTheme.value
  }, [_c('iframe', {
    attrs: {
      "width": "210",
      "height": "85",
      "id": "previewIframe",
      "src": _vm.getBadgeLink() + '?company=' + (_vm.company ? _vm.company.hash : '') + '&theme=' + _vm.iframeTheme.value
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-code"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyIframe()
      }
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "title": "Badge code",
      "id": "iframeCode",
      "rows": "3",
      "cols": "50",
      "onclick": "this.focus(); this.select()",
      "readonly": "readonly"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getIframeCode())
    }
  })])])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-chart-legend-y"
  }, [_c('div', {
    staticClass: "content-chart-legend-y__item level-5"
  }, [_c('span', [_vm._v("Platinum")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-4"
  }, [_c('span', [_vm._v("Gold")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-3"
  }, [_c('span', [_vm._v("Silver")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-2"
  }, [_c('span', [_vm._v("Bronze")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-1"
  }, [_c('span', [_vm._v("Foundation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Quarters")])])
}]}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Create company account")]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users background-1-20 color-2-100",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Back to all companies list")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "companyDetails",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section no-margin-top"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Add company details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.name),
      expression: "newCompany.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: [{
      'form-control form-control__input background-1-10-disabled  border-1-10-disabled has-error': _vm.errors.has('Company name')
    }, 'form-control form-control__input background-1-10-disabled  border-1-10-disabled'],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-name",
      "name": "Company name"
    },
    domProps: {
      "value": (_vm.newCompany.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-parent"
    }
  }, [_vm._v("Parent company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Parent company')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.preparedCompanies,
      "clearable": _vm.newCompany.parent !== null,
      "data-vv-name": "Parent company",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-parent"
    },
    model: {
      value: (_vm.newCompany.parent),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "parent", $$v)
      },
      expression: "newCompany.parent"
    }
  }), _vm._v(" "), (this.errors.has('Parent company')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Parent company')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-industry"
    }
  }, [_vm._v("Industry")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Industry')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getIndustriesForSelect,
      "clearable": false,
      "data-vv-name": "Industry",
      "data-lpignore": "true",
      "name": "Industry",
      "id": "new-company-industry"
    },
    model: {
      value: (_vm.newCompany.industry),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "industry", $$v)
      },
      expression: "newCompany.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-language"
    }
  }, [_vm._v("Default language")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.language),
      expression: "newCompany.language"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-company-language",
      "name": "Default language"
    },
    domProps: {
      "value": (_vm.newCompany.language)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "language", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-types"
    }
  }, [_vm._v("User types")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('User types')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.getDefaultRegistrationRolesForSelect,
      "data-vv-name": "User types",
      "data-lpignore": "true",
      "name": "User types",
      "id": "new-user-types"
    },
    model: {
      value: (_vm.newCompany.usersType),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "usersType", $$v)
      },
      expression: "newCompany.usersType"
    }
  }), _vm._v(" "), (this.errors.has('User types')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('User types')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companySizes"
    }
  }, [_vm._v("Company size")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company size')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.companySizes,
      "data-vv-name": "Company size",
      "data-lpignore": "true",
      "name": "Company size",
      "id": "companySizes"
    },
    model: {
      value: (_vm.newCompany.companySize),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "companySize", $$v)
      },
      expression: "newCompany.companySize"
    }
  }), _vm._v(" "), (this.errors.has('Company size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company size')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companyLocations"
    }
  }, [_vm._v("Company location")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company location')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Company location",
      "data-lpignore": "true",
      "name": "Company location",
      "id": "companyLocations"
    },
    model: {
      value: (_vm.newCompany.companyLocation),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "companyLocation", $$v)
      },
      expression: "newCompany.companyLocation"
    }
  }), _vm._v(" "), (this.errors.has('Company location')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company location')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.seesChat),
      expression: "newCompany.seesChat"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Sees the Chat box')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "new-company-chat",
      "name": "Sees the Chat box"
    },
    domProps: {
      "checked": Array.isArray(_vm.newCompany.seesChat) ? _vm._i(_vm.newCompany.seesChat, null) > -1 : (_vm.newCompany.seesChat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newCompany.seesChat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newCompany, "seesChat", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newCompany, "seesChat", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newCompany, "seesChat", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-chat"
    }
  }, [_vm._v("Sees the Chat box")])]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.isDemo),
      expression: "newCompany.isDemo"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Demo company')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "new-company-demo",
      "name": "Demo company"
    },
    domProps: {
      "checked": Array.isArray(_vm.newCompany.isDemo) ? _vm._i(_vm.newCompany.isDemo, null) > -1 : (_vm.newCompany.isDemo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newCompany.isDemo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newCompany, "isDemo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newCompany, "isDemo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newCompany, "isDemo", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-demo"
    }
  }, [_vm._v("Demo company")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element form-element-date",
    attrs: {
      "id": "date-selector"
    }
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-subscription-end"
    }
  }, [_vm._v("Subscription ends on:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.subscriptionEnd),
      expression: "newCompany.subscriptionEnd"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-subscription-end",
      "name": "Subscription ends"
    },
    domProps: {
      "value": (_vm.newCompany.subscriptionEnd)
    },
    on: {
      "focus": function($event) {
        _vm.datepicker.shown = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "subscriptionEnd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datepicker.shown),
      expression: "datepicker.shown"
    }],
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-calendar-half"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "open-date": _vm.datepicker.subscription,
      "format": 'dd/MM/yyyy'
    },
    on: {
      "selected": function($event) {
        return _vm.dateSelected($event)
      }
    },
    model: {
      value: (_vm.datepicker.subscription),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "subscription", $$v)
      },
      expression: "datepicker.subscription"
    }
  })], 1)]), _vm._v(" "), (this.errors.has('Subscription ends')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Subscription ends')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-limit"
    }
  }, [_vm._v("Employee limit")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.employeeLimit),
      expression: "newCompany.employeeLimit"
    }],
    class: [{
      'form-control form-control__input background-1-10-disabled  border-1-10-disabled has-error': _vm.errors.has('Employee limit')
    }, 'form-control form-control__input background-1-10-disabled  border-1-10-disabled'],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-limit",
      "name": "Employee limit"
    },
    domProps: {
      "value": (_vm.newCompany.employeeLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "employeeLimit", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Employee limit')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Employee limit')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-status"
    }
  }, [_vm._v("Company status")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company status')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getStatusesForSelect,
      "clearable": _vm.newCompany.enabled !== null,
      "data-vv-name": "Company status",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-status"
    },
    model: {
      value: (_vm.newCompany.enabled),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "enabled", $$v)
      },
      expression: "newCompany.enabled"
    }
  }), _vm._v(" "), (this.errors.has('Company status')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company status')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-contraption"
    }
  }, [_vm._v("Company contraption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.contraption),
      expression: "newCompany.contraption"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company contraption')
    }],
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "maxlength": "4",
      "id": "company-contraption",
      "name": "Company contraption"
    },
    domProps: {
      "value": (_vm.newCompany.contraption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "contraption", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "companyEmails",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Company registration settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration"
    }
  }, [_vm._v("Allow user registration")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow user registration')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow user registration",
      "data-lpignore": "true",
      "name": "Allow user registration",
      "id": "company-registration"
    },
    model: {
      value: (_vm.newCompany.allowRegistration),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "allowRegistration", $$v)
      },
      expression: "newCompany.allowRegistration"
    }
  }), _vm._v(" "), (this.errors.has('Allow user registration')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow user registration')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-url"
    }
  }, [_vm._v("Company URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.url),
      expression: "newCompany.url"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company url')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-url",
      "name": "Company url"
    },
    domProps: {
      "value": (_vm.newCompany.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "url", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-all-emails"
    }
  }, [_vm._v("Only allow emails from an approved domain")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow all emails')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow all emails",
      "data-lpignore": "true",
      "name": "Allow all emails",
      "id": "company-registration-all-emails"
    },
    model: {
      value: (_vm.newCompany.allowAllEmails),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "allowAllEmails", $$v)
      },
      expression: "newCompany.allowAllEmails"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow all emails')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-need-approval"
    }
  }, [_vm._v("New users must be approved by an admin")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Request approval')
    }],
    attrs: {
      "disabled": _vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value,
      "searchable": false,
      "options": _vm.yesNoOptionsForSelectNew,
      "data-vv-name": "Request approval",
      "data-lpignore": "true",
      "name": "Request approval",
      "id": "company-registration-need-approval"
    },
    model: {
      value: (_vm.newCompany.emailApproval),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "emailApproval", $$v)
      },
      expression: "newCompany.emailApproval"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Request approval')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', [_c('h3', {
    staticClass: "content-section-subtitle color-2-63"
  }, [_vm._v("Approved email domains")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "pasteEmails"
    }
  }, [_vm._v("Bulk paste")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailControl['input']),
      expression: "emailControl['input']"
    }],
    staticClass: "form-control form-control__textarea",
    attrs: {
      "data-lpignore": "true",
      "rows": "2",
      "id": "pasteEmails",
      "cols": "20"
    },
    domProps: {
      "value": (_vm.emailControl['input'])
    },
    on: {
      "paste": function($event) {
        _vm.emailControl['isPaste'] = true
      },
      "blur": function($event) {
        return _vm.createTags($event, false, true)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailControl, 'input', $event.target.value)
      }, function($event) {
        return _vm.createTags($event, true)
      }]
    }
  })])])]), _vm._v(" "), _vm._l((_vm.newCompany.approvedEmails), function(row, index) {
    return _c('div', {
      staticClass: "form-group form-group-half form-group__email-ending-input",
      class: [{
        'form-group-right-item': (index > 0 && (index + 1) % 2 === 0)
      }]
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.email),
        expression: "row.email"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "title": "Email",
        "aria-label": "Email",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-group-half form-group__email-ending-button form-group__email-ending-remove"
    }, [_c('div', {
      staticClass: "add-email-ending",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half form-group__email-add-button"
  }, [_c('div', {
    staticClass: "add-email-ending",
    on: {
      "click": _vm.addEmailRow
    }
  }, [_vm._v("Add new")])])], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "companyOwner",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Add account owner contact data")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.firstName),
      expression: "ownerData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "owner-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.ownerData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.phoneNumber),
      expression: "ownerData.phoneNumber"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "owner-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.ownerData.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-last-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.lastName),
      expression: "ownerData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "owner-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.ownerData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.email),
      expression: "ownerData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.ownerData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before"
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyDetails')
      }
    }
  }, [_vm._v("Add company details ")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 email-endings",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyEmails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyEmails')
      }
    }
  }, [_vm._v("Add email endings")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyOwner'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [_vm._v("Add account owner contact data")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "add-new-user-control-panel"
  }, [_c('button', {
    staticClass: "clear-form",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardAllData()
      }
    }
  }, [_vm._v("Cancel, discard all data")]), _vm._v(" "), _c('button', {
    staticClass: "submit-user",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewCompany()
      }
    }
  }, [_vm._v("Create company account")])])])
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((_vm.player.shown && _vm.player.url) || (_vm.taskImageFullPath !== '' && !_vm.player.shown)) ? _c('div', {
    staticClass: "task-content-media"
  }, [(_vm.player.shown && _vm.player.url) ? _c('div', {
    staticClass: "task-content-video"
  }, [_c('iframe', {
    attrs: {
      "id": "player",
      "frameborder": "0",
      "webkitAllowFullScreen": "",
      "mozallowfullscreen": "",
      "allowFullScreen": "",
      "height": "340",
      "width": "600",
      "src": _vm.player.url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.taskImageFullPath !== '' && !_vm.player.shown) ? _c('div', {
    staticClass: "task-content-image",
    class: {
      'video-type': _vm.player.url
    },
    style: ({
      backgroundImage: 'url(' + _vm.taskImageFullPath + ')'
    }),
    attrs: {
      "title": _vm.taskImageAlt
    }
  }, [(_vm.player.url) ? _c('div', {
    staticClass: "task-content-video-play",
    on: {
      "click": function($event) {
        return _vm.playVideo()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-play-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "play-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1\n                16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200\n                200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
    }
  })])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.taskContentType === 8 || _vm.taskContentType === 9) ? _c('div', {
    staticClass: "task-content-resources"
  }, [_c('div', {
    staticClass: "task-content-resources-items"
  }, _vm._l((_vm.taskResources), function(resource) {
    return (resource.file) ? _c('a', {
      attrs: {
        "href": "#",
        "role": "button",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadFile(resource)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-circle-down fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-circle-down",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288\n             302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4\n             9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(resource.name ? resource.name : resource.file))])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-content-text",
    domProps: {
      "innerHTML": _vm.taskContent
    }
  }), _vm._v(" "), (_vm.related && _vm.related.length) ? _c('div', {
    staticClass: "task-content-related"
  }, [_c('div', {
    staticClass: "task-content-related-header"
  }, [_vm._v("\n      Related resources\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "task-content-related-list"
  }, _vm._l((_vm.related), function(item) {
    return _c('li', {
      staticClass: "task-content-related-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          'name': 'content',
          'params': {
            'id': item.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "task-content-related-icon"
    }, [(item.contentType === 7) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "play",
        "d": "M20.068,15.367l-6.188-3.762c-0.408-0.226-0.922-0.079-1.149,0.329\n                      c-0.069,0.125-0.106,0.266-0.106,0.409v7.313c0.001,0.467,0.381,0.845,0.849,0.843c0.142,0,0.282-0.037,0.406-0.105l6.188-3.55\n                      c0.408-0.228,0.554-0.743,0.326-1.151C20.317,15.556,20.205,15.443,20.068,15.367z M24.719,16c0.001-4.814-3.901-8.718-8.715-8.719\n                      c-0.001,0-0.003,0-0.004,0c-4.814-0.001-8.718,3.901-8.719,8.715c0,0.001,0,0.003,0,0.004c-0.001,4.814,3.901,8.718,8.715,8.719\n                      c0.001,0,0.003,0,0.004,0c4.814,0.001,8.718-3.901,8.719-8.715C24.719,16.003,24.719,16.001,24.719,16z M8.969,16\n                      c-0.001-3.882,3.145-7.03,7.027-7.031c0.001,0,0.003,0,0.004,0c3.882-0.001,7.03,3.145,7.031,7.027c0,0.001,0,0.003,0,0.004\n                      c0.001,3.882-3.145,7.03-7.027,7.031c-0.001,0-0.003,0-0.004,0c-3.882,0.001-7.03-3.145-7.031-7.027\n                      C8.969,16.003,8.969,16.001,8.969,16z"
      }
    })])])] : (item.contentType === 8) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-pdf",
        "d": "M22.254,10.446L19.3,7.496c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17\n                        c-0.934,0.003-1.69,0.762-1.688,1.696v14.625c0.001,0.932,0.756,1.687,1.688,1.687h10.125c0.931-0.001,1.686-0.756,1.687-1.687\n                        V11.641C22.749,11.193,22.57,10.763,22.254,10.446z M20.925,11.504H18.25V8.829L20.925,11.504z M10.938,23.317V8.692h5.625v3.656\n                        c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v10.125H10.938z M19.738,18.265\n                        c-0.438-0.422-1.657-0.311-2.268-0.229c-0.609-0.374-1.067-0.95-1.294-1.628c0.211-0.634,0.276-1.307,0.19-1.969\n                        c-0.054-0.43-0.446-0.734-0.876-0.68c-0.277,0.035-0.515,0.215-0.624,0.473c-0.105,0.795-0.02,1.603,0.248,2.359\n                        c-0.37,0.893-0.785,1.766-1.244,2.616c-0.7,0.362-1.652,0.921-1.793,1.624c-0.116,0.555,0.914,1.941,2.675-1.1\n                        c0.782-0.293,1.584-0.529,2.4-0.707c0.602,0.343,1.272,0.548,1.962,0.6c0.448,0.011,0.821-0.343,0.832-0.792\n                        c0.005-0.209-0.071-0.413-0.212-0.567H19.738z M12.769,21c0.273-0.476,0.636-0.893,1.069-1.23\n                        C13.17,20.834,12.769,21.024,12.769,21z M15.638,14.3c0.26,0,0.236,1.129,0.063,1.434c-0.139-0.466-0.161-0.959-0.063-1.435V14.3z\n                         M14.78,19.1c0.338-0.618,0.628-1.26,0.868-1.922c0.26,0.487,0.621,0.912,1.059,1.248C16.047,18.595,15.402,18.821,14.78,19.1\n                        L14.78,19.1z M19.407,18.924c0,0-0.176,0.212-1.307-0.27C19.329,18.56,19.533,18.841,19.407,18.924L19.407,18.924z"
      }
    })])])] : (item.contentType === 9) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-alt",
        "d": "M19.375,15.719c-0.001-0.234-0.19-0.423-0.424-0.422H18.95h-5.9\n                        c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9c0.233-0.001,0.421-0.189,0.422-0.422\n                        L19.375,15.719z M18.95,18.25h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9\n                        c0.233-0.001,0.421-0.189,0.422-0.422v-0.984C19.371,18.439,19.183,18.251,18.95,18.25z M22.75,11.637\n                        c-0.002-0.446-0.182-0.873-0.5-1.187L19.3,7.5c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17C10.006,7,9.25,7.756,9.25,8.688v14.625\n                        C9.251,24.245,10.006,25,10.938,25h10.125c0.931-0.001,1.686-0.756,1.687-1.687V11.637z M18.25,8.825l2.675,2.675H18.25V8.825z\n                         M21.063,23.313H10.938V8.688h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656V23.313z"
      }
    })])])] : (item.contentType === 10) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M24.438,7H7.563C6.631,7,5.875,7.756,5.875,8.688v11.25c0.001,0.932,0.756,1.687,1.688,1.687h6.75\n                        l-0.563,1.688h-2.531c-0.466,0-0.844,0.378-0.844,0.844S10.753,25,11.219,25h9.563c0.466-0.016,0.831-0.407,0.814-0.872\n                        c-0.015-0.443-0.371-0.799-0.814-0.814H18.25l-0.562-1.687h6.75c0.932-0.001,1.688-0.757,1.687-1.689V8.688\n                        C26.125,7.756,25.37,7.001,24.438,7z M23.875,19.375H8.125V9.25h15.75V19.375z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,13.25h9c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-9c-0.276,0-0.5,0.224-0.5,0.5v1\n                        C10.375,13.026,10.599,13.25,10.875,13.25z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,17.25h6c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276,0-0.5,0.224-0.5,0.5v1\n                        C10.375,17.025,10.599,17.25,10.875,17.25z"
      }
    })])])])] : (item.contentType === 11) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M17.7,14.421h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.514\n                        c0.245-0.097,0.498-0.177,0.76-0.236c0.028-0.057,0.048-0.118,0.048-0.186l0.003-0.984C18.124,14.609,17.935,14.42,17.7,14.421\n                        C17.701,14.421,17.7,14.421,17.7,14.421z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M11.378,17.796v0.984c0.001,0.233,0.189,0.421,0.422,0.422h2.571c0.272-0.693,0.68-1.316,1.203-1.828H11.8\n                        C11.567,17.375,11.379,17.563,11.378,17.796z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M9.688,22.437V7.812h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v3.62\n                        c0.599,0.067,1.166,0.225,1.687,0.477v-5.648c-0.002-0.446-0.182-0.873-0.5-1.187l-2.95-2.95c-0.315-0.318-0.744-0.498-1.192-0.5\n                        h-7.17C8.756,6.124,8,6.88,8,7.812v14.625c0.001,0.932,0.756,1.687,1.688,1.687h5.28c-0.356-0.503-0.615-1.074-0.776-1.687H9.688z\n                         M17,7.949l2.675,2.675H17V7.949z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M23.891,24.791l-1.558-1.558c-0.071-0.07-0.166-0.109-0.266-0.109h-0.254c0.447-0.571,0.689-1.275,0.688-2\n                        c0.001-1.794-1.454-3.249-3.248-3.25c-0.001,0-0.002,0-0.003,0c-1.794-0.001-3.249,1.454-3.25,3.248c0,0.001,0,0.001,0,0.002\n                        c-0.001,1.794,1.454,3.249,3.248,3.25c0.001,0,0.001,0,0.002,0c0.725,0.002,1.429-0.24,2-0.687v0.255\n                        c0,0.1,0.039,0.195,0.109,0.266l1.558,1.557c0.145,0.146,0.381,0.147,0.528,0.003c0.001-0.001,0.002-0.002,0.003-0.003\n                        l0.442-0.443C24.035,25.176,24.036,24.939,23.891,24.791z M19.25,23.124c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2\n                        S20.355,23.124,19.25,23.124z"
      }
    })])])])] : _vm._e()], 2), _vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditDetails) ? [_vm._v("\n        Edit industry details:\n      ")] : _vm._e(), _vm._v("\n      " + _vm._s(this.industry.details.name) + "\n    ")], 2), _vm._v(" "), _c('div', {
    staticClass: "profile-actions float-none"
  }, [_c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    class: [{
      'not-allowed': (_vm.industry.details.companies && _vm.industry.details.companies.length) || _vm.industry.details.id === 1
    }],
    attrs: {
      "title": _vm.deleteMessage()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteIndustry()
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "dashboard active",
    attrs: {
      "to": {
        name: 'edit-industry',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Basic data")]), _vm._v(" "), (_vm.landing) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-landing',
        params: {
          id: _vm.landing
        }
      }
    }
  }, [_vm._v("Landing")]) : _vm._e(), _vm._v(" "), (!_vm.landing) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createLanding()
      }
    }
  }, [_vm._v("Create landing")]) : _vm._e(), _vm._v(" "), (_vm.registrationLanding) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-registration-landing',
        params: {
          industry: _vm.registrationLanding,
          company: 'default'
        }
      }
    }
  }, [_vm._v("Registration landing")]) : _vm._e(), _vm._v(" "), (!_vm.registrationLanding) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createRegistrationLanding()
      }
    }
  }, [_vm._v("Create registration landing")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'edit-industry-emails',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom emails")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'edit-industry-styling',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom email and website styling")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "industryDetails",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("Industry details")] : [_vm._v("Edit industry details")]], 2), _vm._v(" "), (_vm.canEditDetails === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-name"
    }
  }, [_vm._v("Industry name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.name),
      expression: "industry.details.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Industry name')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-industry-name",
      "name": "Industry name"
    },
    domProps: {
      "value": (_vm.industry.details.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Industry name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                " + _vm._s(this.errors.first('Industry name')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-parent"
    }
  }, [_vm._v("Parent industry")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Parent industry')
    }],
    attrs: {
      "searchable": true,
      "disabled": _vm.canEditDetails === false,
      "options": _vm.preparedIndustries,
      "data-vv-name": "Parent industry",
      "data-lpignore": "true",
      "id": "new-industry-parent"
    },
    model: {
      value: (_vm.industry.details.parent),
      callback: function($$v) {
        _vm.$set(_vm.industry.details, "parent", $$v)
      },
      expression: "industry.details.parent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-alias"
    }
  }, [_vm._v("Industry alias")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.slug),
      expression: "industry.details.slug"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled is-disabled",
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-industry-alias",
      "name": "Industry alias",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.industry.details.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "slug", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industryBenchmark",
    staticClass: "content-section content-section__bordered border-1-20 profile-section"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditBenchmark === false) ? [_vm._v("Benchmark")] : [_vm._v("Edit benchmark")]], 2), _vm._v(" "), (_vm.canEditBenchmark === false) ? _c('a', {
    staticClass: "edit-details border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditBenchmark()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('table', {
    staticClass: "benchmark-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkPoliciesAndProcedures),
      expression: "industry.benchmarkPoliciesAndProcedures"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Policies and procedures benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkPoliciesAndProcedures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkPoliciesAndProcedures", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkFindingTalent),
      expression: "industry.benchmarkFindingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Finding talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkFindingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkFindingTalent", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkAccessingTalent),
      expression: "industry.benchmarkAccessingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Accessing talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkAccessingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkAccessingTalent", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkRetainingTalent),
      expression: "industry.benchmarkRetainingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Retaining talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkRetainingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkRetainingTalent", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditBenchmark) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditBenchmark()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryBenchmark()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industryChapters",
    staticClass: "content-section content-section__bordered border-1-20 profile-section"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditChapters === false) ? [_vm._v("Task categories")] : [_vm._v("Edit task categories")]], 2), _vm._v(" "), (_vm.canEditChapters === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditChapters()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-pp"
    }
  }, [_vm._v("Policies and procedures")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-pp",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterPoliciesAndProcedures),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterPoliciesAndProcedures", $$v)
      },
      expression: "industry.chapterPoliciesAndProcedures"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-ft"
    }
  }, [_vm._v("Finding talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-ft",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterFindingTalent),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterFindingTalent", $$v)
      },
      expression: "industry.chapterFindingTalent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-at"
    }
  }, [_vm._v("Assessing talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-at",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterAccessingTalent),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterAccessingTalent", $$v)
      },
      expression: "industry.chapterAccessingTalent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-rt"
    }
  }, [_vm._v("Retaining talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-rt",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterRetainingTalent),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterRetainingTalent", $$v)
      },
      expression: "industry.chapterRetainingTalent"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditChapters) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditChapters()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryChapters()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industrySponsors",
    staticClass: "content-section content-section__bordered border-1-20",
    class: [{
      'content-section__dark': _vm.canEditSponsors === false
    }]
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditSponsors === false) ? [_vm._v("Sponsors")] : [_vm._v("Edit sponsors")]], 2), _vm._v(" "), (_vm.canEditSponsors === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditSponsors()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.canEditSponsors === true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        onUpdate: _vm.onUpdate
      }),
      expression: "{ onUpdate: onUpdate }"
    }],
    staticClass: "sponsor-list",
    attrs: {
      "options": _vm.industry.sponsors
    }
  }, _vm._l((_vm.industry.sponsors), function(row, index) {
    return _c('div', {
      staticClass: "sponsor-item"
    }, [_c('div', {
      staticClass: "sponsor-item-handle"
    }), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-logo",
      attrs: {
        "id": 'uploadLogo-' + index
      }
    }, [(row.isLogoFileUploaded === true && row.logo !== '') ? _c('div', {
      staticClass: "sponsor-item-logo__image",
      style: ({
        backgroundImage: _vm.getImage(row.logo)
      })
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.sort = index + 1),
        expression: "row.sort = index + 1"
      }],
      staticClass: "hidden",
      staticStyle: {
        "display": "none"
      },
      domProps: {
        "value": (row.sort = index + 1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "sort = index + 1", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.isLogoFileUploaded === false),
        expression: "row.isLogoFileUploaded === false"
      }],
      staticClass: "form-label color-2-63 form-label__logo-upload",
      class: [{
        'disabled': _vm.canEditSponsors === false
      }],
      attrs: {
        "for": 'uploadInput-' + index
      }
    }, [_vm._v("\n                    +Upload logo\n                    "), (row.isLogoFileUploaded === false) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "disabled": _vm.canEditSponsors === false,
        "id": 'uploadInput-' + index,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "row.logo",
        "placeholder": "+Upload logo"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (row.isLogoFileUploaded === true) ? _c('div', {
      staticClass: "sponsor-item-logo__remove",
      on: {
        "click": function($event) {
          return _vm.removeLogo(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-alt"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.alt),
        expression: "row.alt"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Image alt",
        "type": "text",
        "disabled": _vm.canEditSponsors === false,
        "placeholder": "Alt",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.alt)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "alt", $event.target.value)
        }, function($event) {
          return _vm.addNewRow(index)
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.url),
        expression: "row.url"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Image url",
        "type": "text",
        "disabled": _vm.canEditSponsors === false,
        "placeholder": "Url",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.url)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "url", $event.target.value)
        }, function($event) {
          return _vm.addNewRow(index)
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.canEditSponsors === false) ? _c('div', {
    staticClass: "sponsors-list__edit"
  }, _vm._l((_vm.industry.sponsors), function(row, index) {
    return (row.logo) ? _c('div', {
      staticClass: "sponsor-item"
    }, [_c('div', {
      staticClass: "sponsor-item-logo",
      attrs: {
        "id": 'uploadLogo-' + index
      }
    }, [_c('img', {
      staticClass: "sponsor-item-logo__image",
      attrs: {
        "src": _vm.getImageFullPath(row.logo)
      }
    })])]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditSponsors) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditSponsors()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustrySponsors()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before"
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 details-2",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryDetails')
      }
    }
  }, [_vm._v("Industry details ")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 benchmark",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryBenchmark'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryBenchmark')
      }
    }
  }, [_vm._v("Benchmark")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 benchmark",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryChapters'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryChapters')
      }
    }
  }, [_vm._v("Task categories")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 sponsors",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industrySponsors'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industrySponsors')
      }
    }
  }, [_vm._v("Sponsors")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Policies and procedures")]), _vm._v(" "), _c('th', [_vm._v("Finding talent")]), _vm._v(" "), _c('th', [_vm._v("Assessing talent")]), _vm._v(" "), _c('th', [_vm._v("Retaining talent")])])])
}]}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditDetails) ? [_vm._v("\n        Edit user details:\n      ")] : (_vm.canEditPassword) ? [_vm._v("\n        Edit user password:\n      ")] : [_vm._v("\n        User profile:\n      ")], _vm._v("\n      " + _vm._s(_vm.user.personal.first_name) + " " + _vm._s(_vm.user.personal.last_name) + "\n    ")], 2), _vm._v(" "), _c('div', {
    staticClass: "profile-actions"
  }, [(this.user.personal.status !== 5) ? [_c('button', {
    staticClass: "archive-profile archive-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.archiveProfile()
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 11.207 14.009"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 11.207 14.009",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_14_",
      "d": "M9.806,0H1.401C0.628,0,0,0.628,0,1.401v11.207c0,0.772,0.628,1.401,1.401,1.401h8.405\n                c0.773,0,1.401-0.629,1.401-1.401V1.401C11.207,0.628,10.579,0,9.806,0z M9.094,5.697H6.946v2.148h2.148v2.148H6.946V7.845H4.798\n                V5.697h2.148V3.549H4.798V1.401h2.148v2.148h2.148V5.697z"
    }
  })])]), _vm._v(" "), (this.user.personal.enabled) ? [_vm._v("\n            Archive\n          ")] : [_vm._v("\n            Unarchive\n          ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "delete-profile delete-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteProfile()
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 14.431 15.232"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 14.431 15.232",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_8_",
      "points": "9.62,1.603 9.62,0 4.81,0 4.81,1.603 0,1.603 0,3.207 14.431,3.207 14.431,1.603 "
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_7_",
      "d": "M1.603,4.008v9.621c0,0.884,0.719,1.603,1.603,1.603h8.017c0.884,0,1.603-0.72,1.603-1.603V4.008\n                H1.603z M6.414,12.026H4.81v-4.81h1.603V12.026z M9.62,12.026H8.017v-4.81H9.62V12.026z"
    }
  })])]), _vm._v("\n          Delete\n        ")])] : _vm._e(), _vm._v(" "), (this.user.personal.status === 5) ? [_c('button', {
    staticClass: "delete-profile delete-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.approveUser(true)
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 174.239 174.239"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 174.239 174.239",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305\n                  c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M131.55,59.413c-3.231-2.562-7.927-2.027-10.491,1.211L86.694,103.95L66.132,82.015c-2.812-3.014-7.543-3.155-10.555-0.345\n                  c-3.009,2.825-3.162,7.55-0.34,10.555l26.481,28.251c1.415,1.512,3.389,2.363,5.447,2.363c0.102,0,0.204,0,0.309-0.005\n                  c2.168-0.092,4.193-1.123,5.542-2.825L132.76,69.9C135.322,66.672,134.78,61.976,131.55,59.413z"
    }
  })])])]), _vm._v("\n          Approve\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "delete-profile delete-profile-custom background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.approveUser(false)
      }
    }
  }, [_c('span', {
    staticClass: "delete-profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 174.239 174.239"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 174.239 174.239",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305\n                  c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M120.83,53.414c-2.917-2.917-7.647-2.917-10.559,0L87.12,76.568L63.969,53.414c-2.917-2.917-7.642-2.917-10.559,0\n                  s-2.917,7.642,0,10.559l23.151,23.153L53.409,110.28c-2.917,2.917-2.917,7.642,0,10.559c1.458,1.458,3.369,2.188,5.28,2.188\n                  c1.911,0,3.824-0.729,5.28-2.188L87.12,97.686l23.151,23.153c1.458,1.458,3.369,2.188,5.28,2.188c1.911,0,3.821-0.729,5.28-2.188\n                  c2.917-2.917,2.917-7.642,0-10.559L97.679,87.127l23.151-23.153C123.747,61.057,123.747,56.331,120.83,53.414z"
    }
  })])])]), _vm._v("\n          Reject\n        ")])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard dashboard-custom background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "dashboard-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M501.333,490.667H10.667C4.779,490.667,0,495.445,0,501.333C0,507.221,4.779,512,10.667,512h490.667\n                  c5.888,0,10.667-4.779,10.667-10.667C512,495.445,507.221,490.667,501.333,490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M96,362.667H32c-5.888,0-10.667,4.779-10.667,10.667v128C21.333,507.221,26.112,512,32,512h64\n                  c5.888,0,10.667-4.779,10.667-10.667v-128C106.667,367.445,101.888,362.667,96,362.667z M85.333,490.667H42.667V384h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M224,256h-64c-5.888,0-10.667,4.779-10.667,10.667v234.667c0,5.888,4.779,10.667,10.667,10.667h64\n                  c5.888,0,10.667-4.779,10.667-10.667V266.667C234.667,260.779,229.888,256,224,256z M213.333,490.667h-42.667V277.333h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M352,298.667h-64c-5.888,0-10.667,4.779-10.667,10.667v192c0,5.888,4.779,10.667,10.667,10.667h64\n                  c5.888,0,10.667-4.779,10.667-10.667v-192C362.667,303.445,357.888,298.667,352,298.667z M341.333,490.667h-42.667V320h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M480,170.667h-64c-5.888,0-10.667,4.779-10.667,10.667v320c0,5.888,4.779,10.667,10.667,10.667h64\n                  c5.888,0,10.667-4.779,10.667-10.667v-320C490.667,175.445,485.888,170.667,480,170.667z M469.333,490.667h-42.667V192h42.667\n                  V490.667z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M64,192c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                  c23.531,0,42.667-19.136,42.667-42.667C106.667,211.136,87.531,192,64,192z M64,256c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C85.333,246.421,75.776,256,64,256z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M192,85.333c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667s42.667-19.136,42.667-42.667\n                  C234.667,104.469,215.531,85.333,192,85.333z M192,149.333c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C213.333,139.755,203.776,149.333,192,149.333z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M320,128c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                  c23.531,0,42.667-19.136,42.667-42.667C362.667,147.136,343.531,128,320,128z M320,192c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C341.333,182.421,331.776,192,320,192z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M448,0c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667\n                  c23.531,0,42.667-19.136,42.667-42.667C490.667,19.136,471.531,0,448,0z M448,64c-11.776,0-21.333-9.579-21.333-21.333\n                  c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C469.333,54.421,459.776,64,448,64z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M432.939,57.728c-4.16-4.16-10.923-4.16-15.083,0l-82.773,82.773c-4.16,4.16-4.16,10.923,0,15.083\n                  c2.091,2.069,4.821,3.115,7.552,3.115c2.709,0,5.44-1.024,7.531-3.115l82.773-82.773\n                  C437.099,68.651,437.099,61.888,432.939,57.728z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M294.208,146.048l-68.523-19.541c-5.739-1.664-11.563,1.664-13.163,7.339c-1.621,5.675,1.664,11.563,7.317,13.184\n                  l68.523,19.541c0.981,0.277,1.963,0.405,2.923,0.405c4.651,0,8.917-3.051,10.261-7.744\n                  C303.168,153.579,299.883,147.669,294.208,146.048z"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M175.36,141.291c-3.669-4.608-10.368-5.355-14.976-1.707l-80.427,64.128c-4.608,3.691-5.376,10.389-1.685,14.997\n                  c2.112,2.645,5.227,4.011,8.341,4.011c2.325,0,4.672-0.768,6.635-2.304l80.427-64.128\n                  C178.283,152.597,179.051,145.899,175.36,141.291z"
    }
  })])])])]), _vm._v("\n      Go to Dashboard\n    ")]), _vm._v(" "), (_vm.getUserRole !== 'cu' && _vm.user.personal.company) ? _c('router-link', {
    staticClass: "all-users all-users-custom background-1-20 color-2-100",
    attrs: {
      "to": {
        name: _vm.getUserRole === 'gm' ? 'users' : 'ca-users'
      }
    }
  }, [_c('span', {
    staticClass: "all-users-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32.053 34.5"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32.053 34.5",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_10_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_20_",
      "d": "M4.75,0C2.131,0,0,2.131,0,4.75S2.131,9.5,4.75,9.5S9.5,7.369,9.5,4.75S7.369,0,4.75,0z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_21_",
      "d": "M15.178,6.25h15.375c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H15.178\n                c-0.829,0-1.5,0.671-1.5,1.5S14.349,6.25,15.178,6.25z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_22_",
      "d": "M4.75,12.375c-2.619,0-4.75,2.131-4.75,4.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75\n                S7.369,12.375,4.75,12.375z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_23_",
      "d": "M30.553,15.625H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375\n                c0.829,0,1.5-0.671,1.5-1.5S31.381,15.625,30.553,15.625z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_24_",
      "d": "M4.75,25C2.131,25,0,27.131,0,29.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75\n                S7.369,25,4.75,25z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_25_",
      "d": "M30.553,28.25H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375\n                c0.829,0,1.5-0.671,1.5-1.5S31.381,28.25,30.553,28.25z"
    }
  })])])]), _vm._v("\n      Back to all users\n    ")]) : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'gm' && (this.user.personal.role && this.user.personal.role.slug !== 'gm')) ? _c('button', {
    staticClass: "impersonate-user background-1-20",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.impersonateUser()
      }
    }
  }, [_vm._v("Impersonate this user")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details color-1-100",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 18"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 18",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12\n                    c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8\n                    S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1\n                    C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"
    }
  })])]), _vm._v(" "), (_vm.canEditDetails === false) ? [_vm._v("User details")] : [_vm._v("Edit user details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 password",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userPassword'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userPassword')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65\n                    L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"
    }
  })])]), _vm._v(" "), (_vm.canEditPassword === false) ? [_vm._v("User password")] : [_vm._v("Edit user password")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 data",
    class: [{
      'active  color-1-100': _vm.activeSection === 'userData'
    }]
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 19.99 21"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 19.99 21",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0\n                    c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226\n                    c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657\n                    c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878\n                    c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995\n                    c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "10",
      "cy": "9.995",
      "r": "3"
    }
  })])])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('userData')
      }
    }
  }, [_vm._v("User Data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "userDetails",
    staticClass: "content-section content-section__bordered border-1-20 profile-section no-margin-top",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("User details")] : [_vm._v("Edit user details")]], 2), _vm._v(" "), (_vm.canEditDetails === false) ? _c('button', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                      c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                      L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                      l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n            Edit\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element featured-image"
  }, [_c('div', {
    staticClass: "user-featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Profile image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded && _vm.canEditDetails === true),
      expression: "!isThumbnailFileUploaded && canEditDetails === true"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Image",
      "data-vv-as": "\"Image\"",
      "value.sync": "user.personal.image",
      "disabled": _vm.canEditDetails === false
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded && _vm.canEditDetails === false),
      expression: "!isThumbnailFileUploaded && canEditDetails === false"
    }],
    staticClass: "user-featured-image-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0\n                           224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2\n                           288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    }
  })])]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.user.personal.image + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded && _vm.canEditDetails === true) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.first_name),
      expression: "user.personal.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.user.personal.first_name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-surname"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.last_name),
      expression: "user.personal.last_name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-surname",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.user.personal.last_name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.email),
      expression: "user.personal.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': _vm.consentStatus === 0
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false || _vm.consentStatus === 0,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.user.personal.email)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.phone),
      expression: "user.personal.phone"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-user-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.user.personal.phone)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-role"
    }
  }, [_vm._v("User type (role)")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false || (_vm.getUserRole !== 'gm' && _vm.getUserRole !== 'ca' && _vm.getUserRole !== 'ta'),
      "searchable": true,
      "options": _vm.getRolesForSelect,
      "data-vv-name": "User type",
      "name": "User type",
      "id": "new-user-company-role"
    },
    on: {
      "keyup": _vm.fieldChange
    },
    model: {
      value: (_vm.user.personal.role),
      callback: function($$v) {
        _vm.$set(_vm.user.personal, "role", $$v)
      },
      expression: "user.personal.role"
    }
  }), _vm._v(" "), (this.errors.has('User type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('User type')))]) : _vm._e()], 1), _vm._v(" "), (this.isStakeholder === true) ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-stakeholder_type"
    }
  }, [_vm._v("Stakeholder type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.stakeholder_type),
      expression: "user.personal.stakeholder_type"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Stakeholder type'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "data-vv-name": "Stakeholder type",
      "name": "Stakeholder type",
      "id": "new-user-company-stakeholder_type"
    },
    domProps: {
      "value": (_vm.user.personal.stakeholder_type)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "stakeholder_type", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company'),
      'is-locked': !_vm.canEditDetails,
      'is-blocked': (_vm.user.personal.role && _vm.user.personal.role.slug === 'gm')
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false || (_vm.user.personal.role && _vm.user.personal.role.slug === 'gm'),
      "searchable": true,
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Company name",
      "name": "Company name",
      "id": "new-user-company-name"
    },
    on: {
      "keyup": _vm.fieldChange
    },
    model: {
      value: (_vm.user.personal.company),
      callback: function($$v) {
        _vm.$set(_vm.user.personal, "company", $$v)
      },
      expression: "user.personal.company"
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.function),
      expression: "user.personal.function"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Function'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-user-company-function",
      "name": "Function"
    },
    domProps: {
      "value": (_vm.user.personal.function)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "function", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Function')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Function')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-company-title"
    }
  }, [_vm._v("Job title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.job_title),
      expression: "user.personal.job_title"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Job title'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-user-company-title",
      "name": "Job title"
    },
    domProps: {
      "value": (_vm.user.personal.job_title)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "job_title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Job title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Job title')))]) : _vm._e()])]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-id"
    }
  }, [_vm._v("User id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.id),
      expression: "user.personal.id"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'is-blocked': _vm.canEditDetails,
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-user-id"
    },
    domProps: {
      "value": (_vm.user.personal.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal, "id", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfileDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "userPassword",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    class: [{
      'content-section__closed': _vm.canEditPassword === false
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditPassword === false) ? [_vm._v("User password")] : [_vm._v("Edit user password")]], 2), _vm._v(" "), (_vm.canEditPassword === false) ? _c('button', {
    staticClass: "edit-password edit-password-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditPassword()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                      c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                      L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                      l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n            Edit\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canEditPassword) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-password-edit"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.plainPassword.first),
      expression: "user.personal.plainPassword.first"
    }],
    ref: "passwordInput",
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.passwordError
    }],
    attrs: {
      "disabled": _vm.canEditPassword === false,
      "data-lpignore": "true",
      "id": "new-password-edit",
      "type": "password",
      "name": "New password"
    },
    domProps: {
      "value": (_vm.user.personal.plainPassword.first)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('New password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('New password')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "retype-password"
    }
  }, [_vm._v("Retype new password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:passwordInput'),
      expression: "'required|confirmed:passwordInput'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.personal.plainPassword.second),
      expression: "user.personal.plainPassword.second"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.passwordError
    }],
    attrs: {
      "disabled": _vm.canEditPassword === false,
      "data-lpignore": "true",
      "type": "password",
      "id": "retype-password",
      "name": "Retype new password",
      "data-vv-as": "Retype new password"
    },
    domProps: {
      "value": (_vm.user.personal.plainPassword.second)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.personal.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Retype new password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Retype new password')))]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.canEditPassword) ? _c('div', {
    staticClass: "update-data update-data__password"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditPassword()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfilePassword()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "userData",
    staticClass: "content-section consent-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("User data")]), _vm._v(" "), _c('div', {
    staticClass: "consent-data",
    class: this.consentStatus === 1 ? 'consent-given' : 'consent-not-given'
  }, [(this.consentStatus === 1) ? [_vm._v("\n              User provided their consent to store and process their data under the GDPR settings on " + _vm._s(this.convertDate(this.consentDate, '.')) + ".\n            ")] : [(this.consentDate) ? [_vm._v("\n                User withdrawn their consent to allow us to use their data under the GDPR settings on " + _vm._s(this.convertDate(this.consentDate, '.')) + ". "), _c('br'), _vm._v("\n                User has to provide consent so he can use all the website functionalities.\n              ")] : [_vm._v("\n                User haven't provided yet with consent to store and use their data, under the GDPR settings."), _c('br'), _vm._v("\n                User has to provide consent so they can use all the website functionalities.\n              ")]]], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-helper-text color-2-63"
  }, [_vm._v("\n              The new password can't be the same as the old password."), _c('br'), _vm._v("\n              Please use a strong password. It must contain at least 9 characters that include capital letters, lower case letters and numbers.\n            ")])
}]}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Create a new industry account")]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users background-1-20 color-2-100",
    attrs: {
      "to": {
        name: 'industries'
      }
    }
  }, [_vm._v("Back to all industries list")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "industryDetails",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section no-margin-top"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Industry details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-name"
    }
  }, [_vm._v("Industry name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newIndustry.name),
      expression: "newIndustry.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Industry name')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-industry-name",
      "name": "Industry name"
    },
    domProps: {
      "value": (_vm.newIndustry.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newIndustry, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Industry name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-parent"
    }
  }, [_vm._v("Parent industry")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Parent industry')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.preparedIndustries,
      "data-vv-name": "Parent industry",
      "data-lpignore": "true",
      "name": "Industry status",
      "id": "new-industry-parent"
    },
    model: {
      value: (_vm.newIndustry.parent),
      callback: function($$v) {
        _vm.$set(_vm.newIndustry, "parent", $$v)
      },
      expression: "newIndustry.parent"
    }
  }), _vm._v(" "), (this.errors.has('Parent industry')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Parent industry')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "industryBenchmark",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Benchmark")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('table', {
    staticClass: "benchmark-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newIndustry.benchmarkPoliciesAndProcedures),
      expression: "newIndustry.benchmarkPoliciesAndProcedures"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Policies and procedures benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.newIndustry.benchmarkPoliciesAndProcedures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newIndustry, "benchmarkPoliciesAndProcedures", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newIndustry.benchmarkFindingTalent),
      expression: "newIndustry.benchmarkFindingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Finding talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.newIndustry.benchmarkFindingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newIndustry, "benchmarkFindingTalent", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newIndustry.benchmarkAccessingTalent),
      expression: "newIndustry.benchmarkAccessingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Accessing talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.newIndustry.benchmarkAccessingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newIndustry, "benchmarkAccessingTalent", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newIndustry.benchmarkRetainingTalent),
      expression: "newIndustry.benchmarkRetainingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Retaining talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.newIndustry.benchmarkRetainingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newIndustry, "benchmarkRetainingTalent", $event.target.value)
      }
    }
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "industryChapters",
    staticClass: "content-section content-section__bordered border-1-20 profile-section"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Task categories")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-pp"
    }
  }, [_vm._v("Policies and procedures")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-pp",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.newIndustry.chapterPoliciesAndProcedures),
      callback: function($$v) {
        _vm.$set(_vm.newIndustry, "chapterPoliciesAndProcedures", $$v)
      },
      expression: "newIndustry.chapterPoliciesAndProcedures"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-ft"
    }
  }, [_vm._v("Finding talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-ft",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.newIndustry.chapterFindingTalent),
      callback: function($$v) {
        _vm.$set(_vm.newIndustry, "chapterFindingTalent", $$v)
      },
      expression: "newIndustry.chapterFindingTalent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-at"
    }
  }, [_vm._v("Assessing talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-at",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.newIndustry.chapterAccessingTalent),
      callback: function($$v) {
        _vm.$set(_vm.newIndustry, "chapterAccessingTalent", $$v)
      },
      expression: "newIndustry.chapterAccessingTalent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-rt"
    }
  }, [_vm._v("Retaining talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-rt",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.newIndustry.chapterRetainingTalent),
      callback: function($$v) {
        _vm.$set(_vm.newIndustry, "chapterRetainingTalent", $$v)
      },
      expression: "newIndustry.chapterRetainingTalent"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "industrySponsors",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before no-bottom-margin"
  }, [_vm._v("Add sponsors")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable"
    }],
    staticClass: "sponsor-list",
    attrs: {
      "options": _vm.newIndustry.sponsors
    }
  }, _vm._l((_vm.newIndustry.sponsors), function(row, index) {
    return _c('div', {
      staticClass: "sponsor-item"
    }, [_c('div', {
      staticClass: "sponsor-item-handle"
    }), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-logo",
      attrs: {
        "id": 'uploadLogo-' + index
      }
    }, [(row.isLogoFileUploaded === true && row.logo !== '') ? _c('div', {
      staticClass: "sponsor-item-logo__image",
      style: ({
        backgroundImage: 'url(' + row.logo + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.order = index + 1),
        expression: "row.order = index + 1"
      }],
      staticClass: "hidden",
      staticStyle: {
        "display": "none"
      },
      domProps: {
        "value": (row.order = index + 1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "order = index + 1", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.isLogoFileUploaded === false),
        expression: "row.isLogoFileUploaded === false"
      }],
      staticClass: "form-label color-2-63 form-label__logo-upload",
      attrs: {
        "for": 'uploadInput-' + index
      }
    }, [_vm._v("\n                      +Upload logo\n                      "), (row.isLogoFileUploaded === false) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'uploadInput-' + index,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "row.logo",
        "placeholder": "+Upload logo"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (row.isLogoFileUploaded === true) ? _c('div', {
      staticClass: "sponsor-item-logo__remove",
      on: {
        "click": function($event) {
          return _vm.removeLogo(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-alt"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.alt),
        expression: "row.alt"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Image alt",
        "type": "text",
        "placeholder": "Alt",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.alt)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "alt", $event.target.value)
        }, function($event) {
          return _vm.addNewRow(index)
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.url),
        expression: "row.url"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Sponsor url",
        "type": "text",
        "placeholder": "Url",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.url)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "url", $event.target.value)
        }, function($event) {
          return _vm.addNewRow(index)
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    })])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before"
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 details-2",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryDetails')
      }
    }
  }, [_vm._v("Industry details")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 benchmark",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryBenchmark'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryBenchmark')
      }
    }
  }, [_vm._v("Benchmark")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 benchmark",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryChapters'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryChapters')
      }
    }
  }, [_vm._v("Task categories")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 sponsors",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industrySponsors'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industrySponsors')
      }
    }
  }, [_vm._v("Add sponsors")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "add-new-user-control-panel"
  }, [_c('button', {
    staticClass: "clear-form",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardAllData()
      }
    }
  }, [_vm._v("Cancel, discard all data")]), _vm._v(" "), _c('button', {
    staticClass: "submit-user",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewIndustry()
      }
    }
  }, [_vm._v("Save changes")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Policies and procedures")]), _vm._v(" "), _c('th', [_vm._v("Finding talent")]), _vm._v(" "), _c('th', [_vm._v("Accessing talent")]), _vm._v(" "), _c('th', [_vm._v("Retaining talent")])])])
}]}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-single"
  }, [(_vm.task) ? [_c('div', {
    staticClass: "task-header",
    attrs: {
      "id": "taskHeader"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:history.back();"
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n              44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n              24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n          Back\n        ")]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "form-element tasks-list-admin-header-companies"
  }, [_c('label', {
    attrs: {
      "for": "companiesList"
    }
  }, [_vm._v("Change company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select tasks-list-header-boards-selector",
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "clearable": false,
      "value": this.currentCompany,
      "name": "companiesList",
      "id": "companiesList"
    },
    on: {
      "change": function($event) {
        return _vm.changeCompany($event)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "task-single-header"
  }, [_c('div', {
    staticClass: "task-single-header-content-type",
    class: ['content-type-' + _vm.task.contentType]
  }, [(_vm.task.contentType === 7) ? [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "id": "play",
      "d": "M20.068,15.367l-6.188-3.762c-0.408-0.226-0.922-0.079-1.149,0.329\n                c-0.069,0.125-0.106,0.266-0.106,0.409v7.313c0.001,0.467,0.381,0.845,0.849,0.843c0.142,0,0.282-0.037,0.406-0.105l6.188-3.55\n                c0.408-0.228,0.554-0.743,0.326-1.151C20.317,15.556,20.205,15.443,20.068,15.367z M24.719,16c0.001-4.814-3.901-8.718-8.715-8.719\n                c-0.001,0-0.003,0-0.004,0c-4.814-0.001-8.718,3.901-8.719,8.715c0,0.001,0,0.003,0,0.004c-0.001,4.814,3.901,8.718,8.715,8.719\n                c0.001,0,0.003,0,0.004,0c4.814,0.001,8.718-3.901,8.719-8.715C24.719,16.003,24.719,16.001,24.719,16z M8.969,16\n                c-0.001-3.882,3.145-7.03,7.027-7.031c0.001,0,0.003,0,0.004,0c3.882-0.001,7.03,3.145,7.031,7.027c0,0.001,0,0.003,0,0.004\n                c0.001,3.882-3.145,7.03-7.027,7.031c-0.001,0-0.003,0-0.004,0c-3.882,0.001-7.03-3.145-7.031-7.027\n                C8.969,16.003,8.969,16.001,8.969,16z"
    }
  })])])] : (_vm.task.contentType === 8) ? [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "id": "file-pdf",
      "d": "M22.254,10.446L19.3,7.496c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17\n                    c-0.934,0.003-1.69,0.762-1.688,1.696v14.625c0.001,0.932,0.756,1.687,1.688,1.687h10.125c0.931-0.001,1.686-0.756,1.687-1.687\n                    V11.641C22.749,11.193,22.57,10.763,22.254,10.446z M20.925,11.504H18.25V8.829L20.925,11.504z M10.938,23.317V8.692h5.625v3.656\n                    c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v10.125H10.938z M19.738,18.265\n                    c-0.438-0.422-1.657-0.311-2.268-0.229c-0.609-0.374-1.067-0.95-1.294-1.628c0.211-0.634,0.276-1.307,0.19-1.969\n                    c-0.054-0.43-0.446-0.734-0.876-0.68c-0.277,0.035-0.515,0.215-0.624,0.473c-0.105,0.795-0.02,1.603,0.248,2.359\n                    c-0.37,0.893-0.785,1.766-1.244,2.616c-0.7,0.362-1.652,0.921-1.793,1.624c-0.116,0.555,0.914,1.941,2.675-1.1\n                    c0.782-0.293,1.584-0.529,2.4-0.707c0.602,0.343,1.272,0.548,1.962,0.6c0.448,0.011,0.821-0.343,0.832-0.792\n                    c0.005-0.209-0.071-0.413-0.212-0.567H19.738z M12.769,21c0.273-0.476,0.636-0.893,1.069-1.23\n                    C13.17,20.834,12.769,21.024,12.769,21z M15.638,14.3c0.26,0,0.236,1.129,0.063,1.434c-0.139-0.466-0.161-0.959-0.063-1.435V14.3z\n                     M14.78,19.1c0.338-0.618,0.628-1.26,0.868-1.922c0.26,0.487,0.621,0.912,1.059,1.248C16.047,18.595,15.402,18.821,14.78,19.1\n                    L14.78,19.1z M19.407,18.924c0,0-0.176,0.212-1.307-0.27C19.329,18.56,19.533,18.841,19.407,18.924L19.407,18.924z"
    }
  })])])] : (_vm.task.contentType === 9) ? [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "16"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "id": "file-alt",
      "d": "M19.375,15.719c-0.001-0.234-0.19-0.423-0.424-0.422H18.95h-5.9\n                    c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9c0.233-0.001,0.421-0.189,0.422-0.422\n                    L19.375,15.719z M18.95,18.25h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9\n                    c0.233-0.001,0.421-0.189,0.422-0.422v-0.984C19.371,18.439,19.183,18.251,18.95,18.25z M22.75,11.637\n                    c-0.002-0.446-0.182-0.873-0.5-1.187L19.3,7.5c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17C10.006,7,9.25,7.756,9.25,8.688v14.625\n                    C9.251,24.245,10.006,25,10.938,25h10.125c0.931-0.001,1.686-0.756,1.687-1.687V11.637z M18.25,8.825l2.675,2.675H18.25V8.825z\n                     M21.063,23.313H10.938V8.688h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656V23.313z"
    }
  })])])] : (_vm.task.contentType === 10) ? [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "16"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M24.438,7H7.563C6.631,7,5.875,7.756,5.875,8.688v11.25c0.001,0.932,0.756,1.687,1.688,1.687h6.75\n                    l-0.563,1.688h-2.531c-0.466,0-0.844,0.378-0.844,0.844S10.753,25,11.219,25h9.563c0.466-0.016,0.831-0.407,0.814-0.872\n                    c-0.015-0.443-0.371-0.799-0.814-0.814H18.25l-0.562-1.687h6.75c0.932-0.001,1.688-0.757,1.687-1.689V8.688\n                    C26.125,7.756,25.37,7.001,24.438,7z M23.875,19.375H8.125V9.25h15.75V19.375z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M10.875,13.25h9c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-9c-0.276,0-0.5,0.224-0.5,0.5v1\n                    C10.375,13.026,10.599,13.25,10.875,13.25z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M10.875,17.25h6c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276,0-0.5,0.224-0.5,0.5v1\n                    C10.375,17.025,10.599,17.25,10.875,17.25z"
    }
  })])])])] : (_vm.task.contentType === 11) ? [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 32 32"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32 32",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "16"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M17.7,14.421h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.514\n                    c0.245-0.097,0.498-0.177,0.76-0.236c0.028-0.057,0.048-0.118,0.048-0.186l0.003-0.984C18.124,14.609,17.935,14.42,17.7,14.421\n                    C17.701,14.421,17.7,14.421,17.7,14.421z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M11.378,17.796v0.984c0.001,0.233,0.189,0.421,0.422,0.422h2.571c0.272-0.693,0.68-1.316,1.203-1.828H11.8\n                    C11.567,17.375,11.379,17.563,11.378,17.796z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M9.688,22.437V7.812h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v3.62\n                    c0.599,0.067,1.166,0.225,1.687,0.477v-5.648c-0.002-0.446-0.182-0.873-0.5-1.187l-2.95-2.95c-0.315-0.318-0.744-0.498-1.192-0.5\n                    h-7.17C8.756,6.124,8,6.88,8,7.812v14.625c0.001,0.932,0.756,1.687,1.688,1.687h5.28c-0.356-0.503-0.615-1.074-0.776-1.687H9.688z\n                     M17,7.949l2.675,2.675H17V7.949z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M23.891,24.791l-1.558-1.558c-0.071-0.07-0.166-0.109-0.266-0.109h-0.254c0.447-0.571,0.689-1.275,0.688-2\n                    c0.001-1.794-1.454-3.249-3.248-3.25c-0.001,0-0.002,0-0.003,0c-1.794-0.001-3.249,1.454-3.25,3.248c0,0.001,0,0.001,0,0.002\n                    c-0.001,1.794,1.454,3.249,3.248,3.25c0.001,0,0.001,0,0.002,0c0.725,0.002,1.429-0.24,2-0.687v0.255\n                    c0,0.1,0.039,0.195,0.109,0.266l1.558,1.557c0.145,0.146,0.381,0.147,0.528,0.003c0.001-0.001,0.002-0.002,0.003-0.003\n                    l0.442-0.443C24.035,25.176,24.036,24.939,23.891,24.791z M19.25,23.124c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2\n                    S20.355,23.124,19.25,23.124z"
    }
  })])])])] : _vm._e()], 2), _vm._v(" "), _c('h1', {
    staticClass: "task-single-header-title"
  }, [_vm._v("\n          " + _vm._s(_vm.task.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "task-single-header-meta-container"
  }, [_c('div', {
    staticClass: "task-single-header-key"
  }, [_vm._v("\n            " + _vm._s(_vm.task.key) + "\n          ")]), _vm._v(" "), (_vm.getChapterById(_vm.task.chapter)) ? _c('div', {
    staticClass: "task-single-header-chapter"
  }, [_c('div', {
    staticClass: "task-single-header-chapter-progress"
  }, [_c('div', {
    staticClass: "task-single-header-chapter-image",
    style: ({
      backgroundImage: _vm.getChapterBackground(_vm.getChapterById(_vm.task.chapter))
    })
  }), _vm._v(" "), _c('svg', {
    staticClass: "progress",
    attrs: {
      "width": "130",
      "height": "130",
      "viewBox": "0 0 100 100"
    }
  }, [_c('circle', {
    staticClass: "progress_meter",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "44",
      "stroke-width": "5"
    }
  }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
    staticClass: "progress_value",
    class: 'filters_progress_value-' + _vm.getChapterById(_vm.task.chapter)['id'],
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "44",
      "stroke-width": "5"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "task-single-header-chapter-name"
  }, [_vm._v(_vm._s(_vm.getChapterById(_vm.task.chapter)['name']))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-single-header-meta"
  }, [_c('div', {
    staticClass: "task-single-header-meta-properties"
  }, [(_vm.task.recurrent) ? _c('div', {
    staticClass: "task-single-header-meta-property recurrency"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "sync-alt",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                            53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                            94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                            57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                            0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                            162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                            504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.task.mandatory) ? _c('div', {
    staticClass: "task-single-header-meta-property mandatory"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "exclamation-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                            111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                            136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                            0-12.356 5.78-11.981 12.654z"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "task-single-header-meta-user-info"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "task-single-body"
  }, [_c('div', {
    staticClass: "task-single-body-content",
    class: {
      collapsed: _vm.isSectionCollapsed('activeContent')
    }
  }, [_c('button', {
    staticClass: "task-single-collapse",
    class: {
      collapsed: _vm.isSectionCollapsed('activeContent')
    },
    on: {
      "click": function($event) {
        return _vm.collapseSection('activeContent')
      }
    }
  }, [_vm._v("\n            Task content\n            "), _c('span', {
    staticClass: "task-single-collapse-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), _c('task-content', {
    attrs: {
      "company": _vm.company,
      "task-id": _vm.task.id,
      "task-image": _vm.task.image,
      "task-image-alt": _vm.task.imageAlt,
      "task-content": _vm.task.content,
      "task-resources": _vm.task.resources,
      "task-content-type": _vm.task.contentType,
      "task-title": _vm.task.title
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "task-single-body-data",
    class: {
      collapsed: _vm.isSectionCollapsed('activeHistory')
    }
  }, [_c('button', {
    staticClass: "task-single-collapse",
    class: {
      collapsed: _vm.isSectionCollapsed('activeHistory')
    },
    on: {
      "click": function($event) {
        return _vm.collapseSection('activeHistory')
      }
    }
  }, [_vm._v("\n            Manage task\n            "), _c('span', {
    staticClass: "task-single-collapse-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), _c('task-actions', {
    attrs: {
      "company": _vm.company,
      "task-id": _vm.task.id,
      "assignee": _vm.task.assignee,
      "status": _vm.task.status,
      "assessed": _vm.task.assessed,
      "board": _vm.task.board
    },
    on: {
      "task-changed": function($event) {
        return _vm.taskChanged($event)
      }
    }
  }), _vm._v(" "), _c('task-history', {
    attrs: {
      "company": _vm.company,
      "task-id": _vm.task.id,
      "new-status": _vm.newStatus,
      "new-assignee": _vm.newAssignee,
      "new-board": _vm.newBoard
    }
  })], 1)])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All users")]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "admin-gm-breadcrumbs background-2-16-after",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "companies background-1-100-after color-2-77",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users background-1-100-after color-2-77 active",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar border-1-20 background-1-20 color-2-100"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.usersSum) + " users")])]), _vm._v(" "), _c('router-link', {
    staticClass: "data-list-add data-list-add-custom border-1-40 color-2-100",
    attrs: {
      "to": {
        name: _vm.getUserRole === 'gm' ? 'add-user' : 'ca-add-user'
      }
    }
  }, [_c('span', {
    staticClass: "data-list-add-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 15 15"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 15 15",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "points": "8.8,6.2 15,6.2 15,8.8 8.8,8.8 8.8,15 6.2,15 6.2,8.8 0,8.8 0,6.2 6.2,6.2 6.2,0 8.8,0"
    }
  })])]), _vm._v("\n        Add new user\n      ")])], 1), _vm._v(" "), (this.users.length && _vm.getUserRole === 'gm') ? _c('button', {
    staticClass: "csv-download-button",
    on: {
      "click": function($event) {
        return _vm.csvExport(_vm.csvData)
      }
    }
  }, [_vm._v("Export all users")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "fixed",
      "left": "-2000px",
      "bottom": "-2000px"
    },
    attrs: {
      "href": "#",
      "id": "csvDownload"
    }
  }, [_vm._v("download users")]), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters border-1-40"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied data-list-selected-filters-applied-custom background-1-40 color-2-100"
  }, [_c('span', {
    staticClass: "data-list-selected-filters-applied-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 482.41 -477.986 963.167 971.987"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "482.41 -477.986 963.167 971.987",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M848.216-18.686c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3\n                c16.5-19.8,25.6-29.601,25.6-49.2v-272.8c0-15,5.7-29.5,15.8-40.601l353.799-383.899c26.5-28.8,6.101-75.5-33.1-75.5h-873\n                c-39.2,0-59.7,46.6-33.1,75.5L848.216-18.686z"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.editedUsers.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      staticClass: "data-list-selected-filters-body-button-custom background-1-20 color-2-100",
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))]), _vm._v(" "), _c('span', {
      staticClass: "data-list-selected-filters-body-button-icon color-1-100"
    }, [_c('svg', {
      staticClass: "color-1-100",
      staticStyle: {
        "enable-background": "new 0 0 15.002 15.002"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15.002 15.002",
        "xml:space": "preserve"
      }
    }, [_c('polygon', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_2_",
        "points": "7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208\n                12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "
      }
    })])])])
  }), _vm._v(" "), _c('a', {
    staticClass: "data-list-selected-filters-remove-all color-2-100",
    attrs: {
      "href": "#",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeAllFilters($event)
      },
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data border-1-20"
  }, [_c('thead', {
    staticClass: "table-head-mobile-custom background-1-40-before border-1-40",
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [_c('span', {
    staticClass: "table-head-mobile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 482.41 -477.986 963.167 971.987"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "482.41 -477.986 963.167 971.987",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M848.216-18.686c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3\n                c16.5-19.8,25.6-29.601,25.6-49.2v-272.8c0-15,5.7-29.5,15.8-40.601l353.799-383.899c26.5-28.8,6.101-75.5-33.1-75.5h-873\n                c-39.2,0-59.7,46.6-33.1,75.5L848.216-18.686z"
    }
  })])])]), _vm._v(" "), ((_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) && _vm.selectedFilters.length) ? _c('tr', {
    staticClass: "inside-table-filters"
  }, [_c('th', {
    attrs: {
      "colspan": "9",
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      staticClass: "data-list-selected-filters-body-button-custom background-1-20 color-2-100",
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))]), _vm._v(" "), _c('span', {
      staticClass: "data-list-selected-filters-body-button-icon color-1-100"
    }, [_c('svg', {
      staticClass: "color-1-100",
      staticStyle: {
        "enable-background": "new 0 0 15.002 15.002"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15.002 15.002",
        "xml:space": "preserve"
      }
    }, [_c('polygon', {
      staticClass: "st0",
      attrs: {
        "id": "XMLID_2_",
        "points": "7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208\n                      12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "
      }
    })])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil background-1-10 border-1-20",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistSearchInOptions('name')
    },
    attrs: {
      "colspan": "2",
      "scope": "col"
    },
    on: {
      "mouseover": function($event) {
        return _vm.addSearchHoverElement('name')
      },
      "mouseleave": _vm.removeSearchHoverElements
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByName),
      expression: "searchByName"
    }],
    staticClass: "table-search",
    attrs: {
      "title": "Full name",
      "aria-label": "Full name",
      "type": "search",
      "placeholder": "Full name"
    },
    domProps: {
      "value": (_vm.searchByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "column-email-head table-head-ceil background-1-10 border-1-20",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistSearchInOptions('email')
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "mouseover": function($event) {
        return _vm.addSearchHoverElement('email')
      },
      "mouseleave": _vm.removeSearchHoverElements
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchEmail),
      expression: "searchEmail"
    }],
    staticClass: "table-search",
    attrs: {
      "title": "Email",
      "aria-label": "Email",
      "type": "search",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.searchEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "column-role-head table-head-hover table-head-ceil background-1-10 border-1-20",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getRolesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getRolesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getRolesForSelect
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-company-head table-head-hover table-head-ceil background-1-10 border-1-20",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 4,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getTitlesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getTitlesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getTitlesForSelect
    },
    model: {
      value: (_vm.job_title),
      callback: function($$v) {
        _vm.job_title = $$v
      },
      expression: "job_title"
    }
  })], 1)]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('th', {
    staticClass: "column-company-head table-head-hover table-head-ceil background-1-10 border-1-20",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 5,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 5,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(5)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 5
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 5),
      expression: "filerTableHead.selectedCeil === 5"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getCompaniesForSelect
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('created', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'created' && this.userOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'created' && !this.userOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('login', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'login' && this.userOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down background-1-20",
    class: {
      'active': this.userOrderBy !== null && this.userOrderBy.type === 'login' && !this.userOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil background-1-10 border-1-20",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getStatusesForSelect)
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(7)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getStatusesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 7
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 7),
      expression: "filerTableHead.selectedCeil === 7"
    }],
    staticClass: "wrap-dropdown-table-head border-1-20",
    attrs: {
      "id": "sub-menu-7",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "multiple": true,
      "options": _vm.getStatusesForSelect
    },
    model: {
      value: (_vm.userStatus),
      callback: function($$v) {
        _vm.userStatus = $$v
      },
      expression: "userStatus"
    }
  })], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedUsers), function(user, i) {
    return (i < _vm.offset) ? _c('tr', {
      attrs: {
        "tabindex": "0"
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.goToUserEdit(user.id)
        },
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToUserEdit(user.id)
        }
      }
    }, [(user.type === 'show') ? _c('td', {
      staticClass: "id-cell text-center cellpadding border-1-20",
      attrs: {
        "data-title": "ID"
      }
    }, [_vm._v(_vm._s(user.id))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "name-cell cellpadding border-1-20",
      attrs: {
        "data-title": "ID and full name:"
      }
    }, [(_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) ? _c('span', [_vm._v(_vm._s(user.id) + " ")]) : _vm._e(), _vm._v("\n            " + _vm._s(user.first_name || user.last_name ? (user.first_name ? user.first_name + ' ' : '') + (user.last_name ? user.last_name : '') : 'n/a') + "\n          ")]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "email-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Email:"
      }
    }, [_vm._v(_vm._s(user.email ? user.email : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "role-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Role:"
      }
    }, [_vm._v(_vm._s(user.role ? user.role.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "title-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Title:"
      }
    }, [_vm._v(_vm._s(user.job_title ? user.job_title : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show' && _vm.getUserRole === 'gm') ? _c('td', {
      staticClass: "company-cell cellpadding border-1-20",
      attrs: {
        "data-title": "Company:"
      }
    }, [_vm._v(_vm._s(user.company ? user.company.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "created-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Created on:"
      }
    }, [_vm._v(_vm._s(user.created ? _vm.lastActiveTime(user.created) : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "last-login-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Last login:"
      }
    }, [_vm._v(_vm._s(user.last_login ? _vm.lastActiveTime(user.last_login) : 'n/a'))]) : _vm._e(), _vm._v(" "), (user.type === 'show') ? _c('td', {
      staticClass: "status-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Status:"
      }
    }, [_vm._v(_vm._s(_vm.getUserStatus(user) ? _vm.getUserStatus(user).label : 'n/a'))]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), (this.offset <= this.editedUsers.length) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn background-1-100",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(6), _vm._v("Load more\n        ")])]) : _vm._e()])]), _vm._v(" "), (false) ? _c('app-spiner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Created "), _c('br'), _vm._v("on")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("Last login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('button', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editHeader()
      }
    }
  }, [_vm._v("Edit header menu")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editFooter()
      }
    }
  }, [_vm._v("Edit footer")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content background-1-20-before"
  }, [_c('div', {
    staticClass: "hero-title background-1-50-before background-1-100-after"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-1-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-subtitle"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-77",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.subtitle),
      expression: "content.heroSection.subtitle"
    }],
    staticClass: "content color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section subtitle",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.subtitle)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "subtitle", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.subtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description background-1-10-before"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-77",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-points",
    attrs: {
      "role": "list"
    }
  }, [_vm._l((_vm.content.heroSection.points), function(item, index) {
    return _c('div', {
      staticClass: "hero-points_item background-1-20-before background-1-40-after",
      attrs: {
        "role": "listitem"
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-check",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
      }
    })]), _vm._v(" "), (!_vm.pageEditMode) ? _c('span', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.heroSection.points, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('points')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "hero-button"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Get started now")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image background-1-10-after background-2-4-before"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClient"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showClient"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.title && _vm.content.clientSection.title !== '') ? _c('h2', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode || _vm.content.clientSection.description && _vm.content.clientSection.description !== '') ? _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.description && _vm.content.clientSection.description !== '') ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_c('div', {
    staticClass: "clients-slider"
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.featuresSection.hideSection || _vm.content.featuresSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper features-section landing-page-wrapper__gray",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.hideSection),
      expression: "content.featuresSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFeatures"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.featuresSection.hideSection) ? _vm._i(_vm.content.featuresSection.hideSection, null) > -1 : (_vm.content.featuresSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.featuresSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.featuresSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showFeatures'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.featuresSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.title),
      expression: "content.featuresSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.featuresSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.featuresSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.featuresSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  }, [_vm._l((_vm.content.featuresSection.items), function(item, index) {
    return (index < _vm.ppp) ? _c('div', {
      ref: 'feature-' + index,
      refInFor: true,
      staticClass: "feature-item",
      class: [{
        'expanded': item.expanded && !_vm.pageEditMode
      }]
    }, [(!_vm.pageEditMode && item.expanded) ? _c('a', {
      staticClass: "feature-close border-1-50",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.expandSection('feature-' + index, item)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "feature-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": item.altImage
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "landing-page-image-upload",
      attrs: {
        "for": 'feature-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'feature-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "feature-content"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-description color-2-77",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.description)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "feature-description color-2-77",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item excerpt",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
      staticClass: "feature-text edit-mode",
      attrs: {
        "editorToolbar": _vm.editorToolbar,
        "useCustomImageHandler": ""
      },
      on: {
        "imageAdded": _vm.handleImageAdded
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.expanded) ? _c('div', {
      staticClass: "feature-text background-1-50-before",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.text && item.text !== '') ? _c('a', {
      staticClass: "feature-link background-1-10 background-1-50-hover color-2-100 border-1-50",
      class: [{
        'expanded': item.expanded
      }],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.expandSection('feature-' + index, item, true)
        }
      }
    }, [(item.expanded) ? [_vm._v("Show less")] : [_vm._v("Show more")]], 2) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.featuresSection.items, index)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('features')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.howItWorksSection.hideSection || _vm.content.howItWorksSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper how-it-works-section landing-page-wrapper__gray",
    attrs: {
      "role": "region",
      "aria-labelledby": "howItWorksTitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.hideSection),
      expression: "content.howItWorksSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHowItWorksSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.howItWorksSection.hideSection) ? _vm._i(_vm.content.howItWorksSection.hideSection, null) > -1 : (_vm.content.howItWorksSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.howItWorksSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.howItWorksSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHowItWorksSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [(!_vm.pageEditMode && _vm.content.howItWorksSection.title !== '') ? _c('h2', {
    staticClass: "section-title",
    attrs: {
      "id": "howItWorksTitle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.howItWorksSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.title),
      expression: "content.howItWorksSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "title", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.howItWorksSection.description !== '') ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.howItWorksSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.description),
      expression: "content.howItWorksSection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "description", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "list flex-section"
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "content-slider"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "howItWorksSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.howItWorksOptionsContent
    }
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.testimonialsSection.hideSection || _vm.content.testimonialsSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.testimonialsSection.hideSection || content.testimonialsSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper testimonials-section landing-page-wrapper__gray",
    attrs: {
      "id": "our-clients",
      "role": "region",
      "aria-labelledby": "testimonialsTitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.testimonialsSection.hideSection),
      expression: "content.testimonialsSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showTestimonialsSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.testimonialsSection.hideSection) ? _vm._i(_vm.content.testimonialsSection.hideSection, null) > -1 : (_vm.content.testimonialsSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.testimonialsSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.testimonialsSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.testimonialsSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.testimonialsSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showTestimonialsSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title center",
    attrs: {
      "id": "testimonialsTitle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.testimonialsSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.testimonialsSection.title),
      expression: "content.testimonialsSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.testimonialsSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.testimonialsSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.testimonialsSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.content.testimonialsSection.testimonials), function(item, index) {
    return (_vm.pageEditMode) ? _c('div', {
      key: index,
      staticClass: "list-item edit-mode"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.testimonialsSection.testimonials, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "list-item-content"
    }, [_c('div', {
      staticClass: "list-item-text"
    }, [_c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), (_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-image"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.image = null
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [(_vm.isGM()) ? _c('label', {
      staticClass: "list-item-image-upload",
      attrs: {
        "for": 'testimonial-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'testimonial-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta"
    }, [_c('div', {
      staticClass: "list-item-meta-name"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Name",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta-company"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.company),
        expression: "item.company"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Company",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.company)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "company", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.company))]) : _vm._e()])])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.pageEditMode && _vm.slidesReady) ? _c('slick', {
    ref: "testimonialsSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.testimonialsOptionsContent
    }
  }, _vm._l((_vm.content.testimonialsSection.testimonials), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-content"
    }, [_c('div', {
      staticClass: "list-item-text"
    }, [_c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "list-item-image"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" | "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.company)
      }
    })])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('testimonials')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-wrapper plans-section",
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('plans-list', {
    attrs: {
      "title": "Choose a plan that's right for you",
      "subtitle": "Clear Assured contains the latest D&I resources and content so that organisations of all sizes can progress their inclusion journey. Choose the plan that most closely reflects your business sector to access specific guidance and expertise."
    },
    on: {
      "plan-selected": function($event) {
        return _vm.planSelected($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.contactCTA.hideSection || _vm.content.contactCTA.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.contactCTA.hideSection || content.contactCTA.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper contact-cta-section",
    attrs: {
      "role": "region",
      "aria-labelledby": "contactCTATitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.hideSection),
      expression: "content.contactCTA.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showContactCTASection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.contactCTA.hideSection) ? _vm._i(_vm.content.contactCTA.hideSection, null) > -1 : (_vm.content.contactCTA.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.contactCTA.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.contactCTA, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showContactCTASection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_c('div', {
    staticClass: "contact-cta--content__title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.contactCTA.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.title),
      expression: "content.contactCTA.title"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactCTA.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactCTA, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactCTA.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--content__text"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.contactCTA.text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.text),
      expression: "content.contactCTA.text"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactCTA.text)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactCTA, "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactCTA.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions",
    class: _vm.pageEditMode ? 'edit-mode' : ''
  }, [_vm._l((_vm.content.contactCTA.buttons), function(button) {
    return [(_vm.pageEditMode) ? [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.text),
        expression: "button.text"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button text"
      },
      domProps: {
        "value": (button.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "text", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.link),
        expression: "button.link"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button link"
      },
      domProps: {
        "value": (button.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "link", $event.target.value)
        }
      }
    })])])] : [_c('a', {
      attrs: {
        "href": button.link
      }
    }, [_vm._v(_vm._s(button.text))])]]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('contact-cta-button')
      }
    }
  }, [_vm._v("+ Add button")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.subscribeSection.hideSection || _vm.content.subscribeSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.subscribeSection.hideSection || content.subscribeSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper subscribe-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.hideSection),
      expression: "content.subscribeSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showSubscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.subscribeSection.hideSection) ? _vm._i(_vm.content.subscribeSection.hideSection, null) > -1 : (_vm.content.subscribeSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.subscribeSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.subscribeSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showSubscribe"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.title),
      expression: "content.subscribeSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.subscribeSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.description),
      expression: "content.subscribeSection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('form', {
    staticClass: "tcc-form",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.subscribeMe()
      }
    }
  }, [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-firstname"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.firstname),
      expression: "subscribeForm.firstname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'not-empty': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'has-error': this.errors.has('First name')
    }],
    attrs: {
      "id": "tcc-form-firstname",
      "type": "text",
      "name": "First name",
      "data-vv-name": "First name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.firstname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.firstnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.firstnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-lastname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.lastname),
      expression: "subscribeForm.lastname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'not-empty': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'has-error': this.errors.has('Last name')
    }],
    attrs: {
      "id": "tcc-form-lastname",
      "type": "text",
      "name": "Last name",
      "data-vv-name": "Last name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.lastname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.lastnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.lastnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.email),
      expression: "subscribeForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'not-empty': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'has-error': this.errors.has('Email address')
    }],
    attrs: {
      "id": "tcc-form-email",
      "type": "email",
      "name": "Email address",
      "data-vv-name": "Email address",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                Submitting\n              ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-envelope",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-envelope",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM384 320c0 17.67-14.33 32-32 32H160c-17.67 0-32-14.33-32-32V238l122.1 48.82C251.1 287.6 253.1 288 256 288s4.031-.375 5.938-1.141L384 238V320zM384 203.6l-128 51.2L128 203.6V192c0-17.67 14.33-32 32-32h192c17.67 0 32 14.33 32 32V203.6z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                    " + _vm._s(_vm.formStatus.title) + "\n                  ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.formStatus.body) + "\n                  ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                    Some fields are missing.\n                  ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])])])])]), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.headerEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "headerEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change header menu items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-header-edit"
  }, [_vm._l((_vm.headerData), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu title"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.alt),
        expression: "item.alt"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu alt"
      },
      domProps: {
        "value": (item.alt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "alt", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.headerData, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('header-menu')
      }
    }
  }, [_vm._v("+ Add menu item")])], 2), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardHeaderEdit()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateHeader()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.footerEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "footerEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change footer data")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', {
    staticClass: "footerLogos"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_vm._v("Footer logos")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "logosLabel"
    }
  }, [_vm._v("Footer logos label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.logosLabel),
      expression: "footerData.logosLabel"
    }],
    attrs: {
      "id": "logosLabel"
    },
    domProps: {
      "value": (_vm.footerData.logosLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "logosLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _vm._l((_vm.footerData.logos), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.footerData.logos, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-logos')
      }
    }
  }, [_vm._v("+ Add logos")])], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "footer-address"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "addressLabel"
    }
  }, [_vm._v("Address label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.addressLabel),
      expression: "footerData.addressLabel"
    }],
    attrs: {
      "id": "addressLabel"
    },
    domProps: {
      "value": (_vm.footerData.addressLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "addressLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address data")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.address),
      expression: "footerData.address"
    }],
    attrs: {
      "id": "address"
    },
    domProps: {
      "value": (_vm.footerData.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "address", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.footerData))])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_vm._v("Social media")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "socialLabel"
    }
  }, [_vm._v("Social media label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.socialLabel),
      expression: "footerData.socialLabel"
    }],
    attrs: {
      "id": "socialLabel"
    },
    domProps: {
      "value": (_vm.footerData.socialLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "socialLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _vm._l((_vm.footerData.social), function(item2, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item2.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal2-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal2-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item2, 'image')
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item2.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high2-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high2-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item2, 'imageHigh')
        }
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item2.url),
        expression: "item2.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Social media link"
      },
      domProps: {
        "value": (item2.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item2, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item2.altImage),
        expression: "item2.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Social icon alt"
      },
      domProps: {
        "value": (item2.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item2, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.footerData.social, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-social')
      }
    }
  }, [_vm._v("+ Add social")])], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "popup-title"
  }, [_vm._v("Footer menu")]), _vm._v(" "), _vm._l((_vm.footerData.menu), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu title"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.alt),
        expression: "item.alt"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu alt"
      },
      domProps: {
        "value": (item.alt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "alt", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.footerData.menu, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-menu')
      }
    }
  }, [_vm._v("+ Add menu item")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardFooterEdit()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateFooter()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action background-1-20 background-1-60-hover",
    attrs: {
      "name": "subscribe",
      "type": "submit"
    }
  }, [_vm._v("Subscribe")])])
}]}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "page-description",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          You will be redirected to the login page. If not, please click "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("here")]), _vm._v(".\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.first !== '' || _vm.passwordFocus,
      'has-error': this.errors.has('Password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-reset-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('password')
      }
    }
  }), _vm._v(" "), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.first) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.first,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$c)
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "Password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "Password",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.second !== '' || _vm.retypePasswordFocus,
      'has-error': this.errors.has('Retype password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password-retype"
    }
  }, [_vm._v("Retype password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('retypePassword')
      }
    }
  }), _vm._v(" "), ((_vm.retypePasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:Password'),
      expression: "'required|confirmed:Password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.second) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.second,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$c)
        }
      }
    }
  }) : ((_vm.retypePasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:Password'),
      expression: "'required|confirmed:Password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:Password'),
      expression: "'required|confirmed:Password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype password",
      "type": _vm.retypePasswordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Retype password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Retype password')))]) : _vm._e()]), _vm._v(" "), (_vm.loginForm.isError) ? _c('div', {
    staticClass: "login-form-error"
  }, [_vm._v("\n            " + _vm._s(_vm.loginForm.loginErrorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.resetInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetPassword()
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.formStatus.shown) ? _c('div', {
    staticClass: "form-message",
    class: _vm.formStatus.success ? 'success' : 'error'
  }, [(_vm.formStatus.title !== '') ? _c('h1', [_vm._v(_vm._s(_vm.formStatus.title))]) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v(_vm._s(_vm.formStatus.body))]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content text-left"
  }, [_vm._v("\n            We're almost there.\n          ")])])
}]}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v("\n          " + _vm._s(_vm.promotions.length + (_vm.promotions.length === 1 ? ' promotion' : ' promotions')) + "\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new promotion")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-promotion-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.title),
      expression: "newPromotion.title"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-promotion-title"
    },
    domProps: {
      "value": (_vm.newPromotion.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-promotion-desc"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "form-control form-control__editor",
    attrs: {
      "name": "text",
      "id": "textarea-promotion-desc",
      "editorToolbar": _vm.editorToolbar
    },
    model: {
      value: (_vm.newPromotion.text),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "text", $$v)
      },
      expression: "newPromotion.text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "promotion-button"
    }
  }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.button),
      expression: "newPromotion.button"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "promotion-button",
      "id": "promotion-button"
    },
    domProps: {
      "value": (_vm.newPromotion.button)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "button", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "promotion-link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.link),
      expression: "newPromotion.link"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "promotion-desc",
      "id": "promotion-link"
    },
    domProps: {
      "value": (_vm.newPromotion.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-roles"
    }
  }, [_vm._v("Access")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": false,
      "multiple": true,
      "options": _vm.getRolesForSelect,
      "data-lpignore": "true",
      "name": "roles",
      "id": "button-roles"
    },
    model: {
      value: (_vm.newPromotion.roles),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "roles", $$v)
      },
      expression: "newPromotion.roles"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-companies"
    }
  }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getCompaniesForSelect,
      "data-lpignore": "true",
      "name": "companies",
      "id": "button-companies"
    },
    model: {
      value: (_vm.newPromotion.companies),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "companies", $$v)
      },
      expression: "newPromotion.companies"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-industries"
    }
  }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getIndustriesForSelect,
      "data-lpignore": "true",
      "name": "industries",
      "id": "button-industries"
    },
    model: {
      value: (_vm.newPromotion.industries),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "industries", $$v)
      },
      expression: "newPromotion.industries"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element target-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-targetUsers"
    }
  }, [_vm._v("Target users")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": false,
      "multiple": false,
      "options": _vm.targetUsers,
      "data-lpignore": "true",
      "name": "targetUsers",
      "id": "button-targetUsers"
    },
    model: {
      value: (_vm.newPromotion.targetUsers),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "targetUsers", $$v)
      },
      expression: "newPromotion.targetUsers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half",
    attrs: {
      "id": "date-selector"
    }
  }, [(_vm.newPromotion.targetUsers !== null) ? [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-subscription-end"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.targetDate),
      expression: "newPromotion.targetDate"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-subscription-end",
      "name": "Subscription ends"
    },
    domProps: {
      "value": (_vm.newPromotion.targetDate)
    },
    on: {
      "focus": function($event) {
        _vm.datepicker.shown = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "targetDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datepicker.shown),
      expression: "datepicker.shown"
    }],
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-calendar-half"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "open-date": _vm.datepicker.targetDate,
      "format": 'dd/MM/yyyy'
    },
    on: {
      "selected": function($event) {
        return _vm.dateSelected($event)
      }
    },
    model: {
      value: (_vm.datepicker.targetDate),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "targetDate", $$v)
      },
      expression: "datepicker.targetDate"
    }
  })], 1)])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.active),
      expression: "newPromotion.active"
    }],
    staticClass: "form-control form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": 'new-active-' + _vm.newPromotion.id,
      "name": "active"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPromotion.active) ? _vm._i(_vm.newPromotion.active, null) > -1 : (_vm.newPromotion.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPromotion.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newPromotion, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newPromotion, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newPromotion, "active", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": 'new-active-' + _vm.newPromotion.id
    }
  }, [_vm._v("Enabled")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFileUploaded),
      expression: "!isFileUploaded"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": 'promotionImage-0',
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0)
      }
    }
  })]), _vm._v(" "), (_vm.isFileUploaded) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: _vm.getImage(_vm.newPromotion.image)
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isFileUploaded) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0)
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "promotion-image-alt"
    }
  }, [_vm._v("Image alt")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.imageAlt),
      expression: "newPromotion.imageAlt"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "promotion-image-alt",
      "id": "promotion-image-alt"
    },
    domProps: {
      "value": (_vm.newPromotion.imageAlt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "imageAlt", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createPromotion()
      }
    }
  }, [_vm._v("Create promotion")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Image")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Title ..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedPromotions), function(promotion, i) {
    return _c('tr', [(promotion.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v("\n            " + _vm._s(promotion.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [(promotion.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      staticStyle: {
        "width": "50px",
        "height": "50px",
        "border": "none"
      },
      style: ({
        backgroundImage: _vm.getImage(promotion.image)
      })
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(promotion.title) + "\n          ")]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v("\n            " + _vm._s(promotion.active ? 'Yes' : 'No') + "\n          ")]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.switchEditMode(promotion.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removePromotion(promotion.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (promotion.type === 'edit') ? _c('td', {
      staticClass: "edit-row chapter-edit",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', [_c('div', {
      staticClass: "form-group image-alt"
    }, [_c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!promotion.image),
        expression: "!promotion.image"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'promotionImage-' + promotion.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, promotion.id)
        }
      }
    })]), _vm._v(" "), (promotion.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: _vm.getImage(promotion.image)
      })
    }) : _vm._e(), _vm._v(" "), (promotion.image) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(promotion.id)
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-element featured-image-alt"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-image-alt"
      }
    }, [_vm._v("Image alt")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.imageAlt),
        expression: "promotion.imageAlt"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-image-alt",
        "placeholder": "Type in promotion image alt"
      },
      domProps: {
        "value": (promotion.imageAlt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "imageAlt", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-title"
      }
    }, [_vm._v("Promotion title")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.title),
        expression: "promotion.title"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-title",
        "placeholder": "Type in promotion title"
      },
      domProps: {
        "value": (promotion.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-text"
      }
    }, [_vm._v("Promotion text")]), _vm._v(" "), _c('vue-editor', {
      staticClass: "form-control form-control__editor",
      attrs: {
        "name": "text",
        "id": "edit-text",
        "editorToolbar": _vm.editorToolbar
      },
      model: {
        value: (promotion.text),
        callback: function($$v) {
          _vm.$set(promotion, "text", $$v)
        },
        expression: "promotion.text"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-text"
      }
    }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.button),
        expression: "promotion.button"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-button-text",
        "placeholder": "Type in promotion button text"
      },
      domProps: {
        "value": (promotion.button)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "button", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-link"
      }
    }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.link),
        expression: "promotion.link"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-button-link",
        "placeholder": "Type in promotion link"
      },
      domProps: {
        "value": (promotion.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "link", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-roles"
      }
    }, [_vm._v("Access")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": false,
        "multiple": true,
        "options": _vm.getRolesForSelect,
        "data-lpignore": "true",
        "name": "roles",
        "id": "edit-button-roles"
      },
      model: {
        value: (promotion.roles),
        callback: function($$v) {
          _vm.$set(promotion, "roles", $$v)
        },
        expression: "promotion.roles"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-companies"
      }
    }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": true,
        "multiple": true,
        "options": _vm.getCompaniesForSelect,
        "data-lpignore": "true",
        "name": "companies",
        "id": "edit-button-companies"
      },
      model: {
        value: (promotion.companies),
        callback: function($$v) {
          _vm.$set(promotion, "companies", $$v)
        },
        expression: "promotion.companies"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-industries"
      }
    }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": true,
        "multiple": true,
        "options": _vm.getIndustriesForSelect,
        "data-lpignore": "true",
        "name": "industries",
        "id": "edit-button-industries"
      },
      model: {
        value: (promotion.industries),
        callback: function($$v) {
          _vm.$set(promotion, "industries", $$v)
        },
        expression: "promotion.industries"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "target-group--edit"
    }, [_c('div', {
      staticClass: "form-element target-group"
    }, [_c('div', {
      staticClass: "form-group form-group-half"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "button-targetUsers"
      }
    }, [_vm._v("Target users")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": false,
        "multiple": false,
        "options": _vm.targetUsers,
        "data-lpignore": "true",
        "name": "targetUsers",
        "id": "button-targetUsers"
      },
      model: {
        value: (promotion.targetUsers),
        callback: function($$v) {
          _vm.$set(promotion, "targetUsers", $$v)
        },
        expression: "promotion.targetUsers"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-group-half",
      attrs: {
        "id": "date-selector"
      }
    }, [(promotion.targetUsers !== null) ? [_c('div', {
      staticClass: "form-element"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "new-company-subscription-end"
      }
    }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.targetDate),
        expression: "promotion.targetDate"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "new-company-subscription-end",
        "name": "Subscription ends"
      },
      domProps: {
        "value": (promotion.targetDate)
      },
      on: {
        "focus": function($event) {
          _vm.editDatepicker.shown = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "targetDate", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editDatepicker.shown),
        expression: "editDatepicker.shown"
      }],
      staticClass: "datepicker"
    }, [_c('div', {
      staticClass: "datepicker-calendar-half"
    }, [_c('datepicker', {
      attrs: {
        "inline": true,
        "open-date": _vm.editDatepicker.targetDate,
        "format": 'dd/MM/yyyy'
      },
      on: {
        "selected": function($event) {
          return _vm.dateSelectedEdit($event, promotion)
        }
      },
      model: {
        value: (_vm.editDatepicker.targetDate),
        callback: function($$v) {
          _vm.$set(_vm.editDatepicker, "targetDate", $$v)
        },
        expression: "editDatepicker.targetDate"
      }
    })], 1)])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.active),
        expression: "promotion.active"
      }],
      staticClass: "form-control form-control__checkbox",
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true",
        "id": 'edit-active-' + promotion.id,
        "name": "active"
      },
      domProps: {
        "checked": Array.isArray(promotion.active) ? _vm._i(promotion.active, null) > -1 : (promotion.active)
      },
      on: {
        "change": function($event) {
          var $$a = promotion.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(promotion, "active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(promotion, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(promotion, "active", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'edit-active-' + promotion.id
      }
    }, [_vm._v("Enabled")])])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.discardChanges(promotion.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editPromotion(promotion.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Dashboard promotions")])])
}]}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Topics")])])
}]}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v("\n          " + _vm._s(_vm.redirects.length + (_vm.redirects.length === 1 ? ' redirect' : ' redirects')) + "\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new redirect")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-redirect-from"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirect.fromUrl),
      expression: "newRedirect.fromUrl"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-redirect-from"
    },
    domProps: {
      "value": (_vm.newRedirect.fromUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirect, "fromUrl", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-redirect-to"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirect.toUrl),
      expression: "newRedirect.toUrl"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-redirect-to"
    },
    domProps: {
      "value": (_vm.newRedirect.toUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirect, "toUrl", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createRedirect()
      }
    }
  }, [_vm._v("Create redirect")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFrom),
      expression: "searchFrom"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "From ..."
    },
    domProps: {
      "value": (_vm.searchFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTo),
      expression: "searchTo"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "To ..."
    },
    domProps: {
      "value": (_vm.searchTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedRedirects), function(redirect, i) {
    return _c('tr', [(redirect.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v("\n            " + _vm._s(redirect.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(redirect.fromUrl) + "\n          ")]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(redirect.toUrl) + "\n          ")]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.switchEditMode(redirect.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeRedirect(redirect.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (redirect.type === 'edit') ? _c('td', {
      staticClass: "edit-row chapter-edit",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-from"
      }
    }, [_vm._v("Redirect from")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (redirect.fromUrl),
        expression: "redirect.fromUrl"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-from",
        "placeholder": "Type in redirect from"
      },
      domProps: {
        "value": (redirect.fromUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(redirect, "fromUrl", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-to"
      }
    }, [_vm._v("Redirect to")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (redirect.toUrl),
        expression: "redirect.toUrl"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-to",
        "placeholder": "Type in redirect to"
      },
      domProps: {
        "value": (redirect.toUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(redirect, "toUrl", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.discardChanges(redirect.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editRedirect(redirect.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Redirects")])])
}]}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), (_vm.post.data.title || _vm.post.data.content) ? _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "post-title color-1-100 background-1-10-after"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "post-policy-link"
  }, [_c('router-link', {
    staticClass: "post-action border-1-10",
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Read more about this in our Privacy Policy")])], 1), _vm._v(" "), _c('div', {
    staticClass: "post-actions"
  }, [(_vm.user && _vm.user.consent_status === 0) ? _c('a', {
    staticClass: "post-action cancel color-2-100 background-1-30",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateConsent(2)
      }
    }
  }, [_vm._v("I will consent later")]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.consent_status === 0) ? _c('a', {
    staticClass: "post-action submit color-2-100 background-1-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateConsent(1)
      }
    }
  }, [_vm._v("I consent")]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.consent_status === 1) ? _c('a', {
    staticClass: "post-action cancel color-2-100 background-1-20",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateConsent(0)
      }
    }
  }, [_vm._v("Withdraw your consent")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "post-delete-account"
  }, [_c('a', {
    staticClass: "post-action color-2-100 background-1-20",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteMyProfile()
      }
    }
  }, [_vm._v("Delete my account")])])], 1) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Industries")]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('router-link', {
    staticClass: "data-list-add",
    attrs: {
      "to": {
        name: 'add-industry'
      },
      "tabindex": "-1"
    }
  }, [_vm._v("Add new industry")])], 1), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.filteredIndustryList.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [_c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistSearchInOptions('name')
    },
    attrs: {
      "colspan": "2"
    },
    on: {
      "mouseover": function($event) {
        return _vm.addSearchHoverElement('name')
      },
      "mouseleave": _vm.removeSearchHoverElements
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByName),
      expression: "searchByName"
    }],
    staticClass: "table-search",
    attrs: {
      "title": "ID and industry name",
      "aria-label": "ID and industry name",
      "type": "search",
      "placeholder": "ID and industry name"
    },
    domProps: {
      "value": (_vm.searchByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistSearchInOptions('parent')
    },
    on: {
      "mouseover": function($event) {
        return _vm.addSearchHoverElement('parent')
      },
      "mouseleave": _vm.removeSearchHoverElements
    }
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByParent),
      expression: "searchByParent"
    }],
    staticClass: "table-search",
    attrs: {
      "title": "Parent industry",
      "aria-label": "Parent industry",
      "type": "search",
      "placeholder": "Parent industry"
    },
    domProps: {
      "value": (_vm.searchByParent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByParent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy('companies', true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.industryOrderBy !== null && this.industryOrderBy.type === 'companies' && this.industryOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.industryOrderBy !== null && this.industryOrderBy.type === 'companies' && !this.industryOrderBy.order
    }
  })])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredIndustryList), function(industry, i) {
    return (i < _vm.offset) ? _c('tr', {
      on: {
        "click": function($event) {
          return _vm.goToIndustryEdit(industry.id)
        }
      }
    }, [(industry.type === 'show') ? _c('td', {
      staticClass: "id-cell text-center cellpadding",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "data-title": "ID"
      }
    }, [_vm._v(_vm._s(industry.id))]) : _vm._e(), _vm._v(" "), (industry.type === 'show') ? _c('td', {
      staticClass: "name-cell cellpadding",
      attrs: {
        "data-title": "ID and full name:"
      }
    }, [(_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) ? _c('span', [_vm._v(_vm._s(industry.id) + " ")]) : _vm._e(), _vm._v(_vm._s(industry.name))]) : _vm._e(), _vm._v(" "), (industry.type === 'show') ? _c('td', {
      staticClass: "industry-cell cellpadding",
      attrs: {
        "data-title": "Parent industry:"
      }
    }, [_vm._v(_vm._s(industry.parent ? industry.parent.name : 'n/a'))]) : _vm._e(), _vm._v(" "), (industry.type === 'show') ? _c('td', {
      staticClass: "last-login-cell cellpadding text-center",
      attrs: {
        "data-title": "No. of companies"
      }
    }, [_vm._v(_vm._s(industry.companies))]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), (this.offset <= this.filteredIndustryList.length) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(1), _vm._v("Load more\n        ")])]) : _vm._e()])]), _vm._v(" "), (false) ? _c('app-spiner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("No. of companies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header",
    class: [{
      '`skip-links': _vm.accessibilityLinks
    }]
  }, [(_vm.getConsentRequired === 'true' && _vm.hideConsent === false) ? _c('div', {
    staticClass: "app-header-consent background-2-100"
  }, [_c('div', {
    staticClass: "app-header-consent-container"
  }, [_c('div', {
    staticClass: "app-header-consent-content"
  }, [_vm._v("\n        You are yet to give consent for processing your data.\n        Please consent now so you can have access to all website functionalities.\n        You can always read more about this in our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "app-header-consent-control"
  }, [_c('button', {
    staticClass: "background-1-50 color-2-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateConsent()
      }
    }
  }, [_vm._v("I Consent")]), _vm._v(" "), _c('button', {
    staticClass: "background-2-16 color-2-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardConsent()
      }
    }
  }, [_vm._v("Not now")])])])]) : _vm._e(), _vm._v(" "), (_vm.getImpersonatingUser !== false) ? _c('div', {
    staticClass: "app-header-consent background-2-100"
  }, [_c('div', {
    staticClass: "app-header-consent-container"
  }, [_c('div', {
    staticClass: "app-header-consent-content"
  }, [_vm._v("\n        You are currently emulating\n        "), (this.impersonate) ? [(this.impersonate.role) ? [_vm._v("\n            " + _vm._s(this.impersonate.role) + " user\n          ")] : _vm._e(), _vm._v(" "), (this.impersonate.firstName) ? [_vm._v("\n            " + _vm._s(this.impersonate.firstName) + "\n          ")] : _vm._e(), _vm._v(" "), (this.impersonate.lastName) ? [_vm._v("\n            " + _vm._s(this.impersonate.lastName) + "\n          ")] : _vm._e()] : _vm._e(), _vm._v("\n         - " + _vm._s(_vm.getImpersonatingUser) + ".\n        Please remember that all your actions will be reflected in the impersonated user account.\n      ")], 2), _vm._v(" "), _c('div', {
    staticClass: "app-header-consent-control"
  }, [_c('button', {
    staticClass: "background-1-50 color-2-100",
    staticStyle: {
      "width": "auto",
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeImpersonate()
      }
    }
  }, [_vm._v("Revert to your account")])])])]) : _vm._e(), _vm._v(" "), (!this.paid && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta' || _vm.getUserRole === 'la') && _vm.accountExpiring && _vm.accountExpiring <= 30 && !_vm.hasActiveSubscription) ? [_c('div', {
    staticClass: "company-warning-message",
    class: [{
      error: _vm.accountExpiring < 0
    }]
  }, [_c('div', {
    staticClass: "company-warning-message--container"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--text"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-triangle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "triangle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"
    }
  })]), _vm._v(" "), (_vm.accountExpiring < 0) ? [_vm._v("\n            Your subscription expired on " + _vm._s(_vm.accountExpiringDate) + ". Please renew it now to avoid losing access to your Clear Assured account.\n            "), (_vm.profile && _vm.profile.company && _vm.profile.company.activation_step === 5) ? [_c('router-link', {
    attrs: {
      "to": {
        name: 'billing-profile'
      }
    }
  }, [_vm._v("Go to your billing profile")]), _vm._v(".\n            ")] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'renew-subscription'
      }
    }
  }, [_vm._v("Go to your billing profile")]), _vm._v(".\n            ")]] : [_vm._v("\n            Your subscription will expire on " + _vm._s(_vm.accountExpiringDate) + ". Please renew it quickly to avoid losing access to you Clear Assured account.\n            "), (_vm.profile && _vm.profile.company && _vm.profile.company.activation_step === 5) ? [_c('router-link', {
    attrs: {
      "to": {
        name: 'billing-profile'
      }
    }
  }, [_vm._v("Go to your billing profile")]), _vm._v(".\n            ")] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'renew-subscription'
      }
    }
  }, [_vm._v("Go to your billing profile")]), _vm._v(".\n            ")]]], 2), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--action"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.accountExpiring = null
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })]), _vm._v("\n            Ok, close this")])])])])] : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'ca' && _vm.accountExpiring && _vm.accountExpiring <= 0 && _vm.hasActiveSubscription) ? [_c('div', {
    staticClass: "company-warning-message error"
  }, [_c('div', {
    staticClass: "company-warning-message--container"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--text"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-triangle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "triangle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"
    }
  })]), _vm._v("\n          We are yet to receive your payment for the last invoice. Please confirm your payment to avoid losing access to your Clear Assured account. "), _c('router-link', {
    attrs: {
      "to": {
        name: 'billing-profile'
      }
    }
  }, [_vm._v("Go to your billing profile")]), _vm._v(".\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--action"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.accountExpiring = null
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })]), _vm._v("\n            Ok, close this")])])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-header-main"
  }, [_c('div', {
    staticClass: "admin-header"
  }, [_c('div', {
    staticClass: "app-header-main__container"
  }, [_c('router-link', {
    staticClass: "site-logo",
    class: this.customLogo ? 'industry-logo' : '',
    style: ({
      backgroundImage: this.customLogo ? 'url(' + _vm.getFullServerPath(this.customLogo) + ')' : ''
    }),
    attrs: {
      "to": {
        name: _vm.userDashboard
      },
      "title": "Clear Assured dashboard"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "skip-to-links",
    class: [{
      'active': _vm.accessibilityLinks
    }]
  }, [_c('div', {
    staticClass: "myContainer"
  }, [(_vm.hasSection('sticky-anchors')) ? _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "focus": function($event) {
        _vm.accessibilityLinks = true
      },
      "blur": function($event) {
        _vm.accessibilityLinks = false
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.skipTo('sticky-anchors')
      }
    }
  }, [_vm._v("Skip to content menu")]) : _vm._e(), _vm._v(" "), (_vm.hasSection('admin-gm-breadcrumbs')) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "focus": function($event) {
        _vm.accessibilityLinks = true
      },
      "blur": function($event) {
        _vm.accessibilityLinks = false
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.skipTo('admin-gm-breadcrumbs')
      }
    }
  }, [_vm._v("Skip to app menu")]) : _vm._e(), _vm._v(" "), (_vm.isPage(['user-app'])) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "focus": function($event) {
        _vm.accessibilityLinks = true
      },
      "blur": function($event) {
        _vm.accessibilityLinks = false
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.skipTo('chart-accessibility-table')
      }
    }
  }, [_vm._v("Skip to the company progress chart")]) : _vm._e()])]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "app-header-description"
  }, [_c('ul', {
    staticClass: "main-menu-header"
  }, [_c('li', {
    staticClass: "dashboard-icon",
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_c('router-link', {
    staticClass: "parent-item",
    attrs: {
      "to": {
        name: 'admin'
      }
    },
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
    staticClass: "tasks-icon",
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_c('router-link', {
    staticClass: "parent-item",
    attrs: {
      "to": {
        name: 'company-tasks',
        params: {
          companyId: 2
        }
      }
    },
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_vm._v("Tasks")])], 1), _vm._v(" "), _c('li', {
    staticClass: "notifications-icon has-children",
    class: [{
      'no-icon': this.unreadNotifications,
      'active': _vm.activeSection === 'notifications'
    }]
  }, [_c('button', {
    staticClass: "parent-item",
    attrs: {
      "aria-expanded": _vm.activeSection === 'notifications' ? 'true' : 'false',
      "aria-controls": "menuNotifications"
    },
    on: {
      "click": function($event) {
        _vm.activeSection === 'notifications' ? _vm.activeSection = '' : _vm.activeSection = 'notifications'
      }
    }
  }, [(this.unreadNotifications) ? _c('span', {
    staticClass: "unread-notifications"
  }, [_vm._v("\n                  " + _vm._s(this.unreadNotifications) + "\n                ")]) : _vm._e(), _vm._v("\n                Notifications\n              ")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header notifications",
    attrs: {
      "id": "menuNotifications"
    }
  }, [_c('li', {
    staticClass: "dropdown-info-header"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markNotificationsRead()
      }
    }
  }, [_vm._v("Mark all as read")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown-info-list"
  }, _vm._l((_vm.notifications), function(item) {
    return _c('ul', {
      staticClass: "dropdown-info-group"
    }, [_c('li', {
      staticClass: "dropdown-info-header"
    }, [_c('span', {
      staticClass: "meta-date"
    }, [_vm._v(_vm._s(_vm.getTodayDate(item.date)))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('li', {
        staticClass: "notification-item",
        class: [{
          'unread': !child.isRead
        }],
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.readNotification(child)
          }
        }
      }, [(child.type === 1) ? [(child.contentId && child.companyId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 2 || child.type === 3) ? [(child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'edit-user',
            params: {
              id: child.userFromId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e(), _vm._v(" "), (!child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'consent-logs'
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 4) ? [(child.contentId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'content',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 5) ? [(_vm.getUserRole === 'gm') ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _c('router-link', {
        attrs: {
          "to": {
            name: 'task',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))])] : [_vm._v("\n                        " + _vm._s(child.message) + "\n                      ")]], 2)
    })], 2)
  }), 0), _vm._v(" "), _c('li', {
    staticClass: "see-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'notifications'
      }
    }
  }, [_vm._v("See all notifications")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "content-icon has-children",
    class: {
      'active': _vm.activeSection === 'content'
    }
  }, [_c('button', {
    staticClass: "parent-item",
    attrs: {
      "aria-expanded": _vm.activeSection === 'content' ? 'true' : 'false',
      "aria-controls": "menuContent"
    },
    on: {
      "click": function($event) {
        _vm.activeSection === 'content' ? _vm.activeSection = '' : _vm.activeSection = 'content'
      }
    }
  }, [_vm._v("Content")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header",
    attrs: {
      "id": "menuContent"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'todo-list'
      }
    }
  }, [_vm._v("Tasks")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'chapters'
      }
    }
  }, [_vm._v("Task categories")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'articles-list'
      }
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'categories'
      }
    }
  }, [_vm._v("Resource categories")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tags'
      }
    }
  }, [_vm._v("Topics")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'industries'
      }
    }
  }, [_vm._v("Industries")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit-pages-list'
      }
    }
  }, [_vm._v("Landing pages")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'default-email-templates'
      }
    }
  }, [_vm._v("Email templates")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard-promotions'
      }
    }
  }, [_vm._v("Dashboard promotions")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'redirects'
      }
    }
  }, [_vm._v("Redirects")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "users-icon has-children",
    class: {
      'active': _vm.activeSection === 'users'
    }
  }, [_c('button', {
    staticClass: "parent-item",
    attrs: {
      "aria-expanded": _vm.activeSection === 'users' ? 'true' : 'false',
      "aria-controls": "menuUsers"
    },
    on: {
      "click": function($event) {
        _vm.activeSection === 'users' ? _vm.activeSection = '' : _vm.activeSection = 'users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header",
    attrs: {
      "id": "menuUsers"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "logs-icon",
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_c('router-link', {
    staticClass: "parent-item",
    attrs: {
      "to": {
        name: 'logs'
      }
    },
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_vm._v("Logs")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.getUserRole !== 'gm') ? _c('div', {
    staticClass: "front-header-tagline",
    attrs: {
      "aria-label": 'In association with: ' + _vm.industriesAlts
    }
  }, [_c('div', {
    staticClass: "front-header-tagline_text background-1-100",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(this.customLogo) ? [_vm._v("Powered by")] : [_vm._v("In association with")]], 2), _vm._v(" "), _c('div', {
    staticClass: "industry-logos",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(this.customLogo) ? [_c('router-link', {
    staticClass: "front-header-logo",
    attrs: {
      "to": "/",
      "title": "The Clear Company logo"
    }
  }, [_c('img', {
    staticClass: "clearLogo",
    attrs: {
      "src": __webpack_require__(109),
      "alt": "The Clear Company logo"
    }
  })])] : [_vm._l((_vm.sponsors), function(row, index) {
    return [(row.url) ? [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": row.url,
        "aria-label": row.altImage,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "sponsorLogo",
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": " "
      }
    })]) : _vm._e()] : [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": "#",
        "aria-label": row.altImage
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      staticClass: "sponsorLogo",
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": " "
      }
    })]) : _vm._e()]]
  })]], 2)]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "app-header-info background-1-20"
  }, [_c('div', {
    staticClass: "admin-header"
  }, [_c('div', {
    staticClass: "app-header-info__container"
  }, [_c('div', {
    staticClass: "app-header-menus"
  }, [_c('button', {
    staticClass: "mobile-menu-trigger background-1-100-after",
    class: [{
      'active': this.mobileMenuShown
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openSubmenu($event, 'mobileMenu')
      }
    }
  }, [_c('div', {
    staticClass: "mobile-menu-trigger__icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bars fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "bars",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Menu")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu-trigger__arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "app-header-login main-menu-regular",
    class: [{
      'mobile-active': this.mobileMenuShown
    }]
  }, [(_vm.isRegularUser) ? _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('span', {
    staticClass: "menu-icon dashboard",
    class: [{
      'color-1-80': !_vm.activePage('/dashboard'),
      'background-1-100': _vm.activePage('/dashboard')
    }]
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-home fa-w-18",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "home",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    }
  })])]), _vm._v("\n                Dashboard\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": {
        name: 'knowledge-base'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon knowledge-base",
    class: [{
      'color-1-80': !_vm.activePage('/knowledge-base'),
      'background-1-100': _vm.activePage('/knowledge-base')
    }]
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-book fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "book",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    }
  })])]), _vm._v("\n                Inclusion hub\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser) ? _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": {
        name: 'tasks'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon tasks",
    class: [{
      'color-1-80': !_vm.activePage('/tasks'),
      'background-1-100': _vm.activePage('/tasks')
    }]
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-stream fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "stream",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    }
  })])]), _vm._v("\n                Tasks\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', {
    staticClass: "notifications-icon has-children",
    class: [{
      'no-icon': this.unreadNotifications,
      'active border-1-70': _vm.activeSection === 'notifications'
    }]
  }, [_c('button', {
    staticClass: "parent-item menu-link background-1-70-after",
    attrs: {
      "aria-expanded": _vm.activeSection === 'notifications' ? 'true' : 'false',
      "aria-controls": "menuNotifications"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activeSection === 'notifications' ? _vm.activeSection = '' : _vm.activeSection = 'notifications'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon notifications"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bell fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "bell",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    }
  })])]), _vm._v(" "), (this.unreadNotifications) ? _c('span', {
    staticClass: "unread-notifications"
  }, [_vm._v("\n                  " + _vm._s(this.unreadNotifications) + "\n                ")]) : _vm._e(), _vm._v("\n                Notifications\n              ")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header notifications border-1-70",
    class: [{
      'active': _vm.activeSection === 'notifications'
    }],
    attrs: {
      "id": "menuNotifications"
    }
  }, [(_vm.notifications && _vm.notifications.length) ? _c('li', {
    staticClass: "dropdown-info-header",
    class: {
      'no-notifications': !_vm.unreadNotifications
    }
  }, [(_vm.unreadNotifications) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markNotificationsRead()
      }
    }
  }, [_vm._v("\n                    Mark all as read\n                  ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.notifications && _vm.notifications.length) ? _c('li', {
    staticClass: "dropdown-info-list"
  }, _vm._l((_vm.notifications), function(item) {
    return _c('ul', {
      staticClass: "dropdown-info-group"
    }, [_c('li', {
      staticClass: "dropdown-info-header"
    }, [_c('span', {
      staticClass: "meta-date"
    }, [_vm._v(_vm._s(_vm.getTodayDate(item.date)))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('li', {
        staticClass: "notification-item",
        class: [{
          'unread': !child.isRead
        }],
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.readNotification(child)
          }
        }
      }, [(child.type === 1) ? [(child.contentId && child.companyId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 2 || child.type === 3) ? [(child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'edit-user',
            params: {
              id: child.userFromId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e(), _vm._v(" "), (!child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'consent-logs'
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 4) ? [(child.contentId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'content',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 5) ? [(_vm.getUserRole === 'gm') ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _c('router-link', {
        attrs: {
          "to": {
            name: 'task',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))])] : [_vm._v("\n                        " + _vm._s(child.message) + "\n                      ")]], 2)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.notifications && _vm.notifications.length) ? _c('li', {
    staticClass: "see-all border-1-70"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard-notifications'
      }
    }
  }, [_vm._v("See all notifications")])], 1) : _vm._e(), _vm._v(" "), (!_vm.notifications || !_vm.notifications.length) ? _c('li', {
    staticClass: "dropdown-info-list-empty"
  }, [_vm._v("\n                  There are no notifications.\n                ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', {
    staticClass: "notifications-icon notifications-icon-mobile"
  }, [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": {
        name: 'dashboard-notifications'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon notifications"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bell fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "bell",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    }
  })])]), _vm._v(" "), (this.unreadNotifications) ? _c('span', {
    staticClass: "unread-notifications"
  }, [_vm._v("\n                  " + _vm._s(this.unreadNotifications) + "\n                ")]) : _vm._e(), _vm._v("\n                Notifications\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', {
    staticClass: "has-dropdown",
    class: [{
      'opened border-1-70': _vm.menuShown === 'myCompany',
      'background-1-10': _vm.mobileMenuShown && _vm.menuShown === 'myCompany' && !_vm.getDeviceType('desktop')
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('a', {
    staticClass: "color-2-100 background-1-70-after",
    attrs: {
      "href": "#",
      "title": "Open menu"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSubmenu($event, 'myCompany')
      }
    }
  }, [_c('span', {
    staticClass: "app-header-login-icon-before sf-color-1-60"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-briefcase fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "briefcase",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("My organisation")]), _vm._v(" "), _c('span', {
    staticClass: "app-header-login-icon-after sf-color-1-60"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "app-header-login__dropdown border-1-70"
  }, [(_vm.isRegularUser) ? _c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'company-profile'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "16",
      "viewBox": "0 0 14 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M13.5,14.5a.442.442,0,0,1,.5.5v.5a.442.442,0,0,1-.5.5H8V12.5a.442.442,0,0,0-.5-.5h-1a.442.442,0,0,0-.5.5V16H.5a.442.442,0,0,1-.5-.5V15a.442.442,0,0,1,.5-.5H1V.75A.723.723,0,0,1,1.219.219.723.723,0,0,1,1.75,0h10.5a.723.723,0,0,1,.531.219A.723.723,0,0,1,13,.75V14.5ZM6,9.5v-1A.442.442,0,0,0,5.5,8h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,6,9.5Zm0-3v-1A.442.442,0,0,0,5.5,5h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,6,6.5Zm0-3v-1A.442.442,0,0,0,5.5,2h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,6,3.5Zm4,6v-1A.442.442,0,0,0,9.5,8h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,10,9.5Zm0-3v-1A.442.442,0,0,0,9.5,5h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,10,6.5Zm0-3v-1A.442.442,0,0,0,9.5,2h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,10,3.5Z"
    }
  })])]), _vm._v("\n                    Organisation profile\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'account-settings'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user-cog fa-w-20",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user-cog",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 640 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
    }
  })])]), _vm._v("\n                    Account settings\n                  ")])], 1), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta' || _vm.getUserRole === 'la') ? _c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'billing-profile'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "12",
      "height": "16.031",
      "viewBox": "0 0 12 16.031"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12.188.094a.473.473,0,0,1,.531-.047A.473.473,0,0,1,13,.5v15a.509.509,0,0,1-.812.406L11,14.5,9.313,15.906a.5.5,0,0,1-.625,0L7,14.5,5.313,15.906a.5.5,0,0,1-.625,0L3,14.5,1.813,15.906a.473.473,0,0,1-.531.047A.473.473,0,0,1,1,15.5V.5A.473.473,0,0,1,1.281.047a.473.473,0,0,1,.531.047L3,1.5,4.688.094a.5.5,0,0,1,.625,0L7,1.5,8.688.094a.5.5,0,0,1,.625,0L11,1.5ZM10.5,11.5A.442.442,0,0,0,11,11a.442.442,0,0,0-.5-.5h-7A.442.442,0,0,0,3,11a.442.442,0,0,0,.5.5Zm0-3A.442.442,0,0,0,11,8a.442.442,0,0,0-.5-.5h-7A.442.442,0,0,0,3,8a.442.442,0,0,0,.5.5Zm0-3A.442.442,0,0,0,11,5a.442.442,0,0,0-.5-.5h-7A.442.442,0,0,0,3,5a.442.442,0,0,0,.5.5Z",
      "transform": "translate(-1 0.016)"
    }
  })])]), _vm._v("\n                    Billing profile\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta' || _vm.getUserRole === 'la') ? _c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'ca-users'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "16",
      "viewBox": "0 0 20 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12.3-4.953A3.131,3.131,0,0,1,10-4a3.131,3.131,0,0,1-2.3-.953,3.131,3.131,0,0,1-.953-2.3,3.131,3.131,0,0,1,.953-2.3A3.131,3.131,0,0,1,10-10.5a3.131,3.131,0,0,1,2.3.953,3.131,3.131,0,0,1,.953,2.3A3.131,3.131,0,0,1,12.3-4.953ZM11.563-3a4.436,4.436,0,0,1,3.125,1.219A3.866,3.866,0,0,1,16,1.156a.788.788,0,0,1-.266.594.864.864,0,0,1-.609.25H4.875a.864.864,0,0,1-.609-.25A.788.788,0,0,1,4,1.156,3.866,3.866,0,0,1,5.313-1.781,4.436,4.436,0,0,1,8.438-3Zm6.2-6.734A2.407,2.407,0,0,1,16-9a2.407,2.407,0,0,1-1.766-.734A2.407,2.407,0,0,1,13.5-11.5a2.407,2.407,0,0,1,.734-1.766A2.407,2.407,0,0,1,16-14a2.407,2.407,0,0,1,1.766.734A2.407,2.407,0,0,1,18.5-11.5,2.407,2.407,0,0,1,17.766-9.734ZM5.75-7.25A4.224,4.224,0,0,0,6.781-4.5H.563a.524.524,0,0,1-.406-.172A.6.6,0,0,1,0-5.094,2.907,2.907,0,0,1,.8-7.141,2.561,2.561,0,0,1,2.75-8H4.688a2.75,2.75,0,0,1,1.125.25A2.689,2.689,0,0,0,5.75-7.25Zm.016-2.484A2.407,2.407,0,0,1,4-9a2.407,2.407,0,0,1-1.766-.734A2.407,2.407,0,0,1,1.5-11.5a2.407,2.407,0,0,1,.734-1.766A2.407,2.407,0,0,1,4-14a2.407,2.407,0,0,1,1.766.734A2.407,2.407,0,0,1,6.5-11.5,2.407,2.407,0,0,1,5.766-9.734ZM17.25-8a2.561,2.561,0,0,1,1.953.859A2.907,2.907,0,0,1,20-5.094a.6.6,0,0,1-.156.422.524.524,0,0,1-.406.172H13.219A4.224,4.224,0,0,0,14.25-7.25a3.835,3.835,0,0,0-.062-.5A2.75,2.75,0,0,1,15.313-8Z",
      "transform": "translate(0 14)"
    }
  })])]), _vm._v("\n                    Users\n                  ")]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "app-header-right-menus"
  }, [_c('ul', {
    staticClass: "app-header-login"
  }, [_c('li', {
    staticClass: "has-dropdown",
    class: [{
      'opened border-1-70': _vm.menuShown === 'login',
      'background-1-10': _vm.mobileMenuShown && _vm.menuShown === 'login' && !_vm.getDeviceType('desktop')
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('a', {
    staticClass: "color-2-100 background-1-70-after",
    attrs: {
      "href": "#",
      "title": "Open menu"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSubmenu($event, 'login')
      }
    }
  }, [_c('span', {
    staticClass: "app-header-login-icon-before sf-color-1-60"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 11.096 14.417"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 11.096 14.417",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_497_",
      "cx": "5.548",
      "cy": "3.75",
      "r": "3.75"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_496_",
      "d": "M1.002,14.417c-0.619,0-1.087-0.558-0.989-1.17c0.442-2.766,2.492-4.455,5.535-4.455\n                      s5.093,1.69,5.535,4.455c0.098,0.611-0.37,1.17-0.989,1.17H1.002z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("My Account")]), _vm._v(" "), _c('span', {
    staticClass: "app-header-login-icon-after sf-color-1-60"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), (_vm.getIsLoggedIn) ? [_c('ul', {
    staticClass: "app-header-login__dropdown border-1-70",
    staticStyle: {
      "left": "unset",
      "right": "0"
    }
  }, [_c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 496 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    }
  })])]), _vm._v("\n                        My profile\n                      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'email-preferences'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-envelope fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "envelope",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    }
  })])]), _vm._v("\n                        My email preferences\n                      ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authLogout($event)
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-sign-out-alt fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "sign-out-alt",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    }
  })])]), _vm._v("\n                        Logout\n                      ")])])])] : [_c('router-link', {
    staticClass: "app-header-login__item color-2-100",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Login")])]], 2)])])])])])]), _vm._v(" "), (!_vm.hideFeedbackButton) ? _c('button', {
    staticClass: "feedback-button",
    attrs: {
      "aria-label": "Send us your Feedback"
    },
    on: {
      "click": function($event) {
        return _vm.activateFeedback()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Send us your Feedback")])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-title"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "companies active",
    attrs: {
      "to": {
        name: 'default-email-templates'
      }
    }
  }, [_vm._v("Email templates")])], 1), _vm._v(" "), _c('div', {
    staticClass: "industry-emails"
  }, [_c('div', {
    staticClass: "industry-emails-container"
  }, [_c('div', {
    staticClass: "industry-emails-menu"
  }, [(_vm.emailTemplates) ? _c('div', [_c('div', {
    staticClass: "section-head"
  }, [_vm._v("\n            Email templates\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_vm._l((_vm.emailTemplates), function(item) {
    return _c('router-link', {
      key: item.value,
      staticClass: "section-item",
      class: {
        'active': _vm.template === item.value
      },
      attrs: {
        "to": {
          name: 'default-email-templates',
          query: {
            template: item.value
          }
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "industry-emails-content"
  }, [_c('div', {
    ref: "templateDetails",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTemplate === false) ? [_vm._v(_vm._s(_vm.templateLabel) + " email")] : [_vm._v("Edit \"" + _vm._s(_vm.templateLabel) + "\" email")]], 2), _vm._v(" "), _c('div', {
    staticClass: "content-section-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.emailTemplate.description))]), _vm._v(" "), _c('p', {
    staticClass: "variables-list"
  }, [_vm._v("\n                It supports the following variables:\n              ")]), _vm._v(" "), _c('dl', [_vm._l((_vm.emailTemplate.variables), function(variable, index) {
    return [_c('dt', [_c('code', [_vm._v("[" + _vm._s(variable) + "]")])]), _vm._v(" "), (index !== Object.keys(_vm.emailTemplate.variables).length - 1) ? _c('dt', {
      staticClass: "code-separator"
    }) : _vm._e()]
  })], 2)]), _vm._v(" "), (_vm.canEditTemplate === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditTemplate()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "templatePreview",
    staticClass: "content-section content-section__bordered border-1-20",
    class: {
      'content-section__no_padding': _vm.canEditTemplate === false
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditTemplate === false),
      expression: "canEditTemplate === false"
    }]
  }, [_c('div', {
    attrs: {
      "id": "emailBody"
    }
  })]), _vm._v(" "), (_vm.canEditTemplate === true) ? _c('article', {
    staticClass: "personal-info"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-subject"
    }
  }, [_vm._v("Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTemplate.email.subject),
      expression: "emailTemplate.email.subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Subject')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTemplate === false,
      "data-lpignore": "true",
      "id": "template-subject",
      "name": "Subject"
    },
    domProps: {
      "value": (_vm.emailTemplate.email.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailTemplate.email, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Subject')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Subject')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTemplate.email.title),
      expression: "emailTemplate.email.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTemplate === false,
      "data-lpignore": "true",
      "id": "template-title",
      "name": "Title"
    },
    domProps: {
      "value": (_vm.emailTemplate.email.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailTemplate.email, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Title')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-body"
    }
  }, [_vm._v("Email body")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "article-editor",
    attrs: {
      "id": "template-body",
      "editorToolbar": _vm.editorToolbar,
      "name": "body"
    },
    model: {
      value: (_vm.emailTemplate.email.body),
      callback: function($$v) {
        _vm.$set(_vm.emailTemplate.email, "body", $$v)
      },
      expression: "emailTemplate.email.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTemplate) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTemplate()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateEmailTemplate()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "testTemplate",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n              Send test email\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "email-address"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testEmail.email),
      expression: "testEmail.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email address')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "email-address",
      "name": "Email address"
    },
    domProps: {
      "value": (_vm.testEmail.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testEmail, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Email address')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendTestEmail()
      }
    }
  }, [_vm._v("Send")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [_vm._v("\n      Default email templates\n    ")])])
}]}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tcc-plan__wrapper"
  }, [_c('div', {
    staticClass: "tcc-plan__wrapper--contents"
  }, [_c('div', {
    staticClass: "tcc-plan__wrapper--title",
    domProps: {
      "innerHTML": _vm._s(_vm.heading)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tcc-plan__wrapper--subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tcc-plan__wrapper--container"
  }, [(_vm.plans && _vm.plans.length) ? [_c('tabs', {
    on: {
      "tab-selected": function($event) {
        return _vm.tabSelected($event)
      }
    }
  }, _vm._l((_vm.plans), function(plan, index) {
    return (plan.variations && plan.variations.length) ? _c('tab', {
      key: index,
      attrs: {
        "hash": false,
        "name": plan.name,
        "selected": _vm.planSelected(plan),
        "alias": plan.name
      }
    }, [_c('div', {
      staticClass: "tcc-plan__box"
    }, [_c('div', {
      staticClass: "tcc-plan__box--details"
    }, [(_vm.planTemporaryPrice(plan)) ? _c('p', {
      staticClass: "tcc-plan__box--details__starting-at"
    }, [_vm._v("Starting at")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__price"
    }, [(_vm.planPrice(plan)) ? [_c('span', [_vm._v("£")]), _vm._v(_vm._s(_vm.planPrice(plan))), (_vm.vatDisplay) ? _c('sup', [_vm._v(" + VAT")]) : _vm._e(), _vm._v(" / month\n                    "), _c('div', {
      staticClass: "tcc-plan__box--details__price--payment-period",
      domProps: {
        "innerHTML": _vm._s(_vm.planPaymentPeriod(plan))
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__options"
    }, [(!_vm.preSelectedSize) ? _c('div', {
      staticClass: "tcc-plan__box--details__option",
      class: [{
        'active': _vm.sizeSelectorActive
      }]
    }, [_c('label', {
      staticClass: "tcc-plan__box--details__option--label dynamic-option",
      attrs: {
        "for": "sizeOptions"
      }
    }, [_vm._v("Select organisation size")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option--value"
    }, [_c('app-select', {
      staticClass: "tcc-plan__box--details__option--selector",
      attrs: {
        "customType": "planSelector",
        "searchable": false,
        "customActive": false,
        "clearable": false,
        "placeholder": 'Confirm number of employees',
        "options": plan.sizeOptions || [],
        "value": plan.selectedPlanSize,
        "data-vv-name": "Size",
        "data-lpignore": "true",
        "name": "sizeOptions",
        "id": "sizeOptions"
      },
      on: {
        "change": function($event) {
          return _vm.planSizeChanged($event, plan)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option",
      class: [{
        'active': _vm.billingSelectorActive,
        'disabled': !plan.selectedPlanSize
      }]
    }, [_c('label', {
      staticClass: "tcc-plan__box--details__option--label dynamic-option",
      attrs: {
        "for": "billingOptions"
      }
    }, [_vm._v("Select billing cycle")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option--value"
    }, [_c('app-select', {
      staticClass: "tcc-plan__box--details__option--selector",
      attrs: {
        "customType": "planSelector",
        "searchable": false,
        "customActive": false,
        "clearable": false,
        "placeholder": !plan.selectedPlanSize ? 'Select organisation size first' : 'Choose an option',
        "disabled": !plan.selectedPlanSize,
        "options": plan.billingOptions || [],
        "value": plan.selectedPlanBilling,
        "data-vv-name": "Billing",
        "data-lpignore": "true",
        "name": "billingOptions",
        "id": "billingOptions"
      },
      on: {
        "search:focus": function($event) {
          return _vm.searchFocus(plan, 'billing')
        },
        "search:blur": function($event) {
          return _vm.searchBlur(plan, 'billing')
        },
        "change": function($event) {
          return _vm.planBillingChanged($event, plan)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option",
      class: [{
        'active': _vm.commitmentSelectorActive,
        'disabled': !plan.selectedPlanSize
      }]
    }, [_c('label', {
      staticClass: "tcc-plan__box--details__option--label dynamic-option",
      attrs: {
        "for": "commitmentOptions"
      }
    }, [_vm._v("Select commitment period")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option--value"
    }, [_c('app-select', {
      staticClass: "tcc-plan__box--details__option--selector",
      attrs: {
        "customType": "planSelector",
        "searchable": false,
        "customActive": false,
        "clearable": false,
        "placeholder": !plan.selectedPlanSize ? 'Select organisation size first' : 'Choose an option',
        "disabled": !plan.selectedPlanSize,
        "options": plan.commitmentOptions || [],
        "value": plan.selectedPlanCommitment,
        "data-vv-name": "Commitment",
        "data-lpignore": "true",
        "name": "commitmentOptions",
        "id": "commitmentOptions"
      },
      on: {
        "search:focus": function($event) {
          return _vm.searchFocus(plan, 'commitment')
        },
        "search:blur": function($event) {
          return _vm.searchBlur(plan, 'commitment')
        },
        "change": function($event) {
          return _vm.planCommitmentChanged($event, plan)
        }
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__actions hide-on-mobile"
    }, [_c('button', {
      class: [{
        submitting: _vm.submitting
      }],
      on: {
        "click": function($event) {
          return _vm.selectPlan()
        }
      }
    }, [_c('span', [_c('svg', {
      staticClass: "svg-inline--fa fa-check fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
      }
    })])]), _vm._v("\n                    Choose this plan\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features",
      class: [{
        'voucher-shown': _vm.voucherAreaActive
      }]
    }, [_c('div', {
      staticClass: "tcc-plan__box--features__voucher",
      class: [{
        'active': _vm.voucherAreaActive,
        'transition-in': _vm.voucherAreaTransitioning
      }],
      attrs: {
        "id": 'voucherContainer-' + index,
        "aria-expanded": (_vm.voucherAreaActive || _vm.voucherAreaTransitioning) || 'false'
      }
    }, [_c('button', {
      staticClass: "tcc-plan__box--features__voucher--trigger",
      class: [{
        'activate': !_vm.voucherAreaActive && !_vm.voucherAreaTransitioning,
        'deactivate': _vm.voucherAreaActive || _vm.voucherAreaTransitioning
      }],
      attrs: {
        "aria-label": !_vm.voucherAreaActive && !_vm.voucherAreaTransitioning ? 'Use a voucher' : 'Close voucher area',
        "aria-expanded": (_vm.voucherAreaActive || _vm.voucherAreaTransitioning) || 'false',
        "aria-controls": 'voucherContainer-' + index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateVoucherArea()
        }
      }
    }, [(!_vm.voucherAreaActive && !_vm.voucherAreaTransitioning) ? [(_vm.voucher) ? [_vm._v("\n                        Voucher applied: " + _vm._s(_vm.voucher) + "\n                        "), _c('svg', {
      staticClass: "svg-inline--fa fa-pen",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "pen",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M497.9 74.16L437.8 14.06c-18.75-18.75-49.19-18.75-67.93 0l-56.53 56.55l127.1 128l56.56-56.55C516.7 123.3 516.7 92.91 497.9 74.16zM290.8 93.23l-259.7 259.7c-2.234 2.234-3.755 5.078-4.376 8.176l-26.34 131.7C-1.921 504 7.95 513.9 19.15 511.7l131.7-26.34c3.098-.6191 5.941-2.141 8.175-4.373l259.7-259.7L290.8 93.23z"
      }
    })])] : [_vm._v("\n                        Use a voucher\n                        "), _c('svg', {
      staticClass: "svg-inline--fa fa-circle-question",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "circle-question",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 336c-18 0-32 14-32 32s13.1 32 32 32c17.1 0 32-14 32-32S273.1 336 256 336zM289.1 128h-51.1C199 128 168 159 168 198c0 13 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 159 329 128 289.1 128z"
      }
    })])]] : [_c('svg', {
      staticClass: "svg-inline--fa fa-xmark",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "xmark",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 320 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
      }
    })])]], 2), _vm._v(" "), (_vm.voucherAreaActive) ? _c('form', {
      staticClass: "tcc-plan__box--features__voucher--form",
      attrs: {
        "aria-label": 'voucher-' + index
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.submitVoucher()
        }
      }
    }, [(!_vm.hideVoucherSubmitForm) ? [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--title",
      attrs: {
        "id": 'voucher-' + index
      }
    }, [_vm._v("Do you have a voucher? Enter the code below.")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__group",
      class: [{
        'not-empty': !!_vm.voucher
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.voucher),
        expression: "voucher"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Type in here...",
        "name": "voucher"
      },
      domProps: {
        "value": (_vm.voucher)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.voucher = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit voucher")])])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status",
      class: [{
        'saved-voucher': _vm.hideVoucherSubmitForm
      }]
    }, [(_vm.voucherSubmitted) ? [(_vm.invalidVoucher) ? [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--title"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-circle-xmark",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "circle-xmark",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
      }
    })]), _vm._v("\n                            The code you entered is invalid.\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--text"
    }, [_vm._v("\n                            Please try again. If it still doesn't work, please get in touch with the code provider and check if it's correct.\n                          ")])] : [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--title"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-circle-check",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "circle-check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
      }
    })]), _vm._v("\n                            The code you entered '" + _vm._s(_vm.voucher) + "' was successfully applied.\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--text"
    })]] : (_vm.hideVoucherSubmitForm) ? [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--saved__title"
    }, [_vm._v("\n                          You have applied a voucher code '" + _vm._s(_vm.voucher) + "'.\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--saved__actions"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.submitAnotherVoucher()
        }
      }
    }, [_vm._v("Submit another voucher code")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteVoucher()
        }
      }
    }, [_vm._v("Delete voucher code")])])] : _vm._e()], 2)], 2) : _vm._e()]), _vm._v(" "), _c('h3', {
      staticClass: "tcc-plan__box--features__title"
    }, [_vm._v("Plans features at a glance")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__list",
      domProps: {
        "innerHTML": _vm._s(_vm.planDescription(plan))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__actions hide-on-desktop"
    }, [_c('button', {
      class: [{
        submitting: _vm.submitting
      }],
      on: {
        "click": function($event) {
          return _vm.selectPlan()
        }
      }
    }, [_c('span', [_c('svg', {
      staticClass: "svg-inline--fa fa-check fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
      }
    })])]), _vm._v("\n                  Choose this plan\n                ")])])])]) : _vm._e()
  }), 1)] : [_vm._m(0)]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
}]}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activate-company account-suspended"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "activate-company__hero"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-do-not-enter",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "do-not-enter",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM415.9 304H96.05C87.21 304 79.95 296.9 79.95 288V224c0-8.875 7.266-16 16.11-16h319.9c8.84 0 16.11 7.125 16.11 16v64C432.1 296.9 424.8 304 415.9 304z"
    }
  })]), _vm._v("\n          Your account is suspended.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          We can't take you to your dashboard because your organisation subscription expired on " + _vm._s(_vm.expiryDate) + ". To resume your work with ClearAssured, please renew your subscription or get in touch with your designated billing contact:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data"
  }, [_c('div', [_c('div', {
    staticClass: "activate-company__billing-data--label"
  }, [_vm._v("Billing contact:")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data--value"
  }, [_vm._v(_vm._s(_vm.billingContact))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "activate-company__billing-data--label"
  }, [_vm._v("Billing email:")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data--value"
  }, [_vm._v(_vm._s(_vm.billingEmail))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "activate-company__billing-data--label"
  }, [_vm._v("Billing phone:")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data--value"
  }, [_vm._v(_vm._s(_vm.billingPhone))])])]), _vm._v(" "), (_vm.canRenew) ? _c('router-link', {
    staticClass: "activate-company__billing-renew",
    attrs: {
      "to": {
        name: 'billing-profile'
      }
    }
  }, [_vm._v("\n          Renew subscription\n        ")]) : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */
/***/ (function(module, exports) {

module.exports = ["just now",["%s second ago","%s seconds ago"],["%s minute ago","%s minutes ago"],["%s hour ago","%s hours ago"],["%s day ago","%s days ago"],["%s week ago","%s weeks ago"],["%s month ago","%s months ago"],["%s year ago","%s years ago"]]

/***/ }),
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165);
__webpack_require__(166);
module.exports = __webpack_require__(239);


/***/ })
],[1077]);


// WEBPACK FOOTER //
// static/js/app.df575d8f193e8c78ad99.js